/**
 * This file is auto-generated by codegen.ts.
 * DO NOT EDIT IT MANUALLY!
 */

/* eslint-disable */

import { useQuery, UseQueryOptions, useMutation, UseMutationOptions } from 'react-query';
import { fetcher } from '../utils/fetcher';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  Void: void;
  bigint: string;
  json: any;
  jsonb: any;
  name: string;
  numeric: string;
  smallint: number;
  timestamptz: string;
  uuid: string;
};

export type ActiveCampaignDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ActiveCampaignDescribeObjectResult = ActiveCampaignDescribeObjectSuccess;

export type ActiveCampaignDescribeObjectSuccess = {
  __typename?: 'ActiveCampaignDescribeObjectSuccess';
  fields: Array<ActiveCampaignField>;
};

export type ActiveCampaignField = {
  __typename?: 'ActiveCampaignField';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AirtableGetBasesInput = {
  destinationId: Scalars['String'];
};

export type AirtableGetBasesResult = AirtableGetBasesSuccess;

export type AirtableGetBasesSuccess = {
  __typename?: 'AirtableGetBasesSuccess';
  bases: Array<Base>;
};

export type AirtableGetTablesMetaInput = {
  baseId: Scalars['String'];
  destinationId: Scalars['String'];
};

export type AirtableGetTablesMetaResult = AirtableGetTablesMetaSuccess;

export type AirtableGetTablesMetaSuccess = {
  __typename?: 'AirtableGetTablesMetaSuccess';
  tables: Array<Table>;
};

export type AsanaCustomField = {
  __typename?: 'AsanaCustomField';
  dataType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AsanaListCustomFieldsInput = {
  destinationId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type AsanaListCustomFieldsResult = AsanaListCustomFieldsSuccess;

export type AsanaListCustomFieldsSuccess = {
  __typename?: 'AsanaListCustomFieldsSuccess';
  fields: Array<AsanaCustomField>;
};

export type AsanaListTeamsInput = {
  destinationId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type AsanaListTeamsResult = AsanaListTeamsSuccess;

export type AsanaListTeamsSuccess = {
  __typename?: 'AsanaListTeamsSuccess';
  teams: Array<AsanaTeam>;
};

export type AsanaListWorkspacesInput = {
  destinationId: Scalars['String'];
};

export type AsanaListWorkspacesResult = AsanaListWorkspacesSuccess;

export type AsanaListWorkspacesSuccess = {
  __typename?: 'AsanaListWorkspacesSuccess';
  workspaces: Array<AsanaWorkspaces>;
};

export type AsanaTeam = {
  __typename?: 'AsanaTeam';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AsanaWorkspaces = {
  __typename?: 'AsanaWorkspaces';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AthenaCredentials = {
  accessKeyId?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['Int']>;
};

export type AthenaDataCatalog = {
  __typename?: 'AthenaDataCatalog';
  name: Scalars['String'];
};

export type AthenaDatabase = {
  __typename?: 'AthenaDatabase';
  name: Scalars['String'];
};

export type AthenaListDataCatalogsResult = {
  __typename?: 'AthenaListDataCatalogsResult';
  dataCatalogs: Array<AthenaDataCatalog>;
};

export type AthenaListDatabasesResult = {
  __typename?: 'AthenaListDatabasesResult';
  databases: Array<AthenaDatabase>;
};

export type AthenaListWorkGroupsResult = {
  __typename?: 'AthenaListWorkGroupsResult';
  workGroups: Array<AthenaWorkGroup>;
};

export type AthenaWorkGroup = {
  __typename?: 'AthenaWorkGroup';
  name: Scalars['String'];
};

export type AttemptedRow = {
  __typename?: 'AttemptedRow';
  batchId: Maybe<Scalars['String']>;
  batchRequestInfoKey: Maybe<Scalars['String']>;
  error: Maybe<Scalars['JSONObject']>;
  fields: Scalars['String'];
  id: Scalars['String'];
  isBatchError: Maybe<Scalars['Boolean']>;
  opType: SyncOp;
  rejected: Scalars['Boolean'];
  rejectionReason: Maybe<Scalars['String']>;
  requestInfoKeys: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AttemptedRowsPaginationOptions = {
  limit: Scalars['Int'];
  pageKey?: Maybe<Scalars['String']>;
};

export type AttemptedRowsResult = {
  __typename?: 'AttemptedRowsResult';
  nextPageKey: Maybe<Scalars['String']>;
  rows: Array<Maybe<AttemptedRow>>;
};

export type Auth0Connection = {
  __typename?: 'Auth0Connection';
  auth0_id: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AvailableWorkspace = {
  __typename?: 'AvailableWorkspace';
  id: Scalars['Int'];
  name: Scalars['String'];
  organization: Maybe<Organization>;
  slug: Scalars['String'];
};

export type Base = {
  __typename?: 'Base';
  id: Scalars['String'];
  name: Scalars['String'];
  permissionLevel: Scalars['String'];
};

export type BatchRequestInfo = {
  __typename?: 'BatchRequestInfo';
  requests: Array<RequestInfo>;
};

export type BillingOrganization = {
  __typename?: 'BillingOrganization';
  billing: Maybe<Scalars['JSONObject']>;
  entitlements: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  plan: Maybe<Plan>;
  slug: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type CheckTunnelResult = {
  __typename?: 'CheckTunnelResult';
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ClientSuccessDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ClientSuccessDescribeObjectResult = {
  __typename?: 'ClientSuccessDescribeObjectResult';
  customFields: Array<Maybe<ClientSuccessField>>;
  fields: Array<ClientSuccessField>;
};

export type ClientSuccessField = {
  __typename?: 'ClientSuccessField';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CloseioCustomActivitiesInput = {
  destinationId: Scalars['String'];
};

export type CloseioCustomActivitiesResult = CloseioCustomActivitiesSuccess;

export type CloseioCustomActivitiesSuccess = {
  __typename?: 'CloseioCustomActivitiesSuccess';
  activities: Array<CloseioCustomActivity>;
};

export type CloseioCustomActivity = {
  __typename?: 'CloseioCustomActivity';
  fields: Array<CloseioObjectField>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CloseioDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type CloseioDescribeObjectResult = CloseioDescribeObjectSuccess;

export type CloseioDescribeObjectSuccess = {
  __typename?: 'CloseioDescribeObjectSuccess';
  fields: Array<CloseioObjectField>;
};

export type CloseioObjectField = {
  __typename?: 'CloseioObjectField';
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type ColumnResponse = {
  __typename?: 'ColumnResponse';
  columns: Array<QueryColumn>;
};

export type ConnectionDetails = {
  __typename?: 'ConnectionDetails';
  host: Scalars['String'];
  port: Scalars['Int'];
};

export type CreateGoogleServiceAccountResult = CreateGoogleServiceAccountSuccess;

export type CreateGoogleServiceAccountSuccess = {
  __typename?: 'CreateGoogleServiceAccountSuccess';
  serviceAccount: GoogleServiceAccount;
};

export type CreateWorkspaceResult = {
  __typename?: 'CreateWorkspaceResult';
  id: Scalars['Int'];
};

export type CustomDestinationField = {
  __typename?: 'CustomDestinationField';
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifier: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  required: Maybe<Scalars['Boolean']>;
  type: Maybe<Scalars['String']>;
};

export type CustomDestinationListFieldsInput = {
  destinationId: Scalars['String'];
  mode?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
};

export type CustomDestinationListFieldsResult = {
  __typename?: 'CustomDestinationListFieldsResult';
  fields: Maybe<Array<CustomDestinationField>>;
  freeform: Maybe<Scalars['Boolean']>;
};

export type CustomDestinationListModesInput = {
  destinationId: Scalars['String'];
  object?: Maybe<Scalars['String']>;
};

export type CustomDestinationListModesResult = {
  __typename?: 'CustomDestinationListModesResult';
  modes: Maybe<Array<CustomDestinationMode>>;
};

export type CustomDestinationListObjectsInput = {
  destinationId: Scalars['String'];
};

export type CustomDestinationListObjectsResult = {
  __typename?: 'CustomDestinationListObjectsResult';
  objects: Maybe<Array<CustomDestinationObject>>;
};

export type CustomDestinationListOptionsInput = {
  destinationId: Scalars['String'];
  mode?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
};

export type CustomDestinationListOptionsResult = {
  __typename?: 'CustomDestinationListOptionsResult';
  options: Maybe<CustomDestinationOptions>;
};

export type CustomDestinationMode = {
  __typename?: 'CustomDestinationMode';
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type CustomDestinationObject = {
  __typename?: 'CustomDestinationObject';
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type CustomDestinationOptions = {
  __typename?: 'CustomDestinationOptions';
  schema: Maybe<Scalars['String']>;
  uiSchema: Maybe<Scalars['String']>;
};

export type CustomDestinationValidateConfigurationInput = {
  destinationId: Scalars['String'];
  jsonInstanceConfiguration: Scalars['String'];
};

export type CustomDestinationValidateConfigurationResult = {
  __typename?: 'CustomDestinationValidateConfigurationResult';
  errors: Maybe<Array<Scalars['String']>>;
};

export type DbtAccount = {
  __typename?: 'DBTAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DbtCredential = {
  __typename?: 'DBTCredential';
  api_key: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  subdomain: Maybe<Scalars['String']>;
};

export type DbtJob = {
  __typename?: 'DBTJob';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DestinationCategory = {
  __typename?: 'DestinationCategory';
  name: Scalars['String'];
  shortDescription: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type DestinationDefinition = {
  __typename?: 'DestinationDefinition';
  categories: Array<Maybe<DestinationCategory>>;
  configVersion: Maybe<Scalars['Int']>;
  configurationForm: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  docs: Scalars['String'];
  features: Array<Maybe<Scalars['String']>>;
  icon: Scalars['String'];
  longPitch: Scalars['String'];
  name: Scalars['String'];
  oauthUrl: Maybe<Scalars['String']>;
  releasedAt: Maybe<Scalars['String']>;
  shortPitch: Scalars['String'];
  status: Scalars['String'];
  testConnection: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['String']>;
};

export type DestinationDefinitionInput = {
  slug: Scalars['String'];
};

export type DestinationIdInput = {
  destinationId: Scalars['String'];
};

export type DestinationResult = {
  __typename?: 'DestinationResult';
  config: Maybe<Scalars['JSONObject']>;
  created_at: Scalars['String'];
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  definition: DestinationDefinition;
  id: Scalars['bigint'];
  name: Maybe<Scalars['String']>;
  setup_complete: Scalars['Boolean'];
  slug: Maybe<Scalars['String']>;
  stripped_config: Scalars['JSONObject'];
  tags: Scalars['JSONObject'];
  type: Scalars['String'];
  updated_at: Maybe<Scalars['String']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Scalars['bigint'];
};


export type DestinationResultConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


export type DestinationResultTagsArgs = {
  path?: Maybe<Scalars['String']>;
};

export type DestinationTypesResult = {
  __typename?: 'DestinationTypesResult';
  count: Scalars['Int'];
  type: Scalars['String'];
};

export type DestinationsMutationInput = {
  config?: Maybe<Scalars['JSONObject']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

export type FacebookAdAccount = {
  __typename?: 'FacebookAdAccount';
  accountId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FacebookAdCatalogGetProductCatalogs = {
  __typename?: 'FacebookAdCatalogGetProductCatalogs';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FacebookAdCatalogGetProductCatalogsInput = {
  destinationId: Scalars['String'];
};

export type FacebookAdCatalogGetProductCatalogsResult = FacebookAdCatalogGetProductCatalogsSuccess;

export type FacebookAdCatalogGetProductCatalogsSuccess = {
  __typename?: 'FacebookAdCatalogGetProductCatalogsSuccess';
  fields: Array<FacebookAdCatalogGetProductCatalogs>;
};

export type FacebookConversionsDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type FacebookConversionsDescribeObjectResult = FacebookConversionsDescribeObjectSuccess;

export type FacebookConversionsDescribeObjectSuccess = {
  __typename?: 'FacebookConversionsDescribeObjectSuccess';
  fields: Array<FacebookConversionsField>;
};

export type FacebookConversionsField = {
  __typename?: 'FacebookConversionsField';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type FacebookConversionsListObjectsInput = {
  destinationId: Scalars['String'];
};

export type FacebookConversionsListObjectsResult = FacebookConversionsListObjectsSuccess;

export type FacebookConversionsListObjectsSuccess = {
  __typename?: 'FacebookConversionsListObjectsSuccess';
  objects: Array<FacebookConversionsObject>;
};

export type FacebookConversionsObject = {
  __typename?: 'FacebookConversionsObject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FacebookListAdAccountsInput = {
  destinationId: Scalars['String'];
};

export type FacebookListAdAccountsResult = FacebookListAdAccountsSuccess;

export type FacebookListAdAccountsSuccess = {
  __typename?: 'FacebookListAdAccountsSuccess';
  accounts: Array<FacebookAdAccount>;
};

export type FailedQueryResponse = {
  __typename?: 'FailedQueryResponse';
  error: Scalars['String'];
  metadata: Maybe<Scalars['JSONObject']>;
  sql: Maybe<Scalars['String']>;
};

export type Field = {
  __typename?: 'Field';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type FilterableColumn = {
  __typename?: 'FilterableColumn';
  alias: Maybe<Scalars['String']>;
  /** The reference that should be used for referring to this column in filters and aggregations. */
  column_reference: Scalars['JSONObject'];
  custom_type: Maybe<Scalars['String']>;
  disable: Maybe<Scalars['Boolean']>;
  disable_preview: Maybe<Scalars['Boolean']>;
  last_top_k_sync_timestamp: Maybe<Scalars['String']>;
  model_id: Scalars['String'];
  model_name: Scalars['String'];
  name: Scalars['String'];
  top_k_enabled: Maybe<Scalars['Boolean']>;
  top_k_error: Maybe<Scalars['String']>;
  top_k_sync_interval: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type FormkitDefinitionInput = {
  type: Scalars['String'];
};

export type FormkitSourceContext = {
  type: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type FormkitSourceHandlerInput = {
  context: FormkitSourceContext;
  handler: Scalars['String'];
  variables?: Maybe<Scalars['JSONObject']>;
};

export type FormkitSyncContext = {
  destinationId: Scalars['Int'];
  modelId: Scalars['Int'];
  syncId?: Maybe<Scalars['Int']>;
};

export type FormkitSyncHandlerInput = {
  context: FormkitSyncContext;
  handler: Scalars['String'];
  variables?: Maybe<Scalars['JSONObject']>;
};

export type FormkitValidationInput = {
  config: Scalars['JSONObject'];
  context?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type FreshdeskField = {
  __typename?: 'FreshdeskField';
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type FreshdeskListCustomFieldsInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type FreshdeskListCustomFieldsResult = FreshdeskListCustomFieldsSuccess;

export type FreshdeskListCustomFieldsSuccess = {
  __typename?: 'FreshdeskListCustomFieldsSuccess';
  fields: Array<FreshdeskField>;
};

export type FrontDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type FrontDescribeObjectResult = FrontDescribeObjectSuccess;

export type FrontDescribeObjectSuccess = {
  __typename?: 'FrontDescribeObjectSuccess';
  fields: Array<FrontObjectField>;
};

export type FrontObjectField = {
  __typename?: 'FrontObjectField';
  custom: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type GainsightGetAccountAttributesInput = {
  destinationId: Scalars['String'];
};

export type GainsightGetUserAttributesInput = {
  destinationId: Scalars['String'];
};

export type GainsightpxAccountAttributes = {
  __typename?: 'GainsightpxAccountAttributes';
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type GainsightpxGetAccountAttributesResult = GainsightpxGetAccountAttributesSuccess;

export type GainsightpxGetAccountAttributesSuccess = {
  __typename?: 'GainsightpxGetAccountAttributesSuccess';
  fields: Array<GainsightpxAccountAttributes>;
};

export type GainsightpxGetUserAttributesResult = GainsightpxGetUserAttributesSuccess;

export type GainsightpxGetUserAttributesSuccess = {
  __typename?: 'GainsightpxGetUserAttributesSuccess';
  fields: Array<GainsightpxUserAttributes>;
};

export type GainsightpxUserAttributes = {
  __typename?: 'GainsightpxUserAttributes';
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type GetAuth0ConnectionsByOrganizationResult = {
  __typename?: 'GetAuth0ConnectionsByOrganizationResult';
  auth0Connections: Array<Auth0Connection>;
};

export type GetAvailableWorkspacesResult = {
  __typename?: 'GetAvailableWorkspacesResult';
  joinable: Array<AvailableWorkspace>;
  visible: Array<AvailableWorkspace>;
};

export type GetDestinationStrippedConfigurationInput = {
  destinationId: Scalars['bigint'];
};

export type GetLoginTokenResult = {
  __typename?: 'GetLoginTokenResult';
  token: Scalars['String'];
};

export type GetLookerLookOutput = {
  __typename?: 'GetLookerLookOutput';
  look: LookerLook;
};

export type GetTunnelResult = {
  __typename?: 'GetTunnelResult';
  connection: Maybe<ConnectionDetails>;
  tunnel: Tunnel;
  type: Scalars['String'];
};

export type GithubBranch = {
  __typename?: 'GithubBranch';
  name: Scalars['String'];
};

export type GithubRepository = {
  __typename?: 'GithubRepository';
  fullName: Scalars['String'];
  htmlUrl: Scalars['String'];
};

export type GoogleAccountsInput = {
  destinationId: Scalars['String'];
};

export type GoogleAdsConversionAction = {
  __typename?: 'GoogleAdsConversionAction';
  name: Scalars['String'];
  resourceName: Scalars['String'];
};

export type GoogleAdsDescribeModeInput = {
  destinationId: Scalars['String'];
  mode: Scalars['String'];
};

export type GoogleAdsDescribeModeResult = {
  __typename?: 'GoogleAdsDescribeModeResult';
  fields: Array<GoogleAdsField>;
};

export type GoogleAdsField = {
  __typename?: 'GoogleAdsField';
  id: Scalars['String'];
  name: Scalars['String'];
  required: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type GoogleAdsListConversionActionsInput = {
  accountId: Scalars['String'];
  destinationId: Scalars['String'];
  loginAccountId?: Maybe<Scalars['String']>;
  mode: Scalars['String'];
};

export type GoogleAdsListConversionActionsResult = {
  __typename?: 'GoogleAdsListConversionActionsResult';
  actions: Array<GoogleAdsConversionAction>;
};

export type GoogleCampaignManagerListFloodlightActivitiesInput = {
  destinationId: Scalars['String'];
  profileId: Scalars['String'];
};

export type GoogleCampaignManagerListProfilesInput = {
  destinationId: Scalars['String'];
};

export type GoogleServiceAccount = {
  __typename?: 'GoogleServiceAccount';
  credentials: Scalars['String'];
  email: Scalars['String'];
};

export type GooglesheetsListSheetsInput = {
  destinationId: Scalars['String'];
  spreadsheetId: Scalars['String'];
};

export type GooglesheetsListSheetsResult = GooglesheetsListSheetsSuccess;

export type GooglesheetsListSheetsSuccess = {
  __typename?: 'GooglesheetsListSheetsSuccess';
  sheetNames: Array<SheetName>;
};

export type GooglesheetsRetrieveAccessTokenInput = {
  destinationId: Scalars['String'];
};

export type GooglesheetsRetrieveAccessTokenResult = GooglesheetsRetrieveAccessTokenSuccess;

export type GooglesheetsRetrieveAccessTokenSuccess = {
  __typename?: 'GooglesheetsRetrieveAccessTokenSuccess';
  accessToken: Scalars['String'];
};

export type GooglesheetsSpreadSheet = {
  __typename?: 'GooglesheetsSpreadSheet';
  id: Scalars['String'];
  name: Scalars['String'];
  webViewLink: Scalars['String'];
};

export type HubSpotDescribeGlobalInput = {
  destinationId: Scalars['String'];
};

export type HubSpotDescribeGlobalResult = HubSpotDescribeGlobalSuccess;

export type HubSpotDescribeGlobalSuccess = {
  __typename?: 'HubSpotDescribeGlobalSuccess';
  objectsV2: Array<HubSpotObjectDescription>;
};

export type HubSpotDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type HubSpotDescribeObjectResult = HubSpotDescribeObjectSuccess;

export type HubSpotDescribeObjectSuccess = {
  __typename?: 'HubSpotDescribeObjectSuccess';
  associations: Array<HubSpotObjectAssociation>;
  fields: Array<HubSpotObjectField>;
};

export type HubSpotLegacyDescribeGlobalInput = {
  destinationId: Scalars['String'];
};

export type HubSpotLegacyDescribeGlobalResult = HubSpotLegacyDescribeGlobalSuccess;

export type HubSpotLegacyDescribeGlobalSuccess = {
  __typename?: 'HubSpotLegacyDescribeGlobalSuccess';
  objectsV2: Array<HubSpotLegacyObjectDescription>;
};

export type HubSpotLegacyDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type HubSpotLegacyDescribeObjectResult = HubSpotLegacyDescribeObjectSuccess;

export type HubSpotLegacyDescribeObjectSuccess = {
  __typename?: 'HubSpotLegacyDescribeObjectSuccess';
  associations: Array<HubSpotLegacyObjectAssociation>;
  fields: Array<HubSpotLegacyObjectField>;
};

export type HubSpotLegacyObjectAssociation = {
  __typename?: 'HubSpotLegacyObjectAssociation';
  fromObjectTypeId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  toObjectTypeId: Scalars['String'];
};

export type HubSpotLegacyObjectDescription = {
  __typename?: 'HubSpotLegacyObjectDescription';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HubSpotLegacyObjectField = {
  __typename?: 'HubSpotLegacyObjectField';
  isUpdateable: Scalars['Boolean'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
  unique: Scalars['Boolean'];
};

export type HubSpotObjectAssociation = {
  __typename?: 'HubSpotObjectAssociation';
  fromObjectTypeId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  toObjectTypeId: Scalars['String'];
};

export type HubSpotObjectDescription = {
  __typename?: 'HubSpotObjectDescription';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HubSpotObjectField = {
  __typename?: 'HubSpotObjectField';
  isUpdateable: Scalars['Boolean'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
  unique: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export const IntegrationRequestType = {
  Destination: 'Destination',
  Source: 'Source'
} as const;

export type IntegrationRequestType = typeof IntegrationRequestType[keyof typeof IntegrationRequestType];
export type IntercomAttribute = {
  __typename?: 'IntercomAttribute';
  api_writable: Scalars['Boolean'];
  custom: Scalars['Boolean'];
  data_type: Scalars['String'];
  name: Scalars['String'];
};

export type IntercomListAttributesInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type IntercomListAttributesResult = IntercomListAttributesSuccess;

export type IntercomListAttributesSuccess = {
  __typename?: 'IntercomListAttributesSuccess';
  fields: Array<IntercomAttribute>;
};

export type IterableCampaign = {
  __typename?: 'IterableCampaign';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type IterableCatalogFields = {
  __typename?: 'IterableCatalogFields';
  id: Scalars['String'];
  iterableType: Scalars['String'];
  name: Scalars['String'];
  type: StandardFieldType;
};

export type IterableCatalogs = {
  __typename?: 'IterableCatalogs';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IterableField = {
  __typename?: 'IterableField';
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type IterableGetCampaigns = {
  __typename?: 'IterableGetCampaigns';
  campaigns: Array<IterableCampaign>;
};

export type IterableGetCampaignsInput = {
  destinationId: Scalars['String'];
};

export type IterableGetCatalogFields = {
  __typename?: 'IterableGetCatalogFields';
  catalogFields: Maybe<Array<IterableCatalogFields>>;
};

export type IterableGetCatalogFieldsInput = {
  catalogName?: Maybe<Scalars['String']>;
  destinationId: Scalars['String'];
};

export type IterableGetCatalogs = {
  __typename?: 'IterableGetCatalogs';
  catalogs: Array<IterableCatalogs>;
};

export type IterableGetCatalogsInput = {
  destinationId: Scalars['String'];
};

export type IterableGetTemplates = {
  __typename?: 'IterableGetTemplates';
  templates: Array<IterableTemplate>;
};

export type IterableGetTemplatesInput = {
  destinationId: Scalars['String'];
};

export type IterableTemplate = {
  __typename?: 'IterableTemplate';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type IterableUserFieldsInput = {
  destinationId: Scalars['String'];
};

export type IterableUserFieldsResult = IterableUserFieldsSuccess;

export type IterableUserFieldsSuccess = {
  __typename?: 'IterableUserFieldsSuccess';
  fields: Array<IterableField>;
};

export type JiraGetIssueFields = {
  __typename?: 'JiraGetIssueFields';
  fields: Array<JiraIssueFields>;
};

export type JiraGetIssueFieldsInput = {
  destinationId: Scalars['String'];
  issueType: Scalars['String'];
  projectId: Scalars['String'];
};

export type JiraGetIssueTypes = {
  __typename?: 'JiraGetIssueTypes';
  issueTypes: Array<JiraIssueTypes>;
};

export type JiraGetIssueTypesInput = {
  destinationId: Scalars['String'];
  projectId: Scalars['String'];
};

export type JiraGetProjects = {
  __typename?: 'JiraGetProjects';
  projects: Array<JiraProjects>;
};

export type JiraGetProjectsInput = {
  destinationId: Scalars['String'];
};

export type JiraIssueFields = {
  __typename?: 'JiraIssueFields';
  customFieldType: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type JiraIssueTypes = {
  __typename?: 'JiraIssueTypes';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type JiraProjects = {
  __typename?: 'JiraProjects';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ListAllSourceDependenciesResult = {
  __typename?: 'ListAllSourceDependenciesResult';
  sources: Array<Maybe<ListAllSourceDependenciesResultObject>>;
};

export type ListAllSourceDependenciesResultObject = {
  __typename?: 'ListAllSourceDependenciesResultObject';
  dependencies: ListSourceDependenciesResult;
  id: Scalars['String'];
};

export type ListPostgresColumnsInput = {
  destinationId: Scalars['String'];
  table: Scalars['String'];
};

export type ListPostgresTablesInput = {
  destinationId: Scalars['String'];
};

export type ListSourceDependenciesResult = {
  __typename?: 'ListSourceDependenciesResult';
  audiences: Array<Maybe<SourceAudienceDependencyReference>>;
  models: Array<Maybe<SourceModelDependencyReference>>;
  syncs: Array<Maybe<SourceSyncDependencyReference>>;
};

export type LookerLook = {
  __typename?: 'LookerLook';
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sql: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MarketoActivity = {
  __typename?: 'MarketoActivity';
  activityTypeId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MarketoAttribute = {
  __typename?: 'MarketoAttribute';
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type MarketoDescribeActivityInput = {
  activity: Scalars['String'];
  destinationId: Scalars['String'];
};

export type MarketoDescribeActivityResult = MarketoDescribeActivitySuccess;

export type MarketoDescribeActivitySuccess = {
  __typename?: 'MarketoDescribeActivitySuccess';
  attributes: Array<MarketoAttribute>;
};

export type MarketoDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type MarketoDescribeObjectResult = MarketoDescribeObjectSuccess;

export type MarketoDescribeObjectSuccess = {
  __typename?: 'MarketoDescribeObjectSuccess';
  fields: Array<MarketoField>;
};

export type MarketoField = {
  __typename?: 'MarketoField';
  id: Scalars['String'];
  isID: Scalars['Boolean'];
  isLookup: Scalars['Boolean'];
  isUpdateable: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type MarketoListActivitiesInput = {
  destinationId: Scalars['String'];
};

export type MarketoListActivitiesResult = MarketoListActivitiesSuccess;

export type MarketoListActivitiesSuccess = {
  __typename?: 'MarketoListActivitiesSuccess';
  activities: Array<MarketoActivity>;
};

export type MarketoListObjectsInput = {
  destinationId: Scalars['String'];
};

export type MarketoListObjectsResult = MarketoListObjectsSuccess;

export type MarketoListObjectsSuccess = {
  __typename?: 'MarketoListObjectsSuccess';
  objects: Array<MarketoObject>;
};

export type MarketoObject = {
  __typename?: 'MarketoObject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MetricsResult = {
  __typename?: 'MetricsResult';
  metrics: Array<MetricsRowResult>;
  roles: Array<RolesResult>;
};

export type MetricsRowResult = {
  __typename?: 'MetricsRowResult';
  audiences: Maybe<Scalars['Int']>;
  connections: Maybe<Scalars['Int']>;
  created_at: Scalars['String'];
  destinations: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  models: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  syncs: Maybe<Scalars['Int']>;
};

export type ModelColumn = {
  __typename?: 'ModelColumn';
  alias: Maybe<Scalars['String']>;
  /** The reference that should be used for referring to this column in filters and aggregations. */
  column_reference: Scalars['JSONObject'];
  custom_type: Maybe<Scalars['String']>;
  disable: Maybe<Scalars['Boolean']>;
  disable_preview: Maybe<Scalars['Boolean']>;
  is_related: Scalars['Boolean'];
  last_top_k_sync_timestamp: Maybe<Scalars['String']>;
  model_id: Scalars['String'];
  model_name: Scalars['String'];
  name: Scalars['String'];
  top_k_enabled: Maybe<Scalars['Boolean']>;
  top_k_error: Maybe<Scalars['String']>;
  top_k_sync_interval: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type MongoDbListCollectionsInput = {
  destinationId: Scalars['String'];
};

export type NormalTunnel = Tunnel & {
  __typename?: 'NormalTunnel';
  createdAt: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  serviceHost: Scalars['String'];
  servicePort: Scalars['Int'];
  sshHost: Scalars['String'];
  sshPort: Maybe<Scalars['Int']>;
  sshUser: Maybe<Scalars['String']>;
  tunnelPort: Maybe<Scalars['Int']>;
};

export type NormalTunnelInput = {
  name: Scalars['String'];
  serviceHost: Scalars['String'];
  servicePort: Scalars['Int'];
  sshHost: Scalars['String'];
  sshPort?: Maybe<Scalars['Int']>;
};

export type NormalTunnelOutput = {
  __typename?: 'NormalTunnelOutput';
  connection: ConnectionDetails;
  publicKey: Maybe<Scalars['String']>;
  tunnel: NormalTunnel;
};

export type NotionDatabase = {
  __typename?: 'NotionDatabase';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type NotionDatabaseProperty = {
  __typename?: 'NotionDatabaseProperty';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type NotionGetDatabaseProperties = {
  __typename?: 'NotionGetDatabaseProperties';
  properties: Array<NotionDatabaseProperty>;
};

export type NotionGetDatabasePropertiesInput = {
  databaseId: Scalars['String'];
  destinationId: Scalars['String'];
};

export type NotionGetDatabases = {
  __typename?: 'NotionGetDatabases';
  entries: Array<NotionDatabase>;
};

export type NotionGetDatabasesInput = {
  destinationId: Scalars['String'];
};

export type OrbitListWorkspaces = {
  __typename?: 'OrbitListWorkspaces';
  workspaces: Array<OrbitWorkspace>;
};

export type OrbitListWorkspacesInput = {
  destinationId: Scalars['String'];
};

export type OrbitWorkspace = {
  __typename?: 'OrbitWorkspace';
  name: Scalars['String'];
  path: Scalars['String'];
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PartnerAvailableWorkspace = {
  __typename?: 'PartnerAvailableWorkspace';
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PartnerConnection = {
  __typename?: 'PartnerConnection';
  defaultWorkspaceName: Maybe<Scalars['String']>;
  partnerLogo: Scalars['String'];
  partnerName: Scalars['String'];
  resources: Maybe<Array<Maybe<Scalars['String']>>>;
  type: Scalars['String'];
  userIsLinked: Scalars['Boolean'];
  uuid: Scalars['String'];
  workspaceId: Maybe<Scalars['Int']>;
};

export type PartnerInformation = {
  __typename?: 'PartnerInformation';
  partnerLogo: Scalars['String'];
  partnerName: Scalars['String'];
  resources: Maybe<Array<Maybe<Scalars['String']>>>;
  type: Scalars['String'];
};

export type PipedriveDomains = {
  __typename?: 'PipedriveDomains';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type PipedriveListDomains = {
  __typename?: 'PipedriveListDomains';
  domains: Array<Maybe<PipedriveDomains>>;
};

export type PipedriveListDomainsInput = {
  apiKey: Scalars['String'];
  destinationId: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  entitlements: Maybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  sku: Scalars['String'];
};

export type PlannedRowsPaginationOptions = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PlannedRowsResult = {
  __typename?: 'PlannedRowsResult';
  nextPageOffset: Maybe<Scalars['Int']>;
  rows: Array<Maybe<Scalars['String']>>;
};

export type PostgresColumn = {
  __typename?: 'PostgresColumn';
  name: Scalars['String'];
};

export type PostgresTable = {
  __typename?: 'PostgresTable';
  name: Scalars['String'];
};

export type QueryColumn = {
  __typename?: 'QueryColumn';
  name: Scalars['String'];
  type: Scalars['String'];
};

export type QueryResponse = FailedQueryResponse | SuccessfulQueryResponse;

export type RequestInfo = {
  __typename?: 'RequestInfo';
  data: Scalars['JSONObject'];
  requestType: Scalars['String'];
};

export type RequestMediaUploadInput = {
  fileName: Scalars['String'];
};

export type RequestMediaUploadResult = {
  __typename?: 'RequestMediaUploadResult';
  getUrl: Scalars['String'];
  putUrl: Scalars['String'];
};

export type ResourcePermission = {
  __typename?: 'ResourcePermission';
  grants: Maybe<Array<ResourcePermissionGrant>>;
  resource: ResourceToPermission;
  resource_id: Maybe<Scalars['String']>;
};

export const ResourcePermissionGrant = {
  Create: 'create',
  Debugger: 'debugger',
  Delete: 'delete',
  Enable: 'enable',
  Preview: 'preview',
  Read: 'read',
  Start: 'start',
  Testrow: 'testrow',
  Update: 'update'
} as const;

export type ResourcePermissionGrant = typeof ResourcePermissionGrant[keyof typeof ResourcePermissionGrant];
export const ResourceToPermission = {
  Alert: 'alert',
  Audience: 'audience',
  AudienceSchema: 'audience_schema',
  Destination: 'destination',
  Model: 'model',
  Source: 'source',
  Sync: 'sync',
  SyncTemplate: 'sync_template',
  Workspace: 'workspace',
  WorkspaceMembership: 'workspace_membership'
} as const;

export type ResourceToPermission = typeof ResourceToPermission[keyof typeof ResourceToPermission];
export type ReverseTunnel = Tunnel & {
  __typename?: 'ReverseTunnel';
  createdAt: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  sshdPort: Maybe<Scalars['Int']>;
  tunnelPort: Maybe<Scalars['Int']>;
};

export type ReverseTunnelInput = {
  name: Scalars['String'];
};

export type ReverseTunnelOutput = {
  __typename?: 'ReverseTunnelOutput';
  connection: ConnectionDetails;
  privateKeyBase64: Maybe<Scalars['String']>;
  tunnel: ReverseTunnel;
};

export type RolesResult = {
  __typename?: 'RolesResult';
  count: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  workspace_id: Scalars['String'];
};

export type SalesloftCustomFields = {
  __typename?: 'SalesloftCustomFields';
  field_type: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  value_type: Scalars['String'];
};

export type SalesloftCustomFieldsInput = {
  destinationId: Scalars['String'];
};

export type SalesloftCustomFieldsResult = SalesloftCustomFieldsSuccess;

export type SalesloftCustomFieldsSuccess = {
  __typename?: 'SalesloftCustomFieldsSuccess';
  fields: Array<SalesloftCustomFields>;
};

export type SampleModel = {
  __typename?: 'SampleModel';
  name: Scalars['String'];
  sql: Scalars['String'];
};

export type SearchLookerLooksOutput = {
  __typename?: 'SearchLookerLooksOutput';
  looks: Array<LookerLook>;
};

export type SendGridContactField = {
  __typename?: 'SendGridContactField';
  fieldType: Scalars['String'];
  id: Scalars['String'];
  isCustom: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SendGridContactSchemaInput = {
  destinationId: Scalars['String'];
};

export type SendGridContactSchemaResult = SendGridContactSchemaSuccess;

export type SendGridContactSchemaSuccess = {
  __typename?: 'SendGridContactSchemaSuccess';
  fields: Array<SendGridContactField>;
};

export type SetupInWarehouseDiffingForSourceOutput = {
  __typename?: 'SetupInWarehouseDiffingForSourceOutput';
  ignored: Maybe<Scalars['Boolean']>;
};

export type SetupInWarehouseDiffingWithCredentialsOutput = {
  __typename?: 'SetupInWarehouseDiffingWithCredentialsOutput';
  ignored: Maybe<Scalars['Boolean']>;
};

export type SfmcBusinessUnit = {
  __typename?: 'SfmcBusinessUnit';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SfmcDataExtension = {
  __typename?: 'SfmcDataExtension';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SfmcDataExtensionField = {
  __typename?: 'SfmcDataExtensionField';
  id: Scalars['String'];
  isPrimaryKey: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type SfmcDataFolder = {
  __typename?: 'SfmcDataFolder';
  id: Scalars['String'];
  name: Scalars['String'];
  parentId: Maybe<Scalars['String']>;
};

export type SfmcField = {
  __typename?: 'SfmcField';
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type SfmcJourney = {
  __typename?: 'SfmcJourney';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SfmcListAttributeSetsInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type SfmcListAttributeSetsResult = SfmcListAttributeSetsSuccess;

export type SfmcListAttributeSetsSuccess = {
  __typename?: 'SfmcListAttributeSetsSuccess';
  fields: Array<SfmcField>;
};

export type SfmcListBusinessUnits = {
  __typename?: 'SfmcListBusinessUnits';
  businessUnits: Array<SfmcBusinessUnit>;
};

export type SfmcListBusinessUnitsInput = {
  destinationId: Scalars['String'];
};

export type SfmcListDataExtensionFields = {
  __typename?: 'SfmcListDataExtensionFields';
  fields: Array<SfmcDataExtensionField>;
};

export type SfmcListDataExtensionFieldsInput = {
  businessUnit?: Maybe<Scalars['String']>;
  dataExtensionId: Scalars['String'];
  destinationId: Scalars['String'];
};

export type SfmcListDataExtensions = {
  __typename?: 'SfmcListDataExtensions';
  dataExtensions: Array<SfmcDataExtension>;
};

export type SfmcListDataExtensionsInput = {
  businessUnit?: Maybe<Scalars['String']>;
  dataFolder?: Maybe<Scalars['String']>;
  destinationId: Scalars['String'];
};

export type SfmcListDataFolders = {
  __typename?: 'SfmcListDataFolders';
  dataFolders: Array<SfmcDataFolder>;
};

export type SfmcListDataFoldersInput = {
  businessUnit?: Maybe<Scalars['String']>;
  destinationId: Scalars['String'];
};

export type SfmcListJourneysInput = {
  destinationId: Scalars['String'];
};

export type SfmcListJourneysResult = SfmcListJourneysSuccess;

export type SfmcListJourneysSuccess = {
  __typename?: 'SfmcListJourneysSuccess';
  journeys: Array<SfmcJourney>;
};

export type SheetName = {
  __typename?: 'SheetName';
  name: Scalars['String'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SlackListChannelsInput = {
  destinationId: Scalars['String'];
};

export type SlackListChannelsResult = SlackListChannelsSuccess;

export type SlackListChannelsSuccess = {
  __typename?: 'SlackListChannelsSuccess';
  channels: Array<SlackChannel>;
};

export type SnapchatEntity = {
  __typename?: 'SnapchatEntity';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SnapchatListAdAccounts = {
  __typename?: 'SnapchatListAdAccounts';
  accounts: Array<SnapchatEntity>;
};

export type SnapchatListAdAccountsInput = {
  destinationId: Scalars['String'];
};

export type SnapchatListOrganizations = {
  __typename?: 'SnapchatListOrganizations';
  organizations: Array<SnapchatEntity>;
};

export type SnapchatListOrganizationsInput = {
  destinationId: Scalars['String'];
};

export type SourceAudienceDependencyReference = {
  __typename?: 'SourceAudienceDependencyReference';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SourceCategory = {
  __typename?: 'SourceCategory';
  name: Scalars['String'];
  shortDescription: Scalars['String'];
  type: Scalars['String'];
};

export type SourceDefinition = {
  __typename?: 'SourceDefinition';
  categories: Maybe<Array<Maybe<SourceCategory>>>;
  disableTest: Scalars['Boolean'];
  docs: Scalars['String'];
  icon: Scalars['String'];
  isSampleDataSource: Scalars['Boolean'];
  longPitch: Scalars['String'];
  name: Scalars['String'];
  releasedAt: Maybe<Scalars['String']>;
  sampleModels: Maybe<Array<Maybe<SampleModel>>>;
  shortPitch: Scalars['String'];
  status: Scalars['String'];
  supportedQueries: Array<Scalars['String']>;
  supportsCrossDbReference: Scalars['Boolean'];
  supportsInWarehouseDiffing: Scalars['Boolean'];
  supportsIpFiltering: Scalars['Boolean'];
  supportsResultSchema: Scalars['Boolean'];
  supportsTunneling: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['String']>;
};

export type SourceDefinitionInput = {
  type: Scalars['String'];
};

export type SourceMethod = {
  __typename?: 'SourceMethod';
  form: Maybe<Scalars['JSON']>;
  key: Scalars['String'];
  label: Maybe<Scalars['String']>;
  method: Scalars['String'];
  provider: Maybe<Scalars['String']>;
  tunneling: Maybe<Scalars['Boolean']>;
  url: Maybe<Scalars['String']>;
};

export type SourceModelDependencyReference = {
  __typename?: 'SourceModelDependencyReference';
  id: Scalars['String'];
  modelSourceType: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
};

export type SourceSyncDependencyReference = {
  __typename?: 'SourceSyncDependencyReference';
  destinationName: Scalars['String'];
  destinationType: Scalars['String'];
  id: Scalars['String'];
  modelName: Scalars['String'];
  modelType: Scalars['String'];
  slug: Scalars['String'];
};

export type SourceTestResult = {
  __typename?: 'SourceTestResult';
  metadata: Maybe<Scalars['JSONObject']>;
  reason: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export const StandardFieldType = {
  Array: 'ARRAY',
  Boolean: 'BOOLEAN',
  Date: 'DATE',
  Datetime: 'DATETIME',
  Email: 'EMAIL',
  Enum: 'ENUM',
  Number: 'NUMBER',
  Object: 'OBJECT',
  Reference: 'REFERENCE',
  String: 'STRING',
  Unknown: 'UNKNOWN'
} as const;

export type StandardFieldType = typeof StandardFieldType[keyof typeof StandardFieldType];
export type StartSyncRunOutput = {
  __typename?: 'StartSyncRunOutput';
  scheduled: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

export type StripeRedirectResult = {
  __typename?: 'StripeRedirectResult';
  redirect: Scalars['String'];
};

export type SuccessfulQueryResponse = {
  __typename?: 'SuccessfulQueryResponse';
  columns: Array<QueryColumn>;
  exceedsPreviewMax: Scalars['Boolean'];
  numRowsWithoutLimit: Maybe<Scalars['Int']>;
  rows: Array<Scalars['JSONObject']>;
  sql: Maybe<Scalars['String']>;
};

export const SyncOp = {
  Added: 'ADDED',
  Changed: 'CHANGED',
  Removed: 'REMOVED'
} as const;

export type SyncOp = typeof SyncOp[keyof typeof SyncOp];
export type SyncResultBatch = {
  __typename?: 'SyncResultBatch';
  attemptedRows: Maybe<Array<Scalars['JSONObject']>>;
  batchId: Scalars['String'];
  rejectedRows: Maybe<Array<Scalars['JSONObject']>>;
  requestInfoSet: Maybe<Array<Maybe<RequestInfo>>>;
};

export type SyncableColumn = {
  __typename?: 'SyncableColumn';
  /** The reference that should be used for referring to this column in filters and aggregations. */
  column_reference: Scalars['JSONObject'];
  model_name: Scalars['String'];
  name: Scalars['String'];
};

export type Table = {
  __typename?: 'Table';
  fields: Array<Field>;
  name: Scalars['String'];
};

export type TestDestinationConnectionResponse = {
  __typename?: 'TestDestinationConnectionResponse';
  metadata: Maybe<Scalars['JSONObject']>;
  reason: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TestDestinationResponse = {
  __typename?: 'TestDestinationResponse';
  metadata: Maybe<Scalars['JSONObject']>;
  reason: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TestSyncConfigurationResult = {
  __typename?: 'TestSyncConfigurationResult';
  batches: Array<SyncResultBatch>;
  error: Maybe<Scalars['String']>;
};

export type TiktokListAdvertisersInput = {
  destinationId: Scalars['String'];
};

export type TopKColumnResponse = {
  __typename?: 'TopKColumnResponse';
  error: Maybe<Scalars['String']>;
  modelId: Scalars['String'];
  name: Scalars['String'];
  values: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type TopKResponse = {
  __typename?: 'TopKResponse';
  columns: Array<TopKColumnResponse>;
};

export type Tunnel = {
  createdAt: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  tunnelPort: Maybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  avatar_json: Maybe<Scalars['JSONObject']>;
  current_workspace_id: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  is_admin: Scalars['Boolean'];
  name: Scalars['String'];
  not_member_of_current_workspace: Maybe<Scalars['Boolean']>;
  personalization: Maybe<UserPersonalization>;
  workspaces: Array<Maybe<Workspace>>;
};

export type UserPersonalization = {
  __typename?: 'UserPersonalization';
  custom_role: Maybe<Scalars['String']>;
  referrer: Maybe<Scalars['String']>;
  role: Maybe<Scalars['String']>;
  state: Maybe<UserPersonalizationState>;
};

export const UserPersonalizationState = {
  Completed: 'completed',
  Skipped: 'skipped'
} as const;

export type UserPersonalizationState = typeof UserPersonalizationState[keyof typeof UserPersonalizationState];
export type UserflowAttributes = {
  __typename?: 'UserflowAttributes';
  displayName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type UserflowGetAttributes = {
  __typename?: 'UserflowGetAttributes';
  attributes: Array<UserflowAttributes>;
};

export type UserflowGetAttributesInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ValidateDatadogCredentialsInput = {
  apiKey: Scalars['String'];
  site: Scalars['String'];
};

export type ValidateDatadogCredentialsOutput = {
  __typename?: 'ValidateDatadogCredentialsOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Workspace = {
  __typename?: 'Workspace';
  domain: Maybe<Scalars['String']>;
  feature_flags: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  is_approved: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZendeskCustomObjectField = {
  __typename?: 'ZendeskCustomObjectField';
  description: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ZendeskCustomObjectType = {
  __typename?: 'ZendeskCustomObjectType';
  name: Scalars['String'];
};

export type ZendeskField = {
  __typename?: 'ZendeskField';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ZendeskListCustomFieldsInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ZendeskListCustomFieldsResult = ZendeskListCustomFieldsSuccess;

export type ZendeskListCustomFieldsSuccess = {
  __typename?: 'ZendeskListCustomFieldsSuccess';
  fields: Array<ZendeskField>;
};

export type ZendeskListCustomObjectPropertiesInput = {
  destinationId: Scalars['String'];
  objectType: Scalars['String'];
};

export type ZendeskListCustomObjectPropertiesResult = ZendeskListCustomObjectPropertiesSuccess;

export type ZendeskListCustomObjectPropertiesSuccess = {
  __typename?: 'ZendeskListCustomObjectPropertiesSuccess';
  properties: Array<ZendeskCustomObjectField>;
};

export type ZendeskListCustomObjectTypesInput = {
  destinationId: Scalars['String'];
};

export type ZendeskListCustomObjectTypesResult = ZendeskListCustomObjectTypesSuccess;

export type ZendeskListCustomObjectTypesSuccess = {
  __typename?: 'ZendeskListCustomObjectTypesSuccess';
  objectTypes: Array<ZendeskCustomObjectType>;
};

/** columns and relationships of "alert_instances" */
export type AlertInstances = {
  __typename?: 'alert_instances';
  /** An object relationship */
  alert: Alerts;
  alert_id: Scalars['bigint'];
  /** An object relationship */
  destination_instance: Maybe<DestinationInstances>;
  destination_instance_id: Maybe<Scalars['bigint']>;
  fatal_error: Maybe<Scalars['Boolean']>;
  row_error: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  sync_template: Maybe<SyncTemplates>;
  sync_template_id: Maybe<Scalars['Int']>;
};

/** order by aggregate values of table "alert_instances" */
export type AlertInstancesAggregateOrderBy = {
  avg?: Maybe<AlertInstancesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AlertInstancesMaxOrderBy>;
  min?: Maybe<AlertInstancesMinOrderBy>;
  stddev?: Maybe<AlertInstancesStddevOrderBy>;
  stddev_pop?: Maybe<AlertInstancesStddevPopOrderBy>;
  stddev_samp?: Maybe<AlertInstancesStddevSampOrderBy>;
  sum?: Maybe<AlertInstancesSumOrderBy>;
  var_pop?: Maybe<AlertInstancesVarPopOrderBy>;
  var_samp?: Maybe<AlertInstancesVarSampOrderBy>;
  variance?: Maybe<AlertInstancesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "alert_instances" */
export type AlertInstancesArrRelInsertInput = {
  data: Array<AlertInstancesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AlertInstancesOnConflict>;
};

/** order by avg() on columns of table "alert_instances" */
export type AlertInstancesAvgOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "alert_instances". All fields are combined with a logical 'AND'. */
export type AlertInstancesBoolExp = {
  _and?: Maybe<Array<AlertInstancesBoolExp>>;
  _not?: Maybe<AlertInstancesBoolExp>;
  _or?: Maybe<Array<AlertInstancesBoolExp>>;
  alert?: Maybe<AlertsBoolExp>;
  alert_id?: Maybe<BigintComparisonExp>;
  destination_instance?: Maybe<DestinationInstancesBoolExp>;
  destination_instance_id?: Maybe<BigintComparisonExp>;
  fatal_error?: Maybe<BooleanComparisonExp>;
  row_error?: Maybe<BooleanComparisonExp>;
  sync_template?: Maybe<SyncTemplatesBoolExp>;
  sync_template_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "alert_instances" */
export const AlertInstancesConstraint = {
  /** unique or primary key constraint */
  DestinationInstanceUnique: 'destination_instance_unique',
  /** unique or primary key constraint */
  SyncTemplateUnique: 'sync_template_unique'
} as const;

export type AlertInstancesConstraint = typeof AlertInstancesConstraint[keyof typeof AlertInstancesConstraint];
/** input type for inserting data into table "alert_instances" */
export type AlertInstancesInsertInput = {
  alert?: Maybe<AlertsObjRelInsertInput>;
  alert_id?: Maybe<Scalars['bigint']>;
  destination_instance?: Maybe<DestinationInstancesObjRelInsertInput>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  fatal_error?: Maybe<Scalars['Boolean']>;
  row_error?: Maybe<Scalars['Boolean']>;
  sync_template?: Maybe<SyncTemplatesObjRelInsertInput>;
  sync_template_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "alert_instances" */
export type AlertInstancesMaxOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "alert_instances" */
export type AlertInstancesMinOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "alert_instances" */
export type AlertInstancesMutationResponse = {
  __typename?: 'alert_instances_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AlertInstances>;
};

/** on conflict condition type for table "alert_instances" */
export type AlertInstancesOnConflict = {
  constraint: AlertInstancesConstraint;
  update_columns?: Array<AlertInstancesUpdateColumn>;
  where?: Maybe<AlertInstancesBoolExp>;
};

/** Ordering options when selecting data from "alert_instances". */
export type AlertInstancesOrderBy = {
  alert?: Maybe<AlertsOrderBy>;
  alert_id?: Maybe<OrderBy>;
  destination_instance?: Maybe<DestinationInstancesOrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  fatal_error?: Maybe<OrderBy>;
  row_error?: Maybe<OrderBy>;
  sync_template?: Maybe<SyncTemplatesOrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** select columns of table "alert_instances" */
export const AlertInstancesSelectColumn = {
  /** column name */
  AlertId: 'alert_id',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  FatalError: 'fatal_error',
  /** column name */
  RowError: 'row_error',
  /** column name */
  SyncTemplateId: 'sync_template_id'
} as const;

export type AlertInstancesSelectColumn = typeof AlertInstancesSelectColumn[keyof typeof AlertInstancesSelectColumn];
/** input type for updating data in table "alert_instances" */
export type AlertInstancesSetInput = {
  fatal_error?: Maybe<Scalars['Boolean']>;
  row_error?: Maybe<Scalars['Boolean']>;
};

/** order by stddev() on columns of table "alert_instances" */
export type AlertInstancesStddevOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "alert_instances" */
export type AlertInstancesStddevPopOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "alert_instances" */
export type AlertInstancesStddevSampOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "alert_instances" */
export type AlertInstancesSumOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** update columns of table "alert_instances" */
export const AlertInstancesUpdateColumn = {
  /** column name */
  FatalError: 'fatal_error',
  /** column name */
  RowError: 'row_error'
} as const;

export type AlertInstancesUpdateColumn = typeof AlertInstancesUpdateColumn[keyof typeof AlertInstancesUpdateColumn];
/** order by var_pop() on columns of table "alert_instances" */
export type AlertInstancesVarPopOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "alert_instances" */
export type AlertInstancesVarSampOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "alert_instances" */
export type AlertInstancesVarianceOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
};

/** columns and relationships of "alert_statuses" */
export type AlertStatuses = {
  __typename?: 'alert_statuses';
  /** An object relationship */
  alert: Alerts;
  alert_id: Scalars['bigint'];
  /** An object relationship */
  destination_instance: DestinationInstances;
  destination_instance_id: Scalars['bigint'];
  error: Maybe<Scalars['jsonb']>;
  last_attempted: Scalars['timestamptz'];
};


/** columns and relationships of "alert_statuses" */
export type AlertStatusesErrorArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "alert_statuses" */
export type AlertStatusesAggregateOrderBy = {
  avg?: Maybe<AlertStatusesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AlertStatusesMaxOrderBy>;
  min?: Maybe<AlertStatusesMinOrderBy>;
  stddev?: Maybe<AlertStatusesStddevOrderBy>;
  stddev_pop?: Maybe<AlertStatusesStddevPopOrderBy>;
  stddev_samp?: Maybe<AlertStatusesStddevSampOrderBy>;
  sum?: Maybe<AlertStatusesSumOrderBy>;
  var_pop?: Maybe<AlertStatusesVarPopOrderBy>;
  var_samp?: Maybe<AlertStatusesVarSampOrderBy>;
  variance?: Maybe<AlertStatusesVarianceOrderBy>;
};

/** order by avg() on columns of table "alert_statuses" */
export type AlertStatusesAvgOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "alert_statuses". All fields are combined with a logical 'AND'. */
export type AlertStatusesBoolExp = {
  _and?: Maybe<Array<AlertStatusesBoolExp>>;
  _not?: Maybe<AlertStatusesBoolExp>;
  _or?: Maybe<Array<AlertStatusesBoolExp>>;
  alert?: Maybe<AlertsBoolExp>;
  alert_id?: Maybe<BigintComparisonExp>;
  destination_instance?: Maybe<DestinationInstancesBoolExp>;
  destination_instance_id?: Maybe<BigintComparisonExp>;
  error?: Maybe<JsonbComparisonExp>;
  last_attempted?: Maybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "alert_statuses" */
export type AlertStatusesMaxOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  last_attempted?: Maybe<OrderBy>;
};

/** order by min() on columns of table "alert_statuses" */
export type AlertStatusesMinOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  last_attempted?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "alert_statuses". */
export type AlertStatusesOrderBy = {
  alert?: Maybe<AlertsOrderBy>;
  alert_id?: Maybe<OrderBy>;
  destination_instance?: Maybe<DestinationInstancesOrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  last_attempted?: Maybe<OrderBy>;
};

/** select columns of table "alert_statuses" */
export const AlertStatusesSelectColumn = {
  /** column name */
  AlertId: 'alert_id',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  Error: 'error',
  /** column name */
  LastAttempted: 'last_attempted'
} as const;

export type AlertStatusesSelectColumn = typeof AlertStatusesSelectColumn[keyof typeof AlertStatusesSelectColumn];
/** order by stddev() on columns of table "alert_statuses" */
export type AlertStatusesStddevOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "alert_statuses" */
export type AlertStatusesStddevPopOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "alert_statuses" */
export type AlertStatusesStddevSampOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "alert_statuses" */
export type AlertStatusesSumOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "alert_statuses" */
export type AlertStatusesVarPopOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "alert_statuses" */
export type AlertStatusesVarSampOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "alert_statuses" */
export type AlertStatusesVarianceOrderBy = {
  alert_id?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
};

/** columns and relationships of "alerts" */
export type Alerts = {
  __typename?: 'alerts';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  alert_interval: Maybe<Scalars['bigint']>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  config: Scalars['jsonb'];
  created_by: Maybe<Scalars['bigint']>;
  fatal_error_default: Scalars['Boolean'];
  id: Scalars['bigint'];
  name: Scalars['name'];
  /** An object relationship */
  pagerduty_credential: Maybe<PagerdutyCredentials>;
  pagerduty_credential_id: Maybe<Scalars['bigint']>;
  row_error_default: Scalars['Boolean'];
  /** An object relationship */
  slack_credential: Maybe<SlackCredentials>;
  slack_credential_id: Maybe<Scalars['bigint']>;
  type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "alerts" */
export type AlertsAlertInstancesArgs = {
  distinct_on?: Maybe<Array<AlertInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertInstancesOrderBy>>;
  where?: Maybe<AlertInstancesBoolExp>;
};


/** columns and relationships of "alerts" */
export type AlertsAlertStatusesArgs = {
  distinct_on?: Maybe<Array<AlertStatusesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertStatusesOrderBy>>;
  where?: Maybe<AlertStatusesBoolExp>;
};


/** columns and relationships of "alerts" */
export type AlertsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AlertsAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "alerts". All fields are combined with a logical 'AND'. */
export type AlertsBoolExp = {
  _and?: Maybe<Array<AlertsBoolExp>>;
  _not?: Maybe<AlertsBoolExp>;
  _or?: Maybe<Array<AlertsBoolExp>>;
  alert_instances?: Maybe<AlertInstancesBoolExp>;
  alert_interval?: Maybe<BigintComparisonExp>;
  alert_statuses?: Maybe<AlertStatusesBoolExp>;
  config?: Maybe<JsonbComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  fatal_error_default?: Maybe<BooleanComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<NameComparisonExp>;
  pagerduty_credential?: Maybe<PagerdutyCredentialsBoolExp>;
  pagerduty_credential_id?: Maybe<BigintComparisonExp>;
  row_error_default?: Maybe<BooleanComparisonExp>;
  slack_credential?: Maybe<SlackCredentialsBoolExp>;
  slack_credential_id?: Maybe<BigintComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "alerts" */
export const AlertsConstraint = {
  /** unique or primary key constraint */
  AlertsPkey: 'alerts_pkey'
} as const;

export type AlertsConstraint = typeof AlertsConstraint[keyof typeof AlertsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AlertsDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AlertsDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AlertsDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "alerts" */
export type AlertsIncInput = {
  alert_interval?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  pagerduty_credential_id?: Maybe<Scalars['bigint']>;
  slack_credential_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "alerts" */
export type AlertsInsertInput = {
  alert_instances?: Maybe<AlertInstancesArrRelInsertInput>;
  alert_interval?: Maybe<Scalars['bigint']>;
  config?: Maybe<Scalars['jsonb']>;
  created_by?: Maybe<Scalars['bigint']>;
  fatal_error_default?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['name']>;
  pagerduty_credential?: Maybe<PagerdutyCredentialsObjRelInsertInput>;
  pagerduty_credential_id?: Maybe<Scalars['bigint']>;
  row_error_default?: Maybe<Scalars['Boolean']>;
  slack_credential_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "alerts" */
export type AlertsMutationResponse = {
  __typename?: 'alerts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Alerts>;
};

/** input type for inserting object relation for remote table "alerts" */
export type AlertsObjRelInsertInput = {
  data: AlertsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AlertsOnConflict>;
};

/** on conflict condition type for table "alerts" */
export type AlertsOnConflict = {
  constraint: AlertsConstraint;
  update_columns?: Array<AlertsUpdateColumn>;
  where?: Maybe<AlertsBoolExp>;
};

/** Ordering options when selecting data from "alerts". */
export type AlertsOrderBy = {
  alert_instances_aggregate?: Maybe<AlertInstancesAggregateOrderBy>;
  alert_interval?: Maybe<OrderBy>;
  alert_statuses_aggregate?: Maybe<AlertStatusesAggregateOrderBy>;
  config?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  fatal_error_default?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  pagerduty_credential?: Maybe<PagerdutyCredentialsOrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_error_default?: Maybe<OrderBy>;
  slack_credential?: Maybe<SlackCredentialsOrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: alerts */
export type AlertsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AlertsPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "alerts" */
export const AlertsSelectColumn = {
  /** column name */
  AlertInterval: 'alert_interval',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  FatalErrorDefault: 'fatal_error_default',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PagerdutyCredentialId: 'pagerduty_credential_id',
  /** column name */
  RowErrorDefault: 'row_error_default',
  /** column name */
  SlackCredentialId: 'slack_credential_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AlertsSelectColumn = typeof AlertsSelectColumn[keyof typeof AlertsSelectColumn];
/** input type for updating data in table "alerts" */
export type AlertsSetInput = {
  alert_interval?: Maybe<Scalars['bigint']>;
  config?: Maybe<Scalars['jsonb']>;
  created_by?: Maybe<Scalars['bigint']>;
  fatal_error_default?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['name']>;
  pagerduty_credential_id?: Maybe<Scalars['bigint']>;
  row_error_default?: Maybe<Scalars['Boolean']>;
  slack_credential_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "alerts" */
export const AlertsUpdateColumn = {
  /** column name */
  AlertInterval: 'alert_interval',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  FatalErrorDefault: 'fatal_error_default',
  /** column name */
  Name: 'name',
  /** column name */
  PagerdutyCredentialId: 'pagerduty_credential_id',
  /** column name */
  RowErrorDefault: 'row_error_default',
  /** column name */
  SlackCredentialId: 'slack_credential_id',
  /** column name */
  Type: 'type'
} as const;

export type AlertsUpdateColumn = typeof AlertsUpdateColumn[keyof typeof AlertsUpdateColumn];
/** columns and relationships of "api_keys" */
export type ApiKeys = {
  __typename?: 'api_keys';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  last_used: Maybe<Scalars['timestamptz']>;
  name: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "api_keys". All fields are combined with a logical 'AND'. */
export type ApiKeysBoolExp = {
  _and?: Maybe<Array<ApiKeysBoolExp>>;
  _not?: Maybe<ApiKeysBoolExp>;
  _or?: Maybe<Array<ApiKeysBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  last_used?: Maybe<TimestamptzComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** input type for inserting data into table "api_keys" */
export type ApiKeysInsertInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  last_used?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "api_keys" */
export type ApiKeysMutationResponse = {
  __typename?: 'api_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApiKeys>;
};

/** Ordering options when selecting data from "api_keys". */
export type ApiKeysOrderBy = {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_used?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "api_keys" */
export const ApiKeysSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  LastUsed: 'last_used',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ApiKeysSelectColumn = typeof ApiKeysSelectColumn[keyof typeof ApiKeysSelectColumn];
/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "billing_products" */
export type BillingProducts = {
  __typename?: 'billing_products';
  entitlements: Scalars['jsonb'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  sku: Scalars['String'];
};


/** columns and relationships of "billing_products" */
export type BillingProductsEntitlementsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "billing_products". All fields are combined with a logical 'AND'. */
export type BillingProductsBoolExp = {
  _and?: Maybe<Array<BillingProductsBoolExp>>;
  _not?: Maybe<BillingProductsBoolExp>;
  _or?: Maybe<Array<BillingProductsBoolExp>>;
  entitlements?: Maybe<JsonbComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  sku?: Maybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "billing_products". */
export type BillingProductsOrderBy = {
  entitlements?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  sku?: Maybe<OrderBy>;
};

/** select columns of table "billing_products" */
export const BillingProductsSelectColumn = {
  /** column name */
  Entitlements: 'entitlements',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Sku: 'sku'
} as const;

export type BillingProductsSelectColumn = typeof BillingProductsSelectColumn[keyof typeof BillingProductsSelectColumn];
/** columns and relationships of "cloud_credentials" */
export type CloudCredentials = {
  __typename?: 'cloud_credentials';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  provider: Scalars['String'];
  /** A computed field, executes function "cloud_credential_stripped_config" */
  stripped_config: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
};


/** columns and relationships of "cloud_credentials" */
export type CloudCredentialsStrippedConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CloudCredentialsAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "cloud_credentials". All fields are combined with a logical 'AND'. */
export type CloudCredentialsBoolExp = {
  _and?: Maybe<Array<CloudCredentialsBoolExp>>;
  _not?: Maybe<CloudCredentialsBoolExp>;
  _or?: Maybe<Array<CloudCredentialsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  provider?: Maybe<StringComparisonExp>;
  stripped_config?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
};

/** unique or primary key constraints on table "cloud_credentials" */
export const CloudCredentialsConstraint = {
  /** unique or primary key constraint */
  CloudCredentialsPkey: 'cloud_credentials_pkey',
  /** unique or primary key constraint */
  CloudCredentialsWorkspaceIdIdKey: 'cloud_credentials_workspace_id_id_key',
  /** unique or primary key constraint */
  CloudCredentialsWorkspaceIdProviderNameKey: 'cloud_credentials_workspace_id_provider_name_key'
} as const;

export type CloudCredentialsConstraint = typeof CloudCredentialsConstraint[keyof typeof CloudCredentialsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CloudCredentialsDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CloudCredentialsDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CloudCredentialsDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "cloud_credentials" */
export type CloudCredentialsInsertInput = {
  config?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cloud_credentials" */
export type CloudCredentialsMutationResponse = {
  __typename?: 'cloud_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CloudCredentials>;
};

/** input type for inserting object relation for remote table "cloud_credentials" */
export type CloudCredentialsObjRelInsertInput = {
  data: CloudCredentialsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<CloudCredentialsOnConflict>;
};

/** on conflict condition type for table "cloud_credentials" */
export type CloudCredentialsOnConflict = {
  constraint: CloudCredentialsConstraint;
  update_columns?: Array<CloudCredentialsUpdateColumn>;
  where?: Maybe<CloudCredentialsBoolExp>;
};

/** Ordering options when selecting data from "cloud_credentials". */
export type CloudCredentialsOrderBy = {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  provider?: Maybe<OrderBy>;
  stripped_config?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
};

/** primary key columns input for table: cloud_credentials */
export type CloudCredentialsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CloudCredentialsPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "cloud_credentials" */
export const CloudCredentialsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Provider: 'provider',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type CloudCredentialsSelectColumn = typeof CloudCredentialsSelectColumn[keyof typeof CloudCredentialsSelectColumn];
/** input type for updating data in table "cloud_credentials" */
export type CloudCredentialsSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "cloud_credentials" */
export const CloudCredentialsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Name: 'name'
} as const;

export type CloudCredentialsUpdateColumn = typeof CloudCredentialsUpdateColumn[keyof typeof CloudCredentialsUpdateColumn];
/** columns and relationships of "column_selectors" */
export type ColumnSelectors = {
  __typename?: 'column_selectors';
  id: Scalars['bigint'];
  key: Maybe<Scalars['String']>;
  /** An object relationship */
  object_definition: Maybe<ObjectDefinitions>;
  object_definition_id: Maybe<Scalars['bigint']>;
  /** An object relationship */
  object_schema: Maybe<ObjectSchemas>;
  order: Maybe<Scalars['Int']>;
  parent_is_customer_company: Scalars['Boolean'];
  /** An object relationship */
  parent_object_definition: Maybe<ObjectDefinitions>;
  parent_object_definition_id: Maybe<Scalars['bigint']>;
  /** An object relationship */
  parent_saved_query: Maybe<SavedQueries>;
  parent_saved_query_id: Maybe<Scalars['bigint']>;
  related_object_definition_name: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "column_selectors". All fields are combined with a logical 'AND'. */
export type ColumnSelectorsBoolExp = {
  _and?: Maybe<Array<ColumnSelectorsBoolExp>>;
  _not?: Maybe<ColumnSelectorsBoolExp>;
  _or?: Maybe<Array<ColumnSelectorsBoolExp>>;
  id?: Maybe<BigintComparisonExp>;
  key?: Maybe<StringComparisonExp>;
  object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  object_definition_id?: Maybe<BigintComparisonExp>;
  object_schema?: Maybe<ObjectSchemasBoolExp>;
  order?: Maybe<IntComparisonExp>;
  parent_is_customer_company?: Maybe<BooleanComparisonExp>;
  parent_object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  parent_object_definition_id?: Maybe<BigintComparisonExp>;
  parent_saved_query?: Maybe<SavedQueriesBoolExp>;
  parent_saved_query_id?: Maybe<BigintComparisonExp>;
  related_object_definition_name?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "column_selectors" */
export const ColumnSelectorsConstraint = {
  /** unique or primary key constraint */
  ColumnSelectorsObjectDefinitionIdKeyParentObjectDefinit: 'column_selectors_object_definition_id_key_parent_object_definit',
  /** unique or primary key constraint */
  ColumnSelectorsPkey: 'column_selectors_pkey'
} as const;

export type ColumnSelectorsConstraint = typeof ColumnSelectorsConstraint[keyof typeof ColumnSelectorsConstraint];
/** input type for incrementing numeric columns in table "column_selectors" */
export type ColumnSelectorsIncInput = {
  object_definition_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['Int']>;
  parent_object_definition_id?: Maybe<Scalars['bigint']>;
  parent_saved_query_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "column_selectors" */
export type ColumnSelectorsInsertInput = {
  key?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  object_schema?: Maybe<ObjectSchemasObjRelInsertInput>;
  order?: Maybe<Scalars['Int']>;
  parent_is_customer_company?: Maybe<Scalars['Boolean']>;
  parent_object_definition_id?: Maybe<Scalars['bigint']>;
  parent_saved_query?: Maybe<SavedQueriesObjRelInsertInput>;
  parent_saved_query_id?: Maybe<Scalars['bigint']>;
  related_object_definition_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "column_selectors" */
export type ColumnSelectorsMutationResponse = {
  __typename?: 'column_selectors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ColumnSelectors>;
};

/** on conflict condition type for table "column_selectors" */
export type ColumnSelectorsOnConflict = {
  constraint: ColumnSelectorsConstraint;
  update_columns?: Array<ColumnSelectorsUpdateColumn>;
  where?: Maybe<ColumnSelectorsBoolExp>;
};

/** Ordering options when selecting data from "column_selectors". */
export type ColumnSelectorsOrderBy = {
  id?: Maybe<OrderBy>;
  key?: Maybe<OrderBy>;
  object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  object_schema?: Maybe<ObjectSchemasOrderBy>;
  order?: Maybe<OrderBy>;
  parent_is_customer_company?: Maybe<OrderBy>;
  parent_object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  parent_object_definition_id?: Maybe<OrderBy>;
  parent_saved_query?: Maybe<SavedQueriesOrderBy>;
  parent_saved_query_id?: Maybe<OrderBy>;
  related_object_definition_name?: Maybe<OrderBy>;
};

/** primary key columns input for table: column_selectors */
export type ColumnSelectorsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "column_selectors" */
export const ColumnSelectorsSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Order: 'order',
  /** column name */
  ParentIsCustomerCompany: 'parent_is_customer_company',
  /** column name */
  ParentObjectDefinitionId: 'parent_object_definition_id',
  /** column name */
  ParentSavedQueryId: 'parent_saved_query_id',
  /** column name */
  RelatedObjectDefinitionName: 'related_object_definition_name'
} as const;

export type ColumnSelectorsSelectColumn = typeof ColumnSelectorsSelectColumn[keyof typeof ColumnSelectorsSelectColumn];
/** input type for updating data in table "column_selectors" */
export type ColumnSelectorsSetInput = {
  key?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  order?: Maybe<Scalars['Int']>;
  parent_is_customer_company?: Maybe<Scalars['Boolean']>;
  parent_object_definition_id?: Maybe<Scalars['bigint']>;
  parent_saved_query_id?: Maybe<Scalars['bigint']>;
  related_object_definition_name?: Maybe<Scalars['String']>;
};

/** update columns of table "column_selectors" */
export const ColumnSelectorsUpdateColumn = {
  /** column name */
  Key: 'key',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Order: 'order',
  /** column name */
  ParentIsCustomerCompany: 'parent_is_customer_company',
  /** column name */
  ParentObjectDefinitionId: 'parent_object_definition_id',
  /** column name */
  ParentSavedQueryId: 'parent_saved_query_id',
  /** column name */
  RelatedObjectDefinitionName: 'related_object_definition_name'
} as const;

export type ColumnSelectorsUpdateColumn = typeof ColumnSelectorsUpdateColumn[keyof typeof ColumnSelectorsUpdateColumn];
/** columns and relationships of "connections" */
export type Connections = {
  __typename?: 'connections';
  autorun: Maybe<Scalars['Boolean']>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  credential_id: Maybe<Scalars['bigint']>;
  /** An array relationship */
  default_workspaces: Array<Workspaces>;
  definition: SourceDefinition;
  id: Scalars['bigint'];
  is_demo: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  plan_in_warehouse: Scalars['Boolean'];
  plan_in_warehouse_config: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  sample_data_source: Maybe<SampleDataSources>;
  sample_data_source_id: Maybe<Scalars['uuid']>;
  setup_complete: Scalars['Boolean'];
  slug: Maybe<Scalars['String']>;
  state: Maybe<Scalars['jsonb']>;
  stripped_config: Scalars['JSONObject'];
  tags: Scalars['jsonb'];
  /** An object relationship */
  tunnel: Maybe<Tunnels>;
  tunnel_id: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "connections" */
export type ConnectionsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsDefaultWorkspacesArgs = {
  distinct_on?: Maybe<Array<WorkspacesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WorkspacesOrderBy>>;
  where?: Maybe<WorkspacesBoolExp>;
};


/** columns and relationships of "connections" */
export type ConnectionsPlanInWarehouseConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsStateArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsTagsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "connections" */
export type ConnectionsAggregate = {
  __typename?: 'connections_aggregate';
  aggregate: Maybe<ConnectionsAggregateFields>;
  nodes: Array<Connections>;
};

/** aggregate fields of "connections" */
export type ConnectionsAggregateFields = {
  __typename?: 'connections_aggregate_fields';
  avg: Maybe<ConnectionsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ConnectionsMaxFields>;
  min: Maybe<ConnectionsMinFields>;
  stddev: Maybe<ConnectionsStddevFields>;
  stddev_pop: Maybe<ConnectionsStddevPopFields>;
  stddev_samp: Maybe<ConnectionsStddevSampFields>;
  sum: Maybe<ConnectionsSumFields>;
  var_pop: Maybe<ConnectionsVarPopFields>;
  var_samp: Maybe<ConnectionsVarSampFields>;
  variance: Maybe<ConnectionsVarianceFields>;
};


/** aggregate fields of "connections" */
export type ConnectionsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ConnectionsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ConnectionsAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
  plan_in_warehouse_config?: Maybe<Scalars['jsonb']>;
  state?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ConnectionsAvgFields = {
  __typename?: 'connections_avg_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "connections". All fields are combined with a logical 'AND'. */
export type ConnectionsBoolExp = {
  _and?: Maybe<Array<ConnectionsBoolExp>>;
  _not?: Maybe<ConnectionsBoolExp>;
  _or?: Maybe<Array<ConnectionsBoolExp>>;
  autorun?: Maybe<BooleanComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  created_by_user?: Maybe<UsersBoolExp>;
  credential_id?: Maybe<BigintComparisonExp>;
  default_workspaces?: Maybe<WorkspacesBoolExp>;
  id?: Maybe<BigintComparisonExp>;
  is_demo?: Maybe<BooleanComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  plan_in_warehouse?: Maybe<BooleanComparisonExp>;
  plan_in_warehouse_config?: Maybe<JsonbComparisonExp>;
  sample_data_source?: Maybe<SampleDataSourcesBoolExp>;
  sample_data_source_id?: Maybe<UuidComparisonExp>;
  setup_complete?: Maybe<BooleanComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  state?: Maybe<JsonbComparisonExp>;
  tags?: Maybe<JsonbComparisonExp>;
  tunnel?: Maybe<TunnelsBoolExp>;
  tunnel_id?: Maybe<UuidComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  updated_by_user?: Maybe<UsersBoolExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "connections" */
export const ConnectionsConstraint = {
  /** unique or primary key constraint */
  ConnectionsPkey: 'connections_pkey',
  /** unique or primary key constraint */
  ConnectionsSlugWorkspaceIdKey: 'connections_slug_workspace_id_key'
} as const;

export type ConnectionsConstraint = typeof ConnectionsConstraint[keyof typeof ConnectionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ConnectionsDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
  plan_in_warehouse_config?: Maybe<Array<Scalars['String']>>;
  state?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ConnectionsDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
  plan_in_warehouse_config?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ConnectionsDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
  plan_in_warehouse_config?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "connections" */
export type ConnectionsIncInput = {
  credential_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "connections" */
export type ConnectionsInsertInput = {
  autorun?: Maybe<Scalars['Boolean']>;
  config?: Maybe<Scalars['jsonb']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  is_demo?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plan_in_warehouse?: Maybe<Scalars['Boolean']>;
  plan_in_warehouse_config?: Maybe<Scalars['jsonb']>;
  sample_data_source_id?: Maybe<Scalars['uuid']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  tunnel?: Maybe<TunnelsObjRelInsertInput>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ConnectionsMaxFields = {
  __typename?: 'connections_max_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  name: Maybe<Scalars['String']>;
  sample_data_source_id: Maybe<Scalars['uuid']>;
  slug: Maybe<Scalars['String']>;
  tunnel_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ConnectionsMinFields = {
  __typename?: 'connections_min_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  name: Maybe<Scalars['String']>;
  sample_data_source_id: Maybe<Scalars['uuid']>;
  slug: Maybe<Scalars['String']>;
  tunnel_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "connections" */
export type ConnectionsMutationResponse = {
  __typename?: 'connections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Connections>;
};

/** input type for inserting object relation for remote table "connections" */
export type ConnectionsObjRelInsertInput = {
  data: ConnectionsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<ConnectionsOnConflict>;
};

/** on conflict condition type for table "connections" */
export type ConnectionsOnConflict = {
  constraint: ConnectionsConstraint;
  update_columns?: Array<ConnectionsUpdateColumn>;
  where?: Maybe<ConnectionsBoolExp>;
};

/** Ordering options when selecting data from "connections". */
export type ConnectionsOrderBy = {
  autorun?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  created_by_user?: Maybe<UsersOrderBy>;
  credential_id?: Maybe<OrderBy>;
  default_workspaces_aggregate?: Maybe<WorkspacesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  is_demo?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  plan_in_warehouse?: Maybe<OrderBy>;
  plan_in_warehouse_config?: Maybe<OrderBy>;
  sample_data_source?: Maybe<SampleDataSourcesOrderBy>;
  sample_data_source_id?: Maybe<OrderBy>;
  setup_complete?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  tags?: Maybe<OrderBy>;
  tunnel?: Maybe<TunnelsOrderBy>;
  tunnel_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  updated_by_user?: Maybe<UsersOrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: connections */
export type ConnectionsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ConnectionsPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
  plan_in_warehouse_config?: Maybe<Scalars['jsonb']>;
  state?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "connections" */
export const ConnectionsSelectColumn = {
  /** column name */
  Autorun: 'autorun',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  IsDemo: 'is_demo',
  /** column name */
  Name: 'name',
  /** column name */
  PlanInWarehouse: 'plan_in_warehouse',
  /** column name */
  PlanInWarehouseConfig: 'plan_in_warehouse_config',
  /** column name */
  SampleDataSourceId: 'sample_data_source_id',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Slug: 'slug',
  /** column name */
  State: 'state',
  /** column name */
  Tags: 'tags',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ConnectionsSelectColumn = typeof ConnectionsSelectColumn[keyof typeof ConnectionsSelectColumn];
/** input type for updating data in table "connections" */
export type ConnectionsSetInput = {
  autorun?: Maybe<Scalars['Boolean']>;
  config?: Maybe<Scalars['jsonb']>;
  credential_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  plan_in_warehouse?: Maybe<Scalars['Boolean']>;
  plan_in_warehouse_config?: Maybe<Scalars['jsonb']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ConnectionsStddevFields = {
  __typename?: 'connections_stddev_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ConnectionsStddevPopFields = {
  __typename?: 'connections_stddev_pop_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ConnectionsStddevSampFields = {
  __typename?: 'connections_stddev_samp_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type ConnectionsSumFields = {
  __typename?: 'connections_sum_fields';
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** update columns of table "connections" */
export const ConnectionsUpdateColumn = {
  /** column name */
  Autorun: 'autorun',
  /** column name */
  Config: 'config',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Name: 'name',
  /** column name */
  PlanInWarehouse: 'plan_in_warehouse',
  /** column name */
  PlanInWarehouseConfig: 'plan_in_warehouse_config',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Slug: 'slug',
  /** column name */
  State: 'state',
  /** column name */
  Tags: 'tags',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type ConnectionsUpdateColumn = typeof ConnectionsUpdateColumn[keyof typeof ConnectionsUpdateColumn];
/** aggregate var_pop on columns */
export type ConnectionsVarPopFields = {
  __typename?: 'connections_var_pop_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ConnectionsVarSampFields = {
  __typename?: 'connections_var_samp_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ConnectionsVarianceFields = {
  __typename?: 'connections_variance_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "datadog_credentials" */
export type DatadogCredentials = {
  __typename?: 'datadog_credentials';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  site: Scalars['String'];
  workspace_id: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "datadog_credentials". All fields are combined with a logical 'AND'. */
export type DatadogCredentialsBoolExp = {
  _and?: Maybe<Array<DatadogCredentialsBoolExp>>;
  _not?: Maybe<DatadogCredentialsBoolExp>;
  _or?: Maybe<Array<DatadogCredentialsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  site?: Maybe<StringComparisonExp>;
  workspace_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "datadog_credentials" */
export const DatadogCredentialsConstraint = {
  /** unique or primary key constraint */
  DatadogCredentialsPkey: 'datadog_credentials_pkey'
} as const;

export type DatadogCredentialsConstraint = typeof DatadogCredentialsConstraint[keyof typeof DatadogCredentialsConstraint];
/** input type for inserting data into table "datadog_credentials" */
export type DatadogCredentialsInsertInput = {
  api_key?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "datadog_credentials" */
export type DatadogCredentialsMutationResponse = {
  __typename?: 'datadog_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DatadogCredentials>;
};

/** on conflict condition type for table "datadog_credentials" */
export type DatadogCredentialsOnConflict = {
  constraint: DatadogCredentialsConstraint;
  update_columns?: Array<DatadogCredentialsUpdateColumn>;
  where?: Maybe<DatadogCredentialsBoolExp>;
};

/** Ordering options when selecting data from "datadog_credentials". */
export type DatadogCredentialsOrderBy = {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  site?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: datadog_credentials */
export type DatadogCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "datadog_credentials" */
export const DatadogCredentialsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Site: 'site',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DatadogCredentialsSelectColumn = typeof DatadogCredentialsSelectColumn[keyof typeof DatadogCredentialsSelectColumn];
/** input type for updating data in table "datadog_credentials" */
export type DatadogCredentialsSetInput = {
  api_key?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
};

/** update columns of table "datadog_credentials" */
export const DatadogCredentialsUpdateColumn = {
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  Site: 'site'
} as const;

export type DatadogCredentialsUpdateColumn = typeof DatadogCredentialsUpdateColumn[keyof typeof DatadogCredentialsUpdateColumn];
/** columns and relationships of "dbt_credentials" */
export type DbtCredentials = {
  __typename?: 'dbt_credentials';
  api_key: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  subdomain: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
};

/** Boolean expression to filter rows from the table "dbt_credentials". All fields are combined with a logical 'AND'. */
export type DbtCredentialsBoolExp = {
  _and?: Maybe<Array<DbtCredentialsBoolExp>>;
  _not?: Maybe<DbtCredentialsBoolExp>;
  _or?: Maybe<Array<DbtCredentialsBoolExp>>;
  api_key?: Maybe<StringComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  subdomain?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
};

/** Ordering options when selecting data from "dbt_credentials". */
export type DbtCredentialsOrderBy = {
  api_key?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  subdomain?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
};

/** select columns of table "dbt_credentials" */
export const DbtCredentialsSelectColumn = {
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  Id: 'id',
  /** column name */
  Subdomain: 'subdomain'
} as const;

export type DbtCredentialsSelectColumn = typeof DbtCredentialsSelectColumn[keyof typeof DbtCredentialsSelectColumn];
/** columns and relationships of "dbt_models" */
export type DbtModels = {
  __typename?: 'dbt_models';
  alias: Maybe<Scalars['String']>;
  columns: Scalars['jsonb'];
  dbt_unique_id: Scalars['String'];
  description: Scalars['String'];
  /** An object relationship */
  git_sync_config: GitSyncConfig;
  git_sync_config_id: Scalars['Int'];
  id: Scalars['Int'];
  last_commit_synced: Scalars['String'];
  name: Scalars['String'];
  original_file_path: Maybe<Scalars['String']>;
  removed: Scalars['Boolean'];
};


/** columns and relationships of "dbt_models" */
export type DbtModelsColumnsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "dbt_models" */
export type DbtModelsAggregateOrderBy = {
  avg?: Maybe<DbtModelsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<DbtModelsMaxOrderBy>;
  min?: Maybe<DbtModelsMinOrderBy>;
  stddev?: Maybe<DbtModelsStddevOrderBy>;
  stddev_pop?: Maybe<DbtModelsStddevPopOrderBy>;
  stddev_samp?: Maybe<DbtModelsStddevSampOrderBy>;
  sum?: Maybe<DbtModelsSumOrderBy>;
  var_pop?: Maybe<DbtModelsVarPopOrderBy>;
  var_samp?: Maybe<DbtModelsVarSampOrderBy>;
  variance?: Maybe<DbtModelsVarianceOrderBy>;
};

/** order by avg() on columns of table "dbt_models" */
export type DbtModelsAvgOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "dbt_models". All fields are combined with a logical 'AND'. */
export type DbtModelsBoolExp = {
  _and?: Maybe<Array<DbtModelsBoolExp>>;
  _not?: Maybe<DbtModelsBoolExp>;
  _or?: Maybe<Array<DbtModelsBoolExp>>;
  alias?: Maybe<StringComparisonExp>;
  columns?: Maybe<JsonbComparisonExp>;
  dbt_unique_id?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  git_sync_config?: Maybe<GitSyncConfigBoolExp>;
  git_sync_config_id?: Maybe<IntComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  last_commit_synced?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  original_file_path?: Maybe<StringComparisonExp>;
  removed?: Maybe<BooleanComparisonExp>;
};

/** order by max() on columns of table "dbt_models" */
export type DbtModelsMaxOrderBy = {
  alias?: Maybe<OrderBy>;
  dbt_unique_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_commit_synced?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  original_file_path?: Maybe<OrderBy>;
};

/** order by min() on columns of table "dbt_models" */
export type DbtModelsMinOrderBy = {
  alias?: Maybe<OrderBy>;
  dbt_unique_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_commit_synced?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  original_file_path?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "dbt_models". */
export type DbtModelsOrderBy = {
  alias?: Maybe<OrderBy>;
  columns?: Maybe<OrderBy>;
  dbt_unique_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  git_sync_config?: Maybe<GitSyncConfigOrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_commit_synced?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  original_file_path?: Maybe<OrderBy>;
  removed?: Maybe<OrderBy>;
};

/** select columns of table "dbt_models" */
export const DbtModelsSelectColumn = {
  /** column name */
  Alias: 'alias',
  /** column name */
  Columns: 'columns',
  /** column name */
  DbtUniqueId: 'dbt_unique_id',
  /** column name */
  Description: 'description',
  /** column name */
  GitSyncConfigId: 'git_sync_config_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastCommitSynced: 'last_commit_synced',
  /** column name */
  Name: 'name',
  /** column name */
  OriginalFilePath: 'original_file_path',
  /** column name */
  Removed: 'removed'
} as const;

export type DbtModelsSelectColumn = typeof DbtModelsSelectColumn[keyof typeof DbtModelsSelectColumn];
/** order by stddev() on columns of table "dbt_models" */
export type DbtModelsStddevOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "dbt_models" */
export type DbtModelsStddevPopOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "dbt_models" */
export type DbtModelsStddevSampOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "dbt_models" */
export type DbtModelsSumOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "dbt_models" */
export type DbtModelsVarPopOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "dbt_models" */
export type DbtModelsVarSampOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "dbt_models" */
export type DbtModelsVarianceOrderBy = {
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfig = {
  __typename?: 'dbt_sync_config';
  branch: Scalars['String'];
  commit: Maybe<Scalars['String']>;
  /** An object relationship */
  connection: Connections;
  connection_id: Scalars['bigint'];
  default_schema: Scalars['String'];
  enabled: Scalars['Boolean'];
  env_vars: Maybe<Scalars['jsonb']>;
  error: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  git_credentials: GitCredentials;
  git_credentials_id: Scalars['bigint'];
  id: Scalars['bigint'];
  last_run_at: Maybe<Scalars['timestamptz']>;
  path: Maybe<Scalars['String']>;
  repository: Maybe<Scalars['String']>;
  selector: Maybe<Scalars['String']>;
  state: Maybe<Scalars['jsonb']>;
  target: Maybe<Scalars['String']>;
  version: Maybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigEnvVarsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigErrorArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigStateArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DbtSyncConfigAppendInput = {
  env_vars?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "dbt_sync_config". All fields are combined with a logical 'AND'. */
export type DbtSyncConfigBoolExp = {
  _and?: Maybe<Array<DbtSyncConfigBoolExp>>;
  _not?: Maybe<DbtSyncConfigBoolExp>;
  _or?: Maybe<Array<DbtSyncConfigBoolExp>>;
  branch?: Maybe<StringComparisonExp>;
  commit?: Maybe<StringComparisonExp>;
  connection?: Maybe<ConnectionsBoolExp>;
  connection_id?: Maybe<BigintComparisonExp>;
  default_schema?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  env_vars?: Maybe<JsonbComparisonExp>;
  error?: Maybe<JsonbComparisonExp>;
  git_credentials?: Maybe<GitCredentialsBoolExp>;
  git_credentials_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  last_run_at?: Maybe<TimestamptzComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  repository?: Maybe<StringComparisonExp>;
  selector?: Maybe<StringComparisonExp>;
  state?: Maybe<JsonbComparisonExp>;
  target?: Maybe<StringComparisonExp>;
  version?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "dbt_sync_config" */
export const DbtSyncConfigConstraint = {
  /** unique or primary key constraint */
  DbtSyncConfigPkey: 'dbt_sync_config_pkey'
} as const;

export type DbtSyncConfigConstraint = typeof DbtSyncConfigConstraint[keyof typeof DbtSyncConfigConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DbtSyncConfigDeleteAtPathInput = {
  env_vars?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DbtSyncConfigDeleteElemInput = {
  env_vars?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DbtSyncConfigDeleteKeyInput = {
  env_vars?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "dbt_sync_config" */
export type DbtSyncConfigIncInput = {
  connection_id?: Maybe<Scalars['bigint']>;
  git_credentials_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "dbt_sync_config" */
export type DbtSyncConfigInsertInput = {
  branch?: Maybe<Scalars['String']>;
  connection?: Maybe<ConnectionsObjRelInsertInput>;
  connection_id?: Maybe<Scalars['bigint']>;
  default_schema?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  env_vars?: Maybe<Scalars['jsonb']>;
  git_credentials?: Maybe<GitCredentialsObjRelInsertInput>;
  git_credentials_id?: Maybe<Scalars['bigint']>;
  path?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  selector?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "dbt_sync_config" */
export type DbtSyncConfigMutationResponse = {
  __typename?: 'dbt_sync_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DbtSyncConfig>;
};

/** on conflict condition type for table "dbt_sync_config" */
export type DbtSyncConfigOnConflict = {
  constraint: DbtSyncConfigConstraint;
  update_columns?: Array<DbtSyncConfigUpdateColumn>;
  where?: Maybe<DbtSyncConfigBoolExp>;
};

/** Ordering options when selecting data from "dbt_sync_config". */
export type DbtSyncConfigOrderBy = {
  branch?: Maybe<OrderBy>;
  commit?: Maybe<OrderBy>;
  connection?: Maybe<ConnectionsOrderBy>;
  connection_id?: Maybe<OrderBy>;
  default_schema?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  env_vars?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  git_credentials?: Maybe<GitCredentialsOrderBy>;
  git_credentials_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  repository?: Maybe<OrderBy>;
  selector?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  target?: Maybe<OrderBy>;
  version?: Maybe<OrderBy>;
};

/** primary key columns input for table: dbt_sync_config */
export type DbtSyncConfigPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DbtSyncConfigPrependInput = {
  env_vars?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "dbt_sync_config" */
export const DbtSyncConfigSelectColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  Commit: 'commit',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  DefaultSchema: 'default_schema',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EnvVars: 'env_vars',
  /** column name */
  Error: 'error',
  /** column name */
  GitCredentialsId: 'git_credentials_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository',
  /** column name */
  Selector: 'selector',
  /** column name */
  State: 'state',
  /** column name */
  Target: 'target',
  /** column name */
  Version: 'version'
} as const;

export type DbtSyncConfigSelectColumn = typeof DbtSyncConfigSelectColumn[keyof typeof DbtSyncConfigSelectColumn];
/** input type for updating data in table "dbt_sync_config" */
export type DbtSyncConfigSetInput = {
  branch?: Maybe<Scalars['String']>;
  connection_id?: Maybe<Scalars['bigint']>;
  default_schema?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  env_vars?: Maybe<Scalars['jsonb']>;
  git_credentials_id?: Maybe<Scalars['bigint']>;
  path?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  selector?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/** update columns of table "dbt_sync_config" */
export const DbtSyncConfigUpdateColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  DefaultSchema: 'default_schema',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EnvVars: 'env_vars',
  /** column name */
  GitCredentialsId: 'git_credentials_id',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository',
  /** column name */
  Selector: 'selector',
  /** column name */
  Target: 'target',
  /** column name */
  Version: 'version'
} as const;

export type DbtSyncConfigUpdateColumn = typeof DbtSyncConfigUpdateColumn[keyof typeof DbtSyncConfigUpdateColumn];
/** columns and relationships of "dbt_sync_models" */
export type DbtSyncModels = {
  __typename?: 'dbt_sync_models';
  data: Scalars['jsonb'];
  /** An object relationship */
  dbt_sync_config: DbtSyncConfig;
  dbt_sync_config_id: Scalars['bigint'];
  dbt_unique_id: Scalars['String'];
  id: Scalars['bigint'];
  last_commit_synced: Scalars['String'];
  name: Scalars['String'];
  removed: Scalars['Boolean'];
  schema: Scalars['String'];
};


/** columns and relationships of "dbt_sync_models" */
export type DbtSyncModelsDataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "dbt_sync_models". All fields are combined with a logical 'AND'. */
export type DbtSyncModelsBoolExp = {
  _and?: Maybe<Array<DbtSyncModelsBoolExp>>;
  _not?: Maybe<DbtSyncModelsBoolExp>;
  _or?: Maybe<Array<DbtSyncModelsBoolExp>>;
  data?: Maybe<JsonbComparisonExp>;
  dbt_sync_config?: Maybe<DbtSyncConfigBoolExp>;
  dbt_sync_config_id?: Maybe<BigintComparisonExp>;
  dbt_unique_id?: Maybe<StringComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  last_commit_synced?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  removed?: Maybe<BooleanComparisonExp>;
  schema?: Maybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "dbt_sync_models". */
export type DbtSyncModelsOrderBy = {
  data?: Maybe<OrderBy>;
  dbt_sync_config?: Maybe<DbtSyncConfigOrderBy>;
  dbt_sync_config_id?: Maybe<OrderBy>;
  dbt_unique_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_commit_synced?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  removed?: Maybe<OrderBy>;
  schema?: Maybe<OrderBy>;
};

/** select columns of table "dbt_sync_models" */
export const DbtSyncModelsSelectColumn = {
  /** column name */
  Data: 'data',
  /** column name */
  DbtSyncConfigId: 'dbt_sync_config_id',
  /** column name */
  DbtUniqueId: 'dbt_unique_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastCommitSynced: 'last_commit_synced',
  /** column name */
  Name: 'name',
  /** column name */
  Removed: 'removed',
  /** column name */
  Schema: 'schema'
} as const;

export type DbtSyncModelsSelectColumn = typeof DbtSyncModelsSelectColumn[keyof typeof DbtSyncModelsSelectColumn];
/** columns and relationships of "destination_instances" */
export type DestinationInstances = {
  __typename?: 'destination_instances';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  config: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  /** An object relationship */
  destination: Maybe<Destinations>;
  destination_id: Maybe<Scalars['bigint']>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  force_run: Scalars['Boolean'];
  full_resync: Maybe<Scalars['Boolean']>;
  id: Scalars['bigint'];
  last_run_at: Maybe<Scalars['timestamptz']>;
  monitoring: Maybe<Scalars['jsonb']>;
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  schedule: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  slug: Maybe<Scalars['String']>;
  /** A computed field, executes function "sync_status" */
  status: Maybe<Scalars['String']>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** An object relationship */
  sync_template: Maybe<SyncTemplates>;
  sync_template_id: Maybe<Scalars['Int']>;
  tags: Scalars['jsonb'];
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  warehouse_history_config: Maybe<Scalars['jsonb']>;
  workspace_id: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesAlertInstancesArgs = {
  distinct_on?: Maybe<Array<AlertInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertInstancesOrderBy>>;
  where?: Maybe<AlertInstancesBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesAlertStatusesArgs = {
  distinct_on?: Maybe<Array<AlertStatusesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertStatusesOrderBy>>;
  where?: Maybe<AlertStatusesBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesExternalSegmentsArgs = {
  distinct_on?: Maybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ExternalSegmentsOrderBy>>;
  where?: Maybe<ExternalSegmentsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesMonitoringArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesScheduleArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncRequestsArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesTagsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesWarehouseHistoryConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "destination_instances" */
export type DestinationInstancesAggregateOrderBy = {
  avg?: Maybe<DestinationInstancesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<DestinationInstancesMaxOrderBy>;
  min?: Maybe<DestinationInstancesMinOrderBy>;
  stddev?: Maybe<DestinationInstancesStddevOrderBy>;
  stddev_pop?: Maybe<DestinationInstancesStddevPopOrderBy>;
  stddev_samp?: Maybe<DestinationInstancesStddevSampOrderBy>;
  sum?: Maybe<DestinationInstancesSumOrderBy>;
  var_pop?: Maybe<DestinationInstancesVarPopOrderBy>;
  var_samp?: Maybe<DestinationInstancesVarSampOrderBy>;
  variance?: Maybe<DestinationInstancesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DestinationInstancesAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  schedule?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "destination_instances" */
export type DestinationInstancesArrRelInsertInput = {
  data: Array<DestinationInstancesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<DestinationInstancesOnConflict>;
};

/** order by avg() on columns of table "destination_instances" */
export type DestinationInstancesAvgOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "destination_instances". All fields are combined with a logical 'AND'. */
export type DestinationInstancesBoolExp = {
  _and?: Maybe<Array<DestinationInstancesBoolExp>>;
  _not?: Maybe<DestinationInstancesBoolExp>;
  _or?: Maybe<Array<DestinationInstancesBoolExp>>;
  alert_instances?: Maybe<AlertInstancesBoolExp>;
  alert_statuses?: Maybe<AlertStatusesBoolExp>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  created_by_user?: Maybe<UsersBoolExp>;
  destination?: Maybe<DestinationsBoolExp>;
  destination_id?: Maybe<BigintComparisonExp>;
  external_segments?: Maybe<ExternalSegmentsBoolExp>;
  force_run?: Maybe<BooleanComparisonExp>;
  full_resync?: Maybe<BooleanComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  last_run_at?: Maybe<TimestamptzComparisonExp>;
  monitoring?: Maybe<JsonbComparisonExp>;
  row_threshold_attempted?: Maybe<BigintComparisonExp>;
  row_threshold_total?: Maybe<BigintComparisonExp>;
  schedule?: Maybe<JsonbComparisonExp>;
  schedule_paused?: Maybe<BooleanComparisonExp>;
  segment?: Maybe<SegmentsBoolExp>;
  segment_id?: Maybe<BigintComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  sync_requests?: Maybe<SyncRequestsBoolExp>;
  sync_template?: Maybe<SyncTemplatesBoolExp>;
  sync_template_id?: Maybe<IntComparisonExp>;
  tags?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  updated_by_user?: Maybe<UsersBoolExp>;
  warehouse_history_config?: Maybe<JsonbComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "destination_instances" */
export const DestinationInstancesConstraint = {
  /** unique or primary key constraint */
  DestinationInstancesPkey: 'destination_instances_pkey',
  /** unique or primary key constraint */
  DestinationInstancesWorkspaceIdSlugKey: 'destination_instances_workspace_id_slug_key'
} as const;

export type DestinationInstancesConstraint = typeof DestinationInstancesConstraint[keyof typeof DestinationInstancesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DestinationInstancesDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
  monitoring?: Maybe<Array<Scalars['String']>>;
  schedule?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  warehouse_history_config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DestinationInstancesDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
  monitoring?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
  warehouse_history_config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DestinationInstancesDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
  monitoring?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  warehouse_history_config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "destination_instances" */
export type DestinationInstancesIncInput = {
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "destination_instances" */
export type DestinationInstancesInsertInput = {
  alert_instances?: Maybe<AlertInstancesArrRelInsertInput>;
  config?: Maybe<Scalars['jsonb']>;
  created_by?: Maybe<Scalars['bigint']>;
  destination?: Maybe<DestinationsObjRelInsertInput>;
  destination_id?: Maybe<Scalars['bigint']>;
  force_run?: Maybe<Scalars['Boolean']>;
  full_resync?: Maybe<Scalars['Boolean']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  segment?: Maybe<SegmentsObjRelInsertInput>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  sync_template?: Maybe<SyncTemplatesObjRelInsertInput>;
  sync_template_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['jsonb']>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "destination_instances" */
export type DestinationInstancesMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "destination_instances" */
export type DestinationInstancesMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "destination_instances" */
export type DestinationInstancesMutationResponse = {
  __typename?: 'destination_instances_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DestinationInstances>;
};

/** input type for inserting object relation for remote table "destination_instances" */
export type DestinationInstancesObjRelInsertInput = {
  data: DestinationInstancesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<DestinationInstancesOnConflict>;
};

/** on conflict condition type for table "destination_instances" */
export type DestinationInstancesOnConflict = {
  constraint: DestinationInstancesConstraint;
  update_columns?: Array<DestinationInstancesUpdateColumn>;
  where?: Maybe<DestinationInstancesBoolExp>;
};

/** Ordering options when selecting data from "destination_instances". */
export type DestinationInstancesOrderBy = {
  alert_instances_aggregate?: Maybe<AlertInstancesAggregateOrderBy>;
  alert_statuses_aggregate?: Maybe<AlertStatusesAggregateOrderBy>;
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  created_by_user?: Maybe<UsersOrderBy>;
  destination?: Maybe<DestinationsOrderBy>;
  destination_id?: Maybe<OrderBy>;
  external_segments_aggregate?: Maybe<ExternalSegmentsAggregateOrderBy>;
  force_run?: Maybe<OrderBy>;
  full_resync?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  monitoring?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  schedule?: Maybe<OrderBy>;
  schedule_paused?: Maybe<OrderBy>;
  segment?: Maybe<SegmentsOrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_requests_aggregate?: Maybe<SyncRequestsAggregateOrderBy>;
  sync_template?: Maybe<SyncTemplatesOrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  tags?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  updated_by_user?: Maybe<UsersOrderBy>;
  warehouse_history_config?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: destination_instances */
export type DestinationInstancesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DestinationInstancesPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  schedule?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "destination_instances" */
export const DestinationInstancesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DestinationInstancesSelectColumn = typeof DestinationInstancesSelectColumn[keyof typeof DestinationInstancesSelectColumn];
/** input type for updating data in table "destination_instances" */
export type DestinationInstancesSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  force_run?: Maybe<Scalars['Boolean']>;
  full_resync?: Maybe<Scalars['Boolean']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  updated_by?: Maybe<Scalars['bigint']>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "destination_instances" */
export type DestinationInstancesStddevOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "destination_instances" */
export type DestinationInstancesStddevPopOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "destination_instances" */
export type DestinationInstancesStddevSampOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "destination_instances" */
export type DestinationInstancesSumOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** update columns of table "destination_instances" */
export const DestinationInstancesUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config'
} as const;

export type DestinationInstancesUpdateColumn = typeof DestinationInstancesUpdateColumn[keyof typeof DestinationInstancesUpdateColumn];
/** order by var_pop() on columns of table "destination_instances" */
export type DestinationInstancesVarPopOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "destination_instances" */
export type DestinationInstancesVarSampOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "destination_instances" */
export type DestinationInstancesVarianceOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "destinations" */
export type Destinations = {
  __typename?: 'destinations';
  config: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  credential_id: Maybe<Scalars['bigint']>;
  definition: DestinationDefinition;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  id: Scalars['bigint'];
  name: Maybe<Scalars['String']>;
  setup_complete: Scalars['Boolean'];
  slug: Maybe<Scalars['String']>;
  stripped_config: Scalars['JSONObject'];
  tags: Scalars['jsonb'];
  type: Scalars['String'];
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "destinations" */
export type DestinationsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "destinations" */
export type DestinationsDestinationInstancesArgs = {
  distinct_on?: Maybe<Array<DestinationInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationInstancesOrderBy>>;
  where?: Maybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsTagsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "destinations" */
export type DestinationsAggregate = {
  __typename?: 'destinations_aggregate';
  aggregate: Maybe<DestinationsAggregateFields>;
  nodes: Array<Destinations>;
};

/** aggregate fields of "destinations" */
export type DestinationsAggregateFields = {
  __typename?: 'destinations_aggregate_fields';
  avg: Maybe<DestinationsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<DestinationsMaxFields>;
  min: Maybe<DestinationsMinFields>;
  stddev: Maybe<DestinationsStddevFields>;
  stddev_pop: Maybe<DestinationsStddevPopFields>;
  stddev_samp: Maybe<DestinationsStddevSampFields>;
  sum: Maybe<DestinationsSumFields>;
  var_pop: Maybe<DestinationsVarPopFields>;
  var_samp: Maybe<DestinationsVarSampFields>;
  variance: Maybe<DestinationsVarianceFields>;
};


/** aggregate fields of "destinations" */
export type DestinationsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<DestinationsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DestinationsAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type DestinationsAvgFields = {
  __typename?: 'destinations_avg_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "destinations". All fields are combined with a logical 'AND'. */
export type DestinationsBoolExp = {
  _and?: Maybe<Array<DestinationsBoolExp>>;
  _not?: Maybe<DestinationsBoolExp>;
  _or?: Maybe<Array<DestinationsBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  created_by_user?: Maybe<UsersBoolExp>;
  credential_id?: Maybe<BigintComparisonExp>;
  destination_instances?: Maybe<DestinationInstancesBoolExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  setup_complete?: Maybe<BooleanComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  tags?: Maybe<JsonbComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  updated_by_user?: Maybe<UsersBoolExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "destinations" */
export const DestinationsConstraint = {
  /** unique or primary key constraint */
  DestinationsPkey: 'destinations_pkey',
  /** unique or primary key constraint */
  DestinationsSlugWorkspaceIdKey: 'destinations_slug_workspace_id_key'
} as const;

export type DestinationsConstraint = typeof DestinationsConstraint[keyof typeof DestinationsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DestinationsDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DestinationsDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DestinationsDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "destinations" */
export type DestinationsIncInput = {
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "destinations" */
export type DestinationsInsertInput = {
  config?: Maybe<Scalars['jsonb']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  destination_instances?: Maybe<DestinationInstancesArrRelInsertInput>;
  encrypted_config?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type DestinationsMaxFields = {
  __typename?: 'destinations_max_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DestinationsMinFields = {
  __typename?: 'destinations_min_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "destinations" */
export type DestinationsMutationResponse = {
  __typename?: 'destinations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Destinations>;
};

/** input type for inserting object relation for remote table "destinations" */
export type DestinationsObjRelInsertInput = {
  data: DestinationsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<DestinationsOnConflict>;
};

/** on conflict condition type for table "destinations" */
export type DestinationsOnConflict = {
  constraint: DestinationsConstraint;
  update_columns?: Array<DestinationsUpdateColumn>;
  where?: Maybe<DestinationsBoolExp>;
};

/** Ordering options when selecting data from "destinations". */
export type DestinationsOrderBy = {
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  created_by_user?: Maybe<UsersOrderBy>;
  credential_id?: Maybe<OrderBy>;
  destination_instances_aggregate?: Maybe<DestinationInstancesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  setup_complete?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  tags?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  updated_by_user?: Maybe<UsersOrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: destinations */
export type DestinationsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DestinationsPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "destinations" */
export const DestinationsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DestinationsSelectColumn = typeof DestinationsSelectColumn[keyof typeof DestinationsSelectColumn];
/** input type for updating data in table "destinations" */
export type DestinationsSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type DestinationsStddevFields = {
  __typename?: 'destinations_stddev_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DestinationsStddevPopFields = {
  __typename?: 'destinations_stddev_pop_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DestinationsStddevSampFields = {
  __typename?: 'destinations_stddev_samp_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type DestinationsSumFields = {
  __typename?: 'destinations_sum_fields';
  created_by: Maybe<Scalars['bigint']>;
  credential_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** update columns of table "destinations" */
export const DestinationsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Name: 'name',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type DestinationsUpdateColumn = typeof DestinationsUpdateColumn[keyof typeof DestinationsUpdateColumn];
/** aggregate var_pop on columns */
export type DestinationsVarPopFields = {
  __typename?: 'destinations_var_pop_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DestinationsVarSampFields = {
  __typename?: 'destinations_var_samp_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DestinationsVarianceFields = {
  __typename?: 'destinations_variance_fields';
  created_by: Maybe<Scalars['Float']>;
  credential_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "direct_model_relationships" */
export type DirectModelRelationships = {
  __typename?: 'direct_model_relationships';
  from_column: Scalars['String'];
  from_model_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
  /** An object relationship */
  to_model: Segments;
  to_model_id: Scalars['bigint'];
};

/** order by aggregate values of table "direct_model_relationships" */
export type DirectModelRelationshipsAggregateOrderBy = {
  avg?: Maybe<DirectModelRelationshipsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<DirectModelRelationshipsMaxOrderBy>;
  min?: Maybe<DirectModelRelationshipsMinOrderBy>;
  stddev?: Maybe<DirectModelRelationshipsStddevOrderBy>;
  stddev_pop?: Maybe<DirectModelRelationshipsStddevPopOrderBy>;
  stddev_samp?: Maybe<DirectModelRelationshipsStddevSampOrderBy>;
  sum?: Maybe<DirectModelRelationshipsSumOrderBy>;
  var_pop?: Maybe<DirectModelRelationshipsVarPopOrderBy>;
  var_samp?: Maybe<DirectModelRelationshipsVarSampOrderBy>;
  variance?: Maybe<DirectModelRelationshipsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "direct_model_relationships" */
export type DirectModelRelationshipsArrRelInsertInput = {
  data: Array<DirectModelRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<DirectModelRelationshipsOnConflict>;
};

/** order by avg() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsAvgOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "direct_model_relationships". All fields are combined with a logical 'AND'. */
export type DirectModelRelationshipsBoolExp = {
  _and?: Maybe<Array<DirectModelRelationshipsBoolExp>>;
  _not?: Maybe<DirectModelRelationshipsBoolExp>;
  _or?: Maybe<Array<DirectModelRelationshipsBoolExp>>;
  from_column?: Maybe<StringComparisonExp>;
  from_model_id?: Maybe<BigintComparisonExp>;
  relationship_id?: Maybe<BigintComparisonExp>;
  to_column?: Maybe<StringComparisonExp>;
  to_model?: Maybe<SegmentsBoolExp>;
  to_model_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "direct_model_relationships" */
export const DirectModelRelationshipsConstraint = {
  /** unique or primary key constraint */
  DirectModelRelationshipsPkey: 'direct_model_relationships_pkey'
} as const;

export type DirectModelRelationshipsConstraint = typeof DirectModelRelationshipsConstraint[keyof typeof DirectModelRelationshipsConstraint];
/** input type for incrementing numeric columns in table "direct_model_relationships" */
export type DirectModelRelationshipsIncInput = {
  from_model_id?: Maybe<Scalars['bigint']>;
  to_model_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "direct_model_relationships" */
export type DirectModelRelationshipsInsertInput = {
  from_column?: Maybe<Scalars['String']>;
  from_model_id?: Maybe<Scalars['bigint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  to_column?: Maybe<Scalars['String']>;
  to_model?: Maybe<SegmentsObjRelInsertInput>;
  to_model_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsMaxOrderBy = {
  from_column?: Maybe<OrderBy>;
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsMinOrderBy = {
  from_column?: Maybe<OrderBy>;
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "direct_model_relationships" */
export type DirectModelRelationshipsMutationResponse = {
  __typename?: 'direct_model_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DirectModelRelationships>;
};

/** on conflict condition type for table "direct_model_relationships" */
export type DirectModelRelationshipsOnConflict = {
  constraint: DirectModelRelationshipsConstraint;
  update_columns?: Array<DirectModelRelationshipsUpdateColumn>;
  where?: Maybe<DirectModelRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "direct_model_relationships". */
export type DirectModelRelationshipsOrderBy = {
  from_column?: Maybe<OrderBy>;
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
  to_model?: Maybe<SegmentsOrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: direct_model_relationships */
export type DirectModelRelationshipsPkColumnsInput = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};

/** select columns of table "direct_model_relationships" */
export const DirectModelRelationshipsSelectColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type DirectModelRelationshipsSelectColumn = typeof DirectModelRelationshipsSelectColumn[keyof typeof DirectModelRelationshipsSelectColumn];
/** input type for updating data in table "direct_model_relationships" */
export type DirectModelRelationshipsSetInput = {
  from_column?: Maybe<Scalars['String']>;
  from_model_id?: Maybe<Scalars['bigint']>;
  to_column?: Maybe<Scalars['String']>;
  to_model_id?: Maybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsStddevOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsStddevPopOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsStddevSampOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsSumOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** update columns of table "direct_model_relationships" */
export const DirectModelRelationshipsUpdateColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type DirectModelRelationshipsUpdateColumn = typeof DirectModelRelationshipsUpdateColumn[keyof typeof DirectModelRelationshipsUpdateColumn];
/** order by var_pop() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsVarPopOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsVarSampOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsVarianceOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** columns and relationships of "event_definitions" */
export type EventDefinitions = {
  __typename?: 'event_definitions';
  /** An object relationship */
  actor_object_definition: ObjectDefinitions;
  actor_object_definition_id: Scalars['bigint'];
  event: Scalars['String'];
  from_column: Scalars['String'];
  /** An object relationship */
  object_definition: ObjectDefinitions;
  object_definition_id: Scalars['bigint'];
  timestamp_object_schema_key: Scalars['String'];
  to_column: Scalars['String'];
};

/** order by aggregate values of table "event_definitions" */
export type EventDefinitionsAggregateOrderBy = {
  avg?: Maybe<EventDefinitionsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<EventDefinitionsMaxOrderBy>;
  min?: Maybe<EventDefinitionsMinOrderBy>;
  stddev?: Maybe<EventDefinitionsStddevOrderBy>;
  stddev_pop?: Maybe<EventDefinitionsStddevPopOrderBy>;
  stddev_samp?: Maybe<EventDefinitionsStddevSampOrderBy>;
  sum?: Maybe<EventDefinitionsSumOrderBy>;
  var_pop?: Maybe<EventDefinitionsVarPopOrderBy>;
  var_samp?: Maybe<EventDefinitionsVarSampOrderBy>;
  variance?: Maybe<EventDefinitionsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_definitions" */
export type EventDefinitionsAvgOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_definitions". All fields are combined with a logical 'AND'. */
export type EventDefinitionsBoolExp = {
  _and?: Maybe<Array<EventDefinitionsBoolExp>>;
  _not?: Maybe<EventDefinitionsBoolExp>;
  _or?: Maybe<Array<EventDefinitionsBoolExp>>;
  actor_object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  actor_object_definition_id?: Maybe<BigintComparisonExp>;
  event?: Maybe<StringComparisonExp>;
  from_column?: Maybe<StringComparisonExp>;
  object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  object_definition_id?: Maybe<BigintComparisonExp>;
  timestamp_object_schema_key?: Maybe<StringComparisonExp>;
  to_column?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_definitions" */
export const EventDefinitionsConstraint = {
  /** unique or primary key constraint */
  EventDefinitionsPkey: 'event_definitions_pkey'
} as const;

export type EventDefinitionsConstraint = typeof EventDefinitionsConstraint[keyof typeof EventDefinitionsConstraint];
/** input type for incrementing numeric columns in table "event_definitions" */
export type EventDefinitionsIncInput = {
  actor_object_definition_id?: Maybe<Scalars['bigint']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "event_definitions" */
export type EventDefinitionsInsertInput = {
  actor_object_definition_id?: Maybe<Scalars['bigint']>;
  event?: Maybe<Scalars['String']>;
  from_column?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  timestamp_object_schema_key?: Maybe<Scalars['String']>;
  to_column?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "event_definitions" */
export type EventDefinitionsMaxOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  event?: Maybe<OrderBy>;
  from_column?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  timestamp_object_schema_key?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
};

/** order by min() on columns of table "event_definitions" */
export type EventDefinitionsMinOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  event?: Maybe<OrderBy>;
  from_column?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  timestamp_object_schema_key?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
};

/** response of any mutation on the table "event_definitions" */
export type EventDefinitionsMutationResponse = {
  __typename?: 'event_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventDefinitions>;
};

/** on conflict condition type for table "event_definitions" */
export type EventDefinitionsOnConflict = {
  constraint: EventDefinitionsConstraint;
  update_columns?: Array<EventDefinitionsUpdateColumn>;
  where?: Maybe<EventDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "event_definitions". */
export type EventDefinitionsOrderBy = {
  actor_object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  actor_object_definition_id?: Maybe<OrderBy>;
  event?: Maybe<OrderBy>;
  from_column?: Maybe<OrderBy>;
  object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  timestamp_object_schema_key?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
};

/** primary key columns input for table: event_definitions */
export type EventDefinitionsPkColumnsInput = {
  object_definition_id: Scalars['bigint'];
};

/** select columns of table "event_definitions" */
export const EventDefinitionsSelectColumn = {
  /** column name */
  ActorObjectDefinitionId: 'actor_object_definition_id',
  /** column name */
  Event: 'event',
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  TimestampObjectSchemaKey: 'timestamp_object_schema_key',
  /** column name */
  ToColumn: 'to_column'
} as const;

export type EventDefinitionsSelectColumn = typeof EventDefinitionsSelectColumn[keyof typeof EventDefinitionsSelectColumn];
/** input type for updating data in table "event_definitions" */
export type EventDefinitionsSetInput = {
  actor_object_definition_id?: Maybe<Scalars['bigint']>;
  event?: Maybe<Scalars['String']>;
  from_column?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  timestamp_object_schema_key?: Maybe<Scalars['String']>;
  to_column?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "event_definitions" */
export type EventDefinitionsStddevOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "event_definitions" */
export type EventDefinitionsStddevPopOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "event_definitions" */
export type EventDefinitionsStddevSampOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "event_definitions" */
export type EventDefinitionsSumOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** update columns of table "event_definitions" */
export const EventDefinitionsUpdateColumn = {
  /** column name */
  ActorObjectDefinitionId: 'actor_object_definition_id',
  /** column name */
  Event: 'event',
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  TimestampObjectSchemaKey: 'timestamp_object_schema_key',
  /** column name */
  ToColumn: 'to_column'
} as const;

export type EventDefinitionsUpdateColumn = typeof EventDefinitionsUpdateColumn[keyof typeof EventDefinitionsUpdateColumn];
/** order by var_pop() on columns of table "event_definitions" */
export type EventDefinitionsVarPopOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "event_definitions" */
export type EventDefinitionsVarSampOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "event_definitions" */
export type EventDefinitionsVarianceOrderBy = {
  actor_object_definition_id?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
};

/** columns and relationships of "event_models" */
export type EventModels = {
  __typename?: 'event_models';
  /** An object relationship */
  model: Segments;
  model_id: Scalars['bigint'];
  timestamp_column: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_models". All fields are combined with a logical 'AND'. */
export type EventModelsBoolExp = {
  _and?: Maybe<Array<EventModelsBoolExp>>;
  _not?: Maybe<EventModelsBoolExp>;
  _or?: Maybe<Array<EventModelsBoolExp>>;
  model?: Maybe<SegmentsBoolExp>;
  model_id?: Maybe<BigintComparisonExp>;
  timestamp_column?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_models" */
export const EventModelsConstraint = {
  /** unique or primary key constraint */
  EventModelsPkey: 'event_models_pkey'
} as const;

export type EventModelsConstraint = typeof EventModelsConstraint[keyof typeof EventModelsConstraint];
/** input type for inserting data into table "event_models" */
export type EventModelsInsertInput = {
  model?: Maybe<SegmentsObjRelInsertInput>;
  model_id?: Maybe<Scalars['bigint']>;
  timestamp_column?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_models" */
export type EventModelsMutationResponse = {
  __typename?: 'event_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventModels>;
};

/** input type for inserting object relation for remote table "event_models" */
export type EventModelsObjRelInsertInput = {
  data: EventModelsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<EventModelsOnConflict>;
};

/** on conflict condition type for table "event_models" */
export type EventModelsOnConflict = {
  constraint: EventModelsConstraint;
  update_columns?: Array<EventModelsUpdateColumn>;
  where?: Maybe<EventModelsBoolExp>;
};

/** Ordering options when selecting data from "event_models". */
export type EventModelsOrderBy = {
  model?: Maybe<SegmentsOrderBy>;
  model_id?: Maybe<OrderBy>;
  timestamp_column?: Maybe<OrderBy>;
};

/** primary key columns input for table: event_models */
export type EventModelsPkColumnsInput = {
  model_id: Scalars['bigint'];
};

/** select columns of table "event_models" */
export const EventModelsSelectColumn = {
  /** column name */
  ModelId: 'model_id',
  /** column name */
  TimestampColumn: 'timestamp_column'
} as const;

export type EventModelsSelectColumn = typeof EventModelsSelectColumn[keyof typeof EventModelsSelectColumn];
/** input type for updating data in table "event_models" */
export type EventModelsSetInput = {
  timestamp_column?: Maybe<Scalars['String']>;
};

/** update columns of table "event_models" */
export const EventModelsUpdateColumn = {
  /** column name */
  TimestampColumn: 'timestamp_column'
} as const;

export type EventModelsUpdateColumn = typeof EventModelsUpdateColumn[keyof typeof EventModelsUpdateColumn];
/** columns and relationships of "external_buckets" */
export type ExternalBuckets = {
  __typename?: 'external_buckets';
  /** An object relationship */
  cloud_credential: Maybe<CloudCredentials>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  credential_id: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "external_buckets" */
export type ExternalBucketsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExternalBucketsAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "external_buckets". All fields are combined with a logical 'AND'. */
export type ExternalBucketsBoolExp = {
  _and?: Maybe<Array<ExternalBucketsBoolExp>>;
  _not?: Maybe<ExternalBucketsBoolExp>;
  _or?: Maybe<Array<ExternalBucketsBoolExp>>;
  cloud_credential?: Maybe<CloudCredentialsBoolExp>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  credential_id?: Maybe<IntComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "external_buckets" */
export const ExternalBucketsConstraint = {
  /** unique or primary key constraint */
  ExternalBucketsPkey: 'external_buckets_pkey'
} as const;

export type ExternalBucketsConstraint = typeof ExternalBucketsConstraint[keyof typeof ExternalBucketsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExternalBucketsDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExternalBucketsDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExternalBucketsDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "external_buckets" */
export type ExternalBucketsIncInput = {
  credential_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "external_buckets" */
export type ExternalBucketsInsertInput = {
  cloud_credential?: Maybe<CloudCredentialsObjRelInsertInput>;
  config?: Maybe<Scalars['jsonb']>;
  credential_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "external_buckets" */
export type ExternalBucketsMutationResponse = {
  __typename?: 'external_buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalBuckets>;
};

/** on conflict condition type for table "external_buckets" */
export type ExternalBucketsOnConflict = {
  constraint: ExternalBucketsConstraint;
  update_columns?: Array<ExternalBucketsUpdateColumn>;
  where?: Maybe<ExternalBucketsBoolExp>;
};

/** Ordering options when selecting data from "external_buckets". */
export type ExternalBucketsOrderBy = {
  cloud_credential?: Maybe<CloudCredentialsOrderBy>;
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  credential_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: external_buckets */
export type ExternalBucketsPkColumnsInput = {
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExternalBucketsPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "external_buckets" */
export const ExternalBucketsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ExternalBucketsSelectColumn = typeof ExternalBucketsSelectColumn[keyof typeof ExternalBucketsSelectColumn];
/** input type for updating data in table "external_buckets" */
export type ExternalBucketsSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  credential_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "external_buckets" */
export const ExternalBucketsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Type: 'type'
} as const;

export type ExternalBucketsUpdateColumn = typeof ExternalBucketsUpdateColumn[keyof typeof ExternalBucketsUpdateColumn];
/** columns and relationships of "external_segments" */
export type ExternalSegments = {
  __typename?: 'external_segments';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination_instance: DestinationInstances;
  destination_instance_id: Scalars['bigint'];
  external_id: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  status: Scalars['String'];
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
};


/** columns and relationships of "external_segments" */
export type ExternalSegmentsSyncRequestsArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "external_segments" */
export type ExternalSegmentsSyncRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};

/** order by aggregate values of table "external_segments" */
export type ExternalSegmentsAggregateOrderBy = {
  avg?: Maybe<ExternalSegmentsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ExternalSegmentsMaxOrderBy>;
  min?: Maybe<ExternalSegmentsMinOrderBy>;
  stddev?: Maybe<ExternalSegmentsStddevOrderBy>;
  stddev_pop?: Maybe<ExternalSegmentsStddevPopOrderBy>;
  stddev_samp?: Maybe<ExternalSegmentsStddevSampOrderBy>;
  sum?: Maybe<ExternalSegmentsSumOrderBy>;
  var_pop?: Maybe<ExternalSegmentsVarPopOrderBy>;
  var_samp?: Maybe<ExternalSegmentsVarSampOrderBy>;
  variance?: Maybe<ExternalSegmentsVarianceOrderBy>;
};

/** order by avg() on columns of table "external_segments" */
export type ExternalSegmentsAvgOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "external_segments". All fields are combined with a logical 'AND'. */
export type ExternalSegmentsBoolExp = {
  _and?: Maybe<Array<ExternalSegmentsBoolExp>>;
  _not?: Maybe<ExternalSegmentsBoolExp>;
  _or?: Maybe<Array<ExternalSegmentsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  destination_instance?: Maybe<DestinationInstancesBoolExp>;
  destination_instance_id?: Maybe<BigintComparisonExp>;
  external_id?: Maybe<StringComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  sync_requests?: Maybe<SyncRequestsBoolExp>;
};

/** order by max() on columns of table "external_segments" */
export type ExternalSegmentsMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  external_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** order by min() on columns of table "external_segments" */
export type ExternalSegmentsMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  external_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** response of any mutation on the table "external_segments" */
export type ExternalSegmentsMutationResponse = {
  __typename?: 'external_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalSegments>;
};

/** Ordering options when selecting data from "external_segments". */
export type ExternalSegmentsOrderBy = {
  created_at?: Maybe<OrderBy>;
  destination_instance?: Maybe<DestinationInstancesOrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  external_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_requests_aggregate?: Maybe<SyncRequestsAggregateOrderBy>;
};

/** select columns of table "external_segments" */
export const ExternalSegmentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status'
} as const;

export type ExternalSegmentsSelectColumn = typeof ExternalSegmentsSelectColumn[keyof typeof ExternalSegmentsSelectColumn];
/** order by stddev() on columns of table "external_segments" */
export type ExternalSegmentsStddevOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "external_segments" */
export type ExternalSegmentsStddevPopOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "external_segments" */
export type ExternalSegmentsStddevSampOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "external_segments" */
export type ExternalSegmentsSumOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "external_segments" */
export type ExternalSegmentsVarPopOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "external_segments" */
export type ExternalSegmentsVarSampOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "external_segments" */
export type ExternalSegmentsVarianceOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** columns and relationships of "git_credentials" */
export type GitCredentials = {
  __typename?: 'git_credentials';
  credentials: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  repository: Maybe<Scalars['String']>;
  tunnel_id: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  username: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "git_credentials" */
export type GitCredentialsCredentialsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "git_credentials". All fields are combined with a logical 'AND'. */
export type GitCredentialsBoolExp = {
  _and?: Maybe<Array<GitCredentialsBoolExp>>;
  _not?: Maybe<GitCredentialsBoolExp>;
  _or?: Maybe<Array<GitCredentialsBoolExp>>;
  credentials?: Maybe<JsonbComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  repository?: Maybe<StringComparisonExp>;
  tunnel_id?: Maybe<UuidComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  username?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "git_credentials" */
export const GitCredentialsConstraint = {
  /** unique or primary key constraint */
  GitCredentialsPkey: 'git_credentials_pkey'
} as const;

export type GitCredentialsConstraint = typeof GitCredentialsConstraint[keyof typeof GitCredentialsConstraint];
/** input type for inserting data into table "git_credentials" */
export type GitCredentialsInsertInput = {
  password?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  ssh_privatekey?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "git_credentials" */
export type GitCredentialsMutationResponse = {
  __typename?: 'git_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GitCredentials>;
};

/** input type for inserting object relation for remote table "git_credentials" */
export type GitCredentialsObjRelInsertInput = {
  data: GitCredentialsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<GitCredentialsOnConflict>;
};

/** on conflict condition type for table "git_credentials" */
export type GitCredentialsOnConflict = {
  constraint: GitCredentialsConstraint;
  update_columns?: Array<GitCredentialsUpdateColumn>;
  where?: Maybe<GitCredentialsBoolExp>;
};

/** Ordering options when selecting data from "git_credentials". */
export type GitCredentialsOrderBy = {
  credentials?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  repository?: Maybe<OrderBy>;
  tunnel_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  username?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: git_credentials */
export type GitCredentialsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "git_credentials" */
export const GitCredentialsSelectColumn = {
  /** column name */
  Credentials: 'credentials',
  /** column name */
  Id: 'id',
  /** column name */
  Repository: 'repository',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  Username: 'username',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GitCredentialsSelectColumn = typeof GitCredentialsSelectColumn[keyof typeof GitCredentialsSelectColumn];
/** input type for updating data in table "git_credentials" */
export type GitCredentialsSetInput = {
  password?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  ssh_privatekey?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** update columns of table "git_credentials" */
export const GitCredentialsUpdateColumn = {
  /** column name */
  Password: 'password',
  /** column name */
  Repository: 'repository',
  /** column name */
  SshPrivatekey: 'ssh_privatekey',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  Username: 'username'
} as const;

export type GitCredentialsUpdateColumn = typeof GitCredentialsUpdateColumn[keyof typeof GitCredentialsUpdateColumn];
/** columns and relationships of "git_inbound_runs" */
export type GitInboundRuns = {
  __typename?: 'git_inbound_runs';
  affected_resources: Maybe<Scalars['jsonb']>;
  commit: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  error: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  git_outbound_run: GitOutboundRuns;
  git_outbound_run_id: Scalars['bigint'];
  /** An object relationship */
  git_sync_config: GitSyncConfigs;
  git_sync_config_id: Scalars['bigint'];
  id: Scalars['bigint'];
};


/** columns and relationships of "git_inbound_runs" */
export type GitInboundRunsAffectedResourcesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_inbound_runs" */
export type GitInboundRunsErrorArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "git_inbound_runs" */
export type GitInboundRunsAggregateOrderBy = {
  avg?: Maybe<GitInboundRunsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GitInboundRunsMaxOrderBy>;
  min?: Maybe<GitInboundRunsMinOrderBy>;
  stddev?: Maybe<GitInboundRunsStddevOrderBy>;
  stddev_pop?: Maybe<GitInboundRunsStddevPopOrderBy>;
  stddev_samp?: Maybe<GitInboundRunsStddevSampOrderBy>;
  sum?: Maybe<GitInboundRunsSumOrderBy>;
  var_pop?: Maybe<GitInboundRunsVarPopOrderBy>;
  var_samp?: Maybe<GitInboundRunsVarSampOrderBy>;
  variance?: Maybe<GitInboundRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "git_inbound_runs" */
export type GitInboundRunsAvgOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "git_inbound_runs". All fields are combined with a logical 'AND'. */
export type GitInboundRunsBoolExp = {
  _and?: Maybe<Array<GitInboundRunsBoolExp>>;
  _not?: Maybe<GitInboundRunsBoolExp>;
  _or?: Maybe<Array<GitInboundRunsBoolExp>>;
  affected_resources?: Maybe<JsonbComparisonExp>;
  commit?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  error?: Maybe<JsonbComparisonExp>;
  git_outbound_run?: Maybe<GitOutboundRunsBoolExp>;
  git_outbound_run_id?: Maybe<BigintComparisonExp>;
  git_sync_config?: Maybe<GitSyncConfigsBoolExp>;
  git_sync_config_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
};

/** order by max() on columns of table "git_inbound_runs" */
export type GitInboundRunsMaxOrderBy = {
  commit?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "git_inbound_runs" */
export type GitInboundRunsMinOrderBy = {
  commit?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "git_inbound_runs". */
export type GitInboundRunsOrderBy = {
  affected_resources?: Maybe<OrderBy>;
  commit?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  git_outbound_run?: Maybe<GitOutboundRunsOrderBy>;
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config?: Maybe<GitSyncConfigsOrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** select columns of table "git_inbound_runs" */
export const GitInboundRunsSelectColumn = {
  /** column name */
  AffectedResources: 'affected_resources',
  /** column name */
  Commit: 'commit',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  GitOutboundRunId: 'git_outbound_run_id',
  /** column name */
  GitSyncConfigId: 'git_sync_config_id',
  /** column name */
  Id: 'id'
} as const;

export type GitInboundRunsSelectColumn = typeof GitInboundRunsSelectColumn[keyof typeof GitInboundRunsSelectColumn];
/** order by stddev() on columns of table "git_inbound_runs" */
export type GitInboundRunsStddevOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "git_inbound_runs" */
export type GitInboundRunsStddevPopOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "git_inbound_runs" */
export type GitInboundRunsStddevSampOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "git_inbound_runs" */
export type GitInboundRunsSumOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "git_inbound_runs" */
export type GitInboundRunsVarPopOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "git_inbound_runs" */
export type GitInboundRunsVarSampOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "git_inbound_runs" */
export type GitInboundRunsVarianceOrderBy = {
  git_outbound_run_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRuns = {
  __typename?: 'git_outbound_runs';
  changelog_id: Maybe<Scalars['bigint']>;
  commits: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  error: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  git_sync_config: GitSyncConfigs;
  git_sync_config_id: Scalars['bigint'];
  id: Scalars['bigint'];
  state: Scalars['jsonb'];
};


/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRunsCommitsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRunsErrorArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRunsStateArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "git_outbound_runs" */
export type GitOutboundRunsAggregateOrderBy = {
  avg?: Maybe<GitOutboundRunsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GitOutboundRunsMaxOrderBy>;
  min?: Maybe<GitOutboundRunsMinOrderBy>;
  stddev?: Maybe<GitOutboundRunsStddevOrderBy>;
  stddev_pop?: Maybe<GitOutboundRunsStddevPopOrderBy>;
  stddev_samp?: Maybe<GitOutboundRunsStddevSampOrderBy>;
  sum?: Maybe<GitOutboundRunsSumOrderBy>;
  var_pop?: Maybe<GitOutboundRunsVarPopOrderBy>;
  var_samp?: Maybe<GitOutboundRunsVarSampOrderBy>;
  variance?: Maybe<GitOutboundRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "git_outbound_runs" */
export type GitOutboundRunsAvgOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "git_outbound_runs". All fields are combined with a logical 'AND'. */
export type GitOutboundRunsBoolExp = {
  _and?: Maybe<Array<GitOutboundRunsBoolExp>>;
  _not?: Maybe<GitOutboundRunsBoolExp>;
  _or?: Maybe<Array<GitOutboundRunsBoolExp>>;
  changelog_id?: Maybe<BigintComparisonExp>;
  commits?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  error?: Maybe<JsonbComparisonExp>;
  git_sync_config?: Maybe<GitSyncConfigsBoolExp>;
  git_sync_config_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  state?: Maybe<JsonbComparisonExp>;
};

/** order by max() on columns of table "git_outbound_runs" */
export type GitOutboundRunsMaxOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "git_outbound_runs" */
export type GitOutboundRunsMinOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "git_outbound_runs". */
export type GitOutboundRunsOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  commits?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  git_sync_config?: Maybe<GitSyncConfigsOrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
};

/** select columns of table "git_outbound_runs" */
export const GitOutboundRunsSelectColumn = {
  /** column name */
  ChangelogId: 'changelog_id',
  /** column name */
  Commits: 'commits',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  GitSyncConfigId: 'git_sync_config_id',
  /** column name */
  Id: 'id',
  /** column name */
  State: 'state'
} as const;

export type GitOutboundRunsSelectColumn = typeof GitOutboundRunsSelectColumn[keyof typeof GitOutboundRunsSelectColumn];
/** order by stddev() on columns of table "git_outbound_runs" */
export type GitOutboundRunsStddevOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "git_outbound_runs" */
export type GitOutboundRunsStddevPopOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "git_outbound_runs" */
export type GitOutboundRunsStddevSampOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "git_outbound_runs" */
export type GitOutboundRunsSumOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "git_outbound_runs" */
export type GitOutboundRunsVarPopOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "git_outbound_runs" */
export type GitOutboundRunsVarSampOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "git_outbound_runs" */
export type GitOutboundRunsVarianceOrderBy = {
  changelog_id?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** columns and relationships of "git_sync_attempts" */
export type GitSyncAttempts = {
  __typename?: 'git_sync_attempts';
  created_at: Scalars['timestamptz'];
  destination_instance_ids: Scalars['jsonb'];
  error: Maybe<Scalars['jsonb']>;
  git_sync_config_id: Scalars['Int'];
  id: Scalars['Int'];
  revision_ids: Scalars['jsonb'];
  state: Scalars['String'];
  type: Scalars['String'];
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "git_sync_attempts" */
export type GitSyncAttemptsDestinationInstanceIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_sync_attempts" */
export type GitSyncAttemptsErrorArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_sync_attempts" */
export type GitSyncAttemptsRevisionIdsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "git_sync_attempts" */
export type GitSyncAttemptsAggregate = {
  __typename?: 'git_sync_attempts_aggregate';
  aggregate: Maybe<GitSyncAttemptsAggregateFields>;
  nodes: Array<GitSyncAttempts>;
};

/** aggregate fields of "git_sync_attempts" */
export type GitSyncAttemptsAggregateFields = {
  __typename?: 'git_sync_attempts_aggregate_fields';
  avg: Maybe<GitSyncAttemptsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<GitSyncAttemptsMaxFields>;
  min: Maybe<GitSyncAttemptsMinFields>;
  stddev: Maybe<GitSyncAttemptsStddevFields>;
  stddev_pop: Maybe<GitSyncAttemptsStddevPopFields>;
  stddev_samp: Maybe<GitSyncAttemptsStddevSampFields>;
  sum: Maybe<GitSyncAttemptsSumFields>;
  var_pop: Maybe<GitSyncAttemptsVarPopFields>;
  var_samp: Maybe<GitSyncAttemptsVarSampFields>;
  variance: Maybe<GitSyncAttemptsVarianceFields>;
};


/** aggregate fields of "git_sync_attempts" */
export type GitSyncAttemptsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GitSyncAttemptsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GitSyncAttemptsAvgFields = {
  __typename?: 'git_sync_attempts_avg_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "git_sync_attempts". All fields are combined with a logical 'AND'. */
export type GitSyncAttemptsBoolExp = {
  _and?: Maybe<Array<GitSyncAttemptsBoolExp>>;
  _not?: Maybe<GitSyncAttemptsBoolExp>;
  _or?: Maybe<Array<GitSyncAttemptsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  destination_instance_ids?: Maybe<JsonbComparisonExp>;
  error?: Maybe<JsonbComparisonExp>;
  git_sync_config_id?: Maybe<IntComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  revision_ids?: Maybe<JsonbComparisonExp>;
  state?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  workspace_id?: Maybe<IntComparisonExp>;
};

/** aggregate max on columns */
export type GitSyncAttemptsMaxFields = {
  __typename?: 'git_sync_attempts_max_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  git_sync_config_id: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  state: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  workspace_id: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type GitSyncAttemptsMinFields = {
  __typename?: 'git_sync_attempts_min_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  git_sync_config_id: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  state: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  workspace_id: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "git_sync_attempts". */
export type GitSyncAttemptsOrderBy = {
  created_at?: Maybe<OrderBy>;
  destination_instance_ids?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  git_sync_config_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  revision_ids?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "git_sync_attempts" */
export const GitSyncAttemptsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationInstanceIds: 'destination_instance_ids',
  /** column name */
  Error: 'error',
  /** column name */
  GitSyncConfigId: 'git_sync_config_id',
  /** column name */
  Id: 'id',
  /** column name */
  RevisionIds: 'revision_ids',
  /** column name */
  State: 'state',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GitSyncAttemptsSelectColumn = typeof GitSyncAttemptsSelectColumn[keyof typeof GitSyncAttemptsSelectColumn];
/** aggregate stddev on columns */
export type GitSyncAttemptsStddevFields = {
  __typename?: 'git_sync_attempts_stddev_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GitSyncAttemptsStddevPopFields = {
  __typename?: 'git_sync_attempts_stddev_pop_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GitSyncAttemptsStddevSampFields = {
  __typename?: 'git_sync_attempts_stddev_samp_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type GitSyncAttemptsSumFields = {
  __typename?: 'git_sync_attempts_sum_fields';
  git_sync_config_id: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  workspace_id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type GitSyncAttemptsVarPopFields = {
  __typename?: 'git_sync_attempts_var_pop_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GitSyncAttemptsVarSampFields = {
  __typename?: 'git_sync_attempts_var_samp_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GitSyncAttemptsVarianceFields = {
  __typename?: 'git_sync_attempts_variance_fields';
  git_sync_config_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "git_sync_config" */
export type GitSyncConfig = {
  __typename?: 'git_sync_config';
  bidi: Scalars['Boolean'];
  bidi_metadata: Maybe<Scalars['jsonb']>;
  /** fetch data from the table: "dbt_models" */
  dbt_models: Array<DbtModels>;
  id: Scalars['Int'];
  password: Scalars['String'];
  repository: Scalars['String'];
  schema: Maybe<Scalars['String']>;
  username: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "git_sync_config" */
export type GitSyncConfigBidiMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_sync_config" */
export type GitSyncConfigDbtModelsArgs = {
  distinct_on?: Maybe<Array<DbtModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtModelsOrderBy>>;
  where?: Maybe<DbtModelsBoolExp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GitSyncConfigAppendInput = {
  bidi_metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "git_sync_config". All fields are combined with a logical 'AND'. */
export type GitSyncConfigBoolExp = {
  _and?: Maybe<Array<GitSyncConfigBoolExp>>;
  _not?: Maybe<GitSyncConfigBoolExp>;
  _or?: Maybe<Array<GitSyncConfigBoolExp>>;
  bidi?: Maybe<BooleanComparisonExp>;
  bidi_metadata?: Maybe<JsonbComparisonExp>;
  dbt_models?: Maybe<DbtModelsBoolExp>;
  id?: Maybe<IntComparisonExp>;
  password?: Maybe<StringComparisonExp>;
  repository?: Maybe<StringComparisonExp>;
  schema?: Maybe<StringComparisonExp>;
  username?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "git_sync_config" */
export const GitSyncConfigConstraint = {
  /** unique or primary key constraint */
  GitSyncConfigPkey: 'git_sync_config_pkey'
} as const;

export type GitSyncConfigConstraint = typeof GitSyncConfigConstraint[keyof typeof GitSyncConfigConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GitSyncConfigDeleteAtPathInput = {
  bidi_metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GitSyncConfigDeleteElemInput = {
  bidi_metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GitSyncConfigDeleteKeyInput = {
  bidi_metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "git_sync_config" */
export type GitSyncConfigInsertInput = {
  bidi?: Maybe<Scalars['Boolean']>;
  bidi_metadata?: Maybe<Scalars['jsonb']>;
  password?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "git_sync_config" */
export type GitSyncConfigMutationResponse = {
  __typename?: 'git_sync_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GitSyncConfig>;
};

/** on conflict condition type for table "git_sync_config" */
export type GitSyncConfigOnConflict = {
  constraint: GitSyncConfigConstraint;
  update_columns?: Array<GitSyncConfigUpdateColumn>;
  where?: Maybe<GitSyncConfigBoolExp>;
};

/** Ordering options when selecting data from "git_sync_config". */
export type GitSyncConfigOrderBy = {
  bidi?: Maybe<OrderBy>;
  bidi_metadata?: Maybe<OrderBy>;
  dbt_models_aggregate?: Maybe<DbtModelsAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  password?: Maybe<OrderBy>;
  repository?: Maybe<OrderBy>;
  schema?: Maybe<OrderBy>;
  username?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: git_sync_config */
export type GitSyncConfigPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GitSyncConfigPrependInput = {
  bidi_metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "git_sync_config" */
export const GitSyncConfigSelectColumn = {
  /** column name */
  Bidi: 'bidi',
  /** column name */
  BidiMetadata: 'bidi_metadata',
  /** column name */
  Id: 'id',
  /** column name */
  Password: 'password',
  /** column name */
  Repository: 'repository',
  /** column name */
  Schema: 'schema',
  /** column name */
  Username: 'username',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GitSyncConfigSelectColumn = typeof GitSyncConfigSelectColumn[keyof typeof GitSyncConfigSelectColumn];
/** input type for updating data in table "git_sync_config" */
export type GitSyncConfigSetInput = {
  bidi?: Maybe<Scalars['Boolean']>;
  bidi_metadata?: Maybe<Scalars['jsonb']>;
  password?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  schema?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** update columns of table "git_sync_config" */
export const GitSyncConfigUpdateColumn = {
  /** column name */
  Bidi: 'bidi',
  /** column name */
  BidiMetadata: 'bidi_metadata',
  /** column name */
  Password: 'password',
  /** column name */
  Repository: 'repository',
  /** column name */
  Schema: 'schema',
  /** column name */
  Username: 'username'
} as const;

export type GitSyncConfigUpdateColumn = typeof GitSyncConfigUpdateColumn[keyof typeof GitSyncConfigUpdateColumn];
/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigs = {
  __typename?: 'git_sync_configs';
  branch: Scalars['String'];
  enabled: Scalars['Boolean'];
  full_resync: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  git_credential: GitCredentials;
  git_credential_id: Scalars['bigint'];
  /** An array relationship */
  git_inbound_runs: Array<GitInboundRuns>;
  /** fetch data from the table: "git_outbound_runs" */
  git_outbound_runs: Array<GitOutboundRuns>;
  id: Scalars['bigint'];
  inbound_error: Maybe<Scalars['jsonb']>;
  last_attempted_at: Maybe<Scalars['timestamptz']>;
  outbound_error: Maybe<Scalars['jsonb']>;
  path: Maybe<Scalars['String']>;
  repository: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsGitInboundRunsArgs = {
  distinct_on?: Maybe<Array<GitInboundRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitInboundRunsOrderBy>>;
  where?: Maybe<GitInboundRunsBoolExp>;
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsGitOutboundRunsArgs = {
  distinct_on?: Maybe<Array<GitOutboundRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitOutboundRunsOrderBy>>;
  where?: Maybe<GitOutboundRunsBoolExp>;
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsInboundErrorArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsOutboundErrorArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "git_sync_configs". All fields are combined with a logical 'AND'. */
export type GitSyncConfigsBoolExp = {
  _and?: Maybe<Array<GitSyncConfigsBoolExp>>;
  _not?: Maybe<GitSyncConfigsBoolExp>;
  _or?: Maybe<Array<GitSyncConfigsBoolExp>>;
  branch?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  full_resync?: Maybe<BooleanComparisonExp>;
  git_credential?: Maybe<GitCredentialsBoolExp>;
  git_credential_id?: Maybe<BigintComparisonExp>;
  git_inbound_runs?: Maybe<GitInboundRunsBoolExp>;
  git_outbound_runs?: Maybe<GitOutboundRunsBoolExp>;
  id?: Maybe<BigintComparisonExp>;
  inbound_error?: Maybe<JsonbComparisonExp>;
  last_attempted_at?: Maybe<TimestamptzComparisonExp>;
  outbound_error?: Maybe<JsonbComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  repository?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "git_sync_configs" */
export const GitSyncConfigsConstraint = {
  /** unique or primary key constraint */
  GitSyncConfigsPkey: 'git_sync_configs_pkey'
} as const;

export type GitSyncConfigsConstraint = typeof GitSyncConfigsConstraint[keyof typeof GitSyncConfigsConstraint];
/** input type for incrementing numeric columns in table "git_sync_configs" */
export type GitSyncConfigsIncInput = {
  git_credential_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "git_sync_configs" */
export type GitSyncConfigsInsertInput = {
  branch?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  full_resync?: Maybe<Scalars['Boolean']>;
  git_credential?: Maybe<GitCredentialsObjRelInsertInput>;
  git_credential_id?: Maybe<Scalars['bigint']>;
  last_attempted_at?: Maybe<Scalars['timestamptz']>;
  path?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "git_sync_configs" */
export type GitSyncConfigsMutationResponse = {
  __typename?: 'git_sync_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GitSyncConfigs>;
};

/** on conflict condition type for table "git_sync_configs" */
export type GitSyncConfigsOnConflict = {
  constraint: GitSyncConfigsConstraint;
  update_columns?: Array<GitSyncConfigsUpdateColumn>;
  where?: Maybe<GitSyncConfigsBoolExp>;
};

/** Ordering options when selecting data from "git_sync_configs". */
export type GitSyncConfigsOrderBy = {
  branch?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  full_resync?: Maybe<OrderBy>;
  git_credential?: Maybe<GitCredentialsOrderBy>;
  git_credential_id?: Maybe<OrderBy>;
  git_inbound_runs_aggregate?: Maybe<GitInboundRunsAggregateOrderBy>;
  git_outbound_runs_aggregate?: Maybe<GitOutboundRunsAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  inbound_error?: Maybe<OrderBy>;
  last_attempted_at?: Maybe<OrderBy>;
  outbound_error?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  repository?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: git_sync_configs */
export type GitSyncConfigsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "git_sync_configs" */
export const GitSyncConfigsSelectColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  GitCredentialId: 'git_credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  InboundError: 'inbound_error',
  /** column name */
  LastAttemptedAt: 'last_attempted_at',
  /** column name */
  OutboundError: 'outbound_error',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GitSyncConfigsSelectColumn = typeof GitSyncConfigsSelectColumn[keyof typeof GitSyncConfigsSelectColumn];
/** input type for updating data in table "git_sync_configs" */
export type GitSyncConfigsSetInput = {
  branch?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  full_resync?: Maybe<Scalars['Boolean']>;
  git_credential_id?: Maybe<Scalars['bigint']>;
  last_attempted_at?: Maybe<Scalars['timestamptz']>;
  path?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
};

/** update columns of table "git_sync_configs" */
export const GitSyncConfigsUpdateColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  GitCredentialId: 'git_credential_id',
  /** column name */
  LastAttemptedAt: 'last_attempted_at',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository'
} as const;

export type GitSyncConfigsUpdateColumn = typeof GitSyncConfigsUpdateColumn[keyof typeof GitSyncConfigsUpdateColumn];
/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "looker_credentials" */
export type LookerCredentials = {
  __typename?: 'looker_credentials';
  client_id: Scalars['String'];
  client_secret: Scalars['String'];
  id: Scalars['Int'];
  tunnel_id: Maybe<Scalars['uuid']>;
  url: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
};

/** Boolean expression to filter rows from the table "looker_credentials". All fields are combined with a logical 'AND'. */
export type LookerCredentialsBoolExp = {
  _and?: Maybe<Array<LookerCredentialsBoolExp>>;
  _not?: Maybe<LookerCredentialsBoolExp>;
  _or?: Maybe<Array<LookerCredentialsBoolExp>>;
  client_id?: Maybe<StringComparisonExp>;
  client_secret?: Maybe<StringComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  tunnel_id?: Maybe<UuidComparisonExp>;
  url?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
};

/** unique or primary key constraints on table "looker_credentials" */
export const LookerCredentialsConstraint = {
  /** unique or primary key constraint */
  LookerCredentialsPkey: 'looker_credentials_pkey'
} as const;

export type LookerCredentialsConstraint = typeof LookerCredentialsConstraint[keyof typeof LookerCredentialsConstraint];
/** input type for inserting data into table "looker_credentials" */
export type LookerCredentialsInsertInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "looker_credentials" */
export type LookerCredentialsMutationResponse = {
  __typename?: 'looker_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LookerCredentials>;
};

/** on conflict condition type for table "looker_credentials" */
export type LookerCredentialsOnConflict = {
  constraint: LookerCredentialsConstraint;
  update_columns?: Array<LookerCredentialsUpdateColumn>;
  where?: Maybe<LookerCredentialsBoolExp>;
};

/** Ordering options when selecting data from "looker_credentials". */
export type LookerCredentialsOrderBy = {
  client_id?: Maybe<OrderBy>;
  client_secret?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  tunnel_id?: Maybe<OrderBy>;
  url?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
};

/** primary key columns input for table: looker_credentials */
export type LookerCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "looker_credentials" */
export const LookerCredentialsSelectColumn = {
  /** column name */
  ClientId: 'client_id',
  /** column name */
  ClientSecret: 'client_secret',
  /** column name */
  Id: 'id',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Url: 'url'
} as const;

export type LookerCredentialsSelectColumn = typeof LookerCredentialsSelectColumn[keyof typeof LookerCredentialsSelectColumn];
/** input type for updating data in table "looker_credentials" */
export type LookerCredentialsSetInput = {
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** update columns of table "looker_credentials" */
export const LookerCredentialsUpdateColumn = {
  /** column name */
  ClientId: 'client_id',
  /** column name */
  ClientSecret: 'client_secret',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Url: 'url'
} as const;

export type LookerCredentialsUpdateColumn = typeof LookerCredentialsUpdateColumn[keyof typeof LookerCredentialsUpdateColumn];
/** columns and relationships of "membership_requests" */
export type MembershipRequests = {
  __typename?: 'membership_requests';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "membership_requests" */
export type MembershipRequestsAggregateOrderBy = {
  avg?: Maybe<MembershipRequestsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<MembershipRequestsMaxOrderBy>;
  min?: Maybe<MembershipRequestsMinOrderBy>;
  stddev?: Maybe<MembershipRequestsStddevOrderBy>;
  stddev_pop?: Maybe<MembershipRequestsStddevPopOrderBy>;
  stddev_samp?: Maybe<MembershipRequestsStddevSampOrderBy>;
  sum?: Maybe<MembershipRequestsSumOrderBy>;
  var_pop?: Maybe<MembershipRequestsVarPopOrderBy>;
  var_samp?: Maybe<MembershipRequestsVarSampOrderBy>;
  variance?: Maybe<MembershipRequestsVarianceOrderBy>;
};

/** order by avg() on columns of table "membership_requests" */
export type MembershipRequestsAvgOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "membership_requests". All fields are combined with a logical 'AND'. */
export type MembershipRequestsBoolExp = {
  _and?: Maybe<Array<MembershipRequestsBoolExp>>;
  _not?: Maybe<MembershipRequestsBoolExp>;
  _or?: Maybe<Array<MembershipRequestsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<BigintComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** order by max() on columns of table "membership_requests" */
export type MembershipRequestsMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "membership_requests" */
export type MembershipRequestsMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "membership_requests" */
export type MembershipRequestsMutationResponse = {
  __typename?: 'membership_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MembershipRequests>;
};

/** Ordering options when selecting data from "membership_requests". */
export type MembershipRequestsOrderBy = {
  created_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "membership_requests" */
export const MembershipRequestsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MembershipRequestsSelectColumn = typeof MembershipRequestsSelectColumn[keyof typeof MembershipRequestsSelectColumn];
/** order by stddev() on columns of table "membership_requests" */
export type MembershipRequestsStddevOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "membership_requests" */
export type MembershipRequestsStddevPopOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "membership_requests" */
export type MembershipRequestsStddevSampOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "membership_requests" */
export type MembershipRequestsSumOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "membership_requests" */
export type MembershipRequestsVarPopOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "membership_requests" */
export type MembershipRequestsVarSampOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "membership_requests" */
export type MembershipRequestsVarianceOrderBy = {
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "memberships" */
export type Memberships = {
  __typename?: 'memberships';
  /** An object relationship */
  role: Maybe<Roles>;
  role_id: Maybe<Scalars['Int']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "memberships" */
export type MembershipsAggregate = {
  __typename?: 'memberships_aggregate';
  aggregate: Maybe<MembershipsAggregateFields>;
  nodes: Array<Memberships>;
};

/** aggregate fields of "memberships" */
export type MembershipsAggregateFields = {
  __typename?: 'memberships_aggregate_fields';
  avg: Maybe<MembershipsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<MembershipsMaxFields>;
  min: Maybe<MembershipsMinFields>;
  stddev: Maybe<MembershipsStddevFields>;
  stddev_pop: Maybe<MembershipsStddevPopFields>;
  stddev_samp: Maybe<MembershipsStddevSampFields>;
  sum: Maybe<MembershipsSumFields>;
  var_pop: Maybe<MembershipsVarPopFields>;
  var_samp: Maybe<MembershipsVarSampFields>;
  variance: Maybe<MembershipsVarianceFields>;
};


/** aggregate fields of "memberships" */
export type MembershipsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<MembershipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "memberships" */
export type MembershipsAggregateOrderBy = {
  avg?: Maybe<MembershipsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<MembershipsMaxOrderBy>;
  min?: Maybe<MembershipsMinOrderBy>;
  stddev?: Maybe<MembershipsStddevOrderBy>;
  stddev_pop?: Maybe<MembershipsStddevPopOrderBy>;
  stddev_samp?: Maybe<MembershipsStddevSampOrderBy>;
  sum?: Maybe<MembershipsSumOrderBy>;
  var_pop?: Maybe<MembershipsVarPopOrderBy>;
  var_samp?: Maybe<MembershipsVarSampOrderBy>;
  variance?: Maybe<MembershipsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type MembershipsAvgFields = {
  __typename?: 'memberships_avg_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "memberships" */
export type MembershipsAvgOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "memberships". All fields are combined with a logical 'AND'. */
export type MembershipsBoolExp = {
  _and?: Maybe<Array<MembershipsBoolExp>>;
  _not?: Maybe<MembershipsBoolExp>;
  _or?: Maybe<Array<MembershipsBoolExp>>;
  role?: Maybe<RolesBoolExp>;
  role_id?: Maybe<IntComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<BigintComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** input type for incrementing numeric columns in table "memberships" */
export type MembershipsIncInput = {
  role_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MembershipsMaxFields = {
  __typename?: 'memberships_max_fields';
  role_id: Maybe<Scalars['Int']>;
  user_id: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "memberships" */
export type MembershipsMaxOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type MembershipsMinFields = {
  __typename?: 'memberships_min_fields';
  role_id: Maybe<Scalars['Int']>;
  user_id: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "memberships" */
export type MembershipsMinOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "memberships" */
export type MembershipsMutationResponse = {
  __typename?: 'memberships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Memberships>;
};

/** Ordering options when selecting data from "memberships". */
export type MembershipsOrderBy = {
  role?: Maybe<RolesOrderBy>;
  role_id?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: memberships */
export type MembershipsPkColumnsInput = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "memberships" */
export const MembershipsSelectColumn = {
  /** column name */
  RoleId: 'role_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MembershipsSelectColumn = typeof MembershipsSelectColumn[keyof typeof MembershipsSelectColumn];
/** input type for updating data in table "memberships" */
export type MembershipsSetInput = {
  role_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type MembershipsStddevFields = {
  __typename?: 'memberships_stddev_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "memberships" */
export type MembershipsStddevOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MembershipsStddevPopFields = {
  __typename?: 'memberships_stddev_pop_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "memberships" */
export type MembershipsStddevPopOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MembershipsStddevSampFields = {
  __typename?: 'memberships_stddev_samp_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "memberships" */
export type MembershipsStddevSampOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type MembershipsSumFields = {
  __typename?: 'memberships_sum_fields';
  role_id: Maybe<Scalars['Int']>;
  user_id: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "memberships" */
export type MembershipsSumOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type MembershipsVarPopFields = {
  __typename?: 'memberships_var_pop_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "memberships" */
export type MembershipsVarPopOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MembershipsVarSampFields = {
  __typename?: 'memberships_var_samp_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "memberships" */
export type MembershipsVarSampOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type MembershipsVarianceFields = {
  __typename?: 'memberships_variance_fields';
  role_id: Maybe<Scalars['Float']>;
  user_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "memberships" */
export type MembershipsVarianceOrderBy = {
  role_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "model_columns" */
export type ModelColumns = {
  __typename?: 'model_columns';
  alias: Maybe<Scalars['String']>;
  custom_type: Maybe<Scalars['String']>;
  disable: Scalars['Boolean'];
  disable_preview: Scalars['Boolean'];
  last_top_k_sync_timestamp: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  model: Maybe<Segments>;
  model_id: Scalars['bigint'];
  name: Scalars['String'];
  top_k_enabled: Maybe<Scalars['Boolean']>;
  top_k_error: Maybe<Scalars['String']>;
  top_k_sync_interval: Maybe<Scalars['Int']>;
  trigger_top_k_sync: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

/** order by aggregate values of table "model_columns" */
export type ModelColumnsAggregateOrderBy = {
  avg?: Maybe<ModelColumnsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ModelColumnsMaxOrderBy>;
  min?: Maybe<ModelColumnsMinOrderBy>;
  stddev?: Maybe<ModelColumnsStddevOrderBy>;
  stddev_pop?: Maybe<ModelColumnsStddevPopOrderBy>;
  stddev_samp?: Maybe<ModelColumnsStddevSampOrderBy>;
  sum?: Maybe<ModelColumnsSumOrderBy>;
  var_pop?: Maybe<ModelColumnsVarPopOrderBy>;
  var_samp?: Maybe<ModelColumnsVarSampOrderBy>;
  variance?: Maybe<ModelColumnsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "model_columns" */
export type ModelColumnsArrRelInsertInput = {
  data: Array<ModelColumnsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<ModelColumnsOnConflict>;
};

/** order by avg() on columns of table "model_columns" */
export type ModelColumnsAvgOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "model_columns". All fields are combined with a logical 'AND'. */
export type ModelColumnsBoolExp = {
  _and?: Maybe<Array<ModelColumnsBoolExp>>;
  _not?: Maybe<ModelColumnsBoolExp>;
  _or?: Maybe<Array<ModelColumnsBoolExp>>;
  alias?: Maybe<StringComparisonExp>;
  custom_type?: Maybe<StringComparisonExp>;
  disable?: Maybe<BooleanComparisonExp>;
  disable_preview?: Maybe<BooleanComparisonExp>;
  last_top_k_sync_timestamp?: Maybe<TimestamptzComparisonExp>;
  model?: Maybe<SegmentsBoolExp>;
  model_id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  top_k_enabled?: Maybe<BooleanComparisonExp>;
  top_k_error?: Maybe<StringComparisonExp>;
  top_k_sync_interval?: Maybe<IntComparisonExp>;
  trigger_top_k_sync?: Maybe<BooleanComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "model_columns" */
export const ModelColumnsConstraint = {
  /** unique or primary key constraint */
  ModelColumnsPkey: 'model_columns_pkey'
} as const;

export type ModelColumnsConstraint = typeof ModelColumnsConstraint[keyof typeof ModelColumnsConstraint];
/** input type for incrementing numeric columns in table "model_columns" */
export type ModelColumnsIncInput = {
  top_k_sync_interval?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "model_columns" */
export type ModelColumnsInsertInput = {
  alias?: Maybe<Scalars['String']>;
  custom_type?: Maybe<Scalars['String']>;
  disable?: Maybe<Scalars['Boolean']>;
  disable_preview?: Maybe<Scalars['Boolean']>;
  model?: Maybe<SegmentsObjRelInsertInput>;
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  top_k_enabled?: Maybe<Scalars['Boolean']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  trigger_top_k_sync?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "model_columns" */
export type ModelColumnsMaxOrderBy = {
  alias?: Maybe<OrderBy>;
  custom_type?: Maybe<OrderBy>;
  last_top_k_sync_timestamp?: Maybe<OrderBy>;
  model_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  top_k_error?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** order by min() on columns of table "model_columns" */
export type ModelColumnsMinOrderBy = {
  alias?: Maybe<OrderBy>;
  custom_type?: Maybe<OrderBy>;
  last_top_k_sync_timestamp?: Maybe<OrderBy>;
  model_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  top_k_error?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** response of any mutation on the table "model_columns" */
export type ModelColumnsMutationResponse = {
  __typename?: 'model_columns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ModelColumns>;
};

/** on conflict condition type for table "model_columns" */
export type ModelColumnsOnConflict = {
  constraint: ModelColumnsConstraint;
  update_columns?: Array<ModelColumnsUpdateColumn>;
  where?: Maybe<ModelColumnsBoolExp>;
};

/** Ordering options when selecting data from "model_columns". */
export type ModelColumnsOrderBy = {
  alias?: Maybe<OrderBy>;
  custom_type?: Maybe<OrderBy>;
  disable?: Maybe<OrderBy>;
  disable_preview?: Maybe<OrderBy>;
  last_top_k_sync_timestamp?: Maybe<OrderBy>;
  model?: Maybe<SegmentsOrderBy>;
  model_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  top_k_enabled?: Maybe<OrderBy>;
  top_k_error?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
  trigger_top_k_sync?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: model_columns */
export type ModelColumnsPkColumnsInput = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};

/** select columns of table "model_columns" */
export const ModelColumnsSelectColumn = {
  /** column name */
  Alias: 'alias',
  /** column name */
  CustomType: 'custom_type',
  /** column name */
  Disable: 'disable',
  /** column name */
  DisablePreview: 'disable_preview',
  /** column name */
  LastTopKSyncTimestamp: 'last_top_k_sync_timestamp',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Name: 'name',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKError: 'top_k_error',
  /** column name */
  TopKSyncInterval: 'top_k_sync_interval',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync',
  /** column name */
  Type: 'type'
} as const;

export type ModelColumnsSelectColumn = typeof ModelColumnsSelectColumn[keyof typeof ModelColumnsSelectColumn];
/** input type for updating data in table "model_columns" */
export type ModelColumnsSetInput = {
  alias?: Maybe<Scalars['String']>;
  custom_type?: Maybe<Scalars['String']>;
  disable?: Maybe<Scalars['Boolean']>;
  disable_preview?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  top_k_enabled?: Maybe<Scalars['Boolean']>;
  top_k_error?: Maybe<Scalars['String']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  trigger_top_k_sync?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "model_columns" */
export type ModelColumnsStddevOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "model_columns" */
export type ModelColumnsStddevPopOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "model_columns" */
export type ModelColumnsStddevSampOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "model_columns" */
export type ModelColumnsSumOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** update columns of table "model_columns" */
export const ModelColumnsUpdateColumn = {
  /** column name */
  Alias: 'alias',
  /** column name */
  CustomType: 'custom_type',
  /** column name */
  Disable: 'disable',
  /** column name */
  DisablePreview: 'disable_preview',
  /** column name */
  Name: 'name',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKError: 'top_k_error',
  /** column name */
  TopKSyncInterval: 'top_k_sync_interval',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync',
  /** column name */
  Type: 'type'
} as const;

export type ModelColumnsUpdateColumn = typeof ModelColumnsUpdateColumn[keyof typeof ModelColumnsUpdateColumn];
/** order by var_pop() on columns of table "model_columns" */
export type ModelColumnsVarPopOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "model_columns" */
export type ModelColumnsVarSampOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "model_columns" */
export type ModelColumnsVarianceOrderBy = {
  model_id?: Maybe<OrderBy>;
  top_k_sync_interval?: Maybe<OrderBy>;
};

/** columns and relationships of "model_relationships" */
export type ModelRelationships = {
  __typename?: 'model_relationships';
  /** An array relationship */
  direct_relationships: Array<DirectModelRelationships>;
  /** An object relationship */
  from_model: Segments;
  from_model_id: Scalars['bigint'];
  id: Scalars['bigint'];
  is_direct_relationship: Scalars['Boolean'];
  merge_columns: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** An array relationship */
  through_relationships: Array<ThroughModelRelationships>;
  /** An object relationship */
  to_model: Segments;
  to_model_id: Scalars['bigint'];
};


/** columns and relationships of "model_relationships" */
export type ModelRelationshipsDirectRelationshipsArgs = {
  distinct_on?: Maybe<Array<DirectModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DirectModelRelationshipsOrderBy>>;
  where?: Maybe<DirectModelRelationshipsBoolExp>;
};


/** columns and relationships of "model_relationships" */
export type ModelRelationshipsThroughRelationshipsArgs = {
  distinct_on?: Maybe<Array<ThroughModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ThroughModelRelationshipsOrderBy>>;
  where?: Maybe<ThroughModelRelationshipsBoolExp>;
};

/** order by aggregate values of table "model_relationships" */
export type ModelRelationshipsAggregateOrderBy = {
  avg?: Maybe<ModelRelationshipsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ModelRelationshipsMaxOrderBy>;
  min?: Maybe<ModelRelationshipsMinOrderBy>;
  stddev?: Maybe<ModelRelationshipsStddevOrderBy>;
  stddev_pop?: Maybe<ModelRelationshipsStddevPopOrderBy>;
  stddev_samp?: Maybe<ModelRelationshipsStddevSampOrderBy>;
  sum?: Maybe<ModelRelationshipsSumOrderBy>;
  var_pop?: Maybe<ModelRelationshipsVarPopOrderBy>;
  var_samp?: Maybe<ModelRelationshipsVarSampOrderBy>;
  variance?: Maybe<ModelRelationshipsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "model_relationships" */
export type ModelRelationshipsArrRelInsertInput = {
  data: Array<ModelRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<ModelRelationshipsOnConflict>;
};

/** order by avg() on columns of table "model_relationships" */
export type ModelRelationshipsAvgOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "model_relationships". All fields are combined with a logical 'AND'. */
export type ModelRelationshipsBoolExp = {
  _and?: Maybe<Array<ModelRelationshipsBoolExp>>;
  _not?: Maybe<ModelRelationshipsBoolExp>;
  _or?: Maybe<Array<ModelRelationshipsBoolExp>>;
  direct_relationships?: Maybe<DirectModelRelationshipsBoolExp>;
  from_model?: Maybe<SegmentsBoolExp>;
  from_model_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  is_direct_relationship?: Maybe<BooleanComparisonExp>;
  merge_columns?: Maybe<BooleanComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  through_relationships?: Maybe<ThroughModelRelationshipsBoolExp>;
  to_model?: Maybe<SegmentsBoolExp>;
  to_model_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "model_relationships" */
export const ModelRelationshipsConstraint = {
  /** unique or primary key constraint */
  ModelRelationshipsPkey: 'model_relationships_pkey'
} as const;

export type ModelRelationshipsConstraint = typeof ModelRelationshipsConstraint[keyof typeof ModelRelationshipsConstraint];
/** input type for incrementing numeric columns in table "model_relationships" */
export type ModelRelationshipsIncInput = {
  from_model_id?: Maybe<Scalars['bigint']>;
  to_model_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "model_relationships" */
export type ModelRelationshipsInsertInput = {
  direct_relationships?: Maybe<DirectModelRelationshipsArrRelInsertInput>;
  from_model?: Maybe<SegmentsObjRelInsertInput>;
  from_model_id?: Maybe<Scalars['bigint']>;
  is_direct_relationship?: Maybe<Scalars['Boolean']>;
  merge_columns?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  through_relationships?: Maybe<ThroughModelRelationshipsArrRelInsertInput>;
  to_model?: Maybe<SegmentsObjRelInsertInput>;
  to_model_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "model_relationships" */
export type ModelRelationshipsMaxOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "model_relationships" */
export type ModelRelationshipsMinOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "model_relationships" */
export type ModelRelationshipsMutationResponse = {
  __typename?: 'model_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ModelRelationships>;
};

/** input type for inserting object relation for remote table "model_relationships" */
export type ModelRelationshipsObjRelInsertInput = {
  data: ModelRelationshipsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<ModelRelationshipsOnConflict>;
};

/** on conflict condition type for table "model_relationships" */
export type ModelRelationshipsOnConflict = {
  constraint: ModelRelationshipsConstraint;
  update_columns?: Array<ModelRelationshipsUpdateColumn>;
  where?: Maybe<ModelRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "model_relationships". */
export type ModelRelationshipsOrderBy = {
  direct_relationships_aggregate?: Maybe<DirectModelRelationshipsAggregateOrderBy>;
  from_model?: Maybe<SegmentsOrderBy>;
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_direct_relationship?: Maybe<OrderBy>;
  merge_columns?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  through_relationships_aggregate?: Maybe<ThroughModelRelationshipsAggregateOrderBy>;
  to_model?: Maybe<SegmentsOrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: model_relationships */
export type ModelRelationshipsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "model_relationships" */
export const ModelRelationshipsSelectColumn = {
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  Id: 'id',
  /** column name */
  IsDirectRelationship: 'is_direct_relationship',
  /** column name */
  MergeColumns: 'merge_columns',
  /** column name */
  Name: 'name',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type ModelRelationshipsSelectColumn = typeof ModelRelationshipsSelectColumn[keyof typeof ModelRelationshipsSelectColumn];
/** input type for updating data in table "model_relationships" */
export type ModelRelationshipsSetInput = {
  from_model_id?: Maybe<Scalars['bigint']>;
  merge_columns?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  to_model_id?: Maybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "model_relationships" */
export type ModelRelationshipsStddevOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "model_relationships" */
export type ModelRelationshipsStddevPopOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "model_relationships" */
export type ModelRelationshipsStddevSampOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "model_relationships" */
export type ModelRelationshipsSumOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** update columns of table "model_relationships" */
export const ModelRelationshipsUpdateColumn = {
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  MergeColumns: 'merge_columns',
  /** column name */
  Name: 'name',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type ModelRelationshipsUpdateColumn = typeof ModelRelationshipsUpdateColumn[keyof typeof ModelRelationshipsUpdateColumn];
/** order by var_pop() on columns of table "model_relationships" */
export type ModelRelationshipsVarPopOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "model_relationships" */
export type ModelRelationshipsVarSampOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "model_relationships" */
export type ModelRelationshipsVarianceOrderBy = {
  from_model_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  to_model_id?: Maybe<OrderBy>;
};

/** mutation root */
export type Mutation = {
  __typename?: 'mutation';
  approveMembership: Maybe<Scalars['Boolean']>;
  createDBTCredential: DbtCredential;
  createDestinationWithSecrets: DestinationResult;
  createFeatureRequest: Maybe<Scalars['Boolean']>;
  createFeedback: Maybe<Scalars['Boolean']>;
  createGoogleServiceAccount: CreateGoogleServiceAccountResult;
  createIntegrationRequest: Maybe<Scalars['Boolean']>;
  createNormalTunnel: NormalTunnelOutput;
  createReverseTunnel: ReverseTunnelOutput;
  createWorkspace: CreateWorkspaceResult;
  deleteTunnel: Maybe<Scalars['Boolean']>;
  /** delete data from the table: "alert_instances" */
  delete_alert_instances: Maybe<AlertInstancesMutationResponse>;
  /** delete data from the table: "alerts" */
  delete_alerts: Maybe<AlertsMutationResponse>;
  /** delete single row from the table: "alerts" */
  delete_alerts_by_pk: Maybe<Alerts>;
  /** delete data from the table: "api_keys" */
  delete_api_keys: Maybe<ApiKeysMutationResponse>;
  /** delete single row from the table: "api_keys" */
  delete_api_keys_by_pk: Maybe<ApiKeys>;
  /** delete data from the table: "cloud_credentials" */
  delete_cloud_credentials: Maybe<CloudCredentialsMutationResponse>;
  /** delete single row from the table: "cloud_credentials" */
  delete_cloud_credentials_by_pk: Maybe<CloudCredentials>;
  /** delete data from the table: "column_selectors" */
  delete_column_selectors: Maybe<ColumnSelectorsMutationResponse>;
  /** delete single row from the table: "column_selectors" */
  delete_column_selectors_by_pk: Maybe<ColumnSelectors>;
  /** delete data from the table: "connections" */
  delete_connections: Maybe<ConnectionsMutationResponse>;
  /** delete single row from the table: "connections" */
  delete_connections_by_pk: Maybe<Connections>;
  /** delete data from the table: "dbt_sync_config" */
  delete_dbt_sync_config: Maybe<DbtSyncConfigMutationResponse>;
  /** delete single row from the table: "dbt_sync_config" */
  delete_dbt_sync_config_by_pk: Maybe<DbtSyncConfig>;
  /** delete data from the table: "destination_instances" */
  delete_destination_instances: Maybe<DestinationInstancesMutationResponse>;
  /** delete single row from the table: "destination_instances" */
  delete_destination_instances_by_pk: Maybe<DestinationInstances>;
  /** delete data from the table: "destinations" */
  delete_destinations: Maybe<DestinationsMutationResponse>;
  /** delete single row from the table: "destinations" */
  delete_destinations_by_pk: Maybe<Destinations>;
  /** delete data from the table: "direct_model_relationships" */
  delete_direct_model_relationships: Maybe<DirectModelRelationshipsMutationResponse>;
  /** delete single row from the table: "direct_model_relationships" */
  delete_direct_model_relationships_by_pk: Maybe<DirectModelRelationships>;
  /** delete data from the table: "event_definitions" */
  delete_event_definitions: Maybe<EventDefinitionsMutationResponse>;
  /** delete single row from the table: "event_definitions" */
  delete_event_definitions_by_pk: Maybe<EventDefinitions>;
  /** delete data from the table: "external_buckets" */
  delete_external_buckets: Maybe<ExternalBucketsMutationResponse>;
  /** delete single row from the table: "external_buckets" */
  delete_external_buckets_by_pk: Maybe<ExternalBuckets>;
  /** delete data from the table: "external_segments" */
  delete_external_segments: Maybe<ExternalSegmentsMutationResponse>;
  /** delete single row from the table: "external_segments" */
  delete_external_segments_by_pk: Maybe<ExternalSegments>;
  /** delete data from the table: "git_credentials" */
  delete_git_credentials: Maybe<GitCredentialsMutationResponse>;
  /** delete single row from the table: "git_credentials" */
  delete_git_credentials_by_pk: Maybe<GitCredentials>;
  /** delete data from the table: "git_sync_configs" */
  delete_git_sync_configs: Maybe<GitSyncConfigsMutationResponse>;
  /** delete single row from the table: "git_sync_configs" */
  delete_git_sync_configs_by_pk: Maybe<GitSyncConfigs>;
  /** delete data from the table: "looker_credentials" */
  delete_looker_credentials: Maybe<LookerCredentialsMutationResponse>;
  /** delete single row from the table: "looker_credentials" */
  delete_looker_credentials_by_pk: Maybe<LookerCredentials>;
  /** delete data from the table: "membership_requests" */
  delete_membership_requests: Maybe<MembershipRequestsMutationResponse>;
  /** delete single row from the table: "membership_requests" */
  delete_membership_requests_by_pk: Maybe<MembershipRequests>;
  /** delete data from the table: "memberships" */
  delete_memberships: Maybe<MembershipsMutationResponse>;
  /** delete single row from the table: "memberships" */
  delete_memberships_by_pk: Maybe<Memberships>;
  /** delete data from the table: "model_columns" */
  delete_model_columns: Maybe<ModelColumnsMutationResponse>;
  /** delete single row from the table: "model_columns" */
  delete_model_columns_by_pk: Maybe<ModelColumns>;
  /** delete data from the table: "model_relationships" */
  delete_model_relationships: Maybe<ModelRelationshipsMutationResponse>;
  /** delete single row from the table: "model_relationships" */
  delete_model_relationships_by_pk: Maybe<ModelRelationships>;
  /** delete data from the table: "outbound_user_invites" */
  delete_outbound_user_invites: Maybe<OutboundUserInvitesMutationResponse>;
  /** delete single row from the table: "outbound_user_invites" */
  delete_outbound_user_invites_by_pk: Maybe<OutboundUserInvites>;
  /** delete data from the table: "relationship_references" */
  delete_relationship_references: Maybe<RelationshipReferencesMutationResponse>;
  /** delete single row from the table: "relationship_references" */
  delete_relationship_references_by_pk: Maybe<RelationshipReferences>;
  /** delete data from the table: "relationships" */
  delete_relationships: Maybe<RelationshipsMutationResponse>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk: Maybe<Relationships>;
  /** delete data from the table: "resource_views" */
  delete_resource_views: Maybe<ResourceViewsMutationResponse>;
  /** delete single row from the table: "resource_views" */
  delete_resource_views_by_pk: Maybe<ResourceViews>;
  /** delete data from the table: "roles" */
  delete_roles: Maybe<RolesMutationResponse>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk: Maybe<Roles>;
  /** delete data from the table: "saved_queries" */
  delete_saved_queries: Maybe<SavedQueriesMutationResponse>;
  /** delete single row from the table: "saved_queries" */
  delete_saved_queries_by_pk: Maybe<SavedQueries>;
  /** delete data from the table: "segments" */
  delete_segments: Maybe<SegmentsMutationResponse>;
  /** delete single row from the table: "segments" */
  delete_segments_by_pk: Maybe<Segments>;
  /** delete data from the table: "sync_templates" */
  delete_sync_templates: Maybe<SyncTemplatesMutationResponse>;
  /** delete single row from the table: "sync_templates" */
  delete_sync_templates_by_pk: Maybe<SyncTemplates>;
  /** delete data from the table: "through_model_relationships" */
  delete_through_model_relationships: Maybe<ThroughModelRelationshipsMutationResponse>;
  /** delete single row from the table: "through_model_relationships" */
  delete_through_model_relationships_by_pk: Maybe<ThroughModelRelationships>;
  /** delete data from the table: "trait_definitions" */
  delete_trait_definitions: Maybe<TraitDefinitionsMutationResponse>;
  /** delete single row from the table: "trait_definitions" */
  delete_trait_definitions_by_pk: Maybe<TraitDefinitions>;
  /** delete data from the table: "tunnels" */
  delete_tunnels: Maybe<TunnelsMutationResponse>;
  /** delete single row from the table: "tunnels" */
  delete_tunnels_by_pk: Maybe<Tunnels>;
  discover: Maybe<Scalars['Boolean']>;
  getLoginToken: GetLoginTokenResult;
  /** insert data into the table: "alert_instances" */
  insert_alert_instances: Maybe<AlertInstancesMutationResponse>;
  /** insert a single row into the table: "alert_instances" */
  insert_alert_instances_one: Maybe<AlertInstances>;
  /** insert data into the table: "alerts" */
  insert_alerts: Maybe<AlertsMutationResponse>;
  /** insert a single row into the table: "alerts" */
  insert_alerts_one: Maybe<Alerts>;
  /** insert data into the table: "api_keys" */
  insert_api_keys: Maybe<ApiKeysMutationResponse>;
  /** insert a single row into the table: "api_keys" */
  insert_api_keys_one: Maybe<ApiKeys>;
  /** insert data into the table: "cloud_credentials" */
  insert_cloud_credentials: Maybe<CloudCredentialsMutationResponse>;
  /** insert a single row into the table: "cloud_credentials" */
  insert_cloud_credentials_one: Maybe<CloudCredentials>;
  /** insert data into the table: "column_selectors" */
  insert_column_selectors: Maybe<ColumnSelectorsMutationResponse>;
  /** insert a single row into the table: "column_selectors" */
  insert_column_selectors_one: Maybe<ColumnSelectors>;
  /** insert data into the table: "connections" */
  insert_connections: Maybe<ConnectionsMutationResponse>;
  /** insert a single row into the table: "connections" */
  insert_connections_one: Maybe<Connections>;
  /** insert data into the table: "datadog_credentials" */
  insert_datadog_credentials: Maybe<DatadogCredentialsMutationResponse>;
  /** insert a single row into the table: "datadog_credentials" */
  insert_datadog_credentials_one: Maybe<DatadogCredentials>;
  /** insert data into the table: "dbt_sync_config" */
  insert_dbt_sync_config: Maybe<DbtSyncConfigMutationResponse>;
  /** insert a single row into the table: "dbt_sync_config" */
  insert_dbt_sync_config_one: Maybe<DbtSyncConfig>;
  /** insert data into the table: "destination_instances" */
  insert_destination_instances: Maybe<DestinationInstancesMutationResponse>;
  /** insert a single row into the table: "destination_instances" */
  insert_destination_instances_one: Maybe<DestinationInstances>;
  /** insert data into the table: "destinations" */
  insert_destinations: Maybe<DestinationsMutationResponse>;
  /** insert a single row into the table: "destinations" */
  insert_destinations_one: Maybe<Destinations>;
  /** insert data into the table: "direct_model_relationships" */
  insert_direct_model_relationships: Maybe<DirectModelRelationshipsMutationResponse>;
  /** insert a single row into the table: "direct_model_relationships" */
  insert_direct_model_relationships_one: Maybe<DirectModelRelationships>;
  /** insert data into the table: "event_definitions" */
  insert_event_definitions: Maybe<EventDefinitionsMutationResponse>;
  /** insert a single row into the table: "event_definitions" */
  insert_event_definitions_one: Maybe<EventDefinitions>;
  /** insert data into the table: "event_models" */
  insert_event_models: Maybe<EventModelsMutationResponse>;
  /** insert a single row into the table: "event_models" */
  insert_event_models_one: Maybe<EventModels>;
  /** insert data into the table: "external_buckets" */
  insert_external_buckets: Maybe<ExternalBucketsMutationResponse>;
  /** insert a single row into the table: "external_buckets" */
  insert_external_buckets_one: Maybe<ExternalBuckets>;
  /** insert data into the table: "git_credentials" */
  insert_git_credentials: Maybe<GitCredentialsMutationResponse>;
  /** insert a single row into the table: "git_credentials" */
  insert_git_credentials_one: Maybe<GitCredentials>;
  /** insert data into the table: "git_sync_config" */
  insert_git_sync_config: Maybe<GitSyncConfigMutationResponse>;
  /** insert a single row into the table: "git_sync_config" */
  insert_git_sync_config_one: Maybe<GitSyncConfig>;
  /** insert data into the table: "git_sync_configs" */
  insert_git_sync_configs: Maybe<GitSyncConfigsMutationResponse>;
  /** insert a single row into the table: "git_sync_configs" */
  insert_git_sync_configs_one: Maybe<GitSyncConfigs>;
  /** insert data into the table: "looker_credentials" */
  insert_looker_credentials: Maybe<LookerCredentialsMutationResponse>;
  /** insert a single row into the table: "looker_credentials" */
  insert_looker_credentials_one: Maybe<LookerCredentials>;
  /** insert data into the table: "model_columns" */
  insert_model_columns: Maybe<ModelColumnsMutationResponse>;
  /** insert a single row into the table: "model_columns" */
  insert_model_columns_one: Maybe<ModelColumns>;
  /** insert data into the table: "model_relationships" */
  insert_model_relationships: Maybe<ModelRelationshipsMutationResponse>;
  /** insert a single row into the table: "model_relationships" */
  insert_model_relationships_one: Maybe<ModelRelationships>;
  /** insert data into the table: "object_schemas" */
  insert_object_schemas: Maybe<ObjectSchemasMutationResponse>;
  /** insert a single row into the table: "object_schemas" */
  insert_object_schemas_one: Maybe<ObjectSchemas>;
  /** insert data into the table: "pagerduty_credentials" */
  insert_pagerduty_credentials: Maybe<PagerdutyCredentialsMutationResponse>;
  /** insert a single row into the table: "pagerduty_credentials" */
  insert_pagerduty_credentials_one: Maybe<PagerdutyCredentials>;
  /** insert data into the table: "relationship_references" */
  insert_relationship_references: Maybe<RelationshipReferencesMutationResponse>;
  /** insert a single row into the table: "relationship_references" */
  insert_relationship_references_one: Maybe<RelationshipReferences>;
  /** insert data into the table: "relationships" */
  insert_relationships: Maybe<RelationshipsMutationResponse>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one: Maybe<Relationships>;
  /** insert data into the table: "resource_views" */
  insert_resource_views: Maybe<ResourceViewsMutationResponse>;
  /** insert a single row into the table: "resource_views" */
  insert_resource_views_one: Maybe<ResourceViews>;
  /** insert data into the table: "roles" */
  insert_roles: Maybe<RolesMutationResponse>;
  /** insert a single row into the table: "roles" */
  insert_roles_one: Maybe<Roles>;
  /** insert data into the table: "saved_queries" */
  insert_saved_queries: Maybe<SavedQueriesMutationResponse>;
  /** insert a single row into the table: "saved_queries" */
  insert_saved_queries_one: Maybe<SavedQueries>;
  /** insert data into the table: "segments" */
  insert_segments: Maybe<SegmentsMutationResponse>;
  /** insert a single row into the table: "segments" */
  insert_segments_one: Maybe<Segments>;
  /** insert data into the table: "sync_templates" */
  insert_sync_templates: Maybe<SyncTemplatesMutationResponse>;
  /** insert a single row into the table: "sync_templates" */
  insert_sync_templates_one: Maybe<SyncTemplates>;
  /** insert data into the table: "through_model_relationships" */
  insert_through_model_relationships: Maybe<ThroughModelRelationshipsMutationResponse>;
  /** insert a single row into the table: "through_model_relationships" */
  insert_through_model_relationships_one: Maybe<ThroughModelRelationships>;
  /** insert data into the table: "trait_definitions" */
  insert_trait_definitions: Maybe<TraitDefinitionsMutationResponse>;
  /** insert a single row into the table: "trait_definitions" */
  insert_trait_definitions_one: Maybe<TraitDefinitions>;
  /** insert data into the table: "tunnels" */
  insert_tunnels: Maybe<TunnelsMutationResponse>;
  /** insert a single row into the table: "tunnels" */
  insert_tunnels_one: Maybe<Tunnels>;
  joinWorkspaceWithAutojoin: Maybe<Scalars['Boolean']>;
  partnerConnectLinkNewWorkspace: Scalars['Int'];
  partnerConnectLinkWorkspace: Maybe<Scalars['Void']>;
  requestMediaUpload: Maybe<RequestMediaUploadResult>;
  requestMembership: Maybe<Scalars['Boolean']>;
  sendInvite: Maybe<Scalars['Boolean']>;
  setupInWarehouseDiffingForSource: SetupInWarehouseDiffingForSourceOutput;
  setupInWarehouseDiffingWithCredentials: SetupInWarehouseDiffingWithCredentialsOutput;
  startSyncRun: StartSyncRunOutput;
  testDestinationConnection: Maybe<TestDestinationConnectionResponse>;
  testNewDestination: Maybe<TestDestinationResponse>;
  testNewSource: Maybe<SourceTestResult>;
  testUpdatedDestination: Maybe<TestDestinationResponse>;
  testUpdatedSource: Maybe<SourceTestResult>;
  updateDBTCredential: DbtCredential;
  updateDestinationWithSecrets: DestinationResult;
  updateWorkspaceDomains: Maybe<Scalars['Boolean']>;
  /** update data of the table: "alert_instances" */
  update_alert_instances: Maybe<AlertInstancesMutationResponse>;
  /** update data of the table: "alerts" */
  update_alerts: Maybe<AlertsMutationResponse>;
  /** update single row of the table: "alerts" */
  update_alerts_by_pk: Maybe<Alerts>;
  /** update data of the table: "cloud_credentials" */
  update_cloud_credentials: Maybe<CloudCredentialsMutationResponse>;
  /** update single row of the table: "cloud_credentials" */
  update_cloud_credentials_by_pk: Maybe<CloudCredentials>;
  /** update data of the table: "column_selectors" */
  update_column_selectors: Maybe<ColumnSelectorsMutationResponse>;
  /** update single row of the table: "column_selectors" */
  update_column_selectors_by_pk: Maybe<ColumnSelectors>;
  /** update data of the table: "connections" */
  update_connections: Maybe<ConnectionsMutationResponse>;
  /** update single row of the table: "connections" */
  update_connections_by_pk: Maybe<Connections>;
  /** update data of the table: "datadog_credentials" */
  update_datadog_credentials: Maybe<DatadogCredentialsMutationResponse>;
  /** update single row of the table: "datadog_credentials" */
  update_datadog_credentials_by_pk: Maybe<DatadogCredentials>;
  /** update data of the table: "dbt_sync_config" */
  update_dbt_sync_config: Maybe<DbtSyncConfigMutationResponse>;
  /** update single row of the table: "dbt_sync_config" */
  update_dbt_sync_config_by_pk: Maybe<DbtSyncConfig>;
  /** update data of the table: "destination_instances" */
  update_destination_instances: Maybe<DestinationInstancesMutationResponse>;
  /** update single row of the table: "destination_instances" */
  update_destination_instances_by_pk: Maybe<DestinationInstances>;
  /** update data of the table: "destinations" */
  update_destinations: Maybe<DestinationsMutationResponse>;
  /** update single row of the table: "destinations" */
  update_destinations_by_pk: Maybe<Destinations>;
  /** update data of the table: "direct_model_relationships" */
  update_direct_model_relationships: Maybe<DirectModelRelationshipsMutationResponse>;
  /** update single row of the table: "direct_model_relationships" */
  update_direct_model_relationships_by_pk: Maybe<DirectModelRelationships>;
  /** update data of the table: "event_definitions" */
  update_event_definitions: Maybe<EventDefinitionsMutationResponse>;
  /** update single row of the table: "event_definitions" */
  update_event_definitions_by_pk: Maybe<EventDefinitions>;
  /** update data of the table: "event_models" */
  update_event_models: Maybe<EventModelsMutationResponse>;
  /** update single row of the table: "event_models" */
  update_event_models_by_pk: Maybe<EventModels>;
  /** update data of the table: "external_buckets" */
  update_external_buckets: Maybe<ExternalBucketsMutationResponse>;
  /** update single row of the table: "external_buckets" */
  update_external_buckets_by_pk: Maybe<ExternalBuckets>;
  /** update data of the table: "git_credentials" */
  update_git_credentials: Maybe<GitCredentialsMutationResponse>;
  /** update single row of the table: "git_credentials" */
  update_git_credentials_by_pk: Maybe<GitCredentials>;
  /** update data of the table: "git_sync_config" */
  update_git_sync_config: Maybe<GitSyncConfigMutationResponse>;
  /** update single row of the table: "git_sync_config" */
  update_git_sync_config_by_pk: Maybe<GitSyncConfig>;
  /** update data of the table: "git_sync_configs" */
  update_git_sync_configs: Maybe<GitSyncConfigsMutationResponse>;
  /** update single row of the table: "git_sync_configs" */
  update_git_sync_configs_by_pk: Maybe<GitSyncConfigs>;
  /** update data of the table: "looker_credentials" */
  update_looker_credentials: Maybe<LookerCredentialsMutationResponse>;
  /** update single row of the table: "looker_credentials" */
  update_looker_credentials_by_pk: Maybe<LookerCredentials>;
  /** update data of the table: "memberships" */
  update_memberships: Maybe<MembershipsMutationResponse>;
  /** update single row of the table: "memberships" */
  update_memberships_by_pk: Maybe<Memberships>;
  /** update data of the table: "model_columns" */
  update_model_columns: Maybe<ModelColumnsMutationResponse>;
  /** update single row of the table: "model_columns" */
  update_model_columns_by_pk: Maybe<ModelColumns>;
  /** update data of the table: "model_relationships" */
  update_model_relationships: Maybe<ModelRelationshipsMutationResponse>;
  /** update single row of the table: "model_relationships" */
  update_model_relationships_by_pk: Maybe<ModelRelationships>;
  /** update data of the table: "object_definitions" */
  update_object_definitions: Maybe<ObjectDefinitionsMutationResponse>;
  /** update single row of the table: "object_definitions" */
  update_object_definitions_by_pk: Maybe<ObjectDefinitions>;
  /** update data of the table: "pagerduty_credentials" */
  update_pagerduty_credentials: Maybe<PagerdutyCredentialsMutationResponse>;
  /** update single row of the table: "pagerduty_credentials" */
  update_pagerduty_credentials_by_pk: Maybe<PagerdutyCredentials>;
  /** update data of the table: "relationship_references" */
  update_relationship_references: Maybe<RelationshipReferencesMutationResponse>;
  /** update single row of the table: "relationship_references" */
  update_relationship_references_by_pk: Maybe<RelationshipReferences>;
  /** update data of the table: "relationships" */
  update_relationships: Maybe<RelationshipsMutationResponse>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk: Maybe<Relationships>;
  /** update data of the table: "resource_views" */
  update_resource_views: Maybe<ResourceViewsMutationResponse>;
  /** update single row of the table: "resource_views" */
  update_resource_views_by_pk: Maybe<ResourceViews>;
  /** update data of the table: "roles" */
  update_roles: Maybe<RolesMutationResponse>;
  /** update single row of the table: "roles" */
  update_roles_by_pk: Maybe<Roles>;
  /** update data of the table: "saved_queries" */
  update_saved_queries: Maybe<SavedQueriesMutationResponse>;
  /** update single row of the table: "saved_queries" */
  update_saved_queries_by_pk: Maybe<SavedQueries>;
  /** update data of the table: "segments" */
  update_segments: Maybe<SegmentsMutationResponse>;
  /** update single row of the table: "segments" */
  update_segments_by_pk: Maybe<Segments>;
  /** update data of the table: "slack_credentials" */
  update_slack_credentials: Maybe<SlackCredentialsMutationResponse>;
  /** update single row of the table: "slack_credentials" */
  update_slack_credentials_by_pk: Maybe<SlackCredentials>;
  /** update data of the table: "sync_requests" */
  update_sync_requests: Maybe<SyncRequestsMutationResponse>;
  /** update single row of the table: "sync_requests" */
  update_sync_requests_by_pk: Maybe<SyncRequests>;
  /** update data of the table: "sync_templates" */
  update_sync_templates: Maybe<SyncTemplatesMutationResponse>;
  /** update single row of the table: "sync_templates" */
  update_sync_templates_by_pk: Maybe<SyncTemplates>;
  /** update data of the table: "through_model_relationships" */
  update_through_model_relationships: Maybe<ThroughModelRelationshipsMutationResponse>;
  /** update single row of the table: "through_model_relationships" */
  update_through_model_relationships_by_pk: Maybe<ThroughModelRelationships>;
  /** update data of the table: "trait_definitions" */
  update_trait_definitions: Maybe<TraitDefinitionsMutationResponse>;
  /** update single row of the table: "trait_definitions" */
  update_trait_definitions_by_pk: Maybe<TraitDefinitions>;
  /** update data of the table: "tunnels" */
  update_tunnels: Maybe<TunnelsMutationResponse>;
  /** update single row of the table: "tunnels" */
  update_tunnels_by_pk: Maybe<Tunnels>;
  /** update data of the table: "users" */
  update_users: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  update_users_by_pk: Maybe<Users>;
  /** update data of the table: "workspaces" */
  update_workspaces: Maybe<WorkspacesMutationResponse>;
  /** update single row of the table: "workspaces" */
  update_workspaces_by_pk: Maybe<Workspaces>;
};


/** mutation root */
export type MutationApproveMembershipArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type MutationCreateDbtCredentialArgs = {
  apiKey?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
};


/** mutation root */
export type MutationCreateDestinationWithSecretsArgs = {
  destination: DestinationsMutationInput;
};


/** mutation root */
export type MutationCreateFeatureRequestArgs = {
  description: Scalars['String'];
};


/** mutation root */
export type MutationCreateFeedbackArgs = {
  description: Scalars['String'];
};


/** mutation root */
export type MutationCreateIntegrationRequestArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationRequestType;
};


/** mutation root */
export type MutationCreateNormalTunnelArgs = {
  input: NormalTunnelInput;
};


/** mutation root */
export type MutationCreateReverseTunnelArgs = {
  input: ReverseTunnelInput;
};


/** mutation root */
export type MutationCreateWorkspaceArgs = {
  name: Scalars['String'];
  organization?: Maybe<Scalars['Int']>;
  region: Scalars['String'];
  slug: Scalars['String'];
};


/** mutation root */
export type MutationDeleteTunnelArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteAlertInstancesArgs = {
  where: AlertInstancesBoolExp;
};


/** mutation root */
export type MutationDeleteAlertsArgs = {
  where: AlertsBoolExp;
};


/** mutation root */
export type MutationDeleteAlertsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteApiKeysArgs = {
  where: ApiKeysBoolExp;
};


/** mutation root */
export type MutationDeleteApiKeysByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteCloudCredentialsArgs = {
  where: CloudCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteCloudCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteColumnSelectorsArgs = {
  where: ColumnSelectorsBoolExp;
};


/** mutation root */
export type MutationDeleteColumnSelectorsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteConnectionsArgs = {
  where: ConnectionsBoolExp;
};


/** mutation root */
export type MutationDeleteConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDbtSyncConfigArgs = {
  where: DbtSyncConfigBoolExp;
};


/** mutation root */
export type MutationDeleteDbtSyncConfigByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDestinationInstancesArgs = {
  where: DestinationInstancesBoolExp;
};


/** mutation root */
export type MutationDeleteDestinationInstancesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDestinationsArgs = {
  where: DestinationsBoolExp;
};


/** mutation root */
export type MutationDeleteDestinationsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDirectModelRelationshipsArgs = {
  where: DirectModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteDirectModelRelationshipsByPkArgs = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventDefinitionsArgs = {
  where: EventDefinitionsBoolExp;
};


/** mutation root */
export type MutationDeleteEventDefinitionsByPkArgs = {
  object_definition_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteExternalBucketsArgs = {
  where: ExternalBucketsBoolExp;
};


/** mutation root */
export type MutationDeleteExternalBucketsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteExternalSegmentsArgs = {
  where: ExternalSegmentsBoolExp;
};


/** mutation root */
export type MutationDeleteExternalSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteGitCredentialsArgs = {
  where: GitCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteGitCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteGitSyncConfigsArgs = {
  where: GitSyncConfigsBoolExp;
};


/** mutation root */
export type MutationDeleteGitSyncConfigsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteLookerCredentialsArgs = {
  where: LookerCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteLookerCredentialsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationDeleteMembershipRequestsArgs = {
  where: MembershipRequestsBoolExp;
};


/** mutation root */
export type MutationDeleteMembershipRequestsByPkArgs = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteMembershipsArgs = {
  where: MembershipsBoolExp;
};


/** mutation root */
export type MutationDeleteMembershipsByPkArgs = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteModelColumnsArgs = {
  where: ModelColumnsBoolExp;
};


/** mutation root */
export type MutationDeleteModelColumnsByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationDeleteModelRelationshipsArgs = {
  where: ModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteModelRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteOutboundUserInvitesArgs = {
  where: OutboundUserInvitesBoolExp;
};


/** mutation root */
export type MutationDeleteOutboundUserInvitesByPkArgs = {
  recipient_email: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteRelationshipReferencesArgs = {
  where: RelationshipReferencesBoolExp;
};


/** mutation root */
export type MutationDeleteRelationshipReferencesByPkArgs = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


/** mutation root */
export type MutationDeleteRelationshipsArgs = {
  where: RelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteResourceViewsArgs = {
  where: ResourceViewsBoolExp;
};


/** mutation root */
export type MutationDeleteResourceViewsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteRolesArgs = {
  where: RolesBoolExp;
};


/** mutation root */
export type MutationDeleteRolesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSavedQueriesArgs = {
  where: SavedQueriesBoolExp;
};


/** mutation root */
export type MutationDeleteSavedQueriesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSegmentsArgs = {
  where: SegmentsBoolExp;
};


/** mutation root */
export type MutationDeleteSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSyncTemplatesArgs = {
  where: SyncTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteSyncTemplatesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationDeleteThroughModelRelationshipsArgs = {
  where: ThroughModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteThroughModelRelationshipsByPkArgs = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteTraitDefinitionsArgs = {
  where: TraitDefinitionsBoolExp;
};


/** mutation root */
export type MutationDeleteTraitDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteTunnelsArgs = {
  where: TunnelsBoolExp;
};


/** mutation root */
export type MutationDeleteTunnelsByPkArgs = {
  tunnel_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDiscoverArgs = {
  connectionId: Scalars['String'];
};


/** mutation root */
export type MutationInsertAlertInstancesArgs = {
  objects: Array<AlertInstancesInsertInput>;
  on_conflict?: Maybe<AlertInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertAlertInstancesOneArgs = {
  object: AlertInstancesInsertInput;
  on_conflict?: Maybe<AlertInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertAlertsArgs = {
  objects: Array<AlertsInsertInput>;
  on_conflict?: Maybe<AlertsOnConflict>;
};


/** mutation root */
export type MutationInsertAlertsOneArgs = {
  object: AlertsInsertInput;
  on_conflict?: Maybe<AlertsOnConflict>;
};


/** mutation root */
export type MutationInsertApiKeysArgs = {
  objects: Array<ApiKeysInsertInput>;
};


/** mutation root */
export type MutationInsertApiKeysOneArgs = {
  object: ApiKeysInsertInput;
};


/** mutation root */
export type MutationInsertCloudCredentialsArgs = {
  objects: Array<CloudCredentialsInsertInput>;
  on_conflict?: Maybe<CloudCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertCloudCredentialsOneArgs = {
  object: CloudCredentialsInsertInput;
  on_conflict?: Maybe<CloudCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertColumnSelectorsArgs = {
  objects: Array<ColumnSelectorsInsertInput>;
  on_conflict?: Maybe<ColumnSelectorsOnConflict>;
};


/** mutation root */
export type MutationInsertColumnSelectorsOneArgs = {
  object: ColumnSelectorsInsertInput;
  on_conflict?: Maybe<ColumnSelectorsOnConflict>;
};


/** mutation root */
export type MutationInsertConnectionsArgs = {
  objects: Array<ConnectionsInsertInput>;
  on_conflict?: Maybe<ConnectionsOnConflict>;
};


/** mutation root */
export type MutationInsertConnectionsOneArgs = {
  object: ConnectionsInsertInput;
  on_conflict?: Maybe<ConnectionsOnConflict>;
};


/** mutation root */
export type MutationInsertDatadogCredentialsArgs = {
  objects: Array<DatadogCredentialsInsertInput>;
  on_conflict?: Maybe<DatadogCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertDatadogCredentialsOneArgs = {
  object: DatadogCredentialsInsertInput;
  on_conflict?: Maybe<DatadogCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertDbtSyncConfigArgs = {
  objects: Array<DbtSyncConfigInsertInput>;
  on_conflict?: Maybe<DbtSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertDbtSyncConfigOneArgs = {
  object: DbtSyncConfigInsertInput;
  on_conflict?: Maybe<DbtSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationInstancesArgs = {
  objects: Array<DestinationInstancesInsertInput>;
  on_conflict?: Maybe<DestinationInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationInstancesOneArgs = {
  object: DestinationInstancesInsertInput;
  on_conflict?: Maybe<DestinationInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationsArgs = {
  objects: Array<DestinationsInsertInput>;
  on_conflict?: Maybe<DestinationsOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationsOneArgs = {
  object: DestinationsInsertInput;
  on_conflict?: Maybe<DestinationsOnConflict>;
};


/** mutation root */
export type MutationInsertDirectModelRelationshipsArgs = {
  objects: Array<DirectModelRelationshipsInsertInput>;
  on_conflict?: Maybe<DirectModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertDirectModelRelationshipsOneArgs = {
  object: DirectModelRelationshipsInsertInput;
  on_conflict?: Maybe<DirectModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertEventDefinitionsArgs = {
  objects: Array<EventDefinitionsInsertInput>;
  on_conflict?: Maybe<EventDefinitionsOnConflict>;
};


/** mutation root */
export type MutationInsertEventDefinitionsOneArgs = {
  object: EventDefinitionsInsertInput;
  on_conflict?: Maybe<EventDefinitionsOnConflict>;
};


/** mutation root */
export type MutationInsertEventModelsArgs = {
  objects: Array<EventModelsInsertInput>;
  on_conflict?: Maybe<EventModelsOnConflict>;
};


/** mutation root */
export type MutationInsertEventModelsOneArgs = {
  object: EventModelsInsertInput;
  on_conflict?: Maybe<EventModelsOnConflict>;
};


/** mutation root */
export type MutationInsertExternalBucketsArgs = {
  objects: Array<ExternalBucketsInsertInput>;
  on_conflict?: Maybe<ExternalBucketsOnConflict>;
};


/** mutation root */
export type MutationInsertExternalBucketsOneArgs = {
  object: ExternalBucketsInsertInput;
  on_conflict?: Maybe<ExternalBucketsOnConflict>;
};


/** mutation root */
export type MutationInsertGitCredentialsArgs = {
  objects: Array<GitCredentialsInsertInput>;
  on_conflict?: Maybe<GitCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertGitCredentialsOneArgs = {
  object: GitCredentialsInsertInput;
  on_conflict?: Maybe<GitCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertGitSyncConfigArgs = {
  objects: Array<GitSyncConfigInsertInput>;
  on_conflict?: Maybe<GitSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertGitSyncConfigOneArgs = {
  object: GitSyncConfigInsertInput;
  on_conflict?: Maybe<GitSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertGitSyncConfigsArgs = {
  objects: Array<GitSyncConfigsInsertInput>;
  on_conflict?: Maybe<GitSyncConfigsOnConflict>;
};


/** mutation root */
export type MutationInsertGitSyncConfigsOneArgs = {
  object: GitSyncConfigsInsertInput;
  on_conflict?: Maybe<GitSyncConfigsOnConflict>;
};


/** mutation root */
export type MutationInsertLookerCredentialsArgs = {
  objects: Array<LookerCredentialsInsertInput>;
  on_conflict?: Maybe<LookerCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertLookerCredentialsOneArgs = {
  object: LookerCredentialsInsertInput;
  on_conflict?: Maybe<LookerCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertModelColumnsArgs = {
  objects: Array<ModelColumnsInsertInput>;
  on_conflict?: Maybe<ModelColumnsOnConflict>;
};


/** mutation root */
export type MutationInsertModelColumnsOneArgs = {
  object: ModelColumnsInsertInput;
  on_conflict?: Maybe<ModelColumnsOnConflict>;
};


/** mutation root */
export type MutationInsertModelRelationshipsArgs = {
  objects: Array<ModelRelationshipsInsertInput>;
  on_conflict?: Maybe<ModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertModelRelationshipsOneArgs = {
  object: ModelRelationshipsInsertInput;
  on_conflict?: Maybe<ModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertObjectSchemasArgs = {
  objects: Array<ObjectSchemasInsertInput>;
};


/** mutation root */
export type MutationInsertObjectSchemasOneArgs = {
  object: ObjectSchemasInsertInput;
};


/** mutation root */
export type MutationInsertPagerdutyCredentialsArgs = {
  objects: Array<PagerdutyCredentialsInsertInput>;
  on_conflict?: Maybe<PagerdutyCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertPagerdutyCredentialsOneArgs = {
  object: PagerdutyCredentialsInsertInput;
  on_conflict?: Maybe<PagerdutyCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipReferencesArgs = {
  objects: Array<RelationshipReferencesInsertInput>;
  on_conflict?: Maybe<RelationshipReferencesOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipReferencesOneArgs = {
  object: RelationshipReferencesInsertInput;
  on_conflict?: Maybe<RelationshipReferencesOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipsArgs = {
  objects: Array<RelationshipsInsertInput>;
  on_conflict?: Maybe<RelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipsOneArgs = {
  object: RelationshipsInsertInput;
  on_conflict?: Maybe<RelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceViewsArgs = {
  objects: Array<ResourceViewsInsertInput>;
  on_conflict?: Maybe<ResourceViewsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceViewsOneArgs = {
  object: ResourceViewsInsertInput;
  on_conflict?: Maybe<ResourceViewsOnConflict>;
};


/** mutation root */
export type MutationInsertRolesArgs = {
  objects: Array<RolesInsertInput>;
  on_conflict?: Maybe<RolesOnConflict>;
};


/** mutation root */
export type MutationInsertRolesOneArgs = {
  object: RolesInsertInput;
  on_conflict?: Maybe<RolesOnConflict>;
};


/** mutation root */
export type MutationInsertSavedQueriesArgs = {
  objects: Array<SavedQueriesInsertInput>;
  on_conflict?: Maybe<SavedQueriesOnConflict>;
};


/** mutation root */
export type MutationInsertSavedQueriesOneArgs = {
  object: SavedQueriesInsertInput;
  on_conflict?: Maybe<SavedQueriesOnConflict>;
};


/** mutation root */
export type MutationInsertSegmentsArgs = {
  objects: Array<SegmentsInsertInput>;
  on_conflict?: Maybe<SegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertSegmentsOneArgs = {
  object: SegmentsInsertInput;
  on_conflict?: Maybe<SegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertSyncTemplatesArgs = {
  objects: Array<SyncTemplatesInsertInput>;
  on_conflict?: Maybe<SyncTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertSyncTemplatesOneArgs = {
  object: SyncTemplatesInsertInput;
  on_conflict?: Maybe<SyncTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertThroughModelRelationshipsArgs = {
  objects: Array<ThroughModelRelationshipsInsertInput>;
  on_conflict?: Maybe<ThroughModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertThroughModelRelationshipsOneArgs = {
  object: ThroughModelRelationshipsInsertInput;
  on_conflict?: Maybe<ThroughModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertTraitDefinitionsArgs = {
  objects: Array<TraitDefinitionsInsertInput>;
  on_conflict?: Maybe<TraitDefinitionsOnConflict>;
};


/** mutation root */
export type MutationInsertTraitDefinitionsOneArgs = {
  object: TraitDefinitionsInsertInput;
  on_conflict?: Maybe<TraitDefinitionsOnConflict>;
};


/** mutation root */
export type MutationInsertTunnelsArgs = {
  objects: Array<TunnelsInsertInput>;
  on_conflict?: Maybe<TunnelsOnConflict>;
};


/** mutation root */
export type MutationInsertTunnelsOneArgs = {
  object: TunnelsInsertInput;
  on_conflict?: Maybe<TunnelsOnConflict>;
};


/** mutation root */
export type MutationJoinWorkspaceWithAutojoinArgs = {
  workspaceId: Scalars['String'];
};


/** mutation root */
export type MutationPartnerConnectLinkNewWorkspaceArgs = {
  name: Scalars['String'];
  slug: Scalars['String'];
  uuid: Scalars['String'];
};


/** mutation root */
export type MutationPartnerConnectLinkWorkspaceArgs = {
  uuid: Scalars['String'];
  workspaceId: Scalars['Int'];
};


/** mutation root */
export type MutationRequestMediaUploadArgs = {
  input: RequestMediaUploadInput;
};


/** mutation root */
export type MutationRequestMembershipArgs = {
  partnerConnectionId?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
};


/** mutation root */
export type MutationSendInviteArgs = {
  recipientEmail: Scalars['String'];
  recipientRoleID: Scalars['Int'];
};


/** mutation root */
export type MutationSetupInWarehouseDiffingForSourceArgs = {
  plannerDatabase?: Maybe<Scalars['String']>;
  sourceId: Scalars['String'];
};


/** mutation root */
export type MutationSetupInWarehouseDiffingWithCredentialsArgs = {
  configurationJson: Scalars['String'];
  credentialId?: Maybe<Scalars['Int']>;
  plannerDatabase?: Maybe<Scalars['String']>;
  tunnelId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


/** mutation root */
export type MutationStartSyncRunArgs = {
  fullResync?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


/** mutation root */
export type MutationTestDestinationConnectionArgs = {
  configuration?: Maybe<Scalars['JSONObject']>;
  destinationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};


/** mutation root */
export type MutationTestNewDestinationArgs = {
  configuration: Scalars['JSONObject'];
  type: Scalars['String'];
};


/** mutation root */
export type MutationTestNewSourceArgs = {
  configuration: Scalars['JSONObject'];
  credentialId?: Maybe<Scalars['Int']>;
  tunnelId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


/** mutation root */
export type MutationTestUpdatedDestinationArgs = {
  destinationId: Scalars['String'];
  newConfiguration: Scalars['JSONObject'];
};


/** mutation root */
export type MutationTestUpdatedSourceArgs = {
  credentialId?: Maybe<Scalars['Int']>;
  newConfiguration: Scalars['JSONObject'];
  sourceId: Scalars['String'];
  tunnelId?: Maybe<Scalars['String']>;
};


/** mutation root */
export type MutationUpdateDbtCredentialArgs = {
  apiKey: Scalars['String'];
  dbtCredentialId: Scalars['Int'];
  subdomain?: Maybe<Scalars['String']>;
};


/** mutation root */
export type MutationUpdateDestinationWithSecretsArgs = {
  destination: DestinationsMutationInput;
  destinationId: Scalars['String'];
};


/** mutation root */
export type MutationUpdateWorkspaceDomainsArgs = {
  joinableTo?: Maybe<Array<Scalars['String']>>;
  visibleTo?: Maybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationUpdateAlertInstancesArgs = {
  _set?: Maybe<AlertInstancesSetInput>;
  where: AlertInstancesBoolExp;
};


/** mutation root */
export type MutationUpdateAlertsArgs = {
  _append?: Maybe<AlertsAppendInput>;
  _delete_at_path?: Maybe<AlertsDeleteAtPathInput>;
  _delete_elem?: Maybe<AlertsDeleteElemInput>;
  _delete_key?: Maybe<AlertsDeleteKeyInput>;
  _inc?: Maybe<AlertsIncInput>;
  _prepend?: Maybe<AlertsPrependInput>;
  _set?: Maybe<AlertsSetInput>;
  where: AlertsBoolExp;
};


/** mutation root */
export type MutationUpdateAlertsByPkArgs = {
  _append?: Maybe<AlertsAppendInput>;
  _delete_at_path?: Maybe<AlertsDeleteAtPathInput>;
  _delete_elem?: Maybe<AlertsDeleteElemInput>;
  _delete_key?: Maybe<AlertsDeleteKeyInput>;
  _inc?: Maybe<AlertsIncInput>;
  _prepend?: Maybe<AlertsPrependInput>;
  _set?: Maybe<AlertsSetInput>;
  pk_columns: AlertsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCloudCredentialsArgs = {
  _append?: Maybe<CloudCredentialsAppendInput>;
  _delete_at_path?: Maybe<CloudCredentialsDeleteAtPathInput>;
  _delete_elem?: Maybe<CloudCredentialsDeleteElemInput>;
  _delete_key?: Maybe<CloudCredentialsDeleteKeyInput>;
  _prepend?: Maybe<CloudCredentialsPrependInput>;
  _set?: Maybe<CloudCredentialsSetInput>;
  where: CloudCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateCloudCredentialsByPkArgs = {
  _append?: Maybe<CloudCredentialsAppendInput>;
  _delete_at_path?: Maybe<CloudCredentialsDeleteAtPathInput>;
  _delete_elem?: Maybe<CloudCredentialsDeleteElemInput>;
  _delete_key?: Maybe<CloudCredentialsDeleteKeyInput>;
  _prepend?: Maybe<CloudCredentialsPrependInput>;
  _set?: Maybe<CloudCredentialsSetInput>;
  pk_columns: CloudCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateColumnSelectorsArgs = {
  _inc?: Maybe<ColumnSelectorsIncInput>;
  _set?: Maybe<ColumnSelectorsSetInput>;
  where: ColumnSelectorsBoolExp;
};


/** mutation root */
export type MutationUpdateColumnSelectorsByPkArgs = {
  _inc?: Maybe<ColumnSelectorsIncInput>;
  _set?: Maybe<ColumnSelectorsSetInput>;
  pk_columns: ColumnSelectorsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateConnectionsArgs = {
  _append?: Maybe<ConnectionsAppendInput>;
  _delete_at_path?: Maybe<ConnectionsDeleteAtPathInput>;
  _delete_elem?: Maybe<ConnectionsDeleteElemInput>;
  _delete_key?: Maybe<ConnectionsDeleteKeyInput>;
  _inc?: Maybe<ConnectionsIncInput>;
  _prepend?: Maybe<ConnectionsPrependInput>;
  _set?: Maybe<ConnectionsSetInput>;
  where: ConnectionsBoolExp;
};


/** mutation root */
export type MutationUpdateConnectionsByPkArgs = {
  _append?: Maybe<ConnectionsAppendInput>;
  _delete_at_path?: Maybe<ConnectionsDeleteAtPathInput>;
  _delete_elem?: Maybe<ConnectionsDeleteElemInput>;
  _delete_key?: Maybe<ConnectionsDeleteKeyInput>;
  _inc?: Maybe<ConnectionsIncInput>;
  _prepend?: Maybe<ConnectionsPrependInput>;
  _set?: Maybe<ConnectionsSetInput>;
  pk_columns: ConnectionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDatadogCredentialsArgs = {
  _set?: Maybe<DatadogCredentialsSetInput>;
  where: DatadogCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateDatadogCredentialsByPkArgs = {
  _set?: Maybe<DatadogCredentialsSetInput>;
  pk_columns: DatadogCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDbtSyncConfigArgs = {
  _append?: Maybe<DbtSyncConfigAppendInput>;
  _delete_at_path?: Maybe<DbtSyncConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<DbtSyncConfigDeleteElemInput>;
  _delete_key?: Maybe<DbtSyncConfigDeleteKeyInput>;
  _inc?: Maybe<DbtSyncConfigIncInput>;
  _prepend?: Maybe<DbtSyncConfigPrependInput>;
  _set?: Maybe<DbtSyncConfigSetInput>;
  where: DbtSyncConfigBoolExp;
};


/** mutation root */
export type MutationUpdateDbtSyncConfigByPkArgs = {
  _append?: Maybe<DbtSyncConfigAppendInput>;
  _delete_at_path?: Maybe<DbtSyncConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<DbtSyncConfigDeleteElemInput>;
  _delete_key?: Maybe<DbtSyncConfigDeleteKeyInput>;
  _inc?: Maybe<DbtSyncConfigIncInput>;
  _prepend?: Maybe<DbtSyncConfigPrependInput>;
  _set?: Maybe<DbtSyncConfigSetInput>;
  pk_columns: DbtSyncConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDestinationInstancesArgs = {
  _append?: Maybe<DestinationInstancesAppendInput>;
  _delete_at_path?: Maybe<DestinationInstancesDeleteAtPathInput>;
  _delete_elem?: Maybe<DestinationInstancesDeleteElemInput>;
  _delete_key?: Maybe<DestinationInstancesDeleteKeyInput>;
  _inc?: Maybe<DestinationInstancesIncInput>;
  _prepend?: Maybe<DestinationInstancesPrependInput>;
  _set?: Maybe<DestinationInstancesSetInput>;
  where: DestinationInstancesBoolExp;
};


/** mutation root */
export type MutationUpdateDestinationInstancesByPkArgs = {
  _append?: Maybe<DestinationInstancesAppendInput>;
  _delete_at_path?: Maybe<DestinationInstancesDeleteAtPathInput>;
  _delete_elem?: Maybe<DestinationInstancesDeleteElemInput>;
  _delete_key?: Maybe<DestinationInstancesDeleteKeyInput>;
  _inc?: Maybe<DestinationInstancesIncInput>;
  _prepend?: Maybe<DestinationInstancesPrependInput>;
  _set?: Maybe<DestinationInstancesSetInput>;
  pk_columns: DestinationInstancesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDestinationsArgs = {
  _append?: Maybe<DestinationsAppendInput>;
  _delete_at_path?: Maybe<DestinationsDeleteAtPathInput>;
  _delete_elem?: Maybe<DestinationsDeleteElemInput>;
  _delete_key?: Maybe<DestinationsDeleteKeyInput>;
  _inc?: Maybe<DestinationsIncInput>;
  _prepend?: Maybe<DestinationsPrependInput>;
  _set?: Maybe<DestinationsSetInput>;
  where: DestinationsBoolExp;
};


/** mutation root */
export type MutationUpdateDestinationsByPkArgs = {
  _append?: Maybe<DestinationsAppendInput>;
  _delete_at_path?: Maybe<DestinationsDeleteAtPathInput>;
  _delete_elem?: Maybe<DestinationsDeleteElemInput>;
  _delete_key?: Maybe<DestinationsDeleteKeyInput>;
  _inc?: Maybe<DestinationsIncInput>;
  _prepend?: Maybe<DestinationsPrependInput>;
  _set?: Maybe<DestinationsSetInput>;
  pk_columns: DestinationsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDirectModelRelationshipsArgs = {
  _inc?: Maybe<DirectModelRelationshipsIncInput>;
  _set?: Maybe<DirectModelRelationshipsSetInput>;
  where: DirectModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateDirectModelRelationshipsByPkArgs = {
  _inc?: Maybe<DirectModelRelationshipsIncInput>;
  _set?: Maybe<DirectModelRelationshipsSetInput>;
  pk_columns: DirectModelRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventDefinitionsArgs = {
  _inc?: Maybe<EventDefinitionsIncInput>;
  _set?: Maybe<EventDefinitionsSetInput>;
  where: EventDefinitionsBoolExp;
};


/** mutation root */
export type MutationUpdateEventDefinitionsByPkArgs = {
  _inc?: Maybe<EventDefinitionsIncInput>;
  _set?: Maybe<EventDefinitionsSetInput>;
  pk_columns: EventDefinitionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventModelsArgs = {
  _set?: Maybe<EventModelsSetInput>;
  where: EventModelsBoolExp;
};


/** mutation root */
export type MutationUpdateEventModelsByPkArgs = {
  _set?: Maybe<EventModelsSetInput>;
  pk_columns: EventModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateExternalBucketsArgs = {
  _append?: Maybe<ExternalBucketsAppendInput>;
  _delete_at_path?: Maybe<ExternalBucketsDeleteAtPathInput>;
  _delete_elem?: Maybe<ExternalBucketsDeleteElemInput>;
  _delete_key?: Maybe<ExternalBucketsDeleteKeyInput>;
  _inc?: Maybe<ExternalBucketsIncInput>;
  _prepend?: Maybe<ExternalBucketsPrependInput>;
  _set?: Maybe<ExternalBucketsSetInput>;
  where: ExternalBucketsBoolExp;
};


/** mutation root */
export type MutationUpdateExternalBucketsByPkArgs = {
  _append?: Maybe<ExternalBucketsAppendInput>;
  _delete_at_path?: Maybe<ExternalBucketsDeleteAtPathInput>;
  _delete_elem?: Maybe<ExternalBucketsDeleteElemInput>;
  _delete_key?: Maybe<ExternalBucketsDeleteKeyInput>;
  _inc?: Maybe<ExternalBucketsIncInput>;
  _prepend?: Maybe<ExternalBucketsPrependInput>;
  _set?: Maybe<ExternalBucketsSetInput>;
  pk_columns: ExternalBucketsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateGitCredentialsArgs = {
  _set?: Maybe<GitCredentialsSetInput>;
  where: GitCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateGitCredentialsByPkArgs = {
  _set?: Maybe<GitCredentialsSetInput>;
  pk_columns: GitCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateGitSyncConfigArgs = {
  _append?: Maybe<GitSyncConfigAppendInput>;
  _delete_at_path?: Maybe<GitSyncConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<GitSyncConfigDeleteElemInput>;
  _delete_key?: Maybe<GitSyncConfigDeleteKeyInput>;
  _prepend?: Maybe<GitSyncConfigPrependInput>;
  _set?: Maybe<GitSyncConfigSetInput>;
  where: GitSyncConfigBoolExp;
};


/** mutation root */
export type MutationUpdateGitSyncConfigByPkArgs = {
  _append?: Maybe<GitSyncConfigAppendInput>;
  _delete_at_path?: Maybe<GitSyncConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<GitSyncConfigDeleteElemInput>;
  _delete_key?: Maybe<GitSyncConfigDeleteKeyInput>;
  _prepend?: Maybe<GitSyncConfigPrependInput>;
  _set?: Maybe<GitSyncConfigSetInput>;
  pk_columns: GitSyncConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateGitSyncConfigsArgs = {
  _inc?: Maybe<GitSyncConfigsIncInput>;
  _set?: Maybe<GitSyncConfigsSetInput>;
  where: GitSyncConfigsBoolExp;
};


/** mutation root */
export type MutationUpdateGitSyncConfigsByPkArgs = {
  _inc?: Maybe<GitSyncConfigsIncInput>;
  _set?: Maybe<GitSyncConfigsSetInput>;
  pk_columns: GitSyncConfigsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLookerCredentialsArgs = {
  _set?: Maybe<LookerCredentialsSetInput>;
  where: LookerCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateLookerCredentialsByPkArgs = {
  _set?: Maybe<LookerCredentialsSetInput>;
  pk_columns: LookerCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMembershipsArgs = {
  _inc?: Maybe<MembershipsIncInput>;
  _set?: Maybe<MembershipsSetInput>;
  where: MembershipsBoolExp;
};


/** mutation root */
export type MutationUpdateMembershipsByPkArgs = {
  _inc?: Maybe<MembershipsIncInput>;
  _set?: Maybe<MembershipsSetInput>;
  pk_columns: MembershipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateModelColumnsArgs = {
  _inc?: Maybe<ModelColumnsIncInput>;
  _set?: Maybe<ModelColumnsSetInput>;
  where: ModelColumnsBoolExp;
};


/** mutation root */
export type MutationUpdateModelColumnsByPkArgs = {
  _inc?: Maybe<ModelColumnsIncInput>;
  _set?: Maybe<ModelColumnsSetInput>;
  pk_columns: ModelColumnsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateModelRelationshipsArgs = {
  _inc?: Maybe<ModelRelationshipsIncInput>;
  _set?: Maybe<ModelRelationshipsSetInput>;
  where: ModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateModelRelationshipsByPkArgs = {
  _inc?: Maybe<ModelRelationshipsIncInput>;
  _set?: Maybe<ModelRelationshipsSetInput>;
  pk_columns: ModelRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateObjectDefinitionsArgs = {
  _set?: Maybe<ObjectDefinitionsSetInput>;
  where: ObjectDefinitionsBoolExp;
};


/** mutation root */
export type MutationUpdateObjectDefinitionsByPkArgs = {
  _set?: Maybe<ObjectDefinitionsSetInput>;
  pk_columns: ObjectDefinitionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePagerdutyCredentialsArgs = {
  _set?: Maybe<PagerdutyCredentialsSetInput>;
  where: PagerdutyCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdatePagerdutyCredentialsByPkArgs = {
  _set?: Maybe<PagerdutyCredentialsSetInput>;
  pk_columns: PagerdutyCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateRelationshipReferencesArgs = {
  _inc?: Maybe<RelationshipReferencesIncInput>;
  _set?: Maybe<RelationshipReferencesSetInput>;
  where: RelationshipReferencesBoolExp;
};


/** mutation root */
export type MutationUpdateRelationshipReferencesByPkArgs = {
  _inc?: Maybe<RelationshipReferencesIncInput>;
  _set?: Maybe<RelationshipReferencesSetInput>;
  pk_columns: RelationshipReferencesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateRelationshipsArgs = {
  _inc?: Maybe<RelationshipsIncInput>;
  _set?: Maybe<RelationshipsSetInput>;
  where: RelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateRelationshipsByPkArgs = {
  _inc?: Maybe<RelationshipsIncInput>;
  _set?: Maybe<RelationshipsSetInput>;
  pk_columns: RelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateResourceViewsArgs = {
  _append?: Maybe<ResourceViewsAppendInput>;
  _delete_at_path?: Maybe<ResourceViewsDeleteAtPathInput>;
  _delete_elem?: Maybe<ResourceViewsDeleteElemInput>;
  _delete_key?: Maybe<ResourceViewsDeleteKeyInput>;
  _prepend?: Maybe<ResourceViewsPrependInput>;
  _set?: Maybe<ResourceViewsSetInput>;
  where: ResourceViewsBoolExp;
};


/** mutation root */
export type MutationUpdateResourceViewsByPkArgs = {
  _append?: Maybe<ResourceViewsAppendInput>;
  _delete_at_path?: Maybe<ResourceViewsDeleteAtPathInput>;
  _delete_elem?: Maybe<ResourceViewsDeleteElemInput>;
  _delete_key?: Maybe<ResourceViewsDeleteKeyInput>;
  _prepend?: Maybe<ResourceViewsPrependInput>;
  _set?: Maybe<ResourceViewsSetInput>;
  pk_columns: ResourceViewsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateRolesArgs = {
  _append?: Maybe<RolesAppendInput>;
  _delete_at_path?: Maybe<RolesDeleteAtPathInput>;
  _delete_elem?: Maybe<RolesDeleteElemInput>;
  _delete_key?: Maybe<RolesDeleteKeyInput>;
  _prepend?: Maybe<RolesPrependInput>;
  _set?: Maybe<RolesSetInput>;
  where: RolesBoolExp;
};


/** mutation root */
export type MutationUpdateRolesByPkArgs = {
  _append?: Maybe<RolesAppendInput>;
  _delete_at_path?: Maybe<RolesDeleteAtPathInput>;
  _delete_elem?: Maybe<RolesDeleteElemInput>;
  _delete_key?: Maybe<RolesDeleteKeyInput>;
  _prepend?: Maybe<RolesPrependInput>;
  _set?: Maybe<RolesSetInput>;
  pk_columns: RolesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedQueriesArgs = {
  _append?: Maybe<SavedQueriesAppendInput>;
  _delete_at_path?: Maybe<SavedQueriesDeleteAtPathInput>;
  _delete_elem?: Maybe<SavedQueriesDeleteElemInput>;
  _delete_key?: Maybe<SavedQueriesDeleteKeyInput>;
  _inc?: Maybe<SavedQueriesIncInput>;
  _prepend?: Maybe<SavedQueriesPrependInput>;
  _set?: Maybe<SavedQueriesSetInput>;
  where: SavedQueriesBoolExp;
};


/** mutation root */
export type MutationUpdateSavedQueriesByPkArgs = {
  _append?: Maybe<SavedQueriesAppendInput>;
  _delete_at_path?: Maybe<SavedQueriesDeleteAtPathInput>;
  _delete_elem?: Maybe<SavedQueriesDeleteElemInput>;
  _delete_key?: Maybe<SavedQueriesDeleteKeyInput>;
  _inc?: Maybe<SavedQueriesIncInput>;
  _prepend?: Maybe<SavedQueriesPrependInput>;
  _set?: Maybe<SavedQueriesSetInput>;
  pk_columns: SavedQueriesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSegmentsArgs = {
  _append?: Maybe<SegmentsAppendInput>;
  _delete_at_path?: Maybe<SegmentsDeleteAtPathInput>;
  _delete_elem?: Maybe<SegmentsDeleteElemInput>;
  _delete_key?: Maybe<SegmentsDeleteKeyInput>;
  _inc?: Maybe<SegmentsIncInput>;
  _prepend?: Maybe<SegmentsPrependInput>;
  _set?: Maybe<SegmentsSetInput>;
  where: SegmentsBoolExp;
};


/** mutation root */
export type MutationUpdateSegmentsByPkArgs = {
  _append?: Maybe<SegmentsAppendInput>;
  _delete_at_path?: Maybe<SegmentsDeleteAtPathInput>;
  _delete_elem?: Maybe<SegmentsDeleteElemInput>;
  _delete_key?: Maybe<SegmentsDeleteKeyInput>;
  _inc?: Maybe<SegmentsIncInput>;
  _prepend?: Maybe<SegmentsPrependInput>;
  _set?: Maybe<SegmentsSetInput>;
  pk_columns: SegmentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSlackCredentialsArgs = {
  _set?: Maybe<SlackCredentialsSetInput>;
  where: SlackCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateSlackCredentialsByPkArgs = {
  _set?: Maybe<SlackCredentialsSetInput>;
  pk_columns: SlackCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncRequestsArgs = {
  _set?: Maybe<SyncRequestsSetInput>;
  where: SyncRequestsBoolExp;
};


/** mutation root */
export type MutationUpdateSyncRequestsByPkArgs = {
  _set?: Maybe<SyncRequestsSetInput>;
  pk_columns: SyncRequestsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncTemplatesArgs = {
  _append?: Maybe<SyncTemplatesAppendInput>;
  _delete_at_path?: Maybe<SyncTemplatesDeleteAtPathInput>;
  _delete_elem?: Maybe<SyncTemplatesDeleteElemInput>;
  _delete_key?: Maybe<SyncTemplatesDeleteKeyInput>;
  _inc?: Maybe<SyncTemplatesIncInput>;
  _prepend?: Maybe<SyncTemplatesPrependInput>;
  _set?: Maybe<SyncTemplatesSetInput>;
  where: SyncTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateSyncTemplatesByPkArgs = {
  _append?: Maybe<SyncTemplatesAppendInput>;
  _delete_at_path?: Maybe<SyncTemplatesDeleteAtPathInput>;
  _delete_elem?: Maybe<SyncTemplatesDeleteElemInput>;
  _delete_key?: Maybe<SyncTemplatesDeleteKeyInput>;
  _inc?: Maybe<SyncTemplatesIncInput>;
  _prepend?: Maybe<SyncTemplatesPrependInput>;
  _set?: Maybe<SyncTemplatesSetInput>;
  pk_columns: SyncTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateThroughModelRelationshipsArgs = {
  _inc?: Maybe<ThroughModelRelationshipsIncInput>;
  _set?: Maybe<ThroughModelRelationshipsSetInput>;
  where: ThroughModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateThroughModelRelationshipsByPkArgs = {
  _inc?: Maybe<ThroughModelRelationshipsIncInput>;
  _set?: Maybe<ThroughModelRelationshipsSetInput>;
  pk_columns: ThroughModelRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateTraitDefinitionsArgs = {
  _append?: Maybe<TraitDefinitionsAppendInput>;
  _delete_at_path?: Maybe<TraitDefinitionsDeleteAtPathInput>;
  _delete_elem?: Maybe<TraitDefinitionsDeleteElemInput>;
  _delete_key?: Maybe<TraitDefinitionsDeleteKeyInput>;
  _inc?: Maybe<TraitDefinitionsIncInput>;
  _prepend?: Maybe<TraitDefinitionsPrependInput>;
  _set?: Maybe<TraitDefinitionsSetInput>;
  where: TraitDefinitionsBoolExp;
};


/** mutation root */
export type MutationUpdateTraitDefinitionsByPkArgs = {
  _append?: Maybe<TraitDefinitionsAppendInput>;
  _delete_at_path?: Maybe<TraitDefinitionsDeleteAtPathInput>;
  _delete_elem?: Maybe<TraitDefinitionsDeleteElemInput>;
  _delete_key?: Maybe<TraitDefinitionsDeleteKeyInput>;
  _inc?: Maybe<TraitDefinitionsIncInput>;
  _prepend?: Maybe<TraitDefinitionsPrependInput>;
  _set?: Maybe<TraitDefinitionsSetInput>;
  pk_columns: TraitDefinitionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateTunnelsArgs = {
  _set?: Maybe<TunnelsSetInput>;
  where: TunnelsBoolExp;
};


/** mutation root */
export type MutationUpdateTunnelsByPkArgs = {
  _set?: Maybe<TunnelsSetInput>;
  pk_columns: TunnelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUsersArgs = {
  _append?: Maybe<UsersAppendInput>;
  _delete_at_path?: Maybe<UsersDeleteAtPathInput>;
  _delete_elem?: Maybe<UsersDeleteElemInput>;
  _delete_key?: Maybe<UsersDeleteKeyInput>;
  _prepend?: Maybe<UsersPrependInput>;
  _set?: Maybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type MutationUpdateUsersByPkArgs = {
  _append?: Maybe<UsersAppendInput>;
  _delete_at_path?: Maybe<UsersDeleteAtPathInput>;
  _delete_elem?: Maybe<UsersDeleteElemInput>;
  _delete_key?: Maybe<UsersDeleteKeyInput>;
  _prepend?: Maybe<UsersPrependInput>;
  _set?: Maybe<UsersSetInput>;
  pk_columns: UsersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateWorkspacesArgs = {
  _append?: Maybe<WorkspacesAppendInput>;
  _delete_at_path?: Maybe<WorkspacesDeleteAtPathInput>;
  _delete_elem?: Maybe<WorkspacesDeleteElemInput>;
  _delete_key?: Maybe<WorkspacesDeleteKeyInput>;
  _inc?: Maybe<WorkspacesIncInput>;
  _prepend?: Maybe<WorkspacesPrependInput>;
  _set?: Maybe<WorkspacesSetInput>;
  where: WorkspacesBoolExp;
};


/** mutation root */
export type MutationUpdateWorkspacesByPkArgs = {
  _append?: Maybe<WorkspacesAppendInput>;
  _delete_at_path?: Maybe<WorkspacesDeleteAtPathInput>;
  _delete_elem?: Maybe<WorkspacesDeleteElemInput>;
  _delete_key?: Maybe<WorkspacesDeleteKeyInput>;
  _inc?: Maybe<WorkspacesIncInput>;
  _prepend?: Maybe<WorkspacesPrependInput>;
  _set?: Maybe<WorkspacesSetInput>;
  pk_columns: WorkspacesPkColumnsInput;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type NameComparisonExp = {
  _eq?: Maybe<Scalars['name']>;
  _gt?: Maybe<Scalars['name']>;
  _gte?: Maybe<Scalars['name']>;
  _in?: Maybe<Array<Scalars['name']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['name']>;
  _lte?: Maybe<Scalars['name']>;
  _neq?: Maybe<Scalars['name']>;
  _nin?: Maybe<Array<Scalars['name']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "object_definition_groups" */
export type ObjectDefinitionGroups = {
  __typename?: 'object_definition_groups';
  /** An object relationship */
  connection: Connections;
  connection_id: Scalars['bigint'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "object_definition_groups". All fields are combined with a logical 'AND'. */
export type ObjectDefinitionGroupsBoolExp = {
  _and?: Maybe<Array<ObjectDefinitionGroupsBoolExp>>;
  _not?: Maybe<ObjectDefinitionGroupsBoolExp>;
  _or?: Maybe<Array<ObjectDefinitionGroupsBoolExp>>;
  connection?: Maybe<ConnectionsBoolExp>;
  connection_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "object_definition_groups". */
export type ObjectDefinitionGroupsOrderBy = {
  connection?: Maybe<ConnectionsOrderBy>;
  connection_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "object_definition_groups" */
export const ObjectDefinitionGroupsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ObjectDefinitionGroupsSelectColumn = typeof ObjectDefinitionGroupsSelectColumn[keyof typeof ObjectDefinitionGroupsSelectColumn];
/** columns and relationships of "object_definitions" */
export type ObjectDefinitions = {
  __typename?: 'object_definitions';
  connection_id: Maybe<Scalars['bigint']>;
  enabled: Scalars['Boolean'];
  /** fetch data from the table: "event_definitions" */
  event_definitions: Array<EventDefinitions>;
  /** An array relationship */
  from_relationships: Array<Relationships>;
  id: Scalars['bigint'];
  important: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  object_definition_group: Maybe<ObjectDefinitionGroups>;
  object_definition_group_id: Maybe<Scalars['bigint']>;
  /** An array relationship */
  object_schemas: Array<ObjectSchemas>;
  plural_name: Maybe<Scalars['String']>;
  singular_name: Maybe<Scalars['String']>;
  special_type: Maybe<Scalars['String']>;
  /** An array relationship */
  to_relationships: Array<Relationships>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsEventDefinitionsArgs = {
  distinct_on?: Maybe<Array<EventDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventDefinitionsOrderBy>>;
  where?: Maybe<EventDefinitionsBoolExp>;
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsFromRelationshipsArgs = {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsObjectSchemasArgs = {
  distinct_on?: Maybe<Array<ObjectSchemasSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectSchemasOrderBy>>;
  where?: Maybe<ObjectSchemasBoolExp>;
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsToRelationshipsArgs = {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
};

/** Boolean expression to filter rows from the table "object_definitions". All fields are combined with a logical 'AND'. */
export type ObjectDefinitionsBoolExp = {
  _and?: Maybe<Array<ObjectDefinitionsBoolExp>>;
  _not?: Maybe<ObjectDefinitionsBoolExp>;
  _or?: Maybe<Array<ObjectDefinitionsBoolExp>>;
  connection_id?: Maybe<BigintComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  event_definitions?: Maybe<EventDefinitionsBoolExp>;
  from_relationships?: Maybe<RelationshipsBoolExp>;
  id?: Maybe<BigintComparisonExp>;
  important?: Maybe<BooleanComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  object_definition_group?: Maybe<ObjectDefinitionGroupsBoolExp>;
  object_definition_group_id?: Maybe<BigintComparisonExp>;
  object_schemas?: Maybe<ObjectSchemasBoolExp>;
  plural_name?: Maybe<StringComparisonExp>;
  singular_name?: Maybe<StringComparisonExp>;
  special_type?: Maybe<StringComparisonExp>;
  to_relationships?: Maybe<RelationshipsBoolExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** response of any mutation on the table "object_definitions" */
export type ObjectDefinitionsMutationResponse = {
  __typename?: 'object_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ObjectDefinitions>;
};

/** Ordering options when selecting data from "object_definitions". */
export type ObjectDefinitionsOrderBy = {
  connection_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  event_definitions_aggregate?: Maybe<EventDefinitionsAggregateOrderBy>;
  from_relationships_aggregate?: Maybe<RelationshipsAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  important?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  object_definition_group?: Maybe<ObjectDefinitionGroupsOrderBy>;
  object_definition_group_id?: Maybe<OrderBy>;
  object_schemas_aggregate?: Maybe<ObjectSchemasAggregateOrderBy>;
  plural_name?: Maybe<OrderBy>;
  singular_name?: Maybe<OrderBy>;
  special_type?: Maybe<OrderBy>;
  to_relationships_aggregate?: Maybe<RelationshipsAggregateOrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: object_definitions */
export type ObjectDefinitionsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "object_definitions" */
export const ObjectDefinitionsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  Important: 'important',
  /** column name */
  Name: 'name',
  /** column name */
  ObjectDefinitionGroupId: 'object_definition_group_id',
  /** column name */
  PluralName: 'plural_name',
  /** column name */
  SingularName: 'singular_name',
  /** column name */
  SpecialType: 'special_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ObjectDefinitionsSelectColumn = typeof ObjectDefinitionsSelectColumn[keyof typeof ObjectDefinitionsSelectColumn];
/** input type for updating data in table "object_definitions" */
export type ObjectDefinitionsSetInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  important?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plural_name?: Maybe<Scalars['String']>;
  singular_name?: Maybe<Scalars['String']>;
  special_type?: Maybe<Scalars['String']>;
};

/** columns and relationships of "object_schemas" */
export type ObjectSchemas = {
  __typename?: 'object_schemas';
  key: Scalars['String'];
  /** An object relationship */
  object_definition: ObjectDefinitions;
  object_definition_id: Scalars['bigint'];
  type: Scalars['String'];
};

/** order by aggregate values of table "object_schemas" */
export type ObjectSchemasAggregateOrderBy = {
  avg?: Maybe<ObjectSchemasAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ObjectSchemasMaxOrderBy>;
  min?: Maybe<ObjectSchemasMinOrderBy>;
  stddev?: Maybe<ObjectSchemasStddevOrderBy>;
  stddev_pop?: Maybe<ObjectSchemasStddevPopOrderBy>;
  stddev_samp?: Maybe<ObjectSchemasStddevSampOrderBy>;
  sum?: Maybe<ObjectSchemasSumOrderBy>;
  var_pop?: Maybe<ObjectSchemasVarPopOrderBy>;
  var_samp?: Maybe<ObjectSchemasVarSampOrderBy>;
  variance?: Maybe<ObjectSchemasVarianceOrderBy>;
};

/** order by avg() on columns of table "object_schemas" */
export type ObjectSchemasAvgOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "object_schemas". All fields are combined with a logical 'AND'. */
export type ObjectSchemasBoolExp = {
  _and?: Maybe<Array<ObjectSchemasBoolExp>>;
  _not?: Maybe<ObjectSchemasBoolExp>;
  _or?: Maybe<Array<ObjectSchemasBoolExp>>;
  key?: Maybe<StringComparisonExp>;
  object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  object_definition_id?: Maybe<BigintComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** input type for inserting data into table "object_schemas" */
export type ObjectSchemasInsertInput = {
  key?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "object_schemas" */
export type ObjectSchemasMaxOrderBy = {
  key?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** order by min() on columns of table "object_schemas" */
export type ObjectSchemasMinOrderBy = {
  key?: Maybe<OrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** response of any mutation on the table "object_schemas" */
export type ObjectSchemasMutationResponse = {
  __typename?: 'object_schemas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ObjectSchemas>;
};

/** input type for inserting object relation for remote table "object_schemas" */
export type ObjectSchemasObjRelInsertInput = {
  data: ObjectSchemasInsertInput;
};

/** Ordering options when selecting data from "object_schemas". */
export type ObjectSchemasOrderBy = {
  key?: Maybe<OrderBy>;
  object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** select columns of table "object_schemas" */
export const ObjectSchemasSelectColumn = {
  /** column name */
  Key: 'key',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Type: 'type'
} as const;

export type ObjectSchemasSelectColumn = typeof ObjectSchemasSelectColumn[keyof typeof ObjectSchemasSelectColumn];
/** order by stddev() on columns of table "object_schemas" */
export type ObjectSchemasStddevOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "object_schemas" */
export type ObjectSchemasStddevPopOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "object_schemas" */
export type ObjectSchemasStddevSampOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "object_schemas" */
export type ObjectSchemasSumOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "object_schemas" */
export type ObjectSchemasVarPopOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "object_schemas" */
export type ObjectSchemasVarSampOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "object_schemas" */
export type ObjectSchemasVarianceOrderBy = {
  object_definition_id?: Maybe<OrderBy>;
};

/** column ordering options */
export const OrderBy = {
  /** in ascending order, nulls last */
  Asc: 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst: 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast: 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc: 'desc',
  /** in descending order, nulls first */
  DescNullsFirst: 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast: 'desc_nulls_last'
} as const;

export type OrderBy = typeof OrderBy[keyof typeof OrderBy];
/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  billing: Maybe<Scalars['jsonb']>;
  entitlements: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  plan: Maybe<BillingProducts>;
  product_id: Maybe<Scalars['uuid']>;
  slug: Scalars['String'];
  /** An array relationship */
  workspaces: Array<Workspaces>;
};


/** columns and relationships of "organizations" */
export type OrganizationsBillingArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsEntitlementsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsWorkspacesArgs = {
  distinct_on?: Maybe<Array<WorkspacesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WorkspacesOrderBy>>;
  where?: Maybe<WorkspacesBoolExp>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: Maybe<Array<OrganizationsBoolExp>>;
  _not?: Maybe<OrganizationsBoolExp>;
  _or?: Maybe<Array<OrganizationsBoolExp>>;
  billing?: Maybe<JsonbComparisonExp>;
  entitlements?: Maybe<JsonbComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  plan?: Maybe<BillingProductsBoolExp>;
  product_id?: Maybe<UuidComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  workspaces?: Maybe<WorkspacesBoolExp>;
};

/** Ordering options when selecting data from "organizations". */
export type OrganizationsOrderBy = {
  billing?: Maybe<OrderBy>;
  entitlements?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  plan?: Maybe<BillingProductsOrderBy>;
  product_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  workspaces_aggregate?: Maybe<WorkspacesAggregateOrderBy>;
};

/** select columns of table "organizations" */
export const OrganizationsSelectColumn = {
  /** column name */
  Billing: 'billing',
  /** column name */
  Entitlements: 'entitlements',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ProductId: 'product_id',
  /** column name */
  Slug: 'slug'
} as const;

export type OrganizationsSelectColumn = typeof OrganizationsSelectColumn[keyof typeof OrganizationsSelectColumn];
/** columns and relationships of "outbound_user_invites" */
export type OutboundUserInvites = {
  __typename?: 'outbound_user_invites';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  expires_at: Scalars['timestamptz'];
  /** An object relationship */
  outbound_user_invites_role_id: Maybe<Roles>;
  recipient_email: Scalars['String'];
  role_id: Maybe<Scalars['Int']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "outbound_user_invites". All fields are combined with a logical 'AND'. */
export type OutboundUserInvitesBoolExp = {
  _and?: Maybe<Array<OutboundUserInvitesBoolExp>>;
  _not?: Maybe<OutboundUserInvitesBoolExp>;
  _or?: Maybe<Array<OutboundUserInvitesBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  expires_at?: Maybe<TimestamptzComparisonExp>;
  outbound_user_invites_role_id?: Maybe<RolesBoolExp>;
  recipient_email?: Maybe<StringComparisonExp>;
  role_id?: Maybe<IntComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** response of any mutation on the table "outbound_user_invites" */
export type OutboundUserInvitesMutationResponse = {
  __typename?: 'outbound_user_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OutboundUserInvites>;
};

/** Ordering options when selecting data from "outbound_user_invites". */
export type OutboundUserInvitesOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  outbound_user_invites_role_id?: Maybe<RolesOrderBy>;
  recipient_email?: Maybe<OrderBy>;
  role_id?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "outbound_user_invites" */
export const OutboundUserInvitesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ExpiresAt: 'expires_at',
  /** column name */
  RecipientEmail: 'recipient_email',
  /** column name */
  RoleId: 'role_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type OutboundUserInvitesSelectColumn = typeof OutboundUserInvitesSelectColumn[keyof typeof OutboundUserInvitesSelectColumn];
/** columns and relationships of "pagerduty_credentials" */
export type PagerdutyCredentials = {
  __typename?: 'pagerduty_credentials';
  api_key: Maybe<Scalars['String']>;
  config: Scalars['jsonb'];
  id: Scalars['Int'];
  state: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "pagerduty_credentials" */
export type PagerdutyCredentialsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "pagerduty_credentials". All fields are combined with a logical 'AND'. */
export type PagerdutyCredentialsBoolExp = {
  _and?: Maybe<Array<PagerdutyCredentialsBoolExp>>;
  _not?: Maybe<PagerdutyCredentialsBoolExp>;
  _or?: Maybe<Array<PagerdutyCredentialsBoolExp>>;
  api_key?: Maybe<StringComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  state?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pagerduty_credentials" */
export const PagerdutyCredentialsConstraint = {
  /** unique or primary key constraint */
  PagerdutyCredentialsPkey: 'pagerduty_credentials_pkey'
} as const;

export type PagerdutyCredentialsConstraint = typeof PagerdutyCredentialsConstraint[keyof typeof PagerdutyCredentialsConstraint];
/** input type for inserting data into table "pagerduty_credentials" */
export type PagerdutyCredentialsInsertInput = {
  api_key?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['jsonb']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "pagerduty_credentials" */
export type PagerdutyCredentialsMutationResponse = {
  __typename?: 'pagerduty_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PagerdutyCredentials>;
};

/** input type for inserting object relation for remote table "pagerduty_credentials" */
export type PagerdutyCredentialsObjRelInsertInput = {
  data: PagerdutyCredentialsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PagerdutyCredentialsOnConflict>;
};

/** on conflict condition type for table "pagerduty_credentials" */
export type PagerdutyCredentialsOnConflict = {
  constraint: PagerdutyCredentialsConstraint;
  update_columns?: Array<PagerdutyCredentialsUpdateColumn>;
  where?: Maybe<PagerdutyCredentialsBoolExp>;
};

/** Ordering options when selecting data from "pagerduty_credentials". */
export type PagerdutyCredentialsOrderBy = {
  api_key?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: pagerduty_credentials */
export type PagerdutyCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "pagerduty_credentials" */
export const PagerdutyCredentialsSelectColumn = {
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  Config: 'config',
  /** column name */
  Id: 'id',
  /** column name */
  State: 'state',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PagerdutyCredentialsSelectColumn = typeof PagerdutyCredentialsSelectColumn[keyof typeof PagerdutyCredentialsSelectColumn];
/** input type for updating data in table "pagerduty_credentials" */
export type PagerdutyCredentialsSetInput = {
  api_key?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "pagerduty_credentials" */
export const PagerdutyCredentialsUpdateColumn = {
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  State: 'state'
} as const;

export type PagerdutyCredentialsUpdateColumn = typeof PagerdutyCredentialsUpdateColumn[keyof typeof PagerdutyCredentialsUpdateColumn];
export type Query = {
  __typename?: 'query';
  ValidateDatadogCredentials: Maybe<ValidateDatadogCredentialsOutput>;
  activeCampaignDescribeObject: ActiveCampaignDescribeObjectResult;
  airtableGetBases: AirtableGetBasesResult;
  airtableGetTablesMeta: AirtableGetTablesMetaResult;
  airtableListBases: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  airtableListTables: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  /** fetch data from the table: "alert_statuses" using primary key columns */
  alert_statuses_by_pk: Maybe<AlertStatuses>;
  /** fetch data from the table: "alerts" */
  alerts: Array<Alerts>;
  /** fetch data from the table: "alerts" using primary key columns */
  alerts_by_pk: Maybe<Alerts>;
  /** fetch data from the table: "api_keys" */
  api_keys: Array<ApiKeys>;
  /** fetch data from the table: "api_keys" using primary key columns */
  api_keys_by_pk: Maybe<ApiKeys>;
  asanaListCustomFields: AsanaListCustomFieldsResult;
  asanaListTeams: AsanaListTeamsResult;
  asanaListWorkspaces: AsanaListWorkspacesResult;
  athenaListDataCatalogs: AthenaListDataCatalogsResult;
  athenaListDataCatalogsNewSource: AthenaListDataCatalogsResult;
  athenaListDatabases: AthenaListDatabasesResult;
  athenaListDatabasesNewSource: AthenaListDatabasesResult;
  athenaListWorkGroups: AthenaListWorkGroupsResult;
  athenaListWorkGroupsNewSource: AthenaListWorkGroupsResult;
  /** fetch data from the table: "billing_products" */
  billing_products: Array<BillingProducts>;
  /** fetch data from the table: "billing_products" using primary key columns */
  billing_products_by_pk: Maybe<BillingProducts>;
  checkTunnel: CheckTunnelResult;
  clientSuccessDescribeObject: ClientSuccessDescribeObjectResult;
  closeioCustomActivities: CloseioCustomActivitiesResult;
  closeioDescribeObject: CloseioDescribeObjectResult;
  /** fetch data from the table: "cloud_credentials" */
  cloud_credentials: Array<CloudCredentials>;
  /** fetch data from the table: "cloud_credentials" using primary key columns */
  cloud_credentials_by_pk: Maybe<CloudCredentials>;
  /** fetch data from the table: "column_selectors" */
  column_selectors: Array<ColumnSelectors>;
  /** fetch data from the table: "column_selectors" using primary key columns */
  column_selectors_by_pk: Maybe<ColumnSelectors>;
  /** fetch data from the table: "connections" */
  connections: Array<Connections>;
  /** fetch aggregated fields from the table: "connections" */
  connections_aggregate: ConnectionsAggregate;
  /** fetch data from the table: "connections" using primary key columns */
  connections_by_pk: Maybe<Connections>;
  customListFields: CustomDestinationListFieldsResult;
  customListModes: CustomDestinationListModesResult;
  customListObjects: CustomDestinationListObjectsResult;
  customListOptions: CustomDestinationListOptionsResult;
  customQuery: QueryResponse;
  customValidateConfiguration: CustomDestinationValidateConfigurationResult;
  /** fetch data from the table: "datadog_credentials" */
  datadog_credentials: Array<DatadogCredentials>;
  /** fetch data from the table: "datadog_credentials" using primary key columns */
  datadog_credentials_by_pk: Maybe<DatadogCredentials>;
  dbtModelQuery: QueryResponse;
  dbtQuery: QueryResponse;
  /** fetch data from the table: "dbt_credentials" */
  dbt_credentials: Array<DbtCredentials>;
  /** fetch data from the table: "dbt_credentials" using primary key columns */
  dbt_credentials_by_pk: Maybe<DbtCredentials>;
  /** fetch data from the table: "dbt_models" */
  dbt_models: Array<DbtModels>;
  /** fetch data from the table: "dbt_models" using primary key columns */
  dbt_models_by_pk: Maybe<DbtModels>;
  /** fetch data from the table: "dbt_sync_config" */
  dbt_sync_config: Array<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_config" using primary key columns */
  dbt_sync_config_by_pk: Maybe<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_models" */
  dbt_sync_models: Array<DbtSyncModels>;
  /** fetch data from the table: "dbt_sync_models" using primary key columns */
  dbt_sync_models_by_pk: Maybe<DbtSyncModels>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** fetch data from the table: "destination_instances" using primary key columns */
  destination_instances_by_pk: Maybe<DestinationInstances>;
  /** fetch data from the table: "destinations" */
  destinations: Array<Destinations>;
  /** fetch aggregated fields from the table: "destinations" */
  destinations_aggregate: DestinationsAggregate;
  /** fetch data from the table: "destinations" using primary key columns */
  destinations_by_pk: Maybe<Destinations>;
  /** fetch data from the table: "direct_model_relationships" */
  direct_model_relationships: Array<DirectModelRelationships>;
  /** fetch data from the table: "direct_model_relationships" using primary key columns */
  direct_model_relationships_by_pk: Maybe<DirectModelRelationships>;
  /** fetch data from the table: "event_definitions" */
  event_definitions: Array<EventDefinitions>;
  /** fetch data from the table: "event_definitions" using primary key columns */
  event_definitions_by_pk: Maybe<EventDefinitions>;
  /** fetch data from the table: "event_models" */
  event_models: Array<EventModels>;
  /** fetch data from the table: "event_models" using primary key columns */
  event_models_by_pk: Maybe<EventModels>;
  /** fetch data from the table: "external_buckets" */
  external_buckets: Array<ExternalBuckets>;
  /** fetch data from the table: "external_buckets" using primary key columns */
  external_buckets_by_pk: Maybe<ExternalBuckets>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  /** fetch data from the table: "external_segments" using primary key columns */
  external_segments_by_pk: Maybe<ExternalSegments>;
  facebookAdCatalogGetProductCatalogs: FacebookAdCatalogGetProductCatalogsResult;
  facebookConversionsDescribeObject: FacebookConversionsDescribeObjectResult;
  facebookConversionsListObjects: FacebookConversionsListObjectsResult;
  facebookListAdAccounts: FacebookListAdAccountsResult;
  formkitSourceDefinition: Array<SourceMethod>;
  formkitSourceHandler: Scalars['JSON'];
  formkitSourceValidation: Maybe<Scalars['JSON']>;
  formkitSyncDefinition: Scalars['JSON'];
  formkitSyncHandler: Scalars['JSON'];
  formkitSyncValidation: Maybe<Scalars['JSON']>;
  freshdeskListCustomFields: FreshdeskListCustomFieldsResult;
  frontDescribeObject: FrontDescribeObjectResult;
  gainsightpxGetAccountAttributes: GainsightpxGetAccountAttributesResult;
  gainsightpxGetUserAttributes: GainsightpxGetUserAttributesResult;
  getAttemptedRows: AttemptedRowsResult;
  getAttemptedRowsByBatchId: AttemptedRowsResult;
  getAttemptedRowsByPrimaryKey: AttemptedRowsResult;
  getAuth0ConnectionsByOrganization: GetAuth0ConnectionsByOrganizationResult;
  getAvailableWorkspaces: GetAvailableWorkspacesResult;
  getBatchRequestInfo: BatchRequestInfo;
  getBillingOrganization: Maybe<BillingOrganization>;
  getCheckoutUrl: StripeRedirectResult;
  getCurrentPermissions: Maybe<Array<ResourcePermission>>;
  getCurrentUser: Maybe<User>;
  getDBTAccounts: Array<DbtAccount>;
  getDBTJobs: Array<DbtJob>;
  getDestinationDefinition: DestinationDefinition;
  getDestinationDefinitions: Array<DestinationDefinition>;
  getDestinationStrippedConfiguration: Scalars['JSONObject'];
  getGithubBranches: Array<GithubBranch>;
  getGithubRepositories: Array<GithubRepository>;
  getLookerLook: Maybe<GetLookerLookOutput>;
  getOrganization: Maybe<Organization>;
  getOrganizationDestinationTypes: Array<Maybe<DestinationTypesResult>>;
  getOrganizationMetrics: MetricsResult;
  getPortalUrl: StripeRedirectResult;
  getQueryRows: PlannedRowsResult;
  getRequestInfoSet: Maybe<Array<RequestInfo>>;
  getSampleDataSourceDefinition: SourceDefinition;
  getSampleDataSourceDefinitions: Array<SourceDefinition>;
  getSourceDefinition: SourceDefinition;
  getSourceDefinitions: Array<SourceDefinition>;
  getSourceStrippedConfiguration: Scalars['JSONObject'];
  getSyncAttemptProgress: Scalars['Float'];
  getSyncPlan: PlannedRowsResult;
  getTopK: TopKResponse;
  getTransformedSyncConfiguration: Scalars['JSONObject'];
  getTransformedSyncTemplateConfiguration: Scalars['JSONObject'];
  getTunnel: GetTunnelResult;
  getTunnels: Array<GetTunnelResult>;
  getVerifiedDomains: Maybe<Array<Scalars['String']>>;
  /** fetch data from the table: "git_credentials" */
  git_credentials: Array<GitCredentials>;
  /** fetch data from the table: "git_credentials" using primary key columns */
  git_credentials_by_pk: Maybe<GitCredentials>;
  /** An array relationship */
  git_inbound_runs: Array<GitInboundRuns>;
  /** fetch data from the table: "git_inbound_runs" using primary key columns */
  git_inbound_runs_by_pk: Maybe<GitInboundRuns>;
  /** fetch data from the table: "git_outbound_runs" */
  git_outbound_runs: Array<GitOutboundRuns>;
  /** fetch data from the table: "git_outbound_runs" using primary key columns */
  git_outbound_runs_by_pk: Maybe<GitOutboundRuns>;
  /** fetch data from the table: "git_sync_attempts" */
  git_sync_attempts: Array<GitSyncAttempts>;
  /** fetch aggregated fields from the table: "git_sync_attempts" */
  git_sync_attempts_aggregate: GitSyncAttemptsAggregate;
  /** fetch data from the table: "git_sync_attempts" using primary key columns */
  git_sync_attempts_by_pk: Maybe<GitSyncAttempts>;
  /** fetch data from the table: "git_sync_config" */
  git_sync_config: Array<GitSyncConfig>;
  /** fetch data from the table: "git_sync_config" using primary key columns */
  git_sync_config_by_pk: Maybe<GitSyncConfig>;
  /** fetch data from the table: "git_sync_configs" */
  git_sync_configs: Array<GitSyncConfigs>;
  /** fetch data from the table: "git_sync_configs" using primary key columns */
  git_sync_configs_by_pk: Maybe<GitSyncConfigs>;
  googleCampaignManagerListFloodlightActivities: Array<Maybe<Scalars['JSONObject']>>;
  googleCampaignManagerListProfiles: Array<Maybe<Scalars['JSONObject']>>;
  googleDescribeMode: GoogleAdsDescribeModeResult;
  googleGetAccounts: Scalars['String'];
  googleListConversionActions: GoogleAdsListConversionActionsResult;
  googlesheetsListSheets: GooglesheetsListSheetsResult;
  googlesheetsListSpreadSheets: Array<GooglesheetsSpreadSheet>;
  googlesheetsRetrieveAccessToken: GooglesheetsRetrieveAccessTokenResult;
  googlesheetsSourceListSheets: Maybe<Array<Maybe<Scalars['String']>>>;
  hello: Maybe<Scalars['String']>;
  hubspotDescribeGlobal: HubSpotDescribeGlobalResult;
  hubspotDescribeObject: HubSpotDescribeObjectResult;
  hubspotLegacyDescribeGlobal: HubSpotLegacyDescribeGlobalResult;
  hubspotLegacyDescribeObject: HubSpotLegacyDescribeObjectResult;
  intercomListAttributes: IntercomListAttributesResult;
  isOrganizationAvailable: Scalars['Boolean'];
  isResourceSlugAvailable: Scalars['Boolean'];
  isWorkspaceSlugAvailable: Scalars['Boolean'];
  iterableGetCampaigns: IterableGetCampaigns;
  iterableGetCatalogFields: Maybe<IterableGetCatalogFields>;
  iterableGetCatalogs: Maybe<IterableGetCatalogs>;
  iterableGetTemplates: IterableGetTemplates;
  iterableUserFields: IterableUserFieldsResult;
  jiraGetIssueFields: Maybe<JiraGetIssueFields>;
  jiraGetIssueTypes: Maybe<JiraGetIssueTypes>;
  jiraGetProjects: Maybe<JiraGetProjects>;
  listAllSourceDependencies: ListAllSourceDependenciesResult;
  /** List all columns that can be used for filtering audiences made off of this model. */
  listFilterableColumns: Array<FilterableColumn>;
  /**
   * DEPRECATED: List all columns that are accessible from this model.
   * Should remove once the new traits frontend is fully released.
   */
  listModelColumns: Array<ModelColumn>;
  listModelDependencies: Scalars['JSONObject'];
  listPostgresColumns: Array<Maybe<PostgresColumn>>;
  listPostgresTables: Array<Maybe<PostgresTable>>;
  /**
   * The results of these resolvers should be displayed to users before
   * deleting relationships and models so that users know the potential
   * cascading effects.
   * The results aren't GraphQL types since they're recursive types.
   */
  listRelationshipDependencies: Scalars['JSONObject'];
  listSlackChannelsByCredentials: Array<SlackChannel>;
  /** List all columns that can be synced off of this model. */
  listSyncableColumns: Array<SyncableColumn>;
  lookerLookQuery: QueryResponse;
  /** fetch data from the table: "looker_credentials" */
  looker_credentials: Array<LookerCredentials>;
  /** fetch data from the table: "looker_credentials" using primary key columns */
  looker_credentials_by_pk: Maybe<LookerCredentials>;
  marketoDescribeActivity: MarketoDescribeActivityResult;
  marketoDescribeObject: MarketoDescribeObjectResult;
  marketoListActivities: MarketoListActivitiesResult;
  marketoListObjects: MarketoListObjectsResult;
  /** An array relationship */
  membership_requests: Array<MembershipRequests>;
  /** fetch data from the table: "membership_requests" using primary key columns */
  membership_requests_by_pk: Maybe<MembershipRequests>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: MembershipsAggregate;
  /** fetch data from the table: "memberships" using primary key columns */
  memberships_by_pk: Maybe<Memberships>;
  metabaseListDatabases: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  metabaseListQuestions: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  metabaseListTables: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  mixpanelGetLookupTables: Array<Maybe<Scalars['JSONObject']>>;
  mixpanelListCohorts: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  mixpanelListProjects: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  /** fetch data from the table: "model_columns" */
  model_columns: Array<ModelColumns>;
  /** fetch data from the table: "model_columns" using primary key columns */
  model_columns_by_pk: Maybe<ModelColumns>;
  /** fetch data from the table: "model_relationships" */
  model_relationships: Array<ModelRelationships>;
  /** fetch data from the table: "model_relationships" using primary key columns */
  model_relationships_by_pk: Maybe<ModelRelationships>;
  mongodbListCollections: Array<Maybe<Scalars['String']>>;
  notionGetDatabaseProperties: Maybe<NotionGetDatabaseProperties>;
  notionGetDatabases: Maybe<NotionGetDatabases>;
  /** fetch data from the table: "object_definition_groups" */
  object_definition_groups: Array<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definition_groups" using primary key columns */
  object_definition_groups_by_pk: Maybe<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definitions" */
  object_definitions: Array<ObjectDefinitions>;
  /** fetch data from the table: "object_definitions" using primary key columns */
  object_definitions_by_pk: Maybe<ObjectDefinitions>;
  /** An array relationship */
  object_schemas: Array<ObjectSchemas>;
  /** fetch data from the table: "object_schemas" using primary key columns */
  object_schemas_by_pk: Maybe<ObjectSchemas>;
  orbitListWorkspaces: OrbitListWorkspaces;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk: Maybe<Organizations>;
  /** fetch data from the table: "outbound_user_invites" */
  outbound_user_invites: Array<OutboundUserInvites>;
  /** fetch data from the table: "outbound_user_invites" using primary key columns */
  outbound_user_invites_by_pk: Maybe<OutboundUserInvites>;
  /** fetch data from the table: "pagerduty_credentials" */
  pagerduty_credentials: Array<PagerdutyCredentials>;
  /** fetch data from the table: "pagerduty_credentials" using primary key columns */
  pagerduty_credentials_by_pk: Maybe<PagerdutyCredentials>;
  partnerConnectGetConnection: Maybe<PartnerConnection>;
  partnerConnectGetInformation: Maybe<PartnerInformation>;
  partnerConnectListAvailableWorkspaces: Maybe<Array<Maybe<PartnerAvailableWorkspace>>>;
  pipedriveListDomains: PipedriveListDomains;
  previewQuerySchema: ColumnResponse;
  /** An array relationship */
  query_runs: Array<QueryRuns>;
  /** fetch data from the table: "query_runs" using primary key columns */
  query_runs_by_pk: Maybe<QueryRuns>;
  rawSqlQuery: QueryResponse;
  /** An array relationship */
  relationship_references: Array<RelationshipReferences>;
  /** fetch data from the table: "relationship_references" using primary key columns */
  relationship_references_by_pk: Maybe<RelationshipReferences>;
  /** fetch data from the table: "relationships" */
  relationships: Array<Relationships>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk: Maybe<Relationships>;
  /** fetch data from the table: "resource_tag_values" */
  resource_tag_values: Array<ResourceTagValues>;
  /** fetch data from the table: "resource_views" */
  resource_views: Array<ResourceViews>;
  /** fetch data from the table: "resource_views" using primary key columns */
  resource_views_by_pk: Maybe<ResourceViews>;
  /** An array relationship */
  roles: Array<Roles>;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk: Maybe<Roles>;
  salesloftListCustomFields: SalesloftCustomFieldsResult;
  /** fetch data from the table: "sample_data_sources" */
  sample_data_sources: Array<SampleDataSources>;
  /** fetch data from the table: "sample_data_sources" using primary key columns */
  sample_data_sources_by_pk: Maybe<SampleDataSources>;
  /** fetch data from the table: "saved_queries" */
  saved_queries: Array<SavedQueries>;
  /** fetch data from the table: "saved_queries" using primary key columns */
  saved_queries_by_pk: Maybe<SavedQueries>;
  searchLookerLooks: Maybe<SearchLookerLooksOutput>;
  /** fetch data from the table: "segments" */
  segments: Array<Segments>;
  /** fetch aggregated fields from the table: "segments" */
  segments_aggregate: SegmentsAggregate;
  /** fetch data from the table: "segments" using primary key columns */
  segments_by_pk: Maybe<Segments>;
  sendGridContactSchema: SendGridContactSchemaResult;
  sfmcListAttributeSets: SfmcListAttributeSetsResult;
  sfmcListBusinessUnits: SfmcListBusinessUnits;
  sfmcListDataExtensionFields: SfmcListDataExtensionFields;
  sfmcListDataExtensions: SfmcListDataExtensions;
  sfmcListDataFolders: SfmcListDataFolders;
  sfmcListJourneys: SfmcListJourneysResult;
  slackListChannels: SlackListChannelsResult;
  /** fetch data from the table: "slack_credentials" */
  slack_credentials: Array<SlackCredentials>;
  /** fetch data from the table: "slack_credentials" using primary key columns */
  slack_credentials_by_pk: Maybe<SlackCredentials>;
  snapchatListAdAccounts: SnapchatListAdAccounts;
  snapchatListOrganizations: SnapchatListOrganizations;
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** An array relationship */
  sync_attempts: Array<SyncAttempts>;
  /** fetch data from the table: "sync_attempts" using primary key columns */
  sync_attempts_by_pk: Maybe<SyncAttempts>;
  /** fetch data from the table: "sync_request_diffs" */
  sync_request_diffs: Array<SyncRequestDiffs>;
  /** fetch data from the table: "sync_request_diffs" using primary key columns */
  sync_request_diffs_by_pk: Maybe<SyncRequestDiffs>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** fetch data from the table: "sync_requests" using primary key columns */
  sync_requests_by_pk: Maybe<SyncRequests>;
  /** fetch data from the table: "sync_templates" */
  sync_templates: Array<SyncTemplates>;
  /** fetch data from the table: "sync_templates" using primary key columns */
  sync_templates_by_pk: Maybe<SyncTemplates>;
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  tableQuery: QueryResponse;
  testAuthentication: Scalars['String'];
  testStorageConnection: Maybe<Scalars['Boolean']>;
  testSyncConfiguration: TestSyncConfigurationResult;
  testSyncConfigurationSupported: Scalars['Boolean'];
  /** fetch data from the table: "through_model_relationships" */
  through_model_relationships: Array<ThroughModelRelationships>;
  /** fetch data from the table: "through_model_relationships" using primary key columns */
  through_model_relationships_by_pk: Maybe<ThroughModelRelationships>;
  tiktokListAdvertisers: Array<Maybe<Scalars['JSONObject']>>;
  /** fetch data from the table: "trait_definitions" */
  trait_definitions: Array<TraitDefinitions>;
  /** fetch data from the table: "trait_definitions" using primary key columns */
  trait_definitions_by_pk: Maybe<TraitDefinitions>;
  /** fetch data from the table: "tunnels" */
  tunnels: Array<Tunnels>;
  /** fetch data from the table: "tunnels" using primary key columns */
  tunnels_by_pk: Maybe<Tunnels>;
  userflowGetAttributes: Maybe<UserflowGetAttributes>;
  /** An array relationship */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk: Maybe<Users>;
  visualQuery: QueryResponse;
  /** An array relationship */
  workspaces: Array<Workspaces>;
  /** fetch data from the table: "workspaces" using primary key columns */
  workspaces_by_pk: Maybe<Workspaces>;
  zendeskListCustomFields: ZendeskListCustomFieldsResult;
  zendeskListCustomObjectProperties: ZendeskListCustomObjectPropertiesResult;
  zendeskListCustomObjectTypes: ZendeskListCustomObjectTypesResult;
};


export type QueryValidateDatadogCredentialsArgs = {
  input: ValidateDatadogCredentialsInput;
};


export type QueryActiveCampaignDescribeObjectArgs = {
  input: ActiveCampaignDescribeObjectInput;
};


export type QueryAirtableGetBasesArgs = {
  input: AirtableGetBasesInput;
};


export type QueryAirtableGetTablesMetaArgs = {
  input: AirtableGetTablesMetaInput;
};


export type QueryAirtableListBasesArgs = {
  connectionId: Scalars['String'];
};


export type QueryAirtableListTablesArgs = {
  baseId: Scalars['String'];
  connectionId: Scalars['String'];
};


export type QueryAlertInstancesArgs = {
  distinct_on?: Maybe<Array<AlertInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertInstancesOrderBy>>;
  where?: Maybe<AlertInstancesBoolExp>;
};


export type QueryAlertStatusesArgs = {
  distinct_on?: Maybe<Array<AlertStatusesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertStatusesOrderBy>>;
  where?: Maybe<AlertStatusesBoolExp>;
};


export type QueryAlertStatusesByPkArgs = {
  alert_id: Scalars['bigint'];
  destination_instance_id: Scalars['bigint'];
};


export type QueryAlertsArgs = {
  distinct_on?: Maybe<Array<AlertsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertsOrderBy>>;
  where?: Maybe<AlertsBoolExp>;
};


export type QueryAlertsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryApiKeysArgs = {
  distinct_on?: Maybe<Array<ApiKeysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ApiKeysOrderBy>>;
  where?: Maybe<ApiKeysBoolExp>;
};


export type QueryApiKeysByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryAsanaListCustomFieldsArgs = {
  input: AsanaListCustomFieldsInput;
};


export type QueryAsanaListTeamsArgs = {
  input: AsanaListTeamsInput;
};


export type QueryAsanaListWorkspacesArgs = {
  input: AsanaListWorkspacesInput;
};


export type QueryAthenaListDataCatalogsArgs = {
  connectionId: Scalars['Int'];
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAthenaListDataCatalogsNewSourceArgs = {
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAthenaListDatabasesArgs = {
  connectionId: Scalars['Int'];
  credentials: AthenaCredentials;
  dataCatalog: Scalars['String'];
  region: Scalars['String'];
};


export type QueryAthenaListDatabasesNewSourceArgs = {
  credentials: AthenaCredentials;
  dataCatalog: Scalars['String'];
  region: Scalars['String'];
};


export type QueryAthenaListWorkGroupsArgs = {
  connectionId: Scalars['Int'];
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAthenaListWorkGroupsNewSourceArgs = {
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryBillingProductsArgs = {
  distinct_on?: Maybe<Array<BillingProductsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BillingProductsOrderBy>>;
  where?: Maybe<BillingProductsBoolExp>;
};


export type QueryBillingProductsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCheckTunnelArgs = {
  id: Scalars['String'];
};


export type QueryClientSuccessDescribeObjectArgs = {
  input: ClientSuccessDescribeObjectInput;
};


export type QueryCloseioCustomActivitiesArgs = {
  input: CloseioCustomActivitiesInput;
};


export type QueryCloseioDescribeObjectArgs = {
  input: CloseioDescribeObjectInput;
};


export type QueryCloudCredentialsArgs = {
  distinct_on?: Maybe<Array<CloudCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CloudCredentialsOrderBy>>;
  where?: Maybe<CloudCredentialsBoolExp>;
};


export type QueryCloudCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryColumnSelectorsArgs = {
  distinct_on?: Maybe<Array<ColumnSelectorsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ColumnSelectorsOrderBy>>;
  where?: Maybe<ColumnSelectorsBoolExp>;
};


export type QueryColumnSelectorsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryConnectionsArgs = {
  distinct_on?: Maybe<Array<ConnectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ConnectionsOrderBy>>;
  where?: Maybe<ConnectionsBoolExp>;
};


export type QueryConnectionsAggregateArgs = {
  distinct_on?: Maybe<Array<ConnectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ConnectionsOrderBy>>;
  where?: Maybe<ConnectionsBoolExp>;
};


export type QueryConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryCustomListFieldsArgs = {
  input: CustomDestinationListFieldsInput;
};


export type QueryCustomListModesArgs = {
  input: CustomDestinationListModesInput;
};


export type QueryCustomListObjectsArgs = {
  input: CustomDestinationListObjectsInput;
};


export type QueryCustomListOptionsArgs = {
  input: CustomDestinationListOptionsInput;
};


export type QueryCustomQueryArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  query: Scalars['JSONObject'];
};


export type QueryCustomValidateConfigurationArgs = {
  input: CustomDestinationValidateConfigurationInput;
};


export type QueryDatadogCredentialsArgs = {
  distinct_on?: Maybe<Array<DatadogCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DatadogCredentialsOrderBy>>;
  where?: Maybe<DatadogCredentialsBoolExp>;
};


export type QueryDatadogCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryDbtModelQueryArgs = {
  connectionId: Scalars['String'];
  dbtModelId?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  modelId?: Maybe<Scalars['Int']>;
};


export type QueryDbtQueryArgs = {
  connectionId: Scalars['String'];
  dbtModelId?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  modelId?: Maybe<Scalars['Int']>;
};


export type QueryDbtCredentialsArgs = {
  distinct_on?: Maybe<Array<DbtCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtCredentialsOrderBy>>;
  where?: Maybe<DbtCredentialsBoolExp>;
};


export type QueryDbtCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryDbtModelsArgs = {
  distinct_on?: Maybe<Array<DbtModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtModelsOrderBy>>;
  where?: Maybe<DbtModelsBoolExp>;
};


export type QueryDbtModelsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryDbtSyncConfigArgs = {
  distinct_on?: Maybe<Array<DbtSyncConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtSyncConfigOrderBy>>;
  where?: Maybe<DbtSyncConfigBoolExp>;
};


export type QueryDbtSyncConfigByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDbtSyncModelsArgs = {
  distinct_on?: Maybe<Array<DbtSyncModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtSyncModelsOrderBy>>;
  where?: Maybe<DbtSyncModelsBoolExp>;
};


export type QueryDbtSyncModelsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDestinationInstancesArgs = {
  distinct_on?: Maybe<Array<DestinationInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationInstancesOrderBy>>;
  where?: Maybe<DestinationInstancesBoolExp>;
};


export type QueryDestinationInstancesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDestinationsArgs = {
  distinct_on?: Maybe<Array<DestinationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationsOrderBy>>;
  where?: Maybe<DestinationsBoolExp>;
};


export type QueryDestinationsAggregateArgs = {
  distinct_on?: Maybe<Array<DestinationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationsOrderBy>>;
  where?: Maybe<DestinationsBoolExp>;
};


export type QueryDestinationsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDirectModelRelationshipsArgs = {
  distinct_on?: Maybe<Array<DirectModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DirectModelRelationshipsOrderBy>>;
  where?: Maybe<DirectModelRelationshipsBoolExp>;
};


export type QueryDirectModelRelationshipsByPkArgs = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type QueryEventDefinitionsArgs = {
  distinct_on?: Maybe<Array<EventDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventDefinitionsOrderBy>>;
  where?: Maybe<EventDefinitionsBoolExp>;
};


export type QueryEventDefinitionsByPkArgs = {
  object_definition_id: Scalars['bigint'];
};


export type QueryEventModelsArgs = {
  distinct_on?: Maybe<Array<EventModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventModelsOrderBy>>;
  where?: Maybe<EventModelsBoolExp>;
};


export type QueryEventModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type QueryExternalBucketsArgs = {
  distinct_on?: Maybe<Array<ExternalBucketsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ExternalBucketsOrderBy>>;
  where?: Maybe<ExternalBucketsBoolExp>;
};


export type QueryExternalBucketsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type QueryExternalSegmentsArgs = {
  distinct_on?: Maybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ExternalSegmentsOrderBy>>;
  where?: Maybe<ExternalSegmentsBoolExp>;
};


export type QueryExternalSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryFacebookAdCatalogGetProductCatalogsArgs = {
  input: FacebookAdCatalogGetProductCatalogsInput;
};


export type QueryFacebookConversionsDescribeObjectArgs = {
  input: FacebookConversionsDescribeObjectInput;
};


export type QueryFacebookConversionsListObjectsArgs = {
  input: FacebookConversionsListObjectsInput;
};


export type QueryFacebookListAdAccountsArgs = {
  input: FacebookListAdAccountsInput;
};


export type QueryFormkitSourceDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryFormkitSourceHandlerArgs = {
  input: FormkitSourceHandlerInput;
};


export type QueryFormkitSourceValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryFormkitSyncDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryFormkitSyncHandlerArgs = {
  input: FormkitSyncHandlerInput;
};


export type QueryFormkitSyncValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryFreshdeskListCustomFieldsArgs = {
  input: FreshdeskListCustomFieldsInput;
};


export type QueryFrontDescribeObjectArgs = {
  input: FrontDescribeObjectInput;
};


export type QueryGainsightpxGetAccountAttributesArgs = {
  input?: Maybe<GainsightGetAccountAttributesInput>;
};


export type QueryGainsightpxGetUserAttributesArgs = {
  input: GainsightGetUserAttributesInput;
};


export type QueryGetAttemptedRowsArgs = {
  destinationInstanceId: Scalars['Int'];
  onlyRejected?: Maybe<Scalars['Boolean']>;
  onlySuccessful?: Maybe<Scalars['Boolean']>;
  opTypes: Array<SyncOp>;
  paginationOptions: AttemptedRowsPaginationOptions;
  syncRequestId: Scalars['Int'];
};


export type QueryGetAttemptedRowsByBatchIdArgs = {
  destinationInstanceId: Scalars['Int'];
  id: Scalars['String'];
  paginationOptions: AttemptedRowsPaginationOptions;
  syncRequestId: Scalars['Int'];
};


export type QueryGetAttemptedRowsByPrimaryKeyArgs = {
  alreadyHashed?: Maybe<Scalars['Boolean']>;
  destinationInstanceId: Scalars['Int'];
  id: Scalars['String'];
  paginationOptions: AttemptedRowsPaginationOptions;
  syncRequestId: Scalars['Int'];
};


export type QueryGetAuth0ConnectionsByOrganizationArgs = {
  slug: Scalars['String'];
};


export type QueryGetBatchRequestInfoArgs = {
  batchRequestInfoKey: Scalars['String'];
};


export type QueryGetCheckoutUrlArgs = {
  lookup_key: Scalars['String'];
  org_name: Scalars['String'];
  workspace_id: Scalars['Int'];
};


export type QueryGetCurrentPermissionsArgs = {
  filters?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetDbtAccountsArgs = {
  apiKey: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
};


export type QueryGetDbtJobsArgs = {
  accountId: Scalars['String'];
  apiKey: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
};


export type QueryGetDestinationDefinitionArgs = {
  input: DestinationDefinitionInput;
};


export type QueryGetDestinationStrippedConfigurationArgs = {
  input?: Maybe<GetDestinationStrippedConfigurationInput>;
};


export type QueryGetGithubBranchesArgs = {
  credentialId: Scalars['String'];
  repo: Scalars['String'];
};


export type QueryGetGithubRepositoriesArgs = {
  credentialId: Scalars['String'];
};


export type QueryGetLookerLookArgs = {
  id: Scalars['String'];
  withSql?: Maybe<Scalars['Boolean']>;
};


export type QueryGetPortalUrlArgs = {
  customer_id: Scalars['String'];
};


export type QueryGetQueryRowsArgs = {
  destinationInstanceId: Scalars['Int'];
  paginationOptions?: Maybe<PlannedRowsPaginationOptions>;
  syncRequestId: Scalars['Int'];
};


export type QueryGetRequestInfoSetArgs = {
  requestInfoKeys?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetSampleDataSourceDefinitionArgs = {
  sampleDataSourceId: Scalars['String'];
};


export type QueryGetSourceDefinitionArgs = {
  input: SourceDefinitionInput;
};


export type QueryGetSourceStrippedConfigurationArgs = {
  connectionId: Scalars['bigint'];
};


export type QueryGetSyncAttemptProgressArgs = {
  id: Scalars['Int'];
};


export type QueryGetSyncPlanArgs = {
  destinationInstanceId: Scalars['Int'];
  opType: SyncOp;
  paginationOptions?: Maybe<PlannedRowsPaginationOptions>;
  syncRequestId: Scalars['Int'];
};


export type QueryGetTopKArgs = {
  modelIds: Array<Scalars['String']>;
};


export type QueryGetTransformedSyncConfigurationArgs = {
  id: Scalars['bigint'];
};


export type QueryGetTransformedSyncTemplateConfigurationArgs = {
  id: Scalars['Int'];
};


export type QueryGetTunnelArgs = {
  id: Scalars['String'];
};


export type QueryGitCredentialsArgs = {
  distinct_on?: Maybe<Array<GitCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitCredentialsOrderBy>>;
  where?: Maybe<GitCredentialsBoolExp>;
};


export type QueryGitCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGitInboundRunsArgs = {
  distinct_on?: Maybe<Array<GitInboundRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitInboundRunsOrderBy>>;
  where?: Maybe<GitInboundRunsBoolExp>;
};


export type QueryGitInboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGitOutboundRunsArgs = {
  distinct_on?: Maybe<Array<GitOutboundRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitOutboundRunsOrderBy>>;
  where?: Maybe<GitOutboundRunsBoolExp>;
};


export type QueryGitOutboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGitSyncAttemptsArgs = {
  distinct_on?: Maybe<Array<GitSyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncAttemptsOrderBy>>;
  where?: Maybe<GitSyncAttemptsBoolExp>;
};


export type QueryGitSyncAttemptsAggregateArgs = {
  distinct_on?: Maybe<Array<GitSyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncAttemptsOrderBy>>;
  where?: Maybe<GitSyncAttemptsBoolExp>;
};


export type QueryGitSyncAttemptsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryGitSyncConfigArgs = {
  distinct_on?: Maybe<Array<GitSyncConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncConfigOrderBy>>;
  where?: Maybe<GitSyncConfigBoolExp>;
};


export type QueryGitSyncConfigByPkArgs = {
  id: Scalars['Int'];
};


export type QueryGitSyncConfigsArgs = {
  distinct_on?: Maybe<Array<GitSyncConfigsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncConfigsOrderBy>>;
  where?: Maybe<GitSyncConfigsBoolExp>;
};


export type QueryGitSyncConfigsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGoogleCampaignManagerListFloodlightActivitiesArgs = {
  input?: Maybe<GoogleCampaignManagerListFloodlightActivitiesInput>;
};


export type QueryGoogleCampaignManagerListProfilesArgs = {
  input: GoogleCampaignManagerListProfilesInput;
};


export type QueryGoogleDescribeModeArgs = {
  input: GoogleAdsDescribeModeInput;
};


export type QueryGoogleGetAccountsArgs = {
  input: GoogleAccountsInput;
};


export type QueryGoogleListConversionActionsArgs = {
  input?: Maybe<GoogleAdsListConversionActionsInput>;
};


export type QueryGooglesheetsListSheetsArgs = {
  input: GooglesheetsListSheetsInput;
};


export type QueryGooglesheetsListSpreadSheetsArgs = {
  accessToken?: Maybe<Scalars['String']>;
  destinationId?: Maybe<Scalars['Int']>;
};


export type QueryGooglesheetsRetrieveAccessTokenArgs = {
  input: GooglesheetsRetrieveAccessTokenInput;
};


export type QueryGooglesheetsSourceListSheetsArgs = {
  connectionId: Scalars['String'];
};


export type QueryHubspotDescribeGlobalArgs = {
  input: HubSpotDescribeGlobalInput;
};


export type QueryHubspotDescribeObjectArgs = {
  input: HubSpotDescribeObjectInput;
};


export type QueryHubspotLegacyDescribeGlobalArgs = {
  input: HubSpotLegacyDescribeGlobalInput;
};


export type QueryHubspotLegacyDescribeObjectArgs = {
  input: HubSpotLegacyDescribeObjectInput;
};


export type QueryIntercomListAttributesArgs = {
  input: IntercomListAttributesInput;
};


export type QueryIsOrganizationAvailableArgs = {
  name: Scalars['String'];
};


export type QueryIsResourceSlugAvailableArgs = {
  resourceType: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryIsWorkspaceSlugAvailableArgs = {
  slug: Scalars['String'];
};


export type QueryIterableGetCampaignsArgs = {
  input: IterableGetCampaignsInput;
};


export type QueryIterableGetCatalogFieldsArgs = {
  input?: Maybe<IterableGetCatalogFieldsInput>;
};


export type QueryIterableGetCatalogsArgs = {
  input: IterableGetCatalogsInput;
};


export type QueryIterableGetTemplatesArgs = {
  input: IterableGetTemplatesInput;
};


export type QueryIterableUserFieldsArgs = {
  input: IterableUserFieldsInput;
};


export type QueryJiraGetIssueFieldsArgs = {
  input: JiraGetIssueFieldsInput;
};


export type QueryJiraGetIssueTypesArgs = {
  input: JiraGetIssueTypesInput;
};


export type QueryJiraGetProjectsArgs = {
  input: JiraGetProjectsInput;
};


export type QueryListAllSourceDependenciesArgs = {
  ids: Array<Scalars['bigint']>;
};


export type QueryListFilterableColumnsArgs = {
  parentModelId: Scalars['bigint'];
};


export type QueryListModelColumnsArgs = {
  modelId: Scalars['bigint'];
};


export type QueryListModelDependenciesArgs = {
  id: Scalars['String'];
};


export type QueryListPostgresColumnsArgs = {
  input: ListPostgresColumnsInput;
};


export type QueryListPostgresTablesArgs = {
  input: ListPostgresTablesInput;
};


export type QueryListRelationshipDependenciesArgs = {
  id: Scalars['String'];
};


export type QueryListSlackChannelsByCredentialsArgs = {
  id: Scalars['Int'];
};


export type QueryListSyncableColumnsArgs = {
  modelId: Scalars['bigint'];
};


export type QueryLookerLookQueryArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  lookId: Scalars['String'];
  modelId?: Maybe<Scalars['Int']>;
};


export type QueryLookerCredentialsArgs = {
  distinct_on?: Maybe<Array<LookerCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LookerCredentialsOrderBy>>;
  where?: Maybe<LookerCredentialsBoolExp>;
};


export type QueryLookerCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryMarketoDescribeActivityArgs = {
  input: MarketoDescribeActivityInput;
};


export type QueryMarketoDescribeObjectArgs = {
  input: MarketoDescribeObjectInput;
};


export type QueryMarketoListActivitiesArgs = {
  input: MarketoListActivitiesInput;
};


export type QueryMarketoListObjectsArgs = {
  input: MarketoListObjectsInput;
};


export type QueryMembershipRequestsArgs = {
  distinct_on?: Maybe<Array<MembershipRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipRequestsOrderBy>>;
  where?: Maybe<MembershipRequestsBoolExp>;
};


export type QueryMembershipRequestsByPkArgs = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type QueryMembershipsArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


export type QueryMembershipsAggregateArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


export type QueryMembershipsByPkArgs = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type QueryMetabaseListDatabasesArgs = {
  connectionId: Scalars['String'];
};


export type QueryMetabaseListQuestionsArgs = {
  connectionId: Scalars['String'];
};


export type QueryMetabaseListTablesArgs = {
  connectionId: Scalars['String'];
};


export type QueryMixpanelGetLookupTablesArgs = {
  input: DestinationIdInput;
};


export type QueryMixpanelListCohortsArgs = {
  connectionId: Scalars['String'];
  projectId: Scalars['Int'];
};


export type QueryMixpanelListProjectsArgs = {
  connectionId: Scalars['String'];
};


export type QueryModelColumnsArgs = {
  distinct_on?: Maybe<Array<ModelColumnsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ModelColumnsOrderBy>>;
  where?: Maybe<ModelColumnsBoolExp>;
};


export type QueryModelColumnsByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};


export type QueryModelRelationshipsArgs = {
  distinct_on?: Maybe<Array<ModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ModelRelationshipsOrderBy>>;
  where?: Maybe<ModelRelationshipsBoolExp>;
};


export type QueryModelRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryMongodbListCollectionsArgs = {
  input: MongoDbListCollectionsInput;
};


export type QueryNotionGetDatabasePropertiesArgs = {
  input: NotionGetDatabasePropertiesInput;
};


export type QueryNotionGetDatabasesArgs = {
  input: NotionGetDatabasesInput;
};


export type QueryObjectDefinitionGroupsArgs = {
  distinct_on?: Maybe<Array<ObjectDefinitionGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectDefinitionGroupsOrderBy>>;
  where?: Maybe<ObjectDefinitionGroupsBoolExp>;
};


export type QueryObjectDefinitionGroupsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryObjectDefinitionsArgs = {
  distinct_on?: Maybe<Array<ObjectDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectDefinitionsOrderBy>>;
  where?: Maybe<ObjectDefinitionsBoolExp>;
};


export type QueryObjectDefinitionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryObjectSchemasArgs = {
  distinct_on?: Maybe<Array<ObjectSchemasSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectSchemasOrderBy>>;
  where?: Maybe<ObjectSchemasBoolExp>;
};


export type QueryObjectSchemasByPkArgs = {
  key: Scalars['String'];
  object_definition_id: Scalars['bigint'];
};


export type QueryOrbitListWorkspacesArgs = {
  input: OrbitListWorkspacesInput;
};


export type QueryOrganizationsArgs = {
  distinct_on?: Maybe<Array<OrganizationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<OrganizationsOrderBy>>;
  where?: Maybe<OrganizationsBoolExp>;
};


export type QueryOrganizationsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryOutboundUserInvitesArgs = {
  distinct_on?: Maybe<Array<OutboundUserInvitesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<OutboundUserInvitesOrderBy>>;
  where?: Maybe<OutboundUserInvitesBoolExp>;
};


export type QueryOutboundUserInvitesByPkArgs = {
  recipient_email: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type QueryPagerdutyCredentialsArgs = {
  distinct_on?: Maybe<Array<PagerdutyCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PagerdutyCredentialsOrderBy>>;
  where?: Maybe<PagerdutyCredentialsBoolExp>;
};


export type QueryPagerdutyCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryPartnerConnectGetConnectionArgs = {
  uuid: Scalars['String'];
};


export type QueryPartnerConnectGetInformationArgs = {
  uuid: Scalars['String'];
};


export type QueryPartnerConnectListAvailableWorkspacesArgs = {
  uuid: Scalars['String'];
};


export type QueryPipedriveListDomainsArgs = {
  input: PipedriveListDomainsInput;
};


export type QueryPreviewQuerySchemaArgs = {
  connectionId: Scalars['String'];
  query: Scalars['JSONObject'];
  queryType: Scalars['String'];
};


export type QueryQueryRunsArgs = {
  distinct_on?: Maybe<Array<QueryRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueryRunsOrderBy>>;
  where?: Maybe<QueryRunsBoolExp>;
};


export type QueryQueryRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRawSqlQueryArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  modelId?: Maybe<Scalars['Int']>;
  sql: Scalars['String'];
};


export type QueryRelationshipReferencesArgs = {
  distinct_on?: Maybe<Array<RelationshipReferencesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipReferencesOrderBy>>;
  where?: Maybe<RelationshipReferencesBoolExp>;
};


export type QueryRelationshipReferencesByPkArgs = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type QueryRelationshipsArgs = {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
};


export type QueryRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryResourceTagValuesArgs = {
  distinct_on?: Maybe<Array<ResourceTagValuesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ResourceTagValuesOrderBy>>;
  where?: Maybe<ResourceTagValuesBoolExp>;
};


export type QueryResourceViewsArgs = {
  distinct_on?: Maybe<Array<ResourceViewsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ResourceViewsOrderBy>>;
  where?: Maybe<ResourceViewsBoolExp>;
};


export type QueryResourceViewsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRolesArgs = {
  distinct_on?: Maybe<Array<RolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RolesOrderBy>>;
  where?: Maybe<RolesBoolExp>;
};


export type QueryRolesByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySalesloftListCustomFieldsArgs = {
  input?: Maybe<SalesloftCustomFieldsInput>;
};


export type QuerySampleDataSourcesArgs = {
  distinct_on?: Maybe<Array<SampleDataSourcesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SampleDataSourcesOrderBy>>;
  where?: Maybe<SampleDataSourcesBoolExp>;
};


export type QuerySampleDataSourcesByPkArgs = {
  uuid: Scalars['uuid'];
};


export type QuerySavedQueriesArgs = {
  distinct_on?: Maybe<Array<SavedQueriesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SavedQueriesOrderBy>>;
  where?: Maybe<SavedQueriesBoolExp>;
};


export type QuerySavedQueriesByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySearchLookerLooksArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sorts?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type QuerySegmentsArgs = {
  distinct_on?: Maybe<Array<SegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SegmentsOrderBy>>;
  where?: Maybe<SegmentsBoolExp>;
};


export type QuerySegmentsAggregateArgs = {
  distinct_on?: Maybe<Array<SegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SegmentsOrderBy>>;
  where?: Maybe<SegmentsBoolExp>;
};


export type QuerySegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySendGridContactSchemaArgs = {
  input: SendGridContactSchemaInput;
};


export type QuerySfmcListAttributeSetsArgs = {
  input: SfmcListAttributeSetsInput;
};


export type QuerySfmcListBusinessUnitsArgs = {
  input: SfmcListBusinessUnitsInput;
};


export type QuerySfmcListDataExtensionFieldsArgs = {
  input: SfmcListDataExtensionFieldsInput;
};


export type QuerySfmcListDataExtensionsArgs = {
  input: SfmcListDataExtensionsInput;
};


export type QuerySfmcListDataFoldersArgs = {
  input: SfmcListDataFoldersInput;
};


export type QuerySfmcListJourneysArgs = {
  input: SfmcListJourneysInput;
};


export type QuerySlackListChannelsArgs = {
  input: SlackListChannelsInput;
};


export type QuerySlackCredentialsArgs = {
  distinct_on?: Maybe<Array<SlackCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SlackCredentialsOrderBy>>;
  where?: Maybe<SlackCredentialsBoolExp>;
};


export type QuerySlackCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QuerySnapchatListAdAccountsArgs = {
  input: SnapchatListAdAccountsInput;
};


export type QuerySnapchatListOrganizationsArgs = {
  input: SnapchatListOrganizationsInput;
};


export type QuerySyncAlertsArgs = {
  distinct_on?: Maybe<Array<SyncAlertsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncAlertsOrderBy>>;
  where?: Maybe<SyncAlertsBoolExp>;
};


export type QuerySyncAttemptsArgs = {
  distinct_on?: Maybe<Array<SyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncAttemptsOrderBy>>;
  where?: Maybe<SyncAttemptsBoolExp>;
};


export type QuerySyncAttemptsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySyncRequestDiffsArgs = {
  distinct_on?: Maybe<Array<SyncRequestDiffsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestDiffsOrderBy>>;
  where?: Maybe<SyncRequestDiffsBoolExp>;
};


export type QuerySyncRequestDiffsByPkArgs = {
  sync_request_id: Scalars['bigint'];
};


export type QuerySyncRequestsArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


export type QuerySyncRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


export type QuerySyncRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySyncTemplatesArgs = {
  distinct_on?: Maybe<Array<SyncTemplatesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncTemplatesOrderBy>>;
  where?: Maybe<SyncTemplatesBoolExp>;
};


export type QuerySyncTemplatesByPkArgs = {
  id: Scalars['Int'];
};


export type QuerySyncsArgs = {
  distinct_on?: Maybe<Array<SyncsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncsOrderBy>>;
  where?: Maybe<SyncsBoolExp>;
};


export type QuerySyncsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncsOrderBy>>;
  where?: Maybe<SyncsBoolExp>;
};


export type QueryTableQueryArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  modelId?: Maybe<Scalars['Int']>;
  table: Scalars['String'];
};


export type QueryTestStorageConnectionArgs = {
  config?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};


export type QueryTestSyncConfigurationArgs = {
  destinationId: Scalars['Int'];
  operation: SyncOp;
  rows: Array<Scalars['JSONObject']>;
  segmentId: Scalars['Int'];
  syncConfig: Scalars['JSONObject'];
};


export type QueryTestSyncConfigurationSupportedArgs = {
  destinationId: Scalars['Int'];
  segmentId: Scalars['Int'];
  syncConfig: Scalars['JSONObject'];
};


export type QueryThroughModelRelationshipsArgs = {
  distinct_on?: Maybe<Array<ThroughModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ThroughModelRelationshipsOrderBy>>;
  where?: Maybe<ThroughModelRelationshipsBoolExp>;
};


export type QueryThroughModelRelationshipsByPkArgs = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};


export type QueryTiktokListAdvertisersArgs = {
  input: TiktokListAdvertisersInput;
};


export type QueryTraitDefinitionsArgs = {
  distinct_on?: Maybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TraitDefinitionsOrderBy>>;
  where?: Maybe<TraitDefinitionsBoolExp>;
};


export type QueryTraitDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryTunnelsArgs = {
  distinct_on?: Maybe<Array<TunnelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TunnelsOrderBy>>;
  where?: Maybe<TunnelsBoolExp>;
};


export type QueryTunnelsByPkArgs = {
  tunnel_id: Scalars['uuid'];
};


export type QueryUserflowGetAttributesArgs = {
  input: UserflowGetAttributesInput;
};


export type QueryUsersArgs = {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
};


export type QueryUsersByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryVisualQueryArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  filter: Scalars['JSONObject'];
  limit?: Maybe<Scalars['Int']>;
  parentModelId: Scalars['String'];
};


export type QueryWorkspacesArgs = {
  distinct_on?: Maybe<Array<WorkspacesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WorkspacesOrderBy>>;
  where?: Maybe<WorkspacesBoolExp>;
};


export type QueryWorkspacesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryZendeskListCustomFieldsArgs = {
  input: ZendeskListCustomFieldsInput;
};


export type QueryZendeskListCustomObjectPropertiesArgs = {
  input: ZendeskListCustomObjectPropertiesInput;
};


export type QueryZendeskListCustomObjectTypesArgs = {
  input: ZendeskListCustomObjectTypesInput;
};

/** columns and relationships of "query_runs" */
export type QueryRuns = {
  __typename?: 'query_runs';
  created_at: Scalars['timestamptz'];
  duration: Maybe<Scalars['Int']>;
  id: Scalars['bigint'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  size: Scalars['Int'];
};

/** order by aggregate values of table "query_runs" */
export type QueryRunsAggregateOrderBy = {
  avg?: Maybe<QueryRunsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<QueryRunsMaxOrderBy>;
  min?: Maybe<QueryRunsMinOrderBy>;
  stddev?: Maybe<QueryRunsStddevOrderBy>;
  stddev_pop?: Maybe<QueryRunsStddevPopOrderBy>;
  stddev_samp?: Maybe<QueryRunsStddevSampOrderBy>;
  sum?: Maybe<QueryRunsSumOrderBy>;
  var_pop?: Maybe<QueryRunsVarPopOrderBy>;
  var_samp?: Maybe<QueryRunsVarSampOrderBy>;
  variance?: Maybe<QueryRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "query_runs" */
export type QueryRunsAvgOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "query_runs". All fields are combined with a logical 'AND'. */
export type QueryRunsBoolExp = {
  _and?: Maybe<Array<QueryRunsBoolExp>>;
  _not?: Maybe<QueryRunsBoolExp>;
  _or?: Maybe<Array<QueryRunsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  duration?: Maybe<IntComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  segment?: Maybe<SegmentsBoolExp>;
  segment_id?: Maybe<BigintComparisonExp>;
  size?: Maybe<IntComparisonExp>;
};

/** order by max() on columns of table "query_runs" */
export type QueryRunsMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by min() on columns of table "query_runs" */
export type QueryRunsMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "query_runs". */
export type QueryRunsOrderBy = {
  created_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment?: Maybe<SegmentsOrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** select columns of table "query_runs" */
export const QueryRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Duration: 'duration',
  /** column name */
  Id: 'id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Size: 'size'
} as const;

export type QueryRunsSelectColumn = typeof QueryRunsSelectColumn[keyof typeof QueryRunsSelectColumn];
/** order by stddev() on columns of table "query_runs" */
export type QueryRunsStddevOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "query_runs" */
export type QueryRunsStddevPopOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "query_runs" */
export type QueryRunsStddevSampOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "query_runs" */
export type QueryRunsSumOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "query_runs" */
export type QueryRunsVarPopOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "query_runs" */
export type QueryRunsVarSampOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "query_runs" */
export type QueryRunsVarianceOrderBy = {
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  size?: Maybe<OrderBy>;
};

/** columns and relationships of "relationship_references" */
export type RelationshipReferences = {
  __typename?: 'relationship_references';
  from_column: Scalars['String'];
  from_through_column: Maybe<Scalars['String']>;
  ordinal_number: Scalars['smallint'];
  /** An object relationship */
  relationship: Relationships;
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
  to_through_column: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "relationship_references" */
export type RelationshipReferencesAggregateOrderBy = {
  avg?: Maybe<RelationshipReferencesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RelationshipReferencesMaxOrderBy>;
  min?: Maybe<RelationshipReferencesMinOrderBy>;
  stddev?: Maybe<RelationshipReferencesStddevOrderBy>;
  stddev_pop?: Maybe<RelationshipReferencesStddevPopOrderBy>;
  stddev_samp?: Maybe<RelationshipReferencesStddevSampOrderBy>;
  sum?: Maybe<RelationshipReferencesSumOrderBy>;
  var_pop?: Maybe<RelationshipReferencesVarPopOrderBy>;
  var_samp?: Maybe<RelationshipReferencesVarSampOrderBy>;
  variance?: Maybe<RelationshipReferencesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "relationship_references" */
export type RelationshipReferencesArrRelInsertInput = {
  data: Array<RelationshipReferencesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<RelationshipReferencesOnConflict>;
};

/** order by avg() on columns of table "relationship_references" */
export type RelationshipReferencesAvgOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "relationship_references". All fields are combined with a logical 'AND'. */
export type RelationshipReferencesBoolExp = {
  _and?: Maybe<Array<RelationshipReferencesBoolExp>>;
  _not?: Maybe<RelationshipReferencesBoolExp>;
  _or?: Maybe<Array<RelationshipReferencesBoolExp>>;
  from_column?: Maybe<StringComparisonExp>;
  from_through_column?: Maybe<StringComparisonExp>;
  ordinal_number?: Maybe<SmallintComparisonExp>;
  relationship?: Maybe<RelationshipsBoolExp>;
  relationship_id?: Maybe<BigintComparisonExp>;
  to_column?: Maybe<StringComparisonExp>;
  to_through_column?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "relationship_references" */
export const RelationshipReferencesConstraint = {
  /** unique or primary key constraint */
  RelationshipReferencesPkey: 'relationship_references_pkey'
} as const;

export type RelationshipReferencesConstraint = typeof RelationshipReferencesConstraint[keyof typeof RelationshipReferencesConstraint];
/** input type for incrementing numeric columns in table "relationship_references" */
export type RelationshipReferencesIncInput = {
  ordinal_number?: Maybe<Scalars['smallint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "relationship_references" */
export type RelationshipReferencesInsertInput = {
  from_column?: Maybe<Scalars['String']>;
  from_through_column?: Maybe<Scalars['String']>;
  ordinal_number?: Maybe<Scalars['smallint']>;
  relationship?: Maybe<RelationshipsObjRelInsertInput>;
  relationship_id?: Maybe<Scalars['bigint']>;
  to_column?: Maybe<Scalars['String']>;
  to_through_column?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "relationship_references" */
export type RelationshipReferencesMaxOrderBy = {
  from_column?: Maybe<OrderBy>;
  from_through_column?: Maybe<OrderBy>;
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
  to_through_column?: Maybe<OrderBy>;
};

/** order by min() on columns of table "relationship_references" */
export type RelationshipReferencesMinOrderBy = {
  from_column?: Maybe<OrderBy>;
  from_through_column?: Maybe<OrderBy>;
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
  to_through_column?: Maybe<OrderBy>;
};

/** response of any mutation on the table "relationship_references" */
export type RelationshipReferencesMutationResponse = {
  __typename?: 'relationship_references_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationshipReferences>;
};

/** on conflict condition type for table "relationship_references" */
export type RelationshipReferencesOnConflict = {
  constraint: RelationshipReferencesConstraint;
  update_columns?: Array<RelationshipReferencesUpdateColumn>;
  where?: Maybe<RelationshipReferencesBoolExp>;
};

/** Ordering options when selecting data from "relationship_references". */
export type RelationshipReferencesOrderBy = {
  from_column?: Maybe<OrderBy>;
  from_through_column?: Maybe<OrderBy>;
  ordinal_number?: Maybe<OrderBy>;
  relationship?: Maybe<RelationshipsOrderBy>;
  relationship_id?: Maybe<OrderBy>;
  to_column?: Maybe<OrderBy>;
  to_through_column?: Maybe<OrderBy>;
};

/** primary key columns input for table: relationship_references */
export type RelationshipReferencesPkColumnsInput = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};

/** select columns of table "relationship_references" */
export const RelationshipReferencesSelectColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromThroughColumn: 'from_through_column',
  /** column name */
  OrdinalNumber: 'ordinal_number',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToThroughColumn: 'to_through_column'
} as const;

export type RelationshipReferencesSelectColumn = typeof RelationshipReferencesSelectColumn[keyof typeof RelationshipReferencesSelectColumn];
/** input type for updating data in table "relationship_references" */
export type RelationshipReferencesSetInput = {
  from_column?: Maybe<Scalars['String']>;
  from_through_column?: Maybe<Scalars['String']>;
  ordinal_number?: Maybe<Scalars['smallint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  to_column?: Maybe<Scalars['String']>;
  to_through_column?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "relationship_references" */
export type RelationshipReferencesStddevOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "relationship_references" */
export type RelationshipReferencesStddevPopOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "relationship_references" */
export type RelationshipReferencesStddevSampOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "relationship_references" */
export type RelationshipReferencesSumOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** update columns of table "relationship_references" */
export const RelationshipReferencesUpdateColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromThroughColumn: 'from_through_column',
  /** column name */
  OrdinalNumber: 'ordinal_number',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToThroughColumn: 'to_through_column'
} as const;

export type RelationshipReferencesUpdateColumn = typeof RelationshipReferencesUpdateColumn[keyof typeof RelationshipReferencesUpdateColumn];
/** order by var_pop() on columns of table "relationship_references" */
export type RelationshipReferencesVarPopOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "relationship_references" */
export type RelationshipReferencesVarSampOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "relationship_references" */
export type RelationshipReferencesVarianceOrderBy = {
  ordinal_number?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** columns and relationships of "relationships" */
export type Relationships = {
  __typename?: 'relationships';
  from_name: Maybe<Scalars['String']>;
  /** An object relationship */
  from_object_definition: ObjectDefinitions;
  from_object_definition_id: Scalars['bigint'];
  id: Scalars['bigint'];
  ownership: Scalars['Boolean'];
  /** An array relationship */
  relationship_references: Array<RelationshipReferences>;
  /** An object relationship */
  through_object_definition: Maybe<ObjectDefinitions>;
  through_object_definition_id: Maybe<Scalars['bigint']>;
  to_name: Maybe<Scalars['String']>;
  /** An object relationship */
  to_object_definition: ObjectDefinitions;
  to_object_definition_id: Scalars['bigint'];
  type: Scalars['String'];
};


/** columns and relationships of "relationships" */
export type RelationshipsRelationshipReferencesArgs = {
  distinct_on?: Maybe<Array<RelationshipReferencesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipReferencesOrderBy>>;
  where?: Maybe<RelationshipReferencesBoolExp>;
};

/** order by aggregate values of table "relationships" */
export type RelationshipsAggregateOrderBy = {
  avg?: Maybe<RelationshipsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RelationshipsMaxOrderBy>;
  min?: Maybe<RelationshipsMinOrderBy>;
  stddev?: Maybe<RelationshipsStddevOrderBy>;
  stddev_pop?: Maybe<RelationshipsStddevPopOrderBy>;
  stddev_samp?: Maybe<RelationshipsStddevSampOrderBy>;
  sum?: Maybe<RelationshipsSumOrderBy>;
  var_pop?: Maybe<RelationshipsVarPopOrderBy>;
  var_samp?: Maybe<RelationshipsVarSampOrderBy>;
  variance?: Maybe<RelationshipsVarianceOrderBy>;
};

/** order by avg() on columns of table "relationships" */
export type RelationshipsAvgOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export type RelationshipsBoolExp = {
  _and?: Maybe<Array<RelationshipsBoolExp>>;
  _not?: Maybe<RelationshipsBoolExp>;
  _or?: Maybe<Array<RelationshipsBoolExp>>;
  from_name?: Maybe<StringComparisonExp>;
  from_object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  from_object_definition_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  ownership?: Maybe<BooleanComparisonExp>;
  relationship_references?: Maybe<RelationshipReferencesBoolExp>;
  through_object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  through_object_definition_id?: Maybe<BigintComparisonExp>;
  to_name?: Maybe<StringComparisonExp>;
  to_object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  to_object_definition_id?: Maybe<BigintComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "relationships" */
export const RelationshipsConstraint = {
  /** unique or primary key constraint */
  RelationshipsFromObjectDefinitionIdToObjectDefinitioKey: 'relationships_from_object_definition_id_to_object_definitio_key',
  /** unique or primary key constraint */
  RelationshipsPkey: 'relationships_pkey'
} as const;

export type RelationshipsConstraint = typeof RelationshipsConstraint[keyof typeof RelationshipsConstraint];
/** input type for incrementing numeric columns in table "relationships" */
export type RelationshipsIncInput = {
  from_object_definition_id?: Maybe<Scalars['bigint']>;
  through_object_definition_id?: Maybe<Scalars['bigint']>;
  to_object_definition_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "relationships" */
export type RelationshipsInsertInput = {
  from_name?: Maybe<Scalars['String']>;
  from_object_definition_id?: Maybe<Scalars['bigint']>;
  ownership?: Maybe<Scalars['Boolean']>;
  relationship_references?: Maybe<RelationshipReferencesArrRelInsertInput>;
  through_object_definition_id?: Maybe<Scalars['bigint']>;
  to_name?: Maybe<Scalars['String']>;
  to_object_definition_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "relationships" */
export type RelationshipsMaxOrderBy = {
  from_name?: Maybe<OrderBy>;
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_name?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** order by min() on columns of table "relationships" */
export type RelationshipsMinOrderBy = {
  from_name?: Maybe<OrderBy>;
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_name?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** response of any mutation on the table "relationships" */
export type RelationshipsMutationResponse = {
  __typename?: 'relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relationships>;
};

/** input type for inserting object relation for remote table "relationships" */
export type RelationshipsObjRelInsertInput = {
  data: RelationshipsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<RelationshipsOnConflict>;
};

/** on conflict condition type for table "relationships" */
export type RelationshipsOnConflict = {
  constraint: RelationshipsConstraint;
  update_columns?: Array<RelationshipsUpdateColumn>;
  where?: Maybe<RelationshipsBoolExp>;
};

/** Ordering options when selecting data from "relationships". */
export type RelationshipsOrderBy = {
  from_name?: Maybe<OrderBy>;
  from_object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  ownership?: Maybe<OrderBy>;
  relationship_references_aggregate?: Maybe<RelationshipReferencesAggregateOrderBy>;
  through_object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_name?: Maybe<OrderBy>;
  to_object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: relationships */
export type RelationshipsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "relationships" */
export const RelationshipsSelectColumn = {
  /** column name */
  FromName: 'from_name',
  /** column name */
  FromObjectDefinitionId: 'from_object_definition_id',
  /** column name */
  Id: 'id',
  /** column name */
  Ownership: 'ownership',
  /** column name */
  ThroughObjectDefinitionId: 'through_object_definition_id',
  /** column name */
  ToName: 'to_name',
  /** column name */
  ToObjectDefinitionId: 'to_object_definition_id',
  /** column name */
  Type: 'type'
} as const;

export type RelationshipsSelectColumn = typeof RelationshipsSelectColumn[keyof typeof RelationshipsSelectColumn];
/** input type for updating data in table "relationships" */
export type RelationshipsSetInput = {
  from_name?: Maybe<Scalars['String']>;
  from_object_definition_id?: Maybe<Scalars['bigint']>;
  ownership?: Maybe<Scalars['Boolean']>;
  through_object_definition_id?: Maybe<Scalars['bigint']>;
  to_name?: Maybe<Scalars['String']>;
  to_object_definition_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "relationships" */
export type RelationshipsStddevOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "relationships" */
export type RelationshipsStddevPopOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "relationships" */
export type RelationshipsStddevSampOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "relationships" */
export type RelationshipsSumOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** update columns of table "relationships" */
export const RelationshipsUpdateColumn = {
  /** column name */
  FromName: 'from_name',
  /** column name */
  FromObjectDefinitionId: 'from_object_definition_id',
  /** column name */
  Ownership: 'ownership',
  /** column name */
  ThroughObjectDefinitionId: 'through_object_definition_id',
  /** column name */
  ToName: 'to_name',
  /** column name */
  ToObjectDefinitionId: 'to_object_definition_id',
  /** column name */
  Type: 'type'
} as const;

export type RelationshipsUpdateColumn = typeof RelationshipsUpdateColumn[keyof typeof RelationshipsUpdateColumn];
/** order by var_pop() on columns of table "relationships" */
export type RelationshipsVarPopOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "relationships" */
export type RelationshipsVarSampOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "relationships" */
export type RelationshipsVarianceOrderBy = {
  from_object_definition_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  through_object_definition_id?: Maybe<OrderBy>;
  to_object_definition_id?: Maybe<OrderBy>;
};

/** columns and relationships of "resource_tag_values" */
export type ResourceTagValues = {
  __typename?: 'resource_tag_values';
  resource_type: Maybe<Scalars['String']>;
  tag_key: Maybe<Scalars['String']>;
  tag_values: Maybe<Scalars['json']>;
  workspace_id: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "resource_tag_values" */
export type ResourceTagValuesTagValuesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "resource_tag_values". All fields are combined with a logical 'AND'. */
export type ResourceTagValuesBoolExp = {
  _and?: Maybe<Array<ResourceTagValuesBoolExp>>;
  _not?: Maybe<ResourceTagValuesBoolExp>;
  _or?: Maybe<Array<ResourceTagValuesBoolExp>>;
  resource_type?: Maybe<StringComparisonExp>;
  tag_key?: Maybe<StringComparisonExp>;
  tag_values?: Maybe<JsonComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "resource_tag_values". */
export type ResourceTagValuesOrderBy = {
  resource_type?: Maybe<OrderBy>;
  tag_key?: Maybe<OrderBy>;
  tag_values?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "resource_tag_values" */
export const ResourceTagValuesSelectColumn = {
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  TagKey: 'tag_key',
  /** column name */
  TagValues: 'tag_values',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceTagValuesSelectColumn = typeof ResourceTagValuesSelectColumn[keyof typeof ResourceTagValuesSelectColumn];
/** columns and relationships of "resource_views" */
export type ResourceViews = {
  __typename?: 'resource_views';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  private: Scalars['Boolean'];
  resource_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Maybe<Scalars['bigint']>;
  view: Scalars['jsonb'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "resource_views" */
export type ResourceViewsViewArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ResourceViewsAppendInput = {
  view?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "resource_views". All fields are combined with a logical 'AND'. */
export type ResourceViewsBoolExp = {
  _and?: Maybe<Array<ResourceViewsBoolExp>>;
  _not?: Maybe<ResourceViewsBoolExp>;
  _or?: Maybe<Array<ResourceViewsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  private?: Maybe<BooleanComparisonExp>;
  resource_type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  view?: Maybe<JsonbComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "resource_views" */
export const ResourceViewsConstraint = {
  /** unique or primary key constraint */
  ResourceViewsPkey: 'resource_views_pkey'
} as const;

export type ResourceViewsConstraint = typeof ResourceViewsConstraint[keyof typeof ResourceViewsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ResourceViewsDeleteAtPathInput = {
  view?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ResourceViewsDeleteElemInput = {
  view?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ResourceViewsDeleteKeyInput = {
  view?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "resource_views" */
export type ResourceViewsInsertInput = {
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  resource_type?: Maybe<Scalars['String']>;
  view?: Maybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "resource_views" */
export type ResourceViewsMutationResponse = {
  __typename?: 'resource_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ResourceViews>;
};

/** on conflict condition type for table "resource_views" */
export type ResourceViewsOnConflict = {
  constraint: ResourceViewsConstraint;
  update_columns?: Array<ResourceViewsUpdateColumn>;
  where?: Maybe<ResourceViewsBoolExp>;
};

/** Ordering options when selecting data from "resource_views". */
export type ResourceViewsOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  private?: Maybe<OrderBy>;
  resource_type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  view?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: resource_views */
export type ResourceViewsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ResourceViewsPrependInput = {
  view?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "resource_views" */
export const ResourceViewsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Private: 'private',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  View: 'view',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceViewsSelectColumn = typeof ResourceViewsSelectColumn[keyof typeof ResourceViewsSelectColumn];
/** input type for updating data in table "resource_views" */
export type ResourceViewsSetInput = {
  name?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  view?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "resource_views" */
export const ResourceViewsUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  Private: 'private',
  /** column name */
  View: 'view'
} as const;

export type ResourceViewsUpdateColumn = typeof ResourceViewsUpdateColumn[keyof typeof ResourceViewsUpdateColumn];
/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: MembershipsAggregate;
  name: Scalars['String'];
  permissions: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "roles" */
export type RolesMembershipsArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


/** columns and relationships of "roles" */
export type RolesMembershipsAggregateArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


/** columns and relationships of "roles" */
export type RolesPermissionsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "roles" */
export type RolesAggregateOrderBy = {
  avg?: Maybe<RolesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RolesMaxOrderBy>;
  min?: Maybe<RolesMinOrderBy>;
  stddev?: Maybe<RolesStddevOrderBy>;
  stddev_pop?: Maybe<RolesStddevPopOrderBy>;
  stddev_samp?: Maybe<RolesStddevSampOrderBy>;
  sum?: Maybe<RolesSumOrderBy>;
  var_pop?: Maybe<RolesVarPopOrderBy>;
  var_samp?: Maybe<RolesVarSampOrderBy>;
  variance?: Maybe<RolesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RolesAppendInput = {
  permissions?: Maybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "roles" */
export type RolesAvgOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: Maybe<Array<RolesBoolExp>>;
  _not?: Maybe<RolesBoolExp>;
  _or?: Maybe<Array<RolesBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  memberships?: Maybe<MembershipsBoolExp>;
  name?: Maybe<StringComparisonExp>;
  permissions?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "roles" */
export const RolesConstraint = {
  /** unique or primary key constraint */
  RolesOneOwnerPerWorkspace: 'roles_one_owner_per_workspace',
  /** unique or primary key constraint */
  RolesPkey: 'roles_pkey'
} as const;

export type RolesConstraint = typeof RolesConstraint[keyof typeof RolesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RolesDeleteAtPathInput = {
  permissions?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RolesDeleteElemInput = {
  permissions?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RolesDeleteKeyInput = {
  permissions?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "roles" */
export type RolesInsertInput = {
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "roles" */
export type RolesMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "roles" */
export type RolesMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "roles" */
export type RolesMutationResponse = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** on conflict condition type for table "roles" */
export type RolesOnConflict = {
  constraint: RolesConstraint;
  update_columns?: Array<RolesUpdateColumn>;
  where?: Maybe<RolesBoolExp>;
};

/** Ordering options when selecting data from "roles". */
export type RolesOrderBy = {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  memberships_aggregate?: Maybe<MembershipsAggregateOrderBy>;
  name?: Maybe<OrderBy>;
  permissions?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: roles */
export type RolesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RolesPrependInput = {
  permissions?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "roles" */
export const RolesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Permissions: 'permissions',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type RolesSelectColumn = typeof RolesSelectColumn[keyof typeof RolesSelectColumn];
/** input type for updating data in table "roles" */
export type RolesSetInput = {
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "roles" */
export type RolesStddevOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "roles" */
export type RolesStddevPopOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "roles" */
export type RolesStddevSampOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "roles" */
export type RolesSumOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** update columns of table "roles" */
export const RolesUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  Permissions: 'permissions'
} as const;

export type RolesUpdateColumn = typeof RolesUpdateColumn[keyof typeof RolesUpdateColumn];
/** order by var_pop() on columns of table "roles" */
export type RolesVarPopOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "roles" */
export type RolesVarSampOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "roles" */
export type RolesVarianceOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "sample_data_sources" */
export type SampleDataSources = {
  __typename?: 'sample_data_sources';
  configuration: Scalars['jsonb'];
  metadata_slug: Scalars['String'];
  source_type: Scalars['String'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "sample_data_sources" */
export type SampleDataSourcesConfigurationArgs = {
  path?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "sample_data_sources". All fields are combined with a logical 'AND'. */
export type SampleDataSourcesBoolExp = {
  _and?: Maybe<Array<SampleDataSourcesBoolExp>>;
  _not?: Maybe<SampleDataSourcesBoolExp>;
  _or?: Maybe<Array<SampleDataSourcesBoolExp>>;
  configuration?: Maybe<JsonbComparisonExp>;
  metadata_slug?: Maybe<StringComparisonExp>;
  source_type?: Maybe<StringComparisonExp>;
  uuid?: Maybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "sample_data_sources". */
export type SampleDataSourcesOrderBy = {
  configuration?: Maybe<OrderBy>;
  metadata_slug?: Maybe<OrderBy>;
  source_type?: Maybe<OrderBy>;
  uuid?: Maybe<OrderBy>;
};

/** select columns of table "sample_data_sources" */
export const SampleDataSourcesSelectColumn = {
  /** column name */
  Configuration: 'configuration',
  /** column name */
  MetadataSlug: 'metadata_slug',
  /** column name */
  SourceType: 'source_type',
  /** column name */
  Uuid: 'uuid'
} as const;

export type SampleDataSourcesSelectColumn = typeof SampleDataSourcesSelectColumn[keyof typeof SampleDataSourcesSelectColumn];
/** columns and relationships of "saved_queries" */
export type SavedQueries = {
  __typename?: 'saved_queries';
  /** An object relationship */
  connection: Maybe<Connections>;
  connection_id: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by: Maybe<Scalars['bigint']>;
  filter_json: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  last_columns_cache: Maybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at: Maybe<Scalars['timestamptz']>;
  name: Maybe<Scalars['String']>;
  /** An object relationship */
  object_definition: Maybe<ObjectDefinitions>;
  object_definition_id: Maybe<Scalars['bigint']>;
  public: Scalars['Boolean'];
  query_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  workspace_id: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "saved_queries" */
export type SavedQueriesFilterJsonArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "saved_queries" */
export type SavedQueriesLastColumnsCacheArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedQueriesAppendInput = {
  filter_json?: Maybe<Scalars['jsonb']>;
  last_columns_cache?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "saved_queries". All fields are combined with a logical 'AND'. */
export type SavedQueriesBoolExp = {
  _and?: Maybe<Array<SavedQueriesBoolExp>>;
  _not?: Maybe<SavedQueriesBoolExp>;
  _or?: Maybe<Array<SavedQueriesBoolExp>>;
  connection?: Maybe<ConnectionsBoolExp>;
  connection_id?: Maybe<BigintComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  filter_json?: Maybe<JsonbComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  last_columns_cache?: Maybe<JsonbComparisonExp>;
  last_columns_cache_refreshed_at?: Maybe<TimestamptzComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  object_definition?: Maybe<ObjectDefinitionsBoolExp>;
  object_definition_id?: Maybe<BigintComparisonExp>;
  public?: Maybe<BooleanComparisonExp>;
  query_type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<BigintComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_queries" */
export const SavedQueriesConstraint = {
  /** unique or primary key constraint */
  FiltersPkey: 'filters_pkey'
} as const;

export type SavedQueriesConstraint = typeof SavedQueriesConstraint[keyof typeof SavedQueriesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedQueriesDeleteAtPathInput = {
  filter_json?: Maybe<Array<Scalars['String']>>;
  last_columns_cache?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedQueriesDeleteElemInput = {
  filter_json?: Maybe<Scalars['Int']>;
  last_columns_cache?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedQueriesDeleteKeyInput = {
  filter_json?: Maybe<Scalars['String']>;
  last_columns_cache?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "saved_queries" */
export type SavedQueriesIncInput = {
  connection_id?: Maybe<Scalars['bigint']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "saved_queries" */
export type SavedQueriesInsertInput = {
  connection?: Maybe<ConnectionsObjRelInsertInput>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filter_json?: Maybe<Scalars['jsonb']>;
  last_columns_cache?: Maybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  public?: Maybe<Scalars['Boolean']>;
  query_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "saved_queries" */
export type SavedQueriesMutationResponse = {
  __typename?: 'saved_queries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedQueries>;
};

/** input type for inserting object relation for remote table "saved_queries" */
export type SavedQueriesObjRelInsertInput = {
  data: SavedQueriesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SavedQueriesOnConflict>;
};

/** on conflict condition type for table "saved_queries" */
export type SavedQueriesOnConflict = {
  constraint: SavedQueriesConstraint;
  update_columns?: Array<SavedQueriesUpdateColumn>;
  where?: Maybe<SavedQueriesBoolExp>;
};

/** Ordering options when selecting data from "saved_queries". */
export type SavedQueriesOrderBy = {
  connection?: Maybe<ConnectionsOrderBy>;
  connection_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  filter_json?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_columns_cache?: Maybe<OrderBy>;
  last_columns_cache_refreshed_at?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  object_definition?: Maybe<ObjectDefinitionsOrderBy>;
  object_definition_id?: Maybe<OrderBy>;
  public?: Maybe<OrderBy>;
  query_type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: saved_queries */
export type SavedQueriesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedQueriesPrependInput = {
  filter_json?: Maybe<Scalars['jsonb']>;
  last_columns_cache?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "saved_queries" */
export const SavedQueriesSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  FilterJson: 'filter_json',
  /** column name */
  Id: 'id',
  /** column name */
  LastColumnsCache: 'last_columns_cache',
  /** column name */
  LastColumnsCacheRefreshedAt: 'last_columns_cache_refreshed_at',
  /** column name */
  Name: 'name',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Public: 'public',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedQueriesSelectColumn = typeof SavedQueriesSelectColumn[keyof typeof SavedQueriesSelectColumn];
/** input type for updating data in table "saved_queries" */
export type SavedQueriesSetInput = {
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filter_json?: Maybe<Scalars['jsonb']>;
  last_columns_cache?: Maybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  public?: Maybe<Scalars['Boolean']>;
  query_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** update columns of table "saved_queries" */
export const SavedQueriesUpdateColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FilterJson: 'filter_json',
  /** column name */
  LastColumnsCache: 'last_columns_cache',
  /** column name */
  LastColumnsCacheRefreshedAt: 'last_columns_cache_refreshed_at',
  /** column name */
  Name: 'name',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Public: 'public',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type SavedQueriesUpdateColumn = typeof SavedQueriesUpdateColumn[keyof typeof SavedQueriesUpdateColumn];
/** columns and relationships of "segments" */
export type Segments = {
  __typename?: 'segments';
  audience_columns: Array<ModelColumn>;
  /** An array relationship */
  columns: Array<ModelColumns>;
  /** An object relationship */
  connection: Maybe<Connections>;
  connection_id: Maybe<Scalars['bigint']>;
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  custom_query: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An object relationship */
  event: Maybe<EventModels>;
  filterable_audience_columns: Array<FilterableColumn>;
  git_sync_metadata: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema: Maybe<Scalars['Boolean']>;
  last_run_at: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  /** An object relationship */
  parent: Maybe<Segments>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key: Maybe<Scalars['String']>;
  query_dbt_model_id: Maybe<Scalars['Int']>;
  query_looker_look_id: Maybe<Scalars['String']>;
  query_raw_sql: Maybe<Scalars['String']>;
  /** An array relationship */
  query_runs: Array<QueryRuns>;
  query_table_name: Maybe<Scalars['String']>;
  query_type: Maybe<Scalars['String']>;
  /** An array relationship */
  relationships: Array<ModelRelationships>;
  /** An object relationship */
  saved_query: Maybe<SavedQueries>;
  saved_query_id: Maybe<Scalars['bigint']>;
  schedule: Maybe<Scalars['jsonb']>;
  schedule_paused: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
  syncable_columns: Array<SyncableColumn>;
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  tags: Scalars['jsonb'];
  /** An array relationship */
  traits: Array<TraitDefinitions>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  visual_query_filter: Maybe<Scalars['jsonb']>;
  visual_query_parent_id: Maybe<Scalars['bigint']>;
  visual_query_primary_label: Maybe<Scalars['String']>;
  visual_query_secondary_label: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "segments" */
export type SegmentsColumnsArgs = {
  distinct_on?: Maybe<Array<ModelColumnsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ModelColumnsOrderBy>>;
  where?: Maybe<ModelColumnsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsCustomQueryArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsDestinationInstancesArgs = {
  distinct_on?: Maybe<Array<DestinationInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationInstancesOrderBy>>;
  where?: Maybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsGitSyncMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsQueryRunsArgs = {
  distinct_on?: Maybe<Array<QueryRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueryRunsOrderBy>>;
  where?: Maybe<QueryRunsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRelationshipsArgs = {
  distinct_on?: Maybe<Array<ModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ModelRelationshipsOrderBy>>;
  where?: Maybe<ModelRelationshipsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsScheduleArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsSyncsArgs = {
  distinct_on?: Maybe<Array<SyncsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncsOrderBy>>;
  where?: Maybe<SyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSyncsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncsOrderBy>>;
  where?: Maybe<SyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsTagsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsTraitsArgs = {
  distinct_on?: Maybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TraitDefinitionsOrderBy>>;
  where?: Maybe<TraitDefinitionsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsVisualQueryFilterArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "segments" */
export type SegmentsAggregate = {
  __typename?: 'segments_aggregate';
  aggregate: Maybe<SegmentsAggregateFields>;
  nodes: Array<Segments>;
};

/** aggregate fields of "segments" */
export type SegmentsAggregateFields = {
  __typename?: 'segments_aggregate_fields';
  avg: Maybe<SegmentsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<SegmentsMaxFields>;
  min: Maybe<SegmentsMinFields>;
  stddev: Maybe<SegmentsStddevFields>;
  stddev_pop: Maybe<SegmentsStddevPopFields>;
  stddev_samp: Maybe<SegmentsStddevSampFields>;
  sum: Maybe<SegmentsSumFields>;
  var_pop: Maybe<SegmentsVarPopFields>;
  var_samp: Maybe<SegmentsVarSampFields>;
  variance: Maybe<SegmentsVarianceFields>;
};


/** aggregate fields of "segments" */
export type SegmentsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<SegmentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SegmentsAppendInput = {
  custom_query?: Maybe<Scalars['jsonb']>;
  schedule?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  visual_query_filter?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SegmentsAvgFields = {
  __typename?: 'segments_avg_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "segments". All fields are combined with a logical 'AND'. */
export type SegmentsBoolExp = {
  _and?: Maybe<Array<SegmentsBoolExp>>;
  _not?: Maybe<SegmentsBoolExp>;
  _or?: Maybe<Array<SegmentsBoolExp>>;
  columns?: Maybe<ModelColumnsBoolExp>;
  connection?: Maybe<ConnectionsBoolExp>;
  connection_id?: Maybe<BigintComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  created_by_user?: Maybe<UsersBoolExp>;
  custom_query?: Maybe<JsonbComparisonExp>;
  destination_instances?: Maybe<DestinationInstancesBoolExp>;
  event?: Maybe<EventModelsBoolExp>;
  git_sync_metadata?: Maybe<JsonbComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  is_schema?: Maybe<BooleanComparisonExp>;
  last_run_at?: Maybe<TimestamptzComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  parent?: Maybe<SegmentsBoolExp>;
  primary_key?: Maybe<StringComparisonExp>;
  query_dbt_model_id?: Maybe<IntComparisonExp>;
  query_looker_look_id?: Maybe<StringComparisonExp>;
  query_raw_sql?: Maybe<StringComparisonExp>;
  query_runs?: Maybe<QueryRunsBoolExp>;
  query_table_name?: Maybe<StringComparisonExp>;
  query_type?: Maybe<StringComparisonExp>;
  relationships?: Maybe<ModelRelationshipsBoolExp>;
  saved_query?: Maybe<SavedQueriesBoolExp>;
  saved_query_id?: Maybe<BigintComparisonExp>;
  schedule?: Maybe<JsonbComparisonExp>;
  schedule_paused?: Maybe<BooleanComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  syncs?: Maybe<SyncsBoolExp>;
  tags?: Maybe<JsonbComparisonExp>;
  traits?: Maybe<TraitDefinitionsBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  updated_by_user?: Maybe<UsersBoolExp>;
  visual_query_filter?: Maybe<JsonbComparisonExp>;
  visual_query_parent_id?: Maybe<BigintComparisonExp>;
  visual_query_primary_label?: Maybe<StringComparisonExp>;
  visual_query_secondary_label?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "segments" */
export const SegmentsConstraint = {
  /** unique or primary key constraint */
  SegmentPkey: 'segment_pkey',
  /** unique or primary key constraint */
  SegmentsSlugWorkspaceIdKey: 'segments_slug_workspace_id_key'
} as const;

export type SegmentsConstraint = typeof SegmentsConstraint[keyof typeof SegmentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SegmentsDeleteAtPathInput = {
  custom_query?: Maybe<Array<Scalars['String']>>;
  schedule?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  visual_query_filter?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SegmentsDeleteElemInput = {
  custom_query?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
  visual_query_filter?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SegmentsDeleteKeyInput = {
  custom_query?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  visual_query_filter?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "segments" */
export type SegmentsIncInput = {
  connection_id?: Maybe<Scalars['bigint']>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "segments" */
export type SegmentsInsertInput = {
  columns?: Maybe<ModelColumnsArrRelInsertInput>;
  connection?: Maybe<ConnectionsObjRelInsertInput>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  custom_query?: Maybe<Scalars['jsonb']>;
  destination_instances?: Maybe<DestinationInstancesArrRelInsertInput>;
  event?: Maybe<EventModelsObjRelInsertInput>;
  git_sync_metadata?: Maybe<Scalars['jsonb']>;
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema?: Maybe<Scalars['Boolean']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<SegmentsObjRelInsertInput>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: Maybe<Scalars['String']>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  query_looker_look_id?: Maybe<Scalars['String']>;
  query_raw_sql?: Maybe<Scalars['String']>;
  query_table_name?: Maybe<Scalars['String']>;
  query_type?: Maybe<Scalars['String']>;
  relationships?: Maybe<ModelRelationshipsArrRelInsertInput>;
  saved_query?: Maybe<SavedQueriesObjRelInsertInput>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  traits?: Maybe<TraitDefinitionsArrRelInsertInput>;
  visual_query_filter?: Maybe<Scalars['jsonb']>;
  visual_query_parent_id?: Maybe<Scalars['bigint']>;
  visual_query_primary_label?: Maybe<Scalars['String']>;
  visual_query_secondary_label?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SegmentsMaxFields = {
  __typename?: 'segments_max_fields';
  connection_id: Maybe<Scalars['bigint']>;
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  last_run_at: Maybe<Scalars['timestamptz']>;
  name: Maybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key: Maybe<Scalars['String']>;
  query_dbt_model_id: Maybe<Scalars['Int']>;
  query_looker_look_id: Maybe<Scalars['String']>;
  query_raw_sql: Maybe<Scalars['String']>;
  query_table_name: Maybe<Scalars['String']>;
  query_type: Maybe<Scalars['String']>;
  saved_query_id: Maybe<Scalars['bigint']>;
  slug: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  visual_query_parent_id: Maybe<Scalars['bigint']>;
  visual_query_primary_label: Maybe<Scalars['String']>;
  visual_query_secondary_label: Maybe<Scalars['String']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SegmentsMinFields = {
  __typename?: 'segments_min_fields';
  connection_id: Maybe<Scalars['bigint']>;
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  last_run_at: Maybe<Scalars['timestamptz']>;
  name: Maybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key: Maybe<Scalars['String']>;
  query_dbt_model_id: Maybe<Scalars['Int']>;
  query_looker_look_id: Maybe<Scalars['String']>;
  query_raw_sql: Maybe<Scalars['String']>;
  query_table_name: Maybe<Scalars['String']>;
  query_type: Maybe<Scalars['String']>;
  saved_query_id: Maybe<Scalars['bigint']>;
  slug: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  visual_query_parent_id: Maybe<Scalars['bigint']>;
  visual_query_primary_label: Maybe<Scalars['String']>;
  visual_query_secondary_label: Maybe<Scalars['String']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "segments" */
export type SegmentsMutationResponse = {
  __typename?: 'segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Segments>;
};

/** input type for inserting object relation for remote table "segments" */
export type SegmentsObjRelInsertInput = {
  data: SegmentsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SegmentsOnConflict>;
};

/** on conflict condition type for table "segments" */
export type SegmentsOnConflict = {
  constraint: SegmentsConstraint;
  update_columns?: Array<SegmentsUpdateColumn>;
  where?: Maybe<SegmentsBoolExp>;
};

/** Ordering options when selecting data from "segments". */
export type SegmentsOrderBy = {
  columns_aggregate?: Maybe<ModelColumnsAggregateOrderBy>;
  connection?: Maybe<ConnectionsOrderBy>;
  connection_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  created_by_user?: Maybe<UsersOrderBy>;
  custom_query?: Maybe<OrderBy>;
  destination_instances_aggregate?: Maybe<DestinationInstancesAggregateOrderBy>;
  event?: Maybe<EventModelsOrderBy>;
  git_sync_metadata?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_schema?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parent?: Maybe<SegmentsOrderBy>;
  primary_key?: Maybe<OrderBy>;
  query_dbt_model_id?: Maybe<OrderBy>;
  query_looker_look_id?: Maybe<OrderBy>;
  query_raw_sql?: Maybe<OrderBy>;
  query_runs_aggregate?: Maybe<QueryRunsAggregateOrderBy>;
  query_table_name?: Maybe<OrderBy>;
  query_type?: Maybe<OrderBy>;
  relationships_aggregate?: Maybe<ModelRelationshipsAggregateOrderBy>;
  saved_query?: Maybe<SavedQueriesOrderBy>;
  saved_query_id?: Maybe<OrderBy>;
  schedule?: Maybe<OrderBy>;
  schedule_paused?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  syncs_aggregate?: Maybe<SyncsAggregateOrderBy>;
  tags?: Maybe<OrderBy>;
  traits_aggregate?: Maybe<TraitDefinitionsAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  updated_by_user?: Maybe<UsersOrderBy>;
  visual_query_filter?: Maybe<OrderBy>;
  visual_query_parent_id?: Maybe<OrderBy>;
  visual_query_primary_label?: Maybe<OrderBy>;
  visual_query_secondary_label?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: segments */
export type SegmentsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SegmentsPrependInput = {
  custom_query?: Maybe<Scalars['jsonb']>;
  schedule?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  visual_query_filter?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "segments" */
export const SegmentsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CustomQuery: 'custom_query',
  /** column name */
  GitSyncMetadata: 'git_sync_metadata',
  /** column name */
  Id: 'id',
  /** column name */
  IsSchema: 'is_schema',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Name: 'name',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  QueryDbtModelId: 'query_dbt_model_id',
  /** column name */
  QueryLookerLookId: 'query_looker_look_id',
  /** column name */
  QueryRawSql: 'query_raw_sql',
  /** column name */
  QueryTableName: 'query_table_name',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  SavedQueryId: 'saved_query_id',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VisualQueryFilter: 'visual_query_filter',
  /** column name */
  VisualQueryParentId: 'visual_query_parent_id',
  /** column name */
  VisualQueryPrimaryLabel: 'visual_query_primary_label',
  /** column name */
  VisualQuerySecondaryLabel: 'visual_query_secondary_label',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SegmentsSelectColumn = typeof SegmentsSelectColumn[keyof typeof SegmentsSelectColumn];
/** input type for updating data in table "segments" */
export type SegmentsSetInput = {
  connection_id?: Maybe<Scalars['bigint']>;
  custom_query?: Maybe<Scalars['jsonb']>;
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema?: Maybe<Scalars['Boolean']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: Maybe<Scalars['String']>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  query_looker_look_id?: Maybe<Scalars['String']>;
  query_raw_sql?: Maybe<Scalars['String']>;
  query_table_name?: Maybe<Scalars['String']>;
  query_type?: Maybe<Scalars['String']>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  visual_query_filter?: Maybe<Scalars['jsonb']>;
  visual_query_primary_label?: Maybe<Scalars['String']>;
  visual_query_secondary_label?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SegmentsStddevFields = {
  __typename?: 'segments_stddev_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SegmentsStddevPopFields = {
  __typename?: 'segments_stddev_pop_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SegmentsStddevSampFields = {
  __typename?: 'segments_stddev_samp_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type SegmentsSumFields = {
  __typename?: 'segments_sum_fields';
  connection_id: Maybe<Scalars['bigint']>;
  created_by: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  query_dbt_model_id: Maybe<Scalars['Int']>;
  saved_query_id: Maybe<Scalars['bigint']>;
  updated_by: Maybe<Scalars['bigint']>;
  visual_query_parent_id: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** update columns of table "segments" */
export const SegmentsUpdateColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CustomQuery: 'custom_query',
  /** column name */
  IsSchema: 'is_schema',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Name: 'name',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  QueryDbtModelId: 'query_dbt_model_id',
  /** column name */
  QueryLookerLookId: 'query_looker_look_id',
  /** column name */
  QueryRawSql: 'query_raw_sql',
  /** column name */
  QueryTableName: 'query_table_name',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  SavedQueryId: 'saved_query_id',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VisualQueryFilter: 'visual_query_filter',
  /** column name */
  VisualQueryPrimaryLabel: 'visual_query_primary_label',
  /** column name */
  VisualQuerySecondaryLabel: 'visual_query_secondary_label'
} as const;

export type SegmentsUpdateColumn = typeof SegmentsUpdateColumn[keyof typeof SegmentsUpdateColumn];
/** aggregate var_pop on columns */
export type SegmentsVarPopFields = {
  __typename?: 'segments_var_pop_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SegmentsVarSampFields = {
  __typename?: 'segments_var_samp_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SegmentsVarianceFields = {
  __typename?: 'segments_variance_fields';
  connection_id: Maybe<Scalars['Float']>;
  created_by: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  query_dbt_model_id: Maybe<Scalars['Float']>;
  saved_query_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  visual_query_parent_id: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "slack_credentials" */
export type SlackCredentials = {
  __typename?: 'slack_credentials';
  channel_id: Maybe<Scalars['String']>;
  channel_name: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  state: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
};

/** Boolean expression to filter rows from the table "slack_credentials". All fields are combined with a logical 'AND'. */
export type SlackCredentialsBoolExp = {
  _and?: Maybe<Array<SlackCredentialsBoolExp>>;
  _not?: Maybe<SlackCredentialsBoolExp>;
  _or?: Maybe<Array<SlackCredentialsBoolExp>>;
  channel_id?: Maybe<StringComparisonExp>;
  channel_name?: Maybe<StringComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  state?: Maybe<StringComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
};

/** response of any mutation on the table "slack_credentials" */
export type SlackCredentialsMutationResponse = {
  __typename?: 'slack_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SlackCredentials>;
};

/** Ordering options when selecting data from "slack_credentials". */
export type SlackCredentialsOrderBy = {
  channel_id?: Maybe<OrderBy>;
  channel_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
};

/** primary key columns input for table: slack_credentials */
export type SlackCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "slack_credentials" */
export const SlackCredentialsSelectColumn = {
  /** column name */
  ChannelId: 'channel_id',
  /** column name */
  ChannelName: 'channel_name',
  /** column name */
  Id: 'id',
  /** column name */
  State: 'state'
} as const;

export type SlackCredentialsSelectColumn = typeof SlackCredentialsSelectColumn[keyof typeof SlackCredentialsSelectColumn];
/** input type for updating data in table "slack_credentials" */
export type SlackCredentialsSetInput = {
  channel_id?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: Maybe<Scalars['smallint']>;
  _gt?: Maybe<Scalars['smallint']>;
  _gte?: Maybe<Scalars['smallint']>;
  _in?: Maybe<Array<Scalars['smallint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['smallint']>;
  _lte?: Maybe<Scalars['smallint']>;
  _neq?: Maybe<Scalars['smallint']>;
  _nin?: Maybe<Array<Scalars['smallint']>>;
};

export type Subscription = {
  __typename?: 'subscription';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  /** fetch data from the table: "alert_statuses" using primary key columns */
  alert_statuses_by_pk: Maybe<AlertStatuses>;
  /** fetch data from the table: "alerts" */
  alerts: Array<Alerts>;
  /** fetch data from the table: "alerts" using primary key columns */
  alerts_by_pk: Maybe<Alerts>;
  /** fetch data from the table: "api_keys" */
  api_keys: Array<ApiKeys>;
  /** fetch data from the table: "api_keys" using primary key columns */
  api_keys_by_pk: Maybe<ApiKeys>;
  /** fetch data from the table: "billing_products" */
  billing_products: Array<BillingProducts>;
  /** fetch data from the table: "billing_products" using primary key columns */
  billing_products_by_pk: Maybe<BillingProducts>;
  /** fetch data from the table: "cloud_credentials" */
  cloud_credentials: Array<CloudCredentials>;
  /** fetch data from the table: "cloud_credentials" using primary key columns */
  cloud_credentials_by_pk: Maybe<CloudCredentials>;
  /** fetch data from the table: "column_selectors" */
  column_selectors: Array<ColumnSelectors>;
  /** fetch data from the table: "column_selectors" using primary key columns */
  column_selectors_by_pk: Maybe<ColumnSelectors>;
  /** fetch data from the table: "connections" */
  connections: Array<Connections>;
  /** fetch aggregated fields from the table: "connections" */
  connections_aggregate: ConnectionsAggregate;
  /** fetch data from the table: "connections" using primary key columns */
  connections_by_pk: Maybe<Connections>;
  /** fetch data from the table: "datadog_credentials" */
  datadog_credentials: Array<DatadogCredentials>;
  /** fetch data from the table: "datadog_credentials" using primary key columns */
  datadog_credentials_by_pk: Maybe<DatadogCredentials>;
  /** fetch data from the table: "dbt_credentials" */
  dbt_credentials: Array<DbtCredentials>;
  /** fetch data from the table: "dbt_credentials" using primary key columns */
  dbt_credentials_by_pk: Maybe<DbtCredentials>;
  /** fetch data from the table: "dbt_models" */
  dbt_models: Array<DbtModels>;
  /** fetch data from the table: "dbt_models" using primary key columns */
  dbt_models_by_pk: Maybe<DbtModels>;
  /** fetch data from the table: "dbt_sync_config" */
  dbt_sync_config: Array<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_config" using primary key columns */
  dbt_sync_config_by_pk: Maybe<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_models" */
  dbt_sync_models: Array<DbtSyncModels>;
  /** fetch data from the table: "dbt_sync_models" using primary key columns */
  dbt_sync_models_by_pk: Maybe<DbtSyncModels>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** fetch data from the table: "destination_instances" using primary key columns */
  destination_instances_by_pk: Maybe<DestinationInstances>;
  /** fetch data from the table: "destinations" */
  destinations: Array<Destinations>;
  /** fetch aggregated fields from the table: "destinations" */
  destinations_aggregate: DestinationsAggregate;
  /** fetch data from the table: "destinations" using primary key columns */
  destinations_by_pk: Maybe<Destinations>;
  /** fetch data from the table: "direct_model_relationships" */
  direct_model_relationships: Array<DirectModelRelationships>;
  /** fetch data from the table: "direct_model_relationships" using primary key columns */
  direct_model_relationships_by_pk: Maybe<DirectModelRelationships>;
  /** fetch data from the table: "event_definitions" */
  event_definitions: Array<EventDefinitions>;
  /** fetch data from the table: "event_definitions" using primary key columns */
  event_definitions_by_pk: Maybe<EventDefinitions>;
  /** fetch data from the table: "event_models" */
  event_models: Array<EventModels>;
  /** fetch data from the table: "event_models" using primary key columns */
  event_models_by_pk: Maybe<EventModels>;
  /** fetch data from the table: "external_buckets" */
  external_buckets: Array<ExternalBuckets>;
  /** fetch data from the table: "external_buckets" using primary key columns */
  external_buckets_by_pk: Maybe<ExternalBuckets>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  /** fetch data from the table: "external_segments" using primary key columns */
  external_segments_by_pk: Maybe<ExternalSegments>;
  /** fetch data from the table: "git_credentials" */
  git_credentials: Array<GitCredentials>;
  /** fetch data from the table: "git_credentials" using primary key columns */
  git_credentials_by_pk: Maybe<GitCredentials>;
  /** An array relationship */
  git_inbound_runs: Array<GitInboundRuns>;
  /** fetch data from the table: "git_inbound_runs" using primary key columns */
  git_inbound_runs_by_pk: Maybe<GitInboundRuns>;
  /** fetch data from the table: "git_outbound_runs" */
  git_outbound_runs: Array<GitOutboundRuns>;
  /** fetch data from the table: "git_outbound_runs" using primary key columns */
  git_outbound_runs_by_pk: Maybe<GitOutboundRuns>;
  /** fetch data from the table: "git_sync_attempts" */
  git_sync_attempts: Array<GitSyncAttempts>;
  /** fetch aggregated fields from the table: "git_sync_attempts" */
  git_sync_attempts_aggregate: GitSyncAttemptsAggregate;
  /** fetch data from the table: "git_sync_attempts" using primary key columns */
  git_sync_attempts_by_pk: Maybe<GitSyncAttempts>;
  /** fetch data from the table: "git_sync_config" */
  git_sync_config: Array<GitSyncConfig>;
  /** fetch data from the table: "git_sync_config" using primary key columns */
  git_sync_config_by_pk: Maybe<GitSyncConfig>;
  /** fetch data from the table: "git_sync_configs" */
  git_sync_configs: Array<GitSyncConfigs>;
  /** fetch data from the table: "git_sync_configs" using primary key columns */
  git_sync_configs_by_pk: Maybe<GitSyncConfigs>;
  /** fetch data from the table: "looker_credentials" */
  looker_credentials: Array<LookerCredentials>;
  /** fetch data from the table: "looker_credentials" using primary key columns */
  looker_credentials_by_pk: Maybe<LookerCredentials>;
  /** An array relationship */
  membership_requests: Array<MembershipRequests>;
  /** fetch data from the table: "membership_requests" using primary key columns */
  membership_requests_by_pk: Maybe<MembershipRequests>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: MembershipsAggregate;
  /** fetch data from the table: "memberships" using primary key columns */
  memberships_by_pk: Maybe<Memberships>;
  /** fetch data from the table: "model_columns" */
  model_columns: Array<ModelColumns>;
  /** fetch data from the table: "model_columns" using primary key columns */
  model_columns_by_pk: Maybe<ModelColumns>;
  /** fetch data from the table: "model_relationships" */
  model_relationships: Array<ModelRelationships>;
  /** fetch data from the table: "model_relationships" using primary key columns */
  model_relationships_by_pk: Maybe<ModelRelationships>;
  /** fetch data from the table: "object_definition_groups" */
  object_definition_groups: Array<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definition_groups" using primary key columns */
  object_definition_groups_by_pk: Maybe<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definitions" */
  object_definitions: Array<ObjectDefinitions>;
  /** fetch data from the table: "object_definitions" using primary key columns */
  object_definitions_by_pk: Maybe<ObjectDefinitions>;
  /** An array relationship */
  object_schemas: Array<ObjectSchemas>;
  /** fetch data from the table: "object_schemas" using primary key columns */
  object_schemas_by_pk: Maybe<ObjectSchemas>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk: Maybe<Organizations>;
  /** fetch data from the table: "outbound_user_invites" */
  outbound_user_invites: Array<OutboundUserInvites>;
  /** fetch data from the table: "outbound_user_invites" using primary key columns */
  outbound_user_invites_by_pk: Maybe<OutboundUserInvites>;
  /** fetch data from the table: "pagerduty_credentials" */
  pagerduty_credentials: Array<PagerdutyCredentials>;
  /** fetch data from the table: "pagerduty_credentials" using primary key columns */
  pagerduty_credentials_by_pk: Maybe<PagerdutyCredentials>;
  /** An array relationship */
  query_runs: Array<QueryRuns>;
  /** fetch data from the table: "query_runs" using primary key columns */
  query_runs_by_pk: Maybe<QueryRuns>;
  /** An array relationship */
  relationship_references: Array<RelationshipReferences>;
  /** fetch data from the table: "relationship_references" using primary key columns */
  relationship_references_by_pk: Maybe<RelationshipReferences>;
  /** fetch data from the table: "relationships" */
  relationships: Array<Relationships>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk: Maybe<Relationships>;
  /** fetch data from the table: "resource_tag_values" */
  resource_tag_values: Array<ResourceTagValues>;
  /** fetch data from the table: "resource_views" */
  resource_views: Array<ResourceViews>;
  /** fetch data from the table: "resource_views" using primary key columns */
  resource_views_by_pk: Maybe<ResourceViews>;
  /** An array relationship */
  roles: Array<Roles>;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk: Maybe<Roles>;
  /** fetch data from the table: "sample_data_sources" */
  sample_data_sources: Array<SampleDataSources>;
  /** fetch data from the table: "sample_data_sources" using primary key columns */
  sample_data_sources_by_pk: Maybe<SampleDataSources>;
  /** fetch data from the table: "saved_queries" */
  saved_queries: Array<SavedQueries>;
  /** fetch data from the table: "saved_queries" using primary key columns */
  saved_queries_by_pk: Maybe<SavedQueries>;
  /** fetch data from the table: "segments" */
  segments: Array<Segments>;
  /** fetch aggregated fields from the table: "segments" */
  segments_aggregate: SegmentsAggregate;
  /** fetch data from the table: "segments" using primary key columns */
  segments_by_pk: Maybe<Segments>;
  /** fetch data from the table: "slack_credentials" */
  slack_credentials: Array<SlackCredentials>;
  /** fetch data from the table: "slack_credentials" using primary key columns */
  slack_credentials_by_pk: Maybe<SlackCredentials>;
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** An array relationship */
  sync_attempts: Array<SyncAttempts>;
  /** fetch data from the table: "sync_attempts" using primary key columns */
  sync_attempts_by_pk: Maybe<SyncAttempts>;
  /** fetch data from the table: "sync_request_diffs" */
  sync_request_diffs: Array<SyncRequestDiffs>;
  /** fetch data from the table: "sync_request_diffs" using primary key columns */
  sync_request_diffs_by_pk: Maybe<SyncRequestDiffs>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** fetch data from the table: "sync_requests" using primary key columns */
  sync_requests_by_pk: Maybe<SyncRequests>;
  /** fetch data from the table: "sync_templates" */
  sync_templates: Array<SyncTemplates>;
  /** fetch data from the table: "sync_templates" using primary key columns */
  sync_templates_by_pk: Maybe<SyncTemplates>;
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  /** fetch data from the table: "through_model_relationships" */
  through_model_relationships: Array<ThroughModelRelationships>;
  /** fetch data from the table: "through_model_relationships" using primary key columns */
  through_model_relationships_by_pk: Maybe<ThroughModelRelationships>;
  /** fetch data from the table: "trait_definitions" */
  trait_definitions: Array<TraitDefinitions>;
  /** fetch data from the table: "trait_definitions" using primary key columns */
  trait_definitions_by_pk: Maybe<TraitDefinitions>;
  /** fetch data from the table: "tunnels" */
  tunnels: Array<Tunnels>;
  /** fetch data from the table: "tunnels" using primary key columns */
  tunnels_by_pk: Maybe<Tunnels>;
  /** An array relationship */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk: Maybe<Users>;
  /** An array relationship */
  workspaces: Array<Workspaces>;
  /** fetch data from the table: "workspaces" using primary key columns */
  workspaces_by_pk: Maybe<Workspaces>;
};


export type SubscriptionAlertInstancesArgs = {
  distinct_on?: Maybe<Array<AlertInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertInstancesOrderBy>>;
  where?: Maybe<AlertInstancesBoolExp>;
};


export type SubscriptionAlertStatusesArgs = {
  distinct_on?: Maybe<Array<AlertStatusesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertStatusesOrderBy>>;
  where?: Maybe<AlertStatusesBoolExp>;
};


export type SubscriptionAlertStatusesByPkArgs = {
  alert_id: Scalars['bigint'];
  destination_instance_id: Scalars['bigint'];
};


export type SubscriptionAlertsArgs = {
  distinct_on?: Maybe<Array<AlertsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertsOrderBy>>;
  where?: Maybe<AlertsBoolExp>;
};


export type SubscriptionAlertsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionApiKeysArgs = {
  distinct_on?: Maybe<Array<ApiKeysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ApiKeysOrderBy>>;
  where?: Maybe<ApiKeysBoolExp>;
};


export type SubscriptionApiKeysByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionBillingProductsArgs = {
  distinct_on?: Maybe<Array<BillingProductsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BillingProductsOrderBy>>;
  where?: Maybe<BillingProductsBoolExp>;
};


export type SubscriptionBillingProductsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCloudCredentialsArgs = {
  distinct_on?: Maybe<Array<CloudCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CloudCredentialsOrderBy>>;
  where?: Maybe<CloudCredentialsBoolExp>;
};


export type SubscriptionCloudCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionColumnSelectorsArgs = {
  distinct_on?: Maybe<Array<ColumnSelectorsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ColumnSelectorsOrderBy>>;
  where?: Maybe<ColumnSelectorsBoolExp>;
};


export type SubscriptionColumnSelectorsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionConnectionsArgs = {
  distinct_on?: Maybe<Array<ConnectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ConnectionsOrderBy>>;
  where?: Maybe<ConnectionsBoolExp>;
};


export type SubscriptionConnectionsAggregateArgs = {
  distinct_on?: Maybe<Array<ConnectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ConnectionsOrderBy>>;
  where?: Maybe<ConnectionsBoolExp>;
};


export type SubscriptionConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDatadogCredentialsArgs = {
  distinct_on?: Maybe<Array<DatadogCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DatadogCredentialsOrderBy>>;
  where?: Maybe<DatadogCredentialsBoolExp>;
};


export type SubscriptionDatadogCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionDbtCredentialsArgs = {
  distinct_on?: Maybe<Array<DbtCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtCredentialsOrderBy>>;
  where?: Maybe<DbtCredentialsBoolExp>;
};


export type SubscriptionDbtCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionDbtModelsArgs = {
  distinct_on?: Maybe<Array<DbtModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtModelsOrderBy>>;
  where?: Maybe<DbtModelsBoolExp>;
};


export type SubscriptionDbtModelsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionDbtSyncConfigArgs = {
  distinct_on?: Maybe<Array<DbtSyncConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtSyncConfigOrderBy>>;
  where?: Maybe<DbtSyncConfigBoolExp>;
};


export type SubscriptionDbtSyncConfigByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDbtSyncModelsArgs = {
  distinct_on?: Maybe<Array<DbtSyncModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbtSyncModelsOrderBy>>;
  where?: Maybe<DbtSyncModelsBoolExp>;
};


export type SubscriptionDbtSyncModelsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDestinationInstancesArgs = {
  distinct_on?: Maybe<Array<DestinationInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationInstancesOrderBy>>;
  where?: Maybe<DestinationInstancesBoolExp>;
};


export type SubscriptionDestinationInstancesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDestinationsArgs = {
  distinct_on?: Maybe<Array<DestinationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationsOrderBy>>;
  where?: Maybe<DestinationsBoolExp>;
};


export type SubscriptionDestinationsAggregateArgs = {
  distinct_on?: Maybe<Array<DestinationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationsOrderBy>>;
  where?: Maybe<DestinationsBoolExp>;
};


export type SubscriptionDestinationsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDirectModelRelationshipsArgs = {
  distinct_on?: Maybe<Array<DirectModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DirectModelRelationshipsOrderBy>>;
  where?: Maybe<DirectModelRelationshipsBoolExp>;
};


export type SubscriptionDirectModelRelationshipsByPkArgs = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type SubscriptionEventDefinitionsArgs = {
  distinct_on?: Maybe<Array<EventDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventDefinitionsOrderBy>>;
  where?: Maybe<EventDefinitionsBoolExp>;
};


export type SubscriptionEventDefinitionsByPkArgs = {
  object_definition_id: Scalars['bigint'];
};


export type SubscriptionEventModelsArgs = {
  distinct_on?: Maybe<Array<EventModelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventModelsOrderBy>>;
  where?: Maybe<EventModelsBoolExp>;
};


export type SubscriptionEventModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type SubscriptionExternalBucketsArgs = {
  distinct_on?: Maybe<Array<ExternalBucketsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ExternalBucketsOrderBy>>;
  where?: Maybe<ExternalBucketsBoolExp>;
};


export type SubscriptionExternalBucketsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type SubscriptionExternalSegmentsArgs = {
  distinct_on?: Maybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ExternalSegmentsOrderBy>>;
  where?: Maybe<ExternalSegmentsBoolExp>;
};


export type SubscriptionExternalSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitCredentialsArgs = {
  distinct_on?: Maybe<Array<GitCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitCredentialsOrderBy>>;
  where?: Maybe<GitCredentialsBoolExp>;
};


export type SubscriptionGitCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitInboundRunsArgs = {
  distinct_on?: Maybe<Array<GitInboundRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitInboundRunsOrderBy>>;
  where?: Maybe<GitInboundRunsBoolExp>;
};


export type SubscriptionGitInboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitOutboundRunsArgs = {
  distinct_on?: Maybe<Array<GitOutboundRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitOutboundRunsOrderBy>>;
  where?: Maybe<GitOutboundRunsBoolExp>;
};


export type SubscriptionGitOutboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitSyncAttemptsArgs = {
  distinct_on?: Maybe<Array<GitSyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncAttemptsOrderBy>>;
  where?: Maybe<GitSyncAttemptsBoolExp>;
};


export type SubscriptionGitSyncAttemptsAggregateArgs = {
  distinct_on?: Maybe<Array<GitSyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncAttemptsOrderBy>>;
  where?: Maybe<GitSyncAttemptsBoolExp>;
};


export type SubscriptionGitSyncAttemptsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionGitSyncConfigArgs = {
  distinct_on?: Maybe<Array<GitSyncConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncConfigOrderBy>>;
  where?: Maybe<GitSyncConfigBoolExp>;
};


export type SubscriptionGitSyncConfigByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionGitSyncConfigsArgs = {
  distinct_on?: Maybe<Array<GitSyncConfigsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GitSyncConfigsOrderBy>>;
  where?: Maybe<GitSyncConfigsBoolExp>;
};


export type SubscriptionGitSyncConfigsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionLookerCredentialsArgs = {
  distinct_on?: Maybe<Array<LookerCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LookerCredentialsOrderBy>>;
  where?: Maybe<LookerCredentialsBoolExp>;
};


export type SubscriptionLookerCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionMembershipRequestsArgs = {
  distinct_on?: Maybe<Array<MembershipRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipRequestsOrderBy>>;
  where?: Maybe<MembershipRequestsBoolExp>;
};


export type SubscriptionMembershipRequestsByPkArgs = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionMembershipsArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


export type SubscriptionMembershipsAggregateArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


export type SubscriptionMembershipsByPkArgs = {
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionModelColumnsArgs = {
  distinct_on?: Maybe<Array<ModelColumnsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ModelColumnsOrderBy>>;
  where?: Maybe<ModelColumnsBoolExp>;
};


export type SubscriptionModelColumnsByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};


export type SubscriptionModelRelationshipsArgs = {
  distinct_on?: Maybe<Array<ModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ModelRelationshipsOrderBy>>;
  where?: Maybe<ModelRelationshipsBoolExp>;
};


export type SubscriptionModelRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionObjectDefinitionGroupsArgs = {
  distinct_on?: Maybe<Array<ObjectDefinitionGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectDefinitionGroupsOrderBy>>;
  where?: Maybe<ObjectDefinitionGroupsBoolExp>;
};


export type SubscriptionObjectDefinitionGroupsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionObjectDefinitionsArgs = {
  distinct_on?: Maybe<Array<ObjectDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectDefinitionsOrderBy>>;
  where?: Maybe<ObjectDefinitionsBoolExp>;
};


export type SubscriptionObjectDefinitionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionObjectSchemasArgs = {
  distinct_on?: Maybe<Array<ObjectSchemasSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ObjectSchemasOrderBy>>;
  where?: Maybe<ObjectSchemasBoolExp>;
};


export type SubscriptionObjectSchemasByPkArgs = {
  key: Scalars['String'];
  object_definition_id: Scalars['bigint'];
};


export type SubscriptionOrganizationsArgs = {
  distinct_on?: Maybe<Array<OrganizationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<OrganizationsOrderBy>>;
  where?: Maybe<OrganizationsBoolExp>;
};


export type SubscriptionOrganizationsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionOutboundUserInvitesArgs = {
  distinct_on?: Maybe<Array<OutboundUserInvitesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<OutboundUserInvitesOrderBy>>;
  where?: Maybe<OutboundUserInvitesBoolExp>;
};


export type SubscriptionOutboundUserInvitesByPkArgs = {
  recipient_email: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionPagerdutyCredentialsArgs = {
  distinct_on?: Maybe<Array<PagerdutyCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PagerdutyCredentialsOrderBy>>;
  where?: Maybe<PagerdutyCredentialsBoolExp>;
};


export type SubscriptionPagerdutyCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionQueryRunsArgs = {
  distinct_on?: Maybe<Array<QueryRunsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueryRunsOrderBy>>;
  where?: Maybe<QueryRunsBoolExp>;
};


export type SubscriptionQueryRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRelationshipReferencesArgs = {
  distinct_on?: Maybe<Array<RelationshipReferencesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipReferencesOrderBy>>;
  where?: Maybe<RelationshipReferencesBoolExp>;
};


export type SubscriptionRelationshipReferencesByPkArgs = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type SubscriptionRelationshipsArgs = {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
};


export type SubscriptionRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionResourceTagValuesArgs = {
  distinct_on?: Maybe<Array<ResourceTagValuesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ResourceTagValuesOrderBy>>;
  where?: Maybe<ResourceTagValuesBoolExp>;
};


export type SubscriptionResourceViewsArgs = {
  distinct_on?: Maybe<Array<ResourceViewsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ResourceViewsOrderBy>>;
  where?: Maybe<ResourceViewsBoolExp>;
};


export type SubscriptionResourceViewsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRolesArgs = {
  distinct_on?: Maybe<Array<RolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RolesOrderBy>>;
  where?: Maybe<RolesBoolExp>;
};


export type SubscriptionRolesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSampleDataSourcesArgs = {
  distinct_on?: Maybe<Array<SampleDataSourcesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SampleDataSourcesOrderBy>>;
  where?: Maybe<SampleDataSourcesBoolExp>;
};


export type SubscriptionSampleDataSourcesByPkArgs = {
  uuid: Scalars['uuid'];
};


export type SubscriptionSavedQueriesArgs = {
  distinct_on?: Maybe<Array<SavedQueriesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SavedQueriesOrderBy>>;
  where?: Maybe<SavedQueriesBoolExp>;
};


export type SubscriptionSavedQueriesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSegmentsArgs = {
  distinct_on?: Maybe<Array<SegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SegmentsOrderBy>>;
  where?: Maybe<SegmentsBoolExp>;
};


export type SubscriptionSegmentsAggregateArgs = {
  distinct_on?: Maybe<Array<SegmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SegmentsOrderBy>>;
  where?: Maybe<SegmentsBoolExp>;
};


export type SubscriptionSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSlackCredentialsArgs = {
  distinct_on?: Maybe<Array<SlackCredentialsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SlackCredentialsOrderBy>>;
  where?: Maybe<SlackCredentialsBoolExp>;
};


export type SubscriptionSlackCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionSyncAlertsArgs = {
  distinct_on?: Maybe<Array<SyncAlertsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncAlertsOrderBy>>;
  where?: Maybe<SyncAlertsBoolExp>;
};


export type SubscriptionSyncAttemptsArgs = {
  distinct_on?: Maybe<Array<SyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncAttemptsOrderBy>>;
  where?: Maybe<SyncAttemptsBoolExp>;
};


export type SubscriptionSyncAttemptsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSyncRequestDiffsArgs = {
  distinct_on?: Maybe<Array<SyncRequestDiffsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestDiffsOrderBy>>;
  where?: Maybe<SyncRequestDiffsBoolExp>;
};


export type SubscriptionSyncRequestDiffsByPkArgs = {
  sync_request_id: Scalars['bigint'];
};


export type SubscriptionSyncRequestsArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


export type SubscriptionSyncRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


export type SubscriptionSyncRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSyncTemplatesArgs = {
  distinct_on?: Maybe<Array<SyncTemplatesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncTemplatesOrderBy>>;
  where?: Maybe<SyncTemplatesBoolExp>;
};


export type SubscriptionSyncTemplatesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionSyncsArgs = {
  distinct_on?: Maybe<Array<SyncsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncsOrderBy>>;
  where?: Maybe<SyncsBoolExp>;
};


export type SubscriptionSyncsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncsOrderBy>>;
  where?: Maybe<SyncsBoolExp>;
};


export type SubscriptionThroughModelRelationshipsArgs = {
  distinct_on?: Maybe<Array<ThroughModelRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ThroughModelRelationshipsOrderBy>>;
  where?: Maybe<ThroughModelRelationshipsBoolExp>;
};


export type SubscriptionThroughModelRelationshipsByPkArgs = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};


export type SubscriptionTraitDefinitionsArgs = {
  distinct_on?: Maybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TraitDefinitionsOrderBy>>;
  where?: Maybe<TraitDefinitionsBoolExp>;
};


export type SubscriptionTraitDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionTunnelsArgs = {
  distinct_on?: Maybe<Array<TunnelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TunnelsOrderBy>>;
  where?: Maybe<TunnelsBoolExp>;
};


export type SubscriptionTunnelsByPkArgs = {
  tunnel_id: Scalars['uuid'];
};


export type SubscriptionUsersArgs = {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
};


export type SubscriptionUsersByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionWorkspacesArgs = {
  distinct_on?: Maybe<Array<WorkspacesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WorkspacesOrderBy>>;
  where?: Maybe<WorkspacesBoolExp>;
};


export type SubscriptionWorkspacesByPkArgs = {
  id: Scalars['bigint'];
};

/** columns and relationships of "sync_alerts" */
export type SyncAlerts = {
  __typename?: 'sync_alerts';
  alert_interval: Maybe<Scalars['bigint']>;
  /** An object relationship */
  alert_status: Maybe<AlertStatuses>;
  config: Maybe<Scalars['jsonb']>;
  fatal_error: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['bigint']>;
  name: Maybe<Scalars['name']>;
  /** An object relationship */
  pagerduty_credential: Maybe<PagerdutyCredentials>;
  pagerduty_credential_id: Maybe<Scalars['bigint']>;
  row_error: Maybe<Scalars['Boolean']>;
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  /** An object relationship */
  slack_credential: Maybe<SlackCredentials>;
  slack_credential_id: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync: Maybe<Syncs>;
  sync_id: Maybe<Scalars['bigint']>;
  type: Maybe<Scalars['String']>;
  workspace_id: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sync_alerts" */
export type SyncAlertsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "sync_alerts" */
export type SyncAlertsAggregateOrderBy = {
  avg?: Maybe<SyncAlertsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<SyncAlertsMaxOrderBy>;
  min?: Maybe<SyncAlertsMinOrderBy>;
  stddev?: Maybe<SyncAlertsStddevOrderBy>;
  stddev_pop?: Maybe<SyncAlertsStddevPopOrderBy>;
  stddev_samp?: Maybe<SyncAlertsStddevSampOrderBy>;
  sum?: Maybe<SyncAlertsSumOrderBy>;
  var_pop?: Maybe<SyncAlertsVarPopOrderBy>;
  var_samp?: Maybe<SyncAlertsVarSampOrderBy>;
  variance?: Maybe<SyncAlertsVarianceOrderBy>;
};

/** order by avg() on columns of table "sync_alerts" */
export type SyncAlertsAvgOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_alerts". All fields are combined with a logical 'AND'. */
export type SyncAlertsBoolExp = {
  _and?: Maybe<Array<SyncAlertsBoolExp>>;
  _not?: Maybe<SyncAlertsBoolExp>;
  _or?: Maybe<Array<SyncAlertsBoolExp>>;
  alert_interval?: Maybe<BigintComparisonExp>;
  alert_status?: Maybe<AlertStatusesBoolExp>;
  config?: Maybe<JsonbComparisonExp>;
  fatal_error?: Maybe<BooleanComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  name?: Maybe<NameComparisonExp>;
  pagerduty_credential?: Maybe<PagerdutyCredentialsBoolExp>;
  pagerduty_credential_id?: Maybe<BigintComparisonExp>;
  row_error?: Maybe<BooleanComparisonExp>;
  row_threshold_attempted?: Maybe<BigintComparisonExp>;
  row_threshold_total?: Maybe<BigintComparisonExp>;
  slack_credential?: Maybe<SlackCredentialsBoolExp>;
  slack_credential_id?: Maybe<BigintComparisonExp>;
  sync?: Maybe<SyncsBoolExp>;
  sync_id?: Maybe<BigintComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** order by max() on columns of table "sync_alerts" */
export type SyncAlertsMaxOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "sync_alerts" */
export type SyncAlertsMinOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "sync_alerts". */
export type SyncAlertsOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  alert_status?: Maybe<AlertStatusesOrderBy>;
  config?: Maybe<OrderBy>;
  fatal_error?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  pagerduty_credential?: Maybe<PagerdutyCredentialsOrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_error?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential?: Maybe<SlackCredentialsOrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync?: Maybe<SyncsOrderBy>;
  sync_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "sync_alerts" */
export const SyncAlertsSelectColumn = {
  /** column name */
  AlertInterval: 'alert_interval',
  /** column name */
  Config: 'config',
  /** column name */
  FatalError: 'fatal_error',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PagerdutyCredentialId: 'pagerduty_credential_id',
  /** column name */
  RowError: 'row_error',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  SlackCredentialId: 'slack_credential_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncAlertsSelectColumn = typeof SyncAlertsSelectColumn[keyof typeof SyncAlertsSelectColumn];
/** order by stddev() on columns of table "sync_alerts" */
export type SyncAlertsStddevOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sync_alerts" */
export type SyncAlertsStddevPopOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sync_alerts" */
export type SyncAlertsStddevSampOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "sync_alerts" */
export type SyncAlertsSumOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "sync_alerts" */
export type SyncAlertsVarPopOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "sync_alerts" */
export type SyncAlertsVarSampOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "sync_alerts" */
export type SyncAlertsVarianceOrderBy = {
  alert_interval?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pagerduty_credential_id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  slack_credential_id?: Maybe<OrderBy>;
  sync_id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "sync_attempts" */
export type SyncAttempts = {
  __typename?: 'sync_attempts';
  add_checkpoint: Scalars['Int'];
  add_rejected: Maybe<Scalars['Int']>;
  change_checkpoint: Scalars['Int'];
  change_rejected: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  details: Maybe<Scalars['jsonb']>;
  error: Maybe<Scalars['String']>;
  finished_at: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  remove_checkpoint: Scalars['Int'];
  remove_rejected: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  /** A computed field, executes function "successful_operations_count" */
  successful_operations_count: Maybe<Scalars['Int']>;
  /** An object relationship */
  sync_request: SyncRequests;
  sync_request_id: Scalars['bigint'];
};


/** columns and relationships of "sync_attempts" */
export type SyncAttemptsDetailsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "sync_attempts" */
export type SyncAttemptsAggregateOrderBy = {
  avg?: Maybe<SyncAttemptsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<SyncAttemptsMaxOrderBy>;
  min?: Maybe<SyncAttemptsMinOrderBy>;
  stddev?: Maybe<SyncAttemptsStddevOrderBy>;
  stddev_pop?: Maybe<SyncAttemptsStddevPopOrderBy>;
  stddev_samp?: Maybe<SyncAttemptsStddevSampOrderBy>;
  sum?: Maybe<SyncAttemptsSumOrderBy>;
  var_pop?: Maybe<SyncAttemptsVarPopOrderBy>;
  var_samp?: Maybe<SyncAttemptsVarSampOrderBy>;
  variance?: Maybe<SyncAttemptsVarianceOrderBy>;
};

/** order by avg() on columns of table "sync_attempts" */
export type SyncAttemptsAvgOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_attempts". All fields are combined with a logical 'AND'. */
export type SyncAttemptsBoolExp = {
  _and?: Maybe<Array<SyncAttemptsBoolExp>>;
  _not?: Maybe<SyncAttemptsBoolExp>;
  _or?: Maybe<Array<SyncAttemptsBoolExp>>;
  add_checkpoint?: Maybe<IntComparisonExp>;
  add_rejected?: Maybe<IntComparisonExp>;
  change_checkpoint?: Maybe<IntComparisonExp>;
  change_rejected?: Maybe<IntComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  details?: Maybe<JsonbComparisonExp>;
  error?: Maybe<StringComparisonExp>;
  finished_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  remove_checkpoint?: Maybe<IntComparisonExp>;
  remove_rejected?: Maybe<IntComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  successful_operations_count?: Maybe<IntComparisonExp>;
  sync_request?: Maybe<SyncRequestsBoolExp>;
  sync_request_id?: Maybe<BigintComparisonExp>;
};

/** order by max() on columns of table "sync_attempts" */
export type SyncAttemptsMaxOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  finished_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "sync_attempts" */
export type SyncAttemptsMinOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  finished_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "sync_attempts". */
export type SyncAttemptsOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  details?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  finished_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  successful_operations_count?: Maybe<OrderBy>;
  sync_request?: Maybe<SyncRequestsOrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** select columns of table "sync_attempts" */
export const SyncAttemptsSelectColumn = {
  /** column name */
  AddCheckpoint: 'add_checkpoint',
  /** column name */
  AddRejected: 'add_rejected',
  /** column name */
  ChangeCheckpoint: 'change_checkpoint',
  /** column name */
  ChangeRejected: 'change_rejected',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Details: 'details',
  /** column name */
  Error: 'error',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  RemoveCheckpoint: 'remove_checkpoint',
  /** column name */
  RemoveRejected: 'remove_rejected',
  /** column name */
  Status: 'status',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncAttemptsSelectColumn = typeof SyncAttemptsSelectColumn[keyof typeof SyncAttemptsSelectColumn];
/** order by stddev() on columns of table "sync_attempts" */
export type SyncAttemptsStddevOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sync_attempts" */
export type SyncAttemptsStddevPopOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sync_attempts" */
export type SyncAttemptsStddevSampOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "sync_attempts" */
export type SyncAttemptsSumOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "sync_attempts" */
export type SyncAttemptsVarPopOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "sync_attempts" */
export type SyncAttemptsVarSampOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "sync_attempts" */
export type SyncAttemptsVarianceOrderBy = {
  add_checkpoint?: Maybe<OrderBy>;
  add_rejected?: Maybe<OrderBy>;
  change_checkpoint?: Maybe<OrderBy>;
  change_rejected?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  remove_checkpoint?: Maybe<OrderBy>;
  remove_rejected?: Maybe<OrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** columns and relationships of "sync_request_diffs" */
export type SyncRequestDiffs = {
  __typename?: 'sync_request_diffs';
  added_count: Scalars['Int'];
  changed_count: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  removed_count: Scalars['Int'];
  /** An object relationship */
  sync_request: SyncRequests;
  sync_request_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "sync_request_diffs". All fields are combined with a logical 'AND'. */
export type SyncRequestDiffsBoolExp = {
  _and?: Maybe<Array<SyncRequestDiffsBoolExp>>;
  _not?: Maybe<SyncRequestDiffsBoolExp>;
  _or?: Maybe<Array<SyncRequestDiffsBoolExp>>;
  added_count?: Maybe<IntComparisonExp>;
  changed_count?: Maybe<IntComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  removed_count?: Maybe<IntComparisonExp>;
  sync_request?: Maybe<SyncRequestsBoolExp>;
  sync_request_id?: Maybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "sync_request_diffs". */
export type SyncRequestDiffsOrderBy = {
  added_count?: Maybe<OrderBy>;
  changed_count?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  removed_count?: Maybe<OrderBy>;
  sync_request?: Maybe<SyncRequestsOrderBy>;
  sync_request_id?: Maybe<OrderBy>;
};

/** select columns of table "sync_request_diffs" */
export const SyncRequestDiffsSelectColumn = {
  /** column name */
  AddedCount: 'added_count',
  /** column name */
  ChangedCount: 'changed_count',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  RemovedCount: 'removed_count',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncRequestDiffsSelectColumn = typeof SyncRequestDiffsSelectColumn[keyof typeof SyncRequestDiffsSelectColumn];
/** columns and relationships of "sync_requests" */
export type SyncRequests = {
  __typename?: 'sync_requests';
  /** A computed field, executes function "add_executed" */
  add_executed: Maybe<Scalars['Int']>;
  archive_query_results: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "change_executed" */
  change_executed: Maybe<Scalars['Int']>;
  /** A computed field, executes function "sync_request_completion_ratio" */
  completion_ratio: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination_instance: DestinationInstances;
  destination_instance_id: Scalars['bigint'];
  error: Maybe<Scalars['jsonb']>;
  external_segment_id: Maybe<Scalars['bigint']>;
  finished_at: Maybe<Scalars['timestamptz']>;
  full_resync: Maybe<Scalars['Boolean']>;
  id: Scalars['bigint'];
  phase_to_status: Maybe<Scalars['jsonb']>;
  planner_type: Maybe<Scalars['String']>;
  previous_query_run_id: Maybe<Scalars['bigint']>;
  /** An object relationship */
  previous_sync_request: Maybe<SyncRequests>;
  /** An object relationship */
  query_run: Maybe<QueryRuns>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "remove_executed" */
  remove_executed: Maybe<Scalars['Int']>;
  resync_reason: Maybe<Scalars['String']>;
  started_at: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  /** A computed field, executes function "sync_request_status" */
  status_computed: Maybe<Scalars['String']>;
  /** An object relationship */
  sync: Maybe<Syncs>;
  /** An array relationship */
  sync_attempts: Array<SyncAttempts>;
  sync_config: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  sync_request_diff: Maybe<SyncRequestDiffs>;
  trigger_cancel: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsErrorArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsPhaseToStatusArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsSyncAttemptsArgs = {
  distinct_on?: Maybe<Array<SyncAttemptsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncAttemptsOrderBy>>;
  where?: Maybe<SyncAttemptsBoolExp>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsSyncConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "sync_requests" */
export type SyncRequestsAggregate = {
  __typename?: 'sync_requests_aggregate';
  aggregate: Maybe<SyncRequestsAggregateFields>;
  nodes: Array<SyncRequests>;
};

/** aggregate fields of "sync_requests" */
export type SyncRequestsAggregateFields = {
  __typename?: 'sync_requests_aggregate_fields';
  avg: Maybe<SyncRequestsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<SyncRequestsMaxFields>;
  min: Maybe<SyncRequestsMinFields>;
  stddev: Maybe<SyncRequestsStddevFields>;
  stddev_pop: Maybe<SyncRequestsStddevPopFields>;
  stddev_samp: Maybe<SyncRequestsStddevSampFields>;
  sum: Maybe<SyncRequestsSumFields>;
  var_pop: Maybe<SyncRequestsVarPopFields>;
  var_samp: Maybe<SyncRequestsVarSampFields>;
  variance: Maybe<SyncRequestsVarianceFields>;
};


/** aggregate fields of "sync_requests" */
export type SyncRequestsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<SyncRequestsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sync_requests" */
export type SyncRequestsAggregateOrderBy = {
  avg?: Maybe<SyncRequestsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<SyncRequestsMaxOrderBy>;
  min?: Maybe<SyncRequestsMinOrderBy>;
  stddev?: Maybe<SyncRequestsStddevOrderBy>;
  stddev_pop?: Maybe<SyncRequestsStddevPopOrderBy>;
  stddev_samp?: Maybe<SyncRequestsStddevSampOrderBy>;
  sum?: Maybe<SyncRequestsSumOrderBy>;
  var_pop?: Maybe<SyncRequestsVarPopOrderBy>;
  var_samp?: Maybe<SyncRequestsVarSampOrderBy>;
  variance?: Maybe<SyncRequestsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type SyncRequestsAvgFields = {
  __typename?: 'sync_requests_avg_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sync_requests" */
export type SyncRequestsAvgOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_requests". All fields are combined with a logical 'AND'. */
export type SyncRequestsBoolExp = {
  _and?: Maybe<Array<SyncRequestsBoolExp>>;
  _not?: Maybe<SyncRequestsBoolExp>;
  _or?: Maybe<Array<SyncRequestsBoolExp>>;
  add_executed?: Maybe<IntComparisonExp>;
  archive_query_results?: Maybe<BooleanComparisonExp>;
  change_executed?: Maybe<IntComparisonExp>;
  completion_ratio?: Maybe<NumericComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  destination_instance?: Maybe<DestinationInstancesBoolExp>;
  destination_instance_id?: Maybe<BigintComparisonExp>;
  error?: Maybe<JsonbComparisonExp>;
  external_segment_id?: Maybe<BigintComparisonExp>;
  finished_at?: Maybe<TimestamptzComparisonExp>;
  full_resync?: Maybe<BooleanComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  phase_to_status?: Maybe<JsonbComparisonExp>;
  planner_type?: Maybe<StringComparisonExp>;
  previous_query_run_id?: Maybe<BigintComparisonExp>;
  previous_sync_request?: Maybe<SyncRequestsBoolExp>;
  query_run?: Maybe<QueryRunsBoolExp>;
  query_run_id?: Maybe<BigintComparisonExp>;
  remove_executed?: Maybe<IntComparisonExp>;
  resync_reason?: Maybe<StringComparisonExp>;
  started_at?: Maybe<TimestamptzComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  status_computed?: Maybe<StringComparisonExp>;
  sync?: Maybe<SyncsBoolExp>;
  sync_attempts?: Maybe<SyncAttemptsBoolExp>;
  sync_config?: Maybe<JsonbComparisonExp>;
  sync_request_diff?: Maybe<SyncRequestDiffsBoolExp>;
  trigger_cancel?: Maybe<BooleanComparisonExp>;
};

/** aggregate max on columns */
export type SyncRequestsMaxFields = {
  __typename?: 'sync_requests_max_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  destination_instance_id: Maybe<Scalars['bigint']>;
  external_segment_id: Maybe<Scalars['bigint']>;
  finished_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['bigint']>;
  planner_type: Maybe<Scalars['String']>;
  previous_query_run_id: Maybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['bigint']>;
  resync_reason: Maybe<Scalars['String']>;
  started_at: Maybe<Scalars['timestamptz']>;
  status: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sync_requests" */
export type SyncRequestsMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  finished_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  planner_type?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
  resync_reason?: Maybe<OrderBy>;
  started_at?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncRequestsMinFields = {
  __typename?: 'sync_requests_min_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  destination_instance_id: Maybe<Scalars['bigint']>;
  external_segment_id: Maybe<Scalars['bigint']>;
  finished_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['bigint']>;
  planner_type: Maybe<Scalars['String']>;
  previous_query_run_id: Maybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['bigint']>;
  resync_reason: Maybe<Scalars['String']>;
  started_at: Maybe<Scalars['timestamptz']>;
  status: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sync_requests" */
export type SyncRequestsMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  finished_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  planner_type?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
  resync_reason?: Maybe<OrderBy>;
  started_at?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** response of any mutation on the table "sync_requests" */
export type SyncRequestsMutationResponse = {
  __typename?: 'sync_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncRequests>;
};

/** Ordering options when selecting data from "sync_requests". */
export type SyncRequestsOrderBy = {
  add_executed?: Maybe<OrderBy>;
  archive_query_results?: Maybe<OrderBy>;
  change_executed?: Maybe<OrderBy>;
  completion_ratio?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  destination_instance?: Maybe<DestinationInstancesOrderBy>;
  destination_instance_id?: Maybe<OrderBy>;
  error?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  finished_at?: Maybe<OrderBy>;
  full_resync?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  phase_to_status?: Maybe<OrderBy>;
  planner_type?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  previous_sync_request?: Maybe<SyncRequestsOrderBy>;
  query_run?: Maybe<QueryRunsOrderBy>;
  query_run_id?: Maybe<OrderBy>;
  remove_executed?: Maybe<OrderBy>;
  resync_reason?: Maybe<OrderBy>;
  started_at?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  status_computed?: Maybe<OrderBy>;
  sync?: Maybe<SyncsOrderBy>;
  sync_attempts_aggregate?: Maybe<SyncAttemptsAggregateOrderBy>;
  sync_config?: Maybe<OrderBy>;
  sync_request_diff?: Maybe<SyncRequestDiffsOrderBy>;
  trigger_cancel?: Maybe<OrderBy>;
};

/** primary key columns input for table: sync_requests */
export type SyncRequestsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "sync_requests" */
export const SyncRequestsSelectColumn = {
  /** column name */
  ArchiveQueryResults: 'archive_query_results',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  Error: 'error',
  /** column name */
  ExternalSegmentId: 'external_segment_id',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  Id: 'id',
  /** column name */
  PhaseToStatus: 'phase_to_status',
  /** column name */
  PlannerType: 'planner_type',
  /** column name */
  PreviousQueryRunId: 'previous_query_run_id',
  /** column name */
  QueryRunId: 'query_run_id',
  /** column name */
  ResyncReason: 'resync_reason',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  SyncConfig: 'sync_config',
  /** column name */
  TriggerCancel: 'trigger_cancel'
} as const;

export type SyncRequestsSelectColumn = typeof SyncRequestsSelectColumn[keyof typeof SyncRequestsSelectColumn];
/** input type for updating data in table "sync_requests" */
export type SyncRequestsSetInput = {
  trigger_cancel?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type SyncRequestsStddevFields = {
  __typename?: 'sync_requests_stddev_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sync_requests" */
export type SyncRequestsStddevOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncRequestsStddevPopFields = {
  __typename?: 'sync_requests_stddev_pop_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sync_requests" */
export type SyncRequestsStddevPopOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncRequestsStddevSampFields = {
  __typename?: 'sync_requests_stddev_samp_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sync_requests" */
export type SyncRequestsStddevSampOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type SyncRequestsSumFields = {
  __typename?: 'sync_requests_sum_fields';
  destination_instance_id: Maybe<Scalars['bigint']>;
  external_segment_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  previous_query_run_id: Maybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_requests" */
export type SyncRequestsSumOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type SyncRequestsVarPopFields = {
  __typename?: 'sync_requests_var_pop_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sync_requests" */
export type SyncRequestsVarPopOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncRequestsVarSampFields = {
  __typename?: 'sync_requests_var_samp_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sync_requests" */
export type SyncRequestsVarSampOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncRequestsVarianceFields = {
  __typename?: 'sync_requests_variance_fields';
  destination_instance_id: Maybe<Scalars['Float']>;
  external_segment_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  previous_query_run_id: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sync_requests" */
export type SyncRequestsVarianceOrderBy = {
  destination_instance_id?: Maybe<OrderBy>;
  external_segment_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  previous_query_run_id?: Maybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<OrderBy>;
};

/** columns and relationships of "sync_templates" */
export type SyncTemplates = {
  __typename?: 'sync_templates';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Maybe<Scalars['Int']>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['Int'];
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  id: Scalars['Int'];
  name: Scalars['String'];
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  schedule: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['Int'];
  slug: Scalars['String'];
  tags: Scalars['jsonb'];
  transformed_config: Scalars['JSONObject'];
  updated_at: Scalars['timestamptz'];
  updated_by: Maybe<Scalars['Int']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesAlertInstancesArgs = {
  distinct_on?: Maybe<Array<AlertInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AlertInstancesOrderBy>>;
  where?: Maybe<AlertInstancesBoolExp>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesDestinationInstancesArgs = {
  distinct_on?: Maybe<Array<DestinationInstancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DestinationInstancesOrderBy>>;
  where?: Maybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesScheduleArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesTagsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SyncTemplatesAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
  schedule?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "sync_templates". All fields are combined with a logical 'AND'. */
export type SyncTemplatesBoolExp = {
  _and?: Maybe<Array<SyncTemplatesBoolExp>>;
  _not?: Maybe<SyncTemplatesBoolExp>;
  _or?: Maybe<Array<SyncTemplatesBoolExp>>;
  alert_instances?: Maybe<AlertInstancesBoolExp>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<IntComparisonExp>;
  destination?: Maybe<DestinationsBoolExp>;
  destination_id?: Maybe<IntComparisonExp>;
  destination_instances?: Maybe<DestinationInstancesBoolExp>;
  id?: Maybe<IntComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  row_threshold_attempted?: Maybe<BigintComparisonExp>;
  row_threshold_total?: Maybe<BigintComparisonExp>;
  schedule?: Maybe<JsonbComparisonExp>;
  schedule_paused?: Maybe<BooleanComparisonExp>;
  segment?: Maybe<SegmentsBoolExp>;
  segment_id?: Maybe<IntComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  tags?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<IntComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "sync_templates" */
export const SyncTemplatesConstraint = {
  /** unique or primary key constraint */
  SyncTemplatesPkey: 'sync_templates_pkey'
} as const;

export type SyncTemplatesConstraint = typeof SyncTemplatesConstraint[keyof typeof SyncTemplatesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SyncTemplatesDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
  schedule?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SyncTemplatesDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SyncTemplatesDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sync_templates" */
export type SyncTemplatesIncInput = {
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sync_templates" */
export type SyncTemplatesInsertInput = {
  alert_instances?: Maybe<AlertInstancesArrRelInsertInput>;
  config?: Maybe<Scalars['jsonb']>;
  destination?: Maybe<DestinationsObjRelInsertInput>;
  destination_id?: Maybe<Scalars['Int']>;
  destination_instances?: Maybe<DestinationInstancesArrRelInsertInput>;
  name?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  segment?: Maybe<SegmentsObjRelInsertInput>;
  segment_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "sync_templates" */
export type SyncTemplatesMutationResponse = {
  __typename?: 'sync_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncTemplates>;
};

/** input type for inserting object relation for remote table "sync_templates" */
export type SyncTemplatesObjRelInsertInput = {
  data: SyncTemplatesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SyncTemplatesOnConflict>;
};

/** on conflict condition type for table "sync_templates" */
export type SyncTemplatesOnConflict = {
  constraint: SyncTemplatesConstraint;
  update_columns?: Array<SyncTemplatesUpdateColumn>;
  where?: Maybe<SyncTemplatesBoolExp>;
};

/** Ordering options when selecting data from "sync_templates". */
export type SyncTemplatesOrderBy = {
  alert_instances_aggregate?: Maybe<AlertInstancesAggregateOrderBy>;
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  destination?: Maybe<DestinationsOrderBy>;
  destination_id?: Maybe<OrderBy>;
  destination_instances_aggregate?: Maybe<DestinationInstancesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  schedule?: Maybe<OrderBy>;
  schedule_paused?: Maybe<OrderBy>;
  segment?: Maybe<SegmentsOrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  tags?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: sync_templates */
export type SyncTemplatesPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SyncTemplatesPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
  schedule?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "sync_templates" */
export const SyncTemplatesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncTemplatesSelectColumn = typeof SyncTemplatesSelectColumn[keyof typeof SyncTemplatesSelectColumn];
/** input type for updating data in table "sync_templates" */
export type SyncTemplatesSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "sync_templates" */
export const SyncTemplatesUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Name: 'name',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Tags: 'tags'
} as const;

export type SyncTemplatesUpdateColumn = typeof SyncTemplatesUpdateColumn[keyof typeof SyncTemplatesUpdateColumn];
/** columns and relationships of "syncs" */
export type Syncs = {
  __typename?: 'syncs';
  canary: Maybe<Scalars['Boolean']>;
  config: Maybe<Scalars['jsonb']>;
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  /** An object relationship */
  destination: Maybe<Destinations>;
  destination_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  last_run_at: Maybe<Scalars['timestamptz']>;
  monitoring: Maybe<Scalars['jsonb']>;
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  schedule: Maybe<Scalars['jsonb']>;
  schedule_paused: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  segment: Maybe<Segments>;
  segment_id: Maybe<Scalars['bigint']>;
  slug: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  sync_template_id: Maybe<Scalars['Int']>;
  tags: Maybe<Scalars['jsonb']>;
  transformed_config: Scalars['JSONObject'];
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  warehouse_history_config: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  workspace: Maybe<Workspaces>;
  workspace_id: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "syncs" */
export type SyncsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsMonitoringArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsScheduleArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncAlertsArgs = {
  distinct_on?: Maybe<Array<SyncAlertsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncAlertsOrderBy>>;
  where?: Maybe<SyncAlertsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncRequestsArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<SyncRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SyncRequestsOrderBy>>;
  where?: Maybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsTagsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsWarehouseHistoryConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "syncs" */
export type SyncsAggregate = {
  __typename?: 'syncs_aggregate';
  aggregate: Maybe<SyncsAggregateFields>;
  nodes: Array<Syncs>;
};

/** aggregate fields of "syncs" */
export type SyncsAggregateFields = {
  __typename?: 'syncs_aggregate_fields';
  avg: Maybe<SyncsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<SyncsMaxFields>;
  min: Maybe<SyncsMinFields>;
  stddev: Maybe<SyncsStddevFields>;
  stddev_pop: Maybe<SyncsStddevPopFields>;
  stddev_samp: Maybe<SyncsStddevSampFields>;
  sum: Maybe<SyncsSumFields>;
  var_pop: Maybe<SyncsVarPopFields>;
  var_samp: Maybe<SyncsVarSampFields>;
  variance: Maybe<SyncsVarianceFields>;
};


/** aggregate fields of "syncs" */
export type SyncsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<SyncsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "syncs" */
export type SyncsAggregateOrderBy = {
  avg?: Maybe<SyncsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<SyncsMaxOrderBy>;
  min?: Maybe<SyncsMinOrderBy>;
  stddev?: Maybe<SyncsStddevOrderBy>;
  stddev_pop?: Maybe<SyncsStddevPopOrderBy>;
  stddev_samp?: Maybe<SyncsStddevSampOrderBy>;
  sum?: Maybe<SyncsSumOrderBy>;
  var_pop?: Maybe<SyncsVarPopOrderBy>;
  var_samp?: Maybe<SyncsVarSampOrderBy>;
  variance?: Maybe<SyncsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type SyncsAvgFields = {
  __typename?: 'syncs_avg_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "syncs" */
export type SyncsAvgOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "syncs". All fields are combined with a logical 'AND'. */
export type SyncsBoolExp = {
  _and?: Maybe<Array<SyncsBoolExp>>;
  _not?: Maybe<SyncsBoolExp>;
  _or?: Maybe<Array<SyncsBoolExp>>;
  canary?: Maybe<BooleanComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  created_by_user?: Maybe<UsersBoolExp>;
  destination?: Maybe<DestinationsBoolExp>;
  destination_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  last_run_at?: Maybe<TimestamptzComparisonExp>;
  monitoring?: Maybe<JsonbComparisonExp>;
  row_threshold_attempted?: Maybe<BigintComparisonExp>;
  row_threshold_total?: Maybe<BigintComparisonExp>;
  schedule?: Maybe<JsonbComparisonExp>;
  schedule_paused?: Maybe<BooleanComparisonExp>;
  segment?: Maybe<SegmentsBoolExp>;
  segment_id?: Maybe<BigintComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  sync_alerts?: Maybe<SyncAlertsBoolExp>;
  sync_requests?: Maybe<SyncRequestsBoolExp>;
  sync_template_id?: Maybe<IntComparisonExp>;
  tags?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  updated_by_user?: Maybe<UsersBoolExp>;
  warehouse_history_config?: Maybe<JsonbComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type SyncsMaxFields = {
  __typename?: 'syncs_max_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  destination_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  last_run_at: Maybe<Scalars['timestamptz']>;
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  segment_id: Maybe<Scalars['bigint']>;
  slug: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  sync_template_id: Maybe<Scalars['Int']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "syncs" */
export type SyncsMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncsMinFields = {
  __typename?: 'syncs_min_fields';
  created_at: Maybe<Scalars['timestamptz']>;
  created_by: Maybe<Scalars['bigint']>;
  destination_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  last_run_at: Maybe<Scalars['timestamptz']>;
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  segment_id: Maybe<Scalars['bigint']>;
  slug: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  sync_template_id: Maybe<Scalars['Int']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "syncs" */
export type SyncsMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "syncs". */
export type SyncsOrderBy = {
  canary?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  created_by_user?: Maybe<UsersOrderBy>;
  destination?: Maybe<DestinationsOrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_run_at?: Maybe<OrderBy>;
  monitoring?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  schedule?: Maybe<OrderBy>;
  schedule_paused?: Maybe<OrderBy>;
  segment?: Maybe<SegmentsOrderBy>;
  segment_id?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  sync_alerts_aggregate?: Maybe<SyncAlertsAggregateOrderBy>;
  sync_requests_aggregate?: Maybe<SyncRequestsAggregateOrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  tags?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  updated_by_user?: Maybe<UsersOrderBy>;
  warehouse_history_config?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** select columns of table "syncs" */
export const SyncsSelectColumn = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  Status: 'status',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncsSelectColumn = typeof SyncsSelectColumn[keyof typeof SyncsSelectColumn];
/** aggregate stddev on columns */
export type SyncsStddevFields = {
  __typename?: 'syncs_stddev_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "syncs" */
export type SyncsStddevOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncsStddevPopFields = {
  __typename?: 'syncs_stddev_pop_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "syncs" */
export type SyncsStddevPopOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncsStddevSampFields = {
  __typename?: 'syncs_stddev_samp_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "syncs" */
export type SyncsStddevSampOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type SyncsSumFields = {
  __typename?: 'syncs_sum_fields';
  created_by: Maybe<Scalars['bigint']>;
  destination_id: Maybe<Scalars['bigint']>;
  id: Maybe<Scalars['bigint']>;
  row_threshold_attempted: Maybe<Scalars['bigint']>;
  row_threshold_total: Maybe<Scalars['bigint']>;
  segment_id: Maybe<Scalars['bigint']>;
  sync_template_id: Maybe<Scalars['Int']>;
  updated_by: Maybe<Scalars['bigint']>;
  workspace_id: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "syncs" */
export type SyncsSumOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type SyncsVarPopFields = {
  __typename?: 'syncs_var_pop_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "syncs" */
export type SyncsVarPopOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncsVarSampFields = {
  __typename?: 'syncs_var_samp_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "syncs" */
export type SyncsVarSampOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncsVarianceFields = {
  __typename?: 'syncs_variance_fields';
  created_by: Maybe<Scalars['Float']>;
  destination_id: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  row_threshold_attempted: Maybe<Scalars['Float']>;
  row_threshold_total: Maybe<Scalars['Float']>;
  segment_id: Maybe<Scalars['Float']>;
  sync_template_id: Maybe<Scalars['Float']>;
  updated_by: Maybe<Scalars['Float']>;
  workspace_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "syncs" */
export type SyncsVarianceOrderBy = {
  created_by?: Maybe<OrderBy>;
  destination_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  row_threshold_attempted?: Maybe<OrderBy>;
  row_threshold_total?: Maybe<OrderBy>;
  segment_id?: Maybe<OrderBy>;
  sync_template_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "through_model_relationships" */
export type ThroughModelRelationships = {
  __typename?: 'through_model_relationships';
  path_segment_id: Scalars['bigint'];
  /** An object relationship */
  relationship: ModelRelationships;
  relationship_id: Scalars['bigint'];
};

/** order by aggregate values of table "through_model_relationships" */
export type ThroughModelRelationshipsAggregateOrderBy = {
  avg?: Maybe<ThroughModelRelationshipsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ThroughModelRelationshipsMaxOrderBy>;
  min?: Maybe<ThroughModelRelationshipsMinOrderBy>;
  stddev?: Maybe<ThroughModelRelationshipsStddevOrderBy>;
  stddev_pop?: Maybe<ThroughModelRelationshipsStddevPopOrderBy>;
  stddev_samp?: Maybe<ThroughModelRelationshipsStddevSampOrderBy>;
  sum?: Maybe<ThroughModelRelationshipsSumOrderBy>;
  var_pop?: Maybe<ThroughModelRelationshipsVarPopOrderBy>;
  var_samp?: Maybe<ThroughModelRelationshipsVarSampOrderBy>;
  variance?: Maybe<ThroughModelRelationshipsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "through_model_relationships" */
export type ThroughModelRelationshipsArrRelInsertInput = {
  data: Array<ThroughModelRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<ThroughModelRelationshipsOnConflict>;
};

/** order by avg() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsAvgOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "through_model_relationships". All fields are combined with a logical 'AND'. */
export type ThroughModelRelationshipsBoolExp = {
  _and?: Maybe<Array<ThroughModelRelationshipsBoolExp>>;
  _not?: Maybe<ThroughModelRelationshipsBoolExp>;
  _or?: Maybe<Array<ThroughModelRelationshipsBoolExp>>;
  path_segment_id?: Maybe<BigintComparisonExp>;
  relationship?: Maybe<ModelRelationshipsBoolExp>;
  relationship_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "through_model_relationships" */
export const ThroughModelRelationshipsConstraint = {
  /** unique or primary key constraint */
  ThroughModelRelationshipsPkey: 'through_model_relationships_pkey'
} as const;

export type ThroughModelRelationshipsConstraint = typeof ThroughModelRelationshipsConstraint[keyof typeof ThroughModelRelationshipsConstraint];
/** input type for incrementing numeric columns in table "through_model_relationships" */
export type ThroughModelRelationshipsIncInput = {
  path_segment_id?: Maybe<Scalars['bigint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "through_model_relationships" */
export type ThroughModelRelationshipsInsertInput = {
  path_segment_id?: Maybe<Scalars['bigint']>;
  relationship?: Maybe<ModelRelationshipsObjRelInsertInput>;
  relationship_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsMaxOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsMinOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "through_model_relationships" */
export type ThroughModelRelationshipsMutationResponse = {
  __typename?: 'through_model_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ThroughModelRelationships>;
};

/** on conflict condition type for table "through_model_relationships" */
export type ThroughModelRelationshipsOnConflict = {
  constraint: ThroughModelRelationshipsConstraint;
  update_columns?: Array<ThroughModelRelationshipsUpdateColumn>;
  where?: Maybe<ThroughModelRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "through_model_relationships". */
export type ThroughModelRelationshipsOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship?: Maybe<ModelRelationshipsOrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: through_model_relationships */
export type ThroughModelRelationshipsPkColumnsInput = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};

/** select columns of table "through_model_relationships" */
export const ThroughModelRelationshipsSelectColumn = {
  /** column name */
  PathSegmentId: 'path_segment_id',
  /** column name */
  RelationshipId: 'relationship_id'
} as const;

export type ThroughModelRelationshipsSelectColumn = typeof ThroughModelRelationshipsSelectColumn[keyof typeof ThroughModelRelationshipsSelectColumn];
/** input type for updating data in table "through_model_relationships" */
export type ThroughModelRelationshipsSetInput = {
  path_segment_id?: Maybe<Scalars['bigint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsStddevOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsStddevPopOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsStddevSampOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsSumOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** update columns of table "through_model_relationships" */
export const ThroughModelRelationshipsUpdateColumn = {
  /** column name */
  PathSegmentId: 'path_segment_id',
  /** column name */
  RelationshipId: 'relationship_id'
} as const;

export type ThroughModelRelationshipsUpdateColumn = typeof ThroughModelRelationshipsUpdateColumn[keyof typeof ThroughModelRelationshipsUpdateColumn];
/** order by var_pop() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsVarPopOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsVarSampOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsVarianceOrderBy = {
  path_segment_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/**
 * Used for Audiences
 *
 *
 * columns and relationships of "trait_definitions"
 */
export type TraitDefinitions = {
  __typename?: 'trait_definitions';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  parent_model_id: Scalars['bigint'];
  /** An object relationship */
  relationship: ModelRelationships;
  relationship_id: Scalars['bigint'];
  /** An object relationship */
  segment: Segments;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/**
 * Used for Audiences
 *
 *
 * columns and relationships of "trait_definitions"
 */
export type TraitDefinitionsConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "trait_definitions" */
export type TraitDefinitionsAggregateOrderBy = {
  avg?: Maybe<TraitDefinitionsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<TraitDefinitionsMaxOrderBy>;
  min?: Maybe<TraitDefinitionsMinOrderBy>;
  stddev?: Maybe<TraitDefinitionsStddevOrderBy>;
  stddev_pop?: Maybe<TraitDefinitionsStddevPopOrderBy>;
  stddev_samp?: Maybe<TraitDefinitionsStddevSampOrderBy>;
  sum?: Maybe<TraitDefinitionsSumOrderBy>;
  var_pop?: Maybe<TraitDefinitionsVarPopOrderBy>;
  var_samp?: Maybe<TraitDefinitionsVarSampOrderBy>;
  variance?: Maybe<TraitDefinitionsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TraitDefinitionsAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "trait_definitions" */
export type TraitDefinitionsArrRelInsertInput = {
  data: Array<TraitDefinitionsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TraitDefinitionsOnConflict>;
};

/** order by avg() on columns of table "trait_definitions" */
export type TraitDefinitionsAvgOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trait_definitions". All fields are combined with a logical 'AND'. */
export type TraitDefinitionsBoolExp = {
  _and?: Maybe<Array<TraitDefinitionsBoolExp>>;
  _not?: Maybe<TraitDefinitionsBoolExp>;
  _or?: Maybe<Array<TraitDefinitionsBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<BigintComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  parent_model_id?: Maybe<BigintComparisonExp>;
  relationship?: Maybe<ModelRelationshipsBoolExp>;
  relationship_id?: Maybe<BigintComparisonExp>;
  segment?: Maybe<SegmentsBoolExp>;
  type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<BigintComparisonExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "trait_definitions" */
export const TraitDefinitionsConstraint = {
  /** unique or primary key constraint */
  TraitDefinitionsPkey: 'trait_definitions_pkey'
} as const;

export type TraitDefinitionsConstraint = typeof TraitDefinitionsConstraint[keyof typeof TraitDefinitionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TraitDefinitionsDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TraitDefinitionsDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TraitDefinitionsDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "trait_definitions" */
export type TraitDefinitionsIncInput = {
  relationship_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trait_definitions" */
export type TraitDefinitionsInsertInput = {
  config?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  relationship?: Maybe<ModelRelationshipsObjRelInsertInput>;
  relationship_id?: Maybe<Scalars['bigint']>;
  segment?: Maybe<SegmentsObjRelInsertInput>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trait_definitions" */
export type TraitDefinitionsMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "trait_definitions" */
export type TraitDefinitionsMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "trait_definitions" */
export type TraitDefinitionsMutationResponse = {
  __typename?: 'trait_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TraitDefinitions>;
};

/** on conflict condition type for table "trait_definitions" */
export type TraitDefinitionsOnConflict = {
  constraint: TraitDefinitionsConstraint;
  update_columns?: Array<TraitDefinitionsUpdateColumn>;
  where?: Maybe<TraitDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "trait_definitions". */
export type TraitDefinitionsOrderBy = {
  config?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship?: Maybe<ModelRelationshipsOrderBy>;
  relationship_id?: Maybe<OrderBy>;
  segment?: Maybe<SegmentsOrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: trait_definitions */
export type TraitDefinitionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TraitDefinitionsPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "trait_definitions" */
export const TraitDefinitionsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TraitDefinitionsSelectColumn = typeof TraitDefinitionsSelectColumn[keyof typeof TraitDefinitionsSelectColumn];
/** input type for updating data in table "trait_definitions" */
export type TraitDefinitionsSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "trait_definitions" */
export type TraitDefinitionsStddevOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "trait_definitions" */
export type TraitDefinitionsStddevPopOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "trait_definitions" */
export type TraitDefinitionsStddevSampOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "trait_definitions" */
export type TraitDefinitionsSumOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** update columns of table "trait_definitions" */
export const TraitDefinitionsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Name: 'name',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  Type: 'type'
} as const;

export type TraitDefinitionsUpdateColumn = typeof TraitDefinitionsUpdateColumn[keyof typeof TraitDefinitionsUpdateColumn];
/** order by var_pop() on columns of table "trait_definitions" */
export type TraitDefinitionsVarPopOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "trait_definitions" */
export type TraitDefinitionsVarSampOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "trait_definitions" */
export type TraitDefinitionsVarianceOrderBy = {
  created_by?: Maybe<OrderBy>;
  parent_model_id?: Maybe<OrderBy>;
  relationship_id?: Maybe<OrderBy>;
  updated_by?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** columns and relationships of "tunnels" */
export type Tunnels = {
  __typename?: 'tunnels';
  created_at: Scalars['timestamptz'];
  name: Scalars['String'];
  tunnel_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "tunnels". All fields are combined with a logical 'AND'. */
export type TunnelsBoolExp = {
  _and?: Maybe<Array<TunnelsBoolExp>>;
  _not?: Maybe<TunnelsBoolExp>;
  _or?: Maybe<Array<TunnelsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  tunnel_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "tunnels" */
export const TunnelsConstraint = {
  /** unique or primary key constraint */
  TunnelsPkey: 'tunnels_pkey'
} as const;

export type TunnelsConstraint = typeof TunnelsConstraint[keyof typeof TunnelsConstraint];
/** input type for inserting data into table "tunnels" */
export type TunnelsInsertInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "tunnels" */
export type TunnelsMutationResponse = {
  __typename?: 'tunnels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tunnels>;
};

/** input type for inserting object relation for remote table "tunnels" */
export type TunnelsObjRelInsertInput = {
  data: TunnelsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TunnelsOnConflict>;
};

/** on conflict condition type for table "tunnels" */
export type TunnelsOnConflict = {
  constraint: TunnelsConstraint;
  update_columns?: Array<TunnelsUpdateColumn>;
  where?: Maybe<TunnelsBoolExp>;
};

/** Ordering options when selecting data from "tunnels". */
export type TunnelsOrderBy = {
  created_at?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  tunnel_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: tunnels */
export type TunnelsPkColumnsInput = {
  tunnel_id: Scalars['uuid'];
};

/** select columns of table "tunnels" */
export const TunnelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Name: 'name',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TunnelsSelectColumn = typeof TunnelsSelectColumn[keyof typeof TunnelsSelectColumn];
/** input type for updating data in table "tunnels" */
export type TunnelsSetInput = {
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "tunnels" */
export const TunnelsUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type TunnelsUpdateColumn = typeof TunnelsUpdateColumn[keyof typeof TunnelsUpdateColumn];
/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  avatar_json: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['bigint'];
  is_admin: Scalars['Boolean'];
  /** An array relationship */
  membership_requests: Array<MembershipRequests>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: MembershipsAggregate;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Maybe<Workspaces>;
  workspace_id: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "users" */
export type UsersAvatarJsonArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersMembershipRequestsArgs = {
  distinct_on?: Maybe<Array<MembershipRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipRequestsOrderBy>>;
  where?: Maybe<MembershipRequestsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersMembershipsArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersMembershipsAggregateArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};

/** order by aggregate values of table "users" */
export type UsersAggregateOrderBy = {
  avg?: Maybe<UsersAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<UsersMaxOrderBy>;
  min?: Maybe<UsersMinOrderBy>;
  stddev?: Maybe<UsersStddevOrderBy>;
  stddev_pop?: Maybe<UsersStddevPopOrderBy>;
  stddev_samp?: Maybe<UsersStddevSampOrderBy>;
  sum?: Maybe<UsersSumOrderBy>;
  var_pop?: Maybe<UsersVarPopOrderBy>;
  var_samp?: Maybe<UsersVarSampOrderBy>;
  variance?: Maybe<UsersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UsersAppendInput = {
  personalization?: Maybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "users" */
export type UsersAvgOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: Maybe<Array<UsersBoolExp>>;
  _not?: Maybe<UsersBoolExp>;
  _or?: Maybe<Array<UsersBoolExp>>;
  avatar_json?: Maybe<JsonbComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  email?: Maybe<StringComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  is_admin?: Maybe<BooleanComparisonExp>;
  membership_requests?: Maybe<MembershipRequestsBoolExp>;
  memberships?: Maybe<MembershipsBoolExp>;
  name?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  workspace?: Maybe<WorkspacesBoolExp>;
  workspace_id?: Maybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UsersDeleteAtPathInput = {
  personalization?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UsersDeleteElemInput = {
  personalization?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UsersDeleteKeyInput = {
  personalization?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type UsersMaxOrderBy = {
  created_at?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by min() on columns of table "users" */
export type UsersMinOrderBy = {
  created_at?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  avatar_json?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_admin?: Maybe<OrderBy>;
  membership_requests_aggregate?: Maybe<MembershipRequestsAggregateOrderBy>;
  memberships_aggregate?: Maybe<MembershipsAggregateOrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  workspace?: Maybe<WorkspacesOrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UsersPrependInput = {
  personalization?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export const UsersSelectColumn = {
  /** column name */
  AvatarJson: 'avatar_json',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  IsAdmin: 'is_admin',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UsersSelectColumn = typeof UsersSelectColumn[keyof typeof UsersSelectColumn];
/** input type for updating data in table "users" */
export type UsersSetInput = {
  personalization?: Maybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "users" */
export type UsersStddevOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "users" */
export type UsersStddevPopOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "users" */
export type UsersStddevSampOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "users" */
export type UsersSumOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "users" */
export type UsersVarPopOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "users" */
export type UsersVarSampOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "users" */
export type UsersVarianceOrderBy = {
  id?: Maybe<OrderBy>;
  workspace_id?: Maybe<OrderBy>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "workspaces" */
export type Workspaces = {
  __typename?: 'workspaces';
  default_connection: Maybe<Scalars['bigint']>;
  default_role_id: Maybe<Scalars['bigint']>;
  destinations_service_urls: Maybe<Scalars['jsonb']>;
  domain: Maybe<Scalars['String']>;
  feature_flags: Scalars['jsonb'];
  google_hosted_domain: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_approved: Scalars['Boolean'];
  joinable_to: Maybe<Scalars['jsonb']>;
  lock_popup_date: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  membership_requests: Array<MembershipRequests>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: MembershipsAggregate;
  name: Scalars['String'];
  onboarding: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  organization: Maybe<Organizations>;
  organization_id: Maybe<Scalars['bigint']>;
  region: Scalars['String'];
  /** An array relationship */
  roles: Array<Roles>;
  show_lock_popup: Scalars['Boolean'];
  slug: Maybe<Scalars['String']>;
  trial_ends_at: Maybe<Scalars['timestamptz']>;
  typeform_api_key: Maybe<Scalars['String']>;
  /** An array relationship */
  users: Array<Users>;
  visible_to: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesDestinationsServiceUrlsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesFeatureFlagsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesJoinableToArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesMembershipRequestsArgs = {
  distinct_on?: Maybe<Array<MembershipRequestsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipRequestsOrderBy>>;
  where?: Maybe<MembershipRequestsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesMembershipsArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesMembershipsAggregateArgs = {
  distinct_on?: Maybe<Array<MembershipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MembershipsOrderBy>>;
  where?: Maybe<MembershipsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesOnboardingArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesRolesArgs = {
  distinct_on?: Maybe<Array<RolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RolesOrderBy>>;
  where?: Maybe<RolesBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesUsersArgs = {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesVisibleToArgs = {
  path?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "workspaces" */
export type WorkspacesAggregateOrderBy = {
  avg?: Maybe<WorkspacesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<WorkspacesMaxOrderBy>;
  min?: Maybe<WorkspacesMinOrderBy>;
  stddev?: Maybe<WorkspacesStddevOrderBy>;
  stddev_pop?: Maybe<WorkspacesStddevPopOrderBy>;
  stddev_samp?: Maybe<WorkspacesStddevSampOrderBy>;
  sum?: Maybe<WorkspacesSumOrderBy>;
  var_pop?: Maybe<WorkspacesVarPopOrderBy>;
  var_samp?: Maybe<WorkspacesVarSampOrderBy>;
  variance?: Maybe<WorkspacesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WorkspacesAppendInput = {
  destinations_service_urls?: Maybe<Scalars['jsonb']>;
  onboarding?: Maybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "workspaces" */
export type WorkspacesAvgOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "workspaces". All fields are combined with a logical 'AND'. */
export type WorkspacesBoolExp = {
  _and?: Maybe<Array<WorkspacesBoolExp>>;
  _not?: Maybe<WorkspacesBoolExp>;
  _or?: Maybe<Array<WorkspacesBoolExp>>;
  default_connection?: Maybe<BigintComparisonExp>;
  default_role_id?: Maybe<BigintComparisonExp>;
  destinations_service_urls?: Maybe<JsonbComparisonExp>;
  domain?: Maybe<StringComparisonExp>;
  feature_flags?: Maybe<JsonbComparisonExp>;
  google_hosted_domain?: Maybe<StringComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  is_approved?: Maybe<BooleanComparisonExp>;
  joinable_to?: Maybe<JsonbComparisonExp>;
  lock_popup_date?: Maybe<TimestamptzComparisonExp>;
  membership_requests?: Maybe<MembershipRequestsBoolExp>;
  memberships?: Maybe<MembershipsBoolExp>;
  name?: Maybe<StringComparisonExp>;
  onboarding?: Maybe<JsonbComparisonExp>;
  organization?: Maybe<OrganizationsBoolExp>;
  organization_id?: Maybe<BigintComparisonExp>;
  region?: Maybe<StringComparisonExp>;
  roles?: Maybe<RolesBoolExp>;
  show_lock_popup?: Maybe<BooleanComparisonExp>;
  slug?: Maybe<StringComparisonExp>;
  trial_ends_at?: Maybe<TimestamptzComparisonExp>;
  typeform_api_key?: Maybe<StringComparisonExp>;
  users?: Maybe<UsersBoolExp>;
  visible_to?: Maybe<JsonbComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WorkspacesDeleteAtPathInput = {
  destinations_service_urls?: Maybe<Array<Scalars['String']>>;
  onboarding?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WorkspacesDeleteElemInput = {
  destinations_service_urls?: Maybe<Scalars['Int']>;
  onboarding?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WorkspacesDeleteKeyInput = {
  destinations_service_urls?: Maybe<Scalars['String']>;
  onboarding?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workspaces" */
export type WorkspacesIncInput = {
  default_connection?: Maybe<Scalars['bigint']>;
  default_role_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "workspaces" */
export type WorkspacesMaxOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  domain?: Maybe<OrderBy>;
  google_hosted_domain?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lock_popup_date?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  trial_ends_at?: Maybe<OrderBy>;
  typeform_api_key?: Maybe<OrderBy>;
};

/** order by min() on columns of table "workspaces" */
export type WorkspacesMinOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  domain?: Maybe<OrderBy>;
  google_hosted_domain?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lock_popup_date?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  trial_ends_at?: Maybe<OrderBy>;
  typeform_api_key?: Maybe<OrderBy>;
};

/** response of any mutation on the table "workspaces" */
export type WorkspacesMutationResponse = {
  __typename?: 'workspaces_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workspaces>;
};

/** Ordering options when selecting data from "workspaces". */
export type WorkspacesOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  destinations_service_urls?: Maybe<OrderBy>;
  domain?: Maybe<OrderBy>;
  feature_flags?: Maybe<OrderBy>;
  google_hosted_domain?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_approved?: Maybe<OrderBy>;
  joinable_to?: Maybe<OrderBy>;
  lock_popup_date?: Maybe<OrderBy>;
  membership_requests_aggregate?: Maybe<MembershipRequestsAggregateOrderBy>;
  memberships_aggregate?: Maybe<MembershipsAggregateOrderBy>;
  name?: Maybe<OrderBy>;
  onboarding?: Maybe<OrderBy>;
  organization?: Maybe<OrganizationsOrderBy>;
  organization_id?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
  roles_aggregate?: Maybe<RolesAggregateOrderBy>;
  show_lock_popup?: Maybe<OrderBy>;
  slug?: Maybe<OrderBy>;
  trial_ends_at?: Maybe<OrderBy>;
  typeform_api_key?: Maybe<OrderBy>;
  users_aggregate?: Maybe<UsersAggregateOrderBy>;
  visible_to?: Maybe<OrderBy>;
};

/** primary key columns input for table: workspaces */
export type WorkspacesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WorkspacesPrependInput = {
  destinations_service_urls?: Maybe<Scalars['jsonb']>;
  onboarding?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "workspaces" */
export const WorkspacesSelectColumn = {
  /** column name */
  DefaultConnection: 'default_connection',
  /** column name */
  DefaultRoleId: 'default_role_id',
  /** column name */
  DestinationsServiceUrls: 'destinations_service_urls',
  /** column name */
  Domain: 'domain',
  /** column name */
  FeatureFlags: 'feature_flags',
  /** column name */
  GoogleHostedDomain: 'google_hosted_domain',
  /** column name */
  Id: 'id',
  /** column name */
  IsApproved: 'is_approved',
  /** column name */
  JoinableTo: 'joinable_to',
  /** column name */
  LockPopupDate: 'lock_popup_date',
  /** column name */
  Name: 'name',
  /** column name */
  Onboarding: 'onboarding',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  Region: 'region',
  /** column name */
  ShowLockPopup: 'show_lock_popup',
  /** column name */
  Slug: 'slug',
  /** column name */
  TrialEndsAt: 'trial_ends_at',
  /** column name */
  TypeformApiKey: 'typeform_api_key',
  /** column name */
  VisibleTo: 'visible_to'
} as const;

export type WorkspacesSelectColumn = typeof WorkspacesSelectColumn[keyof typeof WorkspacesSelectColumn];
/** input type for updating data in table "workspaces" */
export type WorkspacesSetInput = {
  default_connection?: Maybe<Scalars['bigint']>;
  default_role_id?: Maybe<Scalars['bigint']>;
  destinations_service_urls?: Maybe<Scalars['jsonb']>;
  domain?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarding?: Maybe<Scalars['jsonb']>;
  slug?: Maybe<Scalars['String']>;
  typeform_api_key?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "workspaces" */
export type WorkspacesStddevOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "workspaces" */
export type WorkspacesStddevPopOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "workspaces" */
export type WorkspacesStddevSampOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** order by sum() on columns of table "workspaces" */
export type WorkspacesSumOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** order by var_pop() on columns of table "workspaces" */
export type WorkspacesVarPopOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** order by var_samp() on columns of table "workspaces" */
export type WorkspacesVarSampOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

/** order by variance() on columns of table "workspaces" */
export type WorkspacesVarianceOrderBy = {
  default_connection?: Maybe<OrderBy>;
  default_role_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  organization_id?: Maybe<OrderBy>;
};

export type WorkspaceAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceAlertsQuery = { __typename?: 'query', alerts: Array<{ __typename?: 'alerts', id: any, name: any, alert_interval: Maybe<any>, config: any, created_by: Maybe<any>, fatal_error_default: boolean, row_error_default: boolean, type: string, pagerduty_credential_id: Maybe<any>, slack_credential_id: Maybe<any> }> };

export type WorkspaceAlertsWithStatusesQueryVariables = Exact<{
  syncId?: Maybe<Scalars['bigint']>;
  orderBy?: AlertsOrderBy;
}>;


export type WorkspaceAlertsWithStatusesQuery = { __typename?: 'query', alerts: Array<{ __typename?: 'alerts', id: any, name: any, alert_interval: Maybe<any>, config: any, created_by: Maybe<any>, fatal_error_default: boolean, row_error_default: boolean, type: string, pagerduty_credential_id: Maybe<any>, slack_credential_id: Maybe<any>, alert_statuses: Array<{ __typename?: 'alert_statuses', last_attempted: any, destination_instance_id: any, error: Maybe<any> }> }> };

export type CreateWorkspaceAlertMutationVariables = Exact<{
  input: AlertsInsertInput;
}>;


export type CreateWorkspaceAlertMutation = { __typename?: 'mutation', insert_alerts_one: Maybe<{ __typename?: 'alerts', id: any }> };

export type UpdateWorkspaceAlertMutationVariables = Exact<{
  id: Scalars['bigint'];
  input: AlertsSetInput;
}>;


export type UpdateWorkspaceAlertMutation = { __typename?: 'mutation', update_alerts_by_pk: Maybe<{ __typename?: 'alerts', id: any }> };

export type DeleteWorkspaceAlertsMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteWorkspaceAlertsMutation = { __typename?: 'mutation', delete_alerts: Maybe<{ __typename?: 'alerts_mutation_response', affected_rows: number }> };

export type CreateSyncTemplateAlertsMutationVariables = Exact<{
  input: Array<AlertInstancesInsertInput> | AlertInstancesInsertInput;
}>;


export type CreateSyncTemplateAlertsMutation = { __typename?: 'mutation', insert_alert_instances: Maybe<{ __typename?: 'alert_instances_mutation_response', affected_rows: number }> };

export type CreateSyncAlertsMutationVariables = Exact<{
  input: Array<AlertInstancesInsertInput> | AlertInstancesInsertInput;
}>;


export type CreateSyncAlertsMutation = { __typename?: 'mutation', insert_alert_instances: Maybe<{ __typename?: 'alert_instances_mutation_response', affected_rows: number }> };

export type DeleteSyncAlertsMutationVariables = Exact<{
  syncId?: Maybe<Scalars['bigint']>;
  syncTemplateId?: Maybe<Scalars['Int']>;
  alertIds: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteSyncAlertsMutation = { __typename?: 'mutation', delete_alert_instances: Maybe<{ __typename?: 'alert_instances_mutation_response', affected_rows: number }> };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'query', api_keys: Array<{ __typename?: 'api_keys', id: any, name: Maybe<string>, last_used: Maybe<any>, created_at: any }> };

export type CreateApiKeyMutationVariables = Exact<{
  object: ApiKeysInsertInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'mutation', insert_api_keys_one: Maybe<{ __typename?: 'api_keys', id: any }> };

export type DeleteApiKeysMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteApiKeysMutation = { __typename?: 'mutation', delete_api_keys: Maybe<{ __typename?: 'api_keys_mutation_response', affected_rows: number }> };

export type AthenaWorkGroupsQueryVariables = Exact<{
  connectionId: Scalars['Int'];
  region: Scalars['String'];
  credentials: AthenaCredentials;
}>;


export type AthenaWorkGroupsQuery = { __typename?: 'query', athenaListWorkGroups: { __typename?: 'AthenaListWorkGroupsResult', workGroups: Array<{ __typename?: 'AthenaWorkGroup', name: string }> } };

export type AthenaWorkGroupsNewSourceQueryVariables = Exact<{
  region: Scalars['String'];
  credentials: AthenaCredentials;
}>;


export type AthenaWorkGroupsNewSourceQuery = { __typename?: 'query', athenaListWorkGroupsNewSource: { __typename?: 'AthenaListWorkGroupsResult', workGroups: Array<{ __typename?: 'AthenaWorkGroup', name: string }> } };

export type AthenaDataCatalogsQueryVariables = Exact<{
  connectionId: Scalars['Int'];
  region: Scalars['String'];
  credentials: AthenaCredentials;
}>;


export type AthenaDataCatalogsQuery = { __typename?: 'query', athenaListDataCatalogs: { __typename?: 'AthenaListDataCatalogsResult', dataCatalogs: Array<{ __typename?: 'AthenaDataCatalog', name: string }> } };

export type AthenaDataCatalogsNewSourceQueryVariables = Exact<{
  region: Scalars['String'];
  credentials: AthenaCredentials;
}>;


export type AthenaDataCatalogsNewSourceQuery = { __typename?: 'query', athenaListDataCatalogsNewSource: { __typename?: 'AthenaListDataCatalogsResult', dataCatalogs: Array<{ __typename?: 'AthenaDataCatalog', name: string }> } };

export type AthenaDatabasesQueryVariables = Exact<{
  connectionId: Scalars['Int'];
  region: Scalars['String'];
  credentials: AthenaCredentials;
  dataCatalog: Scalars['String'];
}>;


export type AthenaDatabasesQuery = { __typename?: 'query', athenaListDatabases: { __typename?: 'AthenaListDatabasesResult', databases: Array<{ __typename?: 'AthenaDatabase', name: string }> } };

export type AthenaDatabasesNewSourceQueryVariables = Exact<{
  region: Scalars['String'];
  credentials: AthenaCredentials;
  dataCatalog: Scalars['String'];
}>;


export type AthenaDatabasesNewSourceQuery = { __typename?: 'query', athenaListDatabasesNewSource: { __typename?: 'AthenaListDatabasesResult', databases: Array<{ __typename?: 'AthenaDatabase', name: string }> } };

export type ParentModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParentModelsQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, created_at: Maybe<any>, updated_at: Maybe<any>, syncable_columns: Array<{ __typename?: 'SyncableColumn', column_reference: any, model_name: string, name: string }>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type RelatedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type RelatedModelsQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, created_at: Maybe<any>, updated_at: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type EventsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, created_at: Maybe<any>, updated_at: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type DirectRelationshipModelsQueryVariables = Exact<{
  sourceId: Scalars['bigint'];
}>;


export type DirectRelationshipModelsQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, connection_id: Maybe<any>, columns: Array<{ __typename?: 'model_columns', trigger_top_k_sync: Maybe<boolean>, top_k_sync_interval: Maybe<number>, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, last_top_k_sync_timestamp: Maybe<any>, name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }> }> };

export type ParentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParentsQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> }> };

export type ObjectQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type ObjectQuery = { __typename?: 'query', segments_by_pk: Maybe<{ __typename?: 'segments', id: any, name: string, primary_key: Maybe<string>, slug: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, query_type: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any>, created_at: Maybe<any>, updated_at: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', trigger_top_k_sync: Maybe<boolean>, top_k_sync_interval: Maybe<number>, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, last_top_k_sync_timestamp: Maybe<any>, name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type CreateObjectMutationVariables = Exact<{
  input: SegmentsInsertInput;
}>;


export type CreateObjectMutation = { __typename?: 'mutation', insert_segments_one: Maybe<{ __typename?: 'segments', id: any }> };

export type UpdateObjectMutationVariables = Exact<{
  id: Scalars['bigint'];
  input: SegmentsSetInput;
}>;


export type UpdateObjectMutation = { __typename?: 'mutation', update_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }> };

export type CreateEventMutationVariables = Exact<{
  input: EventModelsInsertInput;
}>;


export type CreateEventMutation = { __typename?: 'mutation', insert_event_models_one: Maybe<{ __typename?: 'event_models', model_id: any }> };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['bigint'];
  set: EventModelsSetInput;
}>;


export type UpdateEventMutation = { __typename?: 'mutation', update_event_models_by_pk: Maybe<{ __typename?: 'event_models', model_id: any }> };

export type DeleteObjectMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteObjectMutation = { __typename?: 'mutation', delete_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }> };

export type CreateTraitMutationVariables = Exact<{
  input: TraitDefinitionsInsertInput;
}>;


export type CreateTraitMutation = { __typename?: 'mutation', insert_trait_definitions_one: Maybe<{ __typename?: 'trait_definitions', id: any }> };

export type UpdateTraitMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: TraitDefinitionsSetInput;
}>;


export type UpdateTraitMutation = { __typename?: 'mutation', update_trait_definitions_by_pk: Maybe<{ __typename?: 'trait_definitions', id: any }> };

export type DeleteTraitMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteTraitMutation = { __typename?: 'mutation', delete_trait_definitions_by_pk: Maybe<{ __typename?: 'trait_definitions', id: any }> };

export type AudiencesQueryVariables = Exact<{
  filters?: Maybe<SegmentsBoolExp>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: SegmentsOrderBy;
}>;


export type AudiencesQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, visual_query_filter: Maybe<any>, created_at: Maybe<any>, updated_at: Maybe<any>, labels: any, parent: Maybe<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> }>, query_runs: Array<{ __typename?: 'query_runs', size: number }>, syncs: Array<{ __typename?: 'syncs', id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, config: any, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any> }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }>, segments_aggregate: { __typename?: 'segments_aggregate', aggregate: Maybe<{ __typename?: 'segments_aggregate_fields', count: number }> } };

export type AudienceQueryVariables = Exact<{
  id: Scalars['bigint'];
  orderBy?: SyncsOrderBy;
}>;


export type AudienceQuery = { __typename?: 'query', segments_by_pk: Maybe<{ __typename?: 'segments', id: any, name: string, visual_query_filter: Maybe<any>, created_at: Maybe<any>, updated_at: Maybe<any>, labels: any, syncable_columns: Array<{ __typename?: 'SyncableColumn', column_reference: any, model_name: string, name: string }>, parent: Maybe<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> }>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, syncs: Array<{ __typename?: 'syncs', sync_template_id: Maybe<number>, row_threshold_attempted: Maybe<any>, row_threshold_total: Maybe<any>, id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, created_at: Maybe<any>, updated_at: Maybe<any>, config: any, sync_alerts: Array<{ __typename?: 'sync_alerts', id: Maybe<any>, fatal_error: Maybe<boolean>, row_error: Maybe<boolean> }>, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any>, definition: { __typename?: 'DestinationDefinition', icon: string, name: string } }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type RelatedAudiencesQueryVariables = Exact<{
  parentModelId: Scalars['bigint'];
  modelId?: Maybe<Scalars['bigint']>;
}>;


export type RelatedAudiencesQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string }> };

export type CreateAudienceMutationVariables = Exact<{
  input: SegmentsInsertInput;
}>;


export type CreateAudienceMutation = { __typename?: 'mutation', insert_segments_one: Maybe<{ __typename?: 'segments', id: any }> };

export type UpdateAudienceMutationVariables = Exact<{
  id: Scalars['bigint'];
  input: SegmentsSetInput;
}>;


export type UpdateAudienceMutation = { __typename?: 'mutation', update_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }> };

export type AddLabelsToAudiencesMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
  labels: Scalars['jsonb'];
}>;


export type AddLabelsToAudiencesMutation = { __typename?: 'mutation', update_segments: Maybe<{ __typename?: 'segments_mutation_response', affected_rows: number }> };

export type DeleteAudienceMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteAudienceMutation = { __typename?: 'mutation', delete_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }> };

export type CreateGoogleServiceAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGoogleServiceAccountMutation = { __typename?: 'mutation', createGoogleServiceAccount: { __typename?: 'CreateGoogleServiceAccountSuccess', serviceAccount: { __typename?: 'GoogleServiceAccount', email: string, credentials: string } } };

export type PortalUrlQueryVariables = Exact<{
  customer_id: Scalars['String'];
}>;


export type PortalUrlQuery = { __typename?: 'query', getPortalUrl: { __typename?: 'StripeRedirectResult', redirect: string } };

export type CheckoutUrlQueryVariables = Exact<{
  lookup_key: Scalars['String'];
  org_name: Scalars['String'];
  workspace_id: Scalars['Int'];
}>;


export type CheckoutUrlQuery = { __typename?: 'query', getCheckoutUrl: { __typename?: 'StripeRedirectResult', redirect: string } };

export type CreateModelColumnMutationVariables = Exact<{
  input: ModelColumnsInsertInput;
}>;


export type CreateModelColumnMutation = { __typename?: 'mutation', insert_model_columns_one: Maybe<{ __typename?: 'model_columns', model_id: any }> };

export type UpdateModelColumnMutationVariables = Exact<{
  id: Scalars['bigint'];
  name: Scalars['String'];
  input?: Maybe<ModelColumnsSetInput>;
}>;


export type UpdateModelColumnMutation = { __typename?: 'mutation', update_model_columns_by_pk: Maybe<{ __typename?: 'model_columns', model_id: any }> };

export type UpdateModelColumnsMutationVariables = Exact<{
  id: Scalars['bigint'];
  input?: Maybe<ModelColumnsSetInput>;
}>;


export type UpdateModelColumnsMutation = { __typename?: 'mutation', update_model_columns: Maybe<{ __typename?: 'model_columns_mutation_response', affected_rows: number }> };

export type DeleteModelColumnsMutationVariables = Exact<{
  modelId: Scalars['bigint'];
  names: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteModelColumnsMutation = { __typename?: 'mutation', delete_model_columns: Maybe<{ __typename?: 'model_columns_mutation_response', affected_rows: number }> };

export type ColumnSuggestionsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type ColumnSuggestionsQuery = { __typename?: 'query', getTopK: { __typename?: 'TopKResponse', columns: Array<{ __typename?: 'TopKColumnResponse', modelId: string, name: string, error: Maybe<string>, values: Maybe<Array<Maybe<any>>> }> } };

export type CloudCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type CloudCredentialsQuery = { __typename?: 'query', cloud_credentials: Array<{ __typename?: 'cloud_credentials', id: any, created_at: any, provider: string, name: string, stripped_config: Maybe<any> }> };

export type CloudCredentialQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type CloudCredentialQuery = { __typename?: 'query', cloud_credentials_by_pk: Maybe<{ __typename?: 'cloud_credentials', id: any, created_at: any, provider: string, name: string, stripped_config: Maybe<any> }> };

export type ProviderCloudCredentialsQueryVariables = Exact<{
  provider: Scalars['String'];
}>;


export type ProviderCloudCredentialsQuery = { __typename?: 'query', cloud_credentials: Array<{ __typename?: 'cloud_credentials', id: any, created_at: any, provider: string, name: string, stripped_config: Maybe<any> }> };

export type CreateCloudCredentialMutationVariables = Exact<{
  input: CloudCredentialsInsertInput;
}>;


export type CreateCloudCredentialMutation = { __typename?: 'mutation', insert_cloud_credentials_one: Maybe<{ __typename?: 'cloud_credentials', id: any, provider: string }> };

export type DeleteCloudCredentialsMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteCloudCredentialsMutation = { __typename?: 'mutation', delete_cloud_credentials: Maybe<{ __typename?: 'cloud_credentials_mutation_response', affected_rows: number }> };

export type DatadogCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type DatadogCredentialsQuery = { __typename?: 'query', datadog_credentials: Array<{ __typename?: 'datadog_credentials', id: number, created_at: any, site: string }> };

export type WorkspaceDatadogCredentialsQueryVariables = Exact<{
  workspace: Scalars['Int'];
}>;


export type WorkspaceDatadogCredentialsQuery = { __typename?: 'query', datadog_credentials: Array<{ __typename?: 'datadog_credentials', id: number, created_at: any, site: string }> };

export type CreateDatadogCredentialsMutationVariables = Exact<{
  input: DatadogCredentialsInsertInput;
}>;


export type CreateDatadogCredentialsMutation = { __typename?: 'mutation', insert_datadog_credentials_one: Maybe<{ __typename?: 'datadog_credentials', id: number, site: string }> };

export type UpdateDatadogCredentialsMutationVariables = Exact<{
  id: Scalars['Int'];
  credentials: DatadogCredentialsSetInput;
}>;


export type UpdateDatadogCredentialsMutation = { __typename?: 'mutation', update_datadog_credentials_by_pk: Maybe<{ __typename?: 'datadog_credentials', id: number, site: string }> };

export type ValidateDatadogCredentialsQueryVariables = Exact<{
  site: Scalars['String'];
  apiKey: Scalars['String'];
}>;


export type ValidateDatadogCredentialsQuery = { __typename?: 'query', ValidateDatadogCredentials: Maybe<{ __typename?: 'ValidateDatadogCredentialsOutput', success: boolean, message: string }> };

export type DbtSyncConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type DbtSyncConfigsQuery = { __typename?: 'query', dbt_sync_config: Array<{ __typename?: 'dbt_sync_config', id: any, git_credentials_id: any, env_vars: Maybe<any>, version: Maybe<string>, last_run_at: Maybe<any>, selector: Maybe<string>, path: Maybe<string>, target: Maybe<string>, enabled: boolean, branch: string, repository: Maybe<string>, default_schema: string, error: Maybe<any>, connection_id: any, git_credentials: { __typename?: 'git_credentials', id: any, type: string } }> };

export type DbtSyncConfigQueryVariables = Exact<{
  sourceId: Scalars['bigint'];
}>;


export type DbtSyncConfigQuery = { __typename?: 'query', dbt_sync_config: Array<{ __typename?: 'dbt_sync_config', id: any, git_credentials_id: any, env_vars: Maybe<any>, version: Maybe<string>, last_run_at: Maybe<any>, selector: Maybe<string>, path: Maybe<string>, target: Maybe<string>, enabled: boolean, branch: string, repository: Maybe<string>, default_schema: string, error: Maybe<any>, git_credentials: { __typename?: 'git_credentials', id: any, type: string } }> };

export type DbtSyncModelsQueryVariables = Exact<{
  sourceId: Scalars['bigint'];
}>;


export type DbtSyncModelsQuery = { __typename?: 'query', dbt_sync_models: Array<{ __typename?: 'dbt_sync_models', id: any, name: string, schema: string, removed: boolean, dbt_unique_id: string, data: any, dbt_sync_config: { __typename?: 'dbt_sync_config', id: any, branch: string, repository: Maybe<string>, git_credentials: { __typename?: 'git_credentials', type: string, username: Maybe<string> } } }> };

export type DbtModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type DbtModelsQuery = { __typename?: 'query', dbt_models: Array<{ __typename?: 'dbt_models', id: number, alias: Maybe<string>, description: string, original_file_path: Maybe<string>, name: string, git_sync_config: { __typename?: 'git_sync_config', id: number, schema: Maybe<string> } }> };

export type DbtModelQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DbtModelQuery = { __typename?: 'query', dbt_models_by_pk: Maybe<{ __typename?: 'dbt_models', name: string, alias: Maybe<string>, original_file_path: Maybe<string>, last_commit_synced: string, description: string, git_sync_config: { __typename?: 'git_sync_config', schema: Maybe<string>, repository: string } }> };

export type DbtSyncModelQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DbtSyncModelQuery = { __typename?: 'query', dbt_sync_models_by_pk: Maybe<{ __typename?: 'dbt_sync_models', id: any, name: string, schema: string, dbt_unique_id: string, data: any, dbt_sync_config: { __typename?: 'dbt_sync_config', id: any, branch: string, repository: Maybe<string>, git_credentials: { __typename?: 'git_credentials', type: string, username: Maybe<string> } } }> };

export type UpdateDbtSyncConfigMutationVariables = Exact<{
  id: Scalars['bigint'];
  object?: Maybe<DbtSyncConfigSetInput>;
}>;


export type UpdateDbtSyncConfigMutation = { __typename?: 'mutation', update_dbt_sync_config_by_pk: Maybe<{ __typename?: 'dbt_sync_config', id: any, version: Maybe<string>, git_credentials_id: any, selector: Maybe<string>, path: Maybe<string>, enabled: boolean, branch: string, repository: Maybe<string>, default_schema: string }> };

export type CreateDbtSyncConfigMutationVariables = Exact<{
  object: DbtSyncConfigInsertInput;
}>;


export type CreateDbtSyncConfigMutation = { __typename?: 'mutation', insert_dbt_sync_config_one: Maybe<{ __typename?: 'dbt_sync_config', id: any, version: Maybe<string>, git_credentials_id: any, selector: Maybe<string>, path: Maybe<string>, enabled: boolean, branch: string, repository: Maybe<string>, default_schema: string }> };

export type DbtAccountsQueryVariables = Exact<{
  apiKey: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
}>;


export type DbtAccountsQuery = { __typename?: 'query', getDBTAccounts: Array<{ __typename?: 'DBTAccount', id: string, name: string }> };

export type DbtJobsQueryVariables = Exact<{
  accountId: Scalars['String'];
  apiKey: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
}>;


export type DbtJobsQuery = { __typename?: 'query', getDBTJobs: Array<{ __typename?: 'DBTJob', id: string, name: string }> };

export type DbtCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type DbtCredentialsQuery = { __typename?: 'query', dbt_credentials: Array<{ __typename?: 'dbt_credentials', id: number, api_key: Maybe<string>, subdomain: Maybe<string> }> };

export type CreateDbtCredentialMutationVariables = Exact<{
  api_key: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
}>;


export type CreateDbtCredentialMutation = { __typename?: 'mutation', createDBTCredential: { __typename?: 'DBTCredential', id: number, api_key: Maybe<string>, subdomain: Maybe<string> } };

export type UpdateDbtCredentialMutationVariables = Exact<{
  id: Scalars['Int'];
  api_key: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
}>;


export type UpdateDbtCredentialMutation = { __typename?: 'mutation', updateDBTCredential: { __typename?: 'DBTCredential', id: number, api_key: Maybe<string>, subdomain: Maybe<string> } };

export type DestinationQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DestinationQuery = { __typename?: 'query', destinations_by_pk: Maybe<{ __typename?: 'destinations', tags: any, id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any>, created_at: any, updated_at: Maybe<any>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type DestinationsQueryVariables = Exact<{
  filters?: Maybe<DestinationsBoolExp>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: DestinationsOrderBy;
}>;


export type DestinationsQuery = { __typename?: 'query', destinations: Array<{ __typename?: 'destinations', tags: any, id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any>, created_at: any, updated_at: Maybe<any>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }>, destinations_aggregate: { __typename?: 'destinations_aggregate', aggregate: Maybe<{ __typename?: 'destinations_aggregate_fields', count: number }> } };

export type DestinationStrippedConfigurationQueryVariables = Exact<{
  destinationId: Scalars['bigint'];
}>;


export type DestinationStrippedConfigurationQuery = { __typename?: 'query', getDestinationStrippedConfiguration: any };

export type DestinationDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DestinationDefinitionsQuery = { __typename?: 'query', getDestinationDefinitions: Array<{ __typename?: 'DestinationDefinition', name: string, type: string, status: string, icon: string, docs: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, features: Array<Maybe<string>>, oauthUrl: Maybe<string>, configurationForm: Maybe<Array<Maybe<any>>>, testConnection: boolean, configVersion: Maybe<number>, categories: Array<Maybe<{ __typename?: 'DestinationCategory', name: string, type: Maybe<string>, shortDescription: Maybe<string> }>> }> };

export type DestinationDefinitionQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type DestinationDefinitionQuery = { __typename?: 'query', getDestinationDefinition: { __typename?: 'DestinationDefinition', name: string, type: string, status: string, icon: string, docs: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, features: Array<Maybe<string>>, oauthUrl: Maybe<string>, configurationForm: Maybe<Array<Maybe<any>>>, testConnection: boolean, configVersion: Maybe<number>, categories: Array<Maybe<{ __typename?: 'DestinationCategory', name: string, type: Maybe<string>, shortDescription: Maybe<string> }>> } };

export type DestinationSyncsQueryVariables = Exact<{
  destinationId: Scalars['bigint'];
  sameDestinationId: Scalars['Int'];
}>;


export type DestinationSyncsQuery = { __typename?: 'query', destinations_by_pk: Maybe<{ __typename?: 'destinations', destination_instances: Array<{ __typename?: 'destination_instances', id: any, config: Maybe<any>, created_at: any, segment: { __typename?: 'segments', id: any, name: string, connection: Maybe<{ __typename?: 'connections', id: any, definition: { __typename?: 'SourceDefinition', icon: string, name: string } }> } }> }>, sync_templates: Array<{ __typename?: 'sync_templates', destination_instances: Array<{ __typename?: 'destination_instances', id: any, config: Maybe<any>, created_at: any, segment: { __typename?: 'segments', id: any, name: string, connection: Maybe<{ __typename?: 'connections', id: any, definition: { __typename?: 'SourceDefinition', icon: string, name: string } }> } }> }> };

export type CreateDestinationV2MutationVariables = Exact<{
  object: DestinationsMutationInput;
}>;


export type CreateDestinationV2Mutation = { __typename?: 'mutation', createDestinationWithSecrets: { __typename?: 'DestinationResult', id: any } };

export type UpdateDestinationV2MutationVariables = Exact<{
  id: Scalars['String'];
  object: DestinationsMutationInput;
}>;


export type UpdateDestinationV2Mutation = { __typename?: 'mutation', updateDestinationWithSecrets: { __typename?: 'DestinationResult', id: any } };

export type DeleteDestinationMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteDestinationMutation = { __typename?: 'mutation', delete_destinations_by_pk: Maybe<{ __typename?: 'destinations', id: any }> };

export type DeleteDestinationsMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteDestinationsMutation = { __typename?: 'mutation', delete_destinations: Maybe<{ __typename?: 'destinations_mutation_response', affected_rows: number }> };

export type TestNewDestinationMutationVariables = Exact<{
  type: Scalars['String'];
  configuration: Scalars['JSONObject'];
}>;


export type TestNewDestinationMutation = { __typename?: 'mutation', testNewDestination: Maybe<{ __typename?: 'TestDestinationResponse', success: boolean, reason: Maybe<string>, metadata: Maybe<any> }> };

export type TestUpdatedDestinationMutationVariables = Exact<{
  destinationId: Scalars['String'];
  newConfiguration: Scalars['JSONObject'];
}>;


export type TestUpdatedDestinationMutation = { __typename?: 'mutation', testUpdatedDestination: Maybe<{ __typename?: 'TestDestinationResponse', success: boolean, reason: Maybe<string>, metadata: Maybe<any> }> };

export type TestDestinationConnectionMutationVariables = Exact<{
  destinationId?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
}>;


export type TestDestinationConnectionMutation = { __typename?: 'mutation', testDestinationConnection: Maybe<{ __typename?: 'TestDestinationConnectionResponse', success: boolean, reason: Maybe<string>, metadata: Maybe<any> }> };

export type ActiveCampaignColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type ActiveCampaignColumnsQuery = { __typename?: 'query', activeCampaignDescribeObject: { __typename?: 'ActiveCampaignDescribeObjectSuccess', fields: Array<{ __typename?: 'ActiveCampaignField', name: string, id: string, type: string }> } };

export type AsanaColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  workspaceId: Scalars['String'];
}>;


export type AsanaColumnsQuery = { __typename?: 'query', asanaListCustomFields: { __typename?: 'AsanaListCustomFieldsSuccess', fields: Array<{ __typename?: 'AsanaCustomField', name: string, id: string, dataType: string }> } };

export type AsanaWorkspacesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type AsanaWorkspacesQuery = { __typename?: 'query', asanaListWorkspaces: { __typename?: 'AsanaListWorkspacesSuccess', workspaces: Array<{ __typename?: 'AsanaWorkspaces', name: string, id: string }> } };

export type ClientSuccessColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type ClientSuccessColumnsQuery = { __typename?: 'query', clientSuccessDescribeObject: { __typename?: 'ClientSuccessDescribeObjectResult', fields: Array<{ __typename?: 'ClientSuccessField', name: string, id: string, type: string }>, customFields: Array<Maybe<{ __typename?: 'ClientSuccessField', name: string, id: string, type: string }>> } };

export type CloseContactColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type CloseContactColumnsQuery = { __typename?: 'query', closeioDescribeObject: { __typename?: 'CloseioDescribeObjectSuccess', fields: Array<{ __typename?: 'CloseioObjectField', name: string, id: string, standardType: StandardFieldType }> } };

export type CloseLeadColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type CloseLeadColumnsQuery = { __typename?: 'query', closeioDescribeObject: { __typename?: 'CloseioDescribeObjectSuccess', fields: Array<{ __typename?: 'CloseioObjectField', name: string, id: string, standardType: StandardFieldType }> } };

export type CloseCustomActivitiesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type CloseCustomActivitiesQuery = { __typename?: 'query', closeioCustomActivities: { __typename?: 'CloseioCustomActivitiesSuccess', activities: Array<{ __typename?: 'CloseioCustomActivity', id: string, name: string, fields: Array<{ __typename?: 'CloseioObjectField', id: string, name: string, type: string, standardType: StandardFieldType }> }> } };

export type CustomObjectsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type CustomObjectsQuery = { __typename?: 'query', customListObjects: { __typename?: 'CustomDestinationListObjectsResult', objects: Maybe<Array<{ __typename?: 'CustomDestinationObject', description: Maybe<string>, id: string, label: string }>> } };

export type CustomModesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object?: Maybe<Scalars['String']>;
}>;


export type CustomModesQuery = { __typename?: 'query', customListModes: { __typename?: 'CustomDestinationListModesResult', modes: Maybe<Array<{ __typename?: 'CustomDestinationMode', description: Maybe<string>, id: string, label: string }>> } };

export type CustomFieldsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
}>;


export type CustomFieldsQuery = { __typename?: 'query', customListFields: { __typename?: 'CustomDestinationListFieldsResult', freeform: Maybe<boolean>, fields: Maybe<Array<{ __typename?: 'CustomDestinationField', description: Maybe<string>, id: string, label: string, required: Maybe<boolean>, identifier: Maybe<boolean>, type: Maybe<string> }>> } };

export type CustomOptionsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
}>;


export type CustomOptionsQuery = { __typename?: 'query', customListOptions: { __typename?: 'CustomDestinationListOptionsResult', options: Maybe<{ __typename?: 'CustomDestinationOptions', schema: Maybe<string>, uiSchema: Maybe<string> }> } };

export type CustomValidateConfigurationQueryVariables = Exact<{
  destinationId: Scalars['String'];
  jsonInstanceConfiguration: Scalars['String'];
}>;


export type CustomValidateConfigurationQuery = { __typename?: 'query', customValidateConfiguration: { __typename?: 'CustomDestinationValidateConfigurationResult', errors: Maybe<Array<string>> } };

export type FacebookAdsProductCatalogQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type FacebookAdsProductCatalogQuery = { __typename?: 'query', facebookAdCatalogGetProductCatalogs: { __typename?: 'FacebookAdCatalogGetProductCatalogsSuccess', fields: Array<{ __typename?: 'FacebookAdCatalogGetProductCatalogs', name: string, id: string }> } };

export type FacebookConversionsColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type FacebookConversionsColumnsQuery = { __typename?: 'query', facebookConversionsDescribeObject: { __typename?: 'FacebookConversionsDescribeObjectSuccess', fields: Array<{ __typename?: 'FacebookConversionsField', name: string, id: string, type: string }> } };

export type FacebookAdAccountsQueryVariables = Exact<{
  destId: Scalars['String'];
}>;


export type FacebookAdAccountsQuery = { __typename?: 'query', facebookListAdAccounts: { __typename?: 'FacebookListAdAccountsSuccess', accounts: Array<{ __typename?: 'FacebookAdAccount', id: string, accountId: string, name: string }> } };

export type FreshdeskColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type FreshdeskColumnsQuery = { __typename?: 'query', freshdeskListCustomFields: { __typename?: 'FreshdeskListCustomFieldsSuccess', fields: Array<{ __typename?: 'FreshdeskField', name: string, id: string, standardType: StandardFieldType }> } };

export type FrontColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type FrontColumnsQuery = { __typename?: 'query', frontDescribeObject: { __typename?: 'FrontDescribeObjectSuccess', fields: Array<{ __typename?: 'FrontObjectField', name: string, id: string, standardType: StandardFieldType }> } };

export type GainsightPxUserAttributesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type GainsightPxUserAttributesQuery = { __typename?: 'query', gainsightpxGetUserAttributes: { __typename?: 'GainsightpxGetUserAttributesSuccess', fields: Array<{ __typename?: 'GainsightpxUserAttributes', name: string, id: string, type: string, standardType: StandardFieldType, origin: string }> } };

export type GainsightPxAccountAttributesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type GainsightPxAccountAttributesQuery = { __typename?: 'query', gainsightpxGetAccountAttributes: { __typename?: 'GainsightpxGetAccountAttributesSuccess', fields: Array<{ __typename?: 'GainsightpxAccountAttributes', name: string, id: string, type: string, standardType: StandardFieldType, origin: string }> } };

export type GoogleAdsColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  mode: Scalars['String'];
}>;


export type GoogleAdsColumnsQuery = { __typename?: 'query', googleDescribeMode: { __typename?: 'GoogleAdsDescribeModeResult', fields: Array<{ __typename?: 'GoogleAdsField', name: string, id: string, type: string, required: Maybe<boolean> }> } };

export type GoogleAdsConversionActionsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  mode: Scalars['String'];
  accountId: Scalars['String'];
  loginAccountId?: Maybe<Scalars['String']>;
}>;


export type GoogleAdsConversionActionsQuery = { __typename?: 'query', googleListConversionActions: { __typename?: 'GoogleAdsListConversionActionsResult', actions: Array<{ __typename?: 'GoogleAdsConversionAction', name: string, resourceName: string }> } };

export type GoogleAdsAccountsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type GoogleAdsAccountsQuery = { __typename?: 'query', googleGetAccounts: string };

export type GoogleCampaignManagerProfilesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type GoogleCampaignManagerProfilesQuery = { __typename?: 'query', googleCampaignManagerListProfiles: Array<Maybe<any>> };

export type GoogleCampaignManagerFloodlightActivitiesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  profileId: Scalars['String'];
}>;


export type GoogleCampaignManagerFloodlightActivitiesQuery = { __typename?: 'query', googleCampaignManagerListFloodlightActivities: Array<Maybe<any>> };

export type GoogleSheetsDestinationSheetNamesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  spreadsheetId: Scalars['String'];
}>;


export type GoogleSheetsDestinationSheetNamesQuery = { __typename?: 'query', googlesheetsListSheets: { __typename?: 'GooglesheetsListSheetsSuccess', sheetNames: Array<{ __typename?: 'SheetName', name: string }> } };

export type GoogleSheetsDestinationSpreadSheetsQueryVariables = Exact<{
  destinationId: Scalars['Int'];
}>;


export type GoogleSheetsDestinationSpreadSheetsQuery = { __typename?: 'query', googlesheetsListSpreadSheets: Array<{ __typename?: 'GooglesheetsSpreadSheet', id: string, name: string, webViewLink: string }> };

export type HubSpotLegacyColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type HubSpotLegacyColumnsQuery = { __typename?: 'query', hubspotLegacyDescribeObject: { __typename?: 'HubSpotLegacyDescribeObjectSuccess', fields: Array<{ __typename?: 'HubSpotLegacyObjectField', name: string, unique: boolean, type: string, standardType: StandardFieldType, isUpdateable: boolean }>, associations: Array<{ __typename?: 'HubSpotLegacyObjectAssociation', id: string, fromObjectTypeId: string, toObjectTypeId: string, name: string }> } };

export type HubSpotLegacyObjectsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type HubSpotLegacyObjectsQuery = { __typename?: 'query', hubspotLegacyDescribeGlobal: { __typename?: 'HubSpotLegacyDescribeGlobalSuccess', objectsV2: Array<{ __typename?: 'HubSpotLegacyObjectDescription', id: string, name: string }> } };

export type HubSpotColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type HubSpotColumnsQuery = { __typename?: 'query', hubspotDescribeObject: { __typename?: 'HubSpotDescribeObjectSuccess', fields: Array<{ __typename?: 'HubSpotObjectField', name: string, unique: boolean, type: string, standardType: StandardFieldType, isUpdateable: boolean }>, associations: Array<{ __typename?: 'HubSpotObjectAssociation', id: string, fromObjectTypeId: string, toObjectTypeId: string, name: string }> } };

export type HubSpotObjectsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type HubSpotObjectsQuery = { __typename?: 'query', hubspotDescribeGlobal: { __typename?: 'HubSpotDescribeGlobalSuccess', objectsV2: Array<{ __typename?: 'HubSpotObjectDescription', id: string, name: string }> } };

export type IntercomColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type IntercomColumnsQuery = { __typename?: 'query', intercomListAttributes: { __typename?: 'IntercomListAttributesSuccess', fields: Array<{ __typename?: 'IntercomAttribute', name: string, custom: boolean, data_type: string, api_writable: boolean }> } };

export type IterableColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type IterableColumnsQuery = { __typename?: 'query', iterableUserFields: { __typename: 'IterableUserFieldsSuccess', fields: Array<{ __typename?: 'IterableField', name: string, type: string, standardType: StandardFieldType }> } };

export type IterableCampaignsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type IterableCampaignsQuery = { __typename?: 'query', iterableGetCampaigns: { __typename: 'IterableGetCampaigns', campaigns: Array<{ __typename?: 'IterableCampaign', name: string, id: number }> } };

export type IterableTemplatesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type IterableTemplatesQuery = { __typename?: 'query', iterableGetTemplates: { __typename: 'IterableGetTemplates', templates: Array<{ __typename?: 'IterableTemplate', name: string, id: number }> } };

export type IterableGetCatalogsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type IterableGetCatalogsQuery = { __typename?: 'query', iterableGetCatalogs: Maybe<{ __typename: 'IterableGetCatalogs', catalogs: Array<{ __typename?: 'IterableCatalogs', name: string, id: string }> }> };

export type IterableCatalogFieldsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  catalogName?: Maybe<Scalars['String']>;
}>;


export type IterableCatalogFieldsQuery = { __typename?: 'query', iterableGetCatalogFields: Maybe<{ __typename: 'IterableGetCatalogFields', catalogFields: Maybe<Array<{ __typename?: 'IterableCatalogFields', name: string, id: string, iterableType: string, type: StandardFieldType }>> }> };

export type JiraIssueTypesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type JiraIssueTypesQuery = { __typename?: 'query', jiraGetIssueTypes: Maybe<{ __typename?: 'JiraGetIssueTypes', issueTypes: Array<{ __typename?: 'JiraIssueTypes', id: string, name: string }> }> };

export type JiraIssueFieldsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  projectId: Scalars['String'];
  issueType: Scalars['String'];
}>;


export type JiraIssueFieldsQuery = { __typename?: 'query', jiraGetIssueFields: Maybe<{ __typename?: 'JiraGetIssueFields', fields: Array<{ __typename?: 'JiraIssueFields', id: string, name: string, type: string, customFieldType: Maybe<string> }> }> };

export type JiraProjectsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type JiraProjectsQuery = { __typename?: 'query', jiraGetProjects: Maybe<{ __typename?: 'JiraGetProjects', projects: Array<{ __typename?: 'JiraProjects', id: string, name: string, type: string }> }> };

export type MarketoColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type MarketoColumnsQuery = { __typename?: 'query', marketoDescribeObject: { __typename?: 'MarketoDescribeObjectSuccess', fields: Array<{ __typename?: 'MarketoField', name: string, id: string, type: string, isID: boolean, isLookup: boolean, isUpdateable: boolean }> } };

export type MarketoAttributesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  activity: Scalars['String'];
}>;


export type MarketoAttributesQuery = { __typename?: 'query', marketoDescribeActivity: { __typename?: 'MarketoDescribeActivitySuccess', attributes: Array<{ __typename?: 'MarketoAttribute', name: string, id: string, type: string, isPrimary: boolean }> } };

export type MarketoActivitiesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type MarketoActivitiesQuery = { __typename?: 'query', marketoListActivities: { __typename?: 'MarketoListActivitiesSuccess', activities: Array<{ __typename?: 'MarketoActivity', name: string, id: string, activityTypeId: string }> } };

export type MarketoObjectsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type MarketoObjectsQuery = { __typename?: 'query', marketoListObjects: { __typename?: 'MarketoListObjectsSuccess', objects: Array<{ __typename?: 'MarketoObject', name: string, id: string }> } };

export type MixpanelLookupTablesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type MixpanelLookupTablesQuery = { __typename?: 'query', mixpanelGetLookupTables: Array<Maybe<any>> };

export type NotionDatabasesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type NotionDatabasesQuery = { __typename?: 'query', notionGetDatabases: Maybe<{ __typename?: 'NotionGetDatabases', entries: Array<{ __typename?: 'NotionDatabase', id: string, name: string, type: string }> }> };

export type NotionDatabasePropertiesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  databaseId: Scalars['String'];
}>;


export type NotionDatabasePropertiesQuery = { __typename?: 'query', notionGetDatabaseProperties: Maybe<{ __typename?: 'NotionGetDatabaseProperties', properties: Array<{ __typename?: 'NotionDatabaseProperty', id: string, name: string, type: string }> }> };

export type OrbitWorkspacesQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type OrbitWorkspacesQuery = { __typename?: 'query', orbitListWorkspaces: { __typename?: 'OrbitListWorkspaces', workspaces: Array<{ __typename?: 'OrbitWorkspace', name: string, path: string }> } };

export type PipedriveDomainsQueryVariables = Exact<{
  destId: Scalars['String'];
  apiKey: Scalars['String'];
}>;


export type PipedriveDomainsQuery = { __typename?: 'query', pipedriveListDomains: { __typename?: 'PipedriveListDomains', domains: Array<Maybe<{ __typename?: 'PipedriveDomains', label: string, value: string }>> } };

export type PostgresColumnsQueryVariables = Exact<{
  input: ListPostgresColumnsInput;
}>;


export type PostgresColumnsQuery = { __typename?: 'query', listPostgresColumns: Array<Maybe<{ __typename?: 'PostgresColumn', name: string }>> };

export type PostgresTablesQueryVariables = Exact<{
  input: ListPostgresTablesInput;
}>;


export type PostgresTablesQuery = { __typename?: 'query', listPostgresTables: Array<Maybe<{ __typename?: 'PostgresTable', name: string }>> };

export type SalesloftColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type SalesloftColumnsQuery = { __typename?: 'query', salesloftListCustomFields: { __typename?: 'SalesloftCustomFieldsSuccess', fields: Array<{ __typename?: 'SalesloftCustomFields', name: string, id: string, field_type: string, value_type: string, standardType: StandardFieldType }> } };

export type SendgridColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type SendgridColumnsQuery = { __typename?: 'query', sendGridContactSchema: { __typename?: 'SendGridContactSchemaSuccess', fields: Array<{ __typename?: 'SendGridContactField', name: string, id: string, isCustom: boolean }> } };

export type SfmcColumnsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type SfmcColumnsQuery = { __typename?: 'query', sfmcListAttributeSets: { __typename?: 'SfmcListAttributeSetsSuccess', fields: Array<{ __typename?: 'SfmcField', name: string, id: string, type: string, standardType: StandardFieldType }> } };

export type SfmcJourneysQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type SfmcJourneysQuery = { __typename?: 'query', sfmcListJourneys: { __typename?: 'SfmcListJourneysSuccess', journeys: Array<{ __typename?: 'SfmcJourney', name: string, id: string }> } };

export type SfmcDataExtensionsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  businessUnit?: Maybe<Scalars['String']>;
  dataFolder?: Maybe<Scalars['String']>;
}>;


export type SfmcDataExtensionsQuery = { __typename?: 'query', sfmcListDataExtensions: { __typename?: 'SfmcListDataExtensions', dataExtensions: Array<{ __typename?: 'SfmcDataExtension', name: string, id: string }> } };

export type SfmcDataExtensionFieldsQueryVariables = Exact<{
  destinationId: Scalars['String'];
  dataExtensionId: Scalars['String'];
  businessUnit?: Maybe<Scalars['String']>;
}>;


export type SfmcDataExtensionFieldsQuery = { __typename?: 'query', sfmcListDataExtensionFields: { __typename?: 'SfmcListDataExtensionFields', fields: Array<{ __typename?: 'SfmcDataExtensionField', name: string, id: string, type: string, standardType: StandardFieldType, isPrimaryKey: boolean, isRequired: boolean }> } };

export type SfmcBusinessUnitsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type SfmcBusinessUnitsQuery = { __typename?: 'query', sfmcListBusinessUnits: { __typename?: 'SfmcListBusinessUnits', businessUnits: Array<{ __typename?: 'SfmcBusinessUnit', name: string, id: string }> } };

export type SfmcDataFoldersQueryVariables = Exact<{
  destinationId: Scalars['String'];
  businessUnit?: Maybe<Scalars['String']>;
}>;


export type SfmcDataFoldersQuery = { __typename?: 'query', sfmcListDataFolders: { __typename?: 'SfmcListDataFolders', dataFolders: Array<{ __typename?: 'SfmcDataFolder', name: string, id: string }> } };

export type SlackDestinationChannelsQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type SlackDestinationChannelsQuery = { __typename?: 'query', slackListChannels: { __typename?: 'SlackListChannelsSuccess', channels: Array<{ __typename?: 'SlackChannel', name: string, id: string }> } };

export type SnapchatAdAccountsQueryVariables = Exact<{
  destId: Scalars['String'];
}>;


export type SnapchatAdAccountsQuery = { __typename?: 'query', snapchatListAdAccounts: { __typename?: 'SnapchatListAdAccounts', accounts: Array<{ __typename?: 'SnapchatEntity', id: string, name: string }> } };

export type SnapchatOrganizationsQueryVariables = Exact<{
  destId: Scalars['String'];
}>;


export type SnapchatOrganizationsQuery = { __typename?: 'query', snapchatListOrganizations: { __typename?: 'SnapchatListOrganizations', organizations: Array<{ __typename?: 'SnapchatEntity', id: string, name: string }> } };

export type TiktokAdvertisersQueryVariables = Exact<{
  destinationId: Scalars['String'];
}>;


export type TiktokAdvertisersQuery = { __typename?: 'query', tiktokListAdvertisers: Array<Maybe<any>> };

export type UserflowAttributesQueryVariables = Exact<{
  destinationId: Scalars['String'];
  object: Scalars['String'];
}>;


export type UserflowAttributesQuery = { __typename?: 'query', userflowGetAttributes: Maybe<{ __typename?: 'UserflowGetAttributes', attributes: Array<{ __typename?: 'UserflowAttributes', id: string, name: string, type: string, displayName: string }> }> };

export type AlertingCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type AlertingCredentialsQuery = { __typename?: 'query', slack_credentials: Array<{ __typename?: 'slack_credentials', id: number, state: string, channel_id: Maybe<string>, channel_name: Maybe<string> }>, pagerduty_credentials: Array<{ __typename?: 'pagerduty_credentials', id: number, state: string, config: any, api_key: Maybe<string> }> };

export type PagerDutyCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type PagerDutyCredentialsQuery = { __typename?: 'query', pagerduty_credentials: Array<{ __typename?: 'pagerduty_credentials', id: number, state: string, config: any, api_key: Maybe<string> }> };

export type SlackCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type SlackCredentialsQuery = { __typename?: 'query', slack_credentials: Array<{ __typename?: 'slack_credentials', id: number, state: string, channel_id: Maybe<string>, channel_name: Maybe<string> }> };

export type UpdateSlackCredentialsMutationVariables = Exact<{
  id: Scalars['Int'];
  object?: Maybe<SlackCredentialsSetInput>;
}>;


export type UpdateSlackCredentialsMutation = { __typename?: 'mutation', update_slack_credentials_by_pk: Maybe<{ __typename?: 'slack_credentials', id: number, state: string, channel_id: Maybe<string>, channel_name: Maybe<string> }> };

export type SlackChannelsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SlackChannelsQuery = { __typename?: 'query', listSlackChannelsByCredentials: Array<{ __typename?: 'SlackChannel', id: string, name: string }> };

export type UpdatePagerDutyCredentialsMutationVariables = Exact<{
  id: Scalars['Int'];
  object?: Maybe<PagerdutyCredentialsSetInput>;
}>;


export type UpdatePagerDutyCredentialsMutation = { __typename?: 'mutation', update_pagerduty_credentials_by_pk: Maybe<{ __typename?: 'pagerduty_credentials', id: number }> };

export type CreatePagerDutyCredentialsMutationVariables = Exact<{
  object: PagerdutyCredentialsInsertInput;
}>;


export type CreatePagerDutyCredentialsMutation = { __typename?: 'mutation', insert_pagerduty_credentials_one: Maybe<{ __typename?: 'pagerduty_credentials', id: number }> };

export type SlackCredentialsFragment = { __typename?: 'slack_credentials', id: number, state: string, channel_id: Maybe<string>, channel_name: Maybe<string> };

export type PagerDutyCredentialsFragment = { __typename?: 'pagerduty_credentials', id: number, state: string, config: any, api_key: Maybe<string> };

export type ExtensionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExtensionsQuery = { __typename?: 'query', alerting: Array<{ __typename?: 'alerts', id: any }>, monitoring: Array<{ __typename?: 'datadog_credentials', id: number }>, dbtCloud: Array<{ __typename?: 'dbt_credentials', id: number }>, dbtModels: Array<{ __typename?: 'dbt_sync_config', id: any }>, gitSync: Array<{ __typename?: 'git_sync_configs', enabled: boolean }>, looker: Array<{ __typename?: 'looker_credentials', id: number }> };

export type CreateFeedbackMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type CreateFeedbackMutation = { __typename?: 'mutation', createFeedback: Maybe<boolean> };

export type CreateFeatureRequestMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type CreateFeatureRequestMutation = { __typename?: 'mutation', createFeatureRequest: Maybe<boolean> };

export type CreateIntegrationRequestMutationVariables = Exact<{
  type: IntegrationRequestType;
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type CreateIntegrationRequestMutation = { __typename?: 'mutation', createIntegrationRequest: Maybe<boolean> };

export type FormkitSyncDefinitionQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type FormkitSyncDefinitionQuery = { __typename?: 'query', formkitSyncDefinition: any };

export type FormkitSyncHandlerQueryVariables = Exact<{
  handler: Scalars['String'];
  context: FormkitSyncContext;
  variables?: Maybe<Scalars['JSONObject']>;
}>;


export type FormkitSyncHandlerQuery = { __typename?: 'query', formkitSyncHandler: any };

export type FormkitSyncValidationQueryVariables = Exact<{
  type: Scalars['String'];
  context?: Maybe<Scalars['JSONObject']>;
  config: Scalars['JSONObject'];
}>;


export type FormkitSyncValidationQuery = { __typename?: 'query', formkitSyncValidation: Maybe<any> };

export type FormkitSourceDefinitionQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type FormkitSourceDefinitionQuery = { __typename?: 'query', formkitSourceDefinition: Array<{ __typename?: 'SourceMethod', key: string, form: Maybe<any>, method: string, label: Maybe<string>, url: Maybe<string>, provider: Maybe<string>, tunneling: Maybe<boolean> }> };

export type FormkitSourceHandlerQueryVariables = Exact<{
  handler: Scalars['String'];
  context: FormkitSourceContext;
  variables?: Maybe<Scalars['JSONObject']>;
}>;


export type FormkitSourceHandlerQuery = { __typename?: 'query', formkitSourceHandler: any };

export type FormkitSourceValidationQueryVariables = Exact<{
  type: Scalars['String'];
  context?: Maybe<Scalars['JSONObject']>;
  config: Scalars['JSONObject'];
}>;


export type FormkitSourceValidationQuery = { __typename?: 'query', formkitSourceValidation: Maybe<any> };

export type WorkspaceFragment = { __typename?: 'workspaces', id: any, name: string, domain: Maybe<string>, slug: Maybe<string>, region: string, feature_flags: any, is_approved: boolean, google_hosted_domain: Maybe<string>, visible_to: Maybe<any>, joinable_to: Maybe<any>, default_role_id: Maybe<any>, trial_ends_at: Maybe<any>, show_lock_popup: boolean, lock_popup_date: Maybe<any>, onboarding: Maybe<any> };

export type OrganizationFragment = { __typename?: 'organizations', name: string, id: any, slug: string, billing: Maybe<any> };

export type MembershipFragment = { __typename?: 'memberships', workspace_id: any, user_id: any, user: { __typename?: 'users', id: any, name: string, email: string, created_at: any }, role: Maybe<{ __typename?: 'roles', id: any }> };

export type UserFragment = { __typename?: 'User', email: string, id: number, name: string, avatar_json: Maybe<any>, current_workspace_id: Maybe<string>, not_member_of_current_workspace: Maybe<boolean>, is_admin: boolean };

export type SourceFragment = { __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> };

export type DestinationFragment = { __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any> };

export type DestinationDefinitionFragment = { __typename?: 'DestinationDefinition', name: string, type: string, status: string, icon: string, docs: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, features: Array<Maybe<string>>, oauthUrl: Maybe<string>, configurationForm: Maybe<Array<Maybe<any>>>, testConnection: boolean, configVersion: Maybe<number>, categories: Array<Maybe<{ __typename?: 'DestinationCategory', name: string, type: Maybe<string>, shortDescription: Maybe<string> }>> };

export type SourceDefinitionFragment = { __typename?: 'SourceDefinition', name: string, type: string, status: string, docs: string, icon: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, supportedQueries: Array<string>, supportsTunneling: boolean, supportsIpFiltering: boolean, supportsResultSchema: boolean, supportsInWarehouseDiffing: boolean, supportsCrossDbReference: boolean, disableTest: boolean, isSampleDataSource: boolean, sampleModels: Maybe<Array<Maybe<{ __typename?: 'SampleModel', name: string, sql: string }>>>, categories: Maybe<Array<Maybe<{ __typename?: 'SourceCategory', name: string, type: string, shortDescription: string }>>> };

export type AudienceParentFragment = { __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> };

export type QueryFieldsFragment = { __typename?: 'segments', query_type: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any> };

export type SegmentHistoryFragment = { __typename?: 'segments', created_at: Maybe<any>, updated_at: Maybe<any>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> };

export type SourceHistoryFragment = { __typename?: 'connections', created_at: any, updated_at: any, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> };

export type DestinationHistoryFragment = { __typename?: 'destinations', created_at: any, updated_at: Maybe<any>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> };

export type SyncHistoryFragment = { __typename?: 'syncs', created_at: Maybe<any>, updated_at: Maybe<any>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> };

export type ColumnFragment = { __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean };

export type ObjectColumnFragment = { __typename?: 'model_columns', trigger_top_k_sync: Maybe<boolean>, top_k_sync_interval: Maybe<number>, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, last_top_k_sync_timestamp: Maybe<any>, name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean };

export type SyncFragment = { __typename?: 'syncs', id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, config: any };

export type SyncAttemptFragment = { __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> };

export type SyncRequestFragment = { __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> };

export type WorkspaceAlertFragment = { __typename?: 'alerts', id: any, name: any, alert_interval: Maybe<any>, config: any, created_by: Maybe<any>, fatal_error_default: boolean, row_error_default: boolean, type: string, pagerduty_credential_id: Maybe<any>, slack_credential_id: Maybe<any> };

export type AlertInstanceFragment = { __typename?: 'alert_instances', fatal_error: Maybe<boolean>, row_error: Maybe<boolean>, id: any };

export type SyncAlertFragment = { __typename?: 'sync_alerts', id: Maybe<any>, fatal_error: Maybe<boolean>, row_error: Maybe<boolean> };

export type AlertStatusFragment = { __typename?: 'alert_statuses', last_attempted: any, destination_instance_id: any, error: Maybe<any> };

export type ExternalBucketFragment = { __typename?: 'external_buckets', type: string, config: any, credential_id: Maybe<number>, created_at: any, updated_at: any };

export type ApiKeyFragment = { __typename?: 'api_keys', id: any, name: Maybe<string>, last_used: Maybe<any>, created_at: any };

export type AttemptedRowFragment = { __typename?: 'AttemptedRow', id: string, opType: SyncOp, rejected: boolean, fields: string, rejectionReason: Maybe<string>, batchId: Maybe<string>, batchRequestInfoKey: Maybe<string>, requestInfoKeys: Maybe<Array<Maybe<string>>>, isBatchError: Maybe<boolean>, error: Maybe<any> };

export type OutboundUserInviteFragment = { __typename?: 'outbound_user_invites', workspace_id: any, recipient_email: string, expires_at: any, created_by: any, role_id: Maybe<number> };

export type RoleFragment = { __typename?: 'roles', id: any, name: string, permissions: Maybe<any> };

export type FilterableColumnFragment = { __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string };

export type SyncableColumnFragment = { __typename?: 'SyncableColumn', column_reference: any, model_name: string, name: string };

export type RelationshipFragment = { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> };

export type TraitDefinitionFragment = { __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } };

export type GitCredentialsFragment = { __typename?: 'git_credentials', id: any, workspace_id: any, tunnel_id: Maybe<any>, username: Maybe<string>, credentials: Maybe<any>, type: string };

export type GitSyncConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GitSyncConfigsQuery = { __typename?: 'query', git_sync_configs: Array<{ __typename?: 'git_sync_configs', id: any, workspace_id: any, path: Maybe<string>, full_resync: Maybe<boolean>, git_credential_id: any, outbound_error: Maybe<any>, inbound_error: Maybe<any>, repository: string, branch: string, enabled: boolean, last_attempted_at: Maybe<any>, git_credential: { __typename?: 'git_credentials', id: any, workspace_id: any, tunnel_id: Maybe<any>, username: Maybe<string>, credentials: Maybe<any>, type: string }, git_inbound_runs: Array<{ __typename?: 'git_inbound_runs', id: any, created_at: any, commit: Maybe<string>, affected_resources: Maybe<any> }>, git_outbound_runs: Array<{ __typename?: 'git_outbound_runs', id: any, created_at: any, changelog_id: Maybe<any>, commits: Maybe<any> }> }> };

export type UpdateGitSyncConfigsMutationVariables = Exact<{
  id: Scalars['bigint'];
  object?: Maybe<GitSyncConfigsSetInput>;
}>;


export type UpdateGitSyncConfigsMutation = { __typename?: 'mutation', update_git_sync_configs_by_pk: Maybe<{ __typename?: 'git_sync_configs', id: any, workspace_id: any, path: Maybe<string>, git_credential_id: any, repository: string, branch: string, enabled: boolean, last_attempted_at: Maybe<any> }> };

export type CreateGitSyncConfigsMutationVariables = Exact<{
  object: GitSyncConfigsInsertInput;
}>;


export type CreateGitSyncConfigsMutation = { __typename?: 'mutation', insert_git_sync_configs_one: Maybe<{ __typename?: 'git_sync_configs', id: any, workspace_id: any, path: Maybe<string>, git_credential_id: any, repository: string, branch: string, enabled: boolean, last_attempted_at: Maybe<any> }> };

export type GitSyncConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GitSyncConfigQuery = { __typename?: 'query', git_sync_config: Array<{ __typename?: 'git_sync_config', id: number, workspace_id: number, username: string, password: string, schema: Maybe<string>, repository: string, bidi: boolean, bidi_metadata: Maybe<any> }> };

export type GitSyncAttemptsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GitSyncAttemptsQuery = { __typename?: 'query', git_sync_attempts: Array<{ __typename?: 'git_sync_attempts', created_at: any, error: Maybe<any>, state: string, type: string }>, git_sync_attempts_aggregate: { __typename?: 'git_sync_attempts_aggregate', aggregate: Maybe<{ __typename?: 'git_sync_attempts_aggregate_fields', count: number }> } };

export type GitSyncAttemptsByIdQueryVariables = Exact<{
  syncId: Scalars['jsonb'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GitSyncAttemptsByIdQuery = { __typename?: 'query', git_sync_attempts: Array<{ __typename?: 'git_sync_attempts', created_at: any, error: Maybe<any>, state: string, type: string }>, git_sync_attempts_aggregate: { __typename?: 'git_sync_attempts_aggregate', aggregate: Maybe<{ __typename?: 'git_sync_attempts_aggregate_fields', count: number }> } };

export type CreateGitSyncConfigMutationVariables = Exact<{
  config: GitSyncConfigInsertInput;
}>;


export type CreateGitSyncConfigMutation = { __typename?: 'mutation', insert_git_sync_config_one: Maybe<{ __typename?: 'git_sync_config', id: number, workspace_id: number, username: string, password: string, schema: Maybe<string>, repository: string, bidi: boolean, bidi_metadata: Maybe<any> }> };

export type UpdateGitSyncConfigMutationVariables = Exact<{
  id: Scalars['Int'];
  config: GitSyncConfigSetInput;
}>;


export type UpdateGitSyncConfigMutation = { __typename?: 'mutation', update_git_sync_config_by_pk: Maybe<{ __typename?: 'git_sync_config', id: number, workspace_id: number, username: string, password: string, schema: Maybe<string>, repository: string }> };

export type GitCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GitCredentialsQuery = { __typename?: 'query', git_credentials: Array<{ __typename?: 'git_credentials', id: any, workspace_id: any, tunnel_id: Maybe<any>, username: Maybe<string>, credentials: Maybe<any>, type: string }> };

export type GithubRepositoriesQueryVariables = Exact<{
  credentialId: Scalars['String'];
}>;


export type GithubRepositoriesQuery = { __typename?: 'query', getGithubRepositories: Array<{ __typename?: 'GithubRepository', fullName: string, htmlUrl: string }> };

export type GithubBranchesQueryVariables = Exact<{
  credentialId: Scalars['String'];
  repo: Scalars['String'];
}>;


export type GithubBranchesQuery = { __typename?: 'query', getGithubBranches: Array<{ __typename?: 'GithubBranch', name: string }> };

export type CreateGitCredentialsMutationVariables = Exact<{
  credentials: GitCredentialsInsertInput;
}>;


export type CreateGitCredentialsMutation = { __typename?: 'mutation', insert_git_credentials_one: Maybe<{ __typename?: 'git_credentials', id: any, workspace_id: any, tunnel_id: Maybe<any>, username: Maybe<string>, credentials: Maybe<any>, type: string }> };

export type UpdateGitCredentialsMutationVariables = Exact<{
  id: Scalars['bigint'];
  credentials: GitCredentialsSetInput;
}>;


export type UpdateGitCredentialsMutation = { __typename?: 'mutation', update_git_credentials_by_pk: Maybe<{ __typename?: 'git_credentials', id: any, workspace_id: any, tunnel_id: Maybe<any>, username: Maybe<string>, credentials: Maybe<any>, type: string }> };

export type GoogleSheetsSourceSpreadSheetsQueryVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type GoogleSheetsSourceSpreadSheetsQuery = { __typename?: 'query', googlesheetsListSpreadSheets: Array<{ __typename?: 'GooglesheetsSpreadSheet', id: string, name: string, webViewLink: string }> };

export type ResourceLabelsQueryVariables = Exact<{
  resource: Scalars['String'];
}>;


export type ResourceLabelsQuery = { __typename?: 'query', resource_tag_values: Array<{ __typename?: 'resource_tag_values', key: Maybe<string>, values: Maybe<any> }> };

export type LookerCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type LookerCredentialsQuery = { __typename?: 'query', looker_credentials: Array<{ __typename?: 'looker_credentials', id: number, tunnel_id: Maybe<any>, url: Maybe<string>, client_id: string, client_secret: string }> };

export type CreateLookerCredentialMutationVariables = Exact<{
  credentials: LookerCredentialsInsertInput;
}>;


export type CreateLookerCredentialMutation = { __typename?: 'mutation', insert_looker_credentials_one: Maybe<{ __typename?: 'looker_credentials', id: number }> };

export type UpdateLookerCredentialMutationVariables = Exact<{
  id: Scalars['Int'];
  credentials: LookerCredentialsSetInput;
}>;


export type UpdateLookerCredentialMutation = { __typename?: 'mutation', update_looker_credentials_by_pk: Maybe<{ __typename?: 'looker_credentials', id: number, tunnel_id: Maybe<any>, url: Maybe<string>, client_id: string, client_secret: string }> };

export type SearchLookerLooksQueryVariables = Exact<{
  title?: Maybe<Scalars['String']>;
  sorts?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type SearchLookerLooksQuery = { __typename?: 'query', searchLookerLooks: Maybe<{ __typename?: 'SearchLookerLooksOutput', looks: Array<{ __typename?: 'LookerLook', id: string, title: string, description: Maybe<string> }> }> };

export type GetLookerLookQueryVariables = Exact<{
  id: Scalars['String'];
  withSql: Scalars['Boolean'];
}>;


export type GetLookerLookQuery = { __typename?: 'query', getLookerLook: Maybe<{ __typename?: 'GetLookerLookOutput', look: { __typename?: 'LookerLook', id: string, title: string, description: Maybe<string>, sql: Maybe<string> } }> };

export type ModelsQueryVariables = Exact<{
  filters?: Maybe<SegmentsBoolExp>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: SegmentsOrderBy;
}>;


export type ModelsQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, tags: any, query_type: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any>, created_at: Maybe<any>, updated_at: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, query_runs: Array<{ __typename?: 'query_runs', size: number }>, syncs: Array<{ __typename?: 'syncs', id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, config: any, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any>, definition: { __typename?: 'DestinationDefinition', icon: string, name: string } }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }>, segments_aggregate: { __typename?: 'segments_aggregate', aggregate: Maybe<{ __typename?: 'segments_aggregate_fields', count: number }> } };

export type ModelQueryVariables = Exact<{
  id: Scalars['bigint'];
  columnsOrderBy?: ModelColumnsOrderBy;
  syncsOrderBy?: SyncsOrderBy;
}>;


export type ModelQuery = { __typename?: 'query', segments_by_pk: Maybe<{ __typename?: 'segments', id: any, name: string, primary_key: Maybe<string>, slug: Maybe<string>, tags: any, query_type: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any>, created_at: Maybe<any>, updated_at: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, syncable_columns: Array<{ __typename?: 'SyncableColumn', column_reference: any, model_name: string, name: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, syncs: Array<{ __typename?: 'syncs', row_threshold_attempted: Maybe<any>, row_threshold_total: Maybe<any>, id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, created_at: Maybe<any>, updated_at: Maybe<any>, config: any, sync_alerts: Array<{ __typename?: 'sync_alerts', id: Maybe<any>, fatal_error: Maybe<boolean>, row_error: Maybe<boolean> }>, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any>, definition: { __typename?: 'DestinationDefinition', icon: string, name: string } }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type ModelsAndAudiencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelsAndAudiencesQuery = { __typename?: 'query', segments: Array<{ __typename?: 'segments', id: any, name: string, slug: Maybe<string>, query_type: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, parent: Maybe<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> }> }> };

export type CreateModelMutationVariables = Exact<{
  input: SegmentsInsertInput;
}>;


export type CreateModelMutation = { __typename?: 'mutation', insert_segments_one: Maybe<{ __typename?: 'segments', id: any }> };

export type UpdateModelMutationVariables = Exact<{
  id: Scalars['bigint'];
  input: SegmentsSetInput;
}>;


export type UpdateModelMutation = { __typename?: 'mutation', update_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }> };

export type DeleteModelMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteModelMutation = { __typename?: 'mutation', delete_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }> };

export type DeleteModelsMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteModelsMutation = { __typename?: 'mutation', delete_segments: Maybe<{ __typename?: 'segments_mutation_response', affected_rows: number }> };

export type Auth0ConnectionsByOrganizationQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type Auth0ConnectionsByOrganizationQuery = { __typename?: 'query', getAuth0ConnectionsByOrganization: { __typename?: 'GetAuth0ConnectionsByOrganizationResult', auth0Connections: Array<{ __typename?: 'Auth0Connection', name: string, id: number, auth0_id: string }> } };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'query', getOrganization: Maybe<{ __typename?: 'Organization', name: string, id: number, slug: string }> };

export type BillingOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingOrganizationQuery = { __typename?: 'query', getBillingOrganization: Maybe<{ __typename?: 'BillingOrganization', name: string, id: number, slug: string, billing: Maybe<any>, entitlements: Maybe<any>, plan: Maybe<{ __typename?: 'Plan', name: string, sku: string, entitlements: Maybe<any> }> }> };

export type OrganizationMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationMetricsQuery = { __typename?: 'query', getOrganizationMetrics: { __typename?: 'MetricsResult', metrics: Array<{ __typename?: 'MetricsRowResult', id: string, name: string, slug: Maybe<string>, created_at: string, destinations: Maybe<number>, connections: Maybe<number>, models: Maybe<number>, audiences: Maybe<number>, syncs: Maybe<number> }>, roles: Array<{ __typename?: 'RolesResult', workspace_id: string, name: string, count: Maybe<number> }> } };

export type OrganizationDestinationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationDestinationTypesQuery = { __typename?: 'query', getOrganizationDestinationTypes: Array<Maybe<{ __typename?: 'DestinationTypesResult', type: string, count: number }>> };

export type IsOrganizationSlugAvailableQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type IsOrganizationSlugAvailableQuery = { __typename?: 'query', isOrganizationAvailable: boolean };

export type PartnerConnectionFragment = { __typename?: 'PartnerConnection', uuid: string, type: string, partnerName: string, partnerLogo: string, resources: Maybe<Array<Maybe<string>>>, userIsLinked: boolean, workspaceId: Maybe<number>, defaultWorkspaceName: Maybe<string> };

export type PartnerConnectGetConnectionQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PartnerConnectGetConnectionQuery = { __typename?: 'query', partnerConnectGetConnection: Maybe<{ __typename?: 'PartnerConnection', uuid: string, type: string, partnerName: string, partnerLogo: string, resources: Maybe<Array<Maybe<string>>>, userIsLinked: boolean, workspaceId: Maybe<number>, defaultWorkspaceName: Maybe<string> }> };

export type PartnerConnectGetInformationQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PartnerConnectGetInformationQuery = { __typename?: 'query', partnerConnectGetInformation: Maybe<{ __typename?: 'PartnerInformation', type: string, partnerName: string, partnerLogo: string, resources: Maybe<Array<Maybe<string>>> }> };

export type PartnerConnectListAvailableWorkspacesQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PartnerConnectListAvailableWorkspacesQuery = { __typename?: 'query', partnerConnectListAvailableWorkspaces: Maybe<Array<Maybe<{ __typename?: 'PartnerAvailableWorkspace', id: number, slug: string, name: string }>>> };

export type PartnerConnectLinkWorkspaceMutationVariables = Exact<{
  uuid: Scalars['String'];
  workspaceId: Scalars['Int'];
}>;


export type PartnerConnectLinkWorkspaceMutation = { __typename?: 'mutation', partnerConnectLinkWorkspace: Maybe<any> };

export type PartnerConnectLinkNewWorkspaceMutationVariables = Exact<{
  uuid: Scalars['String'];
  slug: Scalars['String'];
  name: Scalars['String'];
}>;


export type PartnerConnectLinkNewWorkspaceMutation = { __typename?: 'mutation', partnerConnectLinkNewWorkspace: number };

export type PermissionsQueryVariables = Exact<{
  filters?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type PermissionsQuery = { __typename?: 'query', getCurrentPermissions: Maybe<Array<{ __typename?: 'ResourcePermission', resource: ResourceToPermission, grants: Maybe<Array<ResourcePermissionGrant>>, resource_id: Maybe<string> }>> };

export type SuccessfulQueryResponseFieldsFragment = { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> };

export type FailedQueryResponseFieldsFragment = { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> };

type QueryResponseFieldsFailedQueryResponseFragment = { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> };

type QueryResponseFieldsSuccessfulQueryResponseFragment = { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> };

export type QueryResponseFieldsFragment = QueryResponseFieldsFailedQueryResponseFragment | QueryResponseFieldsSuccessfulQueryResponseFragment;

export type RunSqlQueryVariables = Exact<{
  sourceId: Scalars['String'];
  sql: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  modelId?: Maybe<Scalars['Int']>;
}>;


export type RunSqlQuery = { __typename?: 'query', rawSqlQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type RunDbtQueryVariables = Exact<{
  sourceId: Scalars['String'];
  dbtModelId: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  modelId?: Maybe<Scalars['Int']>;
}>;


export type RunDbtQuery = { __typename?: 'query', dbtQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type RunDbtModelQueryVariables = Exact<{
  sourceId: Scalars['String'];
  dbtModelId: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  modelId?: Maybe<Scalars['Int']>;
}>;


export type RunDbtModelQuery = { __typename?: 'query', dbtModelQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type RunLookerLookQueryVariables = Exact<{
  sourceId: Scalars['String'];
  lookId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  modelId?: Maybe<Scalars['Int']>;
}>;


export type RunLookerLookQuery = { __typename?: 'query', lookerLookQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type RunTableQueryVariables = Exact<{
  sourceId: Scalars['String'];
  table: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
  modelId?: Maybe<Scalars['Int']>;
}>;


export type RunTableQuery = { __typename?: 'query', tableQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type RunVisualQueryVariables = Exact<{
  sourceId: Scalars['String'];
  parentModelId: Scalars['String'];
  filter: Scalars['JSONObject'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
}>;


export type RunVisualQuery = { __typename?: 'query', visualQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type RunCustomQueryVariables = Exact<{
  sourceId: Scalars['String'];
  customQuery: Scalars['JSONObject'];
  limit?: Maybe<Scalars['Int']>;
  disableRowCounter?: Maybe<Scalars['Boolean']>;
}>;


export type RunCustomQuery = { __typename?: 'query', customQuery: { __typename: 'FailedQueryResponse', error: string, metadata: Maybe<any>, sql: Maybe<string> } | { __typename: 'SuccessfulQueryResponse', rows: Array<any>, exceedsPreviewMax: boolean, numRowsWithoutLimit: Maybe<number>, sql: Maybe<string>, columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type PreviewQuerySchemaQueryVariables = Exact<{
  sourceId: Scalars['String'];
  queryType: Scalars['String'];
  query: Scalars['JSONObject'];
}>;


export type PreviewQuerySchemaQuery = { __typename?: 'query', previewQuerySchema: { __typename?: 'ColumnResponse', columns: Array<{ __typename?: 'QueryColumn', name: string, type: string }> } };

export type UpdateQueryMutationVariables = Exact<{
  id: Scalars['bigint'];
  model: SegmentsSetInput;
  columns: Array<ModelColumnsInsertInput> | ModelColumnsInsertInput;
}>;


export type UpdateQueryMutation = { __typename?: 'mutation', update_segments_by_pk: Maybe<{ __typename?: 'segments', id: any }>, insert_model_columns: Maybe<{ __typename?: 'model_columns_mutation_response', affected_rows: number }> };

export type RelationshipsQueryVariables = Exact<{
  modelId: Scalars['bigint'];
}>;


export type RelationshipsQuery = { __typename?: 'query', segments_by_pk: Maybe<{ __typename?: 'segments', relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string } }> }> };

export type AddRelationshipMutationVariables = Exact<{
  object: ModelRelationshipsInsertInput;
}>;


export type AddRelationshipMutation = { __typename?: 'mutation', insert_model_relationships_one: Maybe<{ __typename?: 'model_relationships', id: any }> };

export type UpdateDirectRelationshipMutationVariables = Exact<{
  id: Scalars['bigint'];
  object: ModelRelationshipsSetInput;
  directRelationships: Array<DirectModelRelationshipsInsertInput> | DirectModelRelationshipsInsertInput;
}>;


export type UpdateDirectRelationshipMutation = { __typename?: 'mutation', delete_direct_model_relationships: Maybe<{ __typename?: 'direct_model_relationships_mutation_response', affected_rows: number }>, update_model_relationships_by_pk: Maybe<{ __typename?: 'model_relationships', id: any }>, insert_direct_model_relationships: Maybe<{ __typename?: 'direct_model_relationships_mutation_response', affected_rows: number }> };

export type UpdateThroughRelationshipMutationVariables = Exact<{
  id: Scalars['bigint'];
  object: ModelRelationshipsSetInput;
  throughRelationships: Array<ThroughModelRelationshipsInsertInput> | ThroughModelRelationshipsInsertInput;
}>;


export type UpdateThroughRelationshipMutation = { __typename?: 'mutation', delete_through_model_relationships: Maybe<{ __typename?: 'through_model_relationships_mutation_response', affected_rows: number }>, update_model_relationships_by_pk: Maybe<{ __typename?: 'model_relationships', id: any }>, insert_through_model_relationships: Maybe<{ __typename?: 'through_model_relationships_mutation_response', affected_rows: number }> };

export type RelationshipDependenciesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RelationshipDependenciesQuery = { __typename?: 'query', listRelationshipDependencies: any };

export type DeleteRelationshipMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteRelationshipMutation = { __typename?: 'mutation', delete_model_relationships_by_pk: Maybe<{ __typename?: 'model_relationships', id: any }> };

export type IsResourceSlugAvailableQueryVariables = Exact<{
  slug: Scalars['String'];
  resourceType: Scalars['String'];
}>;


export type IsResourceSlugAvailableQuery = { __typename?: 'query', isResourceSlugAvailable: boolean };

export type SourcesQueryVariables = Exact<{
  filters?: Maybe<ConnectionsBoolExp>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: ConnectionsOrderBy;
}>;


export type SourcesQuery = { __typename?: 'query', connections: Array<{ __typename?: 'connections', setup_complete: boolean, tags: any, credential_id: Maybe<any>, sample_data_source_id: Maybe<any>, id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, created_at: any, updated_at: any, tunnel: Maybe<{ __typename?: 'tunnels', name: string, id: any }>, default_workspaces: Array<{ __typename?: 'workspaces', id: any }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type SourceQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type SourceQuery = { __typename?: 'query', connections_by_pk: Maybe<{ __typename?: 'connections', slug: Maybe<string>, setup_complete: boolean, plan_in_warehouse: boolean, plan_in_warehouse_config: Maybe<any>, autorun: Maybe<boolean>, credential_id: Maybe<any>, sample_data_source_id: Maybe<any>, tags: any, id: any, name: string, type: string, is_demo: Maybe<boolean>, created_at: any, updated_at: any, tunnel: Maybe<{ __typename?: 'tunnels', name: string, id: any }>, default_workspaces: Array<{ __typename?: 'workspaces', id: any }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type SourceObjectDefinitionsQueryVariables = Exact<{
  sourceId: Scalars['bigint'];
}>;


export type SourceObjectDefinitionsQuery = { __typename?: 'query', object_definitions: Array<{ __typename?: 'object_definitions', name: string, object_definition_group: Maybe<{ __typename?: 'object_definition_groups', name: string }>, object_schemas: Array<{ __typename?: 'object_schemas', key: string, type: string }> }> };

export type SourceDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SourceDefinitionsQuery = { __typename?: 'query', getSourceDefinitions: Array<{ __typename?: 'SourceDefinition', name: string, type: string, status: string, docs: string, icon: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, supportedQueries: Array<string>, supportsTunneling: boolean, supportsIpFiltering: boolean, supportsResultSchema: boolean, supportsInWarehouseDiffing: boolean, supportsCrossDbReference: boolean, disableTest: boolean, isSampleDataSource: boolean, sampleModels: Maybe<Array<Maybe<{ __typename?: 'SampleModel', name: string, sql: string }>>>, categories: Maybe<Array<Maybe<{ __typename?: 'SourceCategory', name: string, type: string, shortDescription: string }>>> }> };

export type SampleDataSourceDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SampleDataSourceDefinitionsQuery = { __typename?: 'query', getSampleDataSourceDefinitions: Array<{ __typename?: 'SourceDefinition', name: string, type: string, status: string, docs: string, icon: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, supportedQueries: Array<string>, supportsTunneling: boolean, supportsIpFiltering: boolean, supportsResultSchema: boolean, supportsInWarehouseDiffing: boolean, supportsCrossDbReference: boolean, disableTest: boolean, isSampleDataSource: boolean, sampleModels: Maybe<Array<Maybe<{ __typename?: 'SampleModel', name: string, sql: string }>>>, categories: Maybe<Array<Maybe<{ __typename?: 'SourceCategory', name: string, type: string, shortDescription: string }>>> }> };

export type SourceDefinitionQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type SourceDefinitionQuery = { __typename?: 'query', getSourceDefinition: { __typename?: 'SourceDefinition', name: string, type: string, status: string, docs: string, icon: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, supportedQueries: Array<string>, supportsTunneling: boolean, supportsIpFiltering: boolean, supportsResultSchema: boolean, supportsInWarehouseDiffing: boolean, supportsCrossDbReference: boolean, disableTest: boolean, isSampleDataSource: boolean, sampleModels: Maybe<Array<Maybe<{ __typename?: 'SampleModel', name: string, sql: string }>>>, categories: Maybe<Array<Maybe<{ __typename?: 'SourceCategory', name: string, type: string, shortDescription: string }>>> } };

export type SampleDataSourceDefinitionQueryVariables = Exact<{
  sampleDataSourceId: Scalars['String'];
}>;


export type SampleDataSourceDefinitionQuery = { __typename?: 'query', getSampleDataSourceDefinition: { __typename?: 'SourceDefinition', name: string, type: string, status: string, docs: string, icon: string, shortPitch: string, longPitch: string, releasedAt: Maybe<string>, updatedAt: Maybe<string>, supportedQueries: Array<string>, supportsTunneling: boolean, supportsIpFiltering: boolean, supportsResultSchema: boolean, supportsInWarehouseDiffing: boolean, supportsCrossDbReference: boolean, disableTest: boolean, isSampleDataSource: boolean, sampleModels: Maybe<Array<Maybe<{ __typename?: 'SampleModel', name: string, sql: string }>>>, categories: Maybe<Array<Maybe<{ __typename?: 'SourceCategory', name: string, type: string, shortDescription: string }>>> } };

export type SourceStrippedConfigurationQueryVariables = Exact<{
  connectionId: Scalars['bigint'];
}>;


export type SourceStrippedConfigurationQuery = { __typename?: 'query', getSourceStrippedConfiguration: any };

export type UpdateSourceMutationVariables = Exact<{
  id: Scalars['bigint'];
  set: ConnectionsSetInput;
  append: ConnectionsAppendInput;
}>;


export type UpdateSourceMutation = { __typename?: 'mutation', update_connections_by_pk: Maybe<{ __typename?: 'connections', id: any }> };

export type CreateSourceMutationVariables = Exact<{
  object: ConnectionsInsertInput;
}>;


export type CreateSourceMutation = { __typename?: 'mutation', insert_connections_one: Maybe<{ __typename?: 'connections', id: any }> };

export type DiscoverSourceMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type DiscoverSourceMutation = { __typename?: 'mutation', discover: Maybe<boolean> };

export type SetupWarehousePlanningMutationVariables = Exact<{
  id: Scalars['String'];
  plannerDatabase?: Maybe<Scalars['String']>;
}>;


export type SetupWarehousePlanningMutation = { __typename?: 'mutation', setupInWarehouseDiffingForSource: { __typename?: 'SetupInWarehouseDiffingForSourceOutput', ignored: Maybe<boolean> } };

export type SetupWarehousePlanningWithCredentialsMutationVariables = Exact<{
  type: Scalars['String'];
  tunnelId?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['Int']>;
  config: Scalars['String'];
  plannerDatabase?: Maybe<Scalars['String']>;
}>;


export type SetupWarehousePlanningWithCredentialsMutation = { __typename?: 'mutation', setupInWarehouseDiffingWithCredentials: { __typename?: 'SetupInWarehouseDiffingWithCredentialsOutput', ignored: Maybe<boolean> } };

export type ListAllSourceDependenciesQueryVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type ListAllSourceDependenciesQuery = { __typename?: 'query', listAllSourceDependencies: { __typename?: 'ListAllSourceDependenciesResult', sources: Array<Maybe<{ __typename?: 'ListAllSourceDependenciesResultObject', id: string, dependencies: { __typename?: 'ListSourceDependenciesResult', audiences: Array<Maybe<{ __typename?: 'SourceAudienceDependencyReference', id: string, name: string }>>, models: Array<Maybe<{ __typename?: 'SourceModelDependencyReference', id: string, name: string, modelType: string, modelSourceType: string }>>, syncs: Array<Maybe<{ __typename?: 'SourceSyncDependencyReference', id: string, slug: string, modelName: string, modelType: string, destinationName: string, destinationType: string }>> } }>> } };

export type DeleteSourceMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteSourceMutation = { __typename?: 'mutation', delete_connections_by_pk: Maybe<{ __typename?: 'connections', id: any }> };

export type DeleteSourcesMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteSourcesMutation = { __typename?: 'mutation', delete_connections: Maybe<{ __typename?: 'connections_mutation_response', affected_rows: number }> };

export type TestNewSourceMutationVariables = Exact<{
  type: Scalars['String'];
  configuration: Scalars['JSONObject'];
  tunnelId?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['Int']>;
}>;


export type TestNewSourceMutation = { __typename?: 'mutation', testNewSource: Maybe<{ __typename?: 'SourceTestResult', success: boolean, reason: Maybe<string>, metadata: Maybe<any> }> };

export type TestUpdatedSourceMutationVariables = Exact<{
  sourceId: Scalars['String'];
  newConfiguration: Scalars['JSONObject'];
  tunnelId?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['Int']>;
}>;


export type TestUpdatedSourceMutation = { __typename?: 'mutation', testUpdatedSource: Maybe<{ __typename?: 'SourceTestResult', success: boolean, reason: Maybe<string>, metadata: Maybe<any> }> };

export type AirtableListBasesQueryVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type AirtableListBasesQuery = { __typename?: 'query', airtableListBases: Maybe<Array<Maybe<any>>> };

export type AirtableListTablesQueryVariables = Exact<{
  connectionId: Scalars['String'];
  baseId: Scalars['String'];
}>;


export type AirtableListTablesQuery = { __typename?: 'query', airtableListTables: Maybe<Array<Maybe<any>>> };

export type GooglesheetsSourceListSheetsQueryVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type GooglesheetsSourceListSheetsQuery = { __typename?: 'query', googlesheetsSourceListSheets: Maybe<Array<Maybe<string>>> };

export type MetabaseListDatabasesQueryVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type MetabaseListDatabasesQuery = { __typename?: 'query', metabaseListDatabases: Maybe<Array<Maybe<any>>> };

export type MetabaseListQuestionsQueryVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type MetabaseListQuestionsQuery = { __typename?: 'query', metabaseListQuestions: Maybe<Array<Maybe<any>>> };

export type MetabaseListTablesQueryVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type MetabaseListTablesQuery = { __typename?: 'query', metabaseListTables: Maybe<Array<Maybe<any>>> };

export type MixpanelListProjectsQueryVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type MixpanelListProjectsQuery = { __typename?: 'query', mixpanelListProjects: Maybe<Array<Maybe<any>>> };

export type MixpanelListCohortsQueryVariables = Exact<{
  connectionId: Scalars['String'];
  projectId: Scalars['Int'];
}>;


export type MixpanelListCohortsQuery = { __typename?: 'query', mixpanelListCohorts: Maybe<Array<Maybe<any>>> };

export type ExternalBucketsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalBucketsQuery = { __typename?: 'query', external_buckets: Array<{ __typename?: 'external_buckets', type: string, config: any, credential_id: Maybe<number>, created_at: any, updated_at: any, cloud_credential: Maybe<{ __typename?: 'cloud_credentials', id: any, name: string, provider: string, stripped_config: Maybe<any> }> }> };

export type CreateExternalBucketMutationVariables = Exact<{
  object: ExternalBucketsInsertInput;
}>;


export type CreateExternalBucketMutation = { __typename?: 'mutation', insert_external_buckets_one: Maybe<{ __typename?: 'external_buckets', workspace_id: any, config: any, credential_id: Maybe<number> }> };

export type UpdateExternalBucketMutationVariables = Exact<{
  workspaceId: Scalars['bigint'];
  set: ExternalBucketsSetInput;
  append: ExternalBucketsAppendInput;
}>;


export type UpdateExternalBucketMutation = { __typename?: 'mutation', update_external_buckets_by_pk: Maybe<{ __typename?: 'external_buckets', workspace_id: any }> };

export type TestStorageQueryVariables = Exact<{
  type?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['Int']>;
}>;


export type TestStorageQuery = { __typename?: 'query', testStorageConnection: Maybe<boolean> };

export type SyncsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filters?: Maybe<SyncsBoolExp>;
  orderBy?: SyncsOrderBy;
}>;


export type SyncsQuery = { __typename?: 'query', syncs: Array<{ __typename?: 'syncs', tags: Maybe<any>, id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, created_at: Maybe<any>, updated_at: Maybe<any>, config: any, segment: Maybe<{ __typename?: 'segments', id: any, name: string, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }> }>, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any>, definition: { __typename?: 'DestinationDefinition', icon: string, name: string } }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }>, syncs_aggregate: { __typename?: 'syncs_aggregate', aggregate: Maybe<{ __typename?: 'syncs_aggregate_fields', count: number }> } };

export type SyncQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type SyncQuery = { __typename?: 'query', syncs: Array<{ __typename?: 'syncs', slug: Maybe<string>, row_threshold_attempted: Maybe<any>, row_threshold_total: Maybe<any>, sync_template_id: Maybe<number>, tags: Maybe<any>, warehouse_history_config: Maybe<any>, id: Maybe<any>, status: Maybe<string>, schedule: Maybe<any>, schedule_paused: Maybe<boolean>, created_at: Maybe<any>, updated_at: Maybe<any>, config: any, segment: Maybe<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, git_sync_metadata: Maybe<any>, primary_key: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, syncable_columns: Array<{ __typename?: 'SyncableColumn', column_reference: any, model_name: string, name: string }>, parent: Maybe<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> }> }>, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any> }>, sync_alerts: Array<{ __typename?: 'sync_alerts', id: Maybe<any>, fatal_error: Maybe<boolean>, row_error: Maybe<boolean> }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }>, created_by_user: Maybe<{ __typename?: 'users', name: string }>, updated_by_user: Maybe<{ __typename?: 'users', name: string }> }> };

export type SyncsByTemplateIdQueryVariables = Exact<{
  templateId: Scalars['Int'];
}>;


export type SyncsByTemplateIdQuery = { __typename?: 'query', syncs: Array<{ __typename?: 'syncs', id: Maybe<any>, segment: Maybe<{ __typename?: 'segments', id: any, name: string }>, destination: Maybe<{ __typename?: 'destinations', id: any, name: Maybe<string>, type: string }> }> };

export type CreateSyncMutationVariables = Exact<{
  object: DestinationInstancesInsertInput;
}>;


export type CreateSyncMutation = { __typename?: 'mutation', insert_destination_instances_one: Maybe<{ __typename?: 'destination_instances', id: any }> };

export type CreateSyncsMutationVariables = Exact<{
  objects: Array<DestinationInstancesInsertInput> | DestinationInstancesInsertInput;
}>;


export type CreateSyncsMutation = { __typename?: 'mutation', insert_destination_instances: Maybe<{ __typename?: 'destination_instances_mutation_response', returning: Array<{ __typename?: 'destination_instances', id: any }> }> };

export type UpdateSyncMutationVariables = Exact<{
  id: Scalars['bigint'];
  object: DestinationInstancesSetInput;
}>;


export type UpdateSyncMutation = { __typename?: 'mutation', update_destination_instances_by_pk: Maybe<{ __typename?: 'destination_instances', id: any }> };

export type UpdateSyncsMutationVariables = Exact<{
  ids?: Maybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  object: DestinationInstancesSetInput;
}>;


export type UpdateSyncsMutation = { __typename?: 'mutation', update_destination_instances: Maybe<{ __typename?: 'destination_instances_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'destination_instances', id: any }> }> };

export type DeleteSyncMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteSyncMutation = { __typename?: 'mutation', delete_destination_instances_by_pk: Maybe<{ __typename?: 'destination_instances', id: any }> };

export type DeleteSyncsMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteSyncsMutation = { __typename?: 'mutation', delete_destination_instances: Maybe<{ __typename?: 'destination_instances_mutation_response', affected_rows: number }> };

export type StartSyncRunMutationVariables = Exact<{
  id: Scalars['Int'];
  full_resync?: Maybe<Scalars['Boolean']>;
}>;


export type StartSyncRunMutation = { __typename?: 'mutation', startSyncRun: { __typename?: 'StartSyncRunOutput', scheduled: boolean } };

export type SyncRunsQueryVariables = Exact<{
  syncId: Scalars['bigint'];
  filter?: Maybe<SyncAttemptsBoolExp>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: SyncRequestsOrderBy;
}>;


export type SyncRunsQuery = { __typename?: 'query', sync_requests: Array<{ __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, add_checkpoint: number, change_checkpoint: number, remove_checkpoint: number, add_rejected: Maybe<number>, change_rejected: Maybe<number>, remove_rejected: Maybe<number>, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> }> };

export type SyncRequestsQueryVariables = Exact<{
  instanceId: Scalars['bigint'];
}>;


export type SyncRequestsQuery = { __typename?: 'query', sync_requests: Array<{ __typename?: 'sync_requests', id: any, created_at: any, status: string, status_computed: Maybe<string>, sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, created_at: any, finished_at: Maybe<any>, error: Maybe<string>, status: string, details: Maybe<any> }> }> };

export type SyncAttemptQueryVariables = Exact<{
  syncRequestId: Scalars['bigint'];
}>;


export type SyncAttemptQuery = { __typename?: 'query', sync_attempts: Array<{ __typename?: 'sync_attempts', id: any, created_at: any, finished_at: Maybe<any>, status: string, error: Maybe<string>, add_rejected: Maybe<number>, remove_rejected: Maybe<number>, change_rejected: Maybe<number>, add_checkpoint: number, remove_checkpoint: number, change_checkpoint: number, sync_request: { __typename?: 'sync_requests', id: any, destination_instance_id: any, created_at: any, error: Maybe<any>, status: string, status_computed: Maybe<string>, phase_to_status: Maybe<any>, completion_ratio: Maybe<any>, resync_reason: Maybe<string>, add_executed: Maybe<number>, change_executed: Maybe<number>, remove_executed: Maybe<number>, planner_type: Maybe<string>, trigger_cancel: Maybe<boolean>, sync: Maybe<{ __typename?: 'syncs', id: Maybe<any>, segment: Maybe<{ __typename?: 'segments', primary_key: Maybe<string> }>, destination: Maybe<{ __typename?: 'destinations', id: any, type: string }>, sync_requests: Array<{ __typename?: 'sync_requests', id: any }> }>, sync_request_diff: Maybe<{ __typename?: 'sync_request_diffs', added_count: number, removed_count: number, changed_count: number }>, query_run: Maybe<{ __typename?: 'query_runs', size: number }> } }> };

export type AttemptedRowsQueryVariables = Exact<{
  destinationInstanceId: Scalars['Int'];
  syncRequestId: Scalars['Int'];
  pageKey?: Maybe<Scalars['String']>;
  opTypes: Array<SyncOp> | SyncOp;
  onlyRejected: Scalars['Boolean'];
  onlySuccessful: Scalars['Boolean'];
  limit: Scalars['Int'];
}>;


export type AttemptedRowsQuery = { __typename?: 'query', getAttemptedRows: { __typename?: 'AttemptedRowsResult', nextPageKey: Maybe<string>, rows: Array<Maybe<{ __typename?: 'AttemptedRow', id: string, opType: SyncOp, rejected: boolean, fields: string, rejectionReason: Maybe<string>, batchId: Maybe<string>, batchRequestInfoKey: Maybe<string>, requestInfoKeys: Maybe<Array<Maybe<string>>>, isBatchError: Maybe<boolean>, error: Maybe<any> }>> } };

export type AttemptedRowsByPrimaryKeyQueryVariables = Exact<{
  destinationInstanceId: Scalars['Int'];
  syncRequestId: Scalars['Int'];
  id: Scalars['String'];
  alreadyHashed?: Maybe<Scalars['Boolean']>;
}>;


export type AttemptedRowsByPrimaryKeyQuery = { __typename?: 'query', getAttemptedRowsByPrimaryKey: { __typename?: 'AttemptedRowsResult', rows: Array<Maybe<{ __typename?: 'AttemptedRow', id: string, opType: SyncOp, rejected: boolean, fields: string, rejectionReason: Maybe<string>, batchId: Maybe<string>, batchRequestInfoKey: Maybe<string>, requestInfoKeys: Maybe<Array<Maybe<string>>>, isBatchError: Maybe<boolean>, error: Maybe<any> }>> } };

export type AttemptedRowsByBatchIdQueryVariables = Exact<{
  destinationInstanceId: Scalars['Int'];
  syncRequestId: Scalars['Int'];
  id: Scalars['String'];
  pageKey?: Maybe<Scalars['String']>;
}>;


export type AttemptedRowsByBatchIdQuery = { __typename?: 'query', getAttemptedRowsByBatchId: { __typename?: 'AttemptedRowsResult', nextPageKey: Maybe<string>, rows: Array<Maybe<{ __typename?: 'AttemptedRow', id: string, opType: SyncOp, rejected: boolean, fields: string, rejectionReason: Maybe<string>, batchId: Maybe<string>, batchRequestInfoKey: Maybe<string>, requestInfoKeys: Maybe<Array<Maybe<string>>>, isBatchError: Maybe<boolean>, error: Maybe<any> }>> } };

export type BatchRequestInfoQueryVariables = Exact<{
  batchRequestInfoKey: Scalars['String'];
}>;


export type BatchRequestInfoQuery = { __typename?: 'query', getBatchRequestInfo: { __typename?: 'BatchRequestInfo', requests: Array<{ __typename?: 'RequestInfo', requestType: string, data: any }> } };

export type RequestInfoSetQueryVariables = Exact<{
  requestInfoKeys?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RequestInfoSetQuery = { __typename?: 'query', getRequestInfoSet: Maybe<Array<{ __typename?: 'RequestInfo', requestType: string, data: any }>> };

export type UpdateSyncRequestMutationVariables = Exact<{
  id: Scalars['bigint'];
  object: SyncRequestsSetInput;
}>;


export type UpdateSyncRequestMutation = { __typename?: 'mutation', update_sync_requests_by_pk: Maybe<{ __typename?: 'sync_requests', id: any }> };

export type TestSyncConfigurationQueryVariables = Exact<{
  segmentId: Scalars['Int'];
  destinationId: Scalars['Int'];
  syncConfig: Scalars['JSONObject'];
  rows: Array<Scalars['JSONObject']> | Scalars['JSONObject'];
  operation: SyncOp;
}>;


export type TestSyncConfigurationQuery = { __typename?: 'query', testSyncConfiguration: { __typename?: 'TestSyncConfigurationResult', error: Maybe<string>, batches: Array<{ __typename?: 'SyncResultBatch', batchId: string, attemptedRows: Maybe<Array<any>>, rejectedRows: Maybe<Array<any>>, requestInfoSet: Maybe<Array<Maybe<{ __typename?: 'RequestInfo', requestType: string, data: any }>>> }> } };

export type TestSyncConfigurationSupportedQueryVariables = Exact<{
  segmentId: Scalars['Int'];
  destinationId: Scalars['Int'];
  syncConfig: Scalars['JSONObject'];
}>;


export type TestSyncConfigurationSupportedQuery = { __typename?: 'query', testSyncConfigurationSupported: boolean };

export type ExternalSegmentsQueryVariables = Exact<{
  syncId: Scalars['bigint'];
}>;


export type ExternalSegmentsQuery = { __typename?: 'query', external_segments: Array<{ __typename?: 'external_segments', id: any, external_id: Maybe<string>, created_at: any }> };

export type SyncTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncTemplatesQuery = { __typename?: 'query', sync_templates: Array<{ __typename?: 'sync_templates', id: number, name: string, destination: { __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any> }, segment: { __typename?: 'segments', id: any, name: string, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }> } }> };

export type SyncTemplatesForParentModelQueryVariables = Exact<{
  parentModelId: Scalars['Int'];
}>;


export type SyncTemplatesForParentModelQuery = { __typename?: 'query', sync_templates: Array<{ __typename?: 'sync_templates', id: number, name: string, config: any, transformed_config: any, destination: { __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any> }, segment: { __typename?: 'segments', id: any, name: string, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }> } }> };

export type SyncTemplateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SyncTemplateQuery = { __typename?: 'query', sync_templates_by_pk: Maybe<{ __typename?: 'sync_templates', id: number, name: string, schedule: Maybe<any>, row_threshold_attempted: Maybe<any>, row_threshold_total: Maybe<any>, config: any, destination: { __typename?: 'destinations', id: any, name: Maybe<string>, slug: Maybe<string>, type: string, credential_id: Maybe<any> }, segment: { __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, git_sync_metadata: Maybe<any>, primary_key: Maybe<string>, query_raw_sql: Maybe<string>, query_table_name: Maybe<string>, query_dbt_model_id: Maybe<number>, query_looker_look_id: Maybe<string>, custom_query: Maybe<any>, visual_query_filter: Maybe<any>, visual_query_parent_id: Maybe<any>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, syncable_columns: Array<{ __typename?: 'SyncableColumn', column_reference: any, model_name: string, name: string }>, parent: Maybe<{ __typename?: 'segments', id: any, name: string, query_type: Maybe<string>, primary_key: Maybe<string>, visual_query_primary_label: Maybe<string>, visual_query_secondary_label: Maybe<string>, connection: Maybe<{ __typename?: 'connections', id: any, name: string, type: string, plan_in_warehouse: boolean, is_demo: Maybe<boolean>, sample_data_source_id: Maybe<any> }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, relationships: Array<{ __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> }>, traits: Array<{ __typename?: 'trait_definitions', id: any, name: string, type: string, config: any, relationship: { __typename?: 'model_relationships', id: any, name: string, merge_columns: Maybe<boolean>, to_model: { __typename?: 'segments', id: any, name: string, filterable_audience_columns: Array<{ __typename?: 'FilterableColumn', alias: Maybe<string>, column_reference: any, custom_type: Maybe<string>, disable: Maybe<boolean>, disable_preview: Maybe<boolean>, last_top_k_sync_timestamp: Maybe<string>, model_id: string, model_name: string, name: string, top_k_enabled: Maybe<boolean>, top_k_error: Maybe<string>, top_k_sync_interval: Maybe<number>, type: string }>, columns: Array<{ __typename?: 'model_columns', name: string, alias: Maybe<string>, type: string, custom_type: Maybe<string>, disable: boolean, disable_preview: boolean }>, event: Maybe<{ __typename?: 'event_models', timestamp_column: string }> }, from_model: { __typename?: 'segments', id: any, name: string }, direct_relationships: Array<{ __typename?: 'direct_model_relationships', from_column: string, to_column: string, to_model: { __typename?: 'segments', id: any, name: string } }>, through_relationships: Array<{ __typename?: 'through_model_relationships', relationship: { __typename?: 'model_relationships', id: any, to_model: { __typename?: 'segments', id: any, name: string } } }> } }> }> }, alert_instances: Array<{ __typename?: 'alert_instances', fatal_error: Maybe<boolean>, row_error: Maybe<boolean>, id: any }> }> };

export type CreateSyncTemplateMutationVariables = Exact<{
  object: SyncTemplatesInsertInput;
}>;


export type CreateSyncTemplateMutation = { __typename?: 'mutation', insert_sync_templates_one: Maybe<{ __typename?: 'sync_templates', id: number }> };

export type UpdateSyncTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  input: SyncTemplatesSetInput;
}>;


export type UpdateSyncTemplateMutation = { __typename?: 'mutation', update_sync_templates_by_pk: Maybe<{ __typename?: 'sync_templates', id: number }> };

export type DeleteSyncTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSyncTemplateMutation = { __typename?: 'mutation', delete_sync_templates_by_pk: Maybe<{ __typename?: 'sync_templates', id: number }> };

export type TunnelsQueryVariables = Exact<{ [key: string]: never; }>;


export type TunnelsQuery = { __typename?: 'query', getTunnels: Array<{ __typename?: 'GetTunnelResult', type: string, tunnel: { __typename?: 'NormalTunnel', sshHost: string, sshPort: Maybe<number>, serviceHost: string, servicePort: number, id: Maybe<string>, name: Maybe<string>, createdAt: Maybe<string>, tunnelPort: Maybe<number> } | { __typename?: 'ReverseTunnel', id: Maybe<string>, name: Maybe<string>, createdAt: Maybe<string>, tunnelPort: Maybe<number> }, connection: Maybe<{ __typename?: 'ConnectionDetails', host: string, port: number }> }> };

export type CreateNormalTunnelMutationVariables = Exact<{
  input: NormalTunnelInput;
}>;


export type CreateNormalTunnelMutation = { __typename?: 'mutation', createNormalTunnel: { __typename?: 'NormalTunnelOutput', publicKey: Maybe<string>, tunnel: { __typename?: 'NormalTunnel', id: Maybe<string>, tunnelPort: Maybe<number> }, connection: { __typename?: 'ConnectionDetails', host: string, port: number } } };

export type CreateReverseTunnelMutationVariables = Exact<{
  input: ReverseTunnelInput;
}>;


export type CreateReverseTunnelMutation = { __typename?: 'mutation', createReverseTunnel: { __typename?: 'ReverseTunnelOutput', privateKeyBase64: Maybe<string>, tunnel: { __typename?: 'ReverseTunnel', id: Maybe<string>, sshdPort: Maybe<number>, tunnelPort: Maybe<number> }, connection: { __typename?: 'ConnectionDetails', host: string, port: number } } };

export type TestTunnelQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TestTunnelQuery = { __typename?: 'query', checkTunnel: { __typename?: 'CheckTunnelResult', success: boolean, error: Maybe<string> } };

export type TunnelSourceQueryVariables = Exact<{
  tunnelID: Scalars['uuid'];
  sourceID?: Maybe<Scalars['bigint']>;
}>;


export type TunnelSourceQuery = { __typename?: 'query', connections: Array<{ __typename?: 'connections', id: any, name: string }> };

export type DeleteTunnelMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTunnelMutation = { __typename?: 'mutation', deleteTunnel: Maybe<boolean> };

export type UpdateTunnelMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: TunnelsSetInput;
}>;


export type UpdateTunnelMutation = { __typename?: 'mutation', update_tunnels_by_pk: Maybe<{ __typename?: 'tunnels', tunnel_id: any, name: string }> };

export type SaveUserPersonalizationMutationVariables = Exact<{
  userId: Scalars['bigint'];
  role?: Maybe<Scalars['String']>;
  customRole?: Maybe<Scalars['String']>;
  referrer?: Maybe<Scalars['String']>;
}>;


export type SaveUserPersonalizationMutation = { __typename?: 'mutation', update_users_by_pk: Maybe<{ __typename?: 'users', id: any }> };

export type InitialQueryVariables = Exact<{
  permissionFilters?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type InitialQuery = { __typename?: 'query', getCurrentUser: Maybe<{ __typename?: 'User', email: string, id: number, name: string, avatar_json: Maybe<any>, current_workspace_id: Maybe<string>, not_member_of_current_workspace: Maybe<boolean>, is_admin: boolean }>, getCurrentPermissions: Maybe<Array<{ __typename?: 'ResourcePermission', resource: ResourceToPermission, grants: Maybe<Array<ResourcePermissionGrant>> }>>, getOrganization: Maybe<{ __typename?: 'Organization', id: number, name: string, slug: string }>, workspaces: Array<{ __typename?: 'workspaces', id: any, name: string, domain: Maybe<string>, slug: Maybe<string>, region: string, feature_flags: any, is_approved: boolean, google_hosted_domain: Maybe<string>, visible_to: Maybe<any>, joinable_to: Maybe<any>, default_role_id: Maybe<any>, trial_ends_at: Maybe<any>, show_lock_popup: boolean, lock_popup_date: Maybe<any>, onboarding: Maybe<any>, organization: Maybe<{ __typename?: 'organizations', entitlements: Maybe<any>, name: string, id: any, slug: string, billing: Maybe<any>, plan: Maybe<{ __typename?: 'billing_products', entitlements: any }> }>, memberships: Array<{ __typename?: 'memberships', workspace_id: any, user_id: any, user: { __typename?: 'users', id: any, name: string, email: string, created_at: any }, role: Maybe<{ __typename?: 'roles', id: any }> }>, roles: Array<{ __typename?: 'roles', id: any, name: string, permissions: Maybe<any> }> }>, segments: Array<{ __typename?: 'segments', id: any }>, connections: Array<{ __typename?: 'connections', id: any, type: string }>, destinations: Array<{ __typename?: 'destinations', id: any, type: string }>, destination_instances: Array<{ __typename?: 'destination_instances', id: any }> };

export type ViewsQueryVariables = Exact<{
  resourceType: Scalars['String'];
}>;


export type ViewsQuery = { __typename?: 'query', resource_views: Array<{ __typename?: 'resource_views', id: any, name: string, view: any }> };

export type CreateViewMutationVariables = Exact<{
  resourceType: Scalars['String'];
  name: Scalars['String'];
  view: Scalars['jsonb'];
  private: Scalars['Boolean'];
}>;


export type CreateViewMutation = { __typename?: 'mutation', insert_resource_views_one: Maybe<{ __typename?: 'resource_views', id: any }> };

export type DeleteViewMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteViewMutation = { __typename?: 'mutation', delete_resource_views_by_pk: Maybe<{ __typename?: 'resource_views', id: any }> };

export type UpdateViewMutationVariables = Exact<{
  id: Scalars['bigint'];
  view: Scalars['jsonb'];
}>;


export type UpdateViewMutation = { __typename?: 'mutation', update_resource_views_by_pk: Maybe<{ __typename?: 'resource_views', id: any }> };

export type WorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspacesQuery = { __typename?: 'query', workspaces: Array<{ __typename?: 'workspaces', id: any, name: string, domain: Maybe<string>, slug: Maybe<string>, region: string, feature_flags: any, is_approved: boolean, google_hosted_domain: Maybe<string>, visible_to: Maybe<any>, joinable_to: Maybe<any>, default_role_id: Maybe<any>, trial_ends_at: Maybe<any>, show_lock_popup: boolean, lock_popup_date: Maybe<any>, onboarding: Maybe<any>, organization: Maybe<{ __typename?: 'organizations', id: any, name: string }>, memberships: Array<{ __typename?: 'memberships', workspace_id: any, user_id: any, user: { __typename?: 'users', id: any, name: string, email: string, created_at: any }, role: Maybe<{ __typename?: 'roles', id: any }> }> }> };

export type AllWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllWorkspacesQuery = { __typename?: 'query', workspaces: Array<{ __typename?: 'workspaces', id: any, slug: Maybe<string>, label: string }> };

export type SearchWorkspacesQueryVariables = Exact<{
  query: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type SearchWorkspacesQuery = { __typename?: 'query', workspaces: Array<{ __typename?: 'workspaces', id: any, name: string, slug: Maybe<string> }> };

export type WorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['bigint'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  orderBy?: Maybe<MembershipsOrderBy>;
}>;


export type WorkspaceQuery = { __typename?: 'query', workspaces_by_pk: Maybe<{ __typename?: 'workspaces', id: any, name: string, domain: Maybe<string>, slug: Maybe<string>, region: string, feature_flags: any, is_approved: boolean, google_hosted_domain: Maybe<string>, visible_to: Maybe<any>, joinable_to: Maybe<any>, default_role_id: Maybe<any>, trial_ends_at: Maybe<any>, show_lock_popup: boolean, lock_popup_date: Maybe<any>, onboarding: Maybe<any>, memberships: Array<{ __typename?: 'memberships', workspace_id: any, user_id: any, user: { __typename?: 'users', id: any, name: string, email: string, created_at: any }, role: Maybe<{ __typename?: 'roles', id: any }> }>, roles: Array<{ __typename?: 'roles', id: any, name: string, permissions: Maybe<any> }> }>, memberships_aggregate: { __typename?: 'memberships_aggregate', aggregate: Maybe<{ __typename?: 'memberships_aggregate_fields', count: number }> } };

export type AvailableWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableWorkspacesQuery = { __typename?: 'query', getAvailableWorkspaces: { __typename?: 'GetAvailableWorkspacesResult', joinable: Array<{ __typename?: 'AvailableWorkspace', id: number, name: string, slug: string, organization: Maybe<{ __typename?: 'Organization', id: number, name: string }> }>, visible: Array<{ __typename?: 'AvailableWorkspace', id: number, name: string, slug: string, organization: Maybe<{ __typename?: 'Organization', id: number, name: string }> }> } };

export type GetWorkspaceRolesQueryVariables = Exact<{
  workspaceId: Scalars['bigint'];
}>;


export type GetWorkspaceRolesQuery = { __typename?: 'query', workspaces_by_pk: Maybe<{ __typename?: 'workspaces', roles: Array<{ __typename?: 'roles', id: any, name: string, permissions: Maybe<any> }> }> };

export type UpdateUserWorkspaceRoleMutationVariables = Exact<{
  workspaceId: Scalars['bigint'];
  userId: Scalars['bigint'];
  roleId: Scalars['Int'];
}>;


export type UpdateUserWorkspaceRoleMutation = { __typename?: 'mutation', update_memberships: Maybe<{ __typename?: 'memberships_mutation_response', affected_rows: number }> };

export type UpdateWorkspaceRoleMutationVariables = Exact<{
  workspaceId: Scalars['bigint'];
  roleId: Scalars['bigint'];
  name: Scalars['String'];
  permissions: Scalars['jsonb'];
}>;


export type UpdateWorkspaceRoleMutation = { __typename?: 'mutation', update_roles: Maybe<{ __typename?: 'roles_mutation_response', affected_rows: number }> };

export type AddWorkspaceRoleMutationVariables = Exact<{
  name: Scalars['String'];
  permissions?: Maybe<Scalars['jsonb']>;
}>;


export type AddWorkspaceRoleMutation = { __typename?: 'mutation', insert_roles_one: Maybe<{ __typename?: 'roles', id: any }> };

export type VerifiedDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifiedDomainsQuery = { __typename?: 'query', getVerifiedDomains: Maybe<Array<string>> };

export type MembershipRequestsByWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['bigint'];
}>;


export type MembershipRequestsByWorkspaceQuery = { __typename?: 'query', membership_requests: Array<{ __typename?: 'membership_requests', user_id: any, workspace_id: any, created_at: any, user: { __typename?: 'users', name: string, email: string, id: any } }> };

export type MembershipRequestsByUserQueryVariables = Exact<{
  userId: Scalars['bigint'];
}>;


export type MembershipRequestsByUserQuery = { __typename?: 'query', membership_requests: Array<{ __typename?: 'membership_requests', user_id: any, workspace_id: any, created_at: any }> };

export type RequestMembershipMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  partnerConnectionId?: Maybe<Scalars['String']>;
}>;


export type RequestMembershipMutation = { __typename?: 'mutation', requestMembership: Maybe<boolean> };

export type ApproveMembershipMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ApproveMembershipMutation = { __typename?: 'mutation', approveMembership: Maybe<boolean> };

export type RejectMembershipMutationVariables = Exact<{
  workspaceId: Scalars['bigint'];
  userId: Scalars['bigint'];
}>;


export type RejectMembershipMutation = { __typename?: 'mutation', delete_membership_requests_by_pk: Maybe<{ __typename?: 'membership_requests', user_id: any, workspace_id: any }> };

export type JoinWorkspaceWithAutoJoinMutationVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type JoinWorkspaceWithAutoJoinMutation = { __typename?: 'mutation', joinWorkspaceWithAutojoin: Maybe<boolean> };

export type UpdateWorkspaceMutationVariables = Exact<{
  id: Scalars['bigint'];
  input: WorkspacesSetInput;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'mutation', update_workspaces_by_pk: Maybe<{ __typename?: 'workspaces', id: any }> };

export type UpdateWorkspaceDomainsMutationVariables = Exact<{
  visibleTo?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  joinableTo?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateWorkspaceDomainsMutation = { __typename?: 'mutation', updateWorkspaceDomains: Maybe<boolean> };

export type CreateWorkspaceMutationVariables = Exact<{
  name: Scalars['String'];
  slug: Scalars['String'];
  region: Scalars['String'];
  organization?: Maybe<Scalars['Int']>;
}>;


export type CreateWorkspaceMutation = { __typename?: 'mutation', createWorkspace: { __typename?: 'CreateWorkspaceResult', id: number } };

export type IsWorkspaceSlugAvailableQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type IsWorkspaceSlugAvailableQuery = { __typename?: 'query', isWorkspaceSlugAvailable: boolean };

export type SendInviteMutationVariables = Exact<{
  recipientEmail: Scalars['String'];
  recipientRoleID: Scalars['Int'];
}>;


export type SendInviteMutation = { __typename?: 'mutation', sendInvite: Maybe<boolean> };

export type PendingInvitesQueryVariables = Exact<{
  workspaceId: Scalars['bigint'];
}>;


export type PendingInvitesQuery = { __typename?: 'query', outbound_user_invites: Array<{ __typename?: 'outbound_user_invites', workspace_id: any, recipient_email: string, expires_at: any, created_by: any, role_id: Maybe<number> }> };

export type CancelInviteMutationVariables = Exact<{
  workspaceId: Scalars['bigint'];
  recipientEmail: Scalars['String'];
}>;


export type CancelInviteMutation = { __typename?: 'mutation', delete_outbound_user_invites_by_pk: Maybe<{ __typename?: 'outbound_user_invites', workspace_id: any, recipient_email: string, expires_at: any, created_by: any, role_id: Maybe<number> }> };

export type DeleteMembersMutationVariables = Exact<{
  workspaceId: Scalars['bigint'];
  userIds: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type DeleteMembersMutation = { __typename?: 'mutation', delete_memberships: Maybe<{ __typename?: 'memberships_mutation_response', affected_rows: number }> };

export const SlackCredentialsFragmentDoc = `
    fragment SlackCredentials on slack_credentials {
  id
  state
  channel_id
  channel_name
}
    `;
export const PagerDutyCredentialsFragmentDoc = `
    fragment PagerDutyCredentials on pagerduty_credentials {
  id
  state
  config
  api_key
}
    `;
export const WorkspaceFragmentDoc = `
    fragment Workspace on workspaces {
  id
  name
  domain
  slug
  region
  feature_flags
  is_approved
  google_hosted_domain
  visible_to
  joinable_to
  default_role_id
  trial_ends_at
  show_lock_popup
  lock_popup_date
  onboarding
}
    `;
export const OrganizationFragmentDoc = `
    fragment Organization on organizations {
  name
  id
  slug
  billing
}
    `;
export const MembershipFragmentDoc = `
    fragment Membership on memberships {
  workspace_id
  user_id
  user {
    id
    name
    email
    created_at
  }
  role {
    id
  }
}
    `;
export const UserFragmentDoc = `
    fragment User on User {
  email
  id
  name
  avatar_json
  current_workspace_id
  not_member_of_current_workspace
  is_admin
}
    `;
export const DestinationFragmentDoc = `
    fragment Destination on destinations {
  id
  name
  slug
  type
  credential_id
}
    `;
export const DestinationDefinitionFragmentDoc = `
    fragment DestinationDefinition on DestinationDefinition {
  name
  type
  status
  icon
  docs
  shortPitch
  longPitch
  releasedAt
  updatedAt
  features
  oauthUrl
  configurationForm
  testConnection
  configVersion
  categories {
    name
    type
    shortDescription
  }
}
    `;
export const SourceDefinitionFragmentDoc = `
    fragment SourceDefinition on SourceDefinition {
  name
  type
  status
  docs
  icon
  shortPitch
  longPitch
  releasedAt
  updatedAt
  supportedQueries
  supportsTunneling
  supportsIpFiltering
  supportsResultSchema
  supportsInWarehouseDiffing
  supportsCrossDbReference
  disableTest
  isSampleDataSource
  sampleModels {
    name
    sql
  }
  categories {
    name
    type
    shortDescription
  }
}
    `;
export const SourceFragmentDoc = `
    fragment Source on connections {
  id
  name
  type
  plan_in_warehouse
  is_demo
  sample_data_source_id
}
    `;
export const ColumnFragmentDoc = `
    fragment Column on model_columns {
  name
  alias
  type
  custom_type
  disable
  disable_preview
}
    `;
export const FilterableColumnFragmentDoc = `
    fragment FilterableColumn on FilterableColumn {
  alias
  column_reference
  custom_type
  disable
  disable_preview
  last_top_k_sync_timestamp
  model_id
  model_name
  name
  top_k_enabled
  top_k_error
  top_k_sync_interval
  type
}
    `;
export const RelationshipFragmentDoc = `
    fragment Relationship on model_relationships {
  id
  name
  merge_columns
  to_model {
    id
    name
    filterable_audience_columns {
      ...FilterableColumn
    }
    columns {
      ...Column
    }
    event {
      timestamp_column
    }
  }
  from_model {
    id
    name
  }
  direct_relationships {
    from_column
    to_column
    to_model {
      id
      name
    }
  }
  through_relationships {
    relationship {
      id
      to_model {
        id
        name
      }
    }
  }
}
    `;
export const TraitDefinitionFragmentDoc = `
    fragment TraitDefinition on trait_definitions {
  id
  name
  type
  config
  relationship {
    ...Relationship
  }
}
    `;
export const AudienceParentFragmentDoc = `
    fragment AudienceParent on segments {
  id
  name
  query_type
  primary_key
  visual_query_primary_label
  visual_query_secondary_label
  connection {
    ...Source
  }
  columns {
    ...Column
  }
  filterable_audience_columns {
    ...FilterableColumn
  }
  relationships {
    ...Relationship
  }
  traits {
    ...TraitDefinition
  }
}
    `;
export const QueryFieldsFragmentDoc = `
    fragment QueryFields on segments {
  query_type
  query_raw_sql
  query_table_name
  query_dbt_model_id
  query_looker_look_id
  custom_query
  visual_query_filter
  visual_query_parent_id
}
    `;
export const SegmentHistoryFragmentDoc = `
    fragment SegmentHistory on segments {
  created_at
  updated_at
  created_by_user {
    name
  }
  updated_by_user {
    name
  }
}
    `;
export const SourceHistoryFragmentDoc = `
    fragment SourceHistory on connections {
  created_at
  updated_at
  created_by_user {
    name
  }
  updated_by_user {
    name
  }
}
    `;
export const DestinationHistoryFragmentDoc = `
    fragment DestinationHistory on destinations {
  created_at
  updated_at
  created_by_user {
    name
  }
  updated_by_user {
    name
  }
}
    `;
export const SyncHistoryFragmentDoc = `
    fragment SyncHistory on syncs {
  created_at
  updated_at
  created_by_user {
    name
  }
  updated_by_user {
    name
  }
}
    `;
export const ObjectColumnFragmentDoc = `
    fragment ObjectColumn on model_columns {
  ...Column
  trigger_top_k_sync
  top_k_sync_interval
  top_k_enabled
  top_k_error
  last_top_k_sync_timestamp
}
    `;
export const SyncFragmentDoc = `
    fragment Sync on syncs {
  id
  status
  schedule
  schedule_paused
  config: transformed_config
}
    `;
export const SyncAttemptFragmentDoc = `
    fragment SyncAttempt on sync_attempts {
  id
  add_checkpoint
  change_checkpoint
  remove_checkpoint
  add_rejected
  change_rejected
  remove_rejected
  created_at
  finished_at
  error
  status
  details
}
    `;
export const SyncRequestFragmentDoc = `
    fragment SyncRequest on sync_requests {
  id
  destination_instance_id
  created_at
  error
  status
  status_computed
  phase_to_status
  completion_ratio
  resync_reason
  add_executed
  change_executed
  remove_executed
  planner_type
  trigger_cancel
  sync_request_diff {
    added_count
    removed_count
    changed_count
  }
  query_run {
    size
  }
}
    `;
export const WorkspaceAlertFragmentDoc = `
    fragment WorkspaceAlert on alerts {
  id
  name
  alert_interval
  config
  created_by
  fatal_error_default
  row_error_default
  type
  pagerduty_credential_id
  slack_credential_id
}
    `;
export const AlertInstanceFragmentDoc = `
    fragment AlertInstance on alert_instances {
  id: alert_id
  fatal_error
  row_error
}
    `;
export const SyncAlertFragmentDoc = `
    fragment SyncAlert on sync_alerts {
  id
  fatal_error
  row_error
}
    `;
export const AlertStatusFragmentDoc = `
    fragment AlertStatus on alert_statuses {
  last_attempted
  destination_instance_id
  error
}
    `;
export const ExternalBucketFragmentDoc = `
    fragment ExternalBucket on external_buckets {
  type
  config
  credential_id
  created_at
  updated_at
}
    `;
export const ApiKeyFragmentDoc = `
    fragment APIKey on api_keys {
  id
  name
  last_used
  created_at
}
    `;
export const AttemptedRowFragmentDoc = `
    fragment AttemptedRow on AttemptedRow {
  id
  opType
  rejected
  fields
  rejectionReason
  batchId
  batchRequestInfoKey
  requestInfoKeys
  isBatchError
  error
}
    `;
export const OutboundUserInviteFragmentDoc = `
    fragment OutboundUserInvite on outbound_user_invites {
  workspace_id
  recipient_email
  expires_at
  created_by
  role_id
}
    `;
export const RoleFragmentDoc = `
    fragment Role on roles {
  id
  name
  permissions
}
    `;
export const SyncableColumnFragmentDoc = `
    fragment SyncableColumn on SyncableColumn {
  column_reference
  model_name
  name
}
    `;
export const GitCredentialsFragmentDoc = `
    fragment GitCredentials on git_credentials {
  id
  workspace_id
  tunnel_id
  username
  credentials
  type
}
    `;
export const PartnerConnectionFragmentDoc = `
    fragment PartnerConnection on PartnerConnection {
  uuid
  type
  partnerName
  partnerLogo
  resources
  userIsLinked
  workspaceId
  defaultWorkspaceName
}
    `;
export const FailedQueryResponseFieldsFragmentDoc = `
    fragment FailedQueryResponseFields on FailedQueryResponse {
  __typename
  error
  metadata
  sql
}
    `;
export const SuccessfulQueryResponseFieldsFragmentDoc = `
    fragment SuccessfulQueryResponseFields on SuccessfulQueryResponse {
  __typename
  rows
  columns {
    name
    type
  }
  exceedsPreviewMax
  numRowsWithoutLimit
  sql
}
    `;
export const QueryResponseFieldsFragmentDoc = `
    fragment QueryResponseFields on QueryResponse {
  __typename
  ...FailedQueryResponseFields
  ...SuccessfulQueryResponseFields
}
    `;
export const WorkspaceAlertsDocument = `
    query WorkspaceAlerts {
  alerts {
    ...WorkspaceAlert
  }
}
    ${WorkspaceAlertFragmentDoc}`;
export const useWorkspaceAlertsQuery = <
      TData = WorkspaceAlertsQuery,
      TError = Error
    >(
      variables?: WorkspaceAlertsQueryVariables, 
      options?: UseQueryOptions<WorkspaceAlertsQuery, TError, TData>
    ) => 
    useQuery<WorkspaceAlertsQuery, TError, TData>(
      variables === undefined ? ['WorkspaceAlerts'] : ['WorkspaceAlerts', variables],
      fetcher<WorkspaceAlertsQuery, WorkspaceAlertsQueryVariables>(WorkspaceAlertsDocument, variables),
      options
    );
useWorkspaceAlertsQuery.document = WorkspaceAlertsDocument;

useWorkspaceAlertsQuery.getKey = (variables?: WorkspaceAlertsQueryVariables) => variables === undefined ? ['WorkspaceAlerts'] : ['WorkspaceAlerts', variables];

useWorkspaceAlertsQuery.fetcher = (variables?: WorkspaceAlertsQueryVariables) => fetcher<WorkspaceAlertsQuery, WorkspaceAlertsQueryVariables>(WorkspaceAlertsDocument, variables);
export const WorkspaceAlertsWithStatusesDocument = `
    query WorkspaceAlertsWithStatuses($syncId: bigint, $orderBy: alerts_order_by! = {name: desc}) {
  alerts(order_by: [$orderBy]) {
    ...WorkspaceAlert
    alert_statuses(
      where: {destination_instance_id: {_eq: $syncId}}
      order_by: {last_attempted: desc}
      limit: 1
    ) {
      ...AlertStatus
    }
  }
}
    ${WorkspaceAlertFragmentDoc}
${AlertStatusFragmentDoc}`;
export const useWorkspaceAlertsWithStatusesQuery = <
      TData = WorkspaceAlertsWithStatusesQuery,
      TError = Error
    >(
      variables?: WorkspaceAlertsWithStatusesQueryVariables, 
      options?: UseQueryOptions<WorkspaceAlertsWithStatusesQuery, TError, TData>
    ) => 
    useQuery<WorkspaceAlertsWithStatusesQuery, TError, TData>(
      variables === undefined ? ['WorkspaceAlertsWithStatuses'] : ['WorkspaceAlertsWithStatuses', variables],
      fetcher<WorkspaceAlertsWithStatusesQuery, WorkspaceAlertsWithStatusesQueryVariables>(WorkspaceAlertsWithStatusesDocument, variables),
      options
    );
useWorkspaceAlertsWithStatusesQuery.document = WorkspaceAlertsWithStatusesDocument;

useWorkspaceAlertsWithStatusesQuery.getKey = (variables?: WorkspaceAlertsWithStatusesQueryVariables) => variables === undefined ? ['WorkspaceAlertsWithStatuses'] : ['WorkspaceAlertsWithStatuses', variables];

useWorkspaceAlertsWithStatusesQuery.fetcher = (variables?: WorkspaceAlertsWithStatusesQueryVariables) => fetcher<WorkspaceAlertsWithStatusesQuery, WorkspaceAlertsWithStatusesQueryVariables>(WorkspaceAlertsWithStatusesDocument, variables);
export const CreateWorkspaceAlertDocument = `
    mutation CreateWorkspaceAlert($input: alerts_insert_input!) {
  insert_alerts_one(object: $input) {
    id
  }
}
    `;
export const useCreateWorkspaceAlertMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkspaceAlertMutation, TError, CreateWorkspaceAlertMutationVariables, TContext>) => 
    useMutation<CreateWorkspaceAlertMutation, TError, CreateWorkspaceAlertMutationVariables, TContext>(
      (variables?: CreateWorkspaceAlertMutationVariables) => fetcher<CreateWorkspaceAlertMutation, CreateWorkspaceAlertMutationVariables>(CreateWorkspaceAlertDocument, variables)(),
      options
    );
export const UpdateWorkspaceAlertDocument = `
    mutation UpdateWorkspaceAlert($id: bigint!, $input: alerts_set_input!) {
  update_alerts_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateWorkspaceAlertMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkspaceAlertMutation, TError, UpdateWorkspaceAlertMutationVariables, TContext>) => 
    useMutation<UpdateWorkspaceAlertMutation, TError, UpdateWorkspaceAlertMutationVariables, TContext>(
      (variables?: UpdateWorkspaceAlertMutationVariables) => fetcher<UpdateWorkspaceAlertMutation, UpdateWorkspaceAlertMutationVariables>(UpdateWorkspaceAlertDocument, variables)(),
      options
    );
export const DeleteWorkspaceAlertsDocument = `
    mutation DeleteWorkspaceAlerts($ids: [bigint!]!) {
  delete_alerts(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteWorkspaceAlertsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkspaceAlertsMutation, TError, DeleteWorkspaceAlertsMutationVariables, TContext>) => 
    useMutation<DeleteWorkspaceAlertsMutation, TError, DeleteWorkspaceAlertsMutationVariables, TContext>(
      (variables?: DeleteWorkspaceAlertsMutationVariables) => fetcher<DeleteWorkspaceAlertsMutation, DeleteWorkspaceAlertsMutationVariables>(DeleteWorkspaceAlertsDocument, variables)(),
      options
    );
export const CreateSyncTemplateAlertsDocument = `
    mutation CreateSyncTemplateAlerts($input: [alert_instances_insert_input!]!) {
  insert_alert_instances(
    objects: $input
    on_conflict: {constraint: sync_template_unique, update_columns: [fatal_error, row_error]}
  ) {
    affected_rows
  }
}
    `;
export const useCreateSyncTemplateAlertsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSyncTemplateAlertsMutation, TError, CreateSyncTemplateAlertsMutationVariables, TContext>) => 
    useMutation<CreateSyncTemplateAlertsMutation, TError, CreateSyncTemplateAlertsMutationVariables, TContext>(
      (variables?: CreateSyncTemplateAlertsMutationVariables) => fetcher<CreateSyncTemplateAlertsMutation, CreateSyncTemplateAlertsMutationVariables>(CreateSyncTemplateAlertsDocument, variables)(),
      options
    );
export const CreateSyncAlertsDocument = `
    mutation CreateSyncAlerts($input: [alert_instances_insert_input!]!) {
  insert_alert_instances(
    objects: $input
    on_conflict: {constraint: destination_instance_unique, update_columns: [fatal_error, row_error]}
  ) {
    affected_rows
  }
}
    `;
export const useCreateSyncAlertsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSyncAlertsMutation, TError, CreateSyncAlertsMutationVariables, TContext>) => 
    useMutation<CreateSyncAlertsMutation, TError, CreateSyncAlertsMutationVariables, TContext>(
      (variables?: CreateSyncAlertsMutationVariables) => fetcher<CreateSyncAlertsMutation, CreateSyncAlertsMutationVariables>(CreateSyncAlertsDocument, variables)(),
      options
    );
export const DeleteSyncAlertsDocument = `
    mutation DeleteSyncAlerts($syncId: bigint, $syncTemplateId: Int, $alertIds: [bigint!]!) {
  delete_alert_instances(
    where: {_or: [{destination_instance_id: {_eq: $syncId}}, {sync_template_id: {_eq: $syncTemplateId}}], alert_id: {_in: $alertIds}}
  ) {
    affected_rows
  }
}
    `;
export const useDeleteSyncAlertsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSyncAlertsMutation, TError, DeleteSyncAlertsMutationVariables, TContext>) => 
    useMutation<DeleteSyncAlertsMutation, TError, DeleteSyncAlertsMutationVariables, TContext>(
      (variables?: DeleteSyncAlertsMutationVariables) => fetcher<DeleteSyncAlertsMutation, DeleteSyncAlertsMutationVariables>(DeleteSyncAlertsDocument, variables)(),
      options
    );
export const ApiKeysDocument = `
    query APIKeys {
  api_keys {
    ...APIKey
  }
}
    ${ApiKeyFragmentDoc}`;
export const useApiKeysQuery = <
      TData = ApiKeysQuery,
      TError = Error
    >(
      variables?: ApiKeysQueryVariables, 
      options?: UseQueryOptions<ApiKeysQuery, TError, TData>
    ) => 
    useQuery<ApiKeysQuery, TError, TData>(
      variables === undefined ? ['APIKeys'] : ['APIKeys', variables],
      fetcher<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, variables),
      options
    );
useApiKeysQuery.document = ApiKeysDocument;

useApiKeysQuery.getKey = (variables?: ApiKeysQueryVariables) => variables === undefined ? ['APIKeys'] : ['APIKeys', variables];

useApiKeysQuery.fetcher = (variables?: ApiKeysQueryVariables) => fetcher<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, variables);
export const CreateApiKeyDocument = `
    mutation CreateAPIKey($object: api_keys_insert_input!) {
  insert_api_keys_one(object: $object) {
    id
  }
}
    `;
export const useCreateApiKeyMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateApiKeyMutation, TError, CreateApiKeyMutationVariables, TContext>) => 
    useMutation<CreateApiKeyMutation, TError, CreateApiKeyMutationVariables, TContext>(
      (variables?: CreateApiKeyMutationVariables) => fetcher<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, variables)(),
      options
    );
export const DeleteApiKeysDocument = `
    mutation DeleteAPIKeys($ids: [bigint!]!) {
  delete_api_keys(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteApiKeysMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteApiKeysMutation, TError, DeleteApiKeysMutationVariables, TContext>) => 
    useMutation<DeleteApiKeysMutation, TError, DeleteApiKeysMutationVariables, TContext>(
      (variables?: DeleteApiKeysMutationVariables) => fetcher<DeleteApiKeysMutation, DeleteApiKeysMutationVariables>(DeleteApiKeysDocument, variables)(),
      options
    );
export const AthenaWorkGroupsDocument = `
    query AthenaWorkGroups($connectionId: Int!, $region: String!, $credentials: AthenaCredentials!) {
  athenaListWorkGroups(
    connectionId: $connectionId
    region: $region
    credentials: $credentials
  ) {
    workGroups {
      name
    }
  }
}
    `;
export const useAthenaWorkGroupsQuery = <
      TData = AthenaWorkGroupsQuery,
      TError = Error
    >(
      variables: AthenaWorkGroupsQueryVariables, 
      options?: UseQueryOptions<AthenaWorkGroupsQuery, TError, TData>
    ) => 
    useQuery<AthenaWorkGroupsQuery, TError, TData>(
      ['AthenaWorkGroups', variables],
      fetcher<AthenaWorkGroupsQuery, AthenaWorkGroupsQueryVariables>(AthenaWorkGroupsDocument, variables),
      options
    );
useAthenaWorkGroupsQuery.document = AthenaWorkGroupsDocument;

useAthenaWorkGroupsQuery.getKey = (variables: AthenaWorkGroupsQueryVariables) => ['AthenaWorkGroups', variables];

useAthenaWorkGroupsQuery.fetcher = (variables: AthenaWorkGroupsQueryVariables) => fetcher<AthenaWorkGroupsQuery, AthenaWorkGroupsQueryVariables>(AthenaWorkGroupsDocument, variables);
export const AthenaWorkGroupsNewSourceDocument = `
    query AthenaWorkGroupsNewSource($region: String!, $credentials: AthenaCredentials!) {
  athenaListWorkGroupsNewSource(region: $region, credentials: $credentials) {
    workGroups {
      name
    }
  }
}
    `;
export const useAthenaWorkGroupsNewSourceQuery = <
      TData = AthenaWorkGroupsNewSourceQuery,
      TError = Error
    >(
      variables: AthenaWorkGroupsNewSourceQueryVariables, 
      options?: UseQueryOptions<AthenaWorkGroupsNewSourceQuery, TError, TData>
    ) => 
    useQuery<AthenaWorkGroupsNewSourceQuery, TError, TData>(
      ['AthenaWorkGroupsNewSource', variables],
      fetcher<AthenaWorkGroupsNewSourceQuery, AthenaWorkGroupsNewSourceQueryVariables>(AthenaWorkGroupsNewSourceDocument, variables),
      options
    );
useAthenaWorkGroupsNewSourceQuery.document = AthenaWorkGroupsNewSourceDocument;

useAthenaWorkGroupsNewSourceQuery.getKey = (variables: AthenaWorkGroupsNewSourceQueryVariables) => ['AthenaWorkGroupsNewSource', variables];

useAthenaWorkGroupsNewSourceQuery.fetcher = (variables: AthenaWorkGroupsNewSourceQueryVariables) => fetcher<AthenaWorkGroupsNewSourceQuery, AthenaWorkGroupsNewSourceQueryVariables>(AthenaWorkGroupsNewSourceDocument, variables);
export const AthenaDataCatalogsDocument = `
    query AthenaDataCatalogs($connectionId: Int!, $region: String!, $credentials: AthenaCredentials!) {
  athenaListDataCatalogs(
    connectionId: $connectionId
    region: $region
    credentials: $credentials
  ) {
    dataCatalogs {
      name
    }
  }
}
    `;
export const useAthenaDataCatalogsQuery = <
      TData = AthenaDataCatalogsQuery,
      TError = Error
    >(
      variables: AthenaDataCatalogsQueryVariables, 
      options?: UseQueryOptions<AthenaDataCatalogsQuery, TError, TData>
    ) => 
    useQuery<AthenaDataCatalogsQuery, TError, TData>(
      ['AthenaDataCatalogs', variables],
      fetcher<AthenaDataCatalogsQuery, AthenaDataCatalogsQueryVariables>(AthenaDataCatalogsDocument, variables),
      options
    );
useAthenaDataCatalogsQuery.document = AthenaDataCatalogsDocument;

useAthenaDataCatalogsQuery.getKey = (variables: AthenaDataCatalogsQueryVariables) => ['AthenaDataCatalogs', variables];

useAthenaDataCatalogsQuery.fetcher = (variables: AthenaDataCatalogsQueryVariables) => fetcher<AthenaDataCatalogsQuery, AthenaDataCatalogsQueryVariables>(AthenaDataCatalogsDocument, variables);
export const AthenaDataCatalogsNewSourceDocument = `
    query AthenaDataCatalogsNewSource($region: String!, $credentials: AthenaCredentials!) {
  athenaListDataCatalogsNewSource(region: $region, credentials: $credentials) {
    dataCatalogs {
      name
    }
  }
}
    `;
export const useAthenaDataCatalogsNewSourceQuery = <
      TData = AthenaDataCatalogsNewSourceQuery,
      TError = Error
    >(
      variables: AthenaDataCatalogsNewSourceQueryVariables, 
      options?: UseQueryOptions<AthenaDataCatalogsNewSourceQuery, TError, TData>
    ) => 
    useQuery<AthenaDataCatalogsNewSourceQuery, TError, TData>(
      ['AthenaDataCatalogsNewSource', variables],
      fetcher<AthenaDataCatalogsNewSourceQuery, AthenaDataCatalogsNewSourceQueryVariables>(AthenaDataCatalogsNewSourceDocument, variables),
      options
    );
useAthenaDataCatalogsNewSourceQuery.document = AthenaDataCatalogsNewSourceDocument;

useAthenaDataCatalogsNewSourceQuery.getKey = (variables: AthenaDataCatalogsNewSourceQueryVariables) => ['AthenaDataCatalogsNewSource', variables];

useAthenaDataCatalogsNewSourceQuery.fetcher = (variables: AthenaDataCatalogsNewSourceQueryVariables) => fetcher<AthenaDataCatalogsNewSourceQuery, AthenaDataCatalogsNewSourceQueryVariables>(AthenaDataCatalogsNewSourceDocument, variables);
export const AthenaDatabasesDocument = `
    query AthenaDatabases($connectionId: Int!, $region: String!, $credentials: AthenaCredentials!, $dataCatalog: String!) {
  athenaListDatabases(
    connectionId: $connectionId
    region: $region
    credentials: $credentials
    dataCatalog: $dataCatalog
  ) {
    databases {
      name
    }
  }
}
    `;
export const useAthenaDatabasesQuery = <
      TData = AthenaDatabasesQuery,
      TError = Error
    >(
      variables: AthenaDatabasesQueryVariables, 
      options?: UseQueryOptions<AthenaDatabasesQuery, TError, TData>
    ) => 
    useQuery<AthenaDatabasesQuery, TError, TData>(
      ['AthenaDatabases', variables],
      fetcher<AthenaDatabasesQuery, AthenaDatabasesQueryVariables>(AthenaDatabasesDocument, variables),
      options
    );
useAthenaDatabasesQuery.document = AthenaDatabasesDocument;

useAthenaDatabasesQuery.getKey = (variables: AthenaDatabasesQueryVariables) => ['AthenaDatabases', variables];

useAthenaDatabasesQuery.fetcher = (variables: AthenaDatabasesQueryVariables) => fetcher<AthenaDatabasesQuery, AthenaDatabasesQueryVariables>(AthenaDatabasesDocument, variables);
export const AthenaDatabasesNewSourceDocument = `
    query AthenaDatabasesNewSource($region: String!, $credentials: AthenaCredentials!, $dataCatalog: String!) {
  athenaListDatabasesNewSource(
    region: $region
    credentials: $credentials
    dataCatalog: $dataCatalog
  ) {
    databases {
      name
    }
  }
}
    `;
export const useAthenaDatabasesNewSourceQuery = <
      TData = AthenaDatabasesNewSourceQuery,
      TError = Error
    >(
      variables: AthenaDatabasesNewSourceQueryVariables, 
      options?: UseQueryOptions<AthenaDatabasesNewSourceQuery, TError, TData>
    ) => 
    useQuery<AthenaDatabasesNewSourceQuery, TError, TData>(
      ['AthenaDatabasesNewSource', variables],
      fetcher<AthenaDatabasesNewSourceQuery, AthenaDatabasesNewSourceQueryVariables>(AthenaDatabasesNewSourceDocument, variables),
      options
    );
useAthenaDatabasesNewSourceQuery.document = AthenaDatabasesNewSourceDocument;

useAthenaDatabasesNewSourceQuery.getKey = (variables: AthenaDatabasesNewSourceQueryVariables) => ['AthenaDatabasesNewSource', variables];

useAthenaDatabasesNewSourceQuery.fetcher = (variables: AthenaDatabasesNewSourceQueryVariables) => fetcher<AthenaDatabasesNewSourceQuery, AthenaDatabasesNewSourceQueryVariables>(AthenaDatabasesNewSourceDocument, variables);
export const ParentModelsDocument = `
    query ParentModels {
  segments(
    where: {is_schema: {_eq: true}, _not: {event: {}}, primary_key: {_is_null: false}}
    order_by: {created_at: desc}
  ) {
    ...AudienceParent
    ...SegmentHistory
    syncable_columns {
      ...SyncableColumn
    }
    connection {
      ...Source
    }
  }
}
    ${AudienceParentFragmentDoc}
${SourceFragmentDoc}
${ColumnFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}
${SegmentHistoryFragmentDoc}
${SyncableColumnFragmentDoc}`;
export const useParentModelsQuery = <
      TData = ParentModelsQuery,
      TError = Error
    >(
      variables?: ParentModelsQueryVariables, 
      options?: UseQueryOptions<ParentModelsQuery, TError, TData>
    ) => 
    useQuery<ParentModelsQuery, TError, TData>(
      variables === undefined ? ['ParentModels'] : ['ParentModels', variables],
      fetcher<ParentModelsQuery, ParentModelsQueryVariables>(ParentModelsDocument, variables),
      options
    );
useParentModelsQuery.document = ParentModelsDocument;

useParentModelsQuery.getKey = (variables?: ParentModelsQueryVariables) => variables === undefined ? ['ParentModels'] : ['ParentModels', variables];

useParentModelsQuery.fetcher = (variables?: ParentModelsQueryVariables) => fetcher<ParentModelsQuery, ParentModelsQueryVariables>(ParentModelsDocument, variables);
export const RelatedModelsDocument = `
    query RelatedModels {
  segments(
    where: {is_schema: {_eq: true}, _not: {event: {}}, primary_key: {_is_null: true}}
    order_by: {created_at: desc}
  ) {
    id
    name
    ...SegmentHistory
    connection {
      ...Source
    }
  }
}
    ${SegmentHistoryFragmentDoc}
${SourceFragmentDoc}`;
export const useRelatedModelsQuery = <
      TData = RelatedModelsQuery,
      TError = Error
    >(
      variables?: RelatedModelsQueryVariables, 
      options?: UseQueryOptions<RelatedModelsQuery, TError, TData>
    ) => 
    useQuery<RelatedModelsQuery, TError, TData>(
      variables === undefined ? ['RelatedModels'] : ['RelatedModels', variables],
      fetcher<RelatedModelsQuery, RelatedModelsQueryVariables>(RelatedModelsDocument, variables),
      options
    );
useRelatedModelsQuery.document = RelatedModelsDocument;

useRelatedModelsQuery.getKey = (variables?: RelatedModelsQueryVariables) => variables === undefined ? ['RelatedModels'] : ['RelatedModels', variables];

useRelatedModelsQuery.fetcher = (variables?: RelatedModelsQueryVariables) => fetcher<RelatedModelsQuery, RelatedModelsQueryVariables>(RelatedModelsDocument, variables);
export const EventsDocument = `
    query Events {
  segments(
    where: {is_schema: {_eq: true}, event: {}}
    order_by: {created_at: desc}
  ) {
    id
    name
    ...SegmentHistory
    connection {
      ...Source
    }
    event {
      timestamp_column
    }
  }
}
    ${SegmentHistoryFragmentDoc}
${SourceFragmentDoc}`;
export const useEventsQuery = <
      TData = EventsQuery,
      TError = Error
    >(
      variables?: EventsQueryVariables, 
      options?: UseQueryOptions<EventsQuery, TError, TData>
    ) => 
    useQuery<EventsQuery, TError, TData>(
      variables === undefined ? ['Events'] : ['Events', variables],
      fetcher<EventsQuery, EventsQueryVariables>(EventsDocument, variables),
      options
    );
useEventsQuery.document = EventsDocument;

useEventsQuery.getKey = (variables?: EventsQueryVariables) => variables === undefined ? ['Events'] : ['Events', variables];

useEventsQuery.fetcher = (variables?: EventsQueryVariables) => fetcher<EventsQuery, EventsQueryVariables>(EventsDocument, variables);
export const DirectRelationshipModelsDocument = `
    query DirectRelationshipModels($sourceId: bigint!) {
  segments(where: {connection_id: {_eq: $sourceId}, is_schema: {_eq: true}}) {
    id
    name
    query_type
    connection_id
    columns {
      ...ObjectColumn
    }
  }
}
    ${ObjectColumnFragmentDoc}
${ColumnFragmentDoc}`;
export const useDirectRelationshipModelsQuery = <
      TData = DirectRelationshipModelsQuery,
      TError = Error
    >(
      variables: DirectRelationshipModelsQueryVariables, 
      options?: UseQueryOptions<DirectRelationshipModelsQuery, TError, TData>
    ) => 
    useQuery<DirectRelationshipModelsQuery, TError, TData>(
      ['DirectRelationshipModels', variables],
      fetcher<DirectRelationshipModelsQuery, DirectRelationshipModelsQueryVariables>(DirectRelationshipModelsDocument, variables),
      options
    );
useDirectRelationshipModelsQuery.document = DirectRelationshipModelsDocument;

useDirectRelationshipModelsQuery.getKey = (variables: DirectRelationshipModelsQueryVariables) => ['DirectRelationshipModels', variables];

useDirectRelationshipModelsQuery.fetcher = (variables: DirectRelationshipModelsQueryVariables) => fetcher<DirectRelationshipModelsQuery, DirectRelationshipModelsQueryVariables>(DirectRelationshipModelsDocument, variables);
export const ParentsDocument = `
    query Parents {
  segments(where: {is_schema: {_eq: true}, primary_key: {_is_null: false}}) {
    ...AudienceParent
  }
}
    ${AudienceParentFragmentDoc}
${SourceFragmentDoc}
${ColumnFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}`;
export const useParentsQuery = <
      TData = ParentsQuery,
      TError = Error
    >(
      variables?: ParentsQueryVariables, 
      options?: UseQueryOptions<ParentsQuery, TError, TData>
    ) => 
    useQuery<ParentsQuery, TError, TData>(
      variables === undefined ? ['Parents'] : ['Parents', variables],
      fetcher<ParentsQuery, ParentsQueryVariables>(ParentsDocument, variables),
      options
    );
useParentsQuery.document = ParentsDocument;

useParentsQuery.getKey = (variables?: ParentsQueryVariables) => variables === undefined ? ['Parents'] : ['Parents', variables];

useParentsQuery.fetcher = (variables?: ParentsQueryVariables) => fetcher<ParentsQuery, ParentsQueryVariables>(ParentsDocument, variables);
export const ObjectDocument = `
    query Object($id: bigint!) {
  segments_by_pk(id: $id) {
    id
    name
    primary_key
    slug
    visual_query_primary_label
    visual_query_secondary_label
    ...QueryFields
    ...SegmentHistory
    connection {
      ...Source
    }
    columns(order_by: {name: desc}) {
      ...ObjectColumn
    }
    relationships {
      ...Relationship
    }
    traits {
      ...TraitDefinition
    }
    event {
      timestamp_column
    }
  }
}
    ${QueryFieldsFragmentDoc}
${SegmentHistoryFragmentDoc}
${SourceFragmentDoc}
${ObjectColumnFragmentDoc}
${ColumnFragmentDoc}
${RelationshipFragmentDoc}
${FilterableColumnFragmentDoc}
${TraitDefinitionFragmentDoc}`;
export const useObjectQuery = <
      TData = ObjectQuery,
      TError = Error
    >(
      variables: ObjectQueryVariables, 
      options?: UseQueryOptions<ObjectQuery, TError, TData>
    ) => 
    useQuery<ObjectQuery, TError, TData>(
      ['Object', variables],
      fetcher<ObjectQuery, ObjectQueryVariables>(ObjectDocument, variables),
      options
    );
useObjectQuery.document = ObjectDocument;

useObjectQuery.getKey = (variables: ObjectQueryVariables) => ['Object', variables];

useObjectQuery.fetcher = (variables: ObjectQueryVariables) => fetcher<ObjectQuery, ObjectQueryVariables>(ObjectDocument, variables);
export const CreateObjectDocument = `
    mutation CreateObject($input: segments_insert_input!) {
  insert_segments_one(object: $input) {
    id
  }
}
    `;
export const useCreateObjectMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateObjectMutation, TError, CreateObjectMutationVariables, TContext>) => 
    useMutation<CreateObjectMutation, TError, CreateObjectMutationVariables, TContext>(
      (variables?: CreateObjectMutationVariables) => fetcher<CreateObjectMutation, CreateObjectMutationVariables>(CreateObjectDocument, variables)(),
      options
    );
export const UpdateObjectDocument = `
    mutation UpdateObject($id: bigint!, $input: segments_set_input!) {
  update_segments_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateObjectMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateObjectMutation, TError, UpdateObjectMutationVariables, TContext>) => 
    useMutation<UpdateObjectMutation, TError, UpdateObjectMutationVariables, TContext>(
      (variables?: UpdateObjectMutationVariables) => fetcher<UpdateObjectMutation, UpdateObjectMutationVariables>(UpdateObjectDocument, variables)(),
      options
    );
export const CreateEventDocument = `
    mutation CreateEvent($input: event_models_insert_input!) {
  insert_event_models_one(object: $input) {
    model_id
  }
}
    `;
export const useCreateEventMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateEventMutation, TError, CreateEventMutationVariables, TContext>) => 
    useMutation<CreateEventMutation, TError, CreateEventMutationVariables, TContext>(
      (variables?: CreateEventMutationVariables) => fetcher<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, variables)(),
      options
    );
export const UpdateEventDocument = `
    mutation UpdateEvent($id: bigint!, $set: event_models_set_input!) {
  update_event_models_by_pk(pk_columns: {model_id: $id}, _set: $set) {
    model_id
  }
}
    `;
export const useUpdateEventMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>) => 
    useMutation<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>(
      (variables?: UpdateEventMutationVariables) => fetcher<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, variables)(),
      options
    );
export const DeleteObjectDocument = `
    mutation DeleteObject($id: bigint!) {
  delete_segments_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteObjectMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteObjectMutation, TError, DeleteObjectMutationVariables, TContext>) => 
    useMutation<DeleteObjectMutation, TError, DeleteObjectMutationVariables, TContext>(
      (variables?: DeleteObjectMutationVariables) => fetcher<DeleteObjectMutation, DeleteObjectMutationVariables>(DeleteObjectDocument, variables)(),
      options
    );
export const CreateTraitDocument = `
    mutation CreateTrait($input: trait_definitions_insert_input!) {
  insert_trait_definitions_one(object: $input) {
    id
  }
}
    `;
export const useCreateTraitMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTraitMutation, TError, CreateTraitMutationVariables, TContext>) => 
    useMutation<CreateTraitMutation, TError, CreateTraitMutationVariables, TContext>(
      (variables?: CreateTraitMutationVariables) => fetcher<CreateTraitMutation, CreateTraitMutationVariables>(CreateTraitDocument, variables)(),
      options
    );
export const UpdateTraitDocument = `
    mutation UpdateTrait($id: uuid!, $input: trait_definitions_set_input!) {
  update_trait_definitions_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateTraitMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTraitMutation, TError, UpdateTraitMutationVariables, TContext>) => 
    useMutation<UpdateTraitMutation, TError, UpdateTraitMutationVariables, TContext>(
      (variables?: UpdateTraitMutationVariables) => fetcher<UpdateTraitMutation, UpdateTraitMutationVariables>(UpdateTraitDocument, variables)(),
      options
    );
export const DeleteTraitDocument = `
    mutation DeleteTrait($id: uuid!) {
  delete_trait_definitions_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteTraitMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTraitMutation, TError, DeleteTraitMutationVariables, TContext>) => 
    useMutation<DeleteTraitMutation, TError, DeleteTraitMutationVariables, TContext>(
      (variables?: DeleteTraitMutationVariables) => fetcher<DeleteTraitMutation, DeleteTraitMutationVariables>(DeleteTraitDocument, variables)(),
      options
    );
export const AudiencesDocument = `
    query Audiences($filters: segments_bool_exp, $limit: Int!, $offset: Int!, $orderBy: segments_order_by! = {created_at: desc}) {
  segments(
    where: $filters
    order_by: [$orderBy, {name: desc}]
    limit: $limit
    offset: $offset
  ) {
    id
    name
    visual_query_filter
    labels: tags
    ...SegmentHistory
    parent {
      ...AudienceParent
    }
    query_runs(limit: 1) {
      size
    }
    syncs(order_by: {destination: {type: asc, name: desc}}) {
      ...Sync
      destination {
        ...Destination
      }
      sync_requests(order_by: {created_at: desc}, limit: 1) {
        ...SyncRequest
        sync_attempts(order_by: {created_at: desc}, limit: 1) {
          ...SyncAttempt
        }
      }
    }
  }
  segments_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    ${SegmentHistoryFragmentDoc}
${AudienceParentFragmentDoc}
${SourceFragmentDoc}
${ColumnFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}
${SyncFragmentDoc}
${DestinationFragmentDoc}
${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useAudiencesQuery = <
      TData = AudiencesQuery,
      TError = Error
    >(
      variables: AudiencesQueryVariables, 
      options?: UseQueryOptions<AudiencesQuery, TError, TData>
    ) => 
    useQuery<AudiencesQuery, TError, TData>(
      ['Audiences', variables],
      fetcher<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, variables),
      options
    );
useAudiencesQuery.document = AudiencesDocument;

useAudiencesQuery.getKey = (variables: AudiencesQueryVariables) => ['Audiences', variables];

useAudiencesQuery.fetcher = (variables: AudiencesQueryVariables) => fetcher<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, variables);
export const AudienceDocument = `
    query Audience($id: bigint!, $orderBy: syncs_order_by! = {created_at: desc}) {
  segments_by_pk(id: $id) {
    id
    name
    visual_query_filter
    labels: tags
    ...SegmentHistory
    syncable_columns {
      ...SyncableColumn
    }
    parent {
      ...AudienceParent
    }
    connection {
      ...Source
    }
    syncs(order_by: [$orderBy]) {
      sync_template_id
      ...Sync
      ...SyncHistory
      row_threshold_attempted
      row_threshold_total
      sync_alerts {
        ...SyncAlert
      }
      destination {
        ...Destination
        definition {
          icon
          name
        }
      }
      sync_requests(order_by: {created_at: desc}, limit: 1) {
        ...SyncRequest
        sync_attempts(order_by: {created_at: desc}, limit: 1) {
          ...SyncAttempt
        }
      }
    }
  }
}
    ${SegmentHistoryFragmentDoc}
${SyncableColumnFragmentDoc}
${AudienceParentFragmentDoc}
${SourceFragmentDoc}
${ColumnFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}
${SyncFragmentDoc}
${SyncHistoryFragmentDoc}
${SyncAlertFragmentDoc}
${DestinationFragmentDoc}
${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useAudienceQuery = <
      TData = AudienceQuery,
      TError = Error
    >(
      variables: AudienceQueryVariables, 
      options?: UseQueryOptions<AudienceQuery, TError, TData>
    ) => 
    useQuery<AudienceQuery, TError, TData>(
      ['Audience', variables],
      fetcher<AudienceQuery, AudienceQueryVariables>(AudienceDocument, variables),
      options
    );
useAudienceQuery.document = AudienceDocument;

useAudienceQuery.getKey = (variables: AudienceQueryVariables) => ['Audience', variables];

useAudienceQuery.fetcher = (variables: AudienceQueryVariables) => fetcher<AudienceQuery, AudienceQueryVariables>(AudienceDocument, variables);
export const RelatedAudiencesDocument = `
    query RelatedAudiences($parentModelId: bigint!, $modelId: bigint) {
  segments(
    where: {visual_query_parent_id: {_eq: $parentModelId}, id: {_neq: $modelId}}
  ) {
    id
    name
  }
}
    `;
export const useRelatedAudiencesQuery = <
      TData = RelatedAudiencesQuery,
      TError = Error
    >(
      variables: RelatedAudiencesQueryVariables, 
      options?: UseQueryOptions<RelatedAudiencesQuery, TError, TData>
    ) => 
    useQuery<RelatedAudiencesQuery, TError, TData>(
      ['RelatedAudiences', variables],
      fetcher<RelatedAudiencesQuery, RelatedAudiencesQueryVariables>(RelatedAudiencesDocument, variables),
      options
    );
useRelatedAudiencesQuery.document = RelatedAudiencesDocument;

useRelatedAudiencesQuery.getKey = (variables: RelatedAudiencesQueryVariables) => ['RelatedAudiences', variables];

useRelatedAudiencesQuery.fetcher = (variables: RelatedAudiencesQueryVariables) => fetcher<RelatedAudiencesQuery, RelatedAudiencesQueryVariables>(RelatedAudiencesDocument, variables);
export const CreateAudienceDocument = `
    mutation CreateAudience($input: segments_insert_input!) {
  insert_segments_one(object: $input) {
    id
  }
}
    `;
export const useCreateAudienceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAudienceMutation, TError, CreateAudienceMutationVariables, TContext>) => 
    useMutation<CreateAudienceMutation, TError, CreateAudienceMutationVariables, TContext>(
      (variables?: CreateAudienceMutationVariables) => fetcher<CreateAudienceMutation, CreateAudienceMutationVariables>(CreateAudienceDocument, variables)(),
      options
    );
export const UpdateAudienceDocument = `
    mutation UpdateAudience($id: bigint!, $input: segments_set_input!) {
  update_segments_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateAudienceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAudienceMutation, TError, UpdateAudienceMutationVariables, TContext>) => 
    useMutation<UpdateAudienceMutation, TError, UpdateAudienceMutationVariables, TContext>(
      (variables?: UpdateAudienceMutationVariables) => fetcher<UpdateAudienceMutation, UpdateAudienceMutationVariables>(UpdateAudienceDocument, variables)(),
      options
    );
export const AddLabelsToAudiencesDocument = `
    mutation AddLabelsToAudiences($ids: [bigint!]!, $labels: jsonb!) {
  update_segments(where: {id: {_in: $ids}}, _append: {tags: $labels}) {
    affected_rows
  }
}
    `;
export const useAddLabelsToAudiencesMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<AddLabelsToAudiencesMutation, TError, AddLabelsToAudiencesMutationVariables, TContext>) => 
    useMutation<AddLabelsToAudiencesMutation, TError, AddLabelsToAudiencesMutationVariables, TContext>(
      (variables?: AddLabelsToAudiencesMutationVariables) => fetcher<AddLabelsToAudiencesMutation, AddLabelsToAudiencesMutationVariables>(AddLabelsToAudiencesDocument, variables)(),
      options
    );
export const DeleteAudienceDocument = `
    mutation DeleteAudience($id: bigint!) {
  delete_segments_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteAudienceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAudienceMutation, TError, DeleteAudienceMutationVariables, TContext>) => 
    useMutation<DeleteAudienceMutation, TError, DeleteAudienceMutationVariables, TContext>(
      (variables?: DeleteAudienceMutationVariables) => fetcher<DeleteAudienceMutation, DeleteAudienceMutationVariables>(DeleteAudienceDocument, variables)(),
      options
    );
export const CreateGoogleServiceAccountDocument = `
    mutation CreateGoogleServiceAccount {
  createGoogleServiceAccount {
    ... on CreateGoogleServiceAccountSuccess {
      serviceAccount {
        email
        credentials
      }
    }
  }
}
    `;
export const useCreateGoogleServiceAccountMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGoogleServiceAccountMutation, TError, CreateGoogleServiceAccountMutationVariables, TContext>) => 
    useMutation<CreateGoogleServiceAccountMutation, TError, CreateGoogleServiceAccountMutationVariables, TContext>(
      (variables?: CreateGoogleServiceAccountMutationVariables) => fetcher<CreateGoogleServiceAccountMutation, CreateGoogleServiceAccountMutationVariables>(CreateGoogleServiceAccountDocument, variables)(),
      options
    );
export const PortalUrlDocument = `
    query PortalUrl($customer_id: String!) {
  getPortalUrl(customer_id: $customer_id) {
    redirect
  }
}
    `;
export const usePortalUrlQuery = <
      TData = PortalUrlQuery,
      TError = Error
    >(
      variables: PortalUrlQueryVariables, 
      options?: UseQueryOptions<PortalUrlQuery, TError, TData>
    ) => 
    useQuery<PortalUrlQuery, TError, TData>(
      ['PortalUrl', variables],
      fetcher<PortalUrlQuery, PortalUrlQueryVariables>(PortalUrlDocument, variables),
      options
    );
usePortalUrlQuery.document = PortalUrlDocument;

usePortalUrlQuery.getKey = (variables: PortalUrlQueryVariables) => ['PortalUrl', variables];

usePortalUrlQuery.fetcher = (variables: PortalUrlQueryVariables) => fetcher<PortalUrlQuery, PortalUrlQueryVariables>(PortalUrlDocument, variables);
export const CheckoutUrlDocument = `
    query CheckoutUrl($lookup_key: String!, $org_name: String!, $workspace_id: Int!) {
  getCheckoutUrl(
    lookup_key: $lookup_key
    org_name: $org_name
    workspace_id: $workspace_id
  ) {
    redirect
  }
}
    `;
export const useCheckoutUrlQuery = <
      TData = CheckoutUrlQuery,
      TError = Error
    >(
      variables: CheckoutUrlQueryVariables, 
      options?: UseQueryOptions<CheckoutUrlQuery, TError, TData>
    ) => 
    useQuery<CheckoutUrlQuery, TError, TData>(
      ['CheckoutUrl', variables],
      fetcher<CheckoutUrlQuery, CheckoutUrlQueryVariables>(CheckoutUrlDocument, variables),
      options
    );
useCheckoutUrlQuery.document = CheckoutUrlDocument;

useCheckoutUrlQuery.getKey = (variables: CheckoutUrlQueryVariables) => ['CheckoutUrl', variables];

useCheckoutUrlQuery.fetcher = (variables: CheckoutUrlQueryVariables) => fetcher<CheckoutUrlQuery, CheckoutUrlQueryVariables>(CheckoutUrlDocument, variables);
export const CreateModelColumnDocument = `
    mutation CreateModelColumn($input: model_columns_insert_input!) {
  insert_model_columns_one(object: $input) {
    model_id
  }
}
    `;
export const useCreateModelColumnMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateModelColumnMutation, TError, CreateModelColumnMutationVariables, TContext>) => 
    useMutation<CreateModelColumnMutation, TError, CreateModelColumnMutationVariables, TContext>(
      (variables?: CreateModelColumnMutationVariables) => fetcher<CreateModelColumnMutation, CreateModelColumnMutationVariables>(CreateModelColumnDocument, variables)(),
      options
    );
export const UpdateModelColumnDocument = `
    mutation UpdateModelColumn($id: bigint!, $name: String!, $input: model_columns_set_input) {
  update_model_columns_by_pk(
    pk_columns: {model_id: $id, name: $name}
    _set: $input
  ) {
    model_id
  }
}
    `;
export const useUpdateModelColumnMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateModelColumnMutation, TError, UpdateModelColumnMutationVariables, TContext>) => 
    useMutation<UpdateModelColumnMutation, TError, UpdateModelColumnMutationVariables, TContext>(
      (variables?: UpdateModelColumnMutationVariables) => fetcher<UpdateModelColumnMutation, UpdateModelColumnMutationVariables>(UpdateModelColumnDocument, variables)(),
      options
    );
export const UpdateModelColumnsDocument = `
    mutation UpdateModelColumns($id: bigint!, $input: model_columns_set_input) {
  update_model_columns(where: {model_id: {_eq: $id}}, _set: $input) {
    affected_rows
  }
}
    `;
export const useUpdateModelColumnsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateModelColumnsMutation, TError, UpdateModelColumnsMutationVariables, TContext>) => 
    useMutation<UpdateModelColumnsMutation, TError, UpdateModelColumnsMutationVariables, TContext>(
      (variables?: UpdateModelColumnsMutationVariables) => fetcher<UpdateModelColumnsMutation, UpdateModelColumnsMutationVariables>(UpdateModelColumnsDocument, variables)(),
      options
    );
export const DeleteModelColumnsDocument = `
    mutation DeleteModelColumns($modelId: bigint!, $names: [String!]!) {
  delete_model_columns(where: {model_id: {_eq: $modelId}, name: {_in: $names}}) {
    affected_rows
  }
}
    `;
export const useDeleteModelColumnsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteModelColumnsMutation, TError, DeleteModelColumnsMutationVariables, TContext>) => 
    useMutation<DeleteModelColumnsMutation, TError, DeleteModelColumnsMutationVariables, TContext>(
      (variables?: DeleteModelColumnsMutationVariables) => fetcher<DeleteModelColumnsMutation, DeleteModelColumnsMutationVariables>(DeleteModelColumnsDocument, variables)(),
      options
    );
export const ColumnSuggestionsDocument = `
    query ColumnSuggestions($ids: [String!]!) {
  getTopK(modelIds: $ids) {
    columns {
      modelId
      name
      error
      values
    }
  }
}
    `;
export const useColumnSuggestionsQuery = <
      TData = ColumnSuggestionsQuery,
      TError = Error
    >(
      variables: ColumnSuggestionsQueryVariables, 
      options?: UseQueryOptions<ColumnSuggestionsQuery, TError, TData>
    ) => 
    useQuery<ColumnSuggestionsQuery, TError, TData>(
      ['ColumnSuggestions', variables],
      fetcher<ColumnSuggestionsQuery, ColumnSuggestionsQueryVariables>(ColumnSuggestionsDocument, variables),
      options
    );
useColumnSuggestionsQuery.document = ColumnSuggestionsDocument;

useColumnSuggestionsQuery.getKey = (variables: ColumnSuggestionsQueryVariables) => ['ColumnSuggestions', variables];

useColumnSuggestionsQuery.fetcher = (variables: ColumnSuggestionsQueryVariables) => fetcher<ColumnSuggestionsQuery, ColumnSuggestionsQueryVariables>(ColumnSuggestionsDocument, variables);
export const CloudCredentialsDocument = `
    query CloudCredentials {
  cloud_credentials {
    id
    created_at
    provider
    name
    stripped_config
  }
}
    `;
export const useCloudCredentialsQuery = <
      TData = CloudCredentialsQuery,
      TError = Error
    >(
      variables?: CloudCredentialsQueryVariables, 
      options?: UseQueryOptions<CloudCredentialsQuery, TError, TData>
    ) => 
    useQuery<CloudCredentialsQuery, TError, TData>(
      variables === undefined ? ['CloudCredentials'] : ['CloudCredentials', variables],
      fetcher<CloudCredentialsQuery, CloudCredentialsQueryVariables>(CloudCredentialsDocument, variables),
      options
    );
useCloudCredentialsQuery.document = CloudCredentialsDocument;

useCloudCredentialsQuery.getKey = (variables?: CloudCredentialsQueryVariables) => variables === undefined ? ['CloudCredentials'] : ['CloudCredentials', variables];

useCloudCredentialsQuery.fetcher = (variables?: CloudCredentialsQueryVariables) => fetcher<CloudCredentialsQuery, CloudCredentialsQueryVariables>(CloudCredentialsDocument, variables);
export const CloudCredentialDocument = `
    query CloudCredential($id: bigint!) {
  cloud_credentials_by_pk(id: $id) {
    id
    created_at
    provider
    name
    stripped_config
  }
}
    `;
export const useCloudCredentialQuery = <
      TData = CloudCredentialQuery,
      TError = Error
    >(
      variables: CloudCredentialQueryVariables, 
      options?: UseQueryOptions<CloudCredentialQuery, TError, TData>
    ) => 
    useQuery<CloudCredentialQuery, TError, TData>(
      ['CloudCredential', variables],
      fetcher<CloudCredentialQuery, CloudCredentialQueryVariables>(CloudCredentialDocument, variables),
      options
    );
useCloudCredentialQuery.document = CloudCredentialDocument;

useCloudCredentialQuery.getKey = (variables: CloudCredentialQueryVariables) => ['CloudCredential', variables];

useCloudCredentialQuery.fetcher = (variables: CloudCredentialQueryVariables) => fetcher<CloudCredentialQuery, CloudCredentialQueryVariables>(CloudCredentialDocument, variables);
export const ProviderCloudCredentialsDocument = `
    query ProviderCloudCredentials($provider: String!) {
  cloud_credentials(where: {provider: {_eq: $provider}}) {
    id
    created_at
    provider
    name
    stripped_config
  }
}
    `;
export const useProviderCloudCredentialsQuery = <
      TData = ProviderCloudCredentialsQuery,
      TError = Error
    >(
      variables: ProviderCloudCredentialsQueryVariables, 
      options?: UseQueryOptions<ProviderCloudCredentialsQuery, TError, TData>
    ) => 
    useQuery<ProviderCloudCredentialsQuery, TError, TData>(
      ['ProviderCloudCredentials', variables],
      fetcher<ProviderCloudCredentialsQuery, ProviderCloudCredentialsQueryVariables>(ProviderCloudCredentialsDocument, variables),
      options
    );
useProviderCloudCredentialsQuery.document = ProviderCloudCredentialsDocument;

useProviderCloudCredentialsQuery.getKey = (variables: ProviderCloudCredentialsQueryVariables) => ['ProviderCloudCredentials', variables];

useProviderCloudCredentialsQuery.fetcher = (variables: ProviderCloudCredentialsQueryVariables) => fetcher<ProviderCloudCredentialsQuery, ProviderCloudCredentialsQueryVariables>(ProviderCloudCredentialsDocument, variables);
export const CreateCloudCredentialDocument = `
    mutation CreateCloudCredential($input: cloud_credentials_insert_input!) {
  insert_cloud_credentials_one(object: $input) {
    id
    provider
  }
}
    `;
export const useCreateCloudCredentialMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCloudCredentialMutation, TError, CreateCloudCredentialMutationVariables, TContext>) => 
    useMutation<CreateCloudCredentialMutation, TError, CreateCloudCredentialMutationVariables, TContext>(
      (variables?: CreateCloudCredentialMutationVariables) => fetcher<CreateCloudCredentialMutation, CreateCloudCredentialMutationVariables>(CreateCloudCredentialDocument, variables)(),
      options
    );
export const DeleteCloudCredentialsDocument = `
    mutation DeleteCloudCredentials($ids: [bigint!]!) {
  delete_cloud_credentials(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteCloudCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCloudCredentialsMutation, TError, DeleteCloudCredentialsMutationVariables, TContext>) => 
    useMutation<DeleteCloudCredentialsMutation, TError, DeleteCloudCredentialsMutationVariables, TContext>(
      (variables?: DeleteCloudCredentialsMutationVariables) => fetcher<DeleteCloudCredentialsMutation, DeleteCloudCredentialsMutationVariables>(DeleteCloudCredentialsDocument, variables)(),
      options
    );
export const DatadogCredentialsDocument = `
    query DatadogCredentials {
  datadog_credentials {
    id
    created_at
    site
  }
}
    `;
export const useDatadogCredentialsQuery = <
      TData = DatadogCredentialsQuery,
      TError = Error
    >(
      variables?: DatadogCredentialsQueryVariables, 
      options?: UseQueryOptions<DatadogCredentialsQuery, TError, TData>
    ) => 
    useQuery<DatadogCredentialsQuery, TError, TData>(
      variables === undefined ? ['DatadogCredentials'] : ['DatadogCredentials', variables],
      fetcher<DatadogCredentialsQuery, DatadogCredentialsQueryVariables>(DatadogCredentialsDocument, variables),
      options
    );
useDatadogCredentialsQuery.document = DatadogCredentialsDocument;

useDatadogCredentialsQuery.getKey = (variables?: DatadogCredentialsQueryVariables) => variables === undefined ? ['DatadogCredentials'] : ['DatadogCredentials', variables];

useDatadogCredentialsQuery.fetcher = (variables?: DatadogCredentialsQueryVariables) => fetcher<DatadogCredentialsQuery, DatadogCredentialsQueryVariables>(DatadogCredentialsDocument, variables);
export const WorkspaceDatadogCredentialsDocument = `
    query WorkspaceDatadogCredentials($workspace: Int!) {
  datadog_credentials(where: {workspace_id: {_eq: $workspace}}) {
    id
    created_at
    site
  }
}
    `;
export const useWorkspaceDatadogCredentialsQuery = <
      TData = WorkspaceDatadogCredentialsQuery,
      TError = Error
    >(
      variables: WorkspaceDatadogCredentialsQueryVariables, 
      options?: UseQueryOptions<WorkspaceDatadogCredentialsQuery, TError, TData>
    ) => 
    useQuery<WorkspaceDatadogCredentialsQuery, TError, TData>(
      ['WorkspaceDatadogCredentials', variables],
      fetcher<WorkspaceDatadogCredentialsQuery, WorkspaceDatadogCredentialsQueryVariables>(WorkspaceDatadogCredentialsDocument, variables),
      options
    );
useWorkspaceDatadogCredentialsQuery.document = WorkspaceDatadogCredentialsDocument;

useWorkspaceDatadogCredentialsQuery.getKey = (variables: WorkspaceDatadogCredentialsQueryVariables) => ['WorkspaceDatadogCredentials', variables];

useWorkspaceDatadogCredentialsQuery.fetcher = (variables: WorkspaceDatadogCredentialsQueryVariables) => fetcher<WorkspaceDatadogCredentialsQuery, WorkspaceDatadogCredentialsQueryVariables>(WorkspaceDatadogCredentialsDocument, variables);
export const CreateDatadogCredentialsDocument = `
    mutation CreateDatadogCredentials($input: datadog_credentials_insert_input!) {
  insert_datadog_credentials_one(object: $input) {
    id
    site
  }
}
    `;
export const useCreateDatadogCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDatadogCredentialsMutation, TError, CreateDatadogCredentialsMutationVariables, TContext>) => 
    useMutation<CreateDatadogCredentialsMutation, TError, CreateDatadogCredentialsMutationVariables, TContext>(
      (variables?: CreateDatadogCredentialsMutationVariables) => fetcher<CreateDatadogCredentialsMutation, CreateDatadogCredentialsMutationVariables>(CreateDatadogCredentialsDocument, variables)(),
      options
    );
export const UpdateDatadogCredentialsDocument = `
    mutation UpdateDatadogCredentials($id: Int!, $credentials: datadog_credentials_set_input!) {
  update_datadog_credentials_by_pk(pk_columns: {id: $id}, _set: $credentials) {
    id
    site
  }
}
    `;
export const useUpdateDatadogCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDatadogCredentialsMutation, TError, UpdateDatadogCredentialsMutationVariables, TContext>) => 
    useMutation<UpdateDatadogCredentialsMutation, TError, UpdateDatadogCredentialsMutationVariables, TContext>(
      (variables?: UpdateDatadogCredentialsMutationVariables) => fetcher<UpdateDatadogCredentialsMutation, UpdateDatadogCredentialsMutationVariables>(UpdateDatadogCredentialsDocument, variables)(),
      options
    );
export const ValidateDatadogCredentialsDocument = `
    query ValidateDatadogCredentials($site: String!, $apiKey: String!) {
  ValidateDatadogCredentials(input: {site: $site, apiKey: $apiKey}) {
    ... on ValidateDatadogCredentialsOutput {
      success
      message
    }
  }
}
    `;
export const useValidateDatadogCredentialsQuery = <
      TData = ValidateDatadogCredentialsQuery,
      TError = Error
    >(
      variables: ValidateDatadogCredentialsQueryVariables, 
      options?: UseQueryOptions<ValidateDatadogCredentialsQuery, TError, TData>
    ) => 
    useQuery<ValidateDatadogCredentialsQuery, TError, TData>(
      ['ValidateDatadogCredentials', variables],
      fetcher<ValidateDatadogCredentialsQuery, ValidateDatadogCredentialsQueryVariables>(ValidateDatadogCredentialsDocument, variables),
      options
    );
useValidateDatadogCredentialsQuery.document = ValidateDatadogCredentialsDocument;

useValidateDatadogCredentialsQuery.getKey = (variables: ValidateDatadogCredentialsQueryVariables) => ['ValidateDatadogCredentials', variables];

useValidateDatadogCredentialsQuery.fetcher = (variables: ValidateDatadogCredentialsQueryVariables) => fetcher<ValidateDatadogCredentialsQuery, ValidateDatadogCredentialsQueryVariables>(ValidateDatadogCredentialsDocument, variables);
export const DbtSyncConfigsDocument = `
    query DbtSyncConfigs {
  dbt_sync_config {
    id
    git_credentials_id
    git_credentials {
      id
      type
    }
    env_vars
    version
    last_run_at
    selector
    path
    target
    enabled
    branch
    repository
    default_schema
    error
    connection_id
  }
}
    `;
export const useDbtSyncConfigsQuery = <
      TData = DbtSyncConfigsQuery,
      TError = Error
    >(
      variables?: DbtSyncConfigsQueryVariables, 
      options?: UseQueryOptions<DbtSyncConfigsQuery, TError, TData>
    ) => 
    useQuery<DbtSyncConfigsQuery, TError, TData>(
      variables === undefined ? ['DbtSyncConfigs'] : ['DbtSyncConfigs', variables],
      fetcher<DbtSyncConfigsQuery, DbtSyncConfigsQueryVariables>(DbtSyncConfigsDocument, variables),
      options
    );
useDbtSyncConfigsQuery.document = DbtSyncConfigsDocument;

useDbtSyncConfigsQuery.getKey = (variables?: DbtSyncConfigsQueryVariables) => variables === undefined ? ['DbtSyncConfigs'] : ['DbtSyncConfigs', variables];

useDbtSyncConfigsQuery.fetcher = (variables?: DbtSyncConfigsQueryVariables) => fetcher<DbtSyncConfigsQuery, DbtSyncConfigsQueryVariables>(DbtSyncConfigsDocument, variables);
export const DbtSyncConfigDocument = `
    query DbtSyncConfig($sourceId: bigint!) {
  dbt_sync_config(where: {connection_id: {_eq: $sourceId}}) {
    id
    git_credentials_id
    git_credentials {
      id
      type
    }
    env_vars
    version
    last_run_at
    selector
    path
    target
    enabled
    branch
    repository
    default_schema
    error
  }
}
    `;
export const useDbtSyncConfigQuery = <
      TData = DbtSyncConfigQuery,
      TError = Error
    >(
      variables: DbtSyncConfigQueryVariables, 
      options?: UseQueryOptions<DbtSyncConfigQuery, TError, TData>
    ) => 
    useQuery<DbtSyncConfigQuery, TError, TData>(
      ['DbtSyncConfig', variables],
      fetcher<DbtSyncConfigQuery, DbtSyncConfigQueryVariables>(DbtSyncConfigDocument, variables),
      options
    );
useDbtSyncConfigQuery.document = DbtSyncConfigDocument;

useDbtSyncConfigQuery.getKey = (variables: DbtSyncConfigQueryVariables) => ['DbtSyncConfig', variables];

useDbtSyncConfigQuery.fetcher = (variables: DbtSyncConfigQueryVariables) => fetcher<DbtSyncConfigQuery, DbtSyncConfigQueryVariables>(DbtSyncConfigDocument, variables);
export const DbtSyncModelsDocument = `
    query DbtSyncModels($sourceId: bigint!) {
  dbt_sync_models(
    where: {dbt_sync_config: {connection_id: {_eq: $sourceId}}}
    order_by: {schema: asc, name: asc}
  ) {
    id
    name
    schema
    removed
    dbt_unique_id
    dbt_sync_config {
      id
      branch
      repository
      git_credentials {
        type
        username
      }
    }
    data
  }
}
    `;
export const useDbtSyncModelsQuery = <
      TData = DbtSyncModelsQuery,
      TError = Error
    >(
      variables: DbtSyncModelsQueryVariables, 
      options?: UseQueryOptions<DbtSyncModelsQuery, TError, TData>
    ) => 
    useQuery<DbtSyncModelsQuery, TError, TData>(
      ['DbtSyncModels', variables],
      fetcher<DbtSyncModelsQuery, DbtSyncModelsQueryVariables>(DbtSyncModelsDocument, variables),
      options
    );
useDbtSyncModelsQuery.document = DbtSyncModelsDocument;

useDbtSyncModelsQuery.getKey = (variables: DbtSyncModelsQueryVariables) => ['DbtSyncModels', variables];

useDbtSyncModelsQuery.fetcher = (variables: DbtSyncModelsQueryVariables) => fetcher<DbtSyncModelsQuery, DbtSyncModelsQueryVariables>(DbtSyncModelsDocument, variables);
export const DbtModelsDocument = `
    query DbtModels {
  dbt_models {
    id
    alias
    description
    original_file_path
    name
    git_sync_config {
      id
      schema
    }
  }
}
    `;
export const useDbtModelsQuery = <
      TData = DbtModelsQuery,
      TError = Error
    >(
      variables?: DbtModelsQueryVariables, 
      options?: UseQueryOptions<DbtModelsQuery, TError, TData>
    ) => 
    useQuery<DbtModelsQuery, TError, TData>(
      variables === undefined ? ['DbtModels'] : ['DbtModels', variables],
      fetcher<DbtModelsQuery, DbtModelsQueryVariables>(DbtModelsDocument, variables),
      options
    );
useDbtModelsQuery.document = DbtModelsDocument;

useDbtModelsQuery.getKey = (variables?: DbtModelsQueryVariables) => variables === undefined ? ['DbtModels'] : ['DbtModels', variables];

useDbtModelsQuery.fetcher = (variables?: DbtModelsQueryVariables) => fetcher<DbtModelsQuery, DbtModelsQueryVariables>(DbtModelsDocument, variables);
export const DbtModelDocument = `
    query DbtModel($id: Int!) {
  dbt_models_by_pk(id: $id) {
    name
    alias
    original_file_path
    last_commit_synced
    description
    git_sync_config {
      schema
      repository
    }
  }
}
    `;
export const useDbtModelQuery = <
      TData = DbtModelQuery,
      TError = Error
    >(
      variables: DbtModelQueryVariables, 
      options?: UseQueryOptions<DbtModelQuery, TError, TData>
    ) => 
    useQuery<DbtModelQuery, TError, TData>(
      ['DbtModel', variables],
      fetcher<DbtModelQuery, DbtModelQueryVariables>(DbtModelDocument, variables),
      options
    );
useDbtModelQuery.document = DbtModelDocument;

useDbtModelQuery.getKey = (variables: DbtModelQueryVariables) => ['DbtModel', variables];

useDbtModelQuery.fetcher = (variables: DbtModelQueryVariables) => fetcher<DbtModelQuery, DbtModelQueryVariables>(DbtModelDocument, variables);
export const DbtSyncModelDocument = `
    query DbtSyncModel($id: bigint!) {
  dbt_sync_models_by_pk(id: $id) {
    id
    name
    schema
    dbt_unique_id
    dbt_sync_config {
      id
      branch
      repository
      git_credentials {
        type
        username
      }
    }
    data
  }
}
    `;
export const useDbtSyncModelQuery = <
      TData = DbtSyncModelQuery,
      TError = Error
    >(
      variables: DbtSyncModelQueryVariables, 
      options?: UseQueryOptions<DbtSyncModelQuery, TError, TData>
    ) => 
    useQuery<DbtSyncModelQuery, TError, TData>(
      ['DbtSyncModel', variables],
      fetcher<DbtSyncModelQuery, DbtSyncModelQueryVariables>(DbtSyncModelDocument, variables),
      options
    );
useDbtSyncModelQuery.document = DbtSyncModelDocument;

useDbtSyncModelQuery.getKey = (variables: DbtSyncModelQueryVariables) => ['DbtSyncModel', variables];

useDbtSyncModelQuery.fetcher = (variables: DbtSyncModelQueryVariables) => fetcher<DbtSyncModelQuery, DbtSyncModelQueryVariables>(DbtSyncModelDocument, variables);
export const UpdateDbtSyncConfigDocument = `
    mutation UpdateDbtSyncConfig($id: bigint!, $object: dbt_sync_config_set_input) {
  update_dbt_sync_config_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    version
    git_credentials_id
    selector
    path
    enabled
    branch
    repository
    default_schema
  }
}
    `;
export const useUpdateDbtSyncConfigMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDbtSyncConfigMutation, TError, UpdateDbtSyncConfigMutationVariables, TContext>) => 
    useMutation<UpdateDbtSyncConfigMutation, TError, UpdateDbtSyncConfigMutationVariables, TContext>(
      (variables?: UpdateDbtSyncConfigMutationVariables) => fetcher<UpdateDbtSyncConfigMutation, UpdateDbtSyncConfigMutationVariables>(UpdateDbtSyncConfigDocument, variables)(),
      options
    );
export const CreateDbtSyncConfigDocument = `
    mutation CreateDbtSyncConfig($object: dbt_sync_config_insert_input!) {
  insert_dbt_sync_config_one(object: $object) {
    id
    version
    git_credentials_id
    selector
    path
    enabled
    branch
    repository
    default_schema
  }
}
    `;
export const useCreateDbtSyncConfigMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDbtSyncConfigMutation, TError, CreateDbtSyncConfigMutationVariables, TContext>) => 
    useMutation<CreateDbtSyncConfigMutation, TError, CreateDbtSyncConfigMutationVariables, TContext>(
      (variables?: CreateDbtSyncConfigMutationVariables) => fetcher<CreateDbtSyncConfigMutation, CreateDbtSyncConfigMutationVariables>(CreateDbtSyncConfigDocument, variables)(),
      options
    );
export const DbtAccountsDocument = `
    query DBTAccounts($apiKey: String!, $subdomain: String) {
  getDBTAccounts(apiKey: $apiKey, subdomain: $subdomain) {
    id
    name
  }
}
    `;
export const useDbtAccountsQuery = <
      TData = DbtAccountsQuery,
      TError = Error
    >(
      variables: DbtAccountsQueryVariables, 
      options?: UseQueryOptions<DbtAccountsQuery, TError, TData>
    ) => 
    useQuery<DbtAccountsQuery, TError, TData>(
      ['DBTAccounts', variables],
      fetcher<DbtAccountsQuery, DbtAccountsQueryVariables>(DbtAccountsDocument, variables),
      options
    );
useDbtAccountsQuery.document = DbtAccountsDocument;

useDbtAccountsQuery.getKey = (variables: DbtAccountsQueryVariables) => ['DBTAccounts', variables];

useDbtAccountsQuery.fetcher = (variables: DbtAccountsQueryVariables) => fetcher<DbtAccountsQuery, DbtAccountsQueryVariables>(DbtAccountsDocument, variables);
export const DbtJobsDocument = `
    query DBTJobs($accountId: String!, $apiKey: String!, $subdomain: String) {
  getDBTJobs(accountId: $accountId, apiKey: $apiKey, subdomain: $subdomain) {
    id
    name
  }
}
    `;
export const useDbtJobsQuery = <
      TData = DbtJobsQuery,
      TError = Error
    >(
      variables: DbtJobsQueryVariables, 
      options?: UseQueryOptions<DbtJobsQuery, TError, TData>
    ) => 
    useQuery<DbtJobsQuery, TError, TData>(
      ['DBTJobs', variables],
      fetcher<DbtJobsQuery, DbtJobsQueryVariables>(DbtJobsDocument, variables),
      options
    );
useDbtJobsQuery.document = DbtJobsDocument;

useDbtJobsQuery.getKey = (variables: DbtJobsQueryVariables) => ['DBTJobs', variables];

useDbtJobsQuery.fetcher = (variables: DbtJobsQueryVariables) => fetcher<DbtJobsQuery, DbtJobsQueryVariables>(DbtJobsDocument, variables);
export const DbtCredentialsDocument = `
    query DBTCredentials {
  dbt_credentials {
    id
    api_key
    subdomain
  }
}
    `;
export const useDbtCredentialsQuery = <
      TData = DbtCredentialsQuery,
      TError = Error
    >(
      variables?: DbtCredentialsQueryVariables, 
      options?: UseQueryOptions<DbtCredentialsQuery, TError, TData>
    ) => 
    useQuery<DbtCredentialsQuery, TError, TData>(
      variables === undefined ? ['DBTCredentials'] : ['DBTCredentials', variables],
      fetcher<DbtCredentialsQuery, DbtCredentialsQueryVariables>(DbtCredentialsDocument, variables),
      options
    );
useDbtCredentialsQuery.document = DbtCredentialsDocument;

useDbtCredentialsQuery.getKey = (variables?: DbtCredentialsQueryVariables) => variables === undefined ? ['DBTCredentials'] : ['DBTCredentials', variables];

useDbtCredentialsQuery.fetcher = (variables?: DbtCredentialsQueryVariables) => fetcher<DbtCredentialsQuery, DbtCredentialsQueryVariables>(DbtCredentialsDocument, variables);
export const CreateDbtCredentialDocument = `
    mutation CreateDBTCredential($api_key: String!, $subdomain: String) {
  createDBTCredential(apiKey: $api_key, subdomain: $subdomain) {
    id
    api_key
    subdomain
  }
}
    `;
export const useCreateDbtCredentialMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDbtCredentialMutation, TError, CreateDbtCredentialMutationVariables, TContext>) => 
    useMutation<CreateDbtCredentialMutation, TError, CreateDbtCredentialMutationVariables, TContext>(
      (variables?: CreateDbtCredentialMutationVariables) => fetcher<CreateDbtCredentialMutation, CreateDbtCredentialMutationVariables>(CreateDbtCredentialDocument, variables)(),
      options
    );
export const UpdateDbtCredentialDocument = `
    mutation UpdateDBTCredential($id: Int!, $api_key: String!, $subdomain: String) {
  updateDBTCredential(
    dbtCredentialId: $id
    apiKey: $api_key
    subdomain: $subdomain
  ) {
    id
    api_key
    subdomain
  }
}
    `;
export const useUpdateDbtCredentialMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDbtCredentialMutation, TError, UpdateDbtCredentialMutationVariables, TContext>) => 
    useMutation<UpdateDbtCredentialMutation, TError, UpdateDbtCredentialMutationVariables, TContext>(
      (variables?: UpdateDbtCredentialMutationVariables) => fetcher<UpdateDbtCredentialMutation, UpdateDbtCredentialMutationVariables>(UpdateDbtCredentialDocument, variables)(),
      options
    );
export const DestinationDocument = `
    query Destination($id: bigint!) {
  destinations_by_pk(id: $id) {
    tags
    ...Destination
    ...DestinationHistory
  }
}
    ${DestinationFragmentDoc}
${DestinationHistoryFragmentDoc}`;
export const useDestinationQuery = <
      TData = DestinationQuery,
      TError = Error
    >(
      variables: DestinationQueryVariables, 
      options?: UseQueryOptions<DestinationQuery, TError, TData>
    ) => 
    useQuery<DestinationQuery, TError, TData>(
      ['Destination', variables],
      fetcher<DestinationQuery, DestinationQueryVariables>(DestinationDocument, variables),
      options
    );
useDestinationQuery.document = DestinationDocument;

useDestinationQuery.getKey = (variables: DestinationQueryVariables) => ['Destination', variables];

useDestinationQuery.fetcher = (variables: DestinationQueryVariables) => fetcher<DestinationQuery, DestinationQueryVariables>(DestinationDocument, variables);
export const DestinationsDocument = `
    query Destinations($filters: destinations_bool_exp = {}, $limit: Int, $orderBy: destinations_order_by! = {created_at: desc}) {
  destinations(
    where: {_and: [{setup_complete: {_eq: true}}, $filters]}
    limit: $limit
    order_by: [$orderBy]
  ) {
    ...Destination
    ...DestinationHistory
    tags
  }
  destinations_aggregate(where: $filters, limit: $limit) {
    aggregate {
      count
    }
  }
}
    ${DestinationFragmentDoc}
${DestinationHistoryFragmentDoc}`;
export const useDestinationsQuery = <
      TData = DestinationsQuery,
      TError = Error
    >(
      variables?: DestinationsQueryVariables, 
      options?: UseQueryOptions<DestinationsQuery, TError, TData>
    ) => 
    useQuery<DestinationsQuery, TError, TData>(
      variables === undefined ? ['Destinations'] : ['Destinations', variables],
      fetcher<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, variables),
      options
    );
useDestinationsQuery.document = DestinationsDocument;

useDestinationsQuery.getKey = (variables?: DestinationsQueryVariables) => variables === undefined ? ['Destinations'] : ['Destinations', variables];

useDestinationsQuery.fetcher = (variables?: DestinationsQueryVariables) => fetcher<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, variables);
export const DestinationStrippedConfigurationDocument = `
    query DestinationStrippedConfiguration($destinationId: bigint!) {
  getDestinationStrippedConfiguration(input: {destinationId: $destinationId})
}
    `;
export const useDestinationStrippedConfigurationQuery = <
      TData = DestinationStrippedConfigurationQuery,
      TError = Error
    >(
      variables: DestinationStrippedConfigurationQueryVariables, 
      options?: UseQueryOptions<DestinationStrippedConfigurationQuery, TError, TData>
    ) => 
    useQuery<DestinationStrippedConfigurationQuery, TError, TData>(
      ['DestinationStrippedConfiguration', variables],
      fetcher<DestinationStrippedConfigurationQuery, DestinationStrippedConfigurationQueryVariables>(DestinationStrippedConfigurationDocument, variables),
      options
    );
useDestinationStrippedConfigurationQuery.document = DestinationStrippedConfigurationDocument;

useDestinationStrippedConfigurationQuery.getKey = (variables: DestinationStrippedConfigurationQueryVariables) => ['DestinationStrippedConfiguration', variables];

useDestinationStrippedConfigurationQuery.fetcher = (variables: DestinationStrippedConfigurationQueryVariables) => fetcher<DestinationStrippedConfigurationQuery, DestinationStrippedConfigurationQueryVariables>(DestinationStrippedConfigurationDocument, variables);
export const DestinationDefinitionsDocument = `
    query DestinationDefinitions {
  getDestinationDefinitions {
    ...DestinationDefinition
  }
}
    ${DestinationDefinitionFragmentDoc}`;
export const useDestinationDefinitionsQuery = <
      TData = DestinationDefinitionsQuery,
      TError = Error
    >(
      variables?: DestinationDefinitionsQueryVariables, 
      options?: UseQueryOptions<DestinationDefinitionsQuery, TError, TData>
    ) => 
    useQuery<DestinationDefinitionsQuery, TError, TData>(
      variables === undefined ? ['DestinationDefinitions'] : ['DestinationDefinitions', variables],
      fetcher<DestinationDefinitionsQuery, DestinationDefinitionsQueryVariables>(DestinationDefinitionsDocument, variables),
      options
    );
useDestinationDefinitionsQuery.document = DestinationDefinitionsDocument;

useDestinationDefinitionsQuery.getKey = (variables?: DestinationDefinitionsQueryVariables) => variables === undefined ? ['DestinationDefinitions'] : ['DestinationDefinitions', variables];

useDestinationDefinitionsQuery.fetcher = (variables?: DestinationDefinitionsQueryVariables) => fetcher<DestinationDefinitionsQuery, DestinationDefinitionsQueryVariables>(DestinationDefinitionsDocument, variables);
export const DestinationDefinitionDocument = `
    query DestinationDefinition($slug: String!) {
  getDestinationDefinition(input: {slug: $slug}) {
    ...DestinationDefinition
  }
}
    ${DestinationDefinitionFragmentDoc}`;
export const useDestinationDefinitionQuery = <
      TData = DestinationDefinitionQuery,
      TError = Error
    >(
      variables: DestinationDefinitionQueryVariables, 
      options?: UseQueryOptions<DestinationDefinitionQuery, TError, TData>
    ) => 
    useQuery<DestinationDefinitionQuery, TError, TData>(
      ['DestinationDefinition', variables],
      fetcher<DestinationDefinitionQuery, DestinationDefinitionQueryVariables>(DestinationDefinitionDocument, variables),
      options
    );
useDestinationDefinitionQuery.document = DestinationDefinitionDocument;

useDestinationDefinitionQuery.getKey = (variables: DestinationDefinitionQueryVariables) => ['DestinationDefinition', variables];

useDestinationDefinitionQuery.fetcher = (variables: DestinationDefinitionQueryVariables) => fetcher<DestinationDefinitionQuery, DestinationDefinitionQueryVariables>(DestinationDefinitionDocument, variables);
export const DestinationSyncsDocument = `
    query DestinationSyncs($destinationId: bigint!, $sameDestinationId: Int!) {
  destinations_by_pk(id: $destinationId) {
    destination_instances {
      id
      config
      segment {
        id
        name
        connection {
          id
          definition {
            icon
            name
          }
        }
      }
      created_at
    }
  }
  sync_templates(where: {destination_id: {_eq: $sameDestinationId}}) {
    destination_instances {
      id
      config
      segment {
        id
        name
        connection {
          id
          definition {
            icon
            name
          }
        }
      }
      created_at
    }
  }
}
    `;
export const useDestinationSyncsQuery = <
      TData = DestinationSyncsQuery,
      TError = Error
    >(
      variables: DestinationSyncsQueryVariables, 
      options?: UseQueryOptions<DestinationSyncsQuery, TError, TData>
    ) => 
    useQuery<DestinationSyncsQuery, TError, TData>(
      ['DestinationSyncs', variables],
      fetcher<DestinationSyncsQuery, DestinationSyncsQueryVariables>(DestinationSyncsDocument, variables),
      options
    );
useDestinationSyncsQuery.document = DestinationSyncsDocument;

useDestinationSyncsQuery.getKey = (variables: DestinationSyncsQueryVariables) => ['DestinationSyncs', variables];

useDestinationSyncsQuery.fetcher = (variables: DestinationSyncsQueryVariables) => fetcher<DestinationSyncsQuery, DestinationSyncsQueryVariables>(DestinationSyncsDocument, variables);
export const CreateDestinationV2Document = `
    mutation CreateDestinationV2($object: DestinationsMutationInput!) {
  createDestinationWithSecrets(destination: $object) {
    id
  }
}
    `;
export const useCreateDestinationV2Mutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDestinationV2Mutation, TError, CreateDestinationV2MutationVariables, TContext>) => 
    useMutation<CreateDestinationV2Mutation, TError, CreateDestinationV2MutationVariables, TContext>(
      (variables?: CreateDestinationV2MutationVariables) => fetcher<CreateDestinationV2Mutation, CreateDestinationV2MutationVariables>(CreateDestinationV2Document, variables)(),
      options
    );
export const UpdateDestinationV2Document = `
    mutation UpdateDestinationV2($id: String!, $object: DestinationsMutationInput!) {
  updateDestinationWithSecrets(destinationId: $id, destination: $object) {
    id
  }
}
    `;
export const useUpdateDestinationV2Mutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDestinationV2Mutation, TError, UpdateDestinationV2MutationVariables, TContext>) => 
    useMutation<UpdateDestinationV2Mutation, TError, UpdateDestinationV2MutationVariables, TContext>(
      (variables?: UpdateDestinationV2MutationVariables) => fetcher<UpdateDestinationV2Mutation, UpdateDestinationV2MutationVariables>(UpdateDestinationV2Document, variables)(),
      options
    );
export const DeleteDestinationDocument = `
    mutation DeleteDestination($id: bigint!) {
  delete_destinations_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteDestinationMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDestinationMutation, TError, DeleteDestinationMutationVariables, TContext>) => 
    useMutation<DeleteDestinationMutation, TError, DeleteDestinationMutationVariables, TContext>(
      (variables?: DeleteDestinationMutationVariables) => fetcher<DeleteDestinationMutation, DeleteDestinationMutationVariables>(DeleteDestinationDocument, variables)(),
      options
    );
export const DeleteDestinationsDocument = `
    mutation DeleteDestinations($ids: [bigint!]!) {
  delete_destinations(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteDestinationsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDestinationsMutation, TError, DeleteDestinationsMutationVariables, TContext>) => 
    useMutation<DeleteDestinationsMutation, TError, DeleteDestinationsMutationVariables, TContext>(
      (variables?: DeleteDestinationsMutationVariables) => fetcher<DeleteDestinationsMutation, DeleteDestinationsMutationVariables>(DeleteDestinationsDocument, variables)(),
      options
    );
export const TestNewDestinationDocument = `
    mutation TestNewDestination($type: String!, $configuration: JSONObject!) {
  testNewDestination(type: $type, configuration: $configuration) {
    success
    reason
    metadata
  }
}
    `;
export const useTestNewDestinationMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<TestNewDestinationMutation, TError, TestNewDestinationMutationVariables, TContext>) => 
    useMutation<TestNewDestinationMutation, TError, TestNewDestinationMutationVariables, TContext>(
      (variables?: TestNewDestinationMutationVariables) => fetcher<TestNewDestinationMutation, TestNewDestinationMutationVariables>(TestNewDestinationDocument, variables)(),
      options
    );
export const TestUpdatedDestinationDocument = `
    mutation TestUpdatedDestination($destinationId: String!, $newConfiguration: JSONObject!) {
  testUpdatedDestination(
    destinationId: $destinationId
    newConfiguration: $newConfiguration
  ) {
    success
    reason
    metadata
  }
}
    `;
export const useTestUpdatedDestinationMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<TestUpdatedDestinationMutation, TError, TestUpdatedDestinationMutationVariables, TContext>) => 
    useMutation<TestUpdatedDestinationMutation, TError, TestUpdatedDestinationMutationVariables, TContext>(
      (variables?: TestUpdatedDestinationMutationVariables) => fetcher<TestUpdatedDestinationMutation, TestUpdatedDestinationMutationVariables>(TestUpdatedDestinationDocument, variables)(),
      options
    );
export const TestDestinationConnectionDocument = `
    mutation TestDestinationConnection($destinationId: Int, $configuration: JSONObject, $type: String) {
  testDestinationConnection(
    destinationId: $destinationId
    configuration: $configuration
    type: $type
  ) {
    success
    reason
    metadata
  }
}
    `;
export const useTestDestinationConnectionMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<TestDestinationConnectionMutation, TError, TestDestinationConnectionMutationVariables, TContext>) => 
    useMutation<TestDestinationConnectionMutation, TError, TestDestinationConnectionMutationVariables, TContext>(
      (variables?: TestDestinationConnectionMutationVariables) => fetcher<TestDestinationConnectionMutation, TestDestinationConnectionMutationVariables>(TestDestinationConnectionDocument, variables)(),
      options
    );
export const ActiveCampaignColumnsDocument = `
    query ActiveCampaignColumns($destinationId: String!, $object: String!) {
  activeCampaignDescribeObject(
    input: {destinationId: $destinationId, object: $object}
  ) {
    ... on ActiveCampaignDescribeObjectSuccess {
      fields {
        name
        id
        type
      }
    }
  }
}
    `;
export const useActiveCampaignColumnsQuery = <
      TData = ActiveCampaignColumnsQuery,
      TError = Error
    >(
      variables: ActiveCampaignColumnsQueryVariables, 
      options?: UseQueryOptions<ActiveCampaignColumnsQuery, TError, TData>
    ) => 
    useQuery<ActiveCampaignColumnsQuery, TError, TData>(
      ['ActiveCampaignColumns', variables],
      fetcher<ActiveCampaignColumnsQuery, ActiveCampaignColumnsQueryVariables>(ActiveCampaignColumnsDocument, variables),
      options
    );
useActiveCampaignColumnsQuery.document = ActiveCampaignColumnsDocument;

useActiveCampaignColumnsQuery.getKey = (variables: ActiveCampaignColumnsQueryVariables) => ['ActiveCampaignColumns', variables];

useActiveCampaignColumnsQuery.fetcher = (variables: ActiveCampaignColumnsQueryVariables) => fetcher<ActiveCampaignColumnsQuery, ActiveCampaignColumnsQueryVariables>(ActiveCampaignColumnsDocument, variables);
export const AsanaColumnsDocument = `
    query AsanaColumns($destinationId: String!, $workspaceId: String!) {
  asanaListCustomFields(
    input: {destinationId: $destinationId, workspaceId: $workspaceId}
  ) {
    ... on AsanaListCustomFieldsSuccess {
      fields {
        name
        id
        dataType
      }
    }
  }
}
    `;
export const useAsanaColumnsQuery = <
      TData = AsanaColumnsQuery,
      TError = Error
    >(
      variables: AsanaColumnsQueryVariables, 
      options?: UseQueryOptions<AsanaColumnsQuery, TError, TData>
    ) => 
    useQuery<AsanaColumnsQuery, TError, TData>(
      ['AsanaColumns', variables],
      fetcher<AsanaColumnsQuery, AsanaColumnsQueryVariables>(AsanaColumnsDocument, variables),
      options
    );
useAsanaColumnsQuery.document = AsanaColumnsDocument;

useAsanaColumnsQuery.getKey = (variables: AsanaColumnsQueryVariables) => ['AsanaColumns', variables];

useAsanaColumnsQuery.fetcher = (variables: AsanaColumnsQueryVariables) => fetcher<AsanaColumnsQuery, AsanaColumnsQueryVariables>(AsanaColumnsDocument, variables);
export const AsanaWorkspacesDocument = `
    query AsanaWorkspaces($destinationId: String!) {
  asanaListWorkspaces(input: {destinationId: $destinationId}) {
    ... on AsanaListWorkspacesSuccess {
      workspaces {
        name
        id
      }
    }
  }
}
    `;
export const useAsanaWorkspacesQuery = <
      TData = AsanaWorkspacesQuery,
      TError = Error
    >(
      variables: AsanaWorkspacesQueryVariables, 
      options?: UseQueryOptions<AsanaWorkspacesQuery, TError, TData>
    ) => 
    useQuery<AsanaWorkspacesQuery, TError, TData>(
      ['AsanaWorkspaces', variables],
      fetcher<AsanaWorkspacesQuery, AsanaWorkspacesQueryVariables>(AsanaWorkspacesDocument, variables),
      options
    );
useAsanaWorkspacesQuery.document = AsanaWorkspacesDocument;

useAsanaWorkspacesQuery.getKey = (variables: AsanaWorkspacesQueryVariables) => ['AsanaWorkspaces', variables];

useAsanaWorkspacesQuery.fetcher = (variables: AsanaWorkspacesQueryVariables) => fetcher<AsanaWorkspacesQuery, AsanaWorkspacesQueryVariables>(AsanaWorkspacesDocument, variables);
export const ClientSuccessColumnsDocument = `
    query ClientSuccessColumns($destinationId: String!, $object: String!) {
  clientSuccessDescribeObject(
    input: {destinationId: $destinationId, object: $object}
  ) {
    ... on ClientSuccessDescribeObjectResult {
      fields {
        name
        id
        type
      }
      customFields {
        name
        id
        type
      }
    }
  }
}
    `;
export const useClientSuccessColumnsQuery = <
      TData = ClientSuccessColumnsQuery,
      TError = Error
    >(
      variables: ClientSuccessColumnsQueryVariables, 
      options?: UseQueryOptions<ClientSuccessColumnsQuery, TError, TData>
    ) => 
    useQuery<ClientSuccessColumnsQuery, TError, TData>(
      ['ClientSuccessColumns', variables],
      fetcher<ClientSuccessColumnsQuery, ClientSuccessColumnsQueryVariables>(ClientSuccessColumnsDocument, variables),
      options
    );
useClientSuccessColumnsQuery.document = ClientSuccessColumnsDocument;

useClientSuccessColumnsQuery.getKey = (variables: ClientSuccessColumnsQueryVariables) => ['ClientSuccessColumns', variables];

useClientSuccessColumnsQuery.fetcher = (variables: ClientSuccessColumnsQueryVariables) => fetcher<ClientSuccessColumnsQuery, ClientSuccessColumnsQueryVariables>(ClientSuccessColumnsDocument, variables);
export const CloseContactColumnsDocument = `
    query CloseContactColumns($destinationId: String!, $object: String!) {
  closeioDescribeObject(input: {destinationId: $destinationId, object: $object}) {
    ... on CloseioDescribeObjectSuccess {
      fields {
        name
        id
        standardType
      }
    }
  }
}
    `;
export const useCloseContactColumnsQuery = <
      TData = CloseContactColumnsQuery,
      TError = Error
    >(
      variables: CloseContactColumnsQueryVariables, 
      options?: UseQueryOptions<CloseContactColumnsQuery, TError, TData>
    ) => 
    useQuery<CloseContactColumnsQuery, TError, TData>(
      ['CloseContactColumns', variables],
      fetcher<CloseContactColumnsQuery, CloseContactColumnsQueryVariables>(CloseContactColumnsDocument, variables),
      options
    );
useCloseContactColumnsQuery.document = CloseContactColumnsDocument;

useCloseContactColumnsQuery.getKey = (variables: CloseContactColumnsQueryVariables) => ['CloseContactColumns', variables];

useCloseContactColumnsQuery.fetcher = (variables: CloseContactColumnsQueryVariables) => fetcher<CloseContactColumnsQuery, CloseContactColumnsQueryVariables>(CloseContactColumnsDocument, variables);
export const CloseLeadColumnsDocument = `
    query CloseLeadColumns($destinationId: String!, $object: String!) {
  closeioDescribeObject(input: {destinationId: $destinationId, object: $object}) {
    ... on CloseioDescribeObjectSuccess {
      fields {
        name
        id
        standardType
      }
    }
  }
}
    `;
export const useCloseLeadColumnsQuery = <
      TData = CloseLeadColumnsQuery,
      TError = Error
    >(
      variables: CloseLeadColumnsQueryVariables, 
      options?: UseQueryOptions<CloseLeadColumnsQuery, TError, TData>
    ) => 
    useQuery<CloseLeadColumnsQuery, TError, TData>(
      ['CloseLeadColumns', variables],
      fetcher<CloseLeadColumnsQuery, CloseLeadColumnsQueryVariables>(CloseLeadColumnsDocument, variables),
      options
    );
useCloseLeadColumnsQuery.document = CloseLeadColumnsDocument;

useCloseLeadColumnsQuery.getKey = (variables: CloseLeadColumnsQueryVariables) => ['CloseLeadColumns', variables];

useCloseLeadColumnsQuery.fetcher = (variables: CloseLeadColumnsQueryVariables) => fetcher<CloseLeadColumnsQuery, CloseLeadColumnsQueryVariables>(CloseLeadColumnsDocument, variables);
export const CloseCustomActivitiesDocument = `
    query CloseCustomActivities($destinationId: String!) {
  closeioCustomActivities(input: {destinationId: $destinationId}) {
    ... on CloseioCustomActivitiesSuccess {
      activities {
        id
        name
        fields {
          id
          name
          type
          standardType
        }
      }
    }
  }
}
    `;
export const useCloseCustomActivitiesQuery = <
      TData = CloseCustomActivitiesQuery,
      TError = Error
    >(
      variables: CloseCustomActivitiesQueryVariables, 
      options?: UseQueryOptions<CloseCustomActivitiesQuery, TError, TData>
    ) => 
    useQuery<CloseCustomActivitiesQuery, TError, TData>(
      ['CloseCustomActivities', variables],
      fetcher<CloseCustomActivitiesQuery, CloseCustomActivitiesQueryVariables>(CloseCustomActivitiesDocument, variables),
      options
    );
useCloseCustomActivitiesQuery.document = CloseCustomActivitiesDocument;

useCloseCustomActivitiesQuery.getKey = (variables: CloseCustomActivitiesQueryVariables) => ['CloseCustomActivities', variables];

useCloseCustomActivitiesQuery.fetcher = (variables: CloseCustomActivitiesQueryVariables) => fetcher<CloseCustomActivitiesQuery, CloseCustomActivitiesQueryVariables>(CloseCustomActivitiesDocument, variables);
export const CustomObjectsDocument = `
    query CustomObjects($destinationId: String!) {
  customListObjects(input: {destinationId: $destinationId}) {
    objects {
      description
      id
      label
    }
  }
}
    `;
export const useCustomObjectsQuery = <
      TData = CustomObjectsQuery,
      TError = Error
    >(
      variables: CustomObjectsQueryVariables, 
      options?: UseQueryOptions<CustomObjectsQuery, TError, TData>
    ) => 
    useQuery<CustomObjectsQuery, TError, TData>(
      ['CustomObjects', variables],
      fetcher<CustomObjectsQuery, CustomObjectsQueryVariables>(CustomObjectsDocument, variables),
      options
    );
useCustomObjectsQuery.document = CustomObjectsDocument;

useCustomObjectsQuery.getKey = (variables: CustomObjectsQueryVariables) => ['CustomObjects', variables];

useCustomObjectsQuery.fetcher = (variables: CustomObjectsQueryVariables) => fetcher<CustomObjectsQuery, CustomObjectsQueryVariables>(CustomObjectsDocument, variables);
export const CustomModesDocument = `
    query CustomModes($destinationId: String!, $object: String) {
  customListModes(input: {destinationId: $destinationId, object: $object}) {
    modes {
      description
      id
      label
    }
  }
}
    `;
export const useCustomModesQuery = <
      TData = CustomModesQuery,
      TError = Error
    >(
      variables: CustomModesQueryVariables, 
      options?: UseQueryOptions<CustomModesQuery, TError, TData>
    ) => 
    useQuery<CustomModesQuery, TError, TData>(
      ['CustomModes', variables],
      fetcher<CustomModesQuery, CustomModesQueryVariables>(CustomModesDocument, variables),
      options
    );
useCustomModesQuery.document = CustomModesDocument;

useCustomModesQuery.getKey = (variables: CustomModesQueryVariables) => ['CustomModes', variables];

useCustomModesQuery.fetcher = (variables: CustomModesQueryVariables) => fetcher<CustomModesQuery, CustomModesQueryVariables>(CustomModesDocument, variables);
export const CustomFieldsDocument = `
    query CustomFields($destinationId: String!, $object: String, $mode: String) {
  customListFields(
    input: {destinationId: $destinationId, object: $object, mode: $mode}
  ) {
    fields {
      description
      id
      label
      required
      identifier
      type
    }
    freeform
  }
}
    `;
export const useCustomFieldsQuery = <
      TData = CustomFieldsQuery,
      TError = Error
    >(
      variables: CustomFieldsQueryVariables, 
      options?: UseQueryOptions<CustomFieldsQuery, TError, TData>
    ) => 
    useQuery<CustomFieldsQuery, TError, TData>(
      ['CustomFields', variables],
      fetcher<CustomFieldsQuery, CustomFieldsQueryVariables>(CustomFieldsDocument, variables),
      options
    );
useCustomFieldsQuery.document = CustomFieldsDocument;

useCustomFieldsQuery.getKey = (variables: CustomFieldsQueryVariables) => ['CustomFields', variables];

useCustomFieldsQuery.fetcher = (variables: CustomFieldsQueryVariables) => fetcher<CustomFieldsQuery, CustomFieldsQueryVariables>(CustomFieldsDocument, variables);
export const CustomOptionsDocument = `
    query CustomOptions($destinationId: String!, $object: String, $mode: String) {
  customListOptions(
    input: {destinationId: $destinationId, object: $object, mode: $mode}
  ) {
    options {
      schema
      uiSchema
    }
  }
}
    `;
export const useCustomOptionsQuery = <
      TData = CustomOptionsQuery,
      TError = Error
    >(
      variables: CustomOptionsQueryVariables, 
      options?: UseQueryOptions<CustomOptionsQuery, TError, TData>
    ) => 
    useQuery<CustomOptionsQuery, TError, TData>(
      ['CustomOptions', variables],
      fetcher<CustomOptionsQuery, CustomOptionsQueryVariables>(CustomOptionsDocument, variables),
      options
    );
useCustomOptionsQuery.document = CustomOptionsDocument;

useCustomOptionsQuery.getKey = (variables: CustomOptionsQueryVariables) => ['CustomOptions', variables];

useCustomOptionsQuery.fetcher = (variables: CustomOptionsQueryVariables) => fetcher<CustomOptionsQuery, CustomOptionsQueryVariables>(CustomOptionsDocument, variables);
export const CustomValidateConfigurationDocument = `
    query CustomValidateConfiguration($destinationId: String!, $jsonInstanceConfiguration: String!) {
  customValidateConfiguration(
    input: {destinationId: $destinationId, jsonInstanceConfiguration: $jsonInstanceConfiguration}
  ) {
    errors
  }
}
    `;
export const useCustomValidateConfigurationQuery = <
      TData = CustomValidateConfigurationQuery,
      TError = Error
    >(
      variables: CustomValidateConfigurationQueryVariables, 
      options?: UseQueryOptions<CustomValidateConfigurationQuery, TError, TData>
    ) => 
    useQuery<CustomValidateConfigurationQuery, TError, TData>(
      ['CustomValidateConfiguration', variables],
      fetcher<CustomValidateConfigurationQuery, CustomValidateConfigurationQueryVariables>(CustomValidateConfigurationDocument, variables),
      options
    );
useCustomValidateConfigurationQuery.document = CustomValidateConfigurationDocument;

useCustomValidateConfigurationQuery.getKey = (variables: CustomValidateConfigurationQueryVariables) => ['CustomValidateConfiguration', variables];

useCustomValidateConfigurationQuery.fetcher = (variables: CustomValidateConfigurationQueryVariables) => fetcher<CustomValidateConfigurationQuery, CustomValidateConfigurationQueryVariables>(CustomValidateConfigurationDocument, variables);
export const FacebookAdsProductCatalogDocument = `
    query FacebookAdsProductCatalog($destinationId: String!) {
  facebookAdCatalogGetProductCatalogs(input: {destinationId: $destinationId}) {
    ... on FacebookAdCatalogGetProductCatalogsSuccess {
      fields {
        name
        id
      }
    }
  }
}
    `;
export const useFacebookAdsProductCatalogQuery = <
      TData = FacebookAdsProductCatalogQuery,
      TError = Error
    >(
      variables: FacebookAdsProductCatalogQueryVariables, 
      options?: UseQueryOptions<FacebookAdsProductCatalogQuery, TError, TData>
    ) => 
    useQuery<FacebookAdsProductCatalogQuery, TError, TData>(
      ['FacebookAdsProductCatalog', variables],
      fetcher<FacebookAdsProductCatalogQuery, FacebookAdsProductCatalogQueryVariables>(FacebookAdsProductCatalogDocument, variables),
      options
    );
useFacebookAdsProductCatalogQuery.document = FacebookAdsProductCatalogDocument;

useFacebookAdsProductCatalogQuery.getKey = (variables: FacebookAdsProductCatalogQueryVariables) => ['FacebookAdsProductCatalog', variables];

useFacebookAdsProductCatalogQuery.fetcher = (variables: FacebookAdsProductCatalogQueryVariables) => fetcher<FacebookAdsProductCatalogQuery, FacebookAdsProductCatalogQueryVariables>(FacebookAdsProductCatalogDocument, variables);
export const FacebookConversionsColumnsDocument = `
    query FacebookConversionsColumns($destinationId: String!, $object: String!) {
  facebookConversionsDescribeObject(
    input: {destinationId: $destinationId, object: $object}
  ) {
    ... on FacebookConversionsDescribeObjectSuccess {
      fields {
        name
        id
        type
      }
    }
  }
}
    `;
export const useFacebookConversionsColumnsQuery = <
      TData = FacebookConversionsColumnsQuery,
      TError = Error
    >(
      variables: FacebookConversionsColumnsQueryVariables, 
      options?: UseQueryOptions<FacebookConversionsColumnsQuery, TError, TData>
    ) => 
    useQuery<FacebookConversionsColumnsQuery, TError, TData>(
      ['FacebookConversionsColumns', variables],
      fetcher<FacebookConversionsColumnsQuery, FacebookConversionsColumnsQueryVariables>(FacebookConversionsColumnsDocument, variables),
      options
    );
useFacebookConversionsColumnsQuery.document = FacebookConversionsColumnsDocument;

useFacebookConversionsColumnsQuery.getKey = (variables: FacebookConversionsColumnsQueryVariables) => ['FacebookConversionsColumns', variables];

useFacebookConversionsColumnsQuery.fetcher = (variables: FacebookConversionsColumnsQueryVariables) => fetcher<FacebookConversionsColumnsQuery, FacebookConversionsColumnsQueryVariables>(FacebookConversionsColumnsDocument, variables);
export const FacebookAdAccountsDocument = `
    query FacebookAdAccounts($destId: String!) {
  facebookListAdAccounts(input: {destinationId: $destId}) {
    ... on FacebookListAdAccountsSuccess {
      accounts {
        id
        accountId
        name
      }
    }
  }
}
    `;
export const useFacebookAdAccountsQuery = <
      TData = FacebookAdAccountsQuery,
      TError = Error
    >(
      variables: FacebookAdAccountsQueryVariables, 
      options?: UseQueryOptions<FacebookAdAccountsQuery, TError, TData>
    ) => 
    useQuery<FacebookAdAccountsQuery, TError, TData>(
      ['FacebookAdAccounts', variables],
      fetcher<FacebookAdAccountsQuery, FacebookAdAccountsQueryVariables>(FacebookAdAccountsDocument, variables),
      options
    );
useFacebookAdAccountsQuery.document = FacebookAdAccountsDocument;

useFacebookAdAccountsQuery.getKey = (variables: FacebookAdAccountsQueryVariables) => ['FacebookAdAccounts', variables];

useFacebookAdAccountsQuery.fetcher = (variables: FacebookAdAccountsQueryVariables) => fetcher<FacebookAdAccountsQuery, FacebookAdAccountsQueryVariables>(FacebookAdAccountsDocument, variables);
export const FreshdeskColumnsDocument = `
    query FreshdeskColumns($destinationId: String!, $object: String!) {
  freshdeskListCustomFields(
    input: {destinationId: $destinationId, object: $object}
  ) {
    ... on FreshdeskListCustomFieldsSuccess {
      fields {
        name
        id
        standardType
      }
    }
  }
}
    `;
export const useFreshdeskColumnsQuery = <
      TData = FreshdeskColumnsQuery,
      TError = Error
    >(
      variables: FreshdeskColumnsQueryVariables, 
      options?: UseQueryOptions<FreshdeskColumnsQuery, TError, TData>
    ) => 
    useQuery<FreshdeskColumnsQuery, TError, TData>(
      ['FreshdeskColumns', variables],
      fetcher<FreshdeskColumnsQuery, FreshdeskColumnsQueryVariables>(FreshdeskColumnsDocument, variables),
      options
    );
useFreshdeskColumnsQuery.document = FreshdeskColumnsDocument;

useFreshdeskColumnsQuery.getKey = (variables: FreshdeskColumnsQueryVariables) => ['FreshdeskColumns', variables];

useFreshdeskColumnsQuery.fetcher = (variables: FreshdeskColumnsQueryVariables) => fetcher<FreshdeskColumnsQuery, FreshdeskColumnsQueryVariables>(FreshdeskColumnsDocument, variables);
export const FrontColumnsDocument = `
    query FrontColumns($destinationId: String!, $object: String!) {
  frontDescribeObject(input: {destinationId: $destinationId, object: $object}) {
    ... on FrontDescribeObjectSuccess {
      fields {
        name
        id
        standardType
      }
    }
  }
}
    `;
export const useFrontColumnsQuery = <
      TData = FrontColumnsQuery,
      TError = Error
    >(
      variables: FrontColumnsQueryVariables, 
      options?: UseQueryOptions<FrontColumnsQuery, TError, TData>
    ) => 
    useQuery<FrontColumnsQuery, TError, TData>(
      ['FrontColumns', variables],
      fetcher<FrontColumnsQuery, FrontColumnsQueryVariables>(FrontColumnsDocument, variables),
      options
    );
useFrontColumnsQuery.document = FrontColumnsDocument;

useFrontColumnsQuery.getKey = (variables: FrontColumnsQueryVariables) => ['FrontColumns', variables];

useFrontColumnsQuery.fetcher = (variables: FrontColumnsQueryVariables) => fetcher<FrontColumnsQuery, FrontColumnsQueryVariables>(FrontColumnsDocument, variables);
export const GainsightPxUserAttributesDocument = `
    query GainsightPXUserAttributes($destinationId: String!) {
  gainsightpxGetUserAttributes(input: {destinationId: $destinationId}) {
    ... on GainsightpxGetUserAttributesSuccess {
      fields {
        name
        id
        type
        standardType
        origin
      }
    }
  }
}
    `;
export const useGainsightPxUserAttributesQuery = <
      TData = GainsightPxUserAttributesQuery,
      TError = Error
    >(
      variables: GainsightPxUserAttributesQueryVariables, 
      options?: UseQueryOptions<GainsightPxUserAttributesQuery, TError, TData>
    ) => 
    useQuery<GainsightPxUserAttributesQuery, TError, TData>(
      ['GainsightPXUserAttributes', variables],
      fetcher<GainsightPxUserAttributesQuery, GainsightPxUserAttributesQueryVariables>(GainsightPxUserAttributesDocument, variables),
      options
    );
useGainsightPxUserAttributesQuery.document = GainsightPxUserAttributesDocument;

useGainsightPxUserAttributesQuery.getKey = (variables: GainsightPxUserAttributesQueryVariables) => ['GainsightPXUserAttributes', variables];

useGainsightPxUserAttributesQuery.fetcher = (variables: GainsightPxUserAttributesQueryVariables) => fetcher<GainsightPxUserAttributesQuery, GainsightPxUserAttributesQueryVariables>(GainsightPxUserAttributesDocument, variables);
export const GainsightPxAccountAttributesDocument = `
    query GainsightPXAccountAttributes($destinationId: String!) {
  gainsightpxGetAccountAttributes(input: {destinationId: $destinationId}) {
    ... on GainsightpxGetAccountAttributesSuccess {
      fields {
        name
        id
        type
        standardType
        origin
      }
    }
  }
}
    `;
export const useGainsightPxAccountAttributesQuery = <
      TData = GainsightPxAccountAttributesQuery,
      TError = Error
    >(
      variables: GainsightPxAccountAttributesQueryVariables, 
      options?: UseQueryOptions<GainsightPxAccountAttributesQuery, TError, TData>
    ) => 
    useQuery<GainsightPxAccountAttributesQuery, TError, TData>(
      ['GainsightPXAccountAttributes', variables],
      fetcher<GainsightPxAccountAttributesQuery, GainsightPxAccountAttributesQueryVariables>(GainsightPxAccountAttributesDocument, variables),
      options
    );
useGainsightPxAccountAttributesQuery.document = GainsightPxAccountAttributesDocument;

useGainsightPxAccountAttributesQuery.getKey = (variables: GainsightPxAccountAttributesQueryVariables) => ['GainsightPXAccountAttributes', variables];

useGainsightPxAccountAttributesQuery.fetcher = (variables: GainsightPxAccountAttributesQueryVariables) => fetcher<GainsightPxAccountAttributesQuery, GainsightPxAccountAttributesQueryVariables>(GainsightPxAccountAttributesDocument, variables);
export const GoogleAdsColumnsDocument = `
    query GoogleAdsColumns($destinationId: String!, $mode: String!) {
  googleDescribeMode(input: {destinationId: $destinationId, mode: $mode}) {
    ... on GoogleAdsDescribeModeResult {
      fields {
        name
        id
        type
        required
      }
    }
  }
}
    `;
export const useGoogleAdsColumnsQuery = <
      TData = GoogleAdsColumnsQuery,
      TError = Error
    >(
      variables: GoogleAdsColumnsQueryVariables, 
      options?: UseQueryOptions<GoogleAdsColumnsQuery, TError, TData>
    ) => 
    useQuery<GoogleAdsColumnsQuery, TError, TData>(
      ['GoogleAdsColumns', variables],
      fetcher<GoogleAdsColumnsQuery, GoogleAdsColumnsQueryVariables>(GoogleAdsColumnsDocument, variables),
      options
    );
useGoogleAdsColumnsQuery.document = GoogleAdsColumnsDocument;

useGoogleAdsColumnsQuery.getKey = (variables: GoogleAdsColumnsQueryVariables) => ['GoogleAdsColumns', variables];

useGoogleAdsColumnsQuery.fetcher = (variables: GoogleAdsColumnsQueryVariables) => fetcher<GoogleAdsColumnsQuery, GoogleAdsColumnsQueryVariables>(GoogleAdsColumnsDocument, variables);
export const GoogleAdsConversionActionsDocument = `
    query GoogleAdsConversionActions($destinationId: String!, $mode: String!, $accountId: String!, $loginAccountId: String) {
  googleListConversionActions(
    input: {destinationId: $destinationId, mode: $mode, accountId: $accountId, loginAccountId: $loginAccountId}
  ) {
    ... on GoogleAdsListConversionActionsResult {
      actions {
        name
        resourceName
      }
    }
  }
}
    `;
export const useGoogleAdsConversionActionsQuery = <
      TData = GoogleAdsConversionActionsQuery,
      TError = Error
    >(
      variables: GoogleAdsConversionActionsQueryVariables, 
      options?: UseQueryOptions<GoogleAdsConversionActionsQuery, TError, TData>
    ) => 
    useQuery<GoogleAdsConversionActionsQuery, TError, TData>(
      ['GoogleAdsConversionActions', variables],
      fetcher<GoogleAdsConversionActionsQuery, GoogleAdsConversionActionsQueryVariables>(GoogleAdsConversionActionsDocument, variables),
      options
    );
useGoogleAdsConversionActionsQuery.document = GoogleAdsConversionActionsDocument;

useGoogleAdsConversionActionsQuery.getKey = (variables: GoogleAdsConversionActionsQueryVariables) => ['GoogleAdsConversionActions', variables];

useGoogleAdsConversionActionsQuery.fetcher = (variables: GoogleAdsConversionActionsQueryVariables) => fetcher<GoogleAdsConversionActionsQuery, GoogleAdsConversionActionsQueryVariables>(GoogleAdsConversionActionsDocument, variables);
export const GoogleAdsAccountsDocument = `
    query GoogleAdsAccounts($destinationId: String!) {
  googleGetAccounts(input: {destinationId: $destinationId})
}
    `;
export const useGoogleAdsAccountsQuery = <
      TData = GoogleAdsAccountsQuery,
      TError = Error
    >(
      variables: GoogleAdsAccountsQueryVariables, 
      options?: UseQueryOptions<GoogleAdsAccountsQuery, TError, TData>
    ) => 
    useQuery<GoogleAdsAccountsQuery, TError, TData>(
      ['GoogleAdsAccounts', variables],
      fetcher<GoogleAdsAccountsQuery, GoogleAdsAccountsQueryVariables>(GoogleAdsAccountsDocument, variables),
      options
    );
useGoogleAdsAccountsQuery.document = GoogleAdsAccountsDocument;

useGoogleAdsAccountsQuery.getKey = (variables: GoogleAdsAccountsQueryVariables) => ['GoogleAdsAccounts', variables];

useGoogleAdsAccountsQuery.fetcher = (variables: GoogleAdsAccountsQueryVariables) => fetcher<GoogleAdsAccountsQuery, GoogleAdsAccountsQueryVariables>(GoogleAdsAccountsDocument, variables);
export const GoogleCampaignManagerProfilesDocument = `
    query GoogleCampaignManagerProfiles($destinationId: String!) {
  googleCampaignManagerListProfiles(input: {destinationId: $destinationId})
}
    `;
export const useGoogleCampaignManagerProfilesQuery = <
      TData = GoogleCampaignManagerProfilesQuery,
      TError = Error
    >(
      variables: GoogleCampaignManagerProfilesQueryVariables, 
      options?: UseQueryOptions<GoogleCampaignManagerProfilesQuery, TError, TData>
    ) => 
    useQuery<GoogleCampaignManagerProfilesQuery, TError, TData>(
      ['GoogleCampaignManagerProfiles', variables],
      fetcher<GoogleCampaignManagerProfilesQuery, GoogleCampaignManagerProfilesQueryVariables>(GoogleCampaignManagerProfilesDocument, variables),
      options
    );
useGoogleCampaignManagerProfilesQuery.document = GoogleCampaignManagerProfilesDocument;

useGoogleCampaignManagerProfilesQuery.getKey = (variables: GoogleCampaignManagerProfilesQueryVariables) => ['GoogleCampaignManagerProfiles', variables];

useGoogleCampaignManagerProfilesQuery.fetcher = (variables: GoogleCampaignManagerProfilesQueryVariables) => fetcher<GoogleCampaignManagerProfilesQuery, GoogleCampaignManagerProfilesQueryVariables>(GoogleCampaignManagerProfilesDocument, variables);
export const GoogleCampaignManagerFloodlightActivitiesDocument = `
    query GoogleCampaignManagerFloodlightActivities($destinationId: String!, $profileId: String!) {
  googleCampaignManagerListFloodlightActivities(
    input: {destinationId: $destinationId, profileId: $profileId}
  )
}
    `;
export const useGoogleCampaignManagerFloodlightActivitiesQuery = <
      TData = GoogleCampaignManagerFloodlightActivitiesQuery,
      TError = Error
    >(
      variables: GoogleCampaignManagerFloodlightActivitiesQueryVariables, 
      options?: UseQueryOptions<GoogleCampaignManagerFloodlightActivitiesQuery, TError, TData>
    ) => 
    useQuery<GoogleCampaignManagerFloodlightActivitiesQuery, TError, TData>(
      ['GoogleCampaignManagerFloodlightActivities', variables],
      fetcher<GoogleCampaignManagerFloodlightActivitiesQuery, GoogleCampaignManagerFloodlightActivitiesQueryVariables>(GoogleCampaignManagerFloodlightActivitiesDocument, variables),
      options
    );
useGoogleCampaignManagerFloodlightActivitiesQuery.document = GoogleCampaignManagerFloodlightActivitiesDocument;

useGoogleCampaignManagerFloodlightActivitiesQuery.getKey = (variables: GoogleCampaignManagerFloodlightActivitiesQueryVariables) => ['GoogleCampaignManagerFloodlightActivities', variables];

useGoogleCampaignManagerFloodlightActivitiesQuery.fetcher = (variables: GoogleCampaignManagerFloodlightActivitiesQueryVariables) => fetcher<GoogleCampaignManagerFloodlightActivitiesQuery, GoogleCampaignManagerFloodlightActivitiesQueryVariables>(GoogleCampaignManagerFloodlightActivitiesDocument, variables);
export const GoogleSheetsDestinationSheetNamesDocument = `
    query GoogleSheetsDestinationSheetNames($destinationId: String!, $spreadsheetId: String!) {
  googlesheetsListSheets(
    input: {destinationId: $destinationId, spreadsheetId: $spreadsheetId}
  ) {
    ... on GooglesheetsListSheetsSuccess {
      sheetNames {
        name
      }
    }
  }
}
    `;
export const useGoogleSheetsDestinationSheetNamesQuery = <
      TData = GoogleSheetsDestinationSheetNamesQuery,
      TError = Error
    >(
      variables: GoogleSheetsDestinationSheetNamesQueryVariables, 
      options?: UseQueryOptions<GoogleSheetsDestinationSheetNamesQuery, TError, TData>
    ) => 
    useQuery<GoogleSheetsDestinationSheetNamesQuery, TError, TData>(
      ['GoogleSheetsDestinationSheetNames', variables],
      fetcher<GoogleSheetsDestinationSheetNamesQuery, GoogleSheetsDestinationSheetNamesQueryVariables>(GoogleSheetsDestinationSheetNamesDocument, variables),
      options
    );
useGoogleSheetsDestinationSheetNamesQuery.document = GoogleSheetsDestinationSheetNamesDocument;

useGoogleSheetsDestinationSheetNamesQuery.getKey = (variables: GoogleSheetsDestinationSheetNamesQueryVariables) => ['GoogleSheetsDestinationSheetNames', variables];

useGoogleSheetsDestinationSheetNamesQuery.fetcher = (variables: GoogleSheetsDestinationSheetNamesQueryVariables) => fetcher<GoogleSheetsDestinationSheetNamesQuery, GoogleSheetsDestinationSheetNamesQueryVariables>(GoogleSheetsDestinationSheetNamesDocument, variables);
export const GoogleSheetsDestinationSpreadSheetsDocument = `
    query GoogleSheetsDestinationSpreadSheets($destinationId: Int!) {
  googlesheetsListSpreadSheets(destinationId: $destinationId) {
    id
    name
    webViewLink
  }
}
    `;
export const useGoogleSheetsDestinationSpreadSheetsQuery = <
      TData = GoogleSheetsDestinationSpreadSheetsQuery,
      TError = Error
    >(
      variables: GoogleSheetsDestinationSpreadSheetsQueryVariables, 
      options?: UseQueryOptions<GoogleSheetsDestinationSpreadSheetsQuery, TError, TData>
    ) => 
    useQuery<GoogleSheetsDestinationSpreadSheetsQuery, TError, TData>(
      ['GoogleSheetsDestinationSpreadSheets', variables],
      fetcher<GoogleSheetsDestinationSpreadSheetsQuery, GoogleSheetsDestinationSpreadSheetsQueryVariables>(GoogleSheetsDestinationSpreadSheetsDocument, variables),
      options
    );
useGoogleSheetsDestinationSpreadSheetsQuery.document = GoogleSheetsDestinationSpreadSheetsDocument;

useGoogleSheetsDestinationSpreadSheetsQuery.getKey = (variables: GoogleSheetsDestinationSpreadSheetsQueryVariables) => ['GoogleSheetsDestinationSpreadSheets', variables];

useGoogleSheetsDestinationSpreadSheetsQuery.fetcher = (variables: GoogleSheetsDestinationSpreadSheetsQueryVariables) => fetcher<GoogleSheetsDestinationSpreadSheetsQuery, GoogleSheetsDestinationSpreadSheetsQueryVariables>(GoogleSheetsDestinationSpreadSheetsDocument, variables);
export const HubSpotLegacyColumnsDocument = `
    query HubSpotLegacyColumns($destinationId: String!, $object: String!) {
  hubspotLegacyDescribeObject(
    input: {destinationId: $destinationId, object: $object}
  ) {
    ... on HubSpotLegacyDescribeObjectSuccess {
      fields {
        name
        unique
        type
        standardType
        isUpdateable
      }
      associations {
        id
        fromObjectTypeId
        toObjectTypeId
        name
      }
    }
  }
}
    `;
export const useHubSpotLegacyColumnsQuery = <
      TData = HubSpotLegacyColumnsQuery,
      TError = Error
    >(
      variables: HubSpotLegacyColumnsQueryVariables, 
      options?: UseQueryOptions<HubSpotLegacyColumnsQuery, TError, TData>
    ) => 
    useQuery<HubSpotLegacyColumnsQuery, TError, TData>(
      ['HubSpotLegacyColumns', variables],
      fetcher<HubSpotLegacyColumnsQuery, HubSpotLegacyColumnsQueryVariables>(HubSpotLegacyColumnsDocument, variables),
      options
    );
useHubSpotLegacyColumnsQuery.document = HubSpotLegacyColumnsDocument;

useHubSpotLegacyColumnsQuery.getKey = (variables: HubSpotLegacyColumnsQueryVariables) => ['HubSpotLegacyColumns', variables];

useHubSpotLegacyColumnsQuery.fetcher = (variables: HubSpotLegacyColumnsQueryVariables) => fetcher<HubSpotLegacyColumnsQuery, HubSpotLegacyColumnsQueryVariables>(HubSpotLegacyColumnsDocument, variables);
export const HubSpotLegacyObjectsDocument = `
    query HubSpotLegacyObjects($destinationId: String!) {
  hubspotLegacyDescribeGlobal(input: {destinationId: $destinationId}) {
    ... on HubSpotLegacyDescribeGlobalSuccess {
      objectsV2 {
        id
        name
      }
    }
  }
}
    `;
export const useHubSpotLegacyObjectsQuery = <
      TData = HubSpotLegacyObjectsQuery,
      TError = Error
    >(
      variables: HubSpotLegacyObjectsQueryVariables, 
      options?: UseQueryOptions<HubSpotLegacyObjectsQuery, TError, TData>
    ) => 
    useQuery<HubSpotLegacyObjectsQuery, TError, TData>(
      ['HubSpotLegacyObjects', variables],
      fetcher<HubSpotLegacyObjectsQuery, HubSpotLegacyObjectsQueryVariables>(HubSpotLegacyObjectsDocument, variables),
      options
    );
useHubSpotLegacyObjectsQuery.document = HubSpotLegacyObjectsDocument;

useHubSpotLegacyObjectsQuery.getKey = (variables: HubSpotLegacyObjectsQueryVariables) => ['HubSpotLegacyObjects', variables];

useHubSpotLegacyObjectsQuery.fetcher = (variables: HubSpotLegacyObjectsQueryVariables) => fetcher<HubSpotLegacyObjectsQuery, HubSpotLegacyObjectsQueryVariables>(HubSpotLegacyObjectsDocument, variables);
export const HubSpotColumnsDocument = `
    query HubSpotColumns($destinationId: String!, $object: String!) {
  hubspotDescribeObject(input: {destinationId: $destinationId, object: $object}) {
    ... on HubSpotDescribeObjectSuccess {
      fields {
        name
        unique
        type
        standardType
        isUpdateable
      }
      associations {
        id
        fromObjectTypeId
        toObjectTypeId
        name
      }
    }
  }
}
    `;
export const useHubSpotColumnsQuery = <
      TData = HubSpotColumnsQuery,
      TError = Error
    >(
      variables: HubSpotColumnsQueryVariables, 
      options?: UseQueryOptions<HubSpotColumnsQuery, TError, TData>
    ) => 
    useQuery<HubSpotColumnsQuery, TError, TData>(
      ['HubSpotColumns', variables],
      fetcher<HubSpotColumnsQuery, HubSpotColumnsQueryVariables>(HubSpotColumnsDocument, variables),
      options
    );
useHubSpotColumnsQuery.document = HubSpotColumnsDocument;

useHubSpotColumnsQuery.getKey = (variables: HubSpotColumnsQueryVariables) => ['HubSpotColumns', variables];

useHubSpotColumnsQuery.fetcher = (variables: HubSpotColumnsQueryVariables) => fetcher<HubSpotColumnsQuery, HubSpotColumnsQueryVariables>(HubSpotColumnsDocument, variables);
export const HubSpotObjectsDocument = `
    query HubSpotObjects($destinationId: String!) {
  hubspotDescribeGlobal(input: {destinationId: $destinationId}) {
    ... on HubSpotDescribeGlobalSuccess {
      objectsV2 {
        id
        name
      }
    }
  }
}
    `;
export const useHubSpotObjectsQuery = <
      TData = HubSpotObjectsQuery,
      TError = Error
    >(
      variables: HubSpotObjectsQueryVariables, 
      options?: UseQueryOptions<HubSpotObjectsQuery, TError, TData>
    ) => 
    useQuery<HubSpotObjectsQuery, TError, TData>(
      ['HubSpotObjects', variables],
      fetcher<HubSpotObjectsQuery, HubSpotObjectsQueryVariables>(HubSpotObjectsDocument, variables),
      options
    );
useHubSpotObjectsQuery.document = HubSpotObjectsDocument;

useHubSpotObjectsQuery.getKey = (variables: HubSpotObjectsQueryVariables) => ['HubSpotObjects', variables];

useHubSpotObjectsQuery.fetcher = (variables: HubSpotObjectsQueryVariables) => fetcher<HubSpotObjectsQuery, HubSpotObjectsQueryVariables>(HubSpotObjectsDocument, variables);
export const IntercomColumnsDocument = `
    query IntercomColumns($destinationId: String!, $object: String!) {
  intercomListAttributes(input: {destinationId: $destinationId, object: $object}) {
    ... on IntercomListAttributesSuccess {
      fields {
        name
        custom
        data_type
        api_writable
      }
    }
  }
}
    `;
export const useIntercomColumnsQuery = <
      TData = IntercomColumnsQuery,
      TError = Error
    >(
      variables: IntercomColumnsQueryVariables, 
      options?: UseQueryOptions<IntercomColumnsQuery, TError, TData>
    ) => 
    useQuery<IntercomColumnsQuery, TError, TData>(
      ['IntercomColumns', variables],
      fetcher<IntercomColumnsQuery, IntercomColumnsQueryVariables>(IntercomColumnsDocument, variables),
      options
    );
useIntercomColumnsQuery.document = IntercomColumnsDocument;

useIntercomColumnsQuery.getKey = (variables: IntercomColumnsQueryVariables) => ['IntercomColumns', variables];

useIntercomColumnsQuery.fetcher = (variables: IntercomColumnsQueryVariables) => fetcher<IntercomColumnsQuery, IntercomColumnsQueryVariables>(IntercomColumnsDocument, variables);
export const IterableColumnsDocument = `
    query IterableColumns($destinationId: String!) {
  iterableUserFields(input: {destinationId: $destinationId}) {
    ... on IterableUserFieldsSuccess {
      __typename
      fields {
        name
        type
        standardType
      }
    }
  }
}
    `;
export const useIterableColumnsQuery = <
      TData = IterableColumnsQuery,
      TError = Error
    >(
      variables: IterableColumnsQueryVariables, 
      options?: UseQueryOptions<IterableColumnsQuery, TError, TData>
    ) => 
    useQuery<IterableColumnsQuery, TError, TData>(
      ['IterableColumns', variables],
      fetcher<IterableColumnsQuery, IterableColumnsQueryVariables>(IterableColumnsDocument, variables),
      options
    );
useIterableColumnsQuery.document = IterableColumnsDocument;

useIterableColumnsQuery.getKey = (variables: IterableColumnsQueryVariables) => ['IterableColumns', variables];

useIterableColumnsQuery.fetcher = (variables: IterableColumnsQueryVariables) => fetcher<IterableColumnsQuery, IterableColumnsQueryVariables>(IterableColumnsDocument, variables);
export const IterableCampaignsDocument = `
    query IterableCampaigns($destinationId: String!) {
  iterableGetCampaigns(input: {destinationId: $destinationId}) {
    ... on IterableGetCampaigns {
      __typename
      campaigns {
        name
        id
      }
    }
  }
}
    `;
export const useIterableCampaignsQuery = <
      TData = IterableCampaignsQuery,
      TError = Error
    >(
      variables: IterableCampaignsQueryVariables, 
      options?: UseQueryOptions<IterableCampaignsQuery, TError, TData>
    ) => 
    useQuery<IterableCampaignsQuery, TError, TData>(
      ['IterableCampaigns', variables],
      fetcher<IterableCampaignsQuery, IterableCampaignsQueryVariables>(IterableCampaignsDocument, variables),
      options
    );
useIterableCampaignsQuery.document = IterableCampaignsDocument;

useIterableCampaignsQuery.getKey = (variables: IterableCampaignsQueryVariables) => ['IterableCampaigns', variables];

useIterableCampaignsQuery.fetcher = (variables: IterableCampaignsQueryVariables) => fetcher<IterableCampaignsQuery, IterableCampaignsQueryVariables>(IterableCampaignsDocument, variables);
export const IterableTemplatesDocument = `
    query IterableTemplates($destinationId: String!) {
  iterableGetTemplates(input: {destinationId: $destinationId}) {
    ... on IterableGetTemplates {
      __typename
      templates {
        name
        id
      }
    }
  }
}
    `;
export const useIterableTemplatesQuery = <
      TData = IterableTemplatesQuery,
      TError = Error
    >(
      variables: IterableTemplatesQueryVariables, 
      options?: UseQueryOptions<IterableTemplatesQuery, TError, TData>
    ) => 
    useQuery<IterableTemplatesQuery, TError, TData>(
      ['IterableTemplates', variables],
      fetcher<IterableTemplatesQuery, IterableTemplatesQueryVariables>(IterableTemplatesDocument, variables),
      options
    );
useIterableTemplatesQuery.document = IterableTemplatesDocument;

useIterableTemplatesQuery.getKey = (variables: IterableTemplatesQueryVariables) => ['IterableTemplates', variables];

useIterableTemplatesQuery.fetcher = (variables: IterableTemplatesQueryVariables) => fetcher<IterableTemplatesQuery, IterableTemplatesQueryVariables>(IterableTemplatesDocument, variables);
export const IterableGetCatalogsDocument = `
    query IterableGetCatalogs($destinationId: String!) {
  iterableGetCatalogs(input: {destinationId: $destinationId}) {
    ... on IterableGetCatalogs {
      __typename
      catalogs {
        name
        id
      }
    }
  }
}
    `;
export const useIterableGetCatalogsQuery = <
      TData = IterableGetCatalogsQuery,
      TError = Error
    >(
      variables: IterableGetCatalogsQueryVariables, 
      options?: UseQueryOptions<IterableGetCatalogsQuery, TError, TData>
    ) => 
    useQuery<IterableGetCatalogsQuery, TError, TData>(
      ['IterableGetCatalogs', variables],
      fetcher<IterableGetCatalogsQuery, IterableGetCatalogsQueryVariables>(IterableGetCatalogsDocument, variables),
      options
    );
useIterableGetCatalogsQuery.document = IterableGetCatalogsDocument;

useIterableGetCatalogsQuery.getKey = (variables: IterableGetCatalogsQueryVariables) => ['IterableGetCatalogs', variables];

useIterableGetCatalogsQuery.fetcher = (variables: IterableGetCatalogsQueryVariables) => fetcher<IterableGetCatalogsQuery, IterableGetCatalogsQueryVariables>(IterableGetCatalogsDocument, variables);
export const IterableCatalogFieldsDocument = `
    query IterableCatalogFields($destinationId: String!, $catalogName: String) {
  iterableGetCatalogFields(
    input: {destinationId: $destinationId, catalogName: $catalogName}
  ) {
    ... on IterableGetCatalogFields {
      __typename
      catalogFields {
        name
        id
        iterableType
        type
      }
    }
  }
}
    `;
export const useIterableCatalogFieldsQuery = <
      TData = IterableCatalogFieldsQuery,
      TError = Error
    >(
      variables: IterableCatalogFieldsQueryVariables, 
      options?: UseQueryOptions<IterableCatalogFieldsQuery, TError, TData>
    ) => 
    useQuery<IterableCatalogFieldsQuery, TError, TData>(
      ['IterableCatalogFields', variables],
      fetcher<IterableCatalogFieldsQuery, IterableCatalogFieldsQueryVariables>(IterableCatalogFieldsDocument, variables),
      options
    );
useIterableCatalogFieldsQuery.document = IterableCatalogFieldsDocument;

useIterableCatalogFieldsQuery.getKey = (variables: IterableCatalogFieldsQueryVariables) => ['IterableCatalogFields', variables];

useIterableCatalogFieldsQuery.fetcher = (variables: IterableCatalogFieldsQueryVariables) => fetcher<IterableCatalogFieldsQuery, IterableCatalogFieldsQueryVariables>(IterableCatalogFieldsDocument, variables);
export const JiraIssueTypesDocument = `
    query JiraIssueTypes($destinationId: String!, $projectId: String!) {
  jiraGetIssueTypes(input: {destinationId: $destinationId, projectId: $projectId}) {
    issueTypes {
      id
      name
    }
  }
}
    `;
export const useJiraIssueTypesQuery = <
      TData = JiraIssueTypesQuery,
      TError = Error
    >(
      variables: JiraIssueTypesQueryVariables, 
      options?: UseQueryOptions<JiraIssueTypesQuery, TError, TData>
    ) => 
    useQuery<JiraIssueTypesQuery, TError, TData>(
      ['JiraIssueTypes', variables],
      fetcher<JiraIssueTypesQuery, JiraIssueTypesQueryVariables>(JiraIssueTypesDocument, variables),
      options
    );
useJiraIssueTypesQuery.document = JiraIssueTypesDocument;

useJiraIssueTypesQuery.getKey = (variables: JiraIssueTypesQueryVariables) => ['JiraIssueTypes', variables];

useJiraIssueTypesQuery.fetcher = (variables: JiraIssueTypesQueryVariables) => fetcher<JiraIssueTypesQuery, JiraIssueTypesQueryVariables>(JiraIssueTypesDocument, variables);
export const JiraIssueFieldsDocument = `
    query JiraIssueFields($destinationId: String!, $projectId: String!, $issueType: String!) {
  jiraGetIssueFields(
    input: {destinationId: $destinationId, projectId: $projectId, issueType: $issueType}
  ) {
    fields {
      id
      name
      type
      customFieldType
    }
  }
}
    `;
export const useJiraIssueFieldsQuery = <
      TData = JiraIssueFieldsQuery,
      TError = Error
    >(
      variables: JiraIssueFieldsQueryVariables, 
      options?: UseQueryOptions<JiraIssueFieldsQuery, TError, TData>
    ) => 
    useQuery<JiraIssueFieldsQuery, TError, TData>(
      ['JiraIssueFields', variables],
      fetcher<JiraIssueFieldsQuery, JiraIssueFieldsQueryVariables>(JiraIssueFieldsDocument, variables),
      options
    );
useJiraIssueFieldsQuery.document = JiraIssueFieldsDocument;

useJiraIssueFieldsQuery.getKey = (variables: JiraIssueFieldsQueryVariables) => ['JiraIssueFields', variables];

useJiraIssueFieldsQuery.fetcher = (variables: JiraIssueFieldsQueryVariables) => fetcher<JiraIssueFieldsQuery, JiraIssueFieldsQueryVariables>(JiraIssueFieldsDocument, variables);
export const JiraProjectsDocument = `
    query JiraProjects($destinationId: String!) {
  jiraGetProjects(input: {destinationId: $destinationId}) {
    projects {
      id
      name
      type
    }
  }
}
    `;
export const useJiraProjectsQuery = <
      TData = JiraProjectsQuery,
      TError = Error
    >(
      variables: JiraProjectsQueryVariables, 
      options?: UseQueryOptions<JiraProjectsQuery, TError, TData>
    ) => 
    useQuery<JiraProjectsQuery, TError, TData>(
      ['JiraProjects', variables],
      fetcher<JiraProjectsQuery, JiraProjectsQueryVariables>(JiraProjectsDocument, variables),
      options
    );
useJiraProjectsQuery.document = JiraProjectsDocument;

useJiraProjectsQuery.getKey = (variables: JiraProjectsQueryVariables) => ['JiraProjects', variables];

useJiraProjectsQuery.fetcher = (variables: JiraProjectsQueryVariables) => fetcher<JiraProjectsQuery, JiraProjectsQueryVariables>(JiraProjectsDocument, variables);
export const MarketoColumnsDocument = `
    query MarketoColumns($destinationId: String!, $object: String!) {
  marketoDescribeObject(input: {destinationId: $destinationId, object: $object}) {
    ... on MarketoDescribeObjectSuccess {
      fields {
        name
        id
        type
        isID
        isLookup
        isUpdateable
      }
    }
  }
}
    `;
export const useMarketoColumnsQuery = <
      TData = MarketoColumnsQuery,
      TError = Error
    >(
      variables: MarketoColumnsQueryVariables, 
      options?: UseQueryOptions<MarketoColumnsQuery, TError, TData>
    ) => 
    useQuery<MarketoColumnsQuery, TError, TData>(
      ['MarketoColumns', variables],
      fetcher<MarketoColumnsQuery, MarketoColumnsQueryVariables>(MarketoColumnsDocument, variables),
      options
    );
useMarketoColumnsQuery.document = MarketoColumnsDocument;

useMarketoColumnsQuery.getKey = (variables: MarketoColumnsQueryVariables) => ['MarketoColumns', variables];

useMarketoColumnsQuery.fetcher = (variables: MarketoColumnsQueryVariables) => fetcher<MarketoColumnsQuery, MarketoColumnsQueryVariables>(MarketoColumnsDocument, variables);
export const MarketoAttributesDocument = `
    query MarketoAttributes($destinationId: String!, $activity: String!) {
  marketoDescribeActivity(
    input: {destinationId: $destinationId, activity: $activity}
  ) {
    ... on MarketoDescribeActivitySuccess {
      attributes {
        name
        id
        type
        isPrimary
      }
    }
  }
}
    `;
export const useMarketoAttributesQuery = <
      TData = MarketoAttributesQuery,
      TError = Error
    >(
      variables: MarketoAttributesQueryVariables, 
      options?: UseQueryOptions<MarketoAttributesQuery, TError, TData>
    ) => 
    useQuery<MarketoAttributesQuery, TError, TData>(
      ['MarketoAttributes', variables],
      fetcher<MarketoAttributesQuery, MarketoAttributesQueryVariables>(MarketoAttributesDocument, variables),
      options
    );
useMarketoAttributesQuery.document = MarketoAttributesDocument;

useMarketoAttributesQuery.getKey = (variables: MarketoAttributesQueryVariables) => ['MarketoAttributes', variables];

useMarketoAttributesQuery.fetcher = (variables: MarketoAttributesQueryVariables) => fetcher<MarketoAttributesQuery, MarketoAttributesQueryVariables>(MarketoAttributesDocument, variables);
export const MarketoActivitiesDocument = `
    query MarketoActivities($destinationId: String!) {
  marketoListActivities(input: {destinationId: $destinationId}) {
    ... on MarketoListActivitiesSuccess {
      activities {
        name
        id
        activityTypeId
      }
    }
  }
}
    `;
export const useMarketoActivitiesQuery = <
      TData = MarketoActivitiesQuery,
      TError = Error
    >(
      variables: MarketoActivitiesQueryVariables, 
      options?: UseQueryOptions<MarketoActivitiesQuery, TError, TData>
    ) => 
    useQuery<MarketoActivitiesQuery, TError, TData>(
      ['MarketoActivities', variables],
      fetcher<MarketoActivitiesQuery, MarketoActivitiesQueryVariables>(MarketoActivitiesDocument, variables),
      options
    );
useMarketoActivitiesQuery.document = MarketoActivitiesDocument;

useMarketoActivitiesQuery.getKey = (variables: MarketoActivitiesQueryVariables) => ['MarketoActivities', variables];

useMarketoActivitiesQuery.fetcher = (variables: MarketoActivitiesQueryVariables) => fetcher<MarketoActivitiesQuery, MarketoActivitiesQueryVariables>(MarketoActivitiesDocument, variables);
export const MarketoObjectsDocument = `
    query MarketoObjects($destinationId: String!) {
  marketoListObjects(input: {destinationId: $destinationId}) {
    ... on MarketoListObjectsSuccess {
      objects {
        name
        id
      }
    }
  }
}
    `;
export const useMarketoObjectsQuery = <
      TData = MarketoObjectsQuery,
      TError = Error
    >(
      variables: MarketoObjectsQueryVariables, 
      options?: UseQueryOptions<MarketoObjectsQuery, TError, TData>
    ) => 
    useQuery<MarketoObjectsQuery, TError, TData>(
      ['MarketoObjects', variables],
      fetcher<MarketoObjectsQuery, MarketoObjectsQueryVariables>(MarketoObjectsDocument, variables),
      options
    );
useMarketoObjectsQuery.document = MarketoObjectsDocument;

useMarketoObjectsQuery.getKey = (variables: MarketoObjectsQueryVariables) => ['MarketoObjects', variables];

useMarketoObjectsQuery.fetcher = (variables: MarketoObjectsQueryVariables) => fetcher<MarketoObjectsQuery, MarketoObjectsQueryVariables>(MarketoObjectsDocument, variables);
export const MixpanelLookupTablesDocument = `
    query MixpanelLookupTables($destinationId: String!) {
  mixpanelGetLookupTables(input: {destinationId: $destinationId})
}
    `;
export const useMixpanelLookupTablesQuery = <
      TData = MixpanelLookupTablesQuery,
      TError = Error
    >(
      variables: MixpanelLookupTablesQueryVariables, 
      options?: UseQueryOptions<MixpanelLookupTablesQuery, TError, TData>
    ) => 
    useQuery<MixpanelLookupTablesQuery, TError, TData>(
      ['MixpanelLookupTables', variables],
      fetcher<MixpanelLookupTablesQuery, MixpanelLookupTablesQueryVariables>(MixpanelLookupTablesDocument, variables),
      options
    );
useMixpanelLookupTablesQuery.document = MixpanelLookupTablesDocument;

useMixpanelLookupTablesQuery.getKey = (variables: MixpanelLookupTablesQueryVariables) => ['MixpanelLookupTables', variables];

useMixpanelLookupTablesQuery.fetcher = (variables: MixpanelLookupTablesQueryVariables) => fetcher<MixpanelLookupTablesQuery, MixpanelLookupTablesQueryVariables>(MixpanelLookupTablesDocument, variables);
export const NotionDatabasesDocument = `
    query NotionDatabases($destinationId: String!) {
  notionGetDatabases(input: {destinationId: $destinationId}) {
    entries {
      id
      name
      type
    }
  }
}
    `;
export const useNotionDatabasesQuery = <
      TData = NotionDatabasesQuery,
      TError = Error
    >(
      variables: NotionDatabasesQueryVariables, 
      options?: UseQueryOptions<NotionDatabasesQuery, TError, TData>
    ) => 
    useQuery<NotionDatabasesQuery, TError, TData>(
      ['NotionDatabases', variables],
      fetcher<NotionDatabasesQuery, NotionDatabasesQueryVariables>(NotionDatabasesDocument, variables),
      options
    );
useNotionDatabasesQuery.document = NotionDatabasesDocument;

useNotionDatabasesQuery.getKey = (variables: NotionDatabasesQueryVariables) => ['NotionDatabases', variables];

useNotionDatabasesQuery.fetcher = (variables: NotionDatabasesQueryVariables) => fetcher<NotionDatabasesQuery, NotionDatabasesQueryVariables>(NotionDatabasesDocument, variables);
export const NotionDatabasePropertiesDocument = `
    query NotionDatabaseProperties($destinationId: String!, $databaseId: String!) {
  notionGetDatabaseProperties(
    input: {destinationId: $destinationId, databaseId: $databaseId}
  ) {
    properties {
      id
      name
      type
    }
  }
}
    `;
export const useNotionDatabasePropertiesQuery = <
      TData = NotionDatabasePropertiesQuery,
      TError = Error
    >(
      variables: NotionDatabasePropertiesQueryVariables, 
      options?: UseQueryOptions<NotionDatabasePropertiesQuery, TError, TData>
    ) => 
    useQuery<NotionDatabasePropertiesQuery, TError, TData>(
      ['NotionDatabaseProperties', variables],
      fetcher<NotionDatabasePropertiesQuery, NotionDatabasePropertiesQueryVariables>(NotionDatabasePropertiesDocument, variables),
      options
    );
useNotionDatabasePropertiesQuery.document = NotionDatabasePropertiesDocument;

useNotionDatabasePropertiesQuery.getKey = (variables: NotionDatabasePropertiesQueryVariables) => ['NotionDatabaseProperties', variables];

useNotionDatabasePropertiesQuery.fetcher = (variables: NotionDatabasePropertiesQueryVariables) => fetcher<NotionDatabasePropertiesQuery, NotionDatabasePropertiesQueryVariables>(NotionDatabasePropertiesDocument, variables);
export const OrbitWorkspacesDocument = `
    query OrbitWorkspaces($destinationId: String!) {
  orbitListWorkspaces(input: {destinationId: $destinationId}) {
    workspaces {
      name
      path
    }
  }
}
    `;
export const useOrbitWorkspacesQuery = <
      TData = OrbitWorkspacesQuery,
      TError = Error
    >(
      variables: OrbitWorkspacesQueryVariables, 
      options?: UseQueryOptions<OrbitWorkspacesQuery, TError, TData>
    ) => 
    useQuery<OrbitWorkspacesQuery, TError, TData>(
      ['OrbitWorkspaces', variables],
      fetcher<OrbitWorkspacesQuery, OrbitWorkspacesQueryVariables>(OrbitWorkspacesDocument, variables),
      options
    );
useOrbitWorkspacesQuery.document = OrbitWorkspacesDocument;

useOrbitWorkspacesQuery.getKey = (variables: OrbitWorkspacesQueryVariables) => ['OrbitWorkspaces', variables];

useOrbitWorkspacesQuery.fetcher = (variables: OrbitWorkspacesQueryVariables) => fetcher<OrbitWorkspacesQuery, OrbitWorkspacesQueryVariables>(OrbitWorkspacesDocument, variables);
export const PipedriveDomainsDocument = `
    query PipedriveDomains($destId: String!, $apiKey: String!) {
  pipedriveListDomains(input: {destinationId: $destId, apiKey: $apiKey}) {
    ... on PipedriveListDomains {
      domains {
        label
        value
      }
    }
  }
}
    `;
export const usePipedriveDomainsQuery = <
      TData = PipedriveDomainsQuery,
      TError = Error
    >(
      variables: PipedriveDomainsQueryVariables, 
      options?: UseQueryOptions<PipedriveDomainsQuery, TError, TData>
    ) => 
    useQuery<PipedriveDomainsQuery, TError, TData>(
      ['PipedriveDomains', variables],
      fetcher<PipedriveDomainsQuery, PipedriveDomainsQueryVariables>(PipedriveDomainsDocument, variables),
      options
    );
usePipedriveDomainsQuery.document = PipedriveDomainsDocument;

usePipedriveDomainsQuery.getKey = (variables: PipedriveDomainsQueryVariables) => ['PipedriveDomains', variables];

usePipedriveDomainsQuery.fetcher = (variables: PipedriveDomainsQueryVariables) => fetcher<PipedriveDomainsQuery, PipedriveDomainsQueryVariables>(PipedriveDomainsDocument, variables);
export const PostgresColumnsDocument = `
    query PostgresColumns($input: ListPostgresColumnsInput!) {
  listPostgresColumns(input: $input) {
    name
  }
}
    `;
export const usePostgresColumnsQuery = <
      TData = PostgresColumnsQuery,
      TError = Error
    >(
      variables: PostgresColumnsQueryVariables, 
      options?: UseQueryOptions<PostgresColumnsQuery, TError, TData>
    ) => 
    useQuery<PostgresColumnsQuery, TError, TData>(
      ['PostgresColumns', variables],
      fetcher<PostgresColumnsQuery, PostgresColumnsQueryVariables>(PostgresColumnsDocument, variables),
      options
    );
usePostgresColumnsQuery.document = PostgresColumnsDocument;

usePostgresColumnsQuery.getKey = (variables: PostgresColumnsQueryVariables) => ['PostgresColumns', variables];

usePostgresColumnsQuery.fetcher = (variables: PostgresColumnsQueryVariables) => fetcher<PostgresColumnsQuery, PostgresColumnsQueryVariables>(PostgresColumnsDocument, variables);
export const PostgresTablesDocument = `
    query PostgresTables($input: ListPostgresTablesInput!) {
  listPostgresTables(input: $input) {
    name
  }
}
    `;
export const usePostgresTablesQuery = <
      TData = PostgresTablesQuery,
      TError = Error
    >(
      variables: PostgresTablesQueryVariables, 
      options?: UseQueryOptions<PostgresTablesQuery, TError, TData>
    ) => 
    useQuery<PostgresTablesQuery, TError, TData>(
      ['PostgresTables', variables],
      fetcher<PostgresTablesQuery, PostgresTablesQueryVariables>(PostgresTablesDocument, variables),
      options
    );
usePostgresTablesQuery.document = PostgresTablesDocument;

usePostgresTablesQuery.getKey = (variables: PostgresTablesQueryVariables) => ['PostgresTables', variables];

usePostgresTablesQuery.fetcher = (variables: PostgresTablesQueryVariables) => fetcher<PostgresTablesQuery, PostgresTablesQueryVariables>(PostgresTablesDocument, variables);
export const SalesloftColumnsDocument = `
    query SalesloftColumns($destinationId: String!) {
  salesloftListCustomFields(input: {destinationId: $destinationId}) {
    ... on SalesloftCustomFieldsSuccess {
      fields {
        name
        id
        field_type
        value_type
        standardType
      }
    }
  }
}
    `;
export const useSalesloftColumnsQuery = <
      TData = SalesloftColumnsQuery,
      TError = Error
    >(
      variables: SalesloftColumnsQueryVariables, 
      options?: UseQueryOptions<SalesloftColumnsQuery, TError, TData>
    ) => 
    useQuery<SalesloftColumnsQuery, TError, TData>(
      ['SalesloftColumns', variables],
      fetcher<SalesloftColumnsQuery, SalesloftColumnsQueryVariables>(SalesloftColumnsDocument, variables),
      options
    );
useSalesloftColumnsQuery.document = SalesloftColumnsDocument;

useSalesloftColumnsQuery.getKey = (variables: SalesloftColumnsQueryVariables) => ['SalesloftColumns', variables];

useSalesloftColumnsQuery.fetcher = (variables: SalesloftColumnsQueryVariables) => fetcher<SalesloftColumnsQuery, SalesloftColumnsQueryVariables>(SalesloftColumnsDocument, variables);
export const SendgridColumnsDocument = `
    query SendgridColumns($destinationId: String!) {
  sendGridContactSchema(input: {destinationId: $destinationId}) {
    ... on SendGridContactSchemaSuccess {
      fields {
        name
        id
        isCustom
      }
    }
  }
}
    `;
export const useSendgridColumnsQuery = <
      TData = SendgridColumnsQuery,
      TError = Error
    >(
      variables: SendgridColumnsQueryVariables, 
      options?: UseQueryOptions<SendgridColumnsQuery, TError, TData>
    ) => 
    useQuery<SendgridColumnsQuery, TError, TData>(
      ['SendgridColumns', variables],
      fetcher<SendgridColumnsQuery, SendgridColumnsQueryVariables>(SendgridColumnsDocument, variables),
      options
    );
useSendgridColumnsQuery.document = SendgridColumnsDocument;

useSendgridColumnsQuery.getKey = (variables: SendgridColumnsQueryVariables) => ['SendgridColumns', variables];

useSendgridColumnsQuery.fetcher = (variables: SendgridColumnsQueryVariables) => fetcher<SendgridColumnsQuery, SendgridColumnsQueryVariables>(SendgridColumnsDocument, variables);
export const SfmcColumnsDocument = `
    query SFMCColumns($destinationId: String!, $object: String!) {
  sfmcListAttributeSets(input: {destinationId: $destinationId, object: $object}) {
    ... on SfmcListAttributeSetsSuccess {
      fields {
        name
        id
        type
        standardType
      }
    }
  }
}
    `;
export const useSfmcColumnsQuery = <
      TData = SfmcColumnsQuery,
      TError = Error
    >(
      variables: SfmcColumnsQueryVariables, 
      options?: UseQueryOptions<SfmcColumnsQuery, TError, TData>
    ) => 
    useQuery<SfmcColumnsQuery, TError, TData>(
      ['SFMCColumns', variables],
      fetcher<SfmcColumnsQuery, SfmcColumnsQueryVariables>(SfmcColumnsDocument, variables),
      options
    );
useSfmcColumnsQuery.document = SfmcColumnsDocument;

useSfmcColumnsQuery.getKey = (variables: SfmcColumnsQueryVariables) => ['SFMCColumns', variables];

useSfmcColumnsQuery.fetcher = (variables: SfmcColumnsQueryVariables) => fetcher<SfmcColumnsQuery, SfmcColumnsQueryVariables>(SfmcColumnsDocument, variables);
export const SfmcJourneysDocument = `
    query SFMCJourneys($destinationId: String!) {
  sfmcListJourneys(input: {destinationId: $destinationId}) {
    ... on SfmcListJourneysSuccess {
      journeys {
        name
        id
      }
    }
  }
}
    `;
export const useSfmcJourneysQuery = <
      TData = SfmcJourneysQuery,
      TError = Error
    >(
      variables: SfmcJourneysQueryVariables, 
      options?: UseQueryOptions<SfmcJourneysQuery, TError, TData>
    ) => 
    useQuery<SfmcJourneysQuery, TError, TData>(
      ['SFMCJourneys', variables],
      fetcher<SfmcJourneysQuery, SfmcJourneysQueryVariables>(SfmcJourneysDocument, variables),
      options
    );
useSfmcJourneysQuery.document = SfmcJourneysDocument;

useSfmcJourneysQuery.getKey = (variables: SfmcJourneysQueryVariables) => ['SFMCJourneys', variables];

useSfmcJourneysQuery.fetcher = (variables: SfmcJourneysQueryVariables) => fetcher<SfmcJourneysQuery, SfmcJourneysQueryVariables>(SfmcJourneysDocument, variables);
export const SfmcDataExtensionsDocument = `
    query SFMCDataExtensions($destinationId: String!, $businessUnit: String, $dataFolder: String) {
  sfmcListDataExtensions(
    input: {destinationId: $destinationId, businessUnit: $businessUnit, dataFolder: $dataFolder}
  ) {
    dataExtensions {
      name
      id
    }
  }
}
    `;
export const useSfmcDataExtensionsQuery = <
      TData = SfmcDataExtensionsQuery,
      TError = Error
    >(
      variables: SfmcDataExtensionsQueryVariables, 
      options?: UseQueryOptions<SfmcDataExtensionsQuery, TError, TData>
    ) => 
    useQuery<SfmcDataExtensionsQuery, TError, TData>(
      ['SFMCDataExtensions', variables],
      fetcher<SfmcDataExtensionsQuery, SfmcDataExtensionsQueryVariables>(SfmcDataExtensionsDocument, variables),
      options
    );
useSfmcDataExtensionsQuery.document = SfmcDataExtensionsDocument;

useSfmcDataExtensionsQuery.getKey = (variables: SfmcDataExtensionsQueryVariables) => ['SFMCDataExtensions', variables];

useSfmcDataExtensionsQuery.fetcher = (variables: SfmcDataExtensionsQueryVariables) => fetcher<SfmcDataExtensionsQuery, SfmcDataExtensionsQueryVariables>(SfmcDataExtensionsDocument, variables);
export const SfmcDataExtensionFieldsDocument = `
    query SFMCDataExtensionFields($destinationId: String!, $dataExtensionId: String!, $businessUnit: String) {
  sfmcListDataExtensionFields(
    input: {destinationId: $destinationId, dataExtensionId: $dataExtensionId, businessUnit: $businessUnit}
  ) {
    fields {
      name
      id
      type
      standardType
      isPrimaryKey
      isRequired
    }
  }
}
    `;
export const useSfmcDataExtensionFieldsQuery = <
      TData = SfmcDataExtensionFieldsQuery,
      TError = Error
    >(
      variables: SfmcDataExtensionFieldsQueryVariables, 
      options?: UseQueryOptions<SfmcDataExtensionFieldsQuery, TError, TData>
    ) => 
    useQuery<SfmcDataExtensionFieldsQuery, TError, TData>(
      ['SFMCDataExtensionFields', variables],
      fetcher<SfmcDataExtensionFieldsQuery, SfmcDataExtensionFieldsQueryVariables>(SfmcDataExtensionFieldsDocument, variables),
      options
    );
useSfmcDataExtensionFieldsQuery.document = SfmcDataExtensionFieldsDocument;

useSfmcDataExtensionFieldsQuery.getKey = (variables: SfmcDataExtensionFieldsQueryVariables) => ['SFMCDataExtensionFields', variables];

useSfmcDataExtensionFieldsQuery.fetcher = (variables: SfmcDataExtensionFieldsQueryVariables) => fetcher<SfmcDataExtensionFieldsQuery, SfmcDataExtensionFieldsQueryVariables>(SfmcDataExtensionFieldsDocument, variables);
export const SfmcBusinessUnitsDocument = `
    query SFMCBusinessUnits($destinationId: String!) {
  sfmcListBusinessUnits(input: {destinationId: $destinationId}) {
    businessUnits {
      name
      id
    }
  }
}
    `;
export const useSfmcBusinessUnitsQuery = <
      TData = SfmcBusinessUnitsQuery,
      TError = Error
    >(
      variables: SfmcBusinessUnitsQueryVariables, 
      options?: UseQueryOptions<SfmcBusinessUnitsQuery, TError, TData>
    ) => 
    useQuery<SfmcBusinessUnitsQuery, TError, TData>(
      ['SFMCBusinessUnits', variables],
      fetcher<SfmcBusinessUnitsQuery, SfmcBusinessUnitsQueryVariables>(SfmcBusinessUnitsDocument, variables),
      options
    );
useSfmcBusinessUnitsQuery.document = SfmcBusinessUnitsDocument;

useSfmcBusinessUnitsQuery.getKey = (variables: SfmcBusinessUnitsQueryVariables) => ['SFMCBusinessUnits', variables];

useSfmcBusinessUnitsQuery.fetcher = (variables: SfmcBusinessUnitsQueryVariables) => fetcher<SfmcBusinessUnitsQuery, SfmcBusinessUnitsQueryVariables>(SfmcBusinessUnitsDocument, variables);
export const SfmcDataFoldersDocument = `
    query SFMCDataFolders($destinationId: String!, $businessUnit: String) {
  sfmcListDataFolders(
    input: {destinationId: $destinationId, businessUnit: $businessUnit}
  ) {
    dataFolders {
      name
      id
    }
  }
}
    `;
export const useSfmcDataFoldersQuery = <
      TData = SfmcDataFoldersQuery,
      TError = Error
    >(
      variables: SfmcDataFoldersQueryVariables, 
      options?: UseQueryOptions<SfmcDataFoldersQuery, TError, TData>
    ) => 
    useQuery<SfmcDataFoldersQuery, TError, TData>(
      ['SFMCDataFolders', variables],
      fetcher<SfmcDataFoldersQuery, SfmcDataFoldersQueryVariables>(SfmcDataFoldersDocument, variables),
      options
    );
useSfmcDataFoldersQuery.document = SfmcDataFoldersDocument;

useSfmcDataFoldersQuery.getKey = (variables: SfmcDataFoldersQueryVariables) => ['SFMCDataFolders', variables];

useSfmcDataFoldersQuery.fetcher = (variables: SfmcDataFoldersQueryVariables) => fetcher<SfmcDataFoldersQuery, SfmcDataFoldersQueryVariables>(SfmcDataFoldersDocument, variables);
export const SlackDestinationChannelsDocument = `
    query SlackDestinationChannels($destinationId: String!) {
  slackListChannels(input: {destinationId: $destinationId}) {
    ... on SlackListChannelsSuccess {
      channels {
        name
        id
      }
    }
  }
}
    `;
export const useSlackDestinationChannelsQuery = <
      TData = SlackDestinationChannelsQuery,
      TError = Error
    >(
      variables: SlackDestinationChannelsQueryVariables, 
      options?: UseQueryOptions<SlackDestinationChannelsQuery, TError, TData>
    ) => 
    useQuery<SlackDestinationChannelsQuery, TError, TData>(
      ['SlackDestinationChannels', variables],
      fetcher<SlackDestinationChannelsQuery, SlackDestinationChannelsQueryVariables>(SlackDestinationChannelsDocument, variables),
      options
    );
useSlackDestinationChannelsQuery.document = SlackDestinationChannelsDocument;

useSlackDestinationChannelsQuery.getKey = (variables: SlackDestinationChannelsQueryVariables) => ['SlackDestinationChannels', variables];

useSlackDestinationChannelsQuery.fetcher = (variables: SlackDestinationChannelsQueryVariables) => fetcher<SlackDestinationChannelsQuery, SlackDestinationChannelsQueryVariables>(SlackDestinationChannelsDocument, variables);
export const SnapchatAdAccountsDocument = `
    query SnapchatAdAccounts($destId: String!) {
  snapchatListAdAccounts(input: {destinationId: $destId}) {
    accounts {
      id
      name
    }
  }
}
    `;
export const useSnapchatAdAccountsQuery = <
      TData = SnapchatAdAccountsQuery,
      TError = Error
    >(
      variables: SnapchatAdAccountsQueryVariables, 
      options?: UseQueryOptions<SnapchatAdAccountsQuery, TError, TData>
    ) => 
    useQuery<SnapchatAdAccountsQuery, TError, TData>(
      ['SnapchatAdAccounts', variables],
      fetcher<SnapchatAdAccountsQuery, SnapchatAdAccountsQueryVariables>(SnapchatAdAccountsDocument, variables),
      options
    );
useSnapchatAdAccountsQuery.document = SnapchatAdAccountsDocument;

useSnapchatAdAccountsQuery.getKey = (variables: SnapchatAdAccountsQueryVariables) => ['SnapchatAdAccounts', variables];

useSnapchatAdAccountsQuery.fetcher = (variables: SnapchatAdAccountsQueryVariables) => fetcher<SnapchatAdAccountsQuery, SnapchatAdAccountsQueryVariables>(SnapchatAdAccountsDocument, variables);
export const SnapchatOrganizationsDocument = `
    query SnapchatOrganizations($destId: String!) {
  snapchatListOrganizations(input: {destinationId: $destId}) {
    organizations {
      id
      name
    }
  }
}
    `;
export const useSnapchatOrganizationsQuery = <
      TData = SnapchatOrganizationsQuery,
      TError = Error
    >(
      variables: SnapchatOrganizationsQueryVariables, 
      options?: UseQueryOptions<SnapchatOrganizationsQuery, TError, TData>
    ) => 
    useQuery<SnapchatOrganizationsQuery, TError, TData>(
      ['SnapchatOrganizations', variables],
      fetcher<SnapchatOrganizationsQuery, SnapchatOrganizationsQueryVariables>(SnapchatOrganizationsDocument, variables),
      options
    );
useSnapchatOrganizationsQuery.document = SnapchatOrganizationsDocument;

useSnapchatOrganizationsQuery.getKey = (variables: SnapchatOrganizationsQueryVariables) => ['SnapchatOrganizations', variables];

useSnapchatOrganizationsQuery.fetcher = (variables: SnapchatOrganizationsQueryVariables) => fetcher<SnapchatOrganizationsQuery, SnapchatOrganizationsQueryVariables>(SnapchatOrganizationsDocument, variables);
export const TiktokAdvertisersDocument = `
    query TiktokAdvertisers($destinationId: String!) {
  tiktokListAdvertisers(input: {destinationId: $destinationId})
}
    `;
export const useTiktokAdvertisersQuery = <
      TData = TiktokAdvertisersQuery,
      TError = Error
    >(
      variables: TiktokAdvertisersQueryVariables, 
      options?: UseQueryOptions<TiktokAdvertisersQuery, TError, TData>
    ) => 
    useQuery<TiktokAdvertisersQuery, TError, TData>(
      ['TiktokAdvertisers', variables],
      fetcher<TiktokAdvertisersQuery, TiktokAdvertisersQueryVariables>(TiktokAdvertisersDocument, variables),
      options
    );
useTiktokAdvertisersQuery.document = TiktokAdvertisersDocument;

useTiktokAdvertisersQuery.getKey = (variables: TiktokAdvertisersQueryVariables) => ['TiktokAdvertisers', variables];

useTiktokAdvertisersQuery.fetcher = (variables: TiktokAdvertisersQueryVariables) => fetcher<TiktokAdvertisersQuery, TiktokAdvertisersQueryVariables>(TiktokAdvertisersDocument, variables);
export const UserflowAttributesDocument = `
    query UserflowAttributes($destinationId: String!, $object: String!) {
  userflowGetAttributes(input: {destinationId: $destinationId, object: $object}) {
    attributes {
      id
      name
      type
      displayName
    }
  }
}
    `;
export const useUserflowAttributesQuery = <
      TData = UserflowAttributesQuery,
      TError = Error
    >(
      variables: UserflowAttributesQueryVariables, 
      options?: UseQueryOptions<UserflowAttributesQuery, TError, TData>
    ) => 
    useQuery<UserflowAttributesQuery, TError, TData>(
      ['UserflowAttributes', variables],
      fetcher<UserflowAttributesQuery, UserflowAttributesQueryVariables>(UserflowAttributesDocument, variables),
      options
    );
useUserflowAttributesQuery.document = UserflowAttributesDocument;

useUserflowAttributesQuery.getKey = (variables: UserflowAttributesQueryVariables) => ['UserflowAttributes', variables];

useUserflowAttributesQuery.fetcher = (variables: UserflowAttributesQueryVariables) => fetcher<UserflowAttributesQuery, UserflowAttributesQueryVariables>(UserflowAttributesDocument, variables);
export const AlertingCredentialsDocument = `
    query AlertingCredentials {
  slack_credentials {
    ...SlackCredentials
  }
  pagerduty_credentials {
    ...PagerDutyCredentials
  }
}
    ${SlackCredentialsFragmentDoc}
${PagerDutyCredentialsFragmentDoc}`;
export const useAlertingCredentialsQuery = <
      TData = AlertingCredentialsQuery,
      TError = Error
    >(
      variables?: AlertingCredentialsQueryVariables, 
      options?: UseQueryOptions<AlertingCredentialsQuery, TError, TData>
    ) => 
    useQuery<AlertingCredentialsQuery, TError, TData>(
      variables === undefined ? ['AlertingCredentials'] : ['AlertingCredentials', variables],
      fetcher<AlertingCredentialsQuery, AlertingCredentialsQueryVariables>(AlertingCredentialsDocument, variables),
      options
    );
useAlertingCredentialsQuery.document = AlertingCredentialsDocument;

useAlertingCredentialsQuery.getKey = (variables?: AlertingCredentialsQueryVariables) => variables === undefined ? ['AlertingCredentials'] : ['AlertingCredentials', variables];

useAlertingCredentialsQuery.fetcher = (variables?: AlertingCredentialsQueryVariables) => fetcher<AlertingCredentialsQuery, AlertingCredentialsQueryVariables>(AlertingCredentialsDocument, variables);
export const PagerDutyCredentialsDocument = `
    query PagerDutyCredentials {
  pagerduty_credentials {
    ...PagerDutyCredentials
  }
}
    ${PagerDutyCredentialsFragmentDoc}`;
export const usePagerDutyCredentialsQuery = <
      TData = PagerDutyCredentialsQuery,
      TError = Error
    >(
      variables?: PagerDutyCredentialsQueryVariables, 
      options?: UseQueryOptions<PagerDutyCredentialsQuery, TError, TData>
    ) => 
    useQuery<PagerDutyCredentialsQuery, TError, TData>(
      variables === undefined ? ['PagerDutyCredentials'] : ['PagerDutyCredentials', variables],
      fetcher<PagerDutyCredentialsQuery, PagerDutyCredentialsQueryVariables>(PagerDutyCredentialsDocument, variables),
      options
    );
usePagerDutyCredentialsQuery.document = PagerDutyCredentialsDocument;

usePagerDutyCredentialsQuery.getKey = (variables?: PagerDutyCredentialsQueryVariables) => variables === undefined ? ['PagerDutyCredentials'] : ['PagerDutyCredentials', variables];

usePagerDutyCredentialsQuery.fetcher = (variables?: PagerDutyCredentialsQueryVariables) => fetcher<PagerDutyCredentialsQuery, PagerDutyCredentialsQueryVariables>(PagerDutyCredentialsDocument, variables);
export const SlackCredentialsDocument = `
    query SlackCredentials {
  slack_credentials {
    ...SlackCredentials
  }
}
    ${SlackCredentialsFragmentDoc}`;
export const useSlackCredentialsQuery = <
      TData = SlackCredentialsQuery,
      TError = Error
    >(
      variables?: SlackCredentialsQueryVariables, 
      options?: UseQueryOptions<SlackCredentialsQuery, TError, TData>
    ) => 
    useQuery<SlackCredentialsQuery, TError, TData>(
      variables === undefined ? ['SlackCredentials'] : ['SlackCredentials', variables],
      fetcher<SlackCredentialsQuery, SlackCredentialsQueryVariables>(SlackCredentialsDocument, variables),
      options
    );
useSlackCredentialsQuery.document = SlackCredentialsDocument;

useSlackCredentialsQuery.getKey = (variables?: SlackCredentialsQueryVariables) => variables === undefined ? ['SlackCredentials'] : ['SlackCredentials', variables];

useSlackCredentialsQuery.fetcher = (variables?: SlackCredentialsQueryVariables) => fetcher<SlackCredentialsQuery, SlackCredentialsQueryVariables>(SlackCredentialsDocument, variables);
export const UpdateSlackCredentialsDocument = `
    mutation UpdateSlackCredentials($id: Int!, $object: slack_credentials_set_input) {
  update_slack_credentials_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    state
    channel_id
    channel_name
  }
}
    `;
export const useUpdateSlackCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSlackCredentialsMutation, TError, UpdateSlackCredentialsMutationVariables, TContext>) => 
    useMutation<UpdateSlackCredentialsMutation, TError, UpdateSlackCredentialsMutationVariables, TContext>(
      (variables?: UpdateSlackCredentialsMutationVariables) => fetcher<UpdateSlackCredentialsMutation, UpdateSlackCredentialsMutationVariables>(UpdateSlackCredentialsDocument, variables)(),
      options
    );
export const SlackChannelsDocument = `
    query SlackChannels($id: Int!) {
  listSlackChannelsByCredentials(id: $id) {
    id
    name
  }
}
    `;
export const useSlackChannelsQuery = <
      TData = SlackChannelsQuery,
      TError = Error
    >(
      variables: SlackChannelsQueryVariables, 
      options?: UseQueryOptions<SlackChannelsQuery, TError, TData>
    ) => 
    useQuery<SlackChannelsQuery, TError, TData>(
      ['SlackChannels', variables],
      fetcher<SlackChannelsQuery, SlackChannelsQueryVariables>(SlackChannelsDocument, variables),
      options
    );
useSlackChannelsQuery.document = SlackChannelsDocument;

useSlackChannelsQuery.getKey = (variables: SlackChannelsQueryVariables) => ['SlackChannels', variables];

useSlackChannelsQuery.fetcher = (variables: SlackChannelsQueryVariables) => fetcher<SlackChannelsQuery, SlackChannelsQueryVariables>(SlackChannelsDocument, variables);
export const UpdatePagerDutyCredentialsDocument = `
    mutation UpdatePagerDutyCredentials($id: Int!, $object: pagerduty_credentials_set_input) {
  update_pagerduty_credentials_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `;
export const useUpdatePagerDutyCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePagerDutyCredentialsMutation, TError, UpdatePagerDutyCredentialsMutationVariables, TContext>) => 
    useMutation<UpdatePagerDutyCredentialsMutation, TError, UpdatePagerDutyCredentialsMutationVariables, TContext>(
      (variables?: UpdatePagerDutyCredentialsMutationVariables) => fetcher<UpdatePagerDutyCredentialsMutation, UpdatePagerDutyCredentialsMutationVariables>(UpdatePagerDutyCredentialsDocument, variables)(),
      options
    );
export const CreatePagerDutyCredentialsDocument = `
    mutation CreatePagerDutyCredentials($object: pagerduty_credentials_insert_input!) {
  insert_pagerduty_credentials_one(object: $object) {
    id
  }
}
    `;
export const useCreatePagerDutyCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePagerDutyCredentialsMutation, TError, CreatePagerDutyCredentialsMutationVariables, TContext>) => 
    useMutation<CreatePagerDutyCredentialsMutation, TError, CreatePagerDutyCredentialsMutationVariables, TContext>(
      (variables?: CreatePagerDutyCredentialsMutationVariables) => fetcher<CreatePagerDutyCredentialsMutation, CreatePagerDutyCredentialsMutationVariables>(CreatePagerDutyCredentialsDocument, variables)(),
      options
    );
export const ExtensionsDocument = `
    query Extensions {
  alerting: alerts {
    id
  }
  monitoring: datadog_credentials {
    id
  }
  dbtCloud: dbt_credentials {
    id
  }
  dbtModels: dbt_sync_config {
    id
  }
  gitSync: git_sync_configs {
    enabled
  }
  looker: looker_credentials {
    id
  }
}
    `;
export const useExtensionsQuery = <
      TData = ExtensionsQuery,
      TError = Error
    >(
      variables?: ExtensionsQueryVariables, 
      options?: UseQueryOptions<ExtensionsQuery, TError, TData>
    ) => 
    useQuery<ExtensionsQuery, TError, TData>(
      variables === undefined ? ['Extensions'] : ['Extensions', variables],
      fetcher<ExtensionsQuery, ExtensionsQueryVariables>(ExtensionsDocument, variables),
      options
    );
useExtensionsQuery.document = ExtensionsDocument;

useExtensionsQuery.getKey = (variables?: ExtensionsQueryVariables) => variables === undefined ? ['Extensions'] : ['Extensions', variables];

useExtensionsQuery.fetcher = (variables?: ExtensionsQueryVariables) => fetcher<ExtensionsQuery, ExtensionsQueryVariables>(ExtensionsDocument, variables);
export const CreateFeedbackDocument = `
    mutation CreateFeedback($description: String!) {
  createFeedback(description: $description)
}
    `;
export const useCreateFeedbackMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeedbackMutation, TError, CreateFeedbackMutationVariables, TContext>) => 
    useMutation<CreateFeedbackMutation, TError, CreateFeedbackMutationVariables, TContext>(
      (variables?: CreateFeedbackMutationVariables) => fetcher<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, variables)(),
      options
    );
export const CreateFeatureRequestDocument = `
    mutation CreateFeatureRequest($description: String!) {
  createFeatureRequest(description: $description)
}
    `;
export const useCreateFeatureRequestMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeatureRequestMutation, TError, CreateFeatureRequestMutationVariables, TContext>) => 
    useMutation<CreateFeatureRequestMutation, TError, CreateFeatureRequestMutationVariables, TContext>(
      (variables?: CreateFeatureRequestMutationVariables) => fetcher<CreateFeatureRequestMutation, CreateFeatureRequestMutationVariables>(CreateFeatureRequestDocument, variables)(),
      options
    );
export const CreateIntegrationRequestDocument = `
    mutation CreateIntegrationRequest($type: IntegrationRequestType!, $name: String!, $description: String!) {
  createIntegrationRequest(type: $type, name: $name, description: $description)
}
    `;
export const useCreateIntegrationRequestMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateIntegrationRequestMutation, TError, CreateIntegrationRequestMutationVariables, TContext>) => 
    useMutation<CreateIntegrationRequestMutation, TError, CreateIntegrationRequestMutationVariables, TContext>(
      (variables?: CreateIntegrationRequestMutationVariables) => fetcher<CreateIntegrationRequestMutation, CreateIntegrationRequestMutationVariables>(CreateIntegrationRequestDocument, variables)(),
      options
    );
export const FormkitSyncDefinitionDocument = `
    query FormkitSyncDefinition($type: String!) {
  formkitSyncDefinition(input: {type: $type})
}
    `;
export const useFormkitSyncDefinitionQuery = <
      TData = FormkitSyncDefinitionQuery,
      TError = Error
    >(
      variables: FormkitSyncDefinitionQueryVariables, 
      options?: UseQueryOptions<FormkitSyncDefinitionQuery, TError, TData>
    ) => 
    useQuery<FormkitSyncDefinitionQuery, TError, TData>(
      ['FormkitSyncDefinition', variables],
      fetcher<FormkitSyncDefinitionQuery, FormkitSyncDefinitionQueryVariables>(FormkitSyncDefinitionDocument, variables),
      options
    );
useFormkitSyncDefinitionQuery.document = FormkitSyncDefinitionDocument;

useFormkitSyncDefinitionQuery.getKey = (variables: FormkitSyncDefinitionQueryVariables) => ['FormkitSyncDefinition', variables];

useFormkitSyncDefinitionQuery.fetcher = (variables: FormkitSyncDefinitionQueryVariables) => fetcher<FormkitSyncDefinitionQuery, FormkitSyncDefinitionQueryVariables>(FormkitSyncDefinitionDocument, variables);
export const FormkitSyncHandlerDocument = `
    query FormkitSyncHandler($handler: String!, $context: FormkitSyncContext!, $variables: JSONObject) {
  formkitSyncHandler(
    input: {context: $context, handler: $handler, variables: $variables}
  )
}
    `;
export const useFormkitSyncHandlerQuery = <
      TData = FormkitSyncHandlerQuery,
      TError = Error
    >(
      variables: FormkitSyncHandlerQueryVariables, 
      options?: UseQueryOptions<FormkitSyncHandlerQuery, TError, TData>
    ) => 
    useQuery<FormkitSyncHandlerQuery, TError, TData>(
      ['FormkitSyncHandler', variables],
      fetcher<FormkitSyncHandlerQuery, FormkitSyncHandlerQueryVariables>(FormkitSyncHandlerDocument, variables),
      options
    );
useFormkitSyncHandlerQuery.document = FormkitSyncHandlerDocument;

useFormkitSyncHandlerQuery.getKey = (variables: FormkitSyncHandlerQueryVariables) => ['FormkitSyncHandler', variables];

useFormkitSyncHandlerQuery.fetcher = (variables: FormkitSyncHandlerQueryVariables) => fetcher<FormkitSyncHandlerQuery, FormkitSyncHandlerQueryVariables>(FormkitSyncHandlerDocument, variables);
export const FormkitSyncValidationDocument = `
    query FormkitSyncValidation($type: String!, $context: JSONObject, $config: JSONObject!) {
  formkitSyncValidation(input: {type: $type, config: $config})
}
    `;
export const useFormkitSyncValidationQuery = <
      TData = FormkitSyncValidationQuery,
      TError = Error
    >(
      variables: FormkitSyncValidationQueryVariables, 
      options?: UseQueryOptions<FormkitSyncValidationQuery, TError, TData>
    ) => 
    useQuery<FormkitSyncValidationQuery, TError, TData>(
      ['FormkitSyncValidation', variables],
      fetcher<FormkitSyncValidationQuery, FormkitSyncValidationQueryVariables>(FormkitSyncValidationDocument, variables),
      options
    );
useFormkitSyncValidationQuery.document = FormkitSyncValidationDocument;

useFormkitSyncValidationQuery.getKey = (variables: FormkitSyncValidationQueryVariables) => ['FormkitSyncValidation', variables];

useFormkitSyncValidationQuery.fetcher = (variables: FormkitSyncValidationQueryVariables) => fetcher<FormkitSyncValidationQuery, FormkitSyncValidationQueryVariables>(FormkitSyncValidationDocument, variables);
export const FormkitSourceDefinitionDocument = `
    query FormkitSourceDefinition($type: String!) {
  formkitSourceDefinition(input: {type: $type}) {
    key
    form
    method
    label
    url
    provider
    tunneling
  }
}
    `;
export const useFormkitSourceDefinitionQuery = <
      TData = FormkitSourceDefinitionQuery,
      TError = Error
    >(
      variables: FormkitSourceDefinitionQueryVariables, 
      options?: UseQueryOptions<FormkitSourceDefinitionQuery, TError, TData>
    ) => 
    useQuery<FormkitSourceDefinitionQuery, TError, TData>(
      ['FormkitSourceDefinition', variables],
      fetcher<FormkitSourceDefinitionQuery, FormkitSourceDefinitionQueryVariables>(FormkitSourceDefinitionDocument, variables),
      options
    );
useFormkitSourceDefinitionQuery.document = FormkitSourceDefinitionDocument;

useFormkitSourceDefinitionQuery.getKey = (variables: FormkitSourceDefinitionQueryVariables) => ['FormkitSourceDefinition', variables];

useFormkitSourceDefinitionQuery.fetcher = (variables: FormkitSourceDefinitionQueryVariables) => fetcher<FormkitSourceDefinitionQuery, FormkitSourceDefinitionQueryVariables>(FormkitSourceDefinitionDocument, variables);
export const FormkitSourceHandlerDocument = `
    query FormkitSourceHandler($handler: String!, $context: FormkitSourceContext!, $variables: JSONObject) {
  formkitSourceHandler(
    input: {context: $context, handler: $handler, variables: $variables}
  )
}
    `;
export const useFormkitSourceHandlerQuery = <
      TData = FormkitSourceHandlerQuery,
      TError = Error
    >(
      variables: FormkitSourceHandlerQueryVariables, 
      options?: UseQueryOptions<FormkitSourceHandlerQuery, TError, TData>
    ) => 
    useQuery<FormkitSourceHandlerQuery, TError, TData>(
      ['FormkitSourceHandler', variables],
      fetcher<FormkitSourceHandlerQuery, FormkitSourceHandlerQueryVariables>(FormkitSourceHandlerDocument, variables),
      options
    );
useFormkitSourceHandlerQuery.document = FormkitSourceHandlerDocument;

useFormkitSourceHandlerQuery.getKey = (variables: FormkitSourceHandlerQueryVariables) => ['FormkitSourceHandler', variables];

useFormkitSourceHandlerQuery.fetcher = (variables: FormkitSourceHandlerQueryVariables) => fetcher<FormkitSourceHandlerQuery, FormkitSourceHandlerQueryVariables>(FormkitSourceHandlerDocument, variables);
export const FormkitSourceValidationDocument = `
    query FormkitSourceValidation($type: String!, $context: JSONObject, $config: JSONObject!) {
  formkitSourceValidation(
    input: {type: $type, config: $config, context: $context}
  )
}
    `;
export const useFormkitSourceValidationQuery = <
      TData = FormkitSourceValidationQuery,
      TError = Error
    >(
      variables: FormkitSourceValidationQueryVariables, 
      options?: UseQueryOptions<FormkitSourceValidationQuery, TError, TData>
    ) => 
    useQuery<FormkitSourceValidationQuery, TError, TData>(
      ['FormkitSourceValidation', variables],
      fetcher<FormkitSourceValidationQuery, FormkitSourceValidationQueryVariables>(FormkitSourceValidationDocument, variables),
      options
    );
useFormkitSourceValidationQuery.document = FormkitSourceValidationDocument;

useFormkitSourceValidationQuery.getKey = (variables: FormkitSourceValidationQueryVariables) => ['FormkitSourceValidation', variables];

useFormkitSourceValidationQuery.fetcher = (variables: FormkitSourceValidationQueryVariables) => fetcher<FormkitSourceValidationQuery, FormkitSourceValidationQueryVariables>(FormkitSourceValidationDocument, variables);
export const GitSyncConfigsDocument = `
    query GitSyncConfigs {
  git_sync_configs {
    id
    workspace_id
    path
    full_resync
    git_credential_id
    git_credential {
      ...GitCredentials
    }
    outbound_error
    inbound_error
    git_inbound_runs(limit: 10, order_by: {created_at: desc}) {
      id
      created_at
      commit
      affected_resources
    }
    git_outbound_runs(limit: 10, order_by: {created_at: desc}) {
      id
      created_at
      changelog_id
      commits
    }
    repository
    branch
    enabled
    last_attempted_at
  }
}
    ${GitCredentialsFragmentDoc}`;
export const useGitSyncConfigsQuery = <
      TData = GitSyncConfigsQuery,
      TError = Error
    >(
      variables?: GitSyncConfigsQueryVariables, 
      options?: UseQueryOptions<GitSyncConfigsQuery, TError, TData>
    ) => 
    useQuery<GitSyncConfigsQuery, TError, TData>(
      variables === undefined ? ['GitSyncConfigs'] : ['GitSyncConfigs', variables],
      fetcher<GitSyncConfigsQuery, GitSyncConfigsQueryVariables>(GitSyncConfigsDocument, variables),
      options
    );
useGitSyncConfigsQuery.document = GitSyncConfigsDocument;

useGitSyncConfigsQuery.getKey = (variables?: GitSyncConfigsQueryVariables) => variables === undefined ? ['GitSyncConfigs'] : ['GitSyncConfigs', variables];

useGitSyncConfigsQuery.fetcher = (variables?: GitSyncConfigsQueryVariables) => fetcher<GitSyncConfigsQuery, GitSyncConfigsQueryVariables>(GitSyncConfigsDocument, variables);
export const UpdateGitSyncConfigsDocument = `
    mutation UpdateGitSyncConfigs($id: bigint!, $object: git_sync_configs_set_input) {
  update_git_sync_configs_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    workspace_id
    path
    git_credential_id
    repository
    branch
    enabled
    last_attempted_at
  }
}
    `;
export const useUpdateGitSyncConfigsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGitSyncConfigsMutation, TError, UpdateGitSyncConfigsMutationVariables, TContext>) => 
    useMutation<UpdateGitSyncConfigsMutation, TError, UpdateGitSyncConfigsMutationVariables, TContext>(
      (variables?: UpdateGitSyncConfigsMutationVariables) => fetcher<UpdateGitSyncConfigsMutation, UpdateGitSyncConfigsMutationVariables>(UpdateGitSyncConfigsDocument, variables)(),
      options
    );
export const CreateGitSyncConfigsDocument = `
    mutation CreateGitSyncConfigs($object: git_sync_configs_insert_input!) {
  insert_git_sync_configs_one(object: $object) {
    id
    workspace_id
    path
    git_credential_id
    repository
    branch
    enabled
    last_attempted_at
  }
}
    `;
export const useCreateGitSyncConfigsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGitSyncConfigsMutation, TError, CreateGitSyncConfigsMutationVariables, TContext>) => 
    useMutation<CreateGitSyncConfigsMutation, TError, CreateGitSyncConfigsMutationVariables, TContext>(
      (variables?: CreateGitSyncConfigsMutationVariables) => fetcher<CreateGitSyncConfigsMutation, CreateGitSyncConfigsMutationVariables>(CreateGitSyncConfigsDocument, variables)(),
      options
    );
export const GitSyncConfigDocument = `
    query GitSyncConfig {
  git_sync_config {
    id
    workspace_id
    username
    password
    schema
    repository
    bidi
    bidi_metadata
  }
}
    `;
export const useGitSyncConfigQuery = <
      TData = GitSyncConfigQuery,
      TError = Error
    >(
      variables?: GitSyncConfigQueryVariables, 
      options?: UseQueryOptions<GitSyncConfigQuery, TError, TData>
    ) => 
    useQuery<GitSyncConfigQuery, TError, TData>(
      variables === undefined ? ['GitSyncConfig'] : ['GitSyncConfig', variables],
      fetcher<GitSyncConfigQuery, GitSyncConfigQueryVariables>(GitSyncConfigDocument, variables),
      options
    );
useGitSyncConfigQuery.document = GitSyncConfigDocument;

useGitSyncConfigQuery.getKey = (variables?: GitSyncConfigQueryVariables) => variables === undefined ? ['GitSyncConfig'] : ['GitSyncConfig', variables];

useGitSyncConfigQuery.fetcher = (variables?: GitSyncConfigQueryVariables) => fetcher<GitSyncConfigQuery, GitSyncConfigQueryVariables>(GitSyncConfigDocument, variables);
export const GitSyncAttemptsDocument = `
    query GitSyncAttempts($limit: Int, $offset: Int) {
  git_sync_attempts(order_by: {created_at: desc}, limit: $limit, offset: $offset) {
    created_at
    error
    state
    type
  }
  git_sync_attempts_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const useGitSyncAttemptsQuery = <
      TData = GitSyncAttemptsQuery,
      TError = Error
    >(
      variables?: GitSyncAttemptsQueryVariables, 
      options?: UseQueryOptions<GitSyncAttemptsQuery, TError, TData>
    ) => 
    useQuery<GitSyncAttemptsQuery, TError, TData>(
      variables === undefined ? ['GitSyncAttempts'] : ['GitSyncAttempts', variables],
      fetcher<GitSyncAttemptsQuery, GitSyncAttemptsQueryVariables>(GitSyncAttemptsDocument, variables),
      options
    );
useGitSyncAttemptsQuery.document = GitSyncAttemptsDocument;

useGitSyncAttemptsQuery.getKey = (variables?: GitSyncAttemptsQueryVariables) => variables === undefined ? ['GitSyncAttempts'] : ['GitSyncAttempts', variables];

useGitSyncAttemptsQuery.fetcher = (variables?: GitSyncAttemptsQueryVariables) => fetcher<GitSyncAttemptsQuery, GitSyncAttemptsQueryVariables>(GitSyncAttemptsDocument, variables);
export const GitSyncAttemptsByIdDocument = `
    query GitSyncAttemptsById($syncId: jsonb!, $limit: Int, $offset: Int) {
  git_sync_attempts(
    where: {destination_instance_ids: {_contains: $syncId}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    created_at
    error
    state
    type
  }
  git_sync_attempts_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const useGitSyncAttemptsByIdQuery = <
      TData = GitSyncAttemptsByIdQuery,
      TError = Error
    >(
      variables: GitSyncAttemptsByIdQueryVariables, 
      options?: UseQueryOptions<GitSyncAttemptsByIdQuery, TError, TData>
    ) => 
    useQuery<GitSyncAttemptsByIdQuery, TError, TData>(
      ['GitSyncAttemptsById', variables],
      fetcher<GitSyncAttemptsByIdQuery, GitSyncAttemptsByIdQueryVariables>(GitSyncAttemptsByIdDocument, variables),
      options
    );
useGitSyncAttemptsByIdQuery.document = GitSyncAttemptsByIdDocument;

useGitSyncAttemptsByIdQuery.getKey = (variables: GitSyncAttemptsByIdQueryVariables) => ['GitSyncAttemptsById', variables];

useGitSyncAttemptsByIdQuery.fetcher = (variables: GitSyncAttemptsByIdQueryVariables) => fetcher<GitSyncAttemptsByIdQuery, GitSyncAttemptsByIdQueryVariables>(GitSyncAttemptsByIdDocument, variables);
export const CreateGitSyncConfigDocument = `
    mutation CreateGitSyncConfig($config: git_sync_config_insert_input!) {
  insert_git_sync_config_one(object: $config) {
    id
    workspace_id
    username
    password
    schema
    repository
    bidi
    bidi_metadata
  }
}
    `;
export const useCreateGitSyncConfigMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGitSyncConfigMutation, TError, CreateGitSyncConfigMutationVariables, TContext>) => 
    useMutation<CreateGitSyncConfigMutation, TError, CreateGitSyncConfigMutationVariables, TContext>(
      (variables?: CreateGitSyncConfigMutationVariables) => fetcher<CreateGitSyncConfigMutation, CreateGitSyncConfigMutationVariables>(CreateGitSyncConfigDocument, variables)(),
      options
    );
export const UpdateGitSyncConfigDocument = `
    mutation UpdateGitSyncConfig($id: Int!, $config: git_sync_config_set_input!) {
  update_git_sync_config_by_pk(pk_columns: {id: $id}, _set: $config) {
    id
    workspace_id
    username
    password
    schema
    repository
  }
}
    `;
export const useUpdateGitSyncConfigMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGitSyncConfigMutation, TError, UpdateGitSyncConfigMutationVariables, TContext>) => 
    useMutation<UpdateGitSyncConfigMutation, TError, UpdateGitSyncConfigMutationVariables, TContext>(
      (variables?: UpdateGitSyncConfigMutationVariables) => fetcher<UpdateGitSyncConfigMutation, UpdateGitSyncConfigMutationVariables>(UpdateGitSyncConfigDocument, variables)(),
      options
    );
export const GitCredentialsDocument = `
    query GitCredentials {
  git_credentials {
    id
    workspace_id
    tunnel_id
    username
    credentials
    type
  }
}
    `;
export const useGitCredentialsQuery = <
      TData = GitCredentialsQuery,
      TError = Error
    >(
      variables?: GitCredentialsQueryVariables, 
      options?: UseQueryOptions<GitCredentialsQuery, TError, TData>
    ) => 
    useQuery<GitCredentialsQuery, TError, TData>(
      variables === undefined ? ['GitCredentials'] : ['GitCredentials', variables],
      fetcher<GitCredentialsQuery, GitCredentialsQueryVariables>(GitCredentialsDocument, variables),
      options
    );
useGitCredentialsQuery.document = GitCredentialsDocument;

useGitCredentialsQuery.getKey = (variables?: GitCredentialsQueryVariables) => variables === undefined ? ['GitCredentials'] : ['GitCredentials', variables];

useGitCredentialsQuery.fetcher = (variables?: GitCredentialsQueryVariables) => fetcher<GitCredentialsQuery, GitCredentialsQueryVariables>(GitCredentialsDocument, variables);
export const GithubRepositoriesDocument = `
    query GithubRepositories($credentialId: String!) {
  getGithubRepositories(credentialId: $credentialId) {
    fullName
    htmlUrl
  }
}
    `;
export const useGithubRepositoriesQuery = <
      TData = GithubRepositoriesQuery,
      TError = Error
    >(
      variables: GithubRepositoriesQueryVariables, 
      options?: UseQueryOptions<GithubRepositoriesQuery, TError, TData>
    ) => 
    useQuery<GithubRepositoriesQuery, TError, TData>(
      ['GithubRepositories', variables],
      fetcher<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>(GithubRepositoriesDocument, variables),
      options
    );
useGithubRepositoriesQuery.document = GithubRepositoriesDocument;

useGithubRepositoriesQuery.getKey = (variables: GithubRepositoriesQueryVariables) => ['GithubRepositories', variables];

useGithubRepositoriesQuery.fetcher = (variables: GithubRepositoriesQueryVariables) => fetcher<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>(GithubRepositoriesDocument, variables);
export const GithubBranchesDocument = `
    query GithubBranches($credentialId: String!, $repo: String!) {
  getGithubBranches(credentialId: $credentialId, repo: $repo) {
    name
    name
  }
}
    `;
export const useGithubBranchesQuery = <
      TData = GithubBranchesQuery,
      TError = Error
    >(
      variables: GithubBranchesQueryVariables, 
      options?: UseQueryOptions<GithubBranchesQuery, TError, TData>
    ) => 
    useQuery<GithubBranchesQuery, TError, TData>(
      ['GithubBranches', variables],
      fetcher<GithubBranchesQuery, GithubBranchesQueryVariables>(GithubBranchesDocument, variables),
      options
    );
useGithubBranchesQuery.document = GithubBranchesDocument;

useGithubBranchesQuery.getKey = (variables: GithubBranchesQueryVariables) => ['GithubBranches', variables];

useGithubBranchesQuery.fetcher = (variables: GithubBranchesQueryVariables) => fetcher<GithubBranchesQuery, GithubBranchesQueryVariables>(GithubBranchesDocument, variables);
export const CreateGitCredentialsDocument = `
    mutation CreateGitCredentials($credentials: git_credentials_insert_input!) {
  insert_git_credentials_one(object: $credentials) {
    id
    workspace_id
    tunnel_id
    username
    credentials
    type
  }
}
    `;
export const useCreateGitCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGitCredentialsMutation, TError, CreateGitCredentialsMutationVariables, TContext>) => 
    useMutation<CreateGitCredentialsMutation, TError, CreateGitCredentialsMutationVariables, TContext>(
      (variables?: CreateGitCredentialsMutationVariables) => fetcher<CreateGitCredentialsMutation, CreateGitCredentialsMutationVariables>(CreateGitCredentialsDocument, variables)(),
      options
    );
export const UpdateGitCredentialsDocument = `
    mutation UpdateGitCredentials($id: bigint!, $credentials: git_credentials_set_input!) {
  update_git_credentials_by_pk(pk_columns: {id: $id}, _set: $credentials) {
    id
    workspace_id
    tunnel_id
    username
    credentials
    type
  }
}
    `;
export const useUpdateGitCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGitCredentialsMutation, TError, UpdateGitCredentialsMutationVariables, TContext>) => 
    useMutation<UpdateGitCredentialsMutation, TError, UpdateGitCredentialsMutationVariables, TContext>(
      (variables?: UpdateGitCredentialsMutationVariables) => fetcher<UpdateGitCredentialsMutation, UpdateGitCredentialsMutationVariables>(UpdateGitCredentialsDocument, variables)(),
      options
    );
export const GoogleSheetsSourceSpreadSheetsDocument = `
    query GoogleSheetsSourceSpreadSheets($accessToken: String!) {
  googlesheetsListSpreadSheets(accessToken: $accessToken) {
    id
    name
    webViewLink
  }
}
    `;
export const useGoogleSheetsSourceSpreadSheetsQuery = <
      TData = GoogleSheetsSourceSpreadSheetsQuery,
      TError = Error
    >(
      variables: GoogleSheetsSourceSpreadSheetsQueryVariables, 
      options?: UseQueryOptions<GoogleSheetsSourceSpreadSheetsQuery, TError, TData>
    ) => 
    useQuery<GoogleSheetsSourceSpreadSheetsQuery, TError, TData>(
      ['GoogleSheetsSourceSpreadSheets', variables],
      fetcher<GoogleSheetsSourceSpreadSheetsQuery, GoogleSheetsSourceSpreadSheetsQueryVariables>(GoogleSheetsSourceSpreadSheetsDocument, variables),
      options
    );
useGoogleSheetsSourceSpreadSheetsQuery.document = GoogleSheetsSourceSpreadSheetsDocument;

useGoogleSheetsSourceSpreadSheetsQuery.getKey = (variables: GoogleSheetsSourceSpreadSheetsQueryVariables) => ['GoogleSheetsSourceSpreadSheets', variables];

useGoogleSheetsSourceSpreadSheetsQuery.fetcher = (variables: GoogleSheetsSourceSpreadSheetsQueryVariables) => fetcher<GoogleSheetsSourceSpreadSheetsQuery, GoogleSheetsSourceSpreadSheetsQueryVariables>(GoogleSheetsSourceSpreadSheetsDocument, variables);
export const ResourceLabelsDocument = `
    query ResourceLabels($resource: String!) {
  resource_tag_values(where: {resource_type: {_eq: $resource}}) {
    key: tag_key
    values: tag_values
  }
}
    `;
export const useResourceLabelsQuery = <
      TData = ResourceLabelsQuery,
      TError = Error
    >(
      variables: ResourceLabelsQueryVariables, 
      options?: UseQueryOptions<ResourceLabelsQuery, TError, TData>
    ) => 
    useQuery<ResourceLabelsQuery, TError, TData>(
      ['ResourceLabels', variables],
      fetcher<ResourceLabelsQuery, ResourceLabelsQueryVariables>(ResourceLabelsDocument, variables),
      options
    );
useResourceLabelsQuery.document = ResourceLabelsDocument;

useResourceLabelsQuery.getKey = (variables: ResourceLabelsQueryVariables) => ['ResourceLabels', variables];

useResourceLabelsQuery.fetcher = (variables: ResourceLabelsQueryVariables) => fetcher<ResourceLabelsQuery, ResourceLabelsQueryVariables>(ResourceLabelsDocument, variables);
export const LookerCredentialsDocument = `
    query LookerCredentials {
  looker_credentials {
    id
    tunnel_id
    url
    client_id
    client_secret
  }
}
    `;
export const useLookerCredentialsQuery = <
      TData = LookerCredentialsQuery,
      TError = Error
    >(
      variables?: LookerCredentialsQueryVariables, 
      options?: UseQueryOptions<LookerCredentialsQuery, TError, TData>
    ) => 
    useQuery<LookerCredentialsQuery, TError, TData>(
      variables === undefined ? ['LookerCredentials'] : ['LookerCredentials', variables],
      fetcher<LookerCredentialsQuery, LookerCredentialsQueryVariables>(LookerCredentialsDocument, variables),
      options
    );
useLookerCredentialsQuery.document = LookerCredentialsDocument;

useLookerCredentialsQuery.getKey = (variables?: LookerCredentialsQueryVariables) => variables === undefined ? ['LookerCredentials'] : ['LookerCredentials', variables];

useLookerCredentialsQuery.fetcher = (variables?: LookerCredentialsQueryVariables) => fetcher<LookerCredentialsQuery, LookerCredentialsQueryVariables>(LookerCredentialsDocument, variables);
export const CreateLookerCredentialDocument = `
    mutation CreateLookerCredential($credentials: looker_credentials_insert_input!) {
  insert_looker_credentials_one(object: $credentials) {
    id
  }
}
    `;
export const useCreateLookerCredentialMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLookerCredentialMutation, TError, CreateLookerCredentialMutationVariables, TContext>) => 
    useMutation<CreateLookerCredentialMutation, TError, CreateLookerCredentialMutationVariables, TContext>(
      (variables?: CreateLookerCredentialMutationVariables) => fetcher<CreateLookerCredentialMutation, CreateLookerCredentialMutationVariables>(CreateLookerCredentialDocument, variables)(),
      options
    );
export const UpdateLookerCredentialDocument = `
    mutation UpdateLookerCredential($id: Int!, $credentials: looker_credentials_set_input!) {
  update_looker_credentials_by_pk(pk_columns: {id: $id}, _set: $credentials) {
    id
    tunnel_id
    url
    client_id
    client_secret
  }
}
    `;
export const useUpdateLookerCredentialMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLookerCredentialMutation, TError, UpdateLookerCredentialMutationVariables, TContext>) => 
    useMutation<UpdateLookerCredentialMutation, TError, UpdateLookerCredentialMutationVariables, TContext>(
      (variables?: UpdateLookerCredentialMutationVariables) => fetcher<UpdateLookerCredentialMutation, UpdateLookerCredentialMutationVariables>(UpdateLookerCredentialDocument, variables)(),
      options
    );
export const SearchLookerLooksDocument = `
    query SearchLookerLooks($title: String, $sorts: String, $limit: Int, $offset: Int) {
  searchLookerLooks(title: $title, sorts: $sorts, limit: $limit, offset: $offset) {
    looks {
      id
      title
      description
    }
  }
}
    `;
export const useSearchLookerLooksQuery = <
      TData = SearchLookerLooksQuery,
      TError = Error
    >(
      variables?: SearchLookerLooksQueryVariables, 
      options?: UseQueryOptions<SearchLookerLooksQuery, TError, TData>
    ) => 
    useQuery<SearchLookerLooksQuery, TError, TData>(
      variables === undefined ? ['SearchLookerLooks'] : ['SearchLookerLooks', variables],
      fetcher<SearchLookerLooksQuery, SearchLookerLooksQueryVariables>(SearchLookerLooksDocument, variables),
      options
    );
useSearchLookerLooksQuery.document = SearchLookerLooksDocument;

useSearchLookerLooksQuery.getKey = (variables?: SearchLookerLooksQueryVariables) => variables === undefined ? ['SearchLookerLooks'] : ['SearchLookerLooks', variables];

useSearchLookerLooksQuery.fetcher = (variables?: SearchLookerLooksQueryVariables) => fetcher<SearchLookerLooksQuery, SearchLookerLooksQueryVariables>(SearchLookerLooksDocument, variables);
export const GetLookerLookDocument = `
    query GetLookerLook($id: String!, $withSql: Boolean!) {
  getLookerLook(id: $id) {
    look {
      id
      title
      description
      sql @include(if: $withSql)
    }
  }
}
    `;
export const useGetLookerLookQuery = <
      TData = GetLookerLookQuery,
      TError = Error
    >(
      variables: GetLookerLookQueryVariables, 
      options?: UseQueryOptions<GetLookerLookQuery, TError, TData>
    ) => 
    useQuery<GetLookerLookQuery, TError, TData>(
      ['GetLookerLook', variables],
      fetcher<GetLookerLookQuery, GetLookerLookQueryVariables>(GetLookerLookDocument, variables),
      options
    );
useGetLookerLookQuery.document = GetLookerLookDocument;

useGetLookerLookQuery.getKey = (variables: GetLookerLookQueryVariables) => ['GetLookerLook', variables];

useGetLookerLookQuery.fetcher = (variables: GetLookerLookQueryVariables) => fetcher<GetLookerLookQuery, GetLookerLookQueryVariables>(GetLookerLookDocument, variables);
export const ModelsDocument = `
    query Models($filters: segments_bool_exp, $limit: Int!, $offset: Int!, $orderBy: segments_order_by! = {created_at: desc}) {
  segments(
    where: $filters
    order_by: [$orderBy, {name: desc}]
    limit: $limit
    offset: $offset
  ) {
    id
    name
    tags
    ...QueryFields
    ...SegmentHistory
    connection {
      ...Source
    }
    query_runs(limit: 1) {
      size
    }
    syncs(order_by: {destination: {type: asc}}) {
      ...Sync
      destination {
        ...Destination
        definition {
          icon
          name
        }
      }
      sync_requests(order_by: {created_at: desc}, limit: 1) {
        ...SyncRequest
        sync_attempts(order_by: {created_at: desc}, limit: 1) {
          ...SyncAttempt
        }
      }
    }
  }
  segments_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    ${QueryFieldsFragmentDoc}
${SegmentHistoryFragmentDoc}
${SourceFragmentDoc}
${SyncFragmentDoc}
${DestinationFragmentDoc}
${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useModelsQuery = <
      TData = ModelsQuery,
      TError = Error
    >(
      variables: ModelsQueryVariables, 
      options?: UseQueryOptions<ModelsQuery, TError, TData>
    ) => 
    useQuery<ModelsQuery, TError, TData>(
      ['Models', variables],
      fetcher<ModelsQuery, ModelsQueryVariables>(ModelsDocument, variables),
      options
    );
useModelsQuery.document = ModelsDocument;

useModelsQuery.getKey = (variables: ModelsQueryVariables) => ['Models', variables];

useModelsQuery.fetcher = (variables: ModelsQueryVariables) => fetcher<ModelsQuery, ModelsQueryVariables>(ModelsDocument, variables);
export const ModelDocument = `
    query Model($id: bigint!, $columnsOrderBy: model_columns_order_by! = {name: desc}, $syncsOrderBy: syncs_order_by! = {created_at: desc}) {
  segments_by_pk(id: $id) {
    id
    name
    primary_key
    slug
    ...QueryFields
    ...SegmentHistory
    connection {
      ...Source
    }
    syncable_columns {
      ...SyncableColumn
    }
    columns(order_by: [$columnsOrderBy]) {
      ...Column
    }
    syncs(order_by: [$syncsOrderBy, {created_at: desc}]) {
      ...Sync
      ...SyncHistory
      row_threshold_attempted
      row_threshold_total
      sync_alerts {
        ...SyncAlert
      }
      destination {
        ...Destination
        definition {
          icon
          name
        }
      }
      sync_requests(order_by: {created_at: desc}, limit: 1) {
        ...SyncRequest
        sync_attempts(order_by: {created_at: desc}, limit: 1) {
          ...SyncAttempt
        }
      }
    }
    tags
  }
}
    ${QueryFieldsFragmentDoc}
${SegmentHistoryFragmentDoc}
${SourceFragmentDoc}
${SyncableColumnFragmentDoc}
${ColumnFragmentDoc}
${SyncFragmentDoc}
${SyncHistoryFragmentDoc}
${SyncAlertFragmentDoc}
${DestinationFragmentDoc}
${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useModelQuery = <
      TData = ModelQuery,
      TError = Error
    >(
      variables: ModelQueryVariables, 
      options?: UseQueryOptions<ModelQuery, TError, TData>
    ) => 
    useQuery<ModelQuery, TError, TData>(
      ['Model', variables],
      fetcher<ModelQuery, ModelQueryVariables>(ModelDocument, variables),
      options
    );
useModelQuery.document = ModelDocument;

useModelQuery.getKey = (variables: ModelQueryVariables) => ['Model', variables];

useModelQuery.fetcher = (variables: ModelQueryVariables) => fetcher<ModelQuery, ModelQueryVariables>(ModelDocument, variables);
export const ModelsAndAudiencesDocument = `
    query ModelsAndAudiences {
  segments(where: {is_schema: {_eq: false}}, order_by: {created_at: desc}) {
    id
    name
    slug
    ...QueryFields
    connection {
      ...Source
    }
    parent {
      ...AudienceParent
    }
  }
}
    ${QueryFieldsFragmentDoc}
${SourceFragmentDoc}
${AudienceParentFragmentDoc}
${ColumnFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}`;
export const useModelsAndAudiencesQuery = <
      TData = ModelsAndAudiencesQuery,
      TError = Error
    >(
      variables?: ModelsAndAudiencesQueryVariables, 
      options?: UseQueryOptions<ModelsAndAudiencesQuery, TError, TData>
    ) => 
    useQuery<ModelsAndAudiencesQuery, TError, TData>(
      variables === undefined ? ['ModelsAndAudiences'] : ['ModelsAndAudiences', variables],
      fetcher<ModelsAndAudiencesQuery, ModelsAndAudiencesQueryVariables>(ModelsAndAudiencesDocument, variables),
      options
    );
useModelsAndAudiencesQuery.document = ModelsAndAudiencesDocument;

useModelsAndAudiencesQuery.getKey = (variables?: ModelsAndAudiencesQueryVariables) => variables === undefined ? ['ModelsAndAudiences'] : ['ModelsAndAudiences', variables];

useModelsAndAudiencesQuery.fetcher = (variables?: ModelsAndAudiencesQueryVariables) => fetcher<ModelsAndAudiencesQuery, ModelsAndAudiencesQueryVariables>(ModelsAndAudiencesDocument, variables);
export const CreateModelDocument = `
    mutation CreateModel($input: segments_insert_input!) {
  insert_segments_one(object: $input) {
    id
  }
}
    `;
export const useCreateModelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateModelMutation, TError, CreateModelMutationVariables, TContext>) => 
    useMutation<CreateModelMutation, TError, CreateModelMutationVariables, TContext>(
      (variables?: CreateModelMutationVariables) => fetcher<CreateModelMutation, CreateModelMutationVariables>(CreateModelDocument, variables)(),
      options
    );
export const UpdateModelDocument = `
    mutation UpdateModel($id: bigint!, $input: segments_set_input!) {
  update_segments_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateModelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateModelMutation, TError, UpdateModelMutationVariables, TContext>) => 
    useMutation<UpdateModelMutation, TError, UpdateModelMutationVariables, TContext>(
      (variables?: UpdateModelMutationVariables) => fetcher<UpdateModelMutation, UpdateModelMutationVariables>(UpdateModelDocument, variables)(),
      options
    );
export const DeleteModelDocument = `
    mutation DeleteModel($id: bigint!) {
  delete_segments_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteModelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteModelMutation, TError, DeleteModelMutationVariables, TContext>) => 
    useMutation<DeleteModelMutation, TError, DeleteModelMutationVariables, TContext>(
      (variables?: DeleteModelMutationVariables) => fetcher<DeleteModelMutation, DeleteModelMutationVariables>(DeleteModelDocument, variables)(),
      options
    );
export const DeleteModelsDocument = `
    mutation DeleteModels($ids: [bigint!]!) {
  delete_segments(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteModelsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteModelsMutation, TError, DeleteModelsMutationVariables, TContext>) => 
    useMutation<DeleteModelsMutation, TError, DeleteModelsMutationVariables, TContext>(
      (variables?: DeleteModelsMutationVariables) => fetcher<DeleteModelsMutation, DeleteModelsMutationVariables>(DeleteModelsDocument, variables)(),
      options
    );
export const Auth0ConnectionsByOrganizationDocument = `
    query Auth0ConnectionsByOrganization($slug: String!) {
  getAuth0ConnectionsByOrganization(slug: $slug) {
    auth0Connections {
      name
      id
      auth0_id
    }
  }
}
    `;
export const useAuth0ConnectionsByOrganizationQuery = <
      TData = Auth0ConnectionsByOrganizationQuery,
      TError = Error
    >(
      variables: Auth0ConnectionsByOrganizationQueryVariables, 
      options?: UseQueryOptions<Auth0ConnectionsByOrganizationQuery, TError, TData>
    ) => 
    useQuery<Auth0ConnectionsByOrganizationQuery, TError, TData>(
      ['Auth0ConnectionsByOrganization', variables],
      fetcher<Auth0ConnectionsByOrganizationQuery, Auth0ConnectionsByOrganizationQueryVariables>(Auth0ConnectionsByOrganizationDocument, variables),
      options
    );
useAuth0ConnectionsByOrganizationQuery.document = Auth0ConnectionsByOrganizationDocument;

useAuth0ConnectionsByOrganizationQuery.getKey = (variables: Auth0ConnectionsByOrganizationQueryVariables) => ['Auth0ConnectionsByOrganization', variables];

useAuth0ConnectionsByOrganizationQuery.fetcher = (variables: Auth0ConnectionsByOrganizationQueryVariables) => fetcher<Auth0ConnectionsByOrganizationQuery, Auth0ConnectionsByOrganizationQueryVariables>(Auth0ConnectionsByOrganizationDocument, variables);
export const OrganizationDocument = `
    query Organization {
  getOrganization {
    name
    id
    slug
  }
}
    `;
export const useOrganizationQuery = <
      TData = OrganizationQuery,
      TError = Error
    >(
      variables?: OrganizationQueryVariables, 
      options?: UseQueryOptions<OrganizationQuery, TError, TData>
    ) => 
    useQuery<OrganizationQuery, TError, TData>(
      variables === undefined ? ['Organization'] : ['Organization', variables],
      fetcher<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, variables),
      options
    );
useOrganizationQuery.document = OrganizationDocument;

useOrganizationQuery.getKey = (variables?: OrganizationQueryVariables) => variables === undefined ? ['Organization'] : ['Organization', variables];

useOrganizationQuery.fetcher = (variables?: OrganizationQueryVariables) => fetcher<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, variables);
export const BillingOrganizationDocument = `
    query BillingOrganization {
  getBillingOrganization {
    name
    id
    slug
    billing
    entitlements
    plan {
      name
      sku
      entitlements
    }
  }
}
    `;
export const useBillingOrganizationQuery = <
      TData = BillingOrganizationQuery,
      TError = Error
    >(
      variables?: BillingOrganizationQueryVariables, 
      options?: UseQueryOptions<BillingOrganizationQuery, TError, TData>
    ) => 
    useQuery<BillingOrganizationQuery, TError, TData>(
      variables === undefined ? ['BillingOrganization'] : ['BillingOrganization', variables],
      fetcher<BillingOrganizationQuery, BillingOrganizationQueryVariables>(BillingOrganizationDocument, variables),
      options
    );
useBillingOrganizationQuery.document = BillingOrganizationDocument;

useBillingOrganizationQuery.getKey = (variables?: BillingOrganizationQueryVariables) => variables === undefined ? ['BillingOrganization'] : ['BillingOrganization', variables];

useBillingOrganizationQuery.fetcher = (variables?: BillingOrganizationQueryVariables) => fetcher<BillingOrganizationQuery, BillingOrganizationQueryVariables>(BillingOrganizationDocument, variables);
export const OrganizationMetricsDocument = `
    query OrganizationMetrics {
  getOrganizationMetrics {
    metrics {
      id
      name
      slug
      created_at
      destinations
      connections
      models
      audiences
      syncs
    }
    roles {
      workspace_id
      name
      count
    }
  }
}
    `;
export const useOrganizationMetricsQuery = <
      TData = OrganizationMetricsQuery,
      TError = Error
    >(
      variables?: OrganizationMetricsQueryVariables, 
      options?: UseQueryOptions<OrganizationMetricsQuery, TError, TData>
    ) => 
    useQuery<OrganizationMetricsQuery, TError, TData>(
      variables === undefined ? ['OrganizationMetrics'] : ['OrganizationMetrics', variables],
      fetcher<OrganizationMetricsQuery, OrganizationMetricsQueryVariables>(OrganizationMetricsDocument, variables),
      options
    );
useOrganizationMetricsQuery.document = OrganizationMetricsDocument;

useOrganizationMetricsQuery.getKey = (variables?: OrganizationMetricsQueryVariables) => variables === undefined ? ['OrganizationMetrics'] : ['OrganizationMetrics', variables];

useOrganizationMetricsQuery.fetcher = (variables?: OrganizationMetricsQueryVariables) => fetcher<OrganizationMetricsQuery, OrganizationMetricsQueryVariables>(OrganizationMetricsDocument, variables);
export const OrganizationDestinationTypesDocument = `
    query OrganizationDestinationTypes {
  getOrganizationDestinationTypes {
    type
    count
  }
}
    `;
export const useOrganizationDestinationTypesQuery = <
      TData = OrganizationDestinationTypesQuery,
      TError = Error
    >(
      variables?: OrganizationDestinationTypesQueryVariables, 
      options?: UseQueryOptions<OrganizationDestinationTypesQuery, TError, TData>
    ) => 
    useQuery<OrganizationDestinationTypesQuery, TError, TData>(
      variables === undefined ? ['OrganizationDestinationTypes'] : ['OrganizationDestinationTypes', variables],
      fetcher<OrganizationDestinationTypesQuery, OrganizationDestinationTypesQueryVariables>(OrganizationDestinationTypesDocument, variables),
      options
    );
useOrganizationDestinationTypesQuery.document = OrganizationDestinationTypesDocument;

useOrganizationDestinationTypesQuery.getKey = (variables?: OrganizationDestinationTypesQueryVariables) => variables === undefined ? ['OrganizationDestinationTypes'] : ['OrganizationDestinationTypes', variables];

useOrganizationDestinationTypesQuery.fetcher = (variables?: OrganizationDestinationTypesQueryVariables) => fetcher<OrganizationDestinationTypesQuery, OrganizationDestinationTypesQueryVariables>(OrganizationDestinationTypesDocument, variables);
export const IsOrganizationSlugAvailableDocument = `
    query IsOrganizationSlugAvailable($name: String!) {
  isOrganizationAvailable(name: $name)
}
    `;
export const useIsOrganizationSlugAvailableQuery = <
      TData = IsOrganizationSlugAvailableQuery,
      TError = Error
    >(
      variables: IsOrganizationSlugAvailableQueryVariables, 
      options?: UseQueryOptions<IsOrganizationSlugAvailableQuery, TError, TData>
    ) => 
    useQuery<IsOrganizationSlugAvailableQuery, TError, TData>(
      ['IsOrganizationSlugAvailable', variables],
      fetcher<IsOrganizationSlugAvailableQuery, IsOrganizationSlugAvailableQueryVariables>(IsOrganizationSlugAvailableDocument, variables),
      options
    );
useIsOrganizationSlugAvailableQuery.document = IsOrganizationSlugAvailableDocument;

useIsOrganizationSlugAvailableQuery.getKey = (variables: IsOrganizationSlugAvailableQueryVariables) => ['IsOrganizationSlugAvailable', variables];

useIsOrganizationSlugAvailableQuery.fetcher = (variables: IsOrganizationSlugAvailableQueryVariables) => fetcher<IsOrganizationSlugAvailableQuery, IsOrganizationSlugAvailableQueryVariables>(IsOrganizationSlugAvailableDocument, variables);
export const PartnerConnectGetConnectionDocument = `
    query PartnerConnectGetConnection($uuid: String!) {
  partnerConnectGetConnection(uuid: $uuid) {
    ...PartnerConnection
  }
}
    ${PartnerConnectionFragmentDoc}`;
export const usePartnerConnectGetConnectionQuery = <
      TData = PartnerConnectGetConnectionQuery,
      TError = Error
    >(
      variables: PartnerConnectGetConnectionQueryVariables, 
      options?: UseQueryOptions<PartnerConnectGetConnectionQuery, TError, TData>
    ) => 
    useQuery<PartnerConnectGetConnectionQuery, TError, TData>(
      ['PartnerConnectGetConnection', variables],
      fetcher<PartnerConnectGetConnectionQuery, PartnerConnectGetConnectionQueryVariables>(PartnerConnectGetConnectionDocument, variables),
      options
    );
usePartnerConnectGetConnectionQuery.document = PartnerConnectGetConnectionDocument;

usePartnerConnectGetConnectionQuery.getKey = (variables: PartnerConnectGetConnectionQueryVariables) => ['PartnerConnectGetConnection', variables];

usePartnerConnectGetConnectionQuery.fetcher = (variables: PartnerConnectGetConnectionQueryVariables) => fetcher<PartnerConnectGetConnectionQuery, PartnerConnectGetConnectionQueryVariables>(PartnerConnectGetConnectionDocument, variables);
export const PartnerConnectGetInformationDocument = `
    query PartnerConnectGetInformation($uuid: String!) {
  partnerConnectGetInformation(uuid: $uuid) {
    type
    partnerName
    partnerLogo
    resources
  }
}
    `;
export const usePartnerConnectGetInformationQuery = <
      TData = PartnerConnectGetInformationQuery,
      TError = Error
    >(
      variables: PartnerConnectGetInformationQueryVariables, 
      options?: UseQueryOptions<PartnerConnectGetInformationQuery, TError, TData>
    ) => 
    useQuery<PartnerConnectGetInformationQuery, TError, TData>(
      ['PartnerConnectGetInformation', variables],
      fetcher<PartnerConnectGetInformationQuery, PartnerConnectGetInformationQueryVariables>(PartnerConnectGetInformationDocument, variables),
      options
    );
usePartnerConnectGetInformationQuery.document = PartnerConnectGetInformationDocument;

usePartnerConnectGetInformationQuery.getKey = (variables: PartnerConnectGetInformationQueryVariables) => ['PartnerConnectGetInformation', variables];

usePartnerConnectGetInformationQuery.fetcher = (variables: PartnerConnectGetInformationQueryVariables) => fetcher<PartnerConnectGetInformationQuery, PartnerConnectGetInformationQueryVariables>(PartnerConnectGetInformationDocument, variables);
export const PartnerConnectListAvailableWorkspacesDocument = `
    query PartnerConnectListAvailableWorkspaces($uuid: String!) {
  partnerConnectListAvailableWorkspaces(uuid: $uuid) {
    id
    slug
    name
  }
}
    `;
export const usePartnerConnectListAvailableWorkspacesQuery = <
      TData = PartnerConnectListAvailableWorkspacesQuery,
      TError = Error
    >(
      variables: PartnerConnectListAvailableWorkspacesQueryVariables, 
      options?: UseQueryOptions<PartnerConnectListAvailableWorkspacesQuery, TError, TData>
    ) => 
    useQuery<PartnerConnectListAvailableWorkspacesQuery, TError, TData>(
      ['PartnerConnectListAvailableWorkspaces', variables],
      fetcher<PartnerConnectListAvailableWorkspacesQuery, PartnerConnectListAvailableWorkspacesQueryVariables>(PartnerConnectListAvailableWorkspacesDocument, variables),
      options
    );
usePartnerConnectListAvailableWorkspacesQuery.document = PartnerConnectListAvailableWorkspacesDocument;

usePartnerConnectListAvailableWorkspacesQuery.getKey = (variables: PartnerConnectListAvailableWorkspacesQueryVariables) => ['PartnerConnectListAvailableWorkspaces', variables];

usePartnerConnectListAvailableWorkspacesQuery.fetcher = (variables: PartnerConnectListAvailableWorkspacesQueryVariables) => fetcher<PartnerConnectListAvailableWorkspacesQuery, PartnerConnectListAvailableWorkspacesQueryVariables>(PartnerConnectListAvailableWorkspacesDocument, variables);
export const PartnerConnectLinkWorkspaceDocument = `
    mutation PartnerConnectLinkWorkspace($uuid: String!, $workspaceId: Int!) {
  partnerConnectLinkWorkspace(uuid: $uuid, workspaceId: $workspaceId)
}
    `;
export const usePartnerConnectLinkWorkspaceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<PartnerConnectLinkWorkspaceMutation, TError, PartnerConnectLinkWorkspaceMutationVariables, TContext>) => 
    useMutation<PartnerConnectLinkWorkspaceMutation, TError, PartnerConnectLinkWorkspaceMutationVariables, TContext>(
      (variables?: PartnerConnectLinkWorkspaceMutationVariables) => fetcher<PartnerConnectLinkWorkspaceMutation, PartnerConnectLinkWorkspaceMutationVariables>(PartnerConnectLinkWorkspaceDocument, variables)(),
      options
    );
export const PartnerConnectLinkNewWorkspaceDocument = `
    mutation PartnerConnectLinkNewWorkspace($uuid: String!, $slug: String!, $name: String!) {
  partnerConnectLinkNewWorkspace(uuid: $uuid, slug: $slug, name: $name)
}
    `;
export const usePartnerConnectLinkNewWorkspaceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<PartnerConnectLinkNewWorkspaceMutation, TError, PartnerConnectLinkNewWorkspaceMutationVariables, TContext>) => 
    useMutation<PartnerConnectLinkNewWorkspaceMutation, TError, PartnerConnectLinkNewWorkspaceMutationVariables, TContext>(
      (variables?: PartnerConnectLinkNewWorkspaceMutationVariables) => fetcher<PartnerConnectLinkNewWorkspaceMutation, PartnerConnectLinkNewWorkspaceMutationVariables>(PartnerConnectLinkNewWorkspaceDocument, variables)(),
      options
    );
export const PermissionsDocument = `
    query Permissions($filters: [String!]) {
  getCurrentPermissions(filters: $filters) {
    resource
    grants
    resource_id
  }
}
    `;
export const usePermissionsQuery = <
      TData = PermissionsQuery,
      TError = Error
    >(
      variables?: PermissionsQueryVariables, 
      options?: UseQueryOptions<PermissionsQuery, TError, TData>
    ) => 
    useQuery<PermissionsQuery, TError, TData>(
      variables === undefined ? ['Permissions'] : ['Permissions', variables],
      fetcher<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, variables),
      options
    );
usePermissionsQuery.document = PermissionsDocument;

usePermissionsQuery.getKey = (variables?: PermissionsQueryVariables) => variables === undefined ? ['Permissions'] : ['Permissions', variables];

usePermissionsQuery.fetcher = (variables?: PermissionsQueryVariables) => fetcher<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, variables);
export const RunSqlDocument = `
    query RunSQL($sourceId: String!, $sql: String!, $limit: Int, $disableRowCounter: Boolean, $modelId: Int) {
  rawSqlQuery(
    connectionId: $sourceId
    sql: $sql
    limit: $limit
    disableRowCounter: $disableRowCounter
    modelId: $modelId
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunSqlQuery = <
      TData = RunSqlQuery,
      TError = Error
    >(
      variables: RunSqlQueryVariables, 
      options?: UseQueryOptions<RunSqlQuery, TError, TData>
    ) => 
    useQuery<RunSqlQuery, TError, TData>(
      ['RunSQL', variables],
      fetcher<RunSqlQuery, RunSqlQueryVariables>(RunSqlDocument, variables),
      options
    );
useRunSqlQuery.document = RunSqlDocument;

useRunSqlQuery.getKey = (variables: RunSqlQueryVariables) => ['RunSQL', variables];

useRunSqlQuery.fetcher = (variables: RunSqlQueryVariables) => fetcher<RunSqlQuery, RunSqlQueryVariables>(RunSqlDocument, variables);
export const RunDbtDocument = `
    query RunDBT($sourceId: String!, $dbtModelId: Int!, $limit: Int, $disableRowCounter: Boolean, $modelId: Int) {
  dbtQuery(
    connectionId: $sourceId
    dbtModelId: $dbtModelId
    limit: $limit
    disableRowCounter: $disableRowCounter
    modelId: $modelId
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunDbtQuery = <
      TData = RunDbtQuery,
      TError = Error
    >(
      variables: RunDbtQueryVariables, 
      options?: UseQueryOptions<RunDbtQuery, TError, TData>
    ) => 
    useQuery<RunDbtQuery, TError, TData>(
      ['RunDBT', variables],
      fetcher<RunDbtQuery, RunDbtQueryVariables>(RunDbtDocument, variables),
      options
    );
useRunDbtQuery.document = RunDbtDocument;

useRunDbtQuery.getKey = (variables: RunDbtQueryVariables) => ['RunDBT', variables];

useRunDbtQuery.fetcher = (variables: RunDbtQueryVariables) => fetcher<RunDbtQuery, RunDbtQueryVariables>(RunDbtDocument, variables);
export const RunDbtModelDocument = `
    query RunDBTModel($sourceId: String!, $dbtModelId: Int!, $limit: Int, $disableRowCounter: Boolean, $modelId: Int) {
  dbtModelQuery(
    connectionId: $sourceId
    dbtModelId: $dbtModelId
    limit: $limit
    disableRowCounter: $disableRowCounter
    modelId: $modelId
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunDbtModelQuery = <
      TData = RunDbtModelQuery,
      TError = Error
    >(
      variables: RunDbtModelQueryVariables, 
      options?: UseQueryOptions<RunDbtModelQuery, TError, TData>
    ) => 
    useQuery<RunDbtModelQuery, TError, TData>(
      ['RunDBTModel', variables],
      fetcher<RunDbtModelQuery, RunDbtModelQueryVariables>(RunDbtModelDocument, variables),
      options
    );
useRunDbtModelQuery.document = RunDbtModelDocument;

useRunDbtModelQuery.getKey = (variables: RunDbtModelQueryVariables) => ['RunDBTModel', variables];

useRunDbtModelQuery.fetcher = (variables: RunDbtModelQueryVariables) => fetcher<RunDbtModelQuery, RunDbtModelQueryVariables>(RunDbtModelDocument, variables);
export const RunLookerLookDocument = `
    query RunLookerLook($sourceId: String!, $lookId: String!, $limit: Int, $disableRowCounter: Boolean, $modelId: Int) {
  lookerLookQuery(
    connectionId: $sourceId
    lookId: $lookId
    limit: $limit
    disableRowCounter: $disableRowCounter
    modelId: $modelId
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunLookerLookQuery = <
      TData = RunLookerLookQuery,
      TError = Error
    >(
      variables: RunLookerLookQueryVariables, 
      options?: UseQueryOptions<RunLookerLookQuery, TError, TData>
    ) => 
    useQuery<RunLookerLookQuery, TError, TData>(
      ['RunLookerLook', variables],
      fetcher<RunLookerLookQuery, RunLookerLookQueryVariables>(RunLookerLookDocument, variables),
      options
    );
useRunLookerLookQuery.document = RunLookerLookDocument;

useRunLookerLookQuery.getKey = (variables: RunLookerLookQueryVariables) => ['RunLookerLook', variables];

useRunLookerLookQuery.fetcher = (variables: RunLookerLookQueryVariables) => fetcher<RunLookerLookQuery, RunLookerLookQueryVariables>(RunLookerLookDocument, variables);
export const RunTableDocument = `
    query RunTable($sourceId: String!, $table: String!, $limit: Int, $disableRowCounter: Boolean, $modelId: Int) {
  tableQuery(
    connectionId: $sourceId
    table: $table
    limit: $limit
    disableRowCounter: $disableRowCounter
    modelId: $modelId
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunTableQuery = <
      TData = RunTableQuery,
      TError = Error
    >(
      variables: RunTableQueryVariables, 
      options?: UseQueryOptions<RunTableQuery, TError, TData>
    ) => 
    useQuery<RunTableQuery, TError, TData>(
      ['RunTable', variables],
      fetcher<RunTableQuery, RunTableQueryVariables>(RunTableDocument, variables),
      options
    );
useRunTableQuery.document = RunTableDocument;

useRunTableQuery.getKey = (variables: RunTableQueryVariables) => ['RunTable', variables];

useRunTableQuery.fetcher = (variables: RunTableQueryVariables) => fetcher<RunTableQuery, RunTableQueryVariables>(RunTableDocument, variables);
export const RunVisualDocument = `
    query RunVisual($sourceId: String!, $parentModelId: String!, $filter: JSONObject!, $limit: Int, $disableRowCounter: Boolean) {
  visualQuery(
    connectionId: $sourceId
    parentModelId: $parentModelId
    filter: $filter
    limit: $limit
    disableRowCounter: $disableRowCounter
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunVisualQuery = <
      TData = RunVisualQuery,
      TError = Error
    >(
      variables: RunVisualQueryVariables, 
      options?: UseQueryOptions<RunVisualQuery, TError, TData>
    ) => 
    useQuery<RunVisualQuery, TError, TData>(
      ['RunVisual', variables],
      fetcher<RunVisualQuery, RunVisualQueryVariables>(RunVisualDocument, variables),
      options
    );
useRunVisualQuery.document = RunVisualDocument;

useRunVisualQuery.getKey = (variables: RunVisualQueryVariables) => ['RunVisual', variables];

useRunVisualQuery.fetcher = (variables: RunVisualQueryVariables) => fetcher<RunVisualQuery, RunVisualQueryVariables>(RunVisualDocument, variables);
export const RunCustomDocument = `
    query RunCustom($sourceId: String!, $customQuery: JSONObject!, $limit: Int, $disableRowCounter: Boolean) {
  customQuery(
    connectionId: $sourceId
    query: $customQuery
    limit: $limit
    disableRowCounter: $disableRowCounter
  ) {
    ...QueryResponseFields
    ... on SuccessfulQueryResponse {
      ...SuccessfulQueryResponseFields
    }
    ... on FailedQueryResponse {
      ...FailedQueryResponseFields
    }
  }
}
    ${QueryResponseFieldsFragmentDoc}
${FailedQueryResponseFieldsFragmentDoc}
${SuccessfulQueryResponseFieldsFragmentDoc}`;
export const useRunCustomQuery = <
      TData = RunCustomQuery,
      TError = Error
    >(
      variables: RunCustomQueryVariables, 
      options?: UseQueryOptions<RunCustomQuery, TError, TData>
    ) => 
    useQuery<RunCustomQuery, TError, TData>(
      ['RunCustom', variables],
      fetcher<RunCustomQuery, RunCustomQueryVariables>(RunCustomDocument, variables),
      options
    );
useRunCustomQuery.document = RunCustomDocument;

useRunCustomQuery.getKey = (variables: RunCustomQueryVariables) => ['RunCustom', variables];

useRunCustomQuery.fetcher = (variables: RunCustomQueryVariables) => fetcher<RunCustomQuery, RunCustomQueryVariables>(RunCustomDocument, variables);
export const PreviewQuerySchemaDocument = `
    query PreviewQuerySchema($sourceId: String!, $queryType: String!, $query: JSONObject!) {
  previewQuerySchema(
    connectionId: $sourceId
    queryType: $queryType
    query: $query
  ) {
    columns {
      name
      type
    }
  }
}
    `;
export const usePreviewQuerySchemaQuery = <
      TData = PreviewQuerySchemaQuery,
      TError = Error
    >(
      variables: PreviewQuerySchemaQueryVariables, 
      options?: UseQueryOptions<PreviewQuerySchemaQuery, TError, TData>
    ) => 
    useQuery<PreviewQuerySchemaQuery, TError, TData>(
      ['PreviewQuerySchema', variables],
      fetcher<PreviewQuerySchemaQuery, PreviewQuerySchemaQueryVariables>(PreviewQuerySchemaDocument, variables),
      options
    );
usePreviewQuerySchemaQuery.document = PreviewQuerySchemaDocument;

usePreviewQuerySchemaQuery.getKey = (variables: PreviewQuerySchemaQueryVariables) => ['PreviewQuerySchema', variables];

usePreviewQuerySchemaQuery.fetcher = (variables: PreviewQuerySchemaQueryVariables) => fetcher<PreviewQuerySchemaQuery, PreviewQuerySchemaQueryVariables>(PreviewQuerySchemaDocument, variables);
export const UpdateQueryDocument = `
    mutation UpdateQuery($id: bigint!, $model: segments_set_input!, $columns: [model_columns_insert_input!]!) {
  update_segments_by_pk(pk_columns: {id: $id}, _set: $model) {
    id
  }
  insert_model_columns(
    objects: $columns
    on_conflict: {constraint: model_columns_pkey, update_columns: [name, type]}
  ) {
    affected_rows
  }
}
    `;
export const useUpdateQueryMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateQueryMutation, TError, UpdateQueryMutationVariables, TContext>) => 
    useMutation<UpdateQueryMutation, TError, UpdateQueryMutationVariables, TContext>(
      (variables?: UpdateQueryMutationVariables) => fetcher<UpdateQueryMutation, UpdateQueryMutationVariables>(UpdateQueryDocument, variables)(),
      options
    );
export const RelationshipsDocument = `
    query Relationships($modelId: bigint!) {
  segments_by_pk(id: $modelId) {
    relationships {
      id
      name
      merge_columns
      to_model {
        id
        name
      }
    }
  }
}
    `;
export const useRelationshipsQuery = <
      TData = RelationshipsQuery,
      TError = Error
    >(
      variables: RelationshipsQueryVariables, 
      options?: UseQueryOptions<RelationshipsQuery, TError, TData>
    ) => 
    useQuery<RelationshipsQuery, TError, TData>(
      ['Relationships', variables],
      fetcher<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, variables),
      options
    );
useRelationshipsQuery.document = RelationshipsDocument;

useRelationshipsQuery.getKey = (variables: RelationshipsQueryVariables) => ['Relationships', variables];

useRelationshipsQuery.fetcher = (variables: RelationshipsQueryVariables) => fetcher<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, variables);
export const AddRelationshipDocument = `
    mutation AddRelationship($object: model_relationships_insert_input!) {
  insert_model_relationships_one(object: $object) {
    id
  }
}
    `;
export const useAddRelationshipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<AddRelationshipMutation, TError, AddRelationshipMutationVariables, TContext>) => 
    useMutation<AddRelationshipMutation, TError, AddRelationshipMutationVariables, TContext>(
      (variables?: AddRelationshipMutationVariables) => fetcher<AddRelationshipMutation, AddRelationshipMutationVariables>(AddRelationshipDocument, variables)(),
      options
    );
export const UpdateDirectRelationshipDocument = `
    mutation UpdateDirectRelationship($id: bigint!, $object: model_relationships_set_input!, $directRelationships: [direct_model_relationships_insert_input!]!) {
  delete_direct_model_relationships(where: {relationship_id: {_eq: $id}}) {
    affected_rows
  }
  update_model_relationships_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
  insert_direct_model_relationships(objects: $directRelationships) {
    affected_rows
  }
}
    `;
export const useUpdateDirectRelationshipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDirectRelationshipMutation, TError, UpdateDirectRelationshipMutationVariables, TContext>) => 
    useMutation<UpdateDirectRelationshipMutation, TError, UpdateDirectRelationshipMutationVariables, TContext>(
      (variables?: UpdateDirectRelationshipMutationVariables) => fetcher<UpdateDirectRelationshipMutation, UpdateDirectRelationshipMutationVariables>(UpdateDirectRelationshipDocument, variables)(),
      options
    );
export const UpdateThroughRelationshipDocument = `
    mutation UpdateThroughRelationship($id: bigint!, $object: model_relationships_set_input!, $throughRelationships: [through_model_relationships_insert_input!]!) {
  delete_through_model_relationships(where: {relationship_id: {_eq: $id}}) {
    affected_rows
  }
  update_model_relationships_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
  insert_through_model_relationships(objects: $throughRelationships) {
    affected_rows
  }
}
    `;
export const useUpdateThroughRelationshipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateThroughRelationshipMutation, TError, UpdateThroughRelationshipMutationVariables, TContext>) => 
    useMutation<UpdateThroughRelationshipMutation, TError, UpdateThroughRelationshipMutationVariables, TContext>(
      (variables?: UpdateThroughRelationshipMutationVariables) => fetcher<UpdateThroughRelationshipMutation, UpdateThroughRelationshipMutationVariables>(UpdateThroughRelationshipDocument, variables)(),
      options
    );
export const RelationshipDependenciesDocument = `
    query RelationshipDependencies($id: String!) {
  listRelationshipDependencies(id: $id)
}
    `;
export const useRelationshipDependenciesQuery = <
      TData = RelationshipDependenciesQuery,
      TError = Error
    >(
      variables: RelationshipDependenciesQueryVariables, 
      options?: UseQueryOptions<RelationshipDependenciesQuery, TError, TData>
    ) => 
    useQuery<RelationshipDependenciesQuery, TError, TData>(
      ['RelationshipDependencies', variables],
      fetcher<RelationshipDependenciesQuery, RelationshipDependenciesQueryVariables>(RelationshipDependenciesDocument, variables),
      options
    );
useRelationshipDependenciesQuery.document = RelationshipDependenciesDocument;

useRelationshipDependenciesQuery.getKey = (variables: RelationshipDependenciesQueryVariables) => ['RelationshipDependencies', variables];

useRelationshipDependenciesQuery.fetcher = (variables: RelationshipDependenciesQueryVariables) => fetcher<RelationshipDependenciesQuery, RelationshipDependenciesQueryVariables>(RelationshipDependenciesDocument, variables);
export const DeleteRelationshipDocument = `
    mutation DeleteRelationship($id: bigint!) {
  delete_model_relationships_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteRelationshipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRelationshipMutation, TError, DeleteRelationshipMutationVariables, TContext>) => 
    useMutation<DeleteRelationshipMutation, TError, DeleteRelationshipMutationVariables, TContext>(
      (variables?: DeleteRelationshipMutationVariables) => fetcher<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>(DeleteRelationshipDocument, variables)(),
      options
    );
export const IsResourceSlugAvailableDocument = `
    query IsResourceSlugAvailable($slug: String!, $resourceType: String!) {
  isResourceSlugAvailable(resourceType: $resourceType, slug: $slug)
}
    `;
export const useIsResourceSlugAvailableQuery = <
      TData = IsResourceSlugAvailableQuery,
      TError = Error
    >(
      variables: IsResourceSlugAvailableQueryVariables, 
      options?: UseQueryOptions<IsResourceSlugAvailableQuery, TError, TData>
    ) => 
    useQuery<IsResourceSlugAvailableQuery, TError, TData>(
      ['IsResourceSlugAvailable', variables],
      fetcher<IsResourceSlugAvailableQuery, IsResourceSlugAvailableQueryVariables>(IsResourceSlugAvailableDocument, variables),
      options
    );
useIsResourceSlugAvailableQuery.document = IsResourceSlugAvailableDocument;

useIsResourceSlugAvailableQuery.getKey = (variables: IsResourceSlugAvailableQueryVariables) => ['IsResourceSlugAvailable', variables];

useIsResourceSlugAvailableQuery.fetcher = (variables: IsResourceSlugAvailableQueryVariables) => fetcher<IsResourceSlugAvailableQuery, IsResourceSlugAvailableQueryVariables>(IsResourceSlugAvailableDocument, variables);
export const SourcesDocument = `
    query Sources($filters: connections_bool_exp = {}, $limit: Int, $orderBy: connections_order_by! = {created_at: desc}) {
  connections(
    where: {_and: [{setup_complete: {_eq: true}}, $filters]}
    limit: $limit
    order_by: [$orderBy]
  ) {
    ...Source
    setup_complete
    ...SourceHistory
    tags
    tunnel {
      id: tunnel_id
      name
    }
    default_workspaces {
      id
    }
    credential_id
    sample_data_source_id
  }
}
    ${SourceFragmentDoc}
${SourceHistoryFragmentDoc}`;
export const useSourcesQuery = <
      TData = SourcesQuery,
      TError = Error
    >(
      variables?: SourcesQueryVariables, 
      options?: UseQueryOptions<SourcesQuery, TError, TData>
    ) => 
    useQuery<SourcesQuery, TError, TData>(
      variables === undefined ? ['Sources'] : ['Sources', variables],
      fetcher<SourcesQuery, SourcesQueryVariables>(SourcesDocument, variables),
      options
    );
useSourcesQuery.document = SourcesDocument;

useSourcesQuery.getKey = (variables?: SourcesQueryVariables) => variables === undefined ? ['Sources'] : ['Sources', variables];

useSourcesQuery.fetcher = (variables?: SourcesQueryVariables) => fetcher<SourcesQuery, SourcesQueryVariables>(SourcesDocument, variables);
export const SourceDocument = `
    query Source($id: bigint!) {
  connections_by_pk(id: $id) {
    ...Source
    slug
    setup_complete
    plan_in_warehouse
    plan_in_warehouse_config
    autorun
    ...SourceHistory
    tunnel {
      id: tunnel_id
      name
    }
    default_workspaces {
      id
    }
    credential_id
    sample_data_source_id
    tags
  }
}
    ${SourceFragmentDoc}
${SourceHistoryFragmentDoc}`;
export const useSourceQuery = <
      TData = SourceQuery,
      TError = Error
    >(
      variables: SourceQueryVariables, 
      options?: UseQueryOptions<SourceQuery, TError, TData>
    ) => 
    useQuery<SourceQuery, TError, TData>(
      ['Source', variables],
      fetcher<SourceQuery, SourceQueryVariables>(SourceDocument, variables),
      options
    );
useSourceQuery.document = SourceDocument;

useSourceQuery.getKey = (variables: SourceQueryVariables) => ['Source', variables];

useSourceQuery.fetcher = (variables: SourceQueryVariables) => fetcher<SourceQuery, SourceQueryVariables>(SourceDocument, variables);
export const SourceObjectDefinitionsDocument = `
    query SourceObjectDefinitions($sourceId: bigint!) {
  object_definitions(where: {connection_id: {_eq: $sourceId}}) {
    name
    object_definition_group {
      name
    }
    object_schemas {
      key
      type
    }
  }
}
    `;
export const useSourceObjectDefinitionsQuery = <
      TData = SourceObjectDefinitionsQuery,
      TError = Error
    >(
      variables: SourceObjectDefinitionsQueryVariables, 
      options?: UseQueryOptions<SourceObjectDefinitionsQuery, TError, TData>
    ) => 
    useQuery<SourceObjectDefinitionsQuery, TError, TData>(
      ['SourceObjectDefinitions', variables],
      fetcher<SourceObjectDefinitionsQuery, SourceObjectDefinitionsQueryVariables>(SourceObjectDefinitionsDocument, variables),
      options
    );
useSourceObjectDefinitionsQuery.document = SourceObjectDefinitionsDocument;

useSourceObjectDefinitionsQuery.getKey = (variables: SourceObjectDefinitionsQueryVariables) => ['SourceObjectDefinitions', variables];

useSourceObjectDefinitionsQuery.fetcher = (variables: SourceObjectDefinitionsQueryVariables) => fetcher<SourceObjectDefinitionsQuery, SourceObjectDefinitionsQueryVariables>(SourceObjectDefinitionsDocument, variables);
export const SourceDefinitionsDocument = `
    query SourceDefinitions {
  getSourceDefinitions {
    ...SourceDefinition
  }
}
    ${SourceDefinitionFragmentDoc}`;
export const useSourceDefinitionsQuery = <
      TData = SourceDefinitionsQuery,
      TError = Error
    >(
      variables?: SourceDefinitionsQueryVariables, 
      options?: UseQueryOptions<SourceDefinitionsQuery, TError, TData>
    ) => 
    useQuery<SourceDefinitionsQuery, TError, TData>(
      variables === undefined ? ['SourceDefinitions'] : ['SourceDefinitions', variables],
      fetcher<SourceDefinitionsQuery, SourceDefinitionsQueryVariables>(SourceDefinitionsDocument, variables),
      options
    );
useSourceDefinitionsQuery.document = SourceDefinitionsDocument;

useSourceDefinitionsQuery.getKey = (variables?: SourceDefinitionsQueryVariables) => variables === undefined ? ['SourceDefinitions'] : ['SourceDefinitions', variables];

useSourceDefinitionsQuery.fetcher = (variables?: SourceDefinitionsQueryVariables) => fetcher<SourceDefinitionsQuery, SourceDefinitionsQueryVariables>(SourceDefinitionsDocument, variables);
export const SampleDataSourceDefinitionsDocument = `
    query SampleDataSourceDefinitions {
  getSampleDataSourceDefinitions {
    ...SourceDefinition
  }
}
    ${SourceDefinitionFragmentDoc}`;
export const useSampleDataSourceDefinitionsQuery = <
      TData = SampleDataSourceDefinitionsQuery,
      TError = Error
    >(
      variables?: SampleDataSourceDefinitionsQueryVariables, 
      options?: UseQueryOptions<SampleDataSourceDefinitionsQuery, TError, TData>
    ) => 
    useQuery<SampleDataSourceDefinitionsQuery, TError, TData>(
      variables === undefined ? ['SampleDataSourceDefinitions'] : ['SampleDataSourceDefinitions', variables],
      fetcher<SampleDataSourceDefinitionsQuery, SampleDataSourceDefinitionsQueryVariables>(SampleDataSourceDefinitionsDocument, variables),
      options
    );
useSampleDataSourceDefinitionsQuery.document = SampleDataSourceDefinitionsDocument;

useSampleDataSourceDefinitionsQuery.getKey = (variables?: SampleDataSourceDefinitionsQueryVariables) => variables === undefined ? ['SampleDataSourceDefinitions'] : ['SampleDataSourceDefinitions', variables];

useSampleDataSourceDefinitionsQuery.fetcher = (variables?: SampleDataSourceDefinitionsQueryVariables) => fetcher<SampleDataSourceDefinitionsQuery, SampleDataSourceDefinitionsQueryVariables>(SampleDataSourceDefinitionsDocument, variables);
export const SourceDefinitionDocument = `
    query SourceDefinition($type: String!) {
  getSourceDefinition(input: {type: $type}) {
    ...SourceDefinition
  }
}
    ${SourceDefinitionFragmentDoc}`;
export const useSourceDefinitionQuery = <
      TData = SourceDefinitionQuery,
      TError = Error
    >(
      variables: SourceDefinitionQueryVariables, 
      options?: UseQueryOptions<SourceDefinitionQuery, TError, TData>
    ) => 
    useQuery<SourceDefinitionQuery, TError, TData>(
      ['SourceDefinition', variables],
      fetcher<SourceDefinitionQuery, SourceDefinitionQueryVariables>(SourceDefinitionDocument, variables),
      options
    );
useSourceDefinitionQuery.document = SourceDefinitionDocument;

useSourceDefinitionQuery.getKey = (variables: SourceDefinitionQueryVariables) => ['SourceDefinition', variables];

useSourceDefinitionQuery.fetcher = (variables: SourceDefinitionQueryVariables) => fetcher<SourceDefinitionQuery, SourceDefinitionQueryVariables>(SourceDefinitionDocument, variables);
export const SampleDataSourceDefinitionDocument = `
    query SampleDataSourceDefinition($sampleDataSourceId: String!) {
  getSampleDataSourceDefinition(sampleDataSourceId: $sampleDataSourceId) {
    ...SourceDefinition
  }
}
    ${SourceDefinitionFragmentDoc}`;
export const useSampleDataSourceDefinitionQuery = <
      TData = SampleDataSourceDefinitionQuery,
      TError = Error
    >(
      variables: SampleDataSourceDefinitionQueryVariables, 
      options?: UseQueryOptions<SampleDataSourceDefinitionQuery, TError, TData>
    ) => 
    useQuery<SampleDataSourceDefinitionQuery, TError, TData>(
      ['SampleDataSourceDefinition', variables],
      fetcher<SampleDataSourceDefinitionQuery, SampleDataSourceDefinitionQueryVariables>(SampleDataSourceDefinitionDocument, variables),
      options
    );
useSampleDataSourceDefinitionQuery.document = SampleDataSourceDefinitionDocument;

useSampleDataSourceDefinitionQuery.getKey = (variables: SampleDataSourceDefinitionQueryVariables) => ['SampleDataSourceDefinition', variables];

useSampleDataSourceDefinitionQuery.fetcher = (variables: SampleDataSourceDefinitionQueryVariables) => fetcher<SampleDataSourceDefinitionQuery, SampleDataSourceDefinitionQueryVariables>(SampleDataSourceDefinitionDocument, variables);
export const SourceStrippedConfigurationDocument = `
    query SourceStrippedConfiguration($connectionId: bigint!) {
  getSourceStrippedConfiguration(connectionId: $connectionId)
}
    `;
export const useSourceStrippedConfigurationQuery = <
      TData = SourceStrippedConfigurationQuery,
      TError = Error
    >(
      variables: SourceStrippedConfigurationQueryVariables, 
      options?: UseQueryOptions<SourceStrippedConfigurationQuery, TError, TData>
    ) => 
    useQuery<SourceStrippedConfigurationQuery, TError, TData>(
      ['SourceStrippedConfiguration', variables],
      fetcher<SourceStrippedConfigurationQuery, SourceStrippedConfigurationQueryVariables>(SourceStrippedConfigurationDocument, variables),
      options
    );
useSourceStrippedConfigurationQuery.document = SourceStrippedConfigurationDocument;

useSourceStrippedConfigurationQuery.getKey = (variables: SourceStrippedConfigurationQueryVariables) => ['SourceStrippedConfiguration', variables];

useSourceStrippedConfigurationQuery.fetcher = (variables: SourceStrippedConfigurationQueryVariables) => fetcher<SourceStrippedConfigurationQuery, SourceStrippedConfigurationQueryVariables>(SourceStrippedConfigurationDocument, variables);
export const UpdateSourceDocument = `
    mutation UpdateSource($id: bigint!, $set: connections_set_input!, $append: connections_append_input!) {
  update_connections_by_pk(pk_columns: {id: $id}, _set: $set, _append: $append) {
    id
  }
}
    `;
export const useUpdateSourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSourceMutation, TError, UpdateSourceMutationVariables, TContext>) => 
    useMutation<UpdateSourceMutation, TError, UpdateSourceMutationVariables, TContext>(
      (variables?: UpdateSourceMutationVariables) => fetcher<UpdateSourceMutation, UpdateSourceMutationVariables>(UpdateSourceDocument, variables)(),
      options
    );
export const CreateSourceDocument = `
    mutation CreateSource($object: connections_insert_input!) {
  insert_connections_one(object: $object) {
    id
  }
}
    `;
export const useCreateSourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSourceMutation, TError, CreateSourceMutationVariables, TContext>) => 
    useMutation<CreateSourceMutation, TError, CreateSourceMutationVariables, TContext>(
      (variables?: CreateSourceMutationVariables) => fetcher<CreateSourceMutation, CreateSourceMutationVariables>(CreateSourceDocument, variables)(),
      options
    );
export const DiscoverSourceDocument = `
    mutation DiscoverSource($sourceId: String!) {
  discover(connectionId: $sourceId)
}
    `;
export const useDiscoverSourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DiscoverSourceMutation, TError, DiscoverSourceMutationVariables, TContext>) => 
    useMutation<DiscoverSourceMutation, TError, DiscoverSourceMutationVariables, TContext>(
      (variables?: DiscoverSourceMutationVariables) => fetcher<DiscoverSourceMutation, DiscoverSourceMutationVariables>(DiscoverSourceDocument, variables)(),
      options
    );
export const SetupWarehousePlanningDocument = `
    mutation SetupWarehousePlanning($id: String!, $plannerDatabase: String) {
  setupInWarehouseDiffingForSource(
    sourceId: $id
    plannerDatabase: $plannerDatabase
  ) {
    ignored
  }
}
    `;
export const useSetupWarehousePlanningMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<SetupWarehousePlanningMutation, TError, SetupWarehousePlanningMutationVariables, TContext>) => 
    useMutation<SetupWarehousePlanningMutation, TError, SetupWarehousePlanningMutationVariables, TContext>(
      (variables?: SetupWarehousePlanningMutationVariables) => fetcher<SetupWarehousePlanningMutation, SetupWarehousePlanningMutationVariables>(SetupWarehousePlanningDocument, variables)(),
      options
    );
export const SetupWarehousePlanningWithCredentialsDocument = `
    mutation SetupWarehousePlanningWithCredentials($type: String!, $tunnelId: String, $credentialId: Int, $config: String!, $plannerDatabase: String) {
  setupInWarehouseDiffingWithCredentials(
    type: $type
    tunnelId: $tunnelId
    credentialId: $credentialId
    configurationJson: $config
    plannerDatabase: $plannerDatabase
  ) {
    ignored
  }
}
    `;
export const useSetupWarehousePlanningWithCredentialsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<SetupWarehousePlanningWithCredentialsMutation, TError, SetupWarehousePlanningWithCredentialsMutationVariables, TContext>) => 
    useMutation<SetupWarehousePlanningWithCredentialsMutation, TError, SetupWarehousePlanningWithCredentialsMutationVariables, TContext>(
      (variables?: SetupWarehousePlanningWithCredentialsMutationVariables) => fetcher<SetupWarehousePlanningWithCredentialsMutation, SetupWarehousePlanningWithCredentialsMutationVariables>(SetupWarehousePlanningWithCredentialsDocument, variables)(),
      options
    );
export const ListAllSourceDependenciesDocument = `
    query ListAllSourceDependencies($ids: [bigint!]!) {
  listAllSourceDependencies(ids: $ids) {
    sources {
      id
      dependencies {
        audiences {
          id
          name
        }
        models {
          id
          name
          modelType
          modelSourceType
        }
        syncs {
          id
          slug
          modelName
          modelType
          destinationName
          destinationType
        }
      }
    }
  }
}
    `;
export const useListAllSourceDependenciesQuery = <
      TData = ListAllSourceDependenciesQuery,
      TError = Error
    >(
      variables: ListAllSourceDependenciesQueryVariables, 
      options?: UseQueryOptions<ListAllSourceDependenciesQuery, TError, TData>
    ) => 
    useQuery<ListAllSourceDependenciesQuery, TError, TData>(
      ['ListAllSourceDependencies', variables],
      fetcher<ListAllSourceDependenciesQuery, ListAllSourceDependenciesQueryVariables>(ListAllSourceDependenciesDocument, variables),
      options
    );
useListAllSourceDependenciesQuery.document = ListAllSourceDependenciesDocument;

useListAllSourceDependenciesQuery.getKey = (variables: ListAllSourceDependenciesQueryVariables) => ['ListAllSourceDependencies', variables];

useListAllSourceDependenciesQuery.fetcher = (variables: ListAllSourceDependenciesQueryVariables) => fetcher<ListAllSourceDependenciesQuery, ListAllSourceDependenciesQueryVariables>(ListAllSourceDependenciesDocument, variables);
export const DeleteSourceDocument = `
    mutation DeleteSource($id: bigint!) {
  delete_connections_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteSourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSourceMutation, TError, DeleteSourceMutationVariables, TContext>) => 
    useMutation<DeleteSourceMutation, TError, DeleteSourceMutationVariables, TContext>(
      (variables?: DeleteSourceMutationVariables) => fetcher<DeleteSourceMutation, DeleteSourceMutationVariables>(DeleteSourceDocument, variables)(),
      options
    );
export const DeleteSourcesDocument = `
    mutation DeleteSources($ids: [bigint!]!) {
  delete_connections(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteSourcesMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSourcesMutation, TError, DeleteSourcesMutationVariables, TContext>) => 
    useMutation<DeleteSourcesMutation, TError, DeleteSourcesMutationVariables, TContext>(
      (variables?: DeleteSourcesMutationVariables) => fetcher<DeleteSourcesMutation, DeleteSourcesMutationVariables>(DeleteSourcesDocument, variables)(),
      options
    );
export const TestNewSourceDocument = `
    mutation TestNewSource($type: String!, $configuration: JSONObject!, $tunnelId: String, $credentialId: Int) {
  testNewSource(
    type: $type
    configuration: $configuration
    tunnelId: $tunnelId
    credentialId: $credentialId
  ) {
    success
    reason
    metadata
  }
}
    `;
export const useTestNewSourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<TestNewSourceMutation, TError, TestNewSourceMutationVariables, TContext>) => 
    useMutation<TestNewSourceMutation, TError, TestNewSourceMutationVariables, TContext>(
      (variables?: TestNewSourceMutationVariables) => fetcher<TestNewSourceMutation, TestNewSourceMutationVariables>(TestNewSourceDocument, variables)(),
      options
    );
export const TestUpdatedSourceDocument = `
    mutation TestUpdatedSource($sourceId: String!, $newConfiguration: JSONObject!, $tunnelId: String, $credentialId: Int) {
  testUpdatedSource(
    sourceId: $sourceId
    newConfiguration: $newConfiguration
    tunnelId: $tunnelId
    credentialId: $credentialId
  ) {
    success
    reason
    metadata
  }
}
    `;
export const useTestUpdatedSourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<TestUpdatedSourceMutation, TError, TestUpdatedSourceMutationVariables, TContext>) => 
    useMutation<TestUpdatedSourceMutation, TError, TestUpdatedSourceMutationVariables, TContext>(
      (variables?: TestUpdatedSourceMutationVariables) => fetcher<TestUpdatedSourceMutation, TestUpdatedSourceMutationVariables>(TestUpdatedSourceDocument, variables)(),
      options
    );
export const AirtableListBasesDocument = `
    query AirtableListBases($connectionId: String!) {
  airtableListBases(connectionId: $connectionId)
}
    `;
export const useAirtableListBasesQuery = <
      TData = AirtableListBasesQuery,
      TError = Error
    >(
      variables: AirtableListBasesQueryVariables, 
      options?: UseQueryOptions<AirtableListBasesQuery, TError, TData>
    ) => 
    useQuery<AirtableListBasesQuery, TError, TData>(
      ['AirtableListBases', variables],
      fetcher<AirtableListBasesQuery, AirtableListBasesQueryVariables>(AirtableListBasesDocument, variables),
      options
    );
useAirtableListBasesQuery.document = AirtableListBasesDocument;

useAirtableListBasesQuery.getKey = (variables: AirtableListBasesQueryVariables) => ['AirtableListBases', variables];

useAirtableListBasesQuery.fetcher = (variables: AirtableListBasesQueryVariables) => fetcher<AirtableListBasesQuery, AirtableListBasesQueryVariables>(AirtableListBasesDocument, variables);
export const AirtableListTablesDocument = `
    query AirtableListTables($connectionId: String!, $baseId: String!) {
  airtableListTables(connectionId: $connectionId, baseId: $baseId)
}
    `;
export const useAirtableListTablesQuery = <
      TData = AirtableListTablesQuery,
      TError = Error
    >(
      variables: AirtableListTablesQueryVariables, 
      options?: UseQueryOptions<AirtableListTablesQuery, TError, TData>
    ) => 
    useQuery<AirtableListTablesQuery, TError, TData>(
      ['AirtableListTables', variables],
      fetcher<AirtableListTablesQuery, AirtableListTablesQueryVariables>(AirtableListTablesDocument, variables),
      options
    );
useAirtableListTablesQuery.document = AirtableListTablesDocument;

useAirtableListTablesQuery.getKey = (variables: AirtableListTablesQueryVariables) => ['AirtableListTables', variables];

useAirtableListTablesQuery.fetcher = (variables: AirtableListTablesQueryVariables) => fetcher<AirtableListTablesQuery, AirtableListTablesQueryVariables>(AirtableListTablesDocument, variables);
export const GooglesheetsSourceListSheetsDocument = `
    query GooglesheetsSourceListSheets($connectionId: String!) {
  googlesheetsSourceListSheets(connectionId: $connectionId)
}
    `;
export const useGooglesheetsSourceListSheetsQuery = <
      TData = GooglesheetsSourceListSheetsQuery,
      TError = Error
    >(
      variables: GooglesheetsSourceListSheetsQueryVariables, 
      options?: UseQueryOptions<GooglesheetsSourceListSheetsQuery, TError, TData>
    ) => 
    useQuery<GooglesheetsSourceListSheetsQuery, TError, TData>(
      ['GooglesheetsSourceListSheets', variables],
      fetcher<GooglesheetsSourceListSheetsQuery, GooglesheetsSourceListSheetsQueryVariables>(GooglesheetsSourceListSheetsDocument, variables),
      options
    );
useGooglesheetsSourceListSheetsQuery.document = GooglesheetsSourceListSheetsDocument;

useGooglesheetsSourceListSheetsQuery.getKey = (variables: GooglesheetsSourceListSheetsQueryVariables) => ['GooglesheetsSourceListSheets', variables];

useGooglesheetsSourceListSheetsQuery.fetcher = (variables: GooglesheetsSourceListSheetsQueryVariables) => fetcher<GooglesheetsSourceListSheetsQuery, GooglesheetsSourceListSheetsQueryVariables>(GooglesheetsSourceListSheetsDocument, variables);
export const MetabaseListDatabasesDocument = `
    query MetabaseListDatabases($connectionId: String!) {
  metabaseListDatabases(connectionId: $connectionId)
}
    `;
export const useMetabaseListDatabasesQuery = <
      TData = MetabaseListDatabasesQuery,
      TError = Error
    >(
      variables: MetabaseListDatabasesQueryVariables, 
      options?: UseQueryOptions<MetabaseListDatabasesQuery, TError, TData>
    ) => 
    useQuery<MetabaseListDatabasesQuery, TError, TData>(
      ['MetabaseListDatabases', variables],
      fetcher<MetabaseListDatabasesQuery, MetabaseListDatabasesQueryVariables>(MetabaseListDatabasesDocument, variables),
      options
    );
useMetabaseListDatabasesQuery.document = MetabaseListDatabasesDocument;

useMetabaseListDatabasesQuery.getKey = (variables: MetabaseListDatabasesQueryVariables) => ['MetabaseListDatabases', variables];

useMetabaseListDatabasesQuery.fetcher = (variables: MetabaseListDatabasesQueryVariables) => fetcher<MetabaseListDatabasesQuery, MetabaseListDatabasesQueryVariables>(MetabaseListDatabasesDocument, variables);
export const MetabaseListQuestionsDocument = `
    query MetabaseListQuestions($connectionId: String!) {
  metabaseListQuestions(connectionId: $connectionId)
}
    `;
export const useMetabaseListQuestionsQuery = <
      TData = MetabaseListQuestionsQuery,
      TError = Error
    >(
      variables: MetabaseListQuestionsQueryVariables, 
      options?: UseQueryOptions<MetabaseListQuestionsQuery, TError, TData>
    ) => 
    useQuery<MetabaseListQuestionsQuery, TError, TData>(
      ['MetabaseListQuestions', variables],
      fetcher<MetabaseListQuestionsQuery, MetabaseListQuestionsQueryVariables>(MetabaseListQuestionsDocument, variables),
      options
    );
useMetabaseListQuestionsQuery.document = MetabaseListQuestionsDocument;

useMetabaseListQuestionsQuery.getKey = (variables: MetabaseListQuestionsQueryVariables) => ['MetabaseListQuestions', variables];

useMetabaseListQuestionsQuery.fetcher = (variables: MetabaseListQuestionsQueryVariables) => fetcher<MetabaseListQuestionsQuery, MetabaseListQuestionsQueryVariables>(MetabaseListQuestionsDocument, variables);
export const MetabaseListTablesDocument = `
    query MetabaseListTables($connectionId: String!) {
  metabaseListTables(connectionId: $connectionId)
}
    `;
export const useMetabaseListTablesQuery = <
      TData = MetabaseListTablesQuery,
      TError = Error
    >(
      variables: MetabaseListTablesQueryVariables, 
      options?: UseQueryOptions<MetabaseListTablesQuery, TError, TData>
    ) => 
    useQuery<MetabaseListTablesQuery, TError, TData>(
      ['MetabaseListTables', variables],
      fetcher<MetabaseListTablesQuery, MetabaseListTablesQueryVariables>(MetabaseListTablesDocument, variables),
      options
    );
useMetabaseListTablesQuery.document = MetabaseListTablesDocument;

useMetabaseListTablesQuery.getKey = (variables: MetabaseListTablesQueryVariables) => ['MetabaseListTables', variables];

useMetabaseListTablesQuery.fetcher = (variables: MetabaseListTablesQueryVariables) => fetcher<MetabaseListTablesQuery, MetabaseListTablesQueryVariables>(MetabaseListTablesDocument, variables);
export const MixpanelListProjectsDocument = `
    query MixpanelListProjects($connectionId: String!) {
  mixpanelListProjects(connectionId: $connectionId)
}
    `;
export const useMixpanelListProjectsQuery = <
      TData = MixpanelListProjectsQuery,
      TError = Error
    >(
      variables: MixpanelListProjectsQueryVariables, 
      options?: UseQueryOptions<MixpanelListProjectsQuery, TError, TData>
    ) => 
    useQuery<MixpanelListProjectsQuery, TError, TData>(
      ['MixpanelListProjects', variables],
      fetcher<MixpanelListProjectsQuery, MixpanelListProjectsQueryVariables>(MixpanelListProjectsDocument, variables),
      options
    );
useMixpanelListProjectsQuery.document = MixpanelListProjectsDocument;

useMixpanelListProjectsQuery.getKey = (variables: MixpanelListProjectsQueryVariables) => ['MixpanelListProjects', variables];

useMixpanelListProjectsQuery.fetcher = (variables: MixpanelListProjectsQueryVariables) => fetcher<MixpanelListProjectsQuery, MixpanelListProjectsQueryVariables>(MixpanelListProjectsDocument, variables);
export const MixpanelListCohortsDocument = `
    query MixpanelListCohorts($connectionId: String!, $projectId: Int!) {
  mixpanelListCohorts(connectionId: $connectionId, projectId: $projectId)
}
    `;
export const useMixpanelListCohortsQuery = <
      TData = MixpanelListCohortsQuery,
      TError = Error
    >(
      variables: MixpanelListCohortsQueryVariables, 
      options?: UseQueryOptions<MixpanelListCohortsQuery, TError, TData>
    ) => 
    useQuery<MixpanelListCohortsQuery, TError, TData>(
      ['MixpanelListCohorts', variables],
      fetcher<MixpanelListCohortsQuery, MixpanelListCohortsQueryVariables>(MixpanelListCohortsDocument, variables),
      options
    );
useMixpanelListCohortsQuery.document = MixpanelListCohortsDocument;

useMixpanelListCohortsQuery.getKey = (variables: MixpanelListCohortsQueryVariables) => ['MixpanelListCohorts', variables];

useMixpanelListCohortsQuery.fetcher = (variables: MixpanelListCohortsQueryVariables) => fetcher<MixpanelListCohortsQuery, MixpanelListCohortsQueryVariables>(MixpanelListCohortsDocument, variables);
export const ExternalBucketsDocument = `
    query ExternalBuckets {
  external_buckets {
    ...ExternalBucket
    cloud_credential {
      id
      name
      provider
      stripped_config
    }
  }
}
    ${ExternalBucketFragmentDoc}`;
export const useExternalBucketsQuery = <
      TData = ExternalBucketsQuery,
      TError = Error
    >(
      variables?: ExternalBucketsQueryVariables, 
      options?: UseQueryOptions<ExternalBucketsQuery, TError, TData>
    ) => 
    useQuery<ExternalBucketsQuery, TError, TData>(
      variables === undefined ? ['ExternalBuckets'] : ['ExternalBuckets', variables],
      fetcher<ExternalBucketsQuery, ExternalBucketsQueryVariables>(ExternalBucketsDocument, variables),
      options
    );
useExternalBucketsQuery.document = ExternalBucketsDocument;

useExternalBucketsQuery.getKey = (variables?: ExternalBucketsQueryVariables) => variables === undefined ? ['ExternalBuckets'] : ['ExternalBuckets', variables];

useExternalBucketsQuery.fetcher = (variables?: ExternalBucketsQueryVariables) => fetcher<ExternalBucketsQuery, ExternalBucketsQueryVariables>(ExternalBucketsDocument, variables);
export const CreateExternalBucketDocument = `
    mutation CreateExternalBucket($object: external_buckets_insert_input!) {
  insert_external_buckets_one(object: $object) {
    workspace_id
    config
    credential_id
  }
}
    `;
export const useCreateExternalBucketMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateExternalBucketMutation, TError, CreateExternalBucketMutationVariables, TContext>) => 
    useMutation<CreateExternalBucketMutation, TError, CreateExternalBucketMutationVariables, TContext>(
      (variables?: CreateExternalBucketMutationVariables) => fetcher<CreateExternalBucketMutation, CreateExternalBucketMutationVariables>(CreateExternalBucketDocument, variables)(),
      options
    );
export const UpdateExternalBucketDocument = `
    mutation UpdateExternalBucket($workspaceId: bigint!, $set: external_buckets_set_input!, $append: external_buckets_append_input!) {
  update_external_buckets_by_pk(
    pk_columns: {workspace_id: $workspaceId}
    _set: $set
    _append: $append
  ) {
    workspace_id
  }
}
    `;
export const useUpdateExternalBucketMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExternalBucketMutation, TError, UpdateExternalBucketMutationVariables, TContext>) => 
    useMutation<UpdateExternalBucketMutation, TError, UpdateExternalBucketMutationVariables, TContext>(
      (variables?: UpdateExternalBucketMutationVariables) => fetcher<UpdateExternalBucketMutation, UpdateExternalBucketMutationVariables>(UpdateExternalBucketDocument, variables)(),
      options
    );
export const TestStorageDocument = `
    query TestStorage($type: String, $config: String, $credentialId: Int) {
  testStorageConnection(type: $type, config: $config, credentialId: $credentialId)
}
    `;
export const useTestStorageQuery = <
      TData = TestStorageQuery,
      TError = Error
    >(
      variables?: TestStorageQueryVariables, 
      options?: UseQueryOptions<TestStorageQuery, TError, TData>
    ) => 
    useQuery<TestStorageQuery, TError, TData>(
      variables === undefined ? ['TestStorage'] : ['TestStorage', variables],
      fetcher<TestStorageQuery, TestStorageQueryVariables>(TestStorageDocument, variables),
      options
    );
useTestStorageQuery.document = TestStorageDocument;

useTestStorageQuery.getKey = (variables?: TestStorageQueryVariables) => variables === undefined ? ['TestStorage'] : ['TestStorage', variables];

useTestStorageQuery.fetcher = (variables?: TestStorageQueryVariables) => fetcher<TestStorageQuery, TestStorageQueryVariables>(TestStorageDocument, variables);
export const SyncsDocument = `
    query Syncs($limit: Int!, $offset: Int!, $filters: syncs_bool_exp, $orderBy: syncs_order_by! = {created_at: desc}) {
  syncs(
    order_by: [$orderBy, {id: desc}]
    where: $filters
    limit: $limit
    offset: $offset
  ) {
    ...Sync
    ...SyncHistory
    tags
    segment {
      id
      name
      connection {
        ...Source
      }
    }
    destination {
      ...Destination
      definition {
        icon
        name
      }
    }
    sync_requests(order_by: {created_at: desc}, limit: 1) {
      ...SyncRequest
      sync_attempts(order_by: {created_at: desc}, limit: 1) {
        ...SyncAttempt
      }
    }
  }
  syncs_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    ${SyncFragmentDoc}
${SyncHistoryFragmentDoc}
${SourceFragmentDoc}
${DestinationFragmentDoc}
${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useSyncsQuery = <
      TData = SyncsQuery,
      TError = Error
    >(
      variables: SyncsQueryVariables, 
      options?: UseQueryOptions<SyncsQuery, TError, TData>
    ) => 
    useQuery<SyncsQuery, TError, TData>(
      ['Syncs', variables],
      fetcher<SyncsQuery, SyncsQueryVariables>(SyncsDocument, variables),
      options
    );
useSyncsQuery.document = SyncsDocument;

useSyncsQuery.getKey = (variables: SyncsQueryVariables) => ['Syncs', variables];

useSyncsQuery.fetcher = (variables: SyncsQueryVariables) => fetcher<SyncsQuery, SyncsQueryVariables>(SyncsDocument, variables);
export const SyncDocument = `
    query Sync($id: bigint!) {
  syncs(where: {id: {_eq: $id}}) {
    ...Sync
    ...SyncHistory
    slug
    row_threshold_attempted
    row_threshold_total
    sync_template_id
    tags
    warehouse_history_config
    segment {
      id
      name
      query_type
      git_sync_metadata
      primary_key
      ...QueryFields
      connection {
        ...Source
      }
      columns {
        ...Column
      }
      syncable_columns {
        ...SyncableColumn
      }
      parent {
        ...AudienceParent
      }
    }
    destination {
      ...Destination
    }
    sync_alerts {
      ...SyncAlert
    }
    sync_requests(order_by: {created_at: desc}, limit: 2) {
      ...SyncRequest
      sync_attempts(order_by: {created_at: desc}, limit: 1) {
        ...SyncAttempt
      }
    }
  }
}
    ${SyncFragmentDoc}
${SyncHistoryFragmentDoc}
${QueryFieldsFragmentDoc}
${SourceFragmentDoc}
${ColumnFragmentDoc}
${SyncableColumnFragmentDoc}
${AudienceParentFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}
${DestinationFragmentDoc}
${SyncAlertFragmentDoc}
${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useSyncQuery = <
      TData = SyncQuery,
      TError = Error
    >(
      variables: SyncQueryVariables, 
      options?: UseQueryOptions<SyncQuery, TError, TData>
    ) => 
    useQuery<SyncQuery, TError, TData>(
      ['Sync', variables],
      fetcher<SyncQuery, SyncQueryVariables>(SyncDocument, variables),
      options
    );
useSyncQuery.document = SyncDocument;

useSyncQuery.getKey = (variables: SyncQueryVariables) => ['Sync', variables];

useSyncQuery.fetcher = (variables: SyncQueryVariables) => fetcher<SyncQuery, SyncQueryVariables>(SyncDocument, variables);
export const SyncsByTemplateIdDocument = `
    query SyncsByTemplateId($templateId: Int!) {
  syncs(where: {sync_template_id: {_eq: $templateId}}) {
    id
    segment {
      id
      name
    }
    destination {
      id
      name
      type
    }
  }
}
    `;
export const useSyncsByTemplateIdQuery = <
      TData = SyncsByTemplateIdQuery,
      TError = Error
    >(
      variables: SyncsByTemplateIdQueryVariables, 
      options?: UseQueryOptions<SyncsByTemplateIdQuery, TError, TData>
    ) => 
    useQuery<SyncsByTemplateIdQuery, TError, TData>(
      ['SyncsByTemplateId', variables],
      fetcher<SyncsByTemplateIdQuery, SyncsByTemplateIdQueryVariables>(SyncsByTemplateIdDocument, variables),
      options
    );
useSyncsByTemplateIdQuery.document = SyncsByTemplateIdDocument;

useSyncsByTemplateIdQuery.getKey = (variables: SyncsByTemplateIdQueryVariables) => ['SyncsByTemplateId', variables];

useSyncsByTemplateIdQuery.fetcher = (variables: SyncsByTemplateIdQueryVariables) => fetcher<SyncsByTemplateIdQuery, SyncsByTemplateIdQueryVariables>(SyncsByTemplateIdDocument, variables);
export const CreateSyncDocument = `
    mutation CreateSync($object: destination_instances_insert_input!) {
  insert_destination_instances_one(object: $object) {
    id
  }
}
    `;
export const useCreateSyncMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSyncMutation, TError, CreateSyncMutationVariables, TContext>) => 
    useMutation<CreateSyncMutation, TError, CreateSyncMutationVariables, TContext>(
      (variables?: CreateSyncMutationVariables) => fetcher<CreateSyncMutation, CreateSyncMutationVariables>(CreateSyncDocument, variables)(),
      options
    );
export const CreateSyncsDocument = `
    mutation CreateSyncs($objects: [destination_instances_insert_input!]!) {
  insert_destination_instances(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export const useCreateSyncsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSyncsMutation, TError, CreateSyncsMutationVariables, TContext>) => 
    useMutation<CreateSyncsMutation, TError, CreateSyncsMutationVariables, TContext>(
      (variables?: CreateSyncsMutationVariables) => fetcher<CreateSyncsMutation, CreateSyncsMutationVariables>(CreateSyncsDocument, variables)(),
      options
    );
export const UpdateSyncDocument = `
    mutation UpdateSync($id: bigint!, $object: destination_instances_set_input!) {
  update_destination_instances_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `;
export const useUpdateSyncMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSyncMutation, TError, UpdateSyncMutationVariables, TContext>) => 
    useMutation<UpdateSyncMutation, TError, UpdateSyncMutationVariables, TContext>(
      (variables?: UpdateSyncMutationVariables) => fetcher<UpdateSyncMutation, UpdateSyncMutationVariables>(UpdateSyncDocument, variables)(),
      options
    );
export const UpdateSyncsDocument = `
    mutation UpdateSyncs($ids: [bigint!], $object: destination_instances_set_input!) {
  update_destination_instances(where: {id: {_in: $ids}}, _set: $object) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export const useUpdateSyncsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSyncsMutation, TError, UpdateSyncsMutationVariables, TContext>) => 
    useMutation<UpdateSyncsMutation, TError, UpdateSyncsMutationVariables, TContext>(
      (variables?: UpdateSyncsMutationVariables) => fetcher<UpdateSyncsMutation, UpdateSyncsMutationVariables>(UpdateSyncsDocument, variables)(),
      options
    );
export const DeleteSyncDocument = `
    mutation DeleteSync($id: bigint!) {
  delete_destination_instances_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteSyncMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSyncMutation, TError, DeleteSyncMutationVariables, TContext>) => 
    useMutation<DeleteSyncMutation, TError, DeleteSyncMutationVariables, TContext>(
      (variables?: DeleteSyncMutationVariables) => fetcher<DeleteSyncMutation, DeleteSyncMutationVariables>(DeleteSyncDocument, variables)(),
      options
    );
export const DeleteSyncsDocument = `
    mutation DeleteSyncs($ids: [bigint!]!) {
  delete_destination_instances(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const useDeleteSyncsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSyncsMutation, TError, DeleteSyncsMutationVariables, TContext>) => 
    useMutation<DeleteSyncsMutation, TError, DeleteSyncsMutationVariables, TContext>(
      (variables?: DeleteSyncsMutationVariables) => fetcher<DeleteSyncsMutation, DeleteSyncsMutationVariables>(DeleteSyncsDocument, variables)(),
      options
    );
export const StartSyncRunDocument = `
    mutation StartSyncRun($id: Int!, $full_resync: Boolean) {
  startSyncRun(id: $id, fullResync: $full_resync) {
    scheduled
  }
}
    `;
export const useStartSyncRunMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<StartSyncRunMutation, TError, StartSyncRunMutationVariables, TContext>) => 
    useMutation<StartSyncRunMutation, TError, StartSyncRunMutationVariables, TContext>(
      (variables?: StartSyncRunMutationVariables) => fetcher<StartSyncRunMutation, StartSyncRunMutationVariables>(StartSyncRunDocument, variables)(),
      options
    );
export const SyncRunsDocument = `
    query SyncRuns($syncId: bigint!, $filter: sync_attempts_bool_exp, $limit: Int, $offset: Int, $orderBy: sync_requests_order_by! = {created_at: desc}) {
  sync_requests(
    where: {destination_instance_id: {_eq: $syncId}, sync_attempts: $filter}
    order_by: [$orderBy]
    limit: $limit
    offset: $offset
  ) {
    ...SyncRequest
    sync_attempts(order_by: {created_at: desc}, limit: 1) {
      ...SyncAttempt
    }
  }
}
    ${SyncRequestFragmentDoc}
${SyncAttemptFragmentDoc}`;
export const useSyncRunsQuery = <
      TData = SyncRunsQuery,
      TError = Error
    >(
      variables: SyncRunsQueryVariables, 
      options?: UseQueryOptions<SyncRunsQuery, TError, TData>
    ) => 
    useQuery<SyncRunsQuery, TError, TData>(
      ['SyncRuns', variables],
      fetcher<SyncRunsQuery, SyncRunsQueryVariables>(SyncRunsDocument, variables),
      options
    );
useSyncRunsQuery.document = SyncRunsDocument;

useSyncRunsQuery.getKey = (variables: SyncRunsQueryVariables) => ['SyncRuns', variables];

useSyncRunsQuery.fetcher = (variables: SyncRunsQueryVariables) => fetcher<SyncRunsQuery, SyncRunsQueryVariables>(SyncRunsDocument, variables);
export const SyncRequestsDocument = `
    query SyncRequests($instanceId: bigint!) {
  sync_requests(
    where: {destination_instance_id: {_eq: $instanceId}}
    order_by: {created_at: desc}
    limit: 50
  ) {
    id
    created_at
    status
    status_computed
    sync_attempts(order_by: {created_at: desc}, limit: 50) {
      id
      created_at
      finished_at
      error
      status
      details
    }
  }
}
    `;
export const useSyncRequestsQuery = <
      TData = SyncRequestsQuery,
      TError = Error
    >(
      variables: SyncRequestsQueryVariables, 
      options?: UseQueryOptions<SyncRequestsQuery, TError, TData>
    ) => 
    useQuery<SyncRequestsQuery, TError, TData>(
      ['SyncRequests', variables],
      fetcher<SyncRequestsQuery, SyncRequestsQueryVariables>(SyncRequestsDocument, variables),
      options
    );
useSyncRequestsQuery.document = SyncRequestsDocument;

useSyncRequestsQuery.getKey = (variables: SyncRequestsQueryVariables) => ['SyncRequests', variables];

useSyncRequestsQuery.fetcher = (variables: SyncRequestsQueryVariables) => fetcher<SyncRequestsQuery, SyncRequestsQueryVariables>(SyncRequestsDocument, variables);
export const SyncAttemptDocument = `
    query SyncAttempt($syncRequestId: bigint!) {
  sync_attempts(where: {sync_request_id: {_eq: $syncRequestId}}) {
    id
    created_at
    finished_at
    status
    error
    add_rejected
    remove_rejected
    change_rejected
    add_checkpoint
    remove_checkpoint
    change_checkpoint
    sync_request {
      ...SyncRequest
      sync {
        id
        segment {
          primary_key
        }
        destination {
          id
          type
        }
        sync_requests(order_by: {created_at: desc}, limit: 1) {
          id
        }
      }
    }
  }
}
    ${SyncRequestFragmentDoc}`;
export const useSyncAttemptQuery = <
      TData = SyncAttemptQuery,
      TError = Error
    >(
      variables: SyncAttemptQueryVariables, 
      options?: UseQueryOptions<SyncAttemptQuery, TError, TData>
    ) => 
    useQuery<SyncAttemptQuery, TError, TData>(
      ['SyncAttempt', variables],
      fetcher<SyncAttemptQuery, SyncAttemptQueryVariables>(SyncAttemptDocument, variables),
      options
    );
useSyncAttemptQuery.document = SyncAttemptDocument;

useSyncAttemptQuery.getKey = (variables: SyncAttemptQueryVariables) => ['SyncAttempt', variables];

useSyncAttemptQuery.fetcher = (variables: SyncAttemptQueryVariables) => fetcher<SyncAttemptQuery, SyncAttemptQueryVariables>(SyncAttemptDocument, variables);
export const AttemptedRowsDocument = `
    query AttemptedRows($destinationInstanceId: Int!, $syncRequestId: Int!, $pageKey: String, $opTypes: [SyncOp!]!, $onlyRejected: Boolean!, $onlySuccessful: Boolean!, $limit: Int!) {
  getAttemptedRows(
    destinationInstanceId: $destinationInstanceId
    syncRequestId: $syncRequestId
    onlyRejected: $onlyRejected
    onlySuccessful: $onlySuccessful
    opTypes: $opTypes
    paginationOptions: {limit: $limit, pageKey: $pageKey}
  ) {
    rows {
      ...AttemptedRow
    }
    nextPageKey
  }
}
    ${AttemptedRowFragmentDoc}`;
export const useAttemptedRowsQuery = <
      TData = AttemptedRowsQuery,
      TError = Error
    >(
      variables: AttemptedRowsQueryVariables, 
      options?: UseQueryOptions<AttemptedRowsQuery, TError, TData>
    ) => 
    useQuery<AttemptedRowsQuery, TError, TData>(
      ['AttemptedRows', variables],
      fetcher<AttemptedRowsQuery, AttemptedRowsQueryVariables>(AttemptedRowsDocument, variables),
      options
    );
useAttemptedRowsQuery.document = AttemptedRowsDocument;

useAttemptedRowsQuery.getKey = (variables: AttemptedRowsQueryVariables) => ['AttemptedRows', variables];

useAttemptedRowsQuery.fetcher = (variables: AttemptedRowsQueryVariables) => fetcher<AttemptedRowsQuery, AttemptedRowsQueryVariables>(AttemptedRowsDocument, variables);
export const AttemptedRowsByPrimaryKeyDocument = `
    query AttemptedRowsByPrimaryKey($destinationInstanceId: Int!, $syncRequestId: Int!, $id: String!, $alreadyHashed: Boolean) {
  getAttemptedRowsByPrimaryKey(
    destinationInstanceId: $destinationInstanceId
    syncRequestId: $syncRequestId
    id: $id
    paginationOptions: {limit: 10}
    alreadyHashed: $alreadyHashed
  ) {
    rows {
      ...AttemptedRow
    }
  }
}
    ${AttemptedRowFragmentDoc}`;
export const useAttemptedRowsByPrimaryKeyQuery = <
      TData = AttemptedRowsByPrimaryKeyQuery,
      TError = Error
    >(
      variables: AttemptedRowsByPrimaryKeyQueryVariables, 
      options?: UseQueryOptions<AttemptedRowsByPrimaryKeyQuery, TError, TData>
    ) => 
    useQuery<AttemptedRowsByPrimaryKeyQuery, TError, TData>(
      ['AttemptedRowsByPrimaryKey', variables],
      fetcher<AttemptedRowsByPrimaryKeyQuery, AttemptedRowsByPrimaryKeyQueryVariables>(AttemptedRowsByPrimaryKeyDocument, variables),
      options
    );
useAttemptedRowsByPrimaryKeyQuery.document = AttemptedRowsByPrimaryKeyDocument;

useAttemptedRowsByPrimaryKeyQuery.getKey = (variables: AttemptedRowsByPrimaryKeyQueryVariables) => ['AttemptedRowsByPrimaryKey', variables];

useAttemptedRowsByPrimaryKeyQuery.fetcher = (variables: AttemptedRowsByPrimaryKeyQueryVariables) => fetcher<AttemptedRowsByPrimaryKeyQuery, AttemptedRowsByPrimaryKeyQueryVariables>(AttemptedRowsByPrimaryKeyDocument, variables);
export const AttemptedRowsByBatchIdDocument = `
    query AttemptedRowsByBatchId($destinationInstanceId: Int!, $syncRequestId: Int!, $id: String!, $pageKey: String) {
  getAttemptedRowsByBatchId(
    destinationInstanceId: $destinationInstanceId
    syncRequestId: $syncRequestId
    id: $id
    paginationOptions: {limit: 10, pageKey: $pageKey}
  ) {
    rows {
      ...AttemptedRow
    }
    nextPageKey
  }
}
    ${AttemptedRowFragmentDoc}`;
export const useAttemptedRowsByBatchIdQuery = <
      TData = AttemptedRowsByBatchIdQuery,
      TError = Error
    >(
      variables: AttemptedRowsByBatchIdQueryVariables, 
      options?: UseQueryOptions<AttemptedRowsByBatchIdQuery, TError, TData>
    ) => 
    useQuery<AttemptedRowsByBatchIdQuery, TError, TData>(
      ['AttemptedRowsByBatchId', variables],
      fetcher<AttemptedRowsByBatchIdQuery, AttemptedRowsByBatchIdQueryVariables>(AttemptedRowsByBatchIdDocument, variables),
      options
    );
useAttemptedRowsByBatchIdQuery.document = AttemptedRowsByBatchIdDocument;

useAttemptedRowsByBatchIdQuery.getKey = (variables: AttemptedRowsByBatchIdQueryVariables) => ['AttemptedRowsByBatchId', variables];

useAttemptedRowsByBatchIdQuery.fetcher = (variables: AttemptedRowsByBatchIdQueryVariables) => fetcher<AttemptedRowsByBatchIdQuery, AttemptedRowsByBatchIdQueryVariables>(AttemptedRowsByBatchIdDocument, variables);
export const BatchRequestInfoDocument = `
    query BatchRequestInfo($batchRequestInfoKey: String!) {
  getBatchRequestInfo(batchRequestInfoKey: $batchRequestInfoKey) {
    requests {
      requestType
      data
    }
  }
}
    `;
export const useBatchRequestInfoQuery = <
      TData = BatchRequestInfoQuery,
      TError = Error
    >(
      variables: BatchRequestInfoQueryVariables, 
      options?: UseQueryOptions<BatchRequestInfoQuery, TError, TData>
    ) => 
    useQuery<BatchRequestInfoQuery, TError, TData>(
      ['BatchRequestInfo', variables],
      fetcher<BatchRequestInfoQuery, BatchRequestInfoQueryVariables>(BatchRequestInfoDocument, variables),
      options
    );
useBatchRequestInfoQuery.document = BatchRequestInfoDocument;

useBatchRequestInfoQuery.getKey = (variables: BatchRequestInfoQueryVariables) => ['BatchRequestInfo', variables];

useBatchRequestInfoQuery.fetcher = (variables: BatchRequestInfoQueryVariables) => fetcher<BatchRequestInfoQuery, BatchRequestInfoQueryVariables>(BatchRequestInfoDocument, variables);
export const RequestInfoSetDocument = `
    query RequestInfoSet($requestInfoKeys: [String!]) {
  getRequestInfoSet(requestInfoKeys: $requestInfoKeys) {
    requestType
    data
  }
}
    `;
export const useRequestInfoSetQuery = <
      TData = RequestInfoSetQuery,
      TError = Error
    >(
      variables?: RequestInfoSetQueryVariables, 
      options?: UseQueryOptions<RequestInfoSetQuery, TError, TData>
    ) => 
    useQuery<RequestInfoSetQuery, TError, TData>(
      variables === undefined ? ['RequestInfoSet'] : ['RequestInfoSet', variables],
      fetcher<RequestInfoSetQuery, RequestInfoSetQueryVariables>(RequestInfoSetDocument, variables),
      options
    );
useRequestInfoSetQuery.document = RequestInfoSetDocument;

useRequestInfoSetQuery.getKey = (variables?: RequestInfoSetQueryVariables) => variables === undefined ? ['RequestInfoSet'] : ['RequestInfoSet', variables];

useRequestInfoSetQuery.fetcher = (variables?: RequestInfoSetQueryVariables) => fetcher<RequestInfoSetQuery, RequestInfoSetQueryVariables>(RequestInfoSetDocument, variables);
export const UpdateSyncRequestDocument = `
    mutation UpdateSyncRequest($id: bigint!, $object: sync_requests_set_input!) {
  update_sync_requests_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `;
export const useUpdateSyncRequestMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSyncRequestMutation, TError, UpdateSyncRequestMutationVariables, TContext>) => 
    useMutation<UpdateSyncRequestMutation, TError, UpdateSyncRequestMutationVariables, TContext>(
      (variables?: UpdateSyncRequestMutationVariables) => fetcher<UpdateSyncRequestMutation, UpdateSyncRequestMutationVariables>(UpdateSyncRequestDocument, variables)(),
      options
    );
export const TestSyncConfigurationDocument = `
    query TestSyncConfiguration($segmentId: Int!, $destinationId: Int!, $syncConfig: JSONObject!, $rows: [JSONObject!]!, $operation: SyncOp!) {
  testSyncConfiguration(
    segmentId: $segmentId
    destinationId: $destinationId
    syncConfig: $syncConfig
    rows: $rows
    operation: $operation
  ) {
    batches {
      batchId
      attemptedRows
      rejectedRows
      requestInfoSet {
        requestType
        data
      }
    }
    error
  }
}
    `;
export const useTestSyncConfigurationQuery = <
      TData = TestSyncConfigurationQuery,
      TError = Error
    >(
      variables: TestSyncConfigurationQueryVariables, 
      options?: UseQueryOptions<TestSyncConfigurationQuery, TError, TData>
    ) => 
    useQuery<TestSyncConfigurationQuery, TError, TData>(
      ['TestSyncConfiguration', variables],
      fetcher<TestSyncConfigurationQuery, TestSyncConfigurationQueryVariables>(TestSyncConfigurationDocument, variables),
      options
    );
useTestSyncConfigurationQuery.document = TestSyncConfigurationDocument;

useTestSyncConfigurationQuery.getKey = (variables: TestSyncConfigurationQueryVariables) => ['TestSyncConfiguration', variables];

useTestSyncConfigurationQuery.fetcher = (variables: TestSyncConfigurationQueryVariables) => fetcher<TestSyncConfigurationQuery, TestSyncConfigurationQueryVariables>(TestSyncConfigurationDocument, variables);
export const TestSyncConfigurationSupportedDocument = `
    query TestSyncConfigurationSupported($segmentId: Int!, $destinationId: Int!, $syncConfig: JSONObject!) {
  testSyncConfigurationSupported(
    segmentId: $segmentId
    destinationId: $destinationId
    syncConfig: $syncConfig
  )
}
    `;
export const useTestSyncConfigurationSupportedQuery = <
      TData = TestSyncConfigurationSupportedQuery,
      TError = Error
    >(
      variables: TestSyncConfigurationSupportedQueryVariables, 
      options?: UseQueryOptions<TestSyncConfigurationSupportedQuery, TError, TData>
    ) => 
    useQuery<TestSyncConfigurationSupportedQuery, TError, TData>(
      ['TestSyncConfigurationSupported', variables],
      fetcher<TestSyncConfigurationSupportedQuery, TestSyncConfigurationSupportedQueryVariables>(TestSyncConfigurationSupportedDocument, variables),
      options
    );
useTestSyncConfigurationSupportedQuery.document = TestSyncConfigurationSupportedDocument;

useTestSyncConfigurationSupportedQuery.getKey = (variables: TestSyncConfigurationSupportedQueryVariables) => ['TestSyncConfigurationSupported', variables];

useTestSyncConfigurationSupportedQuery.fetcher = (variables: TestSyncConfigurationSupportedQueryVariables) => fetcher<TestSyncConfigurationSupportedQuery, TestSyncConfigurationSupportedQueryVariables>(TestSyncConfigurationSupportedDocument, variables);
export const ExternalSegmentsDocument = `
    query ExternalSegments($syncId: bigint!) {
  external_segments(where: {destination_instance_id: {_eq: $syncId}}) {
    id
    external_id
    created_at
  }
}
    `;
export const useExternalSegmentsQuery = <
      TData = ExternalSegmentsQuery,
      TError = Error
    >(
      variables: ExternalSegmentsQueryVariables, 
      options?: UseQueryOptions<ExternalSegmentsQuery, TError, TData>
    ) => 
    useQuery<ExternalSegmentsQuery, TError, TData>(
      ['ExternalSegments', variables],
      fetcher<ExternalSegmentsQuery, ExternalSegmentsQueryVariables>(ExternalSegmentsDocument, variables),
      options
    );
useExternalSegmentsQuery.document = ExternalSegmentsDocument;

useExternalSegmentsQuery.getKey = (variables: ExternalSegmentsQueryVariables) => ['ExternalSegments', variables];

useExternalSegmentsQuery.fetcher = (variables: ExternalSegmentsQueryVariables) => fetcher<ExternalSegmentsQuery, ExternalSegmentsQueryVariables>(ExternalSegmentsDocument, variables);
export const SyncTemplatesDocument = `
    query SyncTemplates {
  sync_templates {
    id
    name
    destination {
      ...Destination
    }
    segment {
      id
      name
      connection {
        ...Source
      }
    }
  }
}
    ${DestinationFragmentDoc}
${SourceFragmentDoc}`;
export const useSyncTemplatesQuery = <
      TData = SyncTemplatesQuery,
      TError = Error
    >(
      variables?: SyncTemplatesQueryVariables, 
      options?: UseQueryOptions<SyncTemplatesQuery, TError, TData>
    ) => 
    useQuery<SyncTemplatesQuery, TError, TData>(
      variables === undefined ? ['SyncTemplates'] : ['SyncTemplates', variables],
      fetcher<SyncTemplatesQuery, SyncTemplatesQueryVariables>(SyncTemplatesDocument, variables),
      options
    );
useSyncTemplatesQuery.document = SyncTemplatesDocument;

useSyncTemplatesQuery.getKey = (variables?: SyncTemplatesQueryVariables) => variables === undefined ? ['SyncTemplates'] : ['SyncTemplates', variables];

useSyncTemplatesQuery.fetcher = (variables?: SyncTemplatesQueryVariables) => fetcher<SyncTemplatesQuery, SyncTemplatesQueryVariables>(SyncTemplatesDocument, variables);
export const SyncTemplatesForParentModelDocument = `
    query SyncTemplatesForParentModel($parentModelId: Int!) {
  sync_templates(where: {segment_id: {_eq: $parentModelId}}) {
    id
    name
    config
    transformed_config
    destination {
      ...Destination
    }
    segment {
      id
      name
      connection {
        ...Source
      }
    }
  }
}
    ${DestinationFragmentDoc}
${SourceFragmentDoc}`;
export const useSyncTemplatesForParentModelQuery = <
      TData = SyncTemplatesForParentModelQuery,
      TError = Error
    >(
      variables: SyncTemplatesForParentModelQueryVariables, 
      options?: UseQueryOptions<SyncTemplatesForParentModelQuery, TError, TData>
    ) => 
    useQuery<SyncTemplatesForParentModelQuery, TError, TData>(
      ['SyncTemplatesForParentModel', variables],
      fetcher<SyncTemplatesForParentModelQuery, SyncTemplatesForParentModelQueryVariables>(SyncTemplatesForParentModelDocument, variables),
      options
    );
useSyncTemplatesForParentModelQuery.document = SyncTemplatesForParentModelDocument;

useSyncTemplatesForParentModelQuery.getKey = (variables: SyncTemplatesForParentModelQueryVariables) => ['SyncTemplatesForParentModel', variables];

useSyncTemplatesForParentModelQuery.fetcher = (variables: SyncTemplatesForParentModelQueryVariables) => fetcher<SyncTemplatesForParentModelQuery, SyncTemplatesForParentModelQueryVariables>(SyncTemplatesForParentModelDocument, variables);
export const SyncTemplateDocument = `
    query SyncTemplate($id: Int!) {
  sync_templates_by_pk(id: $id) {
    id
    name
    schedule
    config: transformed_config
    row_threshold_attempted
    row_threshold_total
    destination {
      ...Destination
    }
    segment {
      id
      name
      query_type
      git_sync_metadata
      primary_key
      ...QueryFields
      connection {
        ...Source
      }
      columns {
        ...Column
      }
      syncable_columns {
        ...SyncableColumn
      }
      parent {
        ...AudienceParent
      }
    }
    alert_instances {
      ...AlertInstance
    }
  }
}
    ${DestinationFragmentDoc}
${QueryFieldsFragmentDoc}
${SourceFragmentDoc}
${ColumnFragmentDoc}
${SyncableColumnFragmentDoc}
${AudienceParentFragmentDoc}
${FilterableColumnFragmentDoc}
${RelationshipFragmentDoc}
${TraitDefinitionFragmentDoc}
${AlertInstanceFragmentDoc}`;
export const useSyncTemplateQuery = <
      TData = SyncTemplateQuery,
      TError = Error
    >(
      variables: SyncTemplateQueryVariables, 
      options?: UseQueryOptions<SyncTemplateQuery, TError, TData>
    ) => 
    useQuery<SyncTemplateQuery, TError, TData>(
      ['SyncTemplate', variables],
      fetcher<SyncTemplateQuery, SyncTemplateQueryVariables>(SyncTemplateDocument, variables),
      options
    );
useSyncTemplateQuery.document = SyncTemplateDocument;

useSyncTemplateQuery.getKey = (variables: SyncTemplateQueryVariables) => ['SyncTemplate', variables];

useSyncTemplateQuery.fetcher = (variables: SyncTemplateQueryVariables) => fetcher<SyncTemplateQuery, SyncTemplateQueryVariables>(SyncTemplateDocument, variables);
export const CreateSyncTemplateDocument = `
    mutation CreateSyncTemplate($object: sync_templates_insert_input!) {
  insert_sync_templates_one(object: $object) {
    id
  }
}
    `;
export const useCreateSyncTemplateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSyncTemplateMutation, TError, CreateSyncTemplateMutationVariables, TContext>) => 
    useMutation<CreateSyncTemplateMutation, TError, CreateSyncTemplateMutationVariables, TContext>(
      (variables?: CreateSyncTemplateMutationVariables) => fetcher<CreateSyncTemplateMutation, CreateSyncTemplateMutationVariables>(CreateSyncTemplateDocument, variables)(),
      options
    );
export const UpdateSyncTemplateDocument = `
    mutation UpdateSyncTemplate($id: Int!, $input: sync_templates_set_input!) {
  update_sync_templates_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateSyncTemplateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSyncTemplateMutation, TError, UpdateSyncTemplateMutationVariables, TContext>) => 
    useMutation<UpdateSyncTemplateMutation, TError, UpdateSyncTemplateMutationVariables, TContext>(
      (variables?: UpdateSyncTemplateMutationVariables) => fetcher<UpdateSyncTemplateMutation, UpdateSyncTemplateMutationVariables>(UpdateSyncTemplateDocument, variables)(),
      options
    );
export const DeleteSyncTemplateDocument = `
    mutation DeleteSyncTemplate($id: Int!) {
  delete_sync_templates_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteSyncTemplateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSyncTemplateMutation, TError, DeleteSyncTemplateMutationVariables, TContext>) => 
    useMutation<DeleteSyncTemplateMutation, TError, DeleteSyncTemplateMutationVariables, TContext>(
      (variables?: DeleteSyncTemplateMutationVariables) => fetcher<DeleteSyncTemplateMutation, DeleteSyncTemplateMutationVariables>(DeleteSyncTemplateDocument, variables)(),
      options
    );
export const TunnelsDocument = `
    query Tunnels {
  getTunnels {
    type
    tunnel {
      id
      name
      createdAt
      tunnelPort
      ... on NormalTunnel {
        sshHost
        sshPort
        serviceHost
        servicePort
      }
    }
    connection {
      host
      port
    }
  }
}
    `;
export const useTunnelsQuery = <
      TData = TunnelsQuery,
      TError = Error
    >(
      variables?: TunnelsQueryVariables, 
      options?: UseQueryOptions<TunnelsQuery, TError, TData>
    ) => 
    useQuery<TunnelsQuery, TError, TData>(
      variables === undefined ? ['Tunnels'] : ['Tunnels', variables],
      fetcher<TunnelsQuery, TunnelsQueryVariables>(TunnelsDocument, variables),
      options
    );
useTunnelsQuery.document = TunnelsDocument;

useTunnelsQuery.getKey = (variables?: TunnelsQueryVariables) => variables === undefined ? ['Tunnels'] : ['Tunnels', variables];

useTunnelsQuery.fetcher = (variables?: TunnelsQueryVariables) => fetcher<TunnelsQuery, TunnelsQueryVariables>(TunnelsDocument, variables);
export const CreateNormalTunnelDocument = `
    mutation CreateNormalTunnel($input: NormalTunnelInput!) {
  createNormalTunnel(input: $input) {
    tunnel {
      id
      tunnelPort
    }
    connection {
      host
      port
    }
    publicKey
  }
}
    `;
export const useCreateNormalTunnelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateNormalTunnelMutation, TError, CreateNormalTunnelMutationVariables, TContext>) => 
    useMutation<CreateNormalTunnelMutation, TError, CreateNormalTunnelMutationVariables, TContext>(
      (variables?: CreateNormalTunnelMutationVariables) => fetcher<CreateNormalTunnelMutation, CreateNormalTunnelMutationVariables>(CreateNormalTunnelDocument, variables)(),
      options
    );
export const CreateReverseTunnelDocument = `
    mutation CreateReverseTunnel($input: ReverseTunnelInput!) {
  createReverseTunnel(input: $input) {
    tunnel {
      id
      sshdPort
      tunnelPort
    }
    connection {
      host
      port
    }
    privateKeyBase64
  }
}
    `;
export const useCreateReverseTunnelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReverseTunnelMutation, TError, CreateReverseTunnelMutationVariables, TContext>) => 
    useMutation<CreateReverseTunnelMutation, TError, CreateReverseTunnelMutationVariables, TContext>(
      (variables?: CreateReverseTunnelMutationVariables) => fetcher<CreateReverseTunnelMutation, CreateReverseTunnelMutationVariables>(CreateReverseTunnelDocument, variables)(),
      options
    );
export const TestTunnelDocument = `
    query TestTunnel($id: String!) {
  checkTunnel(id: $id) {
    success
    error
  }
}
    `;
export const useTestTunnelQuery = <
      TData = TestTunnelQuery,
      TError = Error
    >(
      variables: TestTunnelQueryVariables, 
      options?: UseQueryOptions<TestTunnelQuery, TError, TData>
    ) => 
    useQuery<TestTunnelQuery, TError, TData>(
      ['TestTunnel', variables],
      fetcher<TestTunnelQuery, TestTunnelQueryVariables>(TestTunnelDocument, variables),
      options
    );
useTestTunnelQuery.document = TestTunnelDocument;

useTestTunnelQuery.getKey = (variables: TestTunnelQueryVariables) => ['TestTunnel', variables];

useTestTunnelQuery.fetcher = (variables: TestTunnelQueryVariables) => fetcher<TestTunnelQuery, TestTunnelQueryVariables>(TestTunnelDocument, variables);
export const TunnelSourceDocument = `
    query TunnelSource($tunnelID: uuid!, $sourceID: bigint) {
  connections(where: {tunnel_id: {_eq: $tunnelID}, id: {_neq: $sourceID}}) {
    id
    name
  }
}
    `;
export const useTunnelSourceQuery = <
      TData = TunnelSourceQuery,
      TError = Error
    >(
      variables: TunnelSourceQueryVariables, 
      options?: UseQueryOptions<TunnelSourceQuery, TError, TData>
    ) => 
    useQuery<TunnelSourceQuery, TError, TData>(
      ['TunnelSource', variables],
      fetcher<TunnelSourceQuery, TunnelSourceQueryVariables>(TunnelSourceDocument, variables),
      options
    );
useTunnelSourceQuery.document = TunnelSourceDocument;

useTunnelSourceQuery.getKey = (variables: TunnelSourceQueryVariables) => ['TunnelSource', variables];

useTunnelSourceQuery.fetcher = (variables: TunnelSourceQueryVariables) => fetcher<TunnelSourceQuery, TunnelSourceQueryVariables>(TunnelSourceDocument, variables);
export const DeleteTunnelDocument = `
    mutation DeleteTunnel($id: String!) {
  deleteTunnel(id: $id)
}
    `;
export const useDeleteTunnelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTunnelMutation, TError, DeleteTunnelMutationVariables, TContext>) => 
    useMutation<DeleteTunnelMutation, TError, DeleteTunnelMutationVariables, TContext>(
      (variables?: DeleteTunnelMutationVariables) => fetcher<DeleteTunnelMutation, DeleteTunnelMutationVariables>(DeleteTunnelDocument, variables)(),
      options
    );
export const UpdateTunnelDocument = `
    mutation UpdateTunnel($id: uuid!, $input: tunnels_set_input!) {
  update_tunnels_by_pk(pk_columns: {tunnel_id: $id}, _set: $input) {
    tunnel_id
    name
  }
}
    `;
export const useUpdateTunnelMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTunnelMutation, TError, UpdateTunnelMutationVariables, TContext>) => 
    useMutation<UpdateTunnelMutation, TError, UpdateTunnelMutationVariables, TContext>(
      (variables?: UpdateTunnelMutationVariables) => fetcher<UpdateTunnelMutation, UpdateTunnelMutationVariables>(UpdateTunnelDocument, variables)(),
      options
    );
export const SaveUserPersonalizationDocument = `
    mutation SaveUserPersonalization($userId: bigint!, $role: String, $customRole: String, $referrer: String) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {personalization: {state: "completed", role: $role, custom_role: $customRole, referrer: $referrer}}
  ) {
    id
  }
}
    `;
export const useSaveUserPersonalizationMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<SaveUserPersonalizationMutation, TError, SaveUserPersonalizationMutationVariables, TContext>) => 
    useMutation<SaveUserPersonalizationMutation, TError, SaveUserPersonalizationMutationVariables, TContext>(
      (variables?: SaveUserPersonalizationMutationVariables) => fetcher<SaveUserPersonalizationMutation, SaveUserPersonalizationMutationVariables>(SaveUserPersonalizationDocument, variables)(),
      options
    );
export const InitialDocument = `
    query Initial($permissionFilters: [String!]) {
  getCurrentUser {
    ...User
  }
  getCurrentPermissions(filters: $permissionFilters) {
    resource
    grants
  }
  getOrganization {
    id
    name
    slug
  }
  workspaces(order_by: {name: asc}) {
    ...Workspace
    organization {
      ...Organization
      entitlements
      plan {
        entitlements
      }
    }
    memberships {
      ...Membership
    }
    roles {
      ...Role
    }
  }
  segments(order_by: {created_at: desc}, limit: 1) {
    id
  }
  connections(
    order_by: {created_at: desc}
    where: {is_demo: {_eq: false}}
    limit: 1
  ) {
    id
    type
  }
  destinations(order_by: {created_at: desc}, limit: 1) {
    id
    type
  }
  destination_instances(order_by: {created_at: desc}, limit: 1) {
    id
  }
}
    ${UserFragmentDoc}
${WorkspaceFragmentDoc}
${OrganizationFragmentDoc}
${MembershipFragmentDoc}
${RoleFragmentDoc}`;
export const useInitialQuery = <
      TData = InitialQuery,
      TError = Error
    >(
      variables?: InitialQueryVariables, 
      options?: UseQueryOptions<InitialQuery, TError, TData>
    ) => 
    useQuery<InitialQuery, TError, TData>(
      variables === undefined ? ['Initial'] : ['Initial', variables],
      fetcher<InitialQuery, InitialQueryVariables>(InitialDocument, variables),
      options
    );
useInitialQuery.document = InitialDocument;

useInitialQuery.getKey = (variables?: InitialQueryVariables) => variables === undefined ? ['Initial'] : ['Initial', variables];

useInitialQuery.fetcher = (variables?: InitialQueryVariables) => fetcher<InitialQuery, InitialQueryVariables>(InitialDocument, variables);
export const ViewsDocument = `
    query Views($resourceType: String!) {
  resource_views(where: {resource_type: {_eq: $resourceType}}) {
    id
    name
    view
  }
}
    `;
export const useViewsQuery = <
      TData = ViewsQuery,
      TError = Error
    >(
      variables: ViewsQueryVariables, 
      options?: UseQueryOptions<ViewsQuery, TError, TData>
    ) => 
    useQuery<ViewsQuery, TError, TData>(
      ['Views', variables],
      fetcher<ViewsQuery, ViewsQueryVariables>(ViewsDocument, variables),
      options
    );
useViewsQuery.document = ViewsDocument;

useViewsQuery.getKey = (variables: ViewsQueryVariables) => ['Views', variables];

useViewsQuery.fetcher = (variables: ViewsQueryVariables) => fetcher<ViewsQuery, ViewsQueryVariables>(ViewsDocument, variables);
export const CreateViewDocument = `
    mutation CreateView($resourceType: String!, $name: String!, $view: jsonb!, $private: Boolean!) {
  insert_resource_views_one(
    object: {resource_type: $resourceType, view: $view, name: $name, private: $private}
  ) {
    id
  }
}
    `;
export const useCreateViewMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateViewMutation, TError, CreateViewMutationVariables, TContext>) => 
    useMutation<CreateViewMutation, TError, CreateViewMutationVariables, TContext>(
      (variables?: CreateViewMutationVariables) => fetcher<CreateViewMutation, CreateViewMutationVariables>(CreateViewDocument, variables)(),
      options
    );
export const DeleteViewDocument = `
    mutation DeleteView($id: bigint!) {
  delete_resource_views_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteViewMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteViewMutation, TError, DeleteViewMutationVariables, TContext>) => 
    useMutation<DeleteViewMutation, TError, DeleteViewMutationVariables, TContext>(
      (variables?: DeleteViewMutationVariables) => fetcher<DeleteViewMutation, DeleteViewMutationVariables>(DeleteViewDocument, variables)(),
      options
    );
export const UpdateViewDocument = `
    mutation UpdateView($id: bigint!, $view: jsonb!) {
  update_resource_views_by_pk(pk_columns: {id: $id}, _set: {view: $view}) {
    id
  }
}
    `;
export const useUpdateViewMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateViewMutation, TError, UpdateViewMutationVariables, TContext>) => 
    useMutation<UpdateViewMutation, TError, UpdateViewMutationVariables, TContext>(
      (variables?: UpdateViewMutationVariables) => fetcher<UpdateViewMutation, UpdateViewMutationVariables>(UpdateViewDocument, variables)(),
      options
    );
export const WorkspacesDocument = `
    query Workspaces {
  workspaces(order_by: {name: asc}) {
    ...Workspace
    organization {
      id
      name
    }
    memberships {
      ...Membership
    }
  }
}
    ${WorkspaceFragmentDoc}
${MembershipFragmentDoc}`;
export const useWorkspacesQuery = <
      TData = WorkspacesQuery,
      TError = Error
    >(
      variables?: WorkspacesQueryVariables, 
      options?: UseQueryOptions<WorkspacesQuery, TError, TData>
    ) => 
    useQuery<WorkspacesQuery, TError, TData>(
      variables === undefined ? ['Workspaces'] : ['Workspaces', variables],
      fetcher<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, variables),
      options
    );
useWorkspacesQuery.document = WorkspacesDocument;

useWorkspacesQuery.getKey = (variables?: WorkspacesQueryVariables) => variables === undefined ? ['Workspaces'] : ['Workspaces', variables];

useWorkspacesQuery.fetcher = (variables?: WorkspacesQueryVariables) => fetcher<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, variables);
export const AllWorkspacesDocument = `
    query AllWorkspaces {
  workspaces {
    id
    label: name
    slug
  }
}
    `;
export const useAllWorkspacesQuery = <
      TData = AllWorkspacesQuery,
      TError = Error
    >(
      variables?: AllWorkspacesQueryVariables, 
      options?: UseQueryOptions<AllWorkspacesQuery, TError, TData>
    ) => 
    useQuery<AllWorkspacesQuery, TError, TData>(
      variables === undefined ? ['AllWorkspaces'] : ['AllWorkspaces', variables],
      fetcher<AllWorkspacesQuery, AllWorkspacesQueryVariables>(AllWorkspacesDocument, variables),
      options
    );
useAllWorkspacesQuery.document = AllWorkspacesDocument;

useAllWorkspacesQuery.getKey = (variables?: AllWorkspacesQueryVariables) => variables === undefined ? ['AllWorkspaces'] : ['AllWorkspaces', variables];

useAllWorkspacesQuery.fetcher = (variables?: AllWorkspacesQueryVariables) => fetcher<AllWorkspacesQuery, AllWorkspacesQueryVariables>(AllWorkspacesDocument, variables);
export const SearchWorkspacesDocument = `
    query SearchWorkspaces($query: String!, $limit: Int) {
  workspaces(
    where: {_or: [{name: {_ilike: $query}}, {slug: {_ilike: $query}}]}
    limit: $limit
  ) {
    id
    name
    slug
  }
}
    `;
export const useSearchWorkspacesQuery = <
      TData = SearchWorkspacesQuery,
      TError = Error
    >(
      variables: SearchWorkspacesQueryVariables, 
      options?: UseQueryOptions<SearchWorkspacesQuery, TError, TData>
    ) => 
    useQuery<SearchWorkspacesQuery, TError, TData>(
      ['SearchWorkspaces', variables],
      fetcher<SearchWorkspacesQuery, SearchWorkspacesQueryVariables>(SearchWorkspacesDocument, variables),
      options
    );
useSearchWorkspacesQuery.document = SearchWorkspacesDocument;

useSearchWorkspacesQuery.getKey = (variables: SearchWorkspacesQueryVariables) => ['SearchWorkspaces', variables];

useSearchWorkspacesQuery.fetcher = (variables: SearchWorkspacesQueryVariables) => fetcher<SearchWorkspacesQuery, SearchWorkspacesQueryVariables>(SearchWorkspacesDocument, variables);
export const WorkspaceDocument = `
    query Workspace($workspaceId: bigint!, $limit: Int, $offset: Int, $search: String, $orderBy: memberships_order_by = {user_id: desc}) {
  workspaces_by_pk(id: $workspaceId) {
    ...Workspace
    memberships(
      where: {_or: [{user: {name: {_like: $search}}}, {user: {email: {_like: $search}}}]}
      order_by: [$orderBy, {role_id: desc}]
      limit: $limit
      offset: $offset
    ) {
      ...Membership
    }
    roles {
      ...Role
    }
  }
  memberships_aggregate(
    where: {_and: {workspace_id: {_eq: $workspaceId}, _or: [{user: {name: {_like: $search}}}, {user: {email: {_like: $search}}}]}}
  ) {
    aggregate {
      count
    }
  }
}
    ${WorkspaceFragmentDoc}
${MembershipFragmentDoc}
${RoleFragmentDoc}`;
export const useWorkspaceQuery = <
      TData = WorkspaceQuery,
      TError = Error
    >(
      variables: WorkspaceQueryVariables, 
      options?: UseQueryOptions<WorkspaceQuery, TError, TData>
    ) => 
    useQuery<WorkspaceQuery, TError, TData>(
      ['Workspace', variables],
      fetcher<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, variables),
      options
    );
useWorkspaceQuery.document = WorkspaceDocument;

useWorkspaceQuery.getKey = (variables: WorkspaceQueryVariables) => ['Workspace', variables];

useWorkspaceQuery.fetcher = (variables: WorkspaceQueryVariables) => fetcher<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, variables);
export const AvailableWorkspacesDocument = `
    query AvailableWorkspaces {
  getAvailableWorkspaces {
    joinable {
      id
      name
      slug
      organization {
        id
        name
      }
    }
    visible {
      id
      name
      slug
      organization {
        id
        name
      }
    }
  }
}
    `;
export const useAvailableWorkspacesQuery = <
      TData = AvailableWorkspacesQuery,
      TError = Error
    >(
      variables?: AvailableWorkspacesQueryVariables, 
      options?: UseQueryOptions<AvailableWorkspacesQuery, TError, TData>
    ) => 
    useQuery<AvailableWorkspacesQuery, TError, TData>(
      variables === undefined ? ['AvailableWorkspaces'] : ['AvailableWorkspaces', variables],
      fetcher<AvailableWorkspacesQuery, AvailableWorkspacesQueryVariables>(AvailableWorkspacesDocument, variables),
      options
    );
useAvailableWorkspacesQuery.document = AvailableWorkspacesDocument;

useAvailableWorkspacesQuery.getKey = (variables?: AvailableWorkspacesQueryVariables) => variables === undefined ? ['AvailableWorkspaces'] : ['AvailableWorkspaces', variables];

useAvailableWorkspacesQuery.fetcher = (variables?: AvailableWorkspacesQueryVariables) => fetcher<AvailableWorkspacesQuery, AvailableWorkspacesQueryVariables>(AvailableWorkspacesDocument, variables);
export const GetWorkspaceRolesDocument = `
    query GetWorkspaceRoles($workspaceId: bigint!) {
  workspaces_by_pk(id: $workspaceId) {
    roles {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export const useGetWorkspaceRolesQuery = <
      TData = GetWorkspaceRolesQuery,
      TError = Error
    >(
      variables: GetWorkspaceRolesQueryVariables, 
      options?: UseQueryOptions<GetWorkspaceRolesQuery, TError, TData>
    ) => 
    useQuery<GetWorkspaceRolesQuery, TError, TData>(
      ['GetWorkspaceRoles', variables],
      fetcher<GetWorkspaceRolesQuery, GetWorkspaceRolesQueryVariables>(GetWorkspaceRolesDocument, variables),
      options
    );
useGetWorkspaceRolesQuery.document = GetWorkspaceRolesDocument;

useGetWorkspaceRolesQuery.getKey = (variables: GetWorkspaceRolesQueryVariables) => ['GetWorkspaceRoles', variables];

useGetWorkspaceRolesQuery.fetcher = (variables: GetWorkspaceRolesQueryVariables) => fetcher<GetWorkspaceRolesQuery, GetWorkspaceRolesQueryVariables>(GetWorkspaceRolesDocument, variables);
export const UpdateUserWorkspaceRoleDocument = `
    mutation UpdateUserWorkspaceRole($workspaceId: bigint!, $userId: bigint!, $roleId: Int!) {
  update_memberships(
    _set: {role_id: $roleId}
    where: {user_id: {_eq: $userId}, workspace_id: {_eq: $workspaceId}}
  ) {
    affected_rows
  }
}
    `;
export const useUpdateUserWorkspaceRoleMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserWorkspaceRoleMutation, TError, UpdateUserWorkspaceRoleMutationVariables, TContext>) => 
    useMutation<UpdateUserWorkspaceRoleMutation, TError, UpdateUserWorkspaceRoleMutationVariables, TContext>(
      (variables?: UpdateUserWorkspaceRoleMutationVariables) => fetcher<UpdateUserWorkspaceRoleMutation, UpdateUserWorkspaceRoleMutationVariables>(UpdateUserWorkspaceRoleDocument, variables)(),
      options
    );
export const UpdateWorkspaceRoleDocument = `
    mutation UpdateWorkspaceRole($workspaceId: bigint!, $roleId: bigint!, $name: String!, $permissions: jsonb!) {
  update_roles(
    _set: {permissions: $permissions, name: $name}
    where: {id: {_eq: $roleId}, workspace_id: {_eq: $workspaceId}}
  ) {
    affected_rows
  }
}
    `;
export const useUpdateWorkspaceRoleMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkspaceRoleMutation, TError, UpdateWorkspaceRoleMutationVariables, TContext>) => 
    useMutation<UpdateWorkspaceRoleMutation, TError, UpdateWorkspaceRoleMutationVariables, TContext>(
      (variables?: UpdateWorkspaceRoleMutationVariables) => fetcher<UpdateWorkspaceRoleMutation, UpdateWorkspaceRoleMutationVariables>(UpdateWorkspaceRoleDocument, variables)(),
      options
    );
export const AddWorkspaceRoleDocument = `
    mutation AddWorkspaceRole($name: String!, $permissions: jsonb) {
  insert_roles_one(object: {name: $name, permissions: $permissions}) {
    id
  }
}
    `;
export const useAddWorkspaceRoleMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<AddWorkspaceRoleMutation, TError, AddWorkspaceRoleMutationVariables, TContext>) => 
    useMutation<AddWorkspaceRoleMutation, TError, AddWorkspaceRoleMutationVariables, TContext>(
      (variables?: AddWorkspaceRoleMutationVariables) => fetcher<AddWorkspaceRoleMutation, AddWorkspaceRoleMutationVariables>(AddWorkspaceRoleDocument, variables)(),
      options
    );
export const VerifiedDomainsDocument = `
    query VerifiedDomains {
  getVerifiedDomains
}
    `;
export const useVerifiedDomainsQuery = <
      TData = VerifiedDomainsQuery,
      TError = Error
    >(
      variables?: VerifiedDomainsQueryVariables, 
      options?: UseQueryOptions<VerifiedDomainsQuery, TError, TData>
    ) => 
    useQuery<VerifiedDomainsQuery, TError, TData>(
      variables === undefined ? ['VerifiedDomains'] : ['VerifiedDomains', variables],
      fetcher<VerifiedDomainsQuery, VerifiedDomainsQueryVariables>(VerifiedDomainsDocument, variables),
      options
    );
useVerifiedDomainsQuery.document = VerifiedDomainsDocument;

useVerifiedDomainsQuery.getKey = (variables?: VerifiedDomainsQueryVariables) => variables === undefined ? ['VerifiedDomains'] : ['VerifiedDomains', variables];

useVerifiedDomainsQuery.fetcher = (variables?: VerifiedDomainsQueryVariables) => fetcher<VerifiedDomainsQuery, VerifiedDomainsQueryVariables>(VerifiedDomainsDocument, variables);
export const MembershipRequestsByWorkspaceDocument = `
    query MembershipRequestsByWorkspace($workspaceId: bigint!) {
  membership_requests(where: {workspace_id: {_eq: $workspaceId}}) {
    user_id
    user {
      name
      email
      id
    }
    workspace_id
    created_at
  }
}
    `;
export const useMembershipRequestsByWorkspaceQuery = <
      TData = MembershipRequestsByWorkspaceQuery,
      TError = Error
    >(
      variables: MembershipRequestsByWorkspaceQueryVariables, 
      options?: UseQueryOptions<MembershipRequestsByWorkspaceQuery, TError, TData>
    ) => 
    useQuery<MembershipRequestsByWorkspaceQuery, TError, TData>(
      ['MembershipRequestsByWorkspace', variables],
      fetcher<MembershipRequestsByWorkspaceQuery, MembershipRequestsByWorkspaceQueryVariables>(MembershipRequestsByWorkspaceDocument, variables),
      options
    );
useMembershipRequestsByWorkspaceQuery.document = MembershipRequestsByWorkspaceDocument;

useMembershipRequestsByWorkspaceQuery.getKey = (variables: MembershipRequestsByWorkspaceQueryVariables) => ['MembershipRequestsByWorkspace', variables];

useMembershipRequestsByWorkspaceQuery.fetcher = (variables: MembershipRequestsByWorkspaceQueryVariables) => fetcher<MembershipRequestsByWorkspaceQuery, MembershipRequestsByWorkspaceQueryVariables>(MembershipRequestsByWorkspaceDocument, variables);
export const MembershipRequestsByUserDocument = `
    query MembershipRequestsByUser($userId: bigint!) {
  membership_requests(where: {user_id: {_eq: $userId}}) {
    user_id
    workspace_id
    created_at
  }
}
    `;
export const useMembershipRequestsByUserQuery = <
      TData = MembershipRequestsByUserQuery,
      TError = Error
    >(
      variables: MembershipRequestsByUserQueryVariables, 
      options?: UseQueryOptions<MembershipRequestsByUserQuery, TError, TData>
    ) => 
    useQuery<MembershipRequestsByUserQuery, TError, TData>(
      ['MembershipRequestsByUser', variables],
      fetcher<MembershipRequestsByUserQuery, MembershipRequestsByUserQueryVariables>(MembershipRequestsByUserDocument, variables),
      options
    );
useMembershipRequestsByUserQuery.document = MembershipRequestsByUserDocument;

useMembershipRequestsByUserQuery.getKey = (variables: MembershipRequestsByUserQueryVariables) => ['MembershipRequestsByUser', variables];

useMembershipRequestsByUserQuery.fetcher = (variables: MembershipRequestsByUserQueryVariables) => fetcher<MembershipRequestsByUserQuery, MembershipRequestsByUserQueryVariables>(MembershipRequestsByUserDocument, variables);
export const RequestMembershipDocument = `
    mutation RequestMembership($workspaceId: String!, $partnerConnectionId: String) {
  requestMembership(
    workspaceId: $workspaceId
    partnerConnectionId: $partnerConnectionId
  )
}
    `;
export const useRequestMembershipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<RequestMembershipMutation, TError, RequestMembershipMutationVariables, TContext>) => 
    useMutation<RequestMembershipMutation, TError, RequestMembershipMutationVariables, TContext>(
      (variables?: RequestMembershipMutationVariables) => fetcher<RequestMembershipMutation, RequestMembershipMutationVariables>(RequestMembershipDocument, variables)(),
      options
    );
export const ApproveMembershipDocument = `
    mutation ApproveMembership($userId: String!) {
  approveMembership(userId: $userId)
}
    `;
export const useApproveMembershipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveMembershipMutation, TError, ApproveMembershipMutationVariables, TContext>) => 
    useMutation<ApproveMembershipMutation, TError, ApproveMembershipMutationVariables, TContext>(
      (variables?: ApproveMembershipMutationVariables) => fetcher<ApproveMembershipMutation, ApproveMembershipMutationVariables>(ApproveMembershipDocument, variables)(),
      options
    );
export const RejectMembershipDocument = `
    mutation RejectMembership($workspaceId: bigint!, $userId: bigint!) {
  delete_membership_requests_by_pk(workspace_id: $workspaceId, user_id: $userId) {
    user_id
    workspace_id
  }
}
    `;
export const useRejectMembershipMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<RejectMembershipMutation, TError, RejectMembershipMutationVariables, TContext>) => 
    useMutation<RejectMembershipMutation, TError, RejectMembershipMutationVariables, TContext>(
      (variables?: RejectMembershipMutationVariables) => fetcher<RejectMembershipMutation, RejectMembershipMutationVariables>(RejectMembershipDocument, variables)(),
      options
    );
export const JoinWorkspaceWithAutoJoinDocument = `
    mutation JoinWorkspaceWithAutoJoin($workspaceId: String!) {
  joinWorkspaceWithAutojoin(workspaceId: $workspaceId)
}
    `;
export const useJoinWorkspaceWithAutoJoinMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<JoinWorkspaceWithAutoJoinMutation, TError, JoinWorkspaceWithAutoJoinMutationVariables, TContext>) => 
    useMutation<JoinWorkspaceWithAutoJoinMutation, TError, JoinWorkspaceWithAutoJoinMutationVariables, TContext>(
      (variables?: JoinWorkspaceWithAutoJoinMutationVariables) => fetcher<JoinWorkspaceWithAutoJoinMutation, JoinWorkspaceWithAutoJoinMutationVariables>(JoinWorkspaceWithAutoJoinDocument, variables)(),
      options
    );
export const UpdateWorkspaceDocument = `
    mutation UpdateWorkspace($id: bigint!, $input: workspaces_set_input!) {
  update_workspaces_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export const useUpdateWorkspaceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkspaceMutation, TError, UpdateWorkspaceMutationVariables, TContext>) => 
    useMutation<UpdateWorkspaceMutation, TError, UpdateWorkspaceMutationVariables, TContext>(
      (variables?: UpdateWorkspaceMutationVariables) => fetcher<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(UpdateWorkspaceDocument, variables)(),
      options
    );
export const UpdateWorkspaceDomainsDocument = `
    mutation UpdateWorkspaceDomains($visibleTo: [String!], $joinableTo: [String!]) {
  updateWorkspaceDomains(visibleTo: $visibleTo, joinableTo: $joinableTo)
}
    `;
export const useUpdateWorkspaceDomainsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkspaceDomainsMutation, TError, UpdateWorkspaceDomainsMutationVariables, TContext>) => 
    useMutation<UpdateWorkspaceDomainsMutation, TError, UpdateWorkspaceDomainsMutationVariables, TContext>(
      (variables?: UpdateWorkspaceDomainsMutationVariables) => fetcher<UpdateWorkspaceDomainsMutation, UpdateWorkspaceDomainsMutationVariables>(UpdateWorkspaceDomainsDocument, variables)(),
      options
    );
export const CreateWorkspaceDocument = `
    mutation CreateWorkspace($name: String!, $slug: String!, $region: String!, $organization: Int) {
  createWorkspace(
    name: $name
    slug: $slug
    region: $region
    organization: $organization
  ) {
    id
  }
}
    `;
export const useCreateWorkspaceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkspaceMutation, TError, CreateWorkspaceMutationVariables, TContext>) => 
    useMutation<CreateWorkspaceMutation, TError, CreateWorkspaceMutationVariables, TContext>(
      (variables?: CreateWorkspaceMutationVariables) => fetcher<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, variables)(),
      options
    );
export const IsWorkspaceSlugAvailableDocument = `
    query IsWorkspaceSlugAvailable($slug: String!) {
  isWorkspaceSlugAvailable(slug: $slug)
}
    `;
export const useIsWorkspaceSlugAvailableQuery = <
      TData = IsWorkspaceSlugAvailableQuery,
      TError = Error
    >(
      variables: IsWorkspaceSlugAvailableQueryVariables, 
      options?: UseQueryOptions<IsWorkspaceSlugAvailableQuery, TError, TData>
    ) => 
    useQuery<IsWorkspaceSlugAvailableQuery, TError, TData>(
      ['IsWorkspaceSlugAvailable', variables],
      fetcher<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>(IsWorkspaceSlugAvailableDocument, variables),
      options
    );
useIsWorkspaceSlugAvailableQuery.document = IsWorkspaceSlugAvailableDocument;

useIsWorkspaceSlugAvailableQuery.getKey = (variables: IsWorkspaceSlugAvailableQueryVariables) => ['IsWorkspaceSlugAvailable', variables];

useIsWorkspaceSlugAvailableQuery.fetcher = (variables: IsWorkspaceSlugAvailableQueryVariables) => fetcher<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>(IsWorkspaceSlugAvailableDocument, variables);
export const SendInviteDocument = `
    mutation SendInvite($recipientEmail: String!, $recipientRoleID: Int!) {
  sendInvite(recipientEmail: $recipientEmail, recipientRoleID: $recipientRoleID)
}
    `;
export const useSendInviteMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<SendInviteMutation, TError, SendInviteMutationVariables, TContext>) => 
    useMutation<SendInviteMutation, TError, SendInviteMutationVariables, TContext>(
      (variables?: SendInviteMutationVariables) => fetcher<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, variables)(),
      options
    );
export const PendingInvitesDocument = `
    query PendingInvites($workspaceId: bigint!) {
  outbound_user_invites(where: {workspace_id: {_eq: $workspaceId}}) {
    ...OutboundUserInvite
  }
}
    ${OutboundUserInviteFragmentDoc}`;
export const usePendingInvitesQuery = <
      TData = PendingInvitesQuery,
      TError = Error
    >(
      variables: PendingInvitesQueryVariables, 
      options?: UseQueryOptions<PendingInvitesQuery, TError, TData>
    ) => 
    useQuery<PendingInvitesQuery, TError, TData>(
      ['PendingInvites', variables],
      fetcher<PendingInvitesQuery, PendingInvitesQueryVariables>(PendingInvitesDocument, variables),
      options
    );
usePendingInvitesQuery.document = PendingInvitesDocument;

usePendingInvitesQuery.getKey = (variables: PendingInvitesQueryVariables) => ['PendingInvites', variables];

usePendingInvitesQuery.fetcher = (variables: PendingInvitesQueryVariables) => fetcher<PendingInvitesQuery, PendingInvitesQueryVariables>(PendingInvitesDocument, variables);
export const CancelInviteDocument = `
    mutation CancelInvite($workspaceId: bigint!, $recipientEmail: String!) {
  delete_outbound_user_invites_by_pk(
    workspace_id: $workspaceId
    recipient_email: $recipientEmail
  ) {
    ...OutboundUserInvite
  }
}
    ${OutboundUserInviteFragmentDoc}`;
export const useCancelInviteMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CancelInviteMutation, TError, CancelInviteMutationVariables, TContext>) => 
    useMutation<CancelInviteMutation, TError, CancelInviteMutationVariables, TContext>(
      (variables?: CancelInviteMutationVariables) => fetcher<CancelInviteMutation, CancelInviteMutationVariables>(CancelInviteDocument, variables)(),
      options
    );
export const DeleteMembersDocument = `
    mutation DeleteMembers($workspaceId: bigint!, $userIds: [bigint!]!) {
  delete_memberships(
    where: {user_id: {_in: $userIds}, workspace_id: {_eq: $workspaceId}}
  ) {
    affected_rows
  }
}
    `;
export const useDeleteMembersMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMembersMutation, TError, DeleteMembersMutationVariables, TContext>) => 
    useMutation<DeleteMembersMutation, TError, DeleteMembersMutationVariables, TContext>(
      (variables?: DeleteMembersMutationVariables) => fetcher<DeleteMembersMutation, DeleteMembersMutationVariables>(DeleteMembersDocument, variables)(),
      options
    );